this["require"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonprequire"];
/******/ 	window["webpackJsonprequire"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);

/******/ 	};

/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}

/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);

/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".chunk." + {"1":"464563a57913d095d065","2":"4b94e0830345b16e9fab","3":"e601482d0907d02b8414"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};

/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/app/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(677);
	module.exports = __webpack_require__(755);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(157);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Intentionally DOES NOT TAKE CONTEXT INTO ACCOUNT
	// because it's broken anyway when you add a level of nesting:

	// https://github.com/facebook/react/issues/2517
	// https://github.com/rackt/react-router/issues/470

	// Context changing over time will SCREW YOUR UPDATES
	// if there is a component with `shouldComponentUpdate`
	// that stands between context owner and consumer,
	// doesn't specify THAT EXACT context it in `contextTypes`
	// and doesn't take it into account in `shouldComponentUpdate`.

	// There is a very easy fix: just DON'T USE THE DAMN CONTEXT.

	module.exports = __webpack_require__(525);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var classSet = __webpack_require__(163);
	var _ = __webpack_require__(4);var PropTypes = React.PropTypes;

	__webpack_require__(977);
	__webpack_require__(978);
	__webpack_require__(979);
	__webpack_require__(980);
	__webpack_require__(981);
	__webpack_require__(982);
	__webpack_require__(983);
	__webpack_require__(984);
	__webpack_require__(987);
	__webpack_require__(478);
	__webpack_require__(985);
	__webpack_require__(986);
	__webpack_require__(988);
	__webpack_require__(989);

	var UTIL_FLAGS = ['fullWidth', 'maxWidth', 'fillHeight', 'hideOnMobile', 'hideOnTablet', 'floatLeft', 'floatRight', 'clearFix', 'absoluteCenter', 'displayBlock', 'placeholder', 'smallCaps', 'scrolling', 'hideScrollbars'];

	var ClassNameMixin = {
	  propTypes: {
	    className: PropTypes.string,
	    context: PropTypes.string,
	    fullWidth: PropTypes.bool,
	    maxWidth: PropTypes.bool,
	    fillHeight: PropTypes.bool,
	    hideOnMobile: PropTypes.bool,
	    hideOnTablet: PropTypes.bool,
	    floatLeft: PropTypes.bool,
	    floatRight: PropTypes.bool,
	    clearFix: PropTypes.bool,
	    displayBlock: PropTypes.bool,
	    absoluteCenter: PropTypes.bool,
	    smallCaps: PropTypes.bool
	  },

	  getClassName: function getClassName() {
	    var _this = this;

	    var componentClassName = this.className || this.constructor.displayName,
	        classNames = [componentClassName],
	        context = this.props.context,
	        modifiers;

	    if (this.getCSSModifiers) {
	      modifiers = this.getCSSModifiers();
	    } else {
	      modifiers = [];
	    }

	    if (_.isObject(modifiers) && !_.isArray(modifiers)) {
	      modifiers = classSet(modifiers).split(' ');
	    }

	    if (context) {
	      modifiers.push('isIn' + context[0].toUpperCase() + context.slice(1));
	    }

	    if (this.props.className) {
	      classNames = classNames.concat(this.props.className.split(' '));
	    }

	    classNames = classNames.concat(UTIL_FLAGS.filter(function (flag) {
	      return _this.props[flag];
	    }).map(function (flag) {
	      return 'utils--' + flag;
	    }));

	    classNames = _.union(classNames, _.compact(modifiers).map(function (m) {
	      return (UTIL_FLAGS.indexOf(m) !== -1 ? 'utils' : componentClassName) + '--' + m;
	    }));

	    return classNames.join(' ');
	  }
	};

	module.exports = ClassNameMixin;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.6.0
	//     http://underscorejs.org
	//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.

	(function() {

	  // Baseline setup
	  // --------------

	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;

	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;

	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};

	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;

	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;

	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };

	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }

	  // Current version.
	  _.VERSION = '1.6.0';

	  // Collection Functions
	  // --------------------

	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return obj;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, length = obj.length; i < length; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
	      }
	    }
	    return obj;
	  };

	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results.push(iterator.call(context, value, index, list));
	    });
	    return results;
	  };

	  var reduceError = 'Reduce of empty array with no initial value';

	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };

	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };

	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (predicate.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };

	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate.call(context, value, index, list)) results.push(value);
	    });
	    return results;
	  };

	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !predicate.call(context, value, index, list);
	    }, context);
	  };

	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate || (predicate = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(predicate, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && predicate.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };

	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, predicate, context) {
	    predicate || (predicate = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(predicate, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = predicate.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };

	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };

	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };

	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };

	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matches(attrs));
	  };

	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matches(attrs));
	  };

	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    var result = -Infinity, lastComputed = -Infinity;
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      if (computed > lastComputed) {
	        result = value;
	        lastComputed = computed;
	      }
	    });
	    return result;
	  };

	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    var result = Infinity, lastComputed = Infinity;
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      if (computed < lastComputed) {
	        result = value;
	        lastComputed = computed;
	      }
	    });
	    return result;
	  };

	  // Shuffle an array, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };

	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (obj.length !== +obj.length) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };

	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return value;
	    return _.property(value);
	  };

	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, iterator, context) {
	    iterator = lookupIterator(iterator);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };

	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iterator, context) {
	      var result = {};
	      iterator = lookupIterator(iterator);
	      each(obj, function(value, index) {
	        var key = iterator.call(context, value, index, obj);
	        behavior(result, key, value);
	      });
	      return result;
	    };
	  };

	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, key, value) {
	    _.has(result, key) ? result[key].push(value) : result[key] = [value];
	  });

	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, key, value) {
	    result[key] = value;
	  });

	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, key) {
	    _.has(result, key) ? result[key]++ : result[key] = 1;
	  });

	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };

	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };

	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };

	  // Array Functions
	  // ---------------

	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) return array[0];
	    if (n < 0) return [];
	    return slice.call(array, 0, n);
	  };

	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };

	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) return array[array.length - 1];
	    return slice.call(array, Math.max(array.length - n, 0));
	  };

	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };

	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };

	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    each(input, function(value) {
	      if (_.isArray(value) || _.isArguments(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };

	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };

	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };

	  // Split an array into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(array, predicate, context) {
	    predicate = lookupIterator(predicate);
	    var pass = [], fail = [];
	    each(array, function(elem) {
	      (predicate.call(context, elem) ? pass : fail).push(elem);
	    });
	    return [pass, fail];
	  };

	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };

	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(_.flatten(arguments, true));
	  };

	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.contains(other, item);
	      });
	    });
	  };

	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };

	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var length = _.max(_.pluck(arguments, 'length').concat(0));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, '' + i);
	    }
	    return results;
	  };

	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };

	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };

	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };

	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;

	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(length);

	    while(idx < length) {
	      range[idx++] = start;
	      start += step;
	    }

	    return range;
	  };

	  // Function (ahem) Functions
	  // ------------------

	  // Reusable constructor function for prototype setting.
	  var ctor = function(){};

	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;
	    args = slice.call(arguments, 2);
	    return bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      ctor.prototype = func.prototype;
	      var self = new ctor;
	      ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (Object(result) === result) return result;
	      return self;
	    };
	  };

	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function() {
	      var position = 0;
	      var args = boundArgs.slice();
	      for (var i = 0, length = args.length; i < length; i++) {
	        if (args[i] === _) args[i] = arguments[position++];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return func.apply(this, args);
	    };
	  };

	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) throw new Error('bindAll must be passed function names');
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };

	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };

	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };

	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };

	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    options || (options = {});
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	        context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };

	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;

	    var later = function() {
	      var last = _.now() - timestamp;
	      if (last < wait) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          context = args = null;
	        }
	      }
	    };

	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	      }
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }

	      return result;
	    };
	  };

	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };

	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };

	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };

	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };

	  // Object Functions
	  // ----------------

	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };

	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = new Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };

	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = new Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };

	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };

	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };

	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };

	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };

	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };

	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] === void 0) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };

	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };

	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };

	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                             _.isFunction(bCtor) && (bCtor instanceof bCtor))
	                        && ('constructor' in a && 'constructor' in b)) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };

	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };

	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };

	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };

	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };

	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };

	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });

	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }

	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }

	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };

	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };

	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };

	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };

	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };

	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };

	  // Utility Functions
	  // -----------------

	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };

	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };

	  _.constant = function(value) {
	    return function () {
	      return value;
	    };
	  };

	  _.property = function(key) {
	    return function(obj) {
	      return obj[key];
	    };
	  };

	  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
	  _.matches = function(attrs) {
	    return function(obj) {
	      if (obj === attrs) return true; //avoid comparing an object to itself.
	      for (var key in attrs) {
	        if (attrs[key] !== obj[key])
	          return false;
	      }
	      return true;
	    }
	  };

	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(Math.max(0, n));
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };

	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };

	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() { return new Date().getTime(); };

	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);

	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };

	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });

	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };

	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };

	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };

	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };

	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;

	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);

	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');

	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });

	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";

	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";

	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }

	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };

	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

	    return template;
	  };

	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };

	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.

	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };

	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);

	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });

	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });

	  _.extend(_.prototype, {

	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },

	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }

	  });

	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsEmailFlags = __webpack_require__(201);

	var _constantsEmailFlags2 = _interopRequireDefault(_constantsEmailFlags);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _reactLibUpdate = __webpack_require__(49);

	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);

	var _utilsStoreUtils = __webpack_require__(30);

	var _utilsStoreUtils2 = _interopRequireDefault(_utilsStoreUtils);

	var _lodashObjectValues = __webpack_require__(498);

	var _lodashObjectValues2 = _interopRequireDefault(_lodashObjectValues);

	'use strict';

	var _users = {};
	var _currentUserId = undefined;
	var _loginEndpoints = undefined;
	var _signupEndpoints = undefined;

	function toggleEmailNotificationFlag(flag, isEnabled) {
	  var isDisabled = !isEnabled;
	  /*jshint bitwise:false*/
	  _users[_currentUserId] = (0, _reactLibUpdate2['default'])(_users[_currentUserId], {
	    emailFlags: {
	      $apply: function $apply(flags) {
	        return isDisabled ? flags | flag : flags & ~flag;
	      }
	    }
	  });
	}

	var UserStore = _utilsStoreUtils2['default'].createStore({
	  contains: function contains(id, fields) {
	    return (0, _utilsStoreUtils.isInBag)(_users, id, fields);
	  },

	  get: function get(id) {
	    return _users[id];
	  },

	  getMe: function getMe() {
	    return UserStore.get(_currentUserId);
	  },

	  isMe: function isMe(userOrId) {
	    var me = this.getMe();
	    if (me) {
	      return me === userOrId || me.id === userOrId;
	    } else {
	      return false;
	    }
	  },

	  isAuthenticated: function isAuthenticated() {
	    return !!this.getMe();
	  },

	  isEmailNotificationEnabled: function isEmailNotificationEnabled(flag) {
	    (0, _reactLibInvariant2['default'])((0, _lodashObjectValues2['default'])(_constantsEmailFlags2['default']).indexOf(flag) > -1, 'Expected one of EmailFlags, got %s', flag);

	    /*jshint bitwise:false*/

	    var _getMe = this.getMe();

	    var emailFlags = _getMe.emailFlags;

	    return !(emailFlags & flag);
	  },

	  getLoginEndpoints: function getLoginEndpoints() {
	    return _loginEndpoints;
	  },

	  getSignupEndpoints: function getSignupEndpoints() {
	    return _signupEndpoints;
	  }
	});

	UserStore.dispatchToken = _AppDispatcher2['default'].register(function (payload) {
	  var action = payload.action;
	  var userId = action.userId;
	  var response = action.response;
	  var entities = response && response.entities;
	  var receivedUsers = entities && entities.users;

	  switch (action.type) {
	    case _constantsActionTypes2['default'].SPECIFY_CURRENT_USER:
	      _currentUserId = action.userId;
	      break;

	    case _constantsActionTypes2['default'].SPECIFY_LOGIN_OPTIONS:
	      _loginEndpoints = action.loginEndpoints;
	      _signupEndpoints = action.signupEndpoints;
	      break;

	    case _constantsActionTypes2['default'].ENABLE_EMAIL_NOTIFICATION:
	      toggleEmailNotificationFlag(action.flag, true);
	      break;

	    case _constantsActionTypes2['default'].DISABLE_EMAIL_NOTIFICATION:
	      toggleEmailNotificationFlag(action.flag, false);
	      break;

	    case _constantsActionTypes2['default'].FOLLOW_USER:
	    case _constantsActionTypes2['default'].UNFOLLOW_USER_ERROR:
	      _users[userId] = (0, _reactLibUpdate2['default'])(_users[userId], {
	        isSubscribed: {
	          $set: true
	        },
	        subscriberCount: {
	          $apply: function $apply(subscriberCount) {
	            return subscriberCount + 1;
	          }
	        }
	      });
	      _users[_currentUserId] = (0, _reactLibUpdate2['default'])(_users[_currentUserId], {
	        subscriptionCount: {
	          $apply: function $apply(subscriptionCount) {
	            return subscriptionCount + 1;
	          }
	        }
	      });
	      UserStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UNFOLLOW_USER:
	    case _constantsActionTypes2['default'].FOLLOW_USER_ERROR:
	      _users[userId] = (0, _reactLibUpdate2['default'])(_users[userId], {
	        isSubscribed: {
	          $set: false
	        },
	        subscriberCount: {
	          $apply: function $apply(subscriberCount) {
	            return subscriberCount - 1;
	          }
	        }
	      });
	      _users[_currentUserId] = (0, _reactLibUpdate2['default'])(_users[_currentUserId], {
	        subscriptionCount: {
	          $apply: function $apply(subscriptionCount) {
	            return subscriptionCount - 1;
	          }
	        }
	      });
	      UserStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].POST_STAMP_SUCCESS:
	    case _constantsActionTypes2['default'].DELETE_DRAFT_SUCCESS:
	      _users[_currentUserId] = (0, _reactLibUpdate2['default'])(_users[_currentUserId], {
	        draftCount: {
	          $apply: function $apply(draftCount) {
	            return draftCount - 1;
	          }
	        }
	      });
	      UserStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SAVE_DRAFT_SUCCESS:
	      if (action.isNewDraft) {
	        _users[_currentUserId] = (0, _reactLibUpdate2['default'])(_users[_currentUserId], {
	          draftCount: {
	            $apply: function $apply(draftCount) {
	              return draftCount + 1;
	            }
	          }
	        });
	        UserStore.emitChange();
	      }
	      break;

	    case _constantsActionTypes2['default'].LOGIN_WITH_SERVICE_ACCOUNT_SUCCESS:
	    case _constantsActionTypes2['default'].SIGNUP_WITH_SERVICE_ACCOUNT_SUCCESS:
	    case _constantsActionTypes2['default'].LOGIN_WITH_EMAIL_SUCCESS:
	      _currentUserId = response.result;
	      UserStore.emitChange();
	      break;
	  }

	  if (receivedUsers) {
	    (0, _utilsStoreUtils.mergeIntoBag)(_users, receivedUsers);
	    UserStore.emitChange();
	  }
	});

	exports['default'] = UserStore;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _constantsPayloadSources = __webpack_require__(399);

	var _constantsPayloadSources2 = _interopRequireDefault(_constantsPayloadSources);

	var _flux = __webpack_require__(479);

	var _reactLibObjectAssign = __webpack_require__(15);

	var _reactLibObjectAssign2 = _interopRequireDefault(_reactLibObjectAssign);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _CrashReporter = __webpack_require__(294);

	var _CrashReporter2 = _interopRequireDefault(_CrashReporter);

	var _utilsCamelizeAction = __webpack_require__(788);

	var _utilsCamelizeAction2 = _interopRequireDefault(_utilsCamelizeAction);

	var _utilsLogAction = __webpack_require__(798);

	var _utilsLogAction2 = _interopRequireDefault(_utilsLogAction);

	'use strict';

	var AppDispatcher = (0, _reactLibObjectAssign2['default'])(new _flux.Dispatcher(), {
	  handleViewAction: _CrashReporter2['default'].wrap(function handleViewAction(action) {
	    (0, _utilsLogAction2['default'])('->', action);

	    if (!action.type) {
	      throw new Error('Empty action.type: you likely mistyped the action.');
	    }

	    this.dispatch({
	      source: _constantsPayloadSources2['default'].VIEW_ACTION,
	      action: action
	    });
	  }),

	  handleServerAction: _CrashReporter2['default'].wrap(function handleServerAction(action) {
	    action = (0, _utilsCamelizeAction2['default'])(action);
	    (0, _utilsLogAction2['default'])('<-', action);

	    if (!action.type) {
	      throw new Error('Empty action.type: you likely mistyped the action.');
	    }

	    this.dispatch({
	      source: _constantsPayloadSources2['default'].SERVER_ACTION,
	      action: action
	    });
	  }),

	  handleServerFormAction: _CrashReporter2['default'].wrap(function handleServerFormAction(action) {
	    this.handleServerAction(action);
	    this.handleServerAction({
	      type: action.err ? _constantsActionTypes2['default'].SUBMIT_FORM_ERROR : _constantsActionTypes2['default'].SUBMIT_FORM_SUCCESS,
	      messages: action.err && action.err.body
	    });
	  }),

	  handlePreloadedAction: _CrashReporter2['default'].wrap(function handlePreloadedAction(action) {
	    action = (0, _utilsCamelizeAction2['default'])(action);
	    (0, _utilsLogAction2['default'])('--', action);

	    this.dispatch({
	      source: _constantsPayloadSources2['default'].PRELOADED_ACTION,
	      action: action
	    });
	  })
	});

	exports['default'] = AppDispatcher;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function createStoreMixin() {
	  for (var _len = arguments.length, stores = Array(_len), _key = 0; _key < _len; _key++) {
	    stores[_key] = arguments[_key];
	  }

	  var StoreMixin = {
	    getInitialState: function getInitialState() {
	      return this.getStateFromStores(this.props);
	    },

	    componentWillMount: function componentWillMount() {
	      this.stores = stores;
	    },

	    componentDidMount: function componentDidMount() {
	      var _this = this;

	      this.stores.forEach(function (store) {
	        return store.addChangeListener(_this.handleStoresChanged);
	      });
	      this.setState(this.getStateFromStores(this.props));
	    },

	    componentWillUnmount: function componentWillUnmount() {
	      var _this2 = this;

	      this.stores.forEach(function (store) {
	        return store.removeChangeListener(_this2.handleStoresChanged);
	      });
	      this.stores = [];
	    },

	    handleStoresChanged: function handleStoresChanged() {
	      if (this.isMounted()) {
	        this.setState(this.getStateFromStores(this.props));
	      }
	    }
	  };

	  if (false) {
	    StoreMixin.componentDidUpdate = function () {
	      var _this3 = this;

	      if (stores !== this.stores && this.isMounted()) {
	        this.stores.forEach(function (store) {
	          return store.removeChangeListener(_this3.handleStoresChanged);
	        });
	        this.stores = stores;
	        this.stores.forEach(function (store) {
	          return store.addChangeListener(_this3.handleStoresChanged);
	        });

	        this.setState(this.getStateFromStores(this.props));
	      }
	    };
	  }

	  return StoreMixin;
	}

	module.exports = createStoreMixin;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  CHANGE_ROUTE: null,

	  PRELOAD_ZINE: null,
	  REQUEST_ZINE: null,
	  REQUEST_ZINE_SUCCESS: null,
	  REQUEST_ZINE_ERROR: null,

	  INVALIDATE_ZINE_LATEST_STAMPS: null,
	  PRELOAD_ZINE_LATEST_STAMPS: null,
	  REQUEST_ZINE_LATEST_STAMPS: null,
	  REQUEST_ZINE_LATEST_STAMPS_ERROR: null,
	  REQUEST_ZINE_LATEST_STAMPS_SUCCESS: null,

	  PRELOAD_ZINE_PENDING_STAMPS: null,
	  REQUEST_ZINE_PENDING_STAMPS: null,
	  REQUEST_ZINE_PENDING_STAMPS_ERROR: null,
	  REQUEST_ZINE_PENDING_STAMPS_SUCCESS: null,

	  FOLLOW_ZINE: null,
	  FOLLOW_ZINE_SUCCESS: null,
	  FOLLOW_ZINE_ERROR: null,

	  UNFOLLOW_ZINE: null,
	  UNFOLLOW_ZINE_SUCCESS: null,
	  UNFOLLOW_ZINE_ERROR: null,

	  FOLLOW_USER: null,
	  FOLLOW_USER_SUCCESS: null,
	  FOLLOW_USER_ERROR: null,

	  UNFOLLOW_USER: null,
	  UNFOLLOW_USER_SUCCESS: null,
	  UNFOLLOW_USER_ERROR: null,

	  DELETE_ZINE: null,
	  DELETE_ZINE_SUCCESS: null,
	  DELETE_ZINE_ERROR: null,

	  ADD_STAMP_TO_ZINE: null,
	  ADD_STAMP_TO_ZINE_SUCCESS: null,
	  ADD_STAMP_TO_ZINE_ERROR: null,

	  SUBMIT_STAMP_TO_ZINE: null,
	  SUBMIT_STAMP_TO_ZINE_SUCCESS: null,
	  SUBMIT_STAMP_TO_ZINE_ERROR: null,

	  REMOVE_STAMP_FROM_ZINE: null,
	  REMOVE_STAMP_FROM_ZINE_SUCCESS: null,
	  REMOVE_STAMP_FROM_ZINE_ERROR: null,

	  APPROVE_STAMP_TO_ZINE: null,
	  APPROVE_STAMP_TO_ZINE_SUCCESS: null,
	  APPROVE_STAMP_TO_ZINE_ERROR: null,

	  REJECT_STAMP_FROM_ZINE: null,
	  REJECT_STAMP_FROM_ZINE_SUCCESS: null,
	  REJECT_STAMP_FROM_ZINE_ERROR: null,

	  CREATE_ZINE_DRAFT: null,
	  UPDATE_ZINE_DRAFT: null,
	  DESTROY_ZINE_DRAFT: null,

	  CREATE_ZINE: null,
	  CREATE_ZINE_SUCCESS: null,
	  CREATE_ZINE_ERROR: null,

	  UPDATE_ZINE: null,
	  UPDATE_ZINE_SUCCESS: null,
	  UPDATE_ZINE_ERROR: null,

	  SPECIFY_CURRENT_USER: null,

	  PRELOAD_USER: null,
	  REQUEST_USER: null,
	  REQUEST_USER_SUCCESS: null,
	  REQUEST_USER_ERROR: null,

	  PRELOAD_STAMP: null,
	  REQUEST_STAMP: null,
	  REQUEST_STAMP_SUCCESS: null,
	  REQUEST_STAMP_ERROR: null,

	  DELETE_STAMP: null,
	  DELETE_STAMP_SUCCESS: null,
	  DELETE_STAMP_ERROR: null,

	  POST_STAMP: null,
	  POST_STAMP_SUCCESS: null,
	  POST_STAMP_ERROR: null,

	  UPDATE_STAMP: null,
	  UPDATE_STAMP_SUCCESS: null,
	  UPDATE_STAMP_ERROR: null,

	  LIKE_STAMP: null,
	  LIKE_STAMP_SUCCESS: null,
	  LIKE_STAMP_ERROR: null,

	  UNLIKE_STAMP: null,
	  UNLIKE_STAMP_SUCCESS: null,
	  UNLIKE_STAMP_ERROR: null,

	  INCREMENT_STAMP_VIEWS: null,

	  PRELOAD_SUGGESTED_ZINES: null,
	  REQUEST_SUGGESTED_ZINES: null,
	  REQUEST_SUGGESTED_ZINES_SUCCESS: null,
	  REQUEST_SUGGESTED_ZINES_ERROR: null,

	  INVALIDATE_FEED_WITH_TRENDING: null,
	  PRELOAD_FEED: null,
	  REQUEST_FEED: null,
	  REQUEST_FEED_SUCCESS: null,
	  REQUEST_FEED_ERROR: null,
	  PRELOAD_TRENDING_STAMPS: null,
	  REQUEST_TRENDING_STAMPS: null,
	  REQUEST_TRENDING_STAMPS_SUCCESS: null,
	  REQUEST_TRENDING_STAMPS_ERROR: null,

	  PRELOAD_ZINE_SECTIONS: null,
	  REQUEST_ZINE_SECTIONS: null,
	  REQUEST_ZINE_SECTIONS_SUCCESS: null,
	  REQUEST_ZINE_SECTIONS_ERROR: null,

	  PRELOAD_ZINES_IN_SECTION: null,
	  REQUEST_ZINES_IN_SECTION: null,
	  REQUEST_ZINES_IN_SECTION_SUCCESS: null,
	  REQUEST_ZINES_IN_SECTION_ERROR: null,

	  INVALIDATE_USER_LATEST_STAMPS: null,
	  PRELOAD_USER_LATEST_STAMPS: null,
	  REQUEST_USER_LATEST_STAMPS: null,
	  REQUEST_USER_LATEST_STAMPS_SUCCESS: null,
	  REQUEST_USER_LATEST_STAMPS_ERROR: null,

	  PRELOAD_USER_LIKED_STAMPS: null,
	  REQUEST_USER_LIKED_STAMPS: null,
	  REQUEST_USER_LIKED_STAMPS_SUCCESS: null,
	  REQUEST_USER_LIKED_STAMPS_ERROR: null,

	  PRELOAD_USER_CURATED_ZINES: null,
	  REQUEST_USER_CURATED_ZINES: null,
	  REQUEST_USER_CURATED_ZINES_ERROR: null,
	  REQUEST_USER_CURATED_ZINES_SUCCESS: null,

	  REQUEST_USER_CURATED_UNLISTED_ZINES: null,
	  REQUEST_USER_CURATED_UNLISTED_ZINES_ERROR: null,
	  REQUEST_USER_CURATED_UNLISTED_ZINES_SUCCESS: null,

	  PRELOAD_USER_CONTRIBUTED_ZINES: null,
	  REQUEST_USER_CONTRIBUTED_ZINES: null,
	  REQUEST_USER_CONTRIBUTED_ZINES_ERROR: null,
	  REQUEST_USER_CONTRIBUTED_ZINES_SUCCESS: null,

	  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES: null,
	  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_ERROR: null,
	  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_SUCCESS: null,

	  REQUEST_INVITATIONS: null,
	  REQUEST_INVITATIONS_ERROR: null,
	  REQUEST_INVITATIONS_SUCCESS: null,

	  REQUEST_ACTIVITIES: null,
	  REQUEST_ACTIVITIES_ERROR: null,
	  REQUEST_ACTIVITIES_SUCCESS: null,
	  INVALIDATE_ACTIVITIES: null,

	  REQUEST_UNSEEN_ACTIVITY_COUNT: null,
	  REQUEST_UNSEEN_ACTIVITY_COUNT_ERROR: null,
	  REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS: null,

	  ACTIVITY_MARK_ALL: null,
	  ACTIVITY_MARK_ALL_ERROR: null,
	  ACTIVITY_MARK_ALL_SUCCESS: null,

	  REQUEST_SOCIAL_FRIENDS: null,
	  REQUEST_SOCIAL_FRIENDS_ERROR: null,
	  REQUEST_SOCIAL_FRIENDS_SUCCESS: null,

	  SEND_INVITE: null,
	  SEND_INVITE_ERROR: null,
	  SEND_INVITE_SUCCESS: null,

	  RESEND_INVITE: null,
	  RESEND_INVITE_ERROR: null,
	  RESEND_INVITE_SUCCESS: null,

	  UPDATE_INVITE: null,
	  UPDATE_INVITE_ERROR: null,
	  UPDATE_INVITE_SUCCESS: null,

	  SEND_FB_INVITE: null,
	  SEND_FB_INVITE_ERROR: null,
	  SEND_FB_INVITE_SUCCESS: null,

	  SET_NAVIGATION_CONTEXT: null,
	  CLEAR_NAVIGATION_CONTEXT: null,

	  SHOW_NOTIFICATION: null,
	  HIDE_NOTIFICATION: null,

	  SHOW_ALERT: null,
	  HIDE_ALERT: null,
	  SHOW_MODAL: null,
	  HIDE_MODAL: null,
	  SHOW_SIDEBAR: null,
	  HIDE_SIDEBAR: null,
	  HIDE_OVERLAY: null,

	  SHOW_CONTEXT_MENU: null,
	  HIDE_CONTEXT_MENU: null,

	  SHOW_PAGE_CONTROLS: null,
	  HIDE_PAGE_CONTROLS: null,

	  TOGGLE_SERVICE_ACCOUNT_HIDDEN: null,
	  TOGGLE_SERVICE_ACCOUNT_HIDDEN_SUCCESS: null,
	  TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR: null,

	  CONNECT_SERVICE_ACCOUNT: null,
	  CONNECT_SERVICE_ACCOUNT_SUCCESS: null,
	  CONNECT_SERVICE_ACCOUNT_ERROR: null,

	  DISCONNECT_SERVICE_ACCOUNT: null,
	  DISCONNECT_SERVICE_ACCOUNT_SUCCESS: null,
	  DISCONNECT_SERVICE_ACCOUNT_ERROR: null,

	  LOGIN_WITH_SERVICE_ACCOUNT: null,
	  LOGIN_WITH_SERVICE_ACCOUNT_SUCCESS: null,
	  LOGIN_WITH_SERVICE_ACCOUNT_ERROR: null,

	  SIGNUP_WITH_SERVICE_ACCOUNT: null,
	  SIGNUP_WITH_SERVICE_ACCOUNT_SUCCESS: null,
	  SIGNUP_WITH_SERVICE_ACCOUNT_ERROR: null,

	  SHARE_STAMP: null,
	  SHARE_ZINE: null,
	  SHARE_USER: null,
	  SHARE_JOINED: null,

	  SHOW_FORM_MESSAGES: null,
	  HIDE_FORM_MESSAGES: null,

	  FORM_VALUE_CHANGED: null,

	  SUBMIT_FORM: null,
	  SUBMIT_FORM_SUCCESS: null,
	  SUBMIT_FORM_ERROR: null,

	  RESET_FORM: null,

	  SAVE_SETTINGS: null,
	  SAVE_SETTINGS_SUCCESS: null,
	  SAVE_SETTINGS_ERROR: null,

	  REQUEST_RESET_PASSWORD: null,
	  REQUEST_RESET_PASSWORD_SUCCESS: null,
	  REQUEST_RESET_PASSWORD_ERROR: null,

	  RESET_PASSWORD: null,
	  RESET_PASSWORD_SUCCESS: null,
	  RESET_PASSWORD_ERROR: null,

	  ENABLE_EMAIL_NOTIFICATION: null,
	  DISABLE_EMAIL_NOTIFICATION: null,
	  SAVE_EMAIL_NOTIFICATION_SETTINGS_SUCCESS: null,
	  SAVE_EMAIL_NOTIFICATION_SETTINGS_ERROR: null,

	  LOGOUT: null,
	  SPECIFY_LOGIN_OPTIONS: null,

	  LOGIN_WITH_EMAIL: null,
	  LOGIN_WITH_EMAIL_SUCCESS: null,
	  LOGIN_WITH_EMAIL_ERROR: null,

	  FEEDBACK: null,
	  FEEDBACK_SUCCESS: null,
	  FEEDBACK_ERROR: null,

	  RESEND_UNCONFIRMED_EMAIL: null,
	  RESEND_UNCONFIRMED_EMAIL_SUCCESS: null,
	  RESEND_UNCONFIRMED_EMAIL_ERROR: null,

	  CANCEL_UNCONFIRMED_EMAIL: null,
	  CANCEL_UNCONFIRMED_EMAIL_SUCCESS: null,
	  CANCEL_UNCONFIRMED_EMAIL_ERROR: null,

	  RESUBSCRIBE_EMAIL: null,
	  RESUBSCRIBE_EMAIL_SUCCESS: null,
	  RESUBSCRIBE_EMAIL_ERROR: null,

	  ENTER_LIGHTBOX: null,
	  LEAVE_LIGHTBOX: null,

	  INVITATION_FORM_PUSH_TAG: null,
	  INVITATION_FORM_CLEAR_SUGGESTED: null,

	  RESIZE_WINDOW: null,

	  REQUEST_MEDIA_DATA: null,
	  REQUEST_MEDIA_DATA_SUCCESS: null,
	  REQUEST_MEDIA_DATA_ERROR: null,

	  LOAD_STAMP_IN_EDITOR: null,
	  LOAD_STAMP_IN_EDITOR_SUCCESS: null,
	  LOAD_STAMP_IN_EDITOR_ERROR: null,

	  LOAD_DRAFT_IN_EDITOR: null,
	  LOAD_DRAFT_IN_EDITOR_SUCCESS: null,
	  LOAD_DRAFT_IN_EDITOR_ERROR: null,

	  LOAD_EMPTY_DRAFT: null,

	  SAVE_DRAFT: null,
	  SAVE_DRAFT_SUCCESS: null,
	  SAVE_DRAFT_ERROR: null,

	  DELETE_DRAFT: null,
	  DELETE_DRAFT_SUCCESS: null,
	  DELETE_DRAFT_ERROR: null,

	  DRAFT_RESET_LAST_ADDED_ITEM: null,
	  DRAFT_SET_STATUS: null,

	  REQUEST_DRAFTS: null,
	  REQUEST_DRAFTS_SUCCESS: null,
	  REQUEST_DRAFTS_ERROR: null,
	  INVALIDATE_DRAFTS: null,

	  CANVAS_ADD_SECTION: null,
	  CANVAS_UPDATE_SECTION: null,
	  CANVAS_MOVE_SECTION: null,
	  CANVAS_DELETE_SECTION: null,

	  GALLERY_ADD_IMAGE: null,
	  GALLERY_DELETE_IMAGE: null,
	  GALLERY_UPDATE_IMAGE: null,
	  GALLERY_MOVE_IMAGE: null,

	  UPLOAD_MEDIA_THUMBNAIL: null,
	  UPLOAD_MEDIA_THUMBNAIL_ERROR: null,
	  UPLOAD_MEDIA_THUMBNAIL_SUCCESS: null,

	  ADD_GRABBAG_ITEM: null,
	  UPDATE_GRABBAG_ITEM: null,
	  DELETE_GRABBAG_ITEM: null,

	  PLAYER_PLAY: null,
	  PLAYER_PAUSE: null,
	  PLAYER_PLAY_NEXT: null,
	  PLAYER_PLAY_PREVIOUS: null,
	  PLAYER_SET_CURRENT_TIME: null,
	  PLAYER_CONSIDER_SET_STICKY_MEDIA: null,
	  PLAYER_CONSIDER_REMOVE_STICKY_MEDIA: null,
	  PLAYER_REGISTER_AUDIO: null,
	  PLAYER_UNREGISTER_AUDIO: null,

	  ACTIVITY_EXPAND: null,
	  ACTIVITY_COLLAPSE: null,

	  REQUEST_STAMP_LIKES: null,
	  REQUEST_STAMP_LIKES_SUCCESS: null,
	  REQUEST_STAMP_LIKES_ERROR: null,

	  INVALIDATE_USER_SUBSCRIBERS: null,
	  REQUEST_USER_SUBSCRIBERS: null,
	  REQUEST_USER_SUBSCRIBERS_SUCCESS: null,
	  REQUEST_USER_SUBSCRIBERS_ERROR: null,

	  INVALIDATE_USER_SUBSCRIPTIONS: null,
	  REQUEST_USER_SUBSCRIPTIONS: null,
	  REQUEST_USER_SUBSCRIPTIONS_SUCCESS: null,
	  REQUEST_USER_SUBSCRIPTIONS_ERROR: null,

	  IMAGE_ADD_TO_GRABBAG: null,
	  IMAGE_ADD_TO_GRABBAG_ERROR: null,
	  IMAGE_ADD_TO_GRABBAG_SUCCESS: null,

	  IMAGE_REMOVE_FROM_GRABBAG: null,
	  IMAGE_REMOVE_FROM_GRABBAG_ERROR: null,
	  IMAGE_REMOVE_FROM_GRABBAG_SUCCESS: null,

	  IMAGE_REMOVE_STAMPLET_ITEM: null,
	  IMAGE_REMOVE_STAMPLET_ITEM_ERROR: null,
	  IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS: null,

	  REQUEST_GRABBAG_IMAGES: null,
	  REQUEST_GRABBAG_IMAGES_SUCCESS: null,
	  REQUEST_GRABBAG_IMAGES_ERROR: null,

	  REQUEST_IMAGE_USED_IN_STAMPS: null,
	  REQUEST_IMAGE_USED_IN_STAMPS_SUCCESS: null,
	  REQUEST_IMAGE_USED_IN_STAMPS_ERROR: null,

	  SEND_DRAFT_FEEDBACK: null,
	  SEND_DRAFT_FEEDBACK_SUCCESS: null,
	  SEND_DRAFT_FEEDBACK_ERROR: null,

	  REQUEST_DRAFT_FEEDBACKS: null,
	  REQUEST_DRAFT_FEEDBACKS_SUCCESS: null,
	  REQUEST_DRAFT_FEEDBACKS_ERROR: null,
	  INVALIDATE_DRAFT_FEEDBACKS: null,

	  REQUEST_STAMP_SEARCH: null,
	  REQUEST_STAMP_SEARCH_SUCCESS: null,
	  REQUEST_STAMP_SEARCH_ERROR: null,

	  REQUEST_USER_SEARCH: null,
	  REQUEST_USER_SEARCH_SUCCESS: null,
	  REQUEST_USER_SEARCH_ERROR: null,

	  REQUEST_ZINE_SEARCH: null,
	  REQUEST_ZINE_SEARCH_SUCCESS: null,
	  REQUEST_ZINE_SEARCH_ERROR: null
	});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _underscore = __webpack_require__(4);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	__webpack_require__(907);

	var ICON_MAP = {
	  'arrowDown': __webpack_require__(591),
	  'arrowLeft': __webpack_require__(592),
	  'arrowRight': __webpack_require__(593),
	  'arrowUp': __webpack_require__(594),
	  'audio': __webpack_require__(595),
	  'backward': __webpack_require__(596),
	  'check': __webpack_require__(597),
	  'chrome': __webpack_require__(598),
	  'clock': __webpack_require__(599),
	  'cross': __webpack_require__(601),
	  'email': __webpack_require__(602),
	  'eye': __webpack_require__(603),
	  'eyeCrossed': __webpack_require__(604),
	  'facebook': __webpack_require__(605),
	  'firefox': __webpack_require__(606),
	  'forward': __webpack_require__(607),
	  'google': __webpack_require__(608),
	  'grid': __webpack_require__(609),
	  'ie': __webpack_require__(610),
	  'image': __webpack_require__(611),
	  'instagram': __webpack_require__(612),
	  'invite': __webpack_require__(613),
	  'like': __webpack_require__(614),
	  'link': __webpack_require__(615),
	  'list': __webpack_require__(616),
	  'logo': __webpack_require__(617),
	  'more': __webpack_require__(618),
	  'notification': __webpack_require__(619),
	  'opera': __webpack_require__(620),
	  'pause': __webpack_require__(621),
	  'pinterest': __webpack_require__(622),
	  'play': __webpack_require__(623),
	  'plus': __webpack_require__(624),
	  'poster': __webpack_require__(625),
	  'safari': __webpack_require__(626),
	  'search': __webpack_require__(627),
	  'set': __webpack_require__(628),
	  'settings': __webpack_require__(629),
	  'share': __webpack_require__(630),
	  'spinner': __webpack_require__(631),
	  'stamp': __webpack_require__(632),
	  'text': __webpack_require__(633),
	  'trending': __webpack_require__(634),
	  'tumblr': __webpack_require__(635),
	  'twitter': __webpack_require__(636),
	  'video': __webpack_require__(637),
	  'zine': __webpack_require__(638),
	  'collect': __webpack_require__(600)
	};

	var ICON_KEYS = (0, _underscore.keys)(ICON_MAP);

	var Icon = _react2['default'].createClass({
	  displayName: 'Icon',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  statics: {
	    ICON_KEYS: ICON_KEYS
	  },

	  propTypes: {
	    name: _react.PropTypes.oneOf(ICON_KEYS).isRequired,
	    size: _react.PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large']).isRequired,
	    mode: _react.PropTypes.oneOf(['fill', 'stroke']),
	    margin: _react.PropTypes.oneOf(['left', 'right']),
	    className: _react.PropTypes.string,
	    style: _react.PropTypes.object,
	    onClick: _react.PropTypes.func
	  },

	  className: 'Icon',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'small',
	      mode: 'fill'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var modifiers = [this.props.size, this.props.name, this.props.mode];

	    if (this.props.margin) {
	      var marginSide = this.props.margin;
	      modifiers.push('margin' + marginSide[0].toUpperCase() + marginSide.slice(1));
	    }

	    return modifiers;
	  },

	  render: function render() {
	    var NamedIcon = ICON_MAP[this.props.name],
	        iconSize = this.props.size;

	    if (iconSize === 'xsmall' || iconSize === 'xxsmall') {
	      iconSize = 'small';
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName(),
	        style: this.props.style,
	        onClick: this.props.onClick },
	      _react2['default'].createElement(NamedIcon, { size: iconSize })
	    );
	  }
	});

	exports['default'] = Icon;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */

	"use strict";

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	module.exports = invariant;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(811), __esModule: true };

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    cloneWithProps = __webpack_require__(376),
	    ClassNameMixin = __webpack_require__(3),
	    mapKeys = __webpack_require__(448),
	    shouldHandleClick = __webpack_require__(453),
	    formatCount = __webpack_require__(219),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(901);

	function validateOnClick(props, propName) {
	  if (props.href || props.disabled) {
	    return;
	  }

	  if (typeof props[propName] !== 'function') {
	    console.warn('With empty href and disabled=false, expected onClick to be specified and to be a function.');
	  }
	}

	var Button = React.createClass({
	  displayName: 'Button',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'Btn',

	  propTypes: {
	    onClick: validateOnClick,
	    href: React.PropTypes.string,
	    color: React.PropTypes.oneOf(['black', 'light', 'dark', 'gray', 'green', 'red', 'yellow', 'facebook', 'twitter', 'google', 'pinterest', 'tubmlr', 'email']).isRequired,
	    size: React.PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge']).isRequired,
	    active: React.PropTypes.bool.isRequired,
	    disabled: React.PropTypes.bool.isRequired,
	    dataSet: React.PropTypes.object.isRequired,
	    'switch': React.PropTypes.bool,
	    like: React.PropTypes.bool,
	    follow: React.PropTypes.bool,
	    round: React.PropTypes.bool,
	    split: React.PropTypes.bool,
	    fill: React.PropTypes.bool,
	    overlay: React.PropTypes.bool,
	    counter: React.PropTypes.number
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      active: false,
	      color: 'dark',
	      dataSet: {},
	      size: 'medium'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.color, this.props.size, this.props['switch'] && 'switch', this.props.like && 'like', this.props.follow && 'follow', this.props.round && 'round', this.props.split && 'split', this.props.fill && 'fill', this.props.overlay && 'overlay'];
	  },

	  getDefaultContent: function getDefaultContent() {
	    if (this.props['switch']) {
	      return React.createElement('i', null);
	    }
	  },

	  render: function render() {
	    var dataSet, dataProps;

	    dataSet = _.extend({}, this.props.dataSet, {
	      disabled: this.props.disabled,
	      active: this.props.active
	    });

	    dataProps = mapKeys(dataSet, function (key) {
	      return 'data-' + key;
	    });

	    return cloneWithProps(React.createElement(
	      'a',
	      _extends({ className: this.getClassName(),
	        href: this.props.href,
	        onClick: this.handleClick
	      }, this.props.params),
	      this.props.children || this.getDefaultContent(),
	      this.renderCounter()
	    ), dataProps);
	  },

	  renderCounter: function renderCounter() {
	    if (typeof this.props.counter === 'number') {
	      return React.createElement(
	        'span',
	        { className: 'Btn-counter' },
	        formatCount(this.props.counter)
	      );
	    }
	  },

	  handleClick: function handleClick(e) {
	    if (!this.props.onClick) {
	      return;
	    }

	    e.stopPropagation();

	    if (!this.props.href || shouldHandleClick(e)) {
	      e.preventDefault();
	      this.props.onClick(e);
	    }
	  }
	});

	module.exports = Button;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = typeof self != 'undefined' ? self : Function('return this')()
	  , core   = {}
	  , defineProperty = Object.defineProperty
	  , hasOwnProperty = {}.hasOwnProperty
	  , ceil  = Math.ceil
	  , floor = Math.floor
	  , max   = Math.max
	  , min   = Math.min;
	// The engine works fine with descriptors? Thank's IE8 for his funny defineProperty.
	var DESC = !!function(){
	  try {
	    return defineProperty({}, 'a', {get: function(){ return 2; }}).a == 2;
	  } catch(e){ /* empty */ }
	}();
	var hide = createDefiner(1);
	// 7.1.4 ToInteger
	function toInteger(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	}
	function desc(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	}
	function simpleSet(object, key, value){
	  object[key] = value;
	  return object;
	}
	function createDefiner(bitmap){
	  return DESC ? function(object, key, value){
	    return $.setDesc(object, key, desc(bitmap, value));
	  } : simpleSet;
	}

	function isObject(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	}
	function isFunction(it){
	  return typeof it == 'function';
	}
	function assertDefined(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	}

	var $ = module.exports = __webpack_require__(838)({
	  g: global,
	  core: core,
	  html: global.document && document.documentElement,
	  // http://jsperf.com/core-js-isobject
	  isObject:   isObject,
	  isFunction: isFunction,
	  that: function(){
	    return this;
	  },
	  // 7.1.4 ToInteger
	  toInteger: toInteger,
	  // 7.1.15 ToLength
	  toLength: function(it){
	    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	  },
	  toIndex: function(index, length){
	    index = toInteger(index);
	    return index < 0 ? max(index + length, 0) : min(index, length);
	  },
	  has: function(it, key){
	    return hasOwnProperty.call(it, key);
	  },
	  create:     Object.create,
	  getProto:   Object.getPrototypeOf,
	  DESC:       DESC,
	  desc:       desc,
	  getDesc:    Object.getOwnPropertyDescriptor,
	  setDesc:    defineProperty,
	  setDescs:   Object.defineProperties,
	  getKeys:    Object.keys,
	  getNames:   Object.getOwnPropertyNames,
	  getSymbols: Object.getOwnPropertySymbols,
	  assertDefined: assertDefined,
	  // Dummy, fix for not array-like ES3 string in es5 module
	  ES5Object: Object,
	  toObject: function(it){
	    return $.ES5Object(assertDefined(it));
	  },
	  hide: hide,
	  def: createDefiner(0),
	  set: global.Symbol ? simpleSet : hide,
	  each: [].forEach
	});
	/* eslint-disable no-undef */
	if(typeof __e != 'undefined')__e = core;
	if(typeof __g != 'undefined')__g = global;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign

	'use strict';

	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }

	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;

	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }

	    var from = Object(nextSource);

	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.

	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }

	  return to;
	}

	module.exports = assign;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    PureRenderMixin = __webpack_require__(2);

	var IconMixin = {
	  mixins: [PureRenderMixin],

	  propTypes: {
	    size: React.PropTypes.oneOf(['small', 'medium', 'large']).isRequired
	  },

	  render: function render() {
	    var svg = this.renderSVG(this.props.size),
	        viewBox;

	    viewBox = {
	      'small': '0 0 18 18',
	      'medium': '0 0 32 32',
	      'large': '0 0 48 48'
	    };

	    return React.createElement('span', { className: 'Icon-container', dangerouslySetInnerHTML: { __html: '<svg viewBox="' + viewBox[this.props.size] + '">' + svg + '</svg>' } });
	  }
	};

	module.exports = IconMixin;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _underscore = __webpack_require__(4);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _reactLibUpdate = __webpack_require__(49);

	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);

	var _UserStore = __webpack_require__(5);

	var _UserStore2 = _interopRequireDefault(_UserStore);

	var _ZineStore = __webpack_require__(22);

	var _ZineStore2 = _interopRequireDefault(_ZineStore);

	var _utilsIsBestOf2014Special = __webpack_require__(83);

	var _utilsIsBestOf2014Special2 = _interopRequireDefault(_utilsIsBestOf2014Special);

	var _utilsStoreUtils = __webpack_require__(30);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	'use strict';

	var _stamps = {};

	var StampStore = (0, _utilsStoreUtils.createStore)({
	  contains: function contains(id, fields) {
	    return (0, _utilsStoreUtils.isInBag)(_stamps, id, fields);
	  },

	  get: function get(id) {
	    return _stamps[id];
	  },

	  getPrimaryZine: function getPrimaryZine(id) {
	    var stamp = this.get(id),
	        specialSlug = stamp.zines.filter(_utilsIsBestOf2014Special2['default'])[0];

	    if (specialSlug) {
	      return _ZineStore2['default'].get(specialSlug);
	    }

	    if (stamp.primaryZine) {
	      return _ZineStore2['default'].get(stamp.primaryZine);
	    }

	    var zines = stamp.zines.map(_ZineStore2['default'].get),
	        max = _underscore2['default'].max(zines, function (z) {
	      return z.subscriberCount;
	    });

	    if (!_underscore2['default'].isEmpty(max)) {
	      return max;
	    }
	  }
	});

	StampStore.dispatchToken = _AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_UserStore2['default'].dispatchToken, _ZineStore2['default'].dispatchToken]);

	  var _payload$action = payload.action;
	  var zineSlug = _payload$action.zineSlug;
	  var response = _payload$action.response;
	  var type = _payload$action.type;
	  var stampSegment = _payload$action.stampSegment;
	  var entities = response && response.entities;
	  var receivedStamps = entities && entities.stamps;
	  var receivedDrafts = entities && entities.drafts;
	  var me = _UserStore2['default'].getMe();
	  var stampId;

	  if (stampSegment) {
	    stampId = (0, _utilsParseStampSegment2['default'])(stampSegment).stampId;
	  }

	  switch (type) {
	    case _constantsActionTypes2['default'].LIKE_STAMP:
	    case _constantsActionTypes2['default'].UNLIKE_STAMP_ERROR:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        isLiked: {
	          $set: true
	        },
	        likeCount: {
	          $apply: function $apply(x) {
	            return x + 1;
	          }
	        },
	        likes: {
	          $apply: function $apply(likes) {
	            return _underscore2['default'].union([me.id], likes);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UNLIKE_STAMP:
	    case _constantsActionTypes2['default'].LIKE_STAMP_ERROR:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        isLiked: {
	          $set: false
	        },
	        likeCount: {
	          $apply: function $apply(x) {
	            return x - 1;
	          }
	        },
	        likes: {
	          $apply: function $apply(likes) {
	            return _underscore2['default'].without(likes, me.id);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SUBMIT_STAMP_TO_ZINE:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        pendingZines: {
	          $apply: function $apply(pendingZines) {
	            return _underscore2['default'].union([zineSlug], pendingZines);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SUBMIT_STAMP_TO_ZINE_ERROR:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        pendingZines: {
	          $apply: function $apply(pendingZines) {
	            return _underscore2['default'].without(pendingZines, zineSlug);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].ADD_STAMP_TO_ZINE:
	    case _constantsActionTypes2['default'].REMOVE_STAMP_FROM_ZINE_ERROR:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        primaryZine: {
	          $apply: function $apply(primaryZine) {
	            return primaryZine === null ? zineSlug : primaryZine;
	          }
	        },
	        zines: {
	          $apply: function $apply(zines) {
	            return _underscore2['default'].union([zineSlug], zines);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].ADD_STAMP_TO_ZINE_ERROR:
	    case _constantsActionTypes2['default'].REMOVE_STAMP_FROM_ZINE:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        primaryZine: {
	          $apply: function $apply(primaryZine) {
	            return primaryZine === zineSlug ? null : primaryZine;
	          }
	        },
	        zines: {
	          $apply: function $apply(zines) {
	            return _underscore2['default'].without(zines, zineSlug);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].APPROVE_STAMP_TO_ZINE_SUCCESS:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        pendingZines: {
	          $apply: function $apply(pendingZines) {
	            return _underscore2['default'].without(pendingZines, zineSlug);
	          }
	        },
	        zines: {
	          $apply: function $apply(zines) {
	            return _underscore2['default'].union([zineSlug], zines);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].REJECT_STAMP_FROM_ZINE_SUCCESS:
	      _stamps[stampId] = (0, _reactLibUpdate2['default'])(_stamps[stampId], {
	        pendingZines: {
	          $apply: function $apply(pendingZines) {
	            return _underscore2['default'].without(pendingZines, zineSlug);
	          }
	        }
	      });
	      StampStore.emitChange();
	      break;
	  }

	  if (receivedStamps) {
	    (0, _utilsStoreUtils.mergeIntoBag)(_stamps, receivedStamps);
	  }

	  if (receivedDrafts) {
	    (0, _utilsStoreUtils.mergeIntoBag)(_stamps, receivedDrafts);
	  }

	  if (receivedDrafts || receivedStamps) {
	    StampStore.emitChange();
	  }
	});

	module.exports = StampStore;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		var list = [];
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
		return list;
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isIE9 = memoize(function() {
			return /msie 9\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isIE9();

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function () {
				styleElement.parentNode.removeChild(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	function replaceText(source, id, replacement) {
		var boundaries = ["/** >>" + id + " **/", "/** " + id + "<< **/"];
		var start = source.lastIndexOf(boundaries[0]);
		var wrappedReplacement = replacement
			? (boundaries[0] + replacement + boundaries[1])
			: "";
		if (source.lastIndexOf(boundaries[0]) >= 0) {
			var end = source.lastIndexOf(boundaries[1]) + boundaries[1].length;
			return source.slice(0, start) + wrappedReplacement + source.slice(end);
		} else {
			return source + wrappedReplacement;
		}
	}

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(styleElement.styleSheet.cssText, index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(sourceMap && typeof btoa === "function") {
			try {
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
				css = "@import url(\"data:stylesheet/css;base64," + btoa(css) + "\")";
			} catch(e) {}
		}

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ },
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _utilsShouldHandleClick = __webpack_require__(453);

	var _utilsShouldHandleClick2 = _interopRequireDefault(_utilsShouldHandleClick);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsRouterStateMixin = __webpack_require__(166);

	var _mixinsRouterStateMixin2 = _interopRequireDefault(_mixinsRouterStateMixin);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	'use strict';

	__webpack_require__(908);

	var Link = _react2['default'].createClass({
	  displayName: 'Link',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsRouterStateMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    onClick: _react2['default'].PropTypes.func,
	    propagateClick: _react2['default'].PropTypes.bool,
	    href: _react2['default'].PropTypes.string,
	    to: _react2['default'].PropTypes.string,
	    params: _react2['default'].PropTypes.object,
	    className: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string,
	    bold: _react2['default'].PropTypes.bool,
	    active: _react2['default'].PropTypes.bool,
	    withEllipsis: _react2['default'].PropTypes.bool,
	    crossed: _react2['default'].PropTypes.bool,
	    color: _react2['default'].PropTypes.oneOf(['gray', 'green', 'light', 'dark', 'red', 'facebook', 'twitter', 'google', 'tumblr', 'pinterest']),
	    opaque: _react2['default'].PropTypes.bool,
	    underline: _react2['default'].PropTypes.oneOf(['never', 'hover', 'always']),
	    target: _react2['default'].PropTypes.oneOf(['_blank']),
	    rel: _react2['default'].PropTypes.string
	  },

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  className: 'Link',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      propagateClick: false,
	      underline: 'hover'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var underline = this.props.underline;

	    return [this.props.color, this.props.opaque && 'opaque', this.props.bold && 'bold', this.props.active && 'active', this.props.withEllipsis && 'withEllipsis', this.props.crossed && 'crossed', 'underline' + underline[0].toUpperCase() + underline.slice(1)];
	  },

	  getHref: function getHref() {
	    if (this.props.href) {
	      return this.props.href;
	    }

	    if (this.props.to) {
	      var _context$router = this.context.router;
	      _context$router = _context$router === undefined ? {} : _context$router;
	      var makeHref = _context$router.makeHref;

	      return makeHref(this.props.to, this.props.params);
	    }
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      'a',
	      { className: this.getClassName(),
	        href: this.getHref(),
	        onClick: this.handleClick,
	        target: this.props.target,
	        rel: this.props.rel,
	        title: this.props.title },
	      this.props.children
	    );
	  },

	  shouldHandleClick: function shouldHandleClick(e) {
	    if (!this.props.onClick && !this.props.to) {
	      return false;
	    }

	    if (this.getHref() && !(0, _utilsShouldHandleClick2['default'])(e)) {
	      return false;
	    }

	    return true;
	  },

	  handleClick: function handleClick(e) {
	    var _props = this.props;
	    var propagateClick = _props.propagateClick;
	    var onClick = _props.onClick;
	    var to = _props.to;
	    var params = _props.params;
	    var _context$router2 = this.context.router;
	    _context$router2 = _context$router2 === undefined ? {} : _context$router2;
	    var isActive = _context$router2.isActive;
	    var transitionTo = _context$router2.transitionTo;

	    if (!propagateClick) {
	      e.stopPropagation();
	    }

	    if (this.shouldHandleClick(e)) {
	      e.preventDefault();

	      if (onClick) {
	        onClick(e);
	        return;
	      }

	      if (to && !isActive(to, params)) {
	        // Check isActive to avoid resetting query
	        transitionTo(to, params);
	        _actionsSidebarActionCreators2['default'].hideSidebar();
	      }
	    }
	  }

	});

	exports['default'] = Link;
	module.exports = exports['default'];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var UserStore = __webpack_require__(5);
	var update = __webpack_require__(49);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var mergeIntoBag = _require.mergeIntoBag;
	var isInBag = _require.isInBag;

	var _zines = {};

	var ZineStore = createStore({
	  contains: function contains(slug, fields) {
	    return isInBag(_zines, slug, fields);
	  },

	  get: function get(slug) {
	    return _zines[slug];
	  }
	});

	ZineStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      slug = action.zineSlug,
	      response = action.response,
	      entities = response && response.entities,
	      receivedZines = entities && entities.zines;

	  switch (action.type) {
	    case ActionTypes.FOLLOW_ZINE:
	    case ActionTypes.UNFOLLOW_ZINE_ERROR:
	      _zines[slug] = update(_zines[slug], {
	        isSubscribed: {
	          $set: true
	        },
	        subscriberCount: {
	          $apply: function $apply(subscriberCount) {
	            return subscriberCount + 1;
	          }
	        }
	      });
	      ZineStore.emitChange();
	      break;

	    case ActionTypes.UNFOLLOW_ZINE:
	    case ActionTypes.FOLLOW_ZINE_ERROR:
	      _zines[slug] = update(_zines[slug], {
	        isSubscribed: {
	          $set: false
	        },
	        subscriberCount: {
	          $apply: function $apply(subscriberCount) {
	            return subscriberCount - 1;
	          }
	        }
	      });
	      ZineStore.emitChange();
	      break;

	    case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS:
	      _zines[slug] = update(_zines[slug], {
	        pendingCount: {
	          $apply: function $apply(pendingCount) {
	            return pendingCount - 1;
	          }
	        }
	      });
	      ZineStore.emitChange();
	      break;
	  }

	  if (receivedZines) {
	    mergeIntoBag(_zines, receivedZines);
	    ZineStore.emitChange();
	  }
	});

	module.exports = ZineStore;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(14)
	  , global     = $.g
	  , core       = $.core
	  , isFunction = $.isFunction
	  , $redef     = __webpack_require__(101);
	function ctx(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	}
	global.core = core;
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	function $def(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] : (global[name] || {}).prototype
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    if(type & $def.B && own)exp = ctx(out, global);
	    else exp = isProto && isFunction(out) ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)$redef(target, key, out);
	    // export
	    if(exports[key] != out)$.hide(exports, key, exp);
	    if(isProto)(exports.prototype || (exports.prototype = {}))[key] = out;
	  }
	}
	module.exports = $def;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  (false ? invariant(
	    obj instanceof Object && !Array.isArray(obj),
	    'keyMirror(...): Argument must be an object.'
	  ) : invariant(obj instanceof Object && !Array.isArray(obj)));
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};

	module.exports = keyMirror;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = typeof self != 'undefined' ? self : Function('return this')()
	  , core   = {}
	  , defineProperty = Object.defineProperty
	  , hasOwnProperty = {}.hasOwnProperty
	  , ceil  = Math.ceil
	  , floor = Math.floor
	  , max   = Math.max
	  , min   = Math.min;
	// The engine works fine with descriptors? Thank's IE8 for his funny defineProperty.
	var DESC = !!function(){
	  try {
	    return defineProperty({}, 'a', {get: function(){ return 2; }}).a == 2;
	  } catch(e){ /* empty */ }
	}();
	var hide = createDefiner(1);
	// 7.1.4 ToInteger
	function toInteger(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	}
	function desc(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	}
	function simpleSet(object, key, value){
	  object[key] = value;
	  return object;
	}
	function createDefiner(bitmap){
	  return DESC ? function(object, key, value){
	    return $.setDesc(object, key, desc(bitmap, value));
	  } : simpleSet;
	}

	function isObject(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	}
	function isFunction(it){
	  return typeof it == 'function';
	}
	function assertDefined(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	}

	var $ = module.exports = __webpack_require__(819)({
	  g: global,
	  core: core,
	  html: global.document && document.documentElement,
	  // http://jsperf.com/core-js-isobject
	  isObject:   isObject,
	  isFunction: isFunction,
	  that: function(){
	    return this;
	  },
	  // 7.1.4 ToInteger
	  toInteger: toInteger,
	  // 7.1.15 ToLength
	  toLength: function(it){
	    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	  },
	  toIndex: function(index, length){
	    index = toInteger(index);
	    return index < 0 ? max(index + length, 0) : min(index, length);
	  },
	  has: function(it, key){
	    return hasOwnProperty.call(it, key);
	  },
	  create:     Object.create,
	  getProto:   Object.getPrototypeOf,
	  DESC:       DESC,
	  desc:       desc,
	  getDesc:    Object.getOwnPropertyDescriptor,
	  setDesc:    defineProperty,
	  setDescs:   Object.defineProperties,
	  getKeys:    Object.keys,
	  getNames:   Object.getOwnPropertyNames,
	  getSymbols: Object.getOwnPropertySymbols,
	  assertDefined: assertDefined,
	  // Dummy, fix for not array-like ES3 string in es5 module
	  ES5Object: Object,
	  toObject: function(it){
	    return $.ES5Object(assertDefined(it));
	  },
	  hide: hide,
	  def: createDefiner(0),
	  set: global.Symbol ? simpleSet : hide,
	  each: [].forEach
	});
	/* eslint-disable no-undef */
	if(typeof __e != 'undefined')__e = core;
	if(typeof __g != 'undefined')__g = global;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */

	"use strict";

	var emptyFunction = __webpack_require__(89);

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction;

	if (false) {
	  warning = function(condition, format ) {for (var args=[],$__0=2,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }

	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }

	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }

	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function()  {return args[argIndex++];});
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}

	module.exports = warning;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _Object$assign = __webpack_require__(180)["default"];

	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	exports.__esModule = true;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var StoreUtils = __webpack_require__(30),
	    PaginatedList = __webpack_require__(784),
	    invariant = __webpack_require__(11),
	    assign = __webpack_require__(15),
	    createStore = StoreUtils.createStore;

	var PROXIED_PAGINATED_LIST_METHODS = ['getIds', 'getPageCount', 'getNextPageUrl', 'isExpectingPage', 'isLastPage', 'isInvalidated', 'invalidate'];

	function createListStoreSpec(_ref) {
	  var getList = _ref.getList;
	  var callListMethod = _ref.callListMethod;

	  var spec = {
	    getList: getList
	  };

	  PROXIED_PAGINATED_LIST_METHODS.forEach(function (method) {
	    spec[method] = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      return callListMethod(method, args);
	    };
	  });

	  return spec;
	}

	/**
	 * Creates a simple paginated store that represents a global list (e.g. feed).
	 */
	function createListStore(spec) {
	  var list = new PaginatedList();

	  function getList() {
	    return list;
	  }

	  function callListMethod(method, args) {
	    return list[method].call(list, args);
	  }

	  return createStore(assign(createListStoreSpec({
	    getList: getList,
	    callListMethod: callListMethod
	  }), spec));
	}

	/**
	 * Creates an indexed paginated store that represents a one-many relationship
	 * (e.g. user's posts). Expects foreign key ID to be passed as first parameter
	 * to store methods.
	 */
	function createIndexedListStore(spec) {
	  var lists = {},
	      prefix = 'ID_';

	  function getList(id) {
	    var key = prefix + id;

	    if (!lists[key]) {
	      lists[key] = new PaginatedList();
	    }

	    return lists[key];
	  }

	  function callListMethod(method, args) {
	    var id = args.shift();
	    if (typeof id === 'undefined') {
	      throw new Error('Indexed pagination store method “' + method + '” expect ID as first parameter.');
	    }

	    var list = getList(id);
	    return list[method].call(list, args);
	  }

	  return createStore(assign(createListStoreSpec({
	    getList: getList,
	    callListMethod: callListMethod
	  }), spec));
	}

	/**
	 * Creates a handler that responds to list store pagination actions.
	 */
	function createListActionHandler(actions) {
	  var requestAction = actions.request;
	  var errorAction = actions.error;
	  var successAction = actions.success;
	  var preloadAction = actions.preload;

	  invariant(requestAction, 'Pass a valid request action.');
	  invariant(errorAction, 'Pass a valid error action.');
	  invariant(successAction, 'Pass a valid success action.');

	  return function (action, list, emitChange) {
	    switch (action.type) {
	      case requestAction:
	        list.expectPage();
	        emitChange();
	        break;

	      case errorAction:
	        list.cancelPage();
	        emitChange();
	        break;

	      case successAction:
	        list.receivePage(action.response.result.objects, action.response.result.meta.next);
	        emitChange();
	        break;

	      case preloadAction:
	        list.expectPage();
	        list.receivePage(action.response.result.objects, action.response.result.meta.next);
	        emitChange();
	        break;
	    }
	  };
	}

	var PaginatedStoreUtils = {
	  createListStore: createListStore,
	  createIndexedListStore: createIndexedListStore,
	  createListActionHandler: createListActionHandler
	};

	module.exports = PaginatedStoreUtils;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _utilsHandleUnauthAction = __webpack_require__(179);

	var _utilsHandleUnauthAction2 = _interopRequireDefault(_utilsHandleUnauthAction);

	var _reactLibObjectAssign = __webpack_require__(15);

	var _reactLibObjectAssign2 = _interopRequireDefault(_reactLibObjectAssign);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	'use strict';

	function needsAuthentication(id) {
	  switch (id) {
	    case _constantsSidebarTypes2['default'].PINTEREST_PICKER:
	    case _constantsSidebarTypes2['default'].STAMP_OTHER_ZINES:
	    case _constantsSidebarTypes2['default'].STAMP_LIKES:
	    case _constantsSidebarTypes2['default'].USER_SUBSCRIPTIONS:
	    case _constantsSidebarTypes2['default'].USER_SUBSCRIBERS:
	    case _constantsSidebarTypes2['default'].IMAGE_USED_IN_STAMPS:
	      return false;
	  }

	  return true;
	}

	var SidebarActionCreators = {
	  showSidebar: function showSidebar(id, options) {
	    (0, _reactLibInvariant2['default'])(_constantsSidebarTypes2['default'].hasOwnProperty(id), 'showSidebar() accepts a constant from SidebarTypes. You passed %s', id);

	    if (needsAuthentication(id) && (0, _utilsHandleUnauthAction2['default'])(_constantsAnalyticsSources2['default'].SHOW_SIDEBAR)) {
	      return;
	    }

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SHOW_SIDEBAR,
	      sidebar: (0, _reactLibObjectAssign2['default'])({ id: id }, options)
	    });
	  },

	  hideSidebar: function hideSidebar() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].HIDE_SIDEBAR
	    });
	  }
	};

	exports['default'] = SidebarActionCreators;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _events = __webpack_require__(473);

	var _reactLibObjectAssign = __webpack_require__(15);

	var _reactLibObjectAssign2 = _interopRequireDefault(_reactLibObjectAssign);

	var _reactLibShallowEqual = __webpack_require__(46);

	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);

	var _lodashObjectForIn = __webpack_require__(1042);

	var _lodashObjectForIn2 = _interopRequireDefault(_lodashObjectForIn);

	var _lodashLangIsFunction = __webpack_require__(497);

	var _lodashLangIsFunction2 = _interopRequireDefault(_lodashLangIsFunction);

	'use strict';

	var CHANGE_EVENT = 'change';

	var StoreUtils = {
	  createStore: function createStore(spec) {
	    var store = (0, _reactLibObjectAssign2['default'])({
	      emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	      },

	      addChangeListener: function addChangeListener(callback) {
	        this.on(CHANGE_EVENT, callback);
	      },

	      removeChangeListener: function removeChangeListener(callback) {
	        this.removeListener(CHANGE_EVENT, callback);
	      }
	    }, spec, _events.EventEmitter.prototype);

	    (0, _lodashObjectForIn2['default'])(store, function (val, key) {
	      if ((0, _lodashLangIsFunction2['default'])(val)) {
	        store[key] = store[key].bind(store);
	      }
	    });

	    store.setMaxListeners(0);
	    return store;
	  },

	  isInBag: function isInBag(bag, id, fields) {
	    var item = bag[id];
	    if (!bag[id]) {
	      return false;
	    }

	    if (fields) {
	      return fields.every(function (field) {
	        return item.hasOwnProperty(field);
	      });
	    } else {
	      return true;
	    }
	  },

	  mergeIntoBag: function mergeIntoBag(bag, entities, transform) {
	    if (!transform) {
	      transform = function (x) {
	        return x;
	      };
	    }

	    for (var key in entities) {
	      if (!entities.hasOwnProperty(key)) {
	        continue;
	      }

	      if (!bag.hasOwnProperty(key)) {
	        bag[key] = transform(entities[key]);
	      } else if (!(0, _reactLibShallowEqual2['default'])(bag[key], entities[key])) {
	        bag[key] = transform((0, _reactLibObjectAssign2['default'])({}, bag[key], entities[key]));
	      }
	    }
	  }
	};

	exports['default'] = StoreUtils;
	module.exports = exports['default'];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */

	'use strict';

	var ReactContext = __webpack_require__(369);
	var ReactCurrentOwner = __webpack_require__(108);

	var assign = __webpack_require__(15);
	var warning = __webpack_require__(26);

	var RESERVED_PROPS = {
	  key: true,
	  ref: true
	};

	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} object
	 * @param {string} key
	 */
	function defineWarningProperty(object, key) {
	  Object.defineProperty(object, key, {

	    configurable: false,
	    enumerable: true,

	    get: function() {
	      if (!this._store) {
	        return null;
	      }
	      return this._store[key];
	    },

	    set: function(value) {
	      (false ? warning(
	        false,
	        'Don\'t set the %s property of the React element. Instead, ' +
	        'specify the correct value when initially creating the element.',
	        key
	      ) : null);
	      this._store[key] = value;
	    }

	  });
	}

	/**
	 * This is updated to true if the membrane is successfully created.
	 */
	var useMutationMembrane = false;

	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} element
	 */
	function defineMutationMembrane(prototype) {
	  try {
	    var pseudoFrozenProperties = {
	      props: true
	    };
	    for (var key in pseudoFrozenProperties) {
	      defineWarningProperty(prototype, key);
	    }
	    useMutationMembrane = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}

	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {string|object} ref
	 * @param {*} key
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function(type, key, ref, owner, context, props) {
	  // Built-in properties that belong on the element
	  this.type = type;
	  this.key = key;
	  this.ref = ref;

	  // Record the component responsible for creating this element.
	  this._owner = owner;

	  // TODO: Deprecate withContext, and then the context becomes accessible
	  // through the owner.
	  this._context = context;

	  if (false) {
	    // The validation flag and props are currently mutative. We put them on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    this._store = {props: props, originalProps: assign({}, props)};

	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    try {
	      Object.defineProperty(this._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true
	      });
	    } catch (x) {
	    }
	    this._store.validated = false;

	    // We're not allowed to set props directly on the object so we early
	    // return and rely on the prototype membrane to forward to the backing
	    // store.
	    if (useMutationMembrane) {
	      Object.freeze(this);
	      return;
	    }
	  }

	  this.props = props;
	};

	// We intentionally don't expose the function on the constructor property.
	// ReactElement should be indistinguishable from a plain object.
	ReactElement.prototype = {
	  _isReactElement: true
	};

	if (false) {
	  defineMutationMembrane(ReactElement.prototype);
	}

	ReactElement.createElement = function(type, config, children) {
	  var propName;

	  // Reserved names are extracted
	  var props = {};

	  var key = null;
	  var ref = null;

	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }

	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }

	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }

	  return new ReactElement(
	    type,
	    key,
	    ref,
	    ReactCurrentOwner.current,
	    ReactContext.current,
	    props
	  );
	};

	ReactElement.createFactory = function(type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. <Foo />.type === Foo.type.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};

	ReactElement.cloneAndReplaceProps = function(oldElement, newProps) {
	  var newElement = new ReactElement(
	    oldElement.type,
	    oldElement.key,
	    oldElement.ref,
	    oldElement._owner,
	    oldElement._context,
	    newProps
	  );

	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	  return newElement;
	};

	ReactElement.cloneElement = function(element, config, children) {
	  var propName;

	  // Original props are copied
	  var props = assign({}, element.props);

	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;

	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;

	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }

	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }

	  return new ReactElement(
	    element.type,
	    key,
	    ref,
	    owner,
	    element._context,
	    props
	  );
	};

	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function(object) {
	  // ReactTestUtils is often used outside of beforeEach where as React is
	  // within it. This leads to two different instances of React on the same
	  // page. To identify a element from a different React instance we use
	  // a flag instead of an instanceof check.
	  var isElement = !!(object && object._isReactElement);
	  // if (isElement && !(object instanceof ReactElement)) {
	  // This is an indicator that you're using multiple versions of React at the
	  // same time. This will screw with ownership and stuff. Fix it, please.
	  // TODO: We could possibly warn here.
	  // }
	  return isElement;
	};

	module.exports = ReactElement;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    AlertTypes = __webpack_require__(48),
	    assign = __webpack_require__(15),
	    invariant = __webpack_require__(11);

	var AlertActionCreators = {
	  showAlert: function showAlert(id, options) {
	    invariant(AlertTypes.hasOwnProperty(id), 'showAlert() accepts a constant from AlertTypes. You passed %s', id);

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_ALERT,
	      alert: assign({ id: id }, options)
	    });
	  },

	  hideAlert: function hideAlert() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_ALERT
	    });
	  }
	};

	module.exports = AlertActionCreators;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _utilsActionUtils = __webpack_require__(133);

	var _utilsActionUtils2 = _interopRequireDefault(_utilsActionUtils);

	var _apiStampAPI = __webpack_require__(392);

	var _apiStampAPI2 = _interopRequireDefault(_apiStampAPI);

	var _apiDraftAPI = __webpack_require__(575);

	var _apiDraftAPI2 = _interopRequireDefault(_apiDraftAPI);

	var _storesStampDraftStore = __webpack_require__(64);

	var _storesStampDraftStore2 = _interopRequireDefault(_storesStampDraftStore);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _storesGrabbagImageStore = __webpack_require__(209);

	var _storesGrabbagImageStore2 = _interopRequireDefault(_storesGrabbagImageStore);

	var _storesDraftFeedbackStore = __webpack_require__(419);

	var _storesDraftFeedbackStore2 = _interopRequireDefault(_storesDraftFeedbackStore);

	var _utilsGetRefinedStamp = __webpack_require__(439);

	var _utilsGetRefinedStamp2 = _interopRequireDefault(_utilsGetRefinedStamp);

	var _router = __webpack_require__(50);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	'use strict';

	var DraftActionCreators = {
	  deleteSection: function deleteSection(sectionId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CANVAS_DELETE_SECTION,
	      sectionId: sectionId
	    });
	  },

	  addGalleryImage: function addGalleryImage(sectionId, image) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].GALLERY_ADD_IMAGE,
	      sectionId: sectionId,
	      image: image
	    });
	  },

	  updateGalleryImage: function updateGalleryImage(sectionId, imageId, data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].GALLERY_UPDATE_IMAGE,
	      sectionId: sectionId,
	      imageId: imageId,
	      data: data
	    });
	  },

	  moveGalleryImage: function moveGalleryImage(sectionId, imageId, afterImageId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].GALLERY_MOVE_IMAGE,
	      sectionId: sectionId,
	      imageId: imageId,
	      afterImageId: afterImageId
	    });
	  },

	  deleteGalleryImage: function deleteGalleryImage(sectionId, imageId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].GALLERY_DELETE_IMAGE,
	      sectionId: sectionId,
	      imageId: imageId
	    });
	  },

	  addSection: function addSection(sectionType, afterSectionId, initialOptions) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CANVAS_ADD_SECTION,
	      sectionType: sectionType,
	      afterSectionId: afterSectionId,
	      initialOptions: initialOptions
	    });
	  },

	  moveSection: function moveSection(sectionId, afterSectionId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CANVAS_MOVE_SECTION,
	      sectionId: sectionId,
	      afterSectionId: afterSectionId
	    });
	  },

	  updateSection: function updateSection(sectionId, data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CANVAS_UPDATE_SECTION,
	      sectionId: sectionId,
	      data: data
	    });
	  },

	  loadStampInEditor: function loadStampInEditor(stampId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LOAD_STAMP_IN_EDITOR,
	      stampId: stampId
	    });

	    _apiDraftAPI2['default'].loadStampInEditor(stampId);
	  },

	  loadDraftInEditor: function loadDraftInEditor(draftUuid) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LOAD_DRAFT_IN_EDITOR,
	      draftUuid: draftUuid
	    });

	    _apiDraftAPI2['default'].loadDraftInEditor(draftUuid);
	  },

	  loadEmptyDraft: function loadEmptyDraft() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LOAD_EMPTY_DRAFT
	    });
	  },

	  resetLastAddedItem: function resetLastAddedItem() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].DRAFT_RESET_LAST_ADDED_ITEM
	    });
	  },

	  cancelEditingStamp: function cancelEditingStamp(disregardChanges) {
	    if (_storesStampDraftStore2['default'].hasUnsavedChanges() && !disregardChanges) {
	      _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].EDITOR_DISREGARD_CHANGES);
	      return;
	    }

	    if (!(0, _router.goBack)()) {
	      var draft = _storesStampDraftStore2['default'].getDraftStamp();
	      (0, _router.transitionTo)('feedStamp', {
	        stampSegment: (0, _utilsGetStampSegment2['default'])(draft)
	      });
	    }
	  },

	  switchToCompose: function switchToCompose() {
	    var draft = _storesStampDraftStore2['default'].getDraftStamp();
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(draft);

	    var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	    var isStamp = _parseStampSegment.isStamp;

	    if (isStamp) {
	      (0, _router.replaceWith)('stampEditCompose', { stampSegment: stampSegment });
	    } else {
	      (0, _router.replaceWith)('draftCompose', { stampSegment: stampSegment });
	    }
	  },

	  switchToPreview: function switchToPreview() {
	    var draft = _storesStampDraftStore2['default'].getDraftStamp();
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(draft);

	    var _parseStampSegment2 = (0, _utilsParseStampSegment2['default'])(stampSegment);

	    var isStamp = _parseStampSegment2.isStamp;

	    if (isStamp) {
	      (0, _router.replaceWith)('stampEditPreview', { stampSegment: stampSegment });
	    } else {
	      (0, _router.replaceWith)('draftPreview', { stampSegment: stampSegment });
	    }
	  },

	  saveDraft: function saveDraft() {
	    var stamp = _storesStampDraftStore2['default'].getDraftStamp();
	    stamp.grabbag = _storesGrabbagImageStore2['default'].getUploadedImageItems();

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SAVE_DRAFT,
	      entity: stamp
	    });

	    _apiDraftAPI2['default'].saveDraft(stamp);
	  },

	  postOrUpdateStamp: function postOrUpdateStamp() {
	    if (!_storesStampDraftStore2['default'].canPublish()) {
	      return;
	    }

	    var messageId = _storesStampDraftStore2['default'].getMissingContentMessage();
	    if (messageId) {
	      _actionsAlertActionCreators2['default'].showAlert(messageId, { hideOnRouteChange: false });
	      DraftActionCreators.switchToCompose();
	      return;
	    }

	    var stamp = (0, _utilsGetRefinedStamp2['default'])(_storesStampDraftStore2['default'].getDraftStamp());
	    if (stamp.id) {
	      _actionsStampActionCreators2['default'].updateStamp(stamp);
	    } else {
	      _utilsActionUtils2['default'].postEntity({
	        entity: stamp,
	        action: _constantsActionTypes2['default'].POST_STAMP,
	        callAPI: _apiStampAPI2['default'].postStamp
	      });
	    }
	  },

	  deleteDraft: function deleteDraft(draftUuid) {
	    _utilsActionUtils2['default'].deleteEntity({
	      idAttribute: 'draftUuid',
	      draftUuid: draftUuid,
	      store: _storesStampDraftStore2['default'],
	      action: _constantsActionTypes2['default'].DELETE_STAMP,
	      callAPI: _apiDraftAPI2['default'].deleteDraft
	    });
	  },

	  sendFeedback: function sendFeedback(draftUuid, message) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SEND_DRAFT_FEEDBACK,
	      draftUuid: draftUuid
	    });

	    _apiDraftAPI2['default'].sendFeedback(draftUuid, message);
	  },

	  requestDraftPage: function requestDraftPage(isInitialRequest) {
	    if (isInitialRequest) {
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_DRAFTS
	      });
	    }

	    _utilsActionUtils2['default'].requestPage({
	      isInitialRequest: isInitialRequest,
	      store: _storesStampDraftStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_DRAFTS,
	      callAPI: _apiDraftAPI2['default'].requestDraftsPage
	    });
	  },

	  requestDraftFeedbackPage: function requestDraftFeedbackPage(draftUuid, isInitialRequest) {
	    if (isInitialRequest) {
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_DRAFT_FEEDBACKS,
	        draftUuid: draftUuid
	      });
	    }

	    _utilsActionUtils2['default'].requestIndexedPage({
	      draftUuid: draftUuid,
	      idAttribute: 'draftUuid',
	      isInitialRequest: isInitialRequest,
	      store: _storesDraftFeedbackStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS,
	      callAPI: _apiDraftAPI2['default'].requestDraftFeedbacksPage
	    });
	  },

	  setStatus: function setStatus(status) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].DRAFT_SET_STATUS,
	      status: status
	    });
	  }
	};

	module.exports = DraftActionCreators;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  NAV_BAR: 'NavBar',
	  INFO_PANEL: 'InfoPanel',
	  LIGHTBOX: 'Lightbox',
	  STAMP_PAGE_CONTROLS: 'StampPageControls',
	  ZINE_PAGE_CONTROLS: 'ZinePageControls',
	  USER_PAGE_CONTROLS: 'UserPageControls',
	  IMAGE_CONTROLS: 'ImageControls',
	  ALERT: 'Alert',
	  NOTIFICATION: 'Notification',
	  PINTEREST_PICKER: 'PinterestPicker',
	  ABOUT_FORM: 'AboutForm',
	  ABOUT_PAGE_WELCOME: 'AboutPage.welcome',
	  ABOUT_PAGE_SIGNUP: 'AboutPage.signUp',
	  CALL_TO_JOIN: 'CallToJoin',
	  SHOW_SIDEBAR: 'showSidebar',
	  LIKE_STAMP: 'likeStamp',
	  FOLLOW_ZINE: 'followZine',
	  FOLLOW_USER: 'followUser',
	  BEST_OF_2014_SPECIAL: 'bestOf2014Special'
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  FACEBOOK: null,
	  TWITTER: null,
	  GOOGLE: null,
	  TUMBLR: null,
	  INSTAGRAM: null,
	  PINTEREST: null,
	  EMAIL: null
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// based on http://stackoverflow.com/questions/5916900/detect-version-of-browser

	var _browserName = '',
	    _version = 0;

	var _isMobile = typeof navigator !== 'undefined' ? /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()) : false;

	function getBrowserNameAndVersion() {

	  if (typeof navigator === 'undefined') {
	    console.log('navigator is not available in node');
	    return {
	      name: 'Chrome',
	      version: 0
	    };
	  }

	  var ua = navigator.userAgent,
	      versionMatch,
	      match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

	  if (/trident|msie/i.test(match[1])) {
	    versionMatch = /\brv[ :]+(\d+)/g.exec(ua) || /\bMSIE[ :]+(\d+)/g.exec(ua) || [];
	    return {
	      name: 'IE',
	      version: parseInt(versionMatch[1] || 0, 10)
	    };
	  }

	  if (match[1] === 'Chrome') {
	    versionMatch = ua.match(/\bOPR\/(\d+)/);
	    if (versionMatch !== null) {
	      return {
	        name: 'Opera',
	        version: parseInt(versionMatch[1] || 0, 10)
	      };
	    }
	  }

	  match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];

	  if ((versionMatch = ua.match(/version\/(\d+)/i)) !== null) {
	    match.splice(1, 1, versionMatch[1]);
	  }

	  return {
	    name: match[0],
	    version: parseInt(match[1] || 0, 10)
	  };
	}

	try {
	  var data = getBrowserNameAndVersion();
	  _browserName = data.name;
	  _version = data.version;
	} catch (err) {}

	module.exports = {
	  getBrowserName: function getBrowserName() {
	    return _browserName;
	  },
	  getVersion: function getVersion() {
	    return _version;
	  },
	  isIE: function isIE() {
	    return _browserName === 'IE';
	  },
	  isIE10: function isIE10() {
	    return _browserName === 'IE' && _version === 10;
	  },
	  isChrome: function isChrome() {
	    return _browserName === 'Chrome';
	  },
	  isFirefox: function isFirefox() {
	    return _browserName === 'Firefox';
	  },
	  isOpera: function isOpera() {
	    return _browserName === 'Opera';
	  },
	  isMobile: function isMobile() {
	    return _isMobile;
	  }
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);
	var config = __webpack_require__(66);
	var parseHostname = __webpack_require__(452);
	var _require = __webpack_require__(66);

	var soundCloudThumbnailProxyUrl = _require.soundCloudThumbnailProxyUrl;

	var resizerBaseUrl = config.resizerBaseUrl;
	if (!resizerBaseUrl) {
	  throw new Error('You forgot to pass resizerBaseUrl as config parameter.');
	}

	var STORAGE_HOSTS = ['stampsy-eu-1.s3.amazonaws.com'];

	function formatUrl(format, params, query) {
	  var url = format,
	      queryStr;

	  _.each(params, function (val, key) {
	    url = url.replace(RegExp('{' + key + '}', 'g'), val);
	  });

	  queryStr = _.chain(query).map(function (val, key) {
	    return !_.isUndefined(val) && key + '=' + val;
	  }).compact().value().join('&');

	  return queryStr ? url + '?' + queryStr : url;
	}

	function getThumbnailUrl(image, options) {
	  var url = image && image.url,
	      resizeHash = image && image.resizeHash;

	  if (!url) {
	    if (!options.allowEmpty) {
	      throw new Error('Bad original url');
	    }

	    return;
	  }

	  var isExternal = !_.contains(STORAGE_HOSTS, parseHostname(url));
	  if (options.allowExternal && isExternal) {
	    return url;
	  }

	  if (!options.width && !options.height) {
	    throw new Error('Either width or height is required');
	  }

	  var query = _.pick(options, ['quality', 'blur']);

	  if (resizeHash) {
	    query.resizeHash = resizeHash;

	    // SoundCloud URLs aren't always valid, -original may be missing.
	    // We need to run them through a proxy.

	    if (url.indexOf('sndcdn.com') !== -1) {
	      url = soundCloudThumbnailProxyUrl + url;
	    }
	  }

	  if (url.indexOf('http://') === 0) {
	    url = url.substring('http://'.length);
	  }

	  if (url.indexOf('https://') === 0) {
	    url = url.substring('https://'.length);
	  }

	  var params = {
	    baseUrl: resizerBaseUrl,
	    mode: options.mode || 'preview',
	    width: options.width || '',
	    height: options.height || '',
	    url: url
	  };

	  return formatUrl('{baseUrl}/{mode}/{width}x{height}/{url}', params, query);
	}

	module.exports = getThumbnailUrl;

/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibKeyMirror = __webpack_require__(24);

	var _reactLibKeyMirror2 = _interopRequireDefault(_reactLibKeyMirror);

	'use strict';

	exports['default'] = (0, _reactLibKeyMirror2['default'])({
	  STAMP_OTHER_ZINES: null,
	  ZINE_PENDING_STAMPS: null,
	  ADD_STAMP_TO_ZINES: null,
	  ADD_STAMPS_TO_ZINE: null,
	  PINTEREST_PICKER: null,
	  APPROVE_PENDING_STAMP: null,
	  REJECT_PENDING_STAMP: null,
	  ACTIVITIES: null,
	  STAMP_LIKES: null,
	  USER_SUBSCRIBERS: null,
	  USER_SUBSCRIPTIONS: null,
	  IMAGE_USED_IN_STAMPS: null,
	  DRAFTS: null,
	  LEAVE_DRAFT_FEEDBACK: null,
	  DRAFT_FEEDBACKS: null,
	  POST_STAMP: null
	});
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  GALLERY: 'gallery',
	  POSTER: 'poster',
	  COVER: 'cover',
	  TEXT: 'text',
	  MEDIA: 'media',
	  INFO: 'info',
	  // Experimental:
	  BUY_IN_ITUNES: 'buy_in_itunes'
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _apiZineAPI = __webpack_require__(578);

	var _apiZineAPI2 = _interopRequireDefault(_apiZineAPI);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesZineSectionStore = __webpack_require__(434);

	var _storesZineSectionStore2 = _interopRequireDefault(_storesZineSectionStore);

	var _storesZineSectionsStore = __webpack_require__(293);

	var _storesZineSectionsStore2 = _interopRequireDefault(_storesZineSectionsStore);

	var _storesSuggestedZineStore = __webpack_require__(427);

	var _storesSuggestedZineStore2 = _interopRequireDefault(_storesSuggestedZineStore);

	var _storesUserCuratedZineStore = __webpack_require__(291);

	var _storesUserCuratedZineStore2 = _interopRequireDefault(_storesUserCuratedZineStore);

	var _storesUserCuratedUnlistedZineStore = __webpack_require__(431);

	var _storesUserCuratedUnlistedZineStore2 = _interopRequireDefault(_storesUserCuratedUnlistedZineStore);

	var _storesUserContributedZineStore = __webpack_require__(430);

	var _storesUserContributedZineStore2 = _interopRequireDefault(_storesUserContributedZineStore);

	var _storesUserContributedUnlistedZineStore = __webpack_require__(429);

	var _storesUserContributedUnlistedZineStore2 = _interopRequireDefault(_storesUserContributedUnlistedZineStore);

	var _storesSearchZineStore = __webpack_require__(212);

	var _storesSearchZineStore2 = _interopRequireDefault(_storesSearchZineStore);

	var _utilsActionUtils = __webpack_require__(133);

	var _utilsActionUtils2 = _interopRequireDefault(_utilsActionUtils);

	var _utilsHandleUnauthAction = __webpack_require__(179);

	var _utilsHandleUnauthAction2 = _interopRequireDefault(_utilsHandleUnauthAction);

	'use strict';

	var ZineActionCreators = {
	  requestZine: function requestZine(zineSlug, fields) {
	    _utilsActionUtils2['default'].requestEntity({
	      zineSlug: zineSlug,
	      idAttribute: 'zineSlug',
	      store: _storesZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINE,
	      fields: fields,
	      callAPI: _apiZineAPI2['default'].requestZine
	    });
	  },

	  followZine: function followZine(zineSlug) {
	    if ((0, _utilsHandleUnauthAction2['default'])(_constantsAnalyticsSources2['default'].FOLLOW_ZINE)) {
	      return;
	    }

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].FOLLOW_ZINE,
	      zineSlug: zineSlug
	    });

	    _apiZineAPI2['default'].followZine(zineSlug);
	  },

	  unfollowZine: function unfollowZine(zineSlug) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].UNFOLLOW_ZINE,
	      zineSlug: zineSlug
	    });

	    _apiZineAPI2['default'].unfollowZine(zineSlug);
	  },

	  submitStampToZine: function submitStampToZine(zineSlug, stampSegment) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SUBMIT_STAMP_TO_ZINE,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment
	    });

	    _apiZineAPI2['default'].submitStampToZine(zineSlug, stampSegment);
	  },

	  addStampToZine: function addStampToZine(zineSlug, stampSegment) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].ADD_STAMP_TO_ZINE,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment
	    });

	    _apiZineAPI2['default'].addStampToZine(zineSlug, stampSegment);
	  },

	  removeStampFromZine: function removeStampFromZine(zineSlug, stampSegment) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].REMOVE_STAMP_FROM_ZINE,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment
	    });

	    _apiZineAPI2['default'].removeStampFromZine(zineSlug, stampSegment);
	  },

	  approveStampToZine: function approveStampToZine(zineSlug, stampSegment, message) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].APPROVE_STAMP_TO_ZINE,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment,
	      message: message
	    });

	    _apiZineAPI2['default'].approveStampToZine(zineSlug, stampSegment, message);
	  },

	  rejectStampFromZine: function rejectStampFromZine(zineSlug, stampSegment, message) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].REJECT_STAMP_FROM_ZINE,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment,
	      message: message
	    });

	    _apiZineAPI2['default'].rejectStampFromZine(zineSlug, stampSegment, message);
	  },

	  createNewZineDraft: function createNewZineDraft(draft) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CREATE_ZINE_DRAFT,
	      isNew: true,
	      zine: draft
	    });
	  },

	  createZineDraftFromZine: function createZineDraftFromZine(zine) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CREATE_ZINE_DRAFT,
	      zine: zine
	    });
	  },

	  updateZineDraft: function updateZineDraft(key, value) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].UPDATE_ZINE_DRAFT,
	      key: key,
	      value: value
	    });
	  },

	  destroyZineDraft: function destroyZineDraft() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].DESTROY_ZINE_DRAFT
	    });
	  },

	  createZine: function createZine(zine) {
	    _utilsActionUtils2['default'].postEntity({
	      entity: zine,
	      action: _constantsActionTypes2['default'].CREATE_ZINE,
	      callAPI: _apiZineAPI2['default'].createZine
	    });
	  },

	  updateZine: function updateZine(zine) {
	    _utilsActionUtils2['default'].updateEntity({
	      entity: zine,
	      action: _constantsActionTypes2['default'].UPDATE_ZINE,
	      callAPI: _apiZineAPI2['default'].updateZine
	    });
	  },

	  deleteZine: function deleteZine(zineSlug) {
	    _utilsActionUtils2['default'].deleteEntity({
	      idAttribute: 'zineSlug',
	      zineSlug: zineSlug,
	      action: _constantsActionTypes2['default'].DELETE_ZINE,
	      callAPI: _apiZineAPI2['default'].deleteZine
	    });
	  },

	  requestZinesInSection: function requestZinesInSection(sectionId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      idAttribute: 'sectionId',
	      sectionId: sectionId,
	      isInitialRequest: isInitialRequest,
	      store: _storesZineSectionStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINES_IN_SECTION,
	      callAPI: _apiZineAPI2['default'].requestZinesInSection
	    });
	  },

	  requestZineSections: function requestZineSections(isInitialRequest) {
	    _utilsActionUtils2['default'].requestPage({
	      isInitialRequest: isInitialRequest,
	      store: _storesZineSectionsStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINE_SECTIONS,
	      callAPI: _apiZineAPI2['default'].requestZineSections
	    });
	  },

	  requestSuggestedPage: function requestSuggestedPage(isInitialRequest) {
	    _utilsActionUtils2['default'].requestPage({
	      isInitialRequest: isInitialRequest,
	      store: _storesSuggestedZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_SUGGESTED_ZINES,
	      callAPI: _apiZineAPI2['default'].requestSuggestedPage
	    });
	  },

	  requestUserCuratedPage: function requestUserCuratedPage(userId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserCuratedZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_CURATED_ZINES,
	      callAPI: _apiZineAPI2['default'].requestUserCuratedPage
	    });
	  },

	  requestUserCuratedUnlistedPage: function requestUserCuratedUnlistedPage(userId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserCuratedUnlistedZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_CURATED_UNLISTED_ZINES,
	      callAPI: _apiZineAPI2['default'].requestUserCuratedUnlistedPage
	    });
	  },

	  requestUserContributedPage: function requestUserContributedPage(userId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserContributedZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_CONTRIBUTED_ZINES,
	      callAPI: _apiZineAPI2['default'].requestUserContributedPage
	    });
	  },

	  requestUserContributedUnlistedPage: function requestUserContributedUnlistedPage(userId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserContributedUnlistedZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES,
	      callAPI: _apiZineAPI2['default'].requestUserContributedUnlistedPage
	    });
	  },

	  requestSearchPage: function requestSearchPage(terms, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      terms: terms,
	      idAttribute: 'terms',
	      isInitialRequest: isInitialRequest,
	      store: _storesSearchZineStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINE_SEARCH,
	      callAPI: _apiZineAPI2['default'].requestSearchPage
	    });
	  }
	};

	module.exports = ZineActionCreators;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */

	/*jslint evil: true */

	"use strict";

	var canUseDOM = !!(
	  (typeof window !== 'undefined' &&
	  window.document && window.document.createElement)
	);

	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {

	  canUseDOM: canUseDOM,

	  canUseWorkers: typeof Worker !== 'undefined',

	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),

	  canUseViewport: canUseDOM && !!window.screen,

	  isInWorker: !canUseDOM // For now, this is true - might change in the future.

	};

	module.exports = ExecutionEnvironment;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Icon = __webpack_require__(10);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(910);

	var Loader = React.createClass({
	  displayName: 'Loader',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    absoluteCenter: PropTypes.bool,
	    withPadding: PropTypes.bool
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.absoluteCenter && 'absoluteCenter', this.props.withPadding && 'withPadding'];
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      withPadding: true
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(Icon, { name: 'spinner',
	        size: 'medium',
	        key: 'spinner' })
	    );
	  }
	});

	module.exports = Loader;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(931);

	var BtnGroup = React.createClass({
	  displayName: 'BtnGroup',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    vertical: PropTypes.bool,
	    split: PropTypes.bool
	  },

	  className: 'BtnGroup',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      vertical: false,
	      split: false
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.vertical && 'vertical', this.props.split && 'split'];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.props.children
	    );
	  }
	});

	module.exports = BtnGroup;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var Collection = __webpack_require__(417);
	var Icon = __webpack_require__(10);
	var Loader = __webpack_require__(43);
	var Link = __webpack_require__(21);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);
	var PropTypes = React.PropTypes;
	var _require = __webpack_require__(4);

	var pick = _require.pick;

	__webpack_require__(962);

	var Group = React.createClass({
	  displayName: 'Group',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    color: PropTypes.oneOf(['dark', 'light']).isRequired,
	    title: PropTypes.string,
	    isExpectingPage: PropTypes.bool.isRequired,
	    isLastPage: PropTypes.bool.isRequired,
	    isInvalidated: PropTypes.bool,
	    loadNextPage: PropTypes.func,
	    type: PropTypes.any.isRequired,
	    mode: PropTypes.any,
	    columns: PropTypes.number,
	    keys: PropTypes.array,
	    items: PropTypes.array.isRequired,
	    itemProps: PropTypes.object,
	    getItemProps: PropTypes.func,
	    defaultPage: PropTypes.number,
	    onPageChange: PropTypes.func,
	    perFirstPage: PropTypes.number,
	    perPage: PropTypes.number,
	    showInvalidationFeedback: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      isExpectingPage: false,
	      showInvalidationFeedback: false,
	      isLastPage: true,
	      defaultPage: 0,
	      perPage: 24,
	      perFirstPage: 24,
	      color: 'dark'
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      page: this.props.defaultPage
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.color];
	  },

	  hasNextPage: function hasNextPage() {
	    return this.props.loadNextPage && !this.props.isLastPage;
	  },

	  getMaxItemCount: function getMaxItemCount() {
	    var _props = this.props;
	    var perPage = _props.perPage;
	    var perFirstPage = _props.perFirstPage;var page = this.state.page;

	    if (perFirstPage < perPage) {
	      return page === 0 ? perFirstPage : page * perPage;
	    } else {
	      return (page + 1) * perPage;
	    }
	  },

	  loadItemsToSatisfyPage: function loadItemsToSatisfyPage() {
	    if (this.props.isExpectingPage || !this.hasNextPage()) {
	      return;
	    }

	    if (this.getMaxItemCount() > this.props.items.length) {
	      this.props.loadNextPage();
	      return true;
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.state.page !== prevState.page || this.props.items.length > prevProps.items.length) {

	      this.loadItemsToSatisfyPage();
	    }
	  },

	  render: function render() {
	    var _props2 = this.props;
	    var title = _props2.title;
	    var isExpectingPage = _props2.isExpectingPage;
	    var isInvalidated = _props2.isInvalidated;
	    var showInvalidationFeedback = _props2.showInvalidationFeedback;
	    var allKeys = _props2.keys;
	    var allItems = _props2.items;
	    var color = _props2.color;
	    var maxCount = this.getMaxItemCount();
	    var visibleItems = allItems.slice(0, maxCount);
	    var visibleKeys = allKeys ? allKeys.slice(0, maxCount) : null;
	    var isEmpty = visibleItems.length === 0;
	    var mayHaveMore = this.hasNextPage() || maxCount < allItems.length;
	    var isExpectingFirstPage = isExpectingPage && isEmpty;
	    var isExpectingNextPage = isExpectingPage && !isEmpty && !isInvalidated;
	    var isExpectingInvalidatedFirstPage = isInvalidated && !isExpectingFirstPage && !isExpectingNextPage;
	    var showLoadMore = !isEmpty && mayHaveMore;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      title && React.createElement(
	        'div',
	        { className: 'Group-title' },
	        title
	      ),
	      showInvalidationFeedback && isExpectingInvalidatedFirstPage && React.createElement(
	        'div',
	        { className: 'Group-header' },
	        React.createElement(Loader, { color: color })
	      ),
	      React.createElement(
	        'div',
	        { className: 'Group-body' },
	        isExpectingFirstPage && React.createElement(Loader, { color: color,
	          absoluteCenter: true }),
	        !isExpectingFirstPage && React.createElement(
	          Collection,
	          _extends({ items: visibleItems,
	            keys: visibleKeys
	          }, pick(this.props, 'type', 'mode', 'columns', 'context', 'itemProps', 'getItemProps')),
	          this.props.children
	        )
	      ),
	      showLoadMore && React.createElement(
	        'div',
	        { className: 'Group-footer' },
	        isExpectingNextPage ? React.createElement(Loader, { color: color }) : React.createElement(
	          Link,
	          { className: 'Group-loadMore',
	            underline: 'never',
	            onClick: this.handleLoadMoreClick,
	            smallCaps: true },
	          'Show More',
	          React.createElement(Icon, { name: 'arrowDown',
	            mode: 'stroke',
	            size: 'small' })
	        )
	      )
	    );
	  },

	  handleLoadMoreClick: function handleLoadMoreClick() {
	    if (this.props.isExpectingPage) {
	      return;
	    }

	    if (this.loadItemsToSatisfyPage()) {
	      return;
	    }

	    this.setState({
	      page: this.state.page + 1
	    }, this.pageDidChange);
	  },

	  pageDidChange: function pageDidChange() {
	    if (this.props.onPageChange) {
	      this.props.onPageChange(this.state.page);
	    }
	  }
	});

	module.exports = Group;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */

	'use strict';

	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = shallowEqual;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _apiUserAPI = __webpack_require__(577);

	var _apiUserAPI2 = _interopRequireDefault(_apiUserAPI);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _utilsActionUtils = __webpack_require__(133);

	var _utilsActionUtils2 = _interopRequireDefault(_utilsActionUtils);

	var _utilsPopupManager = __webpack_require__(217);

	var _utilsPopupManager2 = _interopRequireDefault(_utilsPopupManager);

	var _constantsEmailFlags = __webpack_require__(201);

	var _constantsEmailFlags2 = _interopRequireDefault(_constantsEmailFlags);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _underscore = __webpack_require__(4);

	var _storesUserSubscribersStore = __webpack_require__(432);

	var _storesUserSubscribersStore2 = _interopRequireDefault(_storesUserSubscribersStore);

	var _storesUserSubscriptionsStore = __webpack_require__(433);

	var _storesUserSubscriptionsStore2 = _interopRequireDefault(_storesUserSubscriptionsStore);

	var _storesSearchUserStore = __webpack_require__(211);

	var _storesSearchUserStore2 = _interopRequireDefault(_storesSearchUserStore);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _utilsHandleUnauthAction = __webpack_require__(179);

	var _utilsHandleUnauthAction2 = _interopRequireDefault(_utilsHandleUnauthAction);

	var _config = __webpack_require__(66);

	var _config2 = _interopRequireDefault(_config);

	'use strict';

	var UserActionCreators = {
	  requestUser: function requestUser(userId, fields) {
	    _utilsActionUtils2['default'].requestEntity({
	      idAttribute: 'userId',
	      userId: userId,
	      store: _storesUserStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER,
	      fields: fields,
	      callAPI: _apiUserAPI2['default'].requestUser
	    });
	  },

	  toggleServiceAccountHidden: function toggleServiceAccountHidden(serviceType, hidden) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].TOGGLE_SERVICE_ACCOUNT_HIDDEN,
	      serviceType: serviceType
	    });

	    _apiUserAPI2['default'].toggleServiceAccountHidden(serviceType, hidden);
	  },

	  connectServiceAccount: function connectServiceAccount(serviceType) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CONNECT_SERVICE_ACCOUNT,
	      serviceType: serviceType
	    });

	    _utilsPopupManager2['default'].openConnect(serviceType);
	  },

	  loginWithServiceAccount: function loginWithServiceAccount(serviceType) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LOGIN_WITH_SERVICE_ACCOUNT,
	      serviceType: serviceType
	    });

	    _utilsPopupManager2['default'].openLogin(serviceType, { popup: !_config2['default'].isAuthPopup });
	  },

	  signupWithServiceAccount: function signupWithServiceAccount(serviceType) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SIGNUP_WITH_SERVICE_ACCOUNT,
	      serviceType: serviceType
	    });

	    _utilsPopupManager2['default'].openSignup(serviceType, { popup: !_config2['default'].isAuthPopup });
	  },

	  disconnectServiceAccount: function disconnectServiceAccount(serviceType) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].DISCONNECT_SERVICE_ACCOUNT,
	      serviceType: serviceType
	    });

	    _apiUserAPI2['default'].disconnectServiceAccount(serviceType);
	  },

	  saveSettings: function saveSettings(settings) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SAVE_SETTINGS
	    });

	    _apiUserAPI2['default'].saveSettings(settings);
	  },

	  requestResetPassword: function requestResetPassword(data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].REQUEST_RESET_PASSWORD
	    });

	    _apiUserAPI2['default'].requestResetPassword(data);
	  },

	  resetPassword: function resetPassword(data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].RESET_PASSWORD
	    });

	    _apiUserAPI2['default'].resetPassword(data);
	  },

	  logOut: function logOut() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LOGOUT
	    });

	    window.location = '/logout';
	  },

	  sendFeedback: function sendFeedback(data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].FEEDBACK
	    });

	    _apiUserAPI2['default'].sendFeedback(data);
	  },

	  resendUnconfirmedEmail: function resendUnconfirmedEmail() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].RESEND_UNCONFIRMED_EMAIL
	    });

	    _apiUserAPI2['default'].resendUnconfirmedEmail();
	  },

	  cancelUnconfirmedEmail: function cancelUnconfirmedEmail() {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].CANCEL_UNCONFIRMED_EMAIL
	    });

	    _apiUserAPI2['default'].cancelUnconfirmedEmail();
	  },

	  resubscribeEmail: function resubscribeEmail(data) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].RESUBSCRIBE_EMAIL
	    });

	    _apiUserAPI2['default'].resubscribeEmail(data);
	  },

	  enableEmailNotification: function enableEmailNotification(flag) {
	    (0, _reactLibInvariant2['default'])((0, _underscore.values)(_constantsEmailFlags2['default']).indexOf(flag) > -1, 'Expected one of EmailFlags, got %s', flag);
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].ENABLE_EMAIL_NOTIFICATION,
	      flag: flag
	    });

	    _apiUserAPI2['default'].saveEmailNotificationSettings();
	  },

	  disableEmailNotification: function disableEmailNotification(flag) {
	    (0, _reactLibInvariant2['default'])((0, _underscore.values)(_constantsEmailFlags2['default']).indexOf(flag) > -1, 'Expected one of EmailFlags, got %s', flag);

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].DISABLE_EMAIL_NOTIFICATION,
	      flag: flag
	    });

	    _apiUserAPI2['default'].saveEmailNotificationSettings();
	  },

	  followUser: function followUser(userId) {
	    if ((0, _utilsHandleUnauthAction2['default'])(_constantsAnalyticsSources2['default'].FOLLOW_USER)) {
	      return;
	    }

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].FOLLOW_USER,
	      userId: userId
	    });

	    _apiUserAPI2['default'].followUser(userId);
	  },

	  unfollowUser: function unfollowUser(userId) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].UNFOLLOW_USER,
	      userId: userId
	    });

	    _apiUserAPI2['default'].unfollowUser(userId);
	  },

	  requestUserSubscriberPage: function requestUserSubscriberPage(userId, isInitialRequest, allowInvalidate) {
	    if (allowInvalidate && isInitialRequest) {
	      // Keep everyone's subscribers fresh
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_USER_SUBSCRIBERS,
	        userId: userId
	      });
	    }

	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserSubscribersStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_SUBSCRIBERS,
	      callAPI: _apiUserAPI2['default'].requestUserSubscriberPage
	    });
	  },

	  requestUserSubscriptionPage: function requestUserSubscriptionPage(userId, isInitialRequest, allowInvalidate) {
	    if (allowInvalidate && isInitialRequest && _storesUserStore2['default'].isMe(userId)) {
	      // Keep own subscriptions fresh
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_USER_SUBSCRIPTIONS,
	        userId: userId
	      });
	    }

	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserSubscriptionsStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_SUBSCRIPTIONS,
	      callAPI: _apiUserAPI2['default'].requestUserSubscriptionPage
	    });
	  },

	  requestSearchPage: function requestSearchPage(terms, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      terms: terms,
	      idAttribute: 'terms',
	      isInitialRequest: isInitialRequest,
	      store: _storesSearchUserStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_SEARCH,
	      callAPI: _apiUserAPI2['default'].requestSearchPage
	    });
	  }
	};

	exports['default'] = UserActionCreators;
	module.exports = exports['default'];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  SERVER_ERROR: null,
	  CONNECTION_ERROR: null,

	  SHARE_POSTED_STAMP: null,
	  DELETE_DRAFT: null,
	  DELETE_STAMP: null,
	  DELETE_ZINE: null,

	  EDITOR_DESKTOP_ONLY: null,
	  EDITOR_COVER_TITLE_REQUIRED: null,
	  EDITOR_TITLE_REQUIRED: null,
	  EDITOR_COVER_REQUIRED: null,
	  EDITOR_DELETE_SECTION: null,
	  EDITOR_ADD_MORE_CONTENT: null,
	  EDITOR_DISREGARD_CHANGES: null,
	  UPLOAD_USER_IMAGE_ERROR: null,
	  LOGOUT: null,
	  NOT_FOUND: null,

	  AUDIO_NOT_FOUND: null,
	  VIDEO_NOT_FOUND: null,
	  VIDEO_EMBED_FORBIDDEN: null,

	  ZINE_TITLE_TOO_SHORT: null,
	  ZINE_TITLE_TWO_WORDS: null,
	  ZINE_DESCRIPTION_TOO_SHORT: null,
	  ZINE_ALREADY_EXISTS: null,

	  STAMP_SAVE_IMAGE_HELP: null,
	  SHARE_DRAFT: null
	});

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */

	 /* global hasOwnProperty:true */

	'use strict';

	var assign = __webpack_require__(15);
	var keyOf = __webpack_require__(76);
	var invariant = __webpack_require__(11);
	var hasOwnProperty = {}.hasOwnProperty;

	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}

	var COMMAND_PUSH = keyOf({$push: null});
	var COMMAND_UNSHIFT = keyOf({$unshift: null});
	var COMMAND_SPLICE = keyOf({$splice: null});
	var COMMAND_SET = keyOf({$set: null});
	var COMMAND_MERGE = keyOf({$merge: null});
	var COMMAND_APPLY = keyOf({$apply: null});

	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];

	var ALL_COMMANDS_SET = {};

	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});

	function invariantArrayCase(value, spec, command) {
	  (false ? invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  ) : invariant(Array.isArray(value)));
	  var specValue = spec[command];
	  (false ? invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  ) : invariant(Array.isArray(specValue)));
	}

	function update(value, spec) {
	  (false ? invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	    'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  ) : invariant(typeof spec === 'object'));

	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    (false ? invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    ) : invariant(Object.keys(spec).length === 1));

	    return spec[COMMAND_SET];
	  }

	  var nextValue = shallowCopy(value);

	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    (false ? invariant(
	      mergeObj && typeof mergeObj === 'object',
	      'update(): %s expects a spec of type \'object\'; got %s',
	      COMMAND_MERGE,
	      mergeObj
	    ) : invariant(mergeObj && typeof mergeObj === 'object'));
	    (false ? invariant(
	      nextValue && typeof nextValue === 'object',
	      'update(): %s expects a target of type \'object\'; got %s',
	      COMMAND_MERGE,
	      nextValue
	    ) : invariant(nextValue && typeof nextValue === 'object'));
	    assign(nextValue, spec[COMMAND_MERGE]);
	  }

	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }

	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }

	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    (false ? invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    ) : invariant(Array.isArray(value)));
	    (false ? invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	      'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    ) : invariant(Array.isArray(spec[COMMAND_SPLICE])));
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      (false ? invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      ) : invariant(Array.isArray(args)));
	      nextValue.splice.apply(nextValue, args);
	    });
	  }

	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    (false ? invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    ) : invariant(typeof spec[COMMAND_APPLY] === 'function'));
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }

	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }

	  return nextValue;
	}

	module.exports = update;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var router, initialState, currentState;

	module.exports = {
	  isInitialPath: function isInitialPath() {
	    return currentState === initialState;
	  },

	  getCurrentPath: function getCurrentPath() {
	    return router.getCurrentPath();
	  },

	  makePath: function makePath(to, params, query) {
	    return router.makePath(to, params, query);
	  },

	  makeHref: function makeHref(to, params, query) {
	    return router.makeHref(to, params, query);
	  },

	  transitionTo: function transitionTo(to, params, query) {
	    router.transitionTo(to, params, query);
	  },

	  replaceWith: function replaceWith(to, params, query) {
	    router.replaceWith(to, params, query);
	  },

	  goBack: function goBack() {
	    router.goBack();
	  },

	  run: function run(render) {
	    router.run(function (Handler, state) {
	      if (!currentState) {
	        initialState = state;
	      }

	      currentState = state;
	      render(Handler, state);
	    });
	  }
	};

	var routes = __webpack_require__(756),
	    Router = __webpack_require__(154);

	router = Router.create({
	  routes: routes,
	  location: Router.HistoryLocation
	});

	if (false) {
	  module.hot.accept('./routes', function () {
	    routes = require('./routes');
	    router.replaceRoutes(routes);
	  });
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  HOME: null,
	  ABOUT: null,
	  STAMP: null,
	  ZINE: null,
	  USER: null,
	  DRAFT_COMPOSE: null,
	  DRAFT_PREVIEW: null,
	  SEARCH: null,
	  ZINES: null
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    UserStore = __webpack_require__(5),
	    AnalyticsClient = __webpack_require__(778),
	    AnalyticsEvents = __webpack_require__(55),
	    parseHostname = __webpack_require__(452),
	    ga = __webpack_require__(1182),
	    config = __webpack_require__(66);

	var backendUrl = config.statsBaseUrl;
	if (!backendUrl) {
	  throw new Error('You forgot to pass statsBaseUrl as config parameter.');
	}

	var Analytics = {
	  start: function start() {
	    var options = {
	      backendUrl: backendUrl,
	      fingerprintKey: 'stampsy-bigdata-fingerprint',
	      sessionKey: 'stampsy-bigdata-session'
	    };

	    if (UserStore.isAuthenticated()) {
	      options.userId = UserStore.getMe().id;
	    }

	    AnalyticsClient.initialize(options);

	    var location = document.location,
	        referrer = document.referrer;

	    if (location.hostname !== parseHostname(referrer)) {
	      _.delay(this.trackExternalVisit, 1000);
	    }
	  },

	  trackExternalVisit: function trackExternalVisit() {
	    Analytics.trackEvent(AnalyticsEvents.STAMPSY_VISIT, {
	      referrer: document.referrer
	    });
	  },

	  trackEvent: function trackEvent(name, params) {
	    if (!name) {
	      console.warn('trackEvent() called with empty name.');
	    }

	    var me = UserStore.getMe();
	    if (me && me.isStaff) {
	      return;
	    }

	    params = params || {};
	    AnalyticsClient.trackEvent(name, params);
	  },

	  trackGAEvent: function trackGAEvent(action, label, value) {
	    if (!action) {
	      console.warn('trackGAEvent() called with empty action.');
	    }

	    var me = UserStore.getMe();
	    if (me && me.isStaff) {
	      return;
	    }

	    ga('send', 'event', 'web', action, label, value);
	  },

	  trackPageView: function trackPageView(currentPath, activeRoutes, activeParams) {
	    var me = UserStore.getMe();
	    if (me && me.isStaff) {
	      return;
	    }

	    var canonicalPath = this.getCanonicalPath(currentPath, activeRoutes, activeParams);
	    ga('send', 'pageview', canonicalPath);
	  },

	  getCanonicalPath: function getCanonicalPath(path, activeRoutes, activeParams) {
	    var deepestRoute = _.last(activeRoutes);var stampId = activeParams.stampId;

	    if (!deepestRoute) {
	      return path;
	    }

	    if (!deepestRoute.name.endsWith('Stamp') || !stampId) {
	      return path;
	    }

	    return '/stamp/' + stampId;
	  }
	};

	module.exports = Analytics;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = parseStampSegment;
	'use strict';

	function parseStampSegment(stampSegment) {
	  var isNewDraft = stampSegment === 'new';

	  var _stampSegment$toString$split = stampSegment.toString().split('-', 2);

	  var _stampSegment$toString$split2 = _slicedToArray(_stampSegment$toString$split, 2);

	  var uuid = _stampSegment$toString$split2[0];
	  var id = _stampSegment$toString$split2[1];

	  if (!Boolean(id) && /^\d+$/.test(uuid)) {
	    id = uuid;
	    uuid = null;
	  }

	  var isStamp = Boolean(id);
	  var isServerDraft = !isNewDraft && !isStamp;

	  return {
	    isNewDraft: isNewDraft,
	    isServerDraft: isServerDraft,
	    isDraft: isNewDraft || isServerDraft,
	    isStamp: isStamp,
	    stampId: isStamp ? parseInt(id, 10) : null,
	    draftUuid: isServerDraft ? uuid : null,
	    stampUuid: isStamp ? uuid : null
	  };
	}

	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _utilsAnalytics = __webpack_require__(52);

	var _utilsAnalytics2 = _interopRequireDefault(_utilsAnalytics);

	var _constantsAnalyticsEvents = __webpack_require__(55);

	var _constantsAnalyticsEvents2 = _interopRequireDefault(_constantsAnalyticsEvents);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _apiStampAPI = __webpack_require__(392);

	var _apiStampAPI2 = _interopRequireDefault(_apiStampAPI);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesFeedStore = __webpack_require__(420);

	var _storesFeedStore2 = _interopRequireDefault(_storesFeedStore);

	var _storesTrendingStore = __webpack_require__(428);

	var _storesTrendingStore2 = _interopRequireDefault(_storesTrendingStore);

	var _storesFeedWithTrendingStore = __webpack_require__(288);

	var _storesFeedWithTrendingStore2 = _interopRequireDefault(_storesFeedWithTrendingStore);

	var _storesUserLatestStampStore = __webpack_require__(213);

	var _storesUserLatestStampStore2 = _interopRequireDefault(_storesUserLatestStampStore);

	var _storesUserLikedStampStore = __webpack_require__(214);

	var _storesUserLikedStampStore2 = _interopRequireDefault(_storesUserLikedStampStore);

	var _storesZineLatestStampStore = __webpack_require__(292);

	var _storesZineLatestStampStore2 = _interopRequireDefault(_storesZineLatestStampStore);

	var _storesZinePendingStampStore = __webpack_require__(216);

	var _storesZinePendingStampStore2 = _interopRequireDefault(_storesZinePendingStampStore);

	var _storesSearchStampStore = __webpack_require__(210);

	var _storesSearchStampStore2 = _interopRequireDefault(_storesSearchStampStore);

	var _storesStampLikesStore = __webpack_require__(426);

	var _storesStampLikesStore2 = _interopRequireDefault(_storesStampLikesStore);

	var _utilsActionUtils = __webpack_require__(133);

	var _utilsActionUtils2 = _interopRequireDefault(_utilsActionUtils);

	var _utilsHandleUnauthAction = __webpack_require__(179);

	var _utilsHandleUnauthAction2 = _interopRequireDefault(_utilsHandleUnauthAction);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	'use strict';

	function parseStampId(stampSegment) {
	  return (0, _utilsParseStampSegment2['default'])(stampSegment).stampId;
	}

	var StampActionCreators = {
	  requestStamp: function requestStamp(stampSegment, fields) {
	    _utilsActionUtils2['default'].requestEntity({
	      idAttribute: 'stampSegment',
	      getIdForStore: parseStampId,
	      stampSegment: stampSegment,
	      store: _storesStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_STAMP,
	      fields: fields,
	      callAPI: _apiStampAPI2['default'].requestStamp
	    });
	  },

	  updateStamp: function updateStamp(stamp) {
	    _utilsActionUtils2['default'].updateEntity({
	      entity: stamp,
	      action: _constantsActionTypes2['default'].UPDATE_STAMP,
	      callAPI: _apiStampAPI2['default'].updateStamp
	    });
	  },

	  deleteStamp: function deleteStamp(stampSegment) {
	    _utilsActionUtils2['default'].deleteEntity({
	      idAttribute: 'stampSegment',
	      stampSegment: stampSegment,
	      action: _constantsActionTypes2['default'].DELETE_STAMP,
	      callAPI: _apiStampAPI2['default'].deleteStamp
	    });
	  },

	  likeStamp: function likeStamp(stampSegment) {
	    if ((0, _utilsHandleUnauthAction2['default'])(_constantsAnalyticsSources2['default'].LIKE_STAMP)) {
	      return;
	    }

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].LIKE_STAMP,
	      stampSegment: stampSegment
	    });

	    _apiStampAPI2['default'].likeStamp(stampSegment);
	  },

	  unlikeStamp: function unlikeStamp(stampSegment) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].UNLIKE_STAMP,
	      stampSegment: stampSegment
	    });

	    _apiStampAPI2['default'].unlikeStamp(stampSegment);
	  },

	  incrementStampViews: function incrementStampViews(stampSegment, isNextStamp) {
	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].INCREMENT_STAMP_VIEWS,
	      stampSegment: stampSegment
	    });

	    _apiStampAPI2['default'].incrementStampViews(stampSegment);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].STAMP_VIEW, {
	      stampSegment: stampSegment,
	      isNextStamp: isNextStamp
	    });
	  },

	  requestFeedWithTrendingPage: function requestFeedWithTrendingPage(isInitialRequest, allowInvalidate) {
	    if (allowInvalidate && isInitialRequest) {
	      // Always keep feed and trending fresh
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_FEED_WITH_TRENDING
	      });
	    }

	    if (_storesFeedWithTrendingStore2['default'].needFeed(isInitialRequest)) {
	      _utilsActionUtils2['default'].requestPage({
	        isInitialRequest: isInitialRequest,
	        store: _storesFeedStore2['default'],
	        action: _constantsActionTypes2['default'].REQUEST_FEED,
	        callAPI: _apiStampAPI2['default'].requestFeedPage
	      });
	    }

	    if (_storesFeedWithTrendingStore2['default'].needTrending(isInitialRequest)) {
	      _utilsActionUtils2['default'].requestPage({
	        isInitialRequest: isInitialRequest,
	        store: _storesTrendingStore2['default'],
	        action: _constantsActionTypes2['default'].REQUEST_TRENDING_STAMPS,
	        callAPI: _apiStampAPI2['default'].requestTrendingPage
	      });
	    }
	  },

	  requestUserLatestPage: function requestUserLatestPage(userId, isInitialRequest, allowInvalidate) {
	    if (allowInvalidate && isInitialRequest && !_storesUserStore2['default'].isMe(userId)) {
	      // Keep other people's published stamps fresh
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_USER_LATEST_STAMPS,
	        userId: userId
	      });
	    }

	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserLatestStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_LATEST_STAMPS,
	      callAPI: _apiStampAPI2['default'].requestUserLatestPage
	    });
	  },

	  requestUserLikedPage: function requestUserLikedPage(userId, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      userId: userId,
	      idAttribute: 'userId',
	      isInitialRequest: isInitialRequest,
	      store: _storesUserLikedStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS,
	      callAPI: _apiStampAPI2['default'].requestUserLikedPage
	    });
	  },

	  requestZineLatestPage: function requestZineLatestPage(zineSlug, isInitialRequest, allowInvalidate) {
	    if (allowInvalidate && isInitialRequest) {
	      // Keep stamps inside zines fresh
	      _AppDispatcher2['default'].handleViewAction({
	        type: _constantsActionTypes2['default'].INVALIDATE_ZINE_LATEST_STAMPS,
	        zineSlug: zineSlug
	      });
	    }

	    _utilsActionUtils2['default'].requestIndexedPage({
	      zineSlug: zineSlug,
	      idAttribute: 'zineSlug',
	      isInitialRequest: isInitialRequest,
	      store: _storesZineLatestStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINE_LATEST_STAMPS,
	      callAPI: _apiStampAPI2['default'].requestZineLatestPage
	    });
	  },

	  requestZinePendingPage: function requestZinePendingPage(zineSlug, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      zineSlug: zineSlug,
	      idAttribute: 'zineSlug',
	      isInitialRequest: isInitialRequest,
	      store: _storesZinePendingStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_ZINE_PENDING_STAMPS,
	      callAPI: _apiStampAPI2['default'].requestZinePendingPage
	    });
	  },

	  requestStampLikePage: function requestStampLikePage(stampSegment, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      stampSegment: stampSegment,
	      idAttribute: 'stampSegment',
	      getIdForStore: parseStampId,
	      isInitialRequest: isInitialRequest,
	      store: _storesStampLikesStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_STAMP_LIKES,
	      callAPI: _apiStampAPI2['default'].requestStampLikePage
	    });
	  },

	  requestSearchPage: function requestSearchPage(terms, isInitialRequest) {
	    _utilsActionUtils2['default'].requestIndexedPage({
	      terms: terms,
	      idAttribute: 'terms',
	      isInitialRequest: isInitialRequest,
	      store: _storesSearchStampStore2['default'],
	      action: _constantsActionTypes2['default'].REQUEST_STAMP_SEARCH,
	      callAPI: _apiStampAPI2['default'].requestSearchPage
	    });
	  }
	};

	module.exports = StampActionCreators;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// TODO: Some of these are unused, some are outdated,
	// some are used but directly by their string values.
	// Need to clean this up.

	module.exports = {
	   // General
	   STAMPSY_VISIT: 'stampsy.visit',
	   STAMPSY_SIGNUP: 'stampsy.signup',
	   FACEBOOK_BUTTON_CLICK: 'facebook_button.click',

	   // Editor
	   EDITOR_VIEW: 'editor.view',
	   EDITOR_COMPOSE_VIEW: 'editor.compose.view',
	   EDITOR_PREVIEW_VIEW: 'editor.preview.view',
	   EDITOR_HELP_SHOW: 'editor.help.show',

	   // Editor actions
	   EDITOR_COVER_CLEAR: 'editor.cover.clear',
	   EDITOR_COVER_DROP: 'editor.cover.drop',
	   EDITOR_GALLERY_DROP: 'editor.gallery.drop',
	   EDITOR_POSTER_DROP: 'editor.poster.drop',
	   EDITOR_GRABBOX_DELETE: 'editor.grabbox.delete',
	   EDITOR_GRABBOX_DROP: 'editor.grabbox.drop',
	   EDITOR_GRABBOX_FAIL: 'editor.grabbox.fail',
	   EDITOR_GRABBOX_QUEUE: 'editor.grabbox.queue',
	   EDITOR_GRABBOX_UPLOAD: 'editor.grabbox.upload',
	   EDITOR_SECTIONS_ADD: 'editor.sections.add',
	   EDITOR_SECTIONS_DELETE: 'editor.sections.delete',
	   EDITOR_SECTIONS_DROP: 'editor.sections.drop',

	   // Feed
	   FEED_VIEW: 'feed.view',

	   // Zines
	   ZINES_VIEW: 'zines.view',

	   // Forms
	   FORMS_ABOUT_SHOW: 'forms.about.show',
	   FORMS_FEEDBACK_SHOW: 'forms.feedback.show',
	   FORMS_FEEDBACK_SEND: 'forms.feedback.send',
	   FORMS_SEND_INVITE_SHOW: 'forms.send_invite.show',
	   FORMS_SEND_INVITE_SEND: 'forms.send_invite.send',
	   FORMS_SETTINGS_SHOW: 'forms.settings.show',
	   FORMS_SETTINGS_SEND: 'forms.settings.send',
	   FORMS_EDIT_ZINE_SHOW: 'forms.edit_zine.show',
	   FORMS_FINISH_SIGNUP_SHOW: 'forms.finish_signup.show',
	   FORMS_FINISH_SIGNUP_SEND: 'forms.finish_signup.send',
	   FORMS_REQUEST_RESET_PASSWORD_SHOW: 'forms.request_reset_password.show',
	   FORMS_REQUEST_RESET_PASSWORD_SEND: 'forms.request_reset_password.send',
	   FORMS_RESET_PASSWORD_SHOW: 'forms.reset_password.show',
	   FORMS_RESET_PASSWORD_SEND: 'forms.reset_password.send',
	   FORMS_LOGIN_SHOW: 'forms.login.show',
	   FORMS_LOGIN_SEND: 'forms.login.send',
	   FORMS_SIGNUP_SHOW: 'forms.signup.show',
	   FORMS_AMBASSADOR_REQUEST_SHOW: 'forms.ambassador_request.show',

	   // Stamp
	   STAMP_VIEW: 'stamp.view',

	   // Stamp actions
	   STAMP_DELETE: 'stamp.delete',
	   STAMP_EDIT: 'stamp.edit',
	   STAMP_PUBLISH: 'stamp.publish',
	   STAMP_LIKE: 'stamp.like',
	   STAMP_UNLIKE: 'stamp.unlike',
	   STAMP_SHARE: 'stamp.share',

	   // User profile
	   USER_VIEW: 'user.view',
	   USER_SHARE: 'user.share',
	   USER_LATEST_VIEW: 'user.latest.view',
	   USER_CURATED_VIEW: 'user.curated.view',
	   USER_LIKES_VIEW: 'user.likes.view',
	   USER_STATS_VIEW: 'user.stats.view',
	   USER_STATS_ADMIN_VIEW: 'user.stats_admin.view',

	   // Zine
	   ZINE_VIEW: 'zine.view',
	   ZINE_SHARE: 'zine.share',
	   ZINE_TRENDING_VIEW: 'zine.trending.view',
	   ZINE_LATEST_VIEW: 'zine.latest.view',
	   ZINE_PENDING_VIEW: 'zine.pending.view',

	   // Zine actions
	   ZINE_ACCEPT_STAMP: 'zine.accept_stamp',
	   ZINE_DECLINE_STAMP: 'zine.decline_stamp',
	   ZINE_ADD_STAMP: 'zine.add_stamp',
	   ZINE_REMOVE_STAMP: 'zine.remove_stamp',
	   ZINE_SUBMIT_STAMP: 'zine.submit_stamp',
	   ZINE_CREATE: 'zine.create',
	   ZINE_EDIT: 'zine.edit',

	   // About
	   ABOUT_VIEW: 'about.view',

	   // Notifications
	   NOTIFICATION_EMAIL_CONFIRMATION_RESEND: 'notification.email_confirmation.resend',
	   NOTIFICATION_EMAIL_CONFIRMATION_CANCEL: 'notification.email_confirmation.cancel',

	   // MISC
	   STAMP_ACTION_BUY_IN_ITUNES: 'stamp.action.buy_in_itunes'
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint bitwise:false */
	'use strict';

	function getLuminance(color) {
	  /* jshint bitwise:false */
	  var c = parseInt(color, 16),
	      r = (c & 16711680) >> 16,
	      g = (c & 65280) >> 8,
	      b = c & 255;

	  return 0.299 * r + 0.587 * g + 0.114 * b;
	}

	var BackColorMixin = {
	  getTextColor: function getTextColor(backColor) {
	    var lum = getLuminance(backColor);
	    return lum > 160 ? 'dark' : 'light';
	  },

	  parseColor: function parseColor(color) {
	    if (color[0] === '#') {
	      color = color.slice(1);
	    }

	    var rgb;
	    if ((rgb = /^([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})/.exec(color) || []).length) {
	      rgb = [parseInt(rgb[1], 16), parseInt(rgb[2], 16), parseInt(rgb[3], 16)];
	    } else {
	      throw new Error(color + ' is not in RRGGBB format.');
	    }

	    return rgb;
	  }
	};

	module.exports = BackColorMixin;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Children = __webpack_require__(366);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var SidebarHeader = __webpack_require__(704);
	var Container = __webpack_require__(81);var PropTypes = React.PropTypes;

	__webpack_require__(969);

	var SidebarBody = React.createClass({
	  displayName: 'SidebarBody',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    title: PropTypes.node.isRequired,
	    subtitle: PropTypes.node
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      fillHeight: true
	    };
	  },

	  className: 'SidebarBody',

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(SidebarHeader, { title: this.props.title,
	        subtitle: this.props.subtitle }),
	      Children.map(this.props.children, this.wrapInContainer)
	    );
	  },

	  wrapInContainer: function wrapInContainer(component) {
	    if (component) {
	      return React.createElement(
	        Container,
	        { context: 'Sidebar' },
	        component
	      );
	    }
	  }
	});

	module.exports = SidebarBody;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  TERMS: null,
	  SETTINGS: null,
	  RESET_PASSWORD: null,
	  LOGIN: null,
	  SIGNUP: null,
	  FINISH_SIGNUP: null,
	  REQUEST_RESET_PASSWORD: null,
	  SEND_INVITE: null,
	  ABOUT: null,
	  FEEDBACK: null,
	  EDITOR_HELP: null,
	  STAMPLET: null,
	  CONTACT_US: null
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(935);

	var Separator = React.createClass({
	  displayName: 'Separator',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'EmptyState-actionSeparator' },
	      this.props.children
	    );
	  }
	});

	var EmptyState = React.createClass({
	  displayName: 'EmptyState',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    label: PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'EmptyState-label' },
	        this.props.label
	      ),
	      this.props.children && React.createElement(
	        'div',
	        { className: 'EmptyState-body' },
	        this.props.children
	      )
	    );
	  }
	});

	module.exports = EmptyState;
	module.exports.Separator = Separator;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	exports['default'] = getStampSegment;

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	function getStampSegment(stamp) {
	  var status = stamp.status;
	  var id = stamp.id;
	  var uuid = stamp.uuid;

	  if (id) {
	    return status === _constantsStampStatus2['default'].UNLISTED ? '' + uuid + '-' + id : id.toString();
	  } else {
	    return uuid || 'new';
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _isIterable = __webpack_require__(802)["default"];

	var _getIterator = __webpack_require__(302)["default"];

	exports["default"] = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (_isIterable(Object(arr))) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};

	exports.__esModule = true;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */

	'use strict';

	var keyMirror = __webpack_require__(24);

	var PropagationPhases = keyMirror({bubbled: null, captured: null});

	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topBlur: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topReset: null,
	  topScroll: null,
	  topSelectionChange: null,
	  topSubmit: null,
	  topTextInput: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topWheel: null
	});

	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};

	module.exports = EventConstants;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */

	'use strict';

	var CallbackQueue = __webpack_require__(363);
	var PooledClass = __webpack_require__(106);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactPerf = __webpack_require__(141);
	var ReactReconciler = __webpack_require__(161);
	var Transaction = __webpack_require__(241);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;

	var batchingStrategy = null;

	function ensureInjected() {
	  (false ? invariant(
	    ReactUpdates.ReactReconcileTransaction && batchingStrategy,
	    'ReactUpdates: must inject a reconcile transaction class and batching ' +
	    'strategy'
	  ) : invariant(ReactUpdates.ReactReconcileTransaction && batchingStrategy));
	}

	var NESTED_UPDATES = {
	  initialize: function() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};

	var UPDATE_QUEUEING = {
	  initialize: function() {
	    this.callbackQueue.reset();
	  },
	  close: function() {
	    this.callbackQueue.notifyAll();
	  }
	};

	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction =
	    ReactUpdates.ReactReconcileTransaction.getPooled();
	}

	assign(
	  ReactUpdatesFlushTransaction.prototype,
	  Transaction.Mixin, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  destructor: function() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },

	  perform: function(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(
	      this,
	      this.reconcileTransaction.perform,
	      this.reconcileTransaction,
	      method,
	      scope,
	      a
	    );
	  }
	});

	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

	function batchedUpdates(callback, a, b, c, d) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d);
	}

	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}

	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  (false ? invariant(
	    len === dirtyComponents.length,
	    'Expected flush transaction\'s stored dirty-components length (%s) to ' +
	    'match dirty-components array length (%s).',
	    len,
	    dirtyComponents.length
	  ) : invariant(len === dirtyComponents.length));

	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);

	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];

	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;

	    ReactReconciler.performUpdateIfNecessary(
	      component,
	      transaction.reconcileTransaction
	    );

	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(
	          callbacks[j],
	          component.getPublicInstance()
	        );
	      }
	    }
	  }
	}

	var flushBatchedUpdates = function() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }

	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure(
	  'ReactUpdates',
	  'flushBatchedUpdates',
	  flushBatchedUpdates
	);

	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();

	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	  (false ? warning(
	    ReactCurrentOwner.current == null,
	    'enqueueUpdate(): Render methods should be a pure function of props ' +
	    'and state; triggering nested component updates from render is not ' +
	    'allowed. If necessary, trigger nested updates in ' +
	    'componentDidUpdate.'
	  ) : null);

	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }

	  dirtyComponents.push(component);
	}

	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  (false ? invariant(
	    batchingStrategy.isBatchingUpdates,
	    'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' +
	    'updates are not being batched.'
	  ) : invariant(batchingStrategy.isBatchingUpdates));
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}

	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function(ReconcileTransaction) {
	    (false ? invariant(
	      ReconcileTransaction,
	      'ReactUpdates: must provide a reconcile transaction class'
	    ) : invariant(ReconcileTransaction));
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },

	  injectBatchingStrategy: function(_batchingStrategy) {
	    (false ? invariant(
	      _batchingStrategy,
	      'ReactUpdates: must provide a batching strategy'
	    ) : invariant(_batchingStrategy));
	    (false ? invariant(
	      typeof _batchingStrategy.batchedUpdates === 'function',
	      'ReactUpdates: must provide a batchedUpdates() function'
	    ) : invariant(typeof _batchingStrategy.batchedUpdates === 'function'));
	    (false ? invariant(
	      typeof _batchingStrategy.isBatchingUpdates === 'boolean',
	      'ReactUpdates: must provide an isBatchingUpdates boolean attribute'
	    ) : invariant(typeof _batchingStrategy.isBatchingUpdates === 'boolean'));
	    batchingStrategy = _batchingStrategy;
	  }
	};

	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,

	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};

	module.exports = ReactUpdates;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$assign = __webpack_require__(180)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _reactLibUpdate = __webpack_require__(49);

	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);

	var _simpleGuid = __webpack_require__(246);

	var _simpleGuid2 = _interopRequireDefault(_simpleGuid);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _utilsIsSectionEmpty = __webpack_require__(446);

	var _utilsIsSectionEmpty2 = _interopRequireDefault(_utilsIsSectionEmpty);

	var _utilsDangerouslyStripHTML = __webpack_require__(296);

	var _utilsDangerouslyStripHTML2 = _interopRequireDefault(_utilsDangerouslyStripHTML);

	var _constantsSectionTypes = __webpack_require__(40);

	var _constantsSectionTypes2 = _interopRequireDefault(_constantsSectionTypes);

	var _UserStore = __webpack_require__(5);

	var _UserStore2 = _interopRequireDefault(_UserStore);

	var _utilsLegacy = __webpack_require__(782);

	var _utilsLegacy2 = _interopRequireDefault(_utilsLegacy);

	var _lodashLangCloneDeep = __webpack_require__(496);

	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);

	var _underscore = __webpack_require__(4);

	var _utilsPaginatedStoreUtils = __webpack_require__(28);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	var _stamp = null,
	    _isPublishing = false,
	    _hasUnsavedChanges = false,
	    _loadingMedia = {},
	    _loadingMediaBackground = {},
	    _lastAddedItemUuid = null;

	function getInitialSectionContent(sectionType) {
	  var section = {
	    type: sectionType,
	    uuid: (0, _simpleGuid2['default'])()
	  };

	  switch (sectionType) {
	    case _constantsSectionTypes2['default'].COVER:
	      return _Object$assign({}, section, {
	        background: null,
	        title: '',
	        subtitle: ''
	      });
	    case _constantsSectionTypes2['default'].GALLERY:
	      return _Object$assign({}, section, {
	        layout: 'list',
	        images: []
	      });
	    case _constantsSectionTypes2['default'].POSTER:
	      return _Object$assign({}, section, {
	        background: null
	      });
	    case _constantsSectionTypes2['default'].TEXT:
	      return _Object$assign({}, section, {
	        text: ''
	      });
	    case _constantsSectionTypes2['default'].MEDIA:
	      return section;
	  }
	}

	function getInitialDraft() {
	  var legacyDraft = _utilsLegacy2['default'].loadDraftFromStorage();
	  var initialDraft = {
	    user: _UserStore2['default'].getMe().id,
	    canEdit: true,
	    content: {
	      sections: [getInitialSectionContent(_constantsSectionTypes2['default'].COVER)]
	    }
	  };

	  if (legacyDraft) {
	    return _Object$assign(initialDraft, legacyDraft);
	  } else {
	    return initialDraft;
	  }
	}

	function getSections() {
	  return _stamp.content.sections;
	}

	function findSection(sectionId) {
	  var sections = getSections();
	  return sections.indexOf((0, _underscore.find)(sections, function (section) {
	    return section.uuid === sectionId;
	  }));
	}

	function findImage(gallery, imageId) {
	  var images = gallery.images;
	  return images.indexOf((0, _underscore.find)(images, function (image) {
	    return image.uuid === imageId;
	  }));
	}

	function prepareSection(section, index) {
	  if (index === 0) {
	    section.subtitle = (0, _utilsDangerouslyStripHTML2['default'])(section.subtitle);
	  }

	  if (!section.uuid) {
	    section.uuid = (0, _simpleGuid2['default'])();
	  }

	  if (section.background) {
	    section.background.caption = (0, _utilsDangerouslyStripHTML2['default'])(section.background.caption);
	  }

	  if (section.images) {
	    section.images.forEach(function (image) {
	      image.uuid = image.uuid || (0, _simpleGuid2['default'])();
	      image.caption = (0, _utilsDangerouslyStripHTML2['default'])(image.caption);
	    });
	  }
	}

	function updateStampFromCoverSection() {
	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    $merge: {
	      title: _stamp.content.sections[0].title,
	      description: _stamp.content.sections[0].subtitle,
	      thumbnail: _stamp.content.sections[0].background
	    }
	  });
	}

	function loadDraft(stamp) {
	  _hasUnsavedChanges = false;

	  if (!stamp) {
	    _stamp = null;
	  } else {
	    _stamp = (0, _lodashLangCloneDeep2['default'])(stamp);
	    _stamp.content.sections.forEach(prepareSection);
	    updateStampFromCoverSection();
	  }
	}

	function markNeedsSave() {
	  _hasUnsavedChanges = true;
	}

	function addSection(sectionType, afterSectionId, initialOptions) {
	  var index = findSection(afterSectionId),
	      newSection;

	  newSection = getInitialSectionContent(sectionType);
	  _lastAddedItemUuid = newSection.uuid;

	  if (initialOptions) {
	    newSection = _Object$assign({}, newSection, (0, _lodashLangCloneDeep2['default'])(initialOptions));
	  }

	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    content: {
	      sections: {
	        $splice: [[index + 1, 0, newSection]]
	      }
	    }
	  });
	}

	function updateSection(index, sectionUpdate) {
	  var sectionsUpdate = {};
	  sectionsUpdate[index] = sectionUpdate;

	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    content: {
	      sections: sectionsUpdate
	    }
	  });

	  if (index === 0) {
	    updateStampFromCoverSection();
	  }
	}

	function updateMediaSection(sectionId, data) {
	  var index = findSection(sectionId),
	      updateData = { $merge: data };

	  if (index > -1) {
	    updateSection(index, updateData);
	  }
	}

	function moveSection(sectionId, afterSectionId) {
	  var index = findSection(sectionId),
	      section = _stamp.content.sections[index],
	      afterIndex = findSection(afterSectionId);

	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    content: {
	      sections: {
	        $splice: [[index, 1], [afterIndex, 0, section]]
	      }
	    }
	  });
	}

	function deleteSection(sectionId) {
	  var index = findSection(sectionId);

	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    content: {
	      sections: {
	        $splice: [[index, 1]]
	      }
	    }
	  });
	}

	function addGalleryImage(afterSectionId, image) {
	  var index = findSection(afterSectionId),
	      section = _stamp.content.sections[index],
	      atIndex = section.images.length;

	  _lastAddedItemUuid = image.uuid;

	  updateSection(index, {
	    images: {
	      $splice: [[atIndex, 0, image]]
	    }
	  });
	}

	function updateGalleryImage(sectionId, imageId, data) {
	  var index = findSection(sectionId),
	      gallery = _stamp.content.sections[index],
	      imageIndex = findImage(gallery, imageId),
	      updateData;

	  updateData = { images: {} };
	  updateData.images[imageIndex] = {
	    $merge: data
	  };

	  updateSection(index, updateData);
	}

	function moveGalleryImage(sectionId, imageId, afterImageId) {
	  var index = findSection(sectionId),
	      gallery = _stamp.content.sections[index],
	      imageIndex = findImage(gallery, imageId),
	      image = gallery.images[imageIndex],
	      afterImageIndex = findImage(gallery, afterImageId);

	  updateSection(index, {
	    images: {
	      $splice: [[imageIndex, 1], [afterImageIndex, 0, image]]
	    }
	  });
	}

	function deleteGalleryImage(sectionId, imageId) {
	  var index = findSection(sectionId),
	      gallery = _stamp.content.sections[index],
	      imageIndex = findImage(gallery, imageId);

	  updateSection(index, {
	    images: {
	      $splice: [[imageIndex, 1]]
	    }
	  });
	}

	function setStatus(status) {
	  _stamp = (0, _reactLibUpdate2['default'])(_stamp, {
	    status: {
	      $set: status
	    }
	  });
	}

	var StampDraftStore = (0, _utilsPaginatedStoreUtils.createListStore)({
	  getSections: getSections,

	  getDraftStamp: function getDraftStamp() {
	    return _stamp;
	  },

	  isUnlisted: function isUnlisted() {
	    return _stamp && _stamp.status === _constantsStampStatus2['default'].UNLISTED || false;
	  },

	  getSectionIndex: function getSectionIndex(sectionId) {
	    return findSection(sectionId);
	  },

	  isEmpty: function isEmpty() {
	    if (!_stamp) {
	      return false;
	    }

	    var sections = getSections(),
	        coverSection = sections[0];

	    return !sections.length || sections.length === 1 && !coverSection.title && !coverSection.subtitle && !coverSection.background;
	  },

	  hasContentOtherThanCover: function hasContentOtherThanCover() {
	    return (0, _underscore.reject)(getSections(), _utilsIsSectionEmpty2['default']).length > 1;
	  },

	  hasUnsavedChanges: function hasUnsavedChanges() {
	    return _hasUnsavedChanges;
	  },

	  getMissingContentMessage: function getMissingContentMessage() {
	    var coverSection = getSections()[0],
	        isEmptyTitle = (0, _underscore.isEmpty)(coverSection.title),
	        isEmptyBackground = (0, _underscore.isEmpty)(coverSection.background);

	    if (isEmptyTitle && isEmptyBackground) {
	      return _constantsAlertTypes2['default'].EDITOR_COVER_TITLE_REQUIRED;
	    } else if (isEmptyTitle && !isEmptyBackground) {
	      return _constantsAlertTypes2['default'].EDITOR_TITLE_REQUIRED;
	    } else if (!isEmptyTitle && isEmptyBackground) {
	      return _constantsAlertTypes2['default'].EDITOR_COVER_REQUIRED;
	    } else if (!this.hasContentOtherThanCover()) {
	      return _constantsAlertTypes2['default'].EDITOR_ADD_MORE_CONTENT;
	    }
	  },

	  isReady: function isReady() {
	    return Boolean(_stamp);
	  },

	  isPublishing: function isPublishing() {
	    return _isPublishing;
	  },

	  isLoadingMedia: function isLoadingMedia(sectionId) {
	    return _loadingMedia[sectionId];
	  },

	  isLoadingMediaBackground: function isLoadingMediaBackground(sectionId) {
	    return _loadingMediaBackground[sectionId];
	  },

	  canPublish: function canPublish() {
	    return this.isReady() && !_isPublishing;
	  },

	  getDraftImages: function getDraftImages() {
	    if (!_stamp) {
	      return [];
	    }

	    return (0, _underscore.chain)(_stamp.content.sections).map(function (section) {
	      switch (section.type) {
	        case _constantsSectionTypes2['default'].COVER:
	        case _constantsSectionTypes2['default'].POSTER:
	        case _constantsSectionTypes2['default'].MEDIA:
	          return section.background;
	        case _constantsSectionTypes2['default'].GALLERY:
	          return section.images;
	      }
	    }).flatten().compact().value();
	  },

	  isLastAddedItem: function isLastAddedItem(uuid) {
	    return _lastAddedItemUuid === uuid;
	  },

	  getDrafts: function getDrafts() {
	    return this.getIds(_UserStore2['default'].getMe().id).map(_storesStampStore2['default'].get);
	  }
	});

	var handleListAction = (0, _utilsPaginatedStoreUtils.createListActionHandler)({
	  request: _constantsActionTypes2['default'].REQUEST_DRAFTS,
	  error: _constantsActionTypes2['default'].REQUEST_DRAFTS_ERROR,
	  success: _constantsActionTypes2['default'].REQUEST_DRAFTS_SUCCESS
	});

	_AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_storesStampStore2['default'].dispatchToken]);

	  var action = payload.action,
	      updateData,
	      list;

	  if (_UserStore2['default'].isAuthenticated()) {
	    list = StampDraftStore.getList();
	    handleListAction(action, list, StampDraftStore.emitChange);
	  }

	  switch (action.type) {
	    case _constantsActionTypes2['default'].INVALIDATE_DRAFTS:
	      StampDraftStore.invalidate();
	      break;

	    case _constantsActionTypes2['default'].SAVE_DRAFT_SUCCESS:
	      _hasUnsavedChanges = false;

	      if (!_stamp.uuid) {
	        _stamp.uuid = action.draftUuid;
	      }

	      if (!list.contains(action.draftUuid)) {
	        list.prepend(action.draftUuid);
	      }

	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].DELETE_DRAFT_SUCCESS:
	      list.remove(action.draftUuid);
	      loadDraft(null);
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].LOAD_EMPTY_DRAFT:
	      loadDraft(getInitialDraft());

	      // Remove this when we disable migrating legacy drafts:
	      if (!StampDraftStore.isEmpty()) {
	        markNeedsSave();
	      }

	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].LOAD_DRAFT_IN_EDITOR:
	      loadDraft(null);
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].LOAD_DRAFT_IN_EDITOR_SUCCESS:
	      loadDraft(_storesStampStore2['default'].get(action.draftUuid));
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].LOAD_STAMP_IN_EDITOR:
	      loadDraft(null);
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].LOAD_STAMP_IN_EDITOR_SUCCESS:
	      loadDraft(_storesStampStore2['default'].get(action.stampId));
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPDATE_STAMP:
	    case _constantsActionTypes2['default'].POST_STAMP:
	      _isPublishing = true;
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPDATE_STAMP_ERROR:
	    case _constantsActionTypes2['default'].POST_STAMP_ERROR:
	      _isPublishing = false;
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPDATE_STAMP_SUCCESS:
	    case _constantsActionTypes2['default'].POST_STAMP_SUCCESS:
	      _isPublishing = false;
	      list.remove(_stamp.uuid);
	      loadDraft(null);
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].CANVAS_ADD_SECTION:
	      addSection(action.sectionType, action.afterSectionId, action.initialOptions);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].CANVAS_UPDATE_SECTION:
	      updateData = { $merge: (0, _lodashLangCloneDeep2['default'])(action.data) };
	      updateSection(findSection(action.sectionId), updateData);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].CANVAS_MOVE_SECTION:
	      moveSection(action.sectionId, action.afterSectionId);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].CANVAS_DELETE_SECTION:
	      deleteSection(action.sectionId);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].GALLERY_ADD_IMAGE:
	      addGalleryImage(action.sectionId, action.image);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].GALLERY_UPDATE_IMAGE:
	      updateGalleryImage(action.sectionId, action.imageId, action.data);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].GALLERY_MOVE_IMAGE:
	      moveGalleryImage(action.sectionId, action.imageId, action.afterImageId);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].GALLERY_DELETE_IMAGE:
	      deleteGalleryImage(action.sectionId, action.imageId);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].REQUEST_MEDIA_DATA:
	      _loadingMedia[action.sectionId] = true;
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].REQUEST_MEDIA_DATA_SUCCESS:
	      delete _loadingMedia[action.sectionId];
	      updateMediaSection(action.sectionId, action.data);
	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].REQUEST_MEDIA_DATA_ERROR:
	      delete _loadingMedia[action.sectionId];
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPLOAD_MEDIA_THUMBNAIL:
	      _loadingMediaBackground[action.sectionId] = true;
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPLOAD_MEDIA_THUMBNAIL_ERROR:
	      delete _loadingMediaBackground[action.sectionId];
	      updateMediaSection(action.sectionId, {
	        background: null
	      });

	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].UPLOAD_MEDIA_THUMBNAIL_SUCCESS:
	      updateMediaSection(action.sectionId, {
	        background: (0, _lodashLangCloneDeep2['default'])(action.image)
	      });
	      delete _loadingMediaBackground[action.sectionId];

	      markNeedsSave();
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].DRAFT_RESET_LAST_ADDED_ITEM:
	      _lastAddedItemUuid = null;
	      StampDraftStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].DRAFT_SET_STATUS:
	      setStatus(action.status);
	      StampDraftStore.emitChange();
	      break;
	  }
	});

	module.exports = StampDraftStore;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(14);
	function assert(condition, msg1, msg2){
	  if(!condition)throw TypeError(msg2 ? msg1 + msg2 : msg1);
	}
	assert.def = $.assertDefined;
	assert.fn = function(it){
	  if(!$.isFunction(it))throw TypeError(it + ' is not a function!');
	  return it;
	};
	assert.obj = function(it){
	  if(!$.isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};
	assert.inst = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};
	module.exports = assert;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	(function() { module.exports = this["embeddedConfig"]; }());

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var NavigationActionCreators = __webpack_require__(558);
	var NavigationContextTypes = __webpack_require__(51);
	var PageControlsActionCreators = __webpack_require__(560);
	var PageControlsTypes = __webpack_require__(94);
	var PlayerActionCreators = __webpack_require__(84);
	var getFirstAudioSection = __webpack_require__(794);
	var createSideEffect = __webpack_require__(519);
	var _require = __webpack_require__(4);

	var values = _require.values;var PropTypes = React.PropTypes;

	var AppContext = createSideEffect(function (propsList) {
	  var props = propsList[propsList.length - 1] || {};

	  if (props.navigationContextType) {
	    NavigationActionCreators.setContext(props.navigationContextType, props.navigationContextOptions);
	  } else {
	    NavigationActionCreators.clearContext();
	  }

	  if (props.pageControlsType) {
	    PageControlsActionCreators.showPageControls(props.pageControlsType, props.pageControlsOptions);
	  } else {
	    PageControlsActionCreators.hidePageControls();
	  }

	  if (props.activeStamp) {
	    var firstAudioSection = getFirstAudioSection(props.activeStamp);
	    if (firstAudioSection) {
	      PlayerActionCreators.considerSetStickyMedia(firstAudioSection.uuid);
	    } else {
	      PlayerActionCreators.considerRemoveStickyMedia();
	    }
	  } else {
	    PlayerActionCreators.considerRemoveStickyMedia();
	  }
	}, {
	  displayName: 'AppContext',

	  propTypes: {
	    navigationContextType: PropTypes.oneOf(values(NavigationContextTypes)),
	    navigationContextOptions: PropTypes.object,
	    pageControlsType: PropTypes.oneOf(values(PageControlsTypes)),
	    pageControlsOptions: PropTypes.object,
	    activeStamp: PropTypes.object
	  }
	});

	module.exports = AppContext;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ReactDocumentTitle = __webpack_require__(1073),
	    PureRenderMixin = __webpack_require__(2);

	var DocumentTitle = React.createClass({
	  displayName: 'DocumentTitle',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    var title = this.props.title;
	    if (!title) {
	      title = 'Stampsy';
	    } else {
	      title += ' · Stampsy';
	    }

	    return React.createElement(
	      ReactDocumentTitle,
	      { title: title },
	      this.props.children
	    );
	  }
	});

	module.exports = DocumentTitle;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Link = __webpack_require__(21);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var UserLink = React.createClass({
	  displayName: 'UserLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    user: PropTypes.object.isRequired,
	    showTitle: PropTypes.bool,
	    className: PropTypes.string,
	    target: PropTypes.oneOf(['_blank']),
	    bold: PropTypes.bool,
	    underline: PropTypes.string
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      bold: true
	    };
	  },

	  getLinkTitle: function getLinkTitle() {
	    if (!this.props.showTitle) {
	      return;
	    }

	    return this.props.user.name;
	  },

	  render: function render() {
	    var name = this.props.user.name,
	        title = this.getLinkTitle();

	    return React.createElement(
	      Link,
	      { className: this.props.className,
	        to: 'user',
	        params: { userId: this.props.user.id },
	        target: this.props.target,
	        title: title,
	        underline: this.props.underline,
	        bold: this.props.bold },
	      this.props.children || name
	    );
	  }
	});

	module.exports = UserLink;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  VIDEO: null,
	  AUDIO_TRACK: null,
	  AUDIO_PLAYLIST: null
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ScreenSizeStore = __webpack_require__(121);

	var ScreenSizeMixin = {
	  getInitialState: function getInitialState() {
	    return this.getScreenSizeState();
	  },

	  getScreenSize: function getScreenSize() {
	    return ScreenSizeStore.getScreenSize();
	  },

	  getScreenSizeState: function getScreenSizeState() {
	    return {
	      isMobile: ScreenSizeStore.isMobile(),
	      isTablet: ScreenSizeStore.isTablet(),
	      isDesktop: ScreenSizeStore.isDesktop(),
	      screenSize: ScreenSizeStore.getScreenSize()
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    ScreenSizeStore.addChangeListener(this.handleScreenSizeChange);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    ScreenSizeStore.removeChangeListener(this.handleScreenSizeChange);
	  },

	  handleScreenSizeChange: function handleScreenSizeChange() {
	    this.setState(this.getScreenSizeState());
	  }
	};

	module.exports = ScreenSizeMixin;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(14)
	  , TAG      = __webpack_require__(73)('toStringTag')
	  , toString = {}.toString;
	function cof(it){
	  return toString.call(it).slice(8, -1);
	}
	cof.classof = function(it){
	  var O, T;
	  return it == undefined ? it === undefined ? 'Undefined' : 'Null'
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T : cof(O);
	};
	cof.set = function(it, tag, stat){
	  if(it && !$.has(it = stat ? it : it.prototype, TAG))$.hide(it, TAG, tag);
	};
	module.exports = cof;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14).g
	  , store  = __webpack_require__(312)('wks');
	module.exports = function(name){
	  return store[name] || (store[name] =
	    global.Symbol && global.Symbol[name] || __webpack_require__(87).safe('Symbol.' + name));
	};

/***/ },
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */

	'use strict';

	var ReactComponent = __webpack_require__(524);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactElement = __webpack_require__(31);
	var ReactErrorUtils = __webpack_require__(1125);
	var ReactInstanceMap = __webpack_require__(160);
	var ReactLifeCycle = __webpack_require__(372);
	var ReactPropTypeLocations = __webpack_require__(373);
	var ReactPropTypeLocationNames = __webpack_require__(239);
	var ReactUpdateQueue = __webpack_require__(375);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);
	var keyMirror = __webpack_require__(24);
	var keyOf = __webpack_require__(76);
	var warning = __webpack_require__(26);

	var MIXINS_KEY = keyOf({mixins: null});

	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});


	var injectedMixins = [];

	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {

	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,

	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,

	  // ==== Definition methods ====

	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,



	  // ==== Delegate methods ====

	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,



	  // ==== Advanced methods ====

	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE

	};

	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function(Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function(Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function(Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        childContextTypes,
	        ReactPropTypeLocations.childContext
	      );
	    }
	    Constructor.childContextTypes = assign(
	      {},
	      Constructor.childContextTypes,
	      childContextTypes
	    );
	  },
	  contextTypes: function(Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        contextTypes,
	        ReactPropTypeLocations.context
	      );
	    }
	    Constructor.contextTypes = assign(
	      {},
	      Constructor.contextTypes,
	      contextTypes
	    );
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function(Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(
	        Constructor.getDefaultProps,
	        getDefaultProps
	      );
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function(Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        propTypes,
	        ReactPropTypeLocations.prop
	      );
	    }
	    Constructor.propTypes = assign(
	      {},
	      Constructor.propTypes,
	      propTypes
	    );
	  },
	  statics: function(Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  }
	};

	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      (false ? warning(
	        typeof typeDef[propName] === 'function',
	        '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	        'React.PropTypes.',
	        Constructor.displayName || 'ReactClass',
	        ReactPropTypeLocationNames[location],
	        propName
	      ) : null);
	    }
	  }
	}

	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ?
	    ReactClassInterface[name] :
	    null;

	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    (false ? invariant(
	      specPolicy === SpecPolicy.OVERRIDE_BASE,
	      'ReactClassInterface: You are attempting to override ' +
	      '`%s` from your class specification. Ensure that your method names ' +
	      'do not overlap with React methods.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.OVERRIDE_BASE));
	  }

	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    (false ? invariant(
	      specPolicy === SpecPolicy.DEFINE_MANY ||
	      specPolicy === SpecPolicy.DEFINE_MANY_MERGED,
	      'ReactClassInterface: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be due ' +
	      'to a mixin.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.DEFINE_MANY ||
	    specPolicy === SpecPolicy.DEFINE_MANY_MERGED));
	  }
	}

	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }

	  (false ? invariant(
	    typeof spec !== 'function',
	    'ReactClass: You\'re attempting to ' +
	    'use a component class as a mixin. Instead, just use a regular object.'
	  ) : invariant(typeof spec !== 'function'));
	  (false ? invariant(
	    !ReactElement.isValidElement(spec),
	    'ReactClass: You\'re attempting to ' +
	    'use a component as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactElement.isValidElement(spec)));

	  var proto = Constructor.prototype;

	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }

	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }

	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above
	      continue;
	    }

	    var property = spec[name];
	    validateMethodOverride(proto, name);

	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod =
	        ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var markedDontBind = property && property.__reactDontBind;
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind =
	        isFunction &&
	        !isReactClassMethod &&
	        !isAlreadyDefined &&
	        !markedDontBind;

	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];

	          // These cases should already be caught by validateMethodOverride
	          (false ? invariant(
	            isReactClassMethod && (
	              (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	            ),
	            'ReactClass: Unexpected spec policy %s for key %s ' +
	            'when mixing in component specs.',
	            specPolicy,
	            name
	          ) : invariant(isReactClassMethod && (
	            (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	          )));

	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}

	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }

	    var isReserved = name in RESERVED_SPEC_KEYS;
	    (false ? invariant(
	      !isReserved,
	      'ReactClass: You are attempting to define a reserved ' +
	      'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	      'as an instance property instead; it will still be accessible on the ' +
	      'constructor.',
	      name
	    ) : invariant(!isReserved));

	    var isInherited = name in Constructor;
	    (false ? invariant(
	      !isInherited,
	      'ReactClass: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be ' +
	      'due to a mixin.',
	      name
	    ) : invariant(!isInherited));
	    Constructor[name] = property;
	  }
	}

	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  (false ? invariant(
	    one && two && typeof one === 'object' && typeof two === 'object',
	    'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	  ) : invariant(one && two && typeof one === 'object' && typeof two === 'object'));

	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      (false ? invariant(
	        one[key] === undefined,
	        'mergeIntoWithNoDuplicateKeys(): ' +
	        'Tried to merge two objects with the same key: `%s`. This conflict ' +
	        'may be due to a mixin; in particular, this may be caused by two ' +
	        'getInitialState() or getDefaultProps() methods returning objects ' +
	        'with clashing keys.',
	        key
	      ) : invariant(one[key] === undefined));
	      one[key] = two[key];
	    }
	  }
	  return one;
	}

	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}

	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}

	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function(newThis ) {for (var args=[],$__0=1,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): React component methods may only be bound to the ' +
	          'component instance. See %s',
	          componentName
	        ) : null);
	      } else if (!args.length) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): You are binding a component method to the component. ' +
	          'React does this for you automatically in a high-performance ' +
	          'way, so you can safely remove this call. See %s',
	          componentName
	        ) : null);
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}

	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(
	        component,
	        ReactErrorUtils.guard(
	          method,
	          component.constructor.displayName + '.' + autoBindKey
	        )
	      );
	    }
	  }
	}

	var typeDeprecationDescriptor = {
	  enumerable: false,
	  get: function() {
	    var displayName = this.displayName || this.name || 'Component';
	    (false ? warning(
	      false,
	      '%s.type is deprecated. Use %s directly to access the class.',
	      displayName,
	      displayName
	    ) : null);
	    Object.defineProperty(this, 'type', {
	      value: this
	    });
	    return this;
	  }
	};

	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {

	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function(newState, callback) {
	    ReactUpdateQueue.enqueueReplaceState(this, newState);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },

	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function() {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          owner._warnedAboutRefsInRender,
	          '%s is accessing isMounted inside its render() function. ' +
	          'render() should be a pure function of props and state. It should ' +
	          'never access something that requires stale data from the previous ' +
	          'render, such as refs. Move this logic to componentDidMount and ' +
	          'componentDidUpdate instead.',
	          owner.getName() || 'A component'
	        ) : null);
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(this);
	    return (
	      internalInstance &&
	      internalInstance !== ReactLifeCycle.currentlyMountingInstance
	    );
	  },

	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function(partialProps, callback) {
	    ReactUpdateQueue.enqueueSetProps(this, partialProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },

	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function(newProps, callback) {
	    ReactUpdateQueue.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  }
	};

	var ReactClassComponent = function() {};
	assign(
	  ReactClassComponent.prototype,
	  ReactComponent.prototype,
	  ReactClassMixin
	);

	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {

	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function(spec) {
	    var Constructor = function(props, context) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.

	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	          'JSX instead. See: http://fb.me/react-legacyfactory'
	        ) : null);
	      }

	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }

	      this.props = props;
	      this.context = context;
	      this.state = null;

	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.

	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' &&
	            this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      (false ? invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));

	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;

	    injectedMixins.forEach(
	      mixSpecIntoComponent.bind(null, Constructor)
	    );

	    mixSpecIntoComponent(Constructor, spec);

	    // Initialize the defaultProps property after all mixins have been merged
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }

	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }

	    (false ? invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    ) : invariant(Constructor.prototype.render));

	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        spec.displayName || 'A component'
	      ) : null);
	    }

	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }

	    // Legacy hook
	    Constructor.type = Constructor;
	    if (false) {
	      try {
	        Object.defineProperty(Constructor, 'type', typeDeprecationDescriptor);
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }

	    return Constructor;
	  },

	  injection: {
	    injectMixin: function(mixin) {
	      injectedMixins.push(mixin);
	    }
	  }

	};

	module.exports = ReactClass;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */

	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without loosing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};


	module.exports = keyOf;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55),
	    NavigationStore = __webpack_require__(422),
	    NavigationContextTypes = __webpack_require__(51),
	    ModalTypes = __webpack_require__(58),
	    invariant = __webpack_require__(11),
	    assign = __webpack_require__(15);

	function getAnalyticsEventId(modalId) {
	  switch (modalId) {
	    case ModalTypes.ABOUT:
	      return AnalyticsEvents.FORMS_ABOUT_SHOW;
	    case ModalTypes.SIGNUP:
	      return AnalyticsEvents.FORMS_SIGNUP_SHOW;
	    case ModalTypes.LOGIN:
	      return AnalyticsEvents.FORMS_LOGIN_SHOW;
	    case ModalTypes.FINISH_SIGNUP:
	      return AnalyticsEvents.FORMS_FINISH_SIGNUP_SHOW;
	    case ModalTypes.SEND_INVITE:
	      return AnalyticsEvents.FORMS_SEND_INVITE_SHOW;
	    case ModalTypes.FEEDBACK:
	      return AnalyticsEvents.FORMS_FEEDBACK_SHOW;
	    case ModalTypes.EDITOR_HELP:
	      return AnalyticsEvents.EDITOR_HELP_SHOW;
	  }
	}

	var ModalActionCreators = {
	  showModal: function showModal(id, options) {
	    invariant(ModalTypes.hasOwnProperty(id), 'showModal() accepts a constant from ModalTypes. You passed %s', id);

	    var isInAbout = NavigationStore.isActive(NavigationContextTypes.ABOUT);
	    if (isInAbout && id === ModalTypes.ABOUT) {
	      id = ModalTypes.SIGNUP;
	    }

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_MODAL,
	      modal: assign({ id: id }, options)
	    });

	    var eventId = getAnalyticsEventId(id),
	        source = options && options.source;

	    if (eventId) {
	      Analytics.trackGAEvent(eventId, source);
	      Analytics.trackEvent(eventId, {
	        source: source
	      });
	    }
	  },

	  hideModal: function hideModal(id) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_MODAL,
	      modal: { id: id }
	    });
	  }
	};

	module.exports = ModalActionCreators;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibKeyMirror = __webpack_require__(24);

	var _reactLibKeyMirror2 = _interopRequireDefault(_reactLibKeyMirror);

	'use strict';

	exports['default'] = (0, _reactLibKeyMirror2['default'])({
	  UNSUPPORTED_BROWSER: null,

	  STAMP_SUBMITTED_TO_ZINE: null,
	  STAMP_APPROVED_TO_ZINE: null,
	  STAMP_DECLINED_FROM_ZINE: null,
	  STAMP_HAS_BEEN_SAVED: null,
	  STAMP_HAS_BEEN_DELETED: null,

	  ZINE_CREATED: null,
	  ZINE_SAVED: null,
	  ZINE_DELETED: null,
	  ZINE_FOLLOWED: null,

	  YOU_CAN_CONTRIBUTE_TO_ZINE: null,
	  ACCOUNT_CONNECTED: null,

	  INVITE_SENT: null,
	  INVITE_SENT_ERROR: null,

	  PASSWORD_RESET_CHECK_EMAIL: null,
	  PASSWORD_RESET_DONE: null,

	  USER_FIRST_EMAIL_NEEDS_CONFIRMATION: null,
	  USER_NEW_EMAIL_NEEDS_CONFIRMATION: null,
	  USER_EMAIL_RESENT: null,
	  USER_EMAIL_CHANGE_CANCELED: null,
	  USER_FOLLOWED: null,

	  EMAIL_CONFIRMED: null,

	  DASHBOARD_COLLECTION_LEARN_MORE: null,
	  DASHBOARD_MESSAGE_DECLINED_LEARN_MORE: null,

	  WELCOME_FOLLOW_ZINES: null,

	  FEEDBACK_SENT: null,

	  EMAIL_UNSUBSCRIBE: null,
	  EMAIL_RESUBSCRIBED: null,
	  EMAIL_UNSUBSCRIBE_ZINE: null,

	  INVITATION_ALREADY_USED: null,
	  INVITATION_FOR_OTHER_USER: null,

	  IMAGE_ADDED_TO_GRABBAG: null,

	  DRAFT_FEEDBACK_SENT: null
	});
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    FormLink = __webpack_require__(148),
	    noop = __webpack_require__(220),
	    mapValues = __webpack_require__(449),
	    FormStore = __webpack_require__(208),
	    FormActionCreators = __webpack_require__(388),
	    FormStates = __webpack_require__(398);

	var FormMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      formMessages: {},
	      firstErrorKey: null,
	      formState: FormStates.EDITABLE_STATE
	    };
	  },

	  handleFormStoreChanged: function handleFormStoreChanged() {
	    if (this.isMounted()) {
	      this.setState({
	        formMessages: FormStore.getActiveMessages(),
	        firstErrorKey: FormStore.getFirstErrorKey(),
	        formState: FormStore.getFormState()
	      });
	    }
	  },

	  componentWillMount: function componentWillMount() {
	    this._linkedValidators = {};
	    this._pendingMessages = {};

	    FormStore.addChangeListener(this.handleFormStoreChanged);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this._linkedValidators = null;
	    this._pendingMessages = null;

	    FormStore.removeChangeListener(this.handleFormStoreChanged);
	  },

	  isFormEditable: function isFormEditable() {
	    return FormStore.getFormState() === FormStates.EDITABLE_STATE;
	  },

	  isFormSubmitting: function isFormSubmitting() {
	    return FormStore.getFormState() === FormStates.SUBMITTING_STATE;
	  },

	  isFormSubmitted: function isFormSubmitted() {
	    return FormStore.getFormState() === FormStates.SUBMITTED_STATE;
	  },

	  isFormValid: function isFormValid(options) {
	    var allKeys = _.keys(this._linkedValidators);
	    this.validateFields(allKeys, options);

	    return !FormStore.getFirstErrorKey();
	  },

	  submitForm: function submitForm(sendRequest) {
	    if (!this.isFormEditable()) {
	      console.warn('Form can only be submitted when in editable state.');
	      return;
	    }

	    var isFormValid = this.isFormValid({
	      showError: true,
	      event: 'submit'
	    });

	    if (!isFormValid) {
	      console.warn('Form is invalid.');
	      return;
	    }

	    FormActionCreators.submitForm();

	    sendRequest();
	  },

	  linkState: function linkState(key) {
	    return this.linkValidatedState(key, noop);
	  },

	  linkValidatedState: function linkValidatedState(key, validator) {
	    this._linkedValidators[key] = validator;

	    var newState = {},
	        requestChange,
	        validateField;

	    requestChange = (function (value, callback) {
	      newState[key] = value;
	      this.setState(newState, callback);

	      FormActionCreators.valueChanged(key, value);
	    }).bind(this);

	    validateField = (function (options) {
	      this.validateFields([key], options);
	    }).bind(this);

	    return new FormLink({
	      value: this.state[key],
	      fieldMessage: this.state.formMessages[key],
	      isFirstError: key === this.state.firstErrorKey,
	      hasFormError: !!this.state.formError,
	      requestChange: requestChange,
	      validateField: validateField
	    });
	  },

	  validateFields: function validateFields(keys, options) {
	    var newMessages;

	    newMessages = this._getClientFieldMessages(keys, options);
	    FormActionCreators.showMessages(newMessages);
	  },

	  isEnterKey: function isEnterKey(e) {
	    var ENTER_KEY = 13;
	    return e.keyCode === ENTER_KEY;
	  },

	  _getClientFieldMessages: function _getClientFieldMessages(keys, options) {
	    var fieldResults = this._runClientValidators(keys, options);

	    return mapValues(fieldResults, function (result) {
	      if (!result) {
	        return;
	      }

	      if (options.showError && result.error) {
	        return {
	          message: result.error,
	          isError: true
	        };
	      }

	      if (options.showHelp && result.help) {
	        return {
	          message: result.help,
	          isError: false
	        };
	      }

	      if (result.permanentHelp) {
	        return {
	          message: result.permanentHelp,
	          isError: false
	        };
	      }
	    });
	  },

	  _runClientValidators: function _runClientValidators(keys, options) {
	    var validators = this._linkedValidators,
	        state = this.state;

	    return _.object(keys.map(function (key) {
	      var validator = validators[key],
	          value = state[key],
	          result = validator(value, options);

	      return [key, result];
	    }));
	  }
	};

	module.exports = FormMixin;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _actionsContextMenuActionCreators = __webpack_require__(111);

	var _actionsContextMenuActionCreators2 = _interopRequireDefault(_actionsContextMenuActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	__webpack_require__(933);

	'use strict';

	var MENU_MARGIN = 8;

	var Separator = _react2['default'].createClass({
	  displayName: 'Separator',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  statics: {
	    IS_SEPARATOR: true
	  },

	  className: 'ContextMenu-separator',

	  render: function render() {
	    return _react2['default'].createElement('div', { className: this.getClassName() });
	  }
	});

	var ContextMenu = _react2['default'].createClass({
	  displayName: 'ContextMenu',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  statics: {
	    Separator: Separator
	  },

	  propTypes: {
	    anchorRect: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      right: _react.PropTypes.number.isRequired,
	      bottom: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired,
	      width: _react.PropTypes.number.isRequired,
	      height: _react.PropTypes.number.isRequired
	    }).isRequired
	  },

	  className: 'ContextMenu',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      theme: 'dark'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.theme];
	  },

	  getMenuRect: function getMenuRect() {
	    var anchorRect = this.props.anchorRect,
	        menuRect;

	    menuRect = {
	      right: window.innerWidth - anchorRect.right
	    };

	    if (anchorRect.top + anchorRect.height / 2 < window.innerHeight / 2) {
	      menuRect.top = anchorRect.bottom + MENU_MARGIN;
	    } else {
	      menuRect.bottom = window.innerHeight - anchorRect.top + MENU_MARGIN;
	    }

	    return menuRect;
	  },

	  render: function render() {
	    var style = this.getMenuRect();

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style },
	      _react2['default'].Children.map(this.props.children, this.renderContextMenuItem)
	    );
	  },

	  renderContextMenuItem: function renderContextMenuItem(item, index) {
	    if (!item) {
	      return;
	    }

	    if (item.type.IS_SEPARATOR) {
	      return item;
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: 'ContextMenu-item',
	        onClick: this.handleContextMenuItemClick,
	        key: index },
	      item
	    );
	  },

	  handleContextMenuItemClick: function handleContextMenuItemClick() {
	    _actionsContextMenuActionCreators2['default'].hideContextMenu();
	  }
	});

	exports['default'] = ContextMenu;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(960);

	var Container = React.createClass({
	  displayName: 'Container',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    color: PropTypes.oneOf(['dark', 'light']),
	    style: PropTypes.object
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.color, this.props.fillParent && 'fillParent'];
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'dark',
	      fillParent: true
	    };
	  },

	  className: 'Container',

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: this.props.style },
	      this.props.children
	    );
	  } });

	module.exports = Container;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibReactBrowserEventEmitter = __webpack_require__(140);

	var _reactLibReactBrowserEventEmitter2 = _interopRequireDefault(_reactLibReactBrowserEventEmitter);

	var _reactLibViewportMetrics = __webpack_require__(242);

	var _reactLibViewportMetrics2 = _interopRequireDefault(_reactLibViewportMetrics);

	var _reactLibGetUnboundedScrollPosition = __webpack_require__(541);

	var _reactLibGetUnboundedScrollPosition2 = _interopRequireDefault(_reactLibGetUnboundedScrollPosition);

	'use strict';

	var scrollPosition = (0, _reactLibGetUnboundedScrollPosition2['default'])(window);

	_reactLibReactBrowserEventEmitter2['default'].ensureScrollValueMonitoring();
	_reactLibViewportMetrics2['default'].refreshScrollValues(scrollPosition);

	function getScrollY() {
	  return _reactLibViewportMetrics2['default'].currentScrollTop;
	}

	exports['default'] = getScrollY;
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function isBestOf2014Special(zineOrSlug) {
	  if (!zineOrSlug) {
	    return false;
	  }

	  if (zineOrSlug.slug) {
	    zineOrSlug = zineOrSlug.slug;
	  }

	  return zineOrSlug === 'best-of-2014';
	}

	module.exports = isBestOf2014Special;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    flushUpdates = __webpack_require__(436);

	var PlayerActionCreators = {
	  play: function play(mediaId, options) {
	    flushUpdates(function () {
	      AppDispatcher.handleViewAction({
	        type: ActionTypes.PLAYER_PLAY,
	        mediaId: mediaId,
	        options: options
	      });
	    });
	  },

	  playPrevious: function playPrevious(mediaId) {
	    flushUpdates(function () {
	      AppDispatcher.handleViewAction({
	        type: ActionTypes.PLAYER_PLAY_PREVIOUS,
	        mediaId: mediaId
	      });
	    });
	  },

	  playNext: function playNext(mediaId) {
	    flushUpdates(function () {
	      AppDispatcher.handleViewAction({
	        type: ActionTypes.PLAYER_PLAY_NEXT,
	        mediaId: mediaId
	      });
	    });
	  },

	  pause: function pause(mediaId) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_PAUSE,
	      mediaId: mediaId
	    });
	  },

	  setCurrentTime: function setCurrentTime(mediaId, time) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_SET_CURRENT_TIME,
	      mediaId: mediaId,
	      time: time
	    });
	  },

	  registerAudio: function registerAudio(mediaId, options) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_REGISTER_AUDIO,
	      mediaId: mediaId,
	      options: options
	    });
	  },

	  unregisterAudio: function unregisterAudio(mediaId) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_UNREGISTER_AUDIO,
	      mediaId: mediaId
	    });
	  },

	  considerSetStickyMedia: function considerSetStickyMedia(mediaId, options) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_CONSIDER_SET_STICKY_MEDIA,
	      mediaId: mediaId,
	      options: options
	    });
	  },

	  considerRemoveStickyMedia: function considerRemoveStickyMedia(force) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.PLAYER_CONSIDER_REMOVE_STICKY_MEDIA,
	      force: force
	    });
	  }
	};

	module.exports = PlayerActionCreators;

/***/ },
/* 85 */,
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ImageQueueMixin = __webpack_require__(406),
	    ResponsiveImageMixin = __webpack_require__(678);

	/**
	 * Manages state of a sequential image queue.
	 * Define `getImageSizes` to specify image sizes for media queries.
	 *
	 * Use `ImageQueueMixin` instead if you need fine control
	 * over requested width and if you are not content with
	 * specifying widths for different @media-* queries, or use
	 * `FlexibleImageQueueMixin` if you want the requested width
	 * to match DOM element's offsetWidth.
	 */
	var ResponsiveImageQueueMixin = {
	  mixins: [ImageQueueMixin, ResponsiveImageMixin],

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.imageSize !== this.state.imageSize) {
	      this.updateImageQueue();
	    }
	  },

	  getNormalImageSize: function getNormalImageSize() {
	    return {
	      width: this.state.imageSize
	    };
	  }
	};

	module.exports = ResponsiveImageQueueMixin;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var sid = 0;
	function uid(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++sid + Math.random()).toString(36));
	}
	uid.safe = __webpack_require__(14).g.Symbol || uid;
	module.exports = uid;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Used as the maximum length of an array-like value.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * for more details.
	 */
	var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on ES `ToLength`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	 * for more details.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	module.exports = isLength;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */

	function makeEmptyFunction(arg) {
	  return function() {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function() { return this; };
	emptyFunction.thatReturnsArgument = function(arg) { return arg; };

	module.exports = emptyFunction;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    NotificationMessages = __webpack_require__(78),
	    NotificationStore = __webpack_require__(423),
	    assign = __webpack_require__(15),
	    invariant = __webpack_require__(11),
	    _ = __webpack_require__(4);

	var _hideTimeouts = [];

	function findTimeouts(id, created) {
	  return _.filter(_hideTimeouts, function (n) {
	    return n.id === id && (!created || created === n.created);
	  });
	}

	function clearHideTimeout(id, created) {
	  var timeouts = findTimeouts(id, created);
	  _.each(timeouts, function (timeout) {
	    clearTimeout(timeout.timeoutId);
	  });
	  _hideTimeouts = _.difference(_hideTimeouts, timeouts);
	}

	function setHideTimeout(id, created) {
	  var duration = NotificationStore.getDuration(id);

	  if (duration) {
	    var timeoutId = setTimeout(function () {
	      AppDispatcher.handleViewAction({
	        type: ActionTypes.HIDE_NOTIFICATION,
	        id: id,
	        created: created
	      });
	    }, duration);

	    _hideTimeouts.push({
	      id: id,
	      timeoutId: timeoutId,
	      created: created
	    });
	  }
	}

	var NotificationActionCreators = {
	  showNotification: function showNotification(id, options) {
	    invariant(NotificationMessages.hasOwnProperty(id), 'showNotification() accepts a constant from NotificationMessages. You passed %s', id);

	    var created = Date.now();

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_NOTIFICATION,
	      notification: assign({
	        id: id,
	        created: created
	      }, options)
	    });

	    setHideTimeout(id, created);
	  },

	  hideNotification: function hideNotification(id, created) {
	    clearHideTimeout(id, created);

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_NOTIFICATION,
	      id: id,
	      created: created
	    });
	  }
	};

	module.exports = NotificationActionCreators;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _utilsAnalytics = __webpack_require__(52);

	var _utilsAnalytics2 = _interopRequireDefault(_utilsAnalytics);

	var _constantsAnalyticsEvents = __webpack_require__(55);

	var _constantsAnalyticsEvents2 = _interopRequireDefault(_constantsAnalyticsEvents);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesServiceAccountStore = __webpack_require__(176);

	var _storesServiceAccountStore2 = _interopRequireDefault(_storesServiceAccountStore);

	var _constantsServiceTypes = __webpack_require__(35);

	var _constantsServiceTypes2 = _interopRequireDefault(_constantsServiceTypes);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _utilsGetQueryUrl = __webpack_require__(438);

	var _utilsGetQueryUrl2 = _interopRequireDefault(_utilsGetQueryUrl);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _utilsIsBestOf2014Special = __webpack_require__(83);

	var _utilsIsBestOf2014Special2 = _interopRequireDefault(_utilsIsBestOf2014Special);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	function openSharePopup(url) {
	  var width = 500,
	      height = 360,
	      left = screen.width / 2 - width / 2,
	      top = screen.height / 2 - height / 2;

	  return window.open(url, '_blank', 'status = 0, height = ' + height + ', width = ' + width + ', top=' + top + ', left=' + left);
	}

	function getHandleOrName(userId, service) {
	  var user = _storesUserStore2['default'].get(userId),
	      account = _storesServiceAccountStore2['default'].getByType(user.id, service),
	      handle = account && account.externalUsername;

	  if (userId === 1 && service === _constantsServiceTypes2['default'].TWITTER) {
	    // Even if user has not been fully loaded yet, hardcode the handle.
	    // Used on "Best of 2014" zine page sharing buttons.
	    handle = 'HelloStampsy';
	  }

	  return handle ? '@' + handle : user.name;
	}

	function getShareStampText(stamp, service) {
	  var stampTitle = stamp.title,
	      handleOrName = getHandleOrName(stamp.user, service);

	  switch (service) {
	    case _constantsServiceTypes2['default'].TWITTER:
	      return 'Have you Seen “' + stampTitle + '” by ' + handleOrName;
	    case _constantsServiceTypes2['default'].TUMBLR:
	      return 'Have you Seen “' + stampTitle + '” by ' + handleOrName + ' on https://stampsy.com';
	    case _constantsServiceTypes2['default'].PINTEREST:
	      return '“' + stampTitle + '” by ' + handleOrName;
	    default:
	      throw new Error('Not implemented for', service);
	  }
	}

	function getShareZineText(zine, service) {
	  var zineTitle = zine.title,
	      handleOrName = getHandleOrName(zine.curator, service);

	  switch (service) {
	    case _constantsServiceTypes2['default'].TWITTER:
	      return 'Check out “' + zineTitle + '” curated by ' + handleOrName;
	    default:
	      throw new Error('Not implemented for', service);
	  }
	}

	function getShareUserText(userId, service) {
	  var handleOrName = getHandleOrName(userId, service);

	  switch (service) {
	    case _constantsServiceTypes2['default'].TWITTER:
	      return 'Check out latest from ' + handleOrName + ' on Stampsy';
	    default:
	      throw new Error('Not implemented for', service);
	  }
	}

	function getStampUrl(stamp) {
	  switch (stamp.status) {
	    case _constantsStampStatus2['default'].UNLISTED:
	      return 'https://stampsy.com/stamp/' + stamp.uuid + '-' + stamp.id;
	    default:
	      return 'https://stampsy.com/stamp/' + stamp.id;
	  }
	}

	var ShareActionCreators = {
	  shareStamp: function shareStamp(_ref) {
	    var stampId = _ref.stampId;
	    var service = _ref.service;
	    var imageUrl = _ref.imageUrl;
	    var source = _ref.source;

	    var stamp = _storesStampStore2['default'].get(stampId),
	        url = getStampUrl(stamp),
	        shareUrl;

	    (0, _reactLibInvariant2['default'])(_constantsServiceTypes2['default'].hasOwnProperty(service), 'shareStamp() accepts a constant from ServiceTypes as service. You passed %s', service);

	    if (service === _constantsServiceTypes2['default'].PINTEREST && !imageUrl) {
	      _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].PINTEREST_PICKER, {
	        stampId: stampId
	      });
	      return;
	    }

	    switch (service) {
	      case _constantsServiceTypes2['default'].TWITTER:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//twitter.com/intent/tweet', {
	          'related': 'hellostampsy',
	          'text': getShareStampText(stamp, service),
	          'url': url,
	          'via': 'HelloStampsy'
	        });
	        break;
	      case _constantsServiceTypes2['default'].FACEBOOK:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//www.facebook.com/share.php', {
	          'u': url
	        });
	        break;
	      case _constantsServiceTypes2['default'].GOOGLE:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//plus.google.com/share', {
	          'url': url
	        });
	        break;
	      case _constantsServiceTypes2['default'].TUMBLR:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//tumblr.com/share/photo', {
	          'source': imageUrl || stamp.thumbnail.url,
	          'caption': getShareStampText(stamp, service),
	          'click_thru': url
	        });
	        break;
	      case _constantsServiceTypes2['default'].PINTEREST:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//www.pinterest.com/pin/create/button/', {
	          'url': url,
	          'description': getShareStampText(stamp, service),
	          'media': imageUrl
	        });
	        break;
	      default:
	        throw new Error('Unknown service');
	    }

	    openSharePopup(shareUrl);

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SHARE_STAMP,
	      stampId: stampId,
	      service: service,
	      imageUrl: imageUrl,
	      source: source
	    });

	    _utilsAnalytics2['default'].trackGAEvent(_constantsAnalyticsEvents2['default'].STAMP_SHARE, source);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].STAMP_SHARE, {
	      stampId: stampId,
	      service: service,
	      imageUrl: imageUrl,
	      source: source
	    });
	  },

	  shareZine: function shareZine(_ref2) {
	    var zineSlug = _ref2.zineSlug;
	    var service = _ref2.service;
	    var source = _ref2.source;

	    var zine = _storesZineStore2['default'].get(zineSlug),
	        url = 'https://stampsy.com/' + zineSlug,
	        shareUrl;

	    (0, _reactLibInvariant2['default'])(_constantsServiceTypes2['default'].hasOwnProperty(service), 'shareZine() accepts a constant from ServiceTypes as service. You passed %s', service);

	    switch (service) {
	      case _constantsServiceTypes2['default'].TWITTER:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//twitter.com/intent/tweet', {
	          'related': 'hellostampsy',
	          'text': getShareZineText(zine, service),
	          'url': url,
	          'via': (0, _utilsIsBestOf2014Special2['default'])(zine) ? null : 'HelloStampsy'
	        });
	        break;
	      case _constantsServiceTypes2['default'].FACEBOOK:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//www.facebook.com/share.php', {
	          'u': url
	        });
	        break;
	      case _constantsServiceTypes2['default'].GOOGLE:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//plus.google.com/share', {
	          'url': url
	        });
	        break;
	      default:
	        throw new Error('Unknown service');
	    }

	    openSharePopup(shareUrl);

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SHARE_ZINE,
	      zineSlug: zineSlug,
	      service: service,
	      source: source
	    });

	    _utilsAnalytics2['default'].trackGAEvent(_constantsAnalyticsEvents2['default'].ZINE_SHARE, source);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].ZINE_SHARE, {
	      source: source
	    });
	  },

	  shareUser: function shareUser(_ref3) {
	    var userId = _ref3.userId;
	    var service = _ref3.service;
	    var source = _ref3.source;

	    var url = 'https://stampsy.com/user/' + userId,
	        shareUrl;

	    (0, _reactLibInvariant2['default'])(_constantsServiceTypes2['default'].hasOwnProperty(service), 'shareUser() accepts a constant from ServiceTypes as service. You passed %s', service);

	    switch (service) {
	      case _constantsServiceTypes2['default'].TWITTER:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//twitter.com/intent/tweet', {
	          'related': 'hellostampsy',
	          'text': getShareUserText(userId, service),
	          'url': url,
	          'via': 'HelloStampsy'
	        });
	        break;
	      case _constantsServiceTypes2['default'].FACEBOOK:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//www.facebook.com/share.php', {
	          'u': url
	        });
	        break;
	      case _constantsServiceTypes2['default'].GOOGLE:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//plus.google.com/share', {
	          'url': url
	        });
	        break;
	      default:
	        throw new Error('Unknown service');
	    }

	    openSharePopup(shareUrl);

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SHARE_USER,
	      userId: userId,
	      service: service,
	      source: source
	    });

	    _utilsAnalytics2['default'].trackGAEvent(_constantsAnalyticsEvents2['default'].USER_SHARE, source);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].USER_SHARE, {
	      source: source
	    });
	  },

	  shareJoined: function shareJoined(_ref4) {
	    var service = _ref4.service;
	    var source = _ref4.source;

	    var me = _storesUserStore2['default'].getMe(),
	        url = 'https://stampsy.com',
	        shareUrl;

	    (0, _reactLibInvariant2['default'])(_constantsServiceTypes2['default'].hasOwnProperty(service), 'shareJoined() accepts a constant from ServiceTypes as service. You passed %s', service);

	    switch (service) {
	      case _constantsServiceTypes2['default'].TWITTER:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//twitter.com/intent/tweet', {
	          'related': 'hellostampsy',
	          'text': 'I’ve just joined Stampsy — a sharing platform for visual stories and inspiration. Check it out',
	          'url': url,
	          'via': 'HelloStampsy'
	        });
	        break;
	      case _constantsServiceTypes2['default'].FACEBOOK:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//www.facebook.com/share.php', {
	          'u': url + '/?ref=' + me.id
	        });
	        break;
	      case _constantsServiceTypes2['default'].GOOGLE:
	        shareUrl = (0, _utilsGetQueryUrl2['default'])('//plus.google.com/share', {
	          'url': url
	        });
	        break;
	      default:
	        throw new Error('Unknown service');
	    }

	    openSharePopup(shareUrl);

	    _AppDispatcher2['default'].handleViewAction({
	      type: _constantsActionTypes2['default'].SHARE_JOINED,
	      service: service,
	      source: source
	    });

	    _utilsAnalytics2['default'].trackGAEvent(_constantsAnalyticsEvents2['default'].USER_SHARE, source);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].USER_SHARE, {
	      source: source
	    });
	  }
	};

	module.exports = ShareActionCreators;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var FontLoader = __webpack_require__(780);
	var onlyChild = __webpack_require__(245);var PropTypes = React.PropTypes;

	var FontTest = React.createClass({
	  displayName: 'FontTest',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    family: PropTypes.oneOf(['minion-pro-condensed', 'playfair-display']),
	    test: PropTypes.string
	  },

	  componentDidMount: function componentDidMount() {
	    this.loadFontIfNeccessary();
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.test !== this.props.test) {
	      this.loadFontIfNeccessary();
	    }
	  },

	  loadFontIfNeccessary: function loadFontIfNeccessary() {
	    var _props = this.props;
	    var test = _props.test;
	    var family = _props.family;

	    if (test && family) {
	      FontLoader.ensureCanRenderString(test, family);
	    }
	  },

	  render: function render() {
	    return onlyChild(this.props.children);
	  }
	});

	module.exports = FontTest;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Link = __webpack_require__(21);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ZineLink = React.createClass({
	  displayName: 'ZineLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    zine: PropTypes.object.isRequired,
	    bold: PropTypes.bool,
	    showTitle: PropTypes.bool,
	    withEllipsis: PropTypes.bool,
	    className: PropTypes.string,
	    target: PropTypes.oneOf(['_blank'])
	  },

	  getLinkTitle: function getLinkTitle() {
	    if (!this.props.showTitle) {
	      return;
	    }

	    return this.props.zine.title;
	  },

	  render: function render() {
	    var title = this.getLinkTitle();

	    return React.createElement(
	      Link,
	      { className: this.props.className,
	        to: 'zine',
	        params: { zineSlug: this.props.zine.slug },
	        bold: this.props.bold,
	        target: this.props.target,
	        title: title,
	        underline: this.props.underline,
	        withEllipsis: this.props.withEllipsis },
	      this.props.children || this.props.zine.title
	    );
	  }
	});

	module.exports = ZineLink;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  STAMP: null,
	  STAMP_REVIEW: null,
	  ZINE: null,
	  ZINE_EDIT: null,
	  DRAFT_COMPOSE: null,
	  DRAFT_PREVIEW: null,
	  USER: null,
	  IMAGE: null,
	  DRAFT_FEEDBACK: null
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibKeyMirror = __webpack_require__(24);

	var _reactLibKeyMirror2 = _interopRequireDefault(_reactLibKeyMirror);

	exports['default'] = (0, _reactLibKeyMirror2['default'])({
	  PUBLIC: null,
	  UNLISTED: null,
	  DELETED: null
	});
	module.exports = exports['default'];

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ImageQueueMixin = __webpack_require__(406),
	    SizeMonitorMixin = __webpack_require__(679);

	/**
	 * Manages state of a sequential image queue.
	 * Uses element's own `offsetWidth` and `offsetHeight` to determine requested size.
	 *
	 * To avoid generating too many images, we round up
	 * height and width to the closest value divisible by passed `sizeStep`.
	 *
	 * Use `ResponsiveImageQueueMixin` instead if you need to only
	 * allow several @media-* steps, or use plain `ImageQueueMixin`
	 * if you need finer control over requested width.
	 */
	function createFlexibleImageQueueMixin(sizeStep) {
	  if (!sizeStep) {
	    throw new Error('Provide a minimal size delta. Use 1 for precise size, something larger to avoid too many versoins.');
	  }

	  return {
	    mixins: [ImageQueueMixin, SizeMonitorMixin],

	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.offsetWidth !== this.state.offsetWidth || prevState.offsetHeight !== this.state.offsetHeight) {

	        this.updateImageQueue();
	      }
	    },

	    getNormalImageSize: function getNormalImageSize() {
	      var _state = this.state;
	      var offsetWidth = _state.offsetWidth;
	      var offsetHeight = _state.offsetHeight;

	      if (!offsetWidth || !offsetHeight) {
	        return;
	      }

	      return {
	        width: sizeStep * Math.ceil(offsetWidth / sizeStep),
	        height: sizeStep * Math.ceil(offsetHeight / sizeStep)
	      };
	    }
	  };
	}

	module.exports = createFlexibleImageQueueMixin;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);
	var Footer = __webpack_require__(717);var PropTypes = React.PropTypes;

	__webpack_require__(967);

	var Page = React.createClass({
	  displayName: 'Page',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    background: PropTypes.string,
	    showFooter: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      showFooter: false
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: this.getStyle() },
	      this.props.children,
	      this.props.showFooter && React.createElement(Footer, null)
	    );
	  },

	  getStyle: function getStyle() {
	    if (this.props.background) {
	      return {
	        background: '#' + this.props.background
	      };
	    }
	  }
	});

	module.exports = Page;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function pluralize(n, singular, plural) {
	  return n === 1 ? singular : plural;
	}

	module.exports = pluralize;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(814), __esModule: true };

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(14)
	  , cof               = __webpack_require__(72)
	  , classof           = cof.classof
	  , assert            = __webpack_require__(65)
	  , assertObject      = assert.obj
	  , SYMBOL_ITERATOR   = __webpack_require__(73)('iterator')
	  , FF_ITERATOR       = '@@iterator'
	  , Iterators         = __webpack_require__(312)('iterators')
	  , IteratorPrototype = {};
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	setIterator(IteratorPrototype, $.that);
	function setIterator(O, value){
	  $.hide(O, SYMBOL_ITERATOR, value);
	  // Add iterator for FF iterator protocol
	  if(FF_ITERATOR in [])$.hide(O, FF_ITERATOR, value);
	}

	module.exports = {
	  // Safari has buggy iterators w/o `next`
	  BUGGY: 'keys' in [] && !('next' in [].keys()),
	  Iterators: Iterators,
	  step: function(done, value){
	    return {value: value, done: !!done};
	  },
	  is: function(it){
	    var O      = Object(it)
	      , Symbol = $.g.Symbol;
	    return (Symbol && Symbol.iterator || FF_ITERATOR) in O
	      || SYMBOL_ITERATOR in O
	      || $.has(Iterators, classof(O));
	  },
	  get: function(it){
	    var Symbol = $.g.Symbol
	      , getIter;
	    if(it != undefined){
	      getIter = it[Symbol && Symbol.iterator || FF_ITERATOR]
	        || it[SYMBOL_ITERATOR]
	        || Iterators[classof(it)];
	    }
	    assert($.isFunction(getIter), it, ' is not iterable!');
	    return assertObject(getIter.call(it));
	  },
	  set: setIterator,
	  create: function(Constructor, NAME, next, proto){
	    Constructor.prototype = $.create(proto || IteratorPrototype, {next: $.desc(1, next)});
	    cof.set(Constructor, NAME + ' Iterator');
	  }
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var $   = __webpack_require__(14)
	  , tpl = String({}.hasOwnProperty)
	  , SRC = __webpack_require__(87).safe('src')
	  , _toString = Function.toString;

	function $redef(O, key, val, safe){
	  if($.isFunction(val)){
	    var base = O[key];
	    $.hide(val, SRC, base ? String(base) : tpl.replace(/hasOwnProperty/, String(key)));
	    if(!('name' in val))val.name = key;
	  }
	  if(O === $.g){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    $.hide(O, key, val);
	  }
	}

	// add fake Function#toString for correct work wrapped methods / constructors
	// with methods similar to LoDash isNative
	$redef(Function.prototype, 'toString', function toString(){
	  return $.has(this, SRC) ? this[SRC] : _toString.call(this);
	});

	$.core.inspectSource = function(it){
	  return _toString.call(it);
	};

	module.exports = $redef;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(88),
	    isNative = __webpack_require__(103),
	    isObjectLike = __webpack_require__(188);

	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return (isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag) || false;
	};

	module.exports = isArray;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(1045),
	    isObjectLike = __webpack_require__(188);

	/** `Object#toString` result references. */
	var funcTag = '[object Function]';

	/** Used to detect host constructors (Safari > 5). */
	var reHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reNative = RegExp('^' +
	  escapeRegExp(objToString)
	  .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (objToString.call(value) == funcTag) {
	    return reNative.test(fnToString.call(value));
	  }
	  return (isObjectLike(value) && reHostCtor.test(value)) || false;
	}

	module.exports = isNative;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Checks if `value` is the language type of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * **Note:** See the [ES5 spec](https://es5.github.io/#x8) for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type == 'function' || (value && type == 'object') || false;
	}

	module.exports = isObject;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var assign = __webpack_require__(15);
	var ReactPropTypes = __webpack_require__(1).PropTypes;
	var Route = __webpack_require__(138);

	var PropTypes = assign({}, ReactPropTypes, {

	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) {
	      return new Error("<" + componentName + "> may not have a \"" + propName + "\" prop");
	    }
	  },

	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),

	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func

	});

	module.exports = PropTypes;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};

	var twoArgumentPooler = function(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};

	var threeArgumentPooler = function(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};

	var fiveArgumentPooler = function(a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};

	var standardReleaser = function(instance) {
	  var Klass = this;
	  (false ? invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  ) : invariant(instance instanceof Klass));
	  if (instance.destructor) {
	    instance.destructor();
	  }
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};

	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;

	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function(CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};

	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};

	module.exports = PooledClass;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */

	'use strict';

	var findDOMNode = __webpack_require__(535);

	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function() {
	    return findDOMNode(this);
	  }
	};

	module.exports = ReactBrowserComponentMixin;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */

	'use strict';

	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 *
	 * The depth indicate how many composite components are above this render level.
	 */
	var ReactCurrentOwner = {

	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null

	};

	module.exports = ReactCurrentOwner;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */

	'use strict';

	var DOMProperty = __webpack_require__(155);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactElement = __webpack_require__(31);
	var ReactElementValidator = __webpack_require__(193);
	var ReactEmptyComponent = __webpack_require__(371);
	var ReactInstanceHandles = __webpack_require__(159);
	var ReactInstanceMap = __webpack_require__(160);
	var ReactMarkupChecksum = __webpack_require__(529);
	var ReactPerf = __webpack_require__(141);
	var ReactReconciler = __webpack_require__(161);
	var ReactUpdateQueue = __webpack_require__(375);
	var ReactUpdates = __webpack_require__(63);

	var emptyObject = __webpack_require__(244);
	var containsNode = __webpack_require__(534);
	var getReactRootElementInContainer = __webpack_require__(1163);
	var instantiateReactComponent = __webpack_require__(381);
	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(383);
	var shouldUpdateReactComponent = __webpack_require__(384);
	var warning = __webpack_require__(26);

	var SEPARATOR = ReactInstanceHandles.SEPARATOR;

	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};

	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;

	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};

	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};

	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}

	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];

	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}

	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}

	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        (false ? invariant(
	          !isValid(cached, id),
	          'ReactMount: Two valid but unequal nodes with the same `%s`: %s',
	          ATTR_NAME, id
	        ) : invariant(!isValid(cached, id)));

	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }

	  return id;
	}

	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}

	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}

	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}

	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponent.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}

	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    (false ? invariant(
	      internalGetID(node) === id,
	      'ReactMount: Unexpected modification of `%s`',
	      ATTR_NAME
	    ) : invariant(internalGetID(node) === id));

	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }

	  return false;
	}

	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}

	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}

	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(
	    targetID,
	    findDeepestCachedAncestorImpl
	  );

	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}

	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup) {
	  var markup = ReactReconciler.mountComponent(
	    componentInstance, rootID, transaction, emptyObject
	  );
	  componentInstance._isTopLevel = true;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup);
	}

	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    shouldReuseMarkup) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  transaction.perform(
	    mountComponentIntoNode,
	    null,
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup
	  );
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}

	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,

	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function(container, renderCallback) {
	    renderCallback();
	  },

	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function(
	      prevComponent,
	      nextElement,
	      container,
	      callback) {
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }

	    ReactMount.scrollMonitor(container, function() {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });

	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] =
	        getReactRootElementInContainer(container);
	    }

	    return prevComponent;
	  },

	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function(nextComponent, container) {
	    (false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      '_registerComponent(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));

	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();

	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },

	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function(
	    nextElement,
	    container,
	    shouldReuseMarkup
	  ) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    (false ? warning(
	      ReactCurrentOwner.current == null,
	      '_renderNewRootComponent(): Render methods should be a pure function ' +
	      'of props and state; triggering nested component updates from ' +
	      'render is not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);

	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(
	      componentInstance,
	      container
	    );

	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.

	    ReactUpdates.batchedUpdates(
	      batchedMountComponentIntoNode,
	      componentInstance,
	      reactRootID,
	      container,
	      shouldReuseMarkup
	    );

	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] =
	        getReactRootElementInContainer(container);
	    }

	    return componentInstance;
	  },

	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function(nextElement, container, callback) {
	    (false ? invariant(
	      ReactElement.isValidElement(nextElement),
	      'React.render(): Invalid component element.%s',
	      (
	        typeof nextElement === 'string' ?
	          ' Instead of passing an element string, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        typeof nextElement === 'function' ?
	          ' Instead of passing a component class, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        // Check if it quacks like an element
	        nextElement != null && nextElement.props !== undefined ?
	          ' This may be caused by unintentionally loading two independent ' +
	          'copies of React.' :
	          ''
	      )
	    ) : invariant(ReactElement.isValidElement(nextElement)));

	    var prevComponent = instancesByReactRootID[getReactRootID(container)];

	    if (prevComponent) {
	      var prevElement = prevComponent._currentElement;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        return ReactMount._updateRootComponent(
	          prevComponent,
	          nextElement,
	          container,
	          callback
	        ).getPublicInstance();
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }

	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup =
	      reactRootElement && ReactMount.isRenderedByReact(reactRootElement);

	    if (false) {
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (ReactMount.isRenderedByReact(rootElementSibling)) {
	            ("production" !== process.env.NODE_ENV ? warning(
	              false,
	              'render(): Target node has markup rendered by React, but there ' +
	              'are unrelated nodes as well. This is most commonly caused by ' +
	              'white-space inserted around server-rendered markup.'
	            ) : null);
	            break;
	          }

	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }

	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;

	    var component = ReactMount._renderNewRootComponent(
	      nextElement,
	      container,
	      shouldReuseMarkup
	    ).getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },

	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into the supplied `container`.
	   *
	   * @param {function} constructor React component constructor.
	   * @param {?object} props Initial props of the component instance.
	   * @param {DOMElement} container DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  constructAndRenderComponent: function(constructor, props, container) {
	    var element = ReactElement.createElement(constructor, props);
	    return ReactMount.render(element, container);
	  },

	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into a container node identified by supplied `id`.
	   *
	   * @param {function} componentConstructor React component constructor
	   * @param {?object} props Initial props of the component instance.
	   * @param {string} id ID of the DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in the container node.
	   */
	  constructAndRenderComponentByID: function(constructor, props, id) {
	    var domNode = document.getElementById(id);
	    (false ? invariant(
	      domNode,
	      'Tried to get element with id of "%s" but it is not present on the page.',
	      id
	    ) : invariant(domNode));
	    return ReactMount.constructAndRenderComponent(constructor, props, domNode);
	  },

	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function(container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },

	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    (false ? warning(
	      ReactCurrentOwner.current == null,
	      'unmountComponentAtNode(): Render methods should be a pure function of ' +
	      'props and state; triggering nested component updates from render is ' +
	      'not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);

	    (false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'unmountComponentAtNode(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));

	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      return false;
	    }
	    ReactMount.unmountComponentFromNode(component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },

	  /**
	   * Unmounts a component and removes it from the DOM.
	   *
	   * @param {ReactComponent} instance React component instance.
	   * @param {DOMElement} container DOM element to unmount from.
	   * @final
	   * @internal
	   * @see {ReactMount.unmountComponentAtNode}
	   */
	  unmountComponentFromNode: function(instance, container) {
	    ReactReconciler.unmountComponent(instance);

	    if (container.nodeType === DOC_NODE_TYPE) {
	      container = container.documentElement;
	    }

	    // http://jsperf.com/emptying-a-node
	    while (container.lastChild) {
	      container.removeChild(container.lastChild);
	    }
	  },

	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function(id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];

	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ("production" !== process.env.NODE_ENV ? invariant(
	          // Call internalGetID here because getID calls isValid which calls
	          // findReactContainerForID (this function).
	          internalGetID(rootElement) === reactRootID,
	          'ReactMount: Root element ID differed from reactRootID.'
	        ) : invariant(// Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID));

	        var containerChild = container.firstChild;
	        if (containerChild &&
	            reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'ReactMount: Root element has been removed from its original ' +
	            'container. New container:', rootElement.parentNode
	          ) : null);
	        }
	      }
	    }

	    return container;
	  },

	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function(id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },

	  /**
	   * True if the supplied `node` is rendered by React.
	   *
	   * @param {*} node DOM Element to check.
	   * @return {boolean} True if the DOM Element appears to be rendered by React.
	   * @internal
	   */
	  isRenderedByReact: function(node) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      return false;
	    }
	    var id = ReactMount.getID(node);
	    return id ? id.charAt(0) === SEPARATOR : false;
	  },

	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function(node) {
	    var current = node;
	    while (current && current.parentNode !== current) {
	      if (ReactMount.isRenderedByReact(current)) {
	        return current;
	      }
	      current = current.parentNode;
	    }
	    return null;
	  },

	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function(ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;

	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;

	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;

	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;

	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.

	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }

	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }

	        child = child.nextSibling;
	      }

	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;

	        return targetChild;
	      }
	    }

	    firstChildren.length = 0;

	    (false ? invariant(
	      false,
	      'findComponentRoot(..., %s): Unable to find element. This probably ' +
	      'means the DOM was unexpectedly mutated (e.g., by the browser), ' +
	      'usually due to forgetting a <tbody> when using tables, nesting tags ' +
	      'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' +
	      'parent. ' +
	      'Try inspecting the child nodes of the element with React ID `%s`.',
	      targetID,
	      ReactMount.getID(ancestorNode)
	    ) : invariant(false));
	  },

	  _mountImageIntoNode: function(markup, container, shouldReuseMarkup) {
	    (false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'mountComponentIntoNode(...): Target container is not valid.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));

	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	        );
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME,
	          checksum
	        );

	        var diffIndex = firstDifferenceIndex(markup, rootMarkup);
	        var difference = ' (client) ' +
	          markup.substring(diffIndex - 20, diffIndex + 20) +
	          '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

	        (false ? invariant(
	          container.nodeType !== DOC_NODE_TYPE,
	          'You\'re trying to render a component to the document using ' +
	          'server rendering but the checksum was invalid. This usually ' +
	          'means you rendered a different component type or props on ' +
	          'the client from the one on the server, or your render() ' +
	          'methods are impure. React cannot handle this case due to ' +
	          'cross-browser quirks by rendering at the document root. You ' +
	          'should look for environment dependent code in your components ' +
	          'and ensure the props are the same client and server side:\n%s',
	          difference
	        ) : invariant(container.nodeType !== DOC_NODE_TYPE));

	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'React attempted to reuse markup in a container but the ' +
	            'checksum was invalid. This generally means that you are ' +
	            'using server rendering and the markup generated on the ' +
	            'server was not what the client was expecting. React injected ' +
	            'new markup to compensate which works but you have lost many ' +
	            'of the benefits of server rendering. Instead, figure out ' +
	            'why the markup being generated is different on the client ' +
	            'or server:\n%s',
	            difference
	          ) : null);
	        }
	      }
	    }

	    (false ? invariant(
	      container.nodeType !== DOC_NODE_TYPE,
	      'You\'re trying to render a component to the document but ' +
	        'you didn\'t use server rendering. We can\'t do this ' +
	        'without using server rendering due to cross-browser quirks. ' +
	        'See React.renderToString() for server rendering.'
	    ) : invariant(container.nodeType !== DOC_NODE_TYPE));

	    setInnerHTML(container, markup);
	  },

	  /**
	   * React ID utilities.
	   */

	  getReactRootID: getReactRootID,

	  getID: getID,

	  setID: setID,

	  getNode: getNode,

	  getNodeFromInstance: getNodeFromInstance,

	  purgeID: purgeID
	};

	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});

	module.exports = ReactMount;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);

	var assign = __webpack_require__(15);
	var emptyFunction = __webpack_require__(89);
	var getEventTarget = __webpack_require__(380);

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: getEventTarget,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};

	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;

	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }

	  var defaultPrevented = nativeEvent.defaultPrevented != null ?
	    nativeEvent.defaultPrevented :
	    nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}

	assign(SyntheticEvent.prototype, {

	  preventDefault: function() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },

	  stopPropagation: function() {
	    var event = this.nativeEvent;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },

	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },

	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,

	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }

	});

	SyntheticEvent.Interface = EventInterface;

	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function(Class, Interface) {
	  var Super = this;

	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;

	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;

	  PooledClass.addPoolingTo(Class, PooledClass.threeArgumentPooler);
	};

	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.threeArgumentPooler);

	module.exports = SyntheticEvent;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    ContextMenuTypes = __webpack_require__(112),
	    invariant = __webpack_require__(11),
	    assign = __webpack_require__(15);

	var ContextMenuActionCreators = {
	  showContextMenu: function showContextMenu(id, anchorEl, options) {
	    invariant(ContextMenuTypes.hasOwnProperty(id), 'showContextMenu() accepts a constant from ContextMenuTypes. You passed %s', id);

	    var anchorRect = _.pick(anchorEl.getBoundingClientRect(), 'top', 'bottom', 'right', 'left', 'width', 'height');

	    _.each(anchorRect, function (val, key) {
	      anchorRect[key] = Math.round(val);
	    });

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_CONTEXT_MENU,
	      contextMenu: assign({ id: id, anchorRect: anchorRect }, options)
	    });
	  },

	  hideContextMenu: function hideContextMenu() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_CONTEXT_MENU
	    });
	  }
	};

	module.exports = ContextMenuActionCreators;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  STAMP_SHARE: null,
	  STAMP_MORE: null,
	  ZINE_SHARE: null,
	  ZINE_MORE: null,
	  USER_PROFILE: null,
	  USER_SHARE: null,
	  CREATE: null,
	  ZINE_COLOR_PICKER: null,
	  STAMP_STATUS_PICKER: null,
	  ZINE_STATUS_PICKER: null,
	  EDITOR_MORE: null
	});

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceTypes = __webpack_require__(35),
	    keyMirror = __webpack_require__(24),
	    invariant = __webpack_require__(11);

	var ShareTypes = keyMirror({
	  FACEBOOK: null,
	  TWITTER: null,
	  GOOGLE: null,
	  TUMBLR: null,
	  PINTEREST: null
	});

	if (false) {
	  for (var key in ShareTypes) {
	    if (ShareTypes.hasOwnProperty(key)) {
	      invariant(ServiceTypes.hasOwnProperty(key), '%s is specified in ShareTypes but not in ServiceTypes', key);
	    }
	  }
	}

	module.exports = ShareTypes;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibKeyMirror = __webpack_require__(24);

	var _reactLibKeyMirror2 = _interopRequireDefault(_reactLibKeyMirror);

	exports['default'] = (0, _reactLibKeyMirror2['default'])({
	  PUBLIC: null,
	  UNLISTED: null
	});
	module.exports = exports['default'];

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var getScrollY = __webpack_require__(82);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;
	var _require2 = __webpack_require__(4);

	var throttle = _require2.throttle;

	var currentScrollY,
	    previousScrollY,
	    maxScrollY,
	    windowHeight,
	    SENSITIVITY = 10;

	function updateCurrentScrollY() {
	  var scrollY = getScrollY();
	  if (Math.abs(scrollY - currentScrollY) < SENSITIVITY) {
	    return;
	  }

	  previousScrollY = currentScrollY;
	  currentScrollY = scrollY;
	}

	var updateMetrics = throttle(function () {
	  windowHeight = window.innerHeight;
	  maxScrollY = document.body.scrollHeight - windowHeight;
	}, 1000);

	/**
	 * Define `getScrollState(scrollY) -> state` and `scrollStateDidUpdate()` to react to scroll.
	 */
	var ScrollStateMixin = {
	  getInitialState: function getInitialState() {
	    updateCurrentScrollY();
	    return this.getScrollState(currentScrollY, currentScrollY, maxScrollY);
	  },

	  componentDidMount: function componentDidMount() {
	    if (!isMobile()) {
	      window.addEventListener('scroll', this.updateScrollState);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (!isMobile()) {
	      window.removeEventListener('scroll', this.updateScrollState);
	    }
	  },

	  updateScrollState: function updateScrollState() {
	    if (!this.isMounted() || isMobile()) {
	      return;
	    }

	    updateCurrentScrollY();
	    updateMetrics();

	    var scrollState = this.getScrollState(currentScrollY, previousScrollY, maxScrollY, windowHeight),
	        needsSetState = false;

	    for (var key in scrollState) {
	      if (!scrollState.hasOwnProperty(key)) {
	        continue;
	      }

	      if (scrollState[key] !== this.state[key]) {
	        needsSetState = true;
	        break;
	      }
	    }

	    if (!needsSetState) {
	      return;
	    }

	    this.setState(scrollState, this.scrollStateDidUpdate);
	  },

	  hasScrolledPastOffset: function hasScrolledPastOffset(offset) {
	    var scrollY = Math.min(currentScrollY, maxScrollY);

	    if (offset) {
	      return scrollY > offset;
	    } else {
	      return false;
	    }
	  },

	  hasScrolledToOffset: function hasScrolledToOffset(offset) {
	    var scrollY = Math.min(currentScrollY, maxScrollY);

	    if (offset) {
	      return scrollY > offset - windowHeight;
	    } else {
	      return false;
	    }
	  }
	};

	module.exports = ScrollStateMixin;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	var Container = React.createClass({
	  displayName: 'Container',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    overlay: PropTypes.bool
	  },

	  className: 'PageControls-container',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.fill && 'fill'];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.props.children
	    );
	  }
	});

	__webpack_require__(941);

	var Separator = React.createClass({
	  displayName: 'Separator',

	  mixins: [PureRenderMixin],

	  statics: {
	    IS_SEPARATOR: true
	  },

	  render: function render() {
	    return React.createElement('div', { className: 'PageControls-separator' });
	  }
	});

	var Message = React.createClass({
	  displayName: 'Message',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'PageControls-message' },
	      this.props.children
	    );
	  }
	});

	var PageControls = React.createClass({
	  displayName: 'PageControls',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    overlay: PropTypes.bool,
	    color: PropTypes.oneOf(['dark', 'light'])
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'dark'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.center && 'center', this.props.spaceBetween && 'spaceBetween', this.props.color];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.Children.map(this.props.children, this.renderAction)
	    );
	  },

	  renderAction: function renderAction(item) {
	    if (!item) {
	      return;
	    }

	    if (item.type.IS_SEPARATOR) {
	      return item;
	    }

	    return { item: item };
	  }
	});

	module.exports = PageControls;
	module.exports.Container = Container;
	module.exports.Separator = Separator;
	module.exports.Message = Message;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(956);

	var Alert = React.createClass({
	  displayName: 'Alert',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    title: React.PropTypes.string.isRequired,
	    message: React.PropTypes.node
	  },

	  render: function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var message = _props.message;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'Alert-content' },
	        title && React.createElement(
	          'h3',
	          { className: 'Alert-title' },
	          title
	        ),
	        message && React.createElement(
	          'div',
	          { className: 'Alert-message' },
	          message
	        ),
	        React.createElement(
	          'div',
	          { className: 'Alert-actions' },
	          this.props.children
	        )
	      )
	    );
	  }
	});

	module.exports = Alert;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsModalTypes = __webpack_require__(58);

	var _constantsModalTypes2 = _interopRequireDefault(_constantsModalTypes);

	var _constantsPayloadSources = __webpack_require__(399);

	var _constantsPayloadSources2 = _interopRequireDefault(_constantsPayloadSources);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _utilsStoreUtils = __webpack_require__(30);

	var _config = __webpack_require__(66);

	var _config2 = _interopRequireDefault(_config);

	'use strict';

	var _alert = null,
	    _sidebar = null,
	    _contextMenu = null,
	    _modal = null,
	    _isFacebookOwnModalVisible = false,
	    _isModalSpecifiedByServer = false;

	function is(entity, id) {
	  if (entity) {
	    return !id || entity.id === id;
	  } else {
	    return false;
	  }
	}

	function hideAlert() {
	  _alert = null;
	}

	function hideSidebar() {
	  _sidebar = null;
	}

	function hideContextMenu() {
	  _contextMenu = null;
	}

	function _canHideModal(modal) {
	  if (modal && modal.id && _modal) {
	    return modal.id === _modal.id;
	  }

	  if (_config2['default'].isAuthPopup) {
	    return false;
	  }

	  switch (_modal && _modal.id) {
	    case _constantsModalTypes2['default'].RESET_PASSWORD:
	      return false;
	    case _constantsModalTypes2['default'].SIGNUP:
	    case _constantsModalTypes2['default'].FINISH_SIGNUP:
	      var justSignedUp = _storesUserStore2['default'].isAuthenticated();
	      return !justSignedUp;
	    case _constantsModalTypes2['default'].SEND_INVITE:
	      return !_isFacebookOwnModalVisible;
	    default:
	      return true;
	  }
	}

	function hideModal(modal) {
	  if (!_canHideModal(modal)) {
	    return;
	  }

	  _isModalSpecifiedByServer = false;
	  if (_modal && _modal.next) {
	    _modal = _modal.next;
	  } else {
	    _modal = null;
	  }
	}

	function hideAll() {
	  hideAlert();
	  hideSidebar();
	  hideContextMenu();
	  hideModal();
	}

	function showAlert(alert) {
	  hideAll();
	  _alert = alert;
	}

	function showSidebar(sidebar) {
	  hideAll();
	  _sidebar = sidebar;
	}

	function showContextMenu(contextMenu) {
	  hideAll();
	  _contextMenu = contextMenu;
	}

	function showModal(modal, isPreloaded) {
	  hideAll();
	  _modal = modal;
	  _isModalSpecifiedByServer = isPreloaded || false;
	}

	function shouldHideModalOnRouteChange() {
	  return !_isModalSpecifiedByServer;
	}

	function shouldHideAlertOnRouteChange() {
	  // By default true, unless explicitly set to false
	  return _alert && _alert.hideOnRouteChange !== false;
	}

	function handleRouteChange() {
	  if (shouldHideModalOnRouteChange()) {
	    hideModal();
	  }

	  if (shouldHideAlertOnRouteChange()) {
	    hideAlert();
	  }

	  hideContextMenu();
	  hideSidebar();
	}

	var OverlayStore = (0, _utilsStoreUtils.createStore)({
	  hasAlert: function hasAlert(id) {
	    return is(_alert, id);
	  },

	  hasSidebar: function hasSidebar(id) {
	    return is(_sidebar, id);
	  },

	  hasModal: function hasModal(id) {
	    return is(_modal, id);
	  },

	  hasContextMenu: function hasContextMenu(id) {
	    return is(_contextMenu, id);
	  },

	  hasAny: function hasAny() {
	    return this.hasAlert() || this.hasSidebar() || this.hasModal() || this.hasContextMenu();
	  },

	  getAlert: function getAlert() {
	    return _alert;
	  },

	  getSidebar: function getSidebar() {
	    return _sidebar;
	  },

	  getModal: function getModal() {
	    return _modal;
	  },

	  getContextMenu: function getContextMenu() {
	    return _contextMenu;
	  },

	  canHideModal: function canHideModal() {
	    return _canHideModal();
	  }
	});

	_AppDispatcher2['default'].register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case _constantsActionTypes2['default'].SHOW_ALERT:
	      showAlert(action.alert);
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].HIDE_ALERT:
	      hideAlert();
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SHOW_SIDEBAR:
	      showSidebar(action.sidebar);
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].HIDE_SIDEBAR:
	      hideSidebar();
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SHOW_CONTEXT_MENU:
	      showContextMenu(action.contextMenu);
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].HIDE_CONTEXT_MENU:
	      hideContextMenu();
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SHOW_MODAL:
	      showModal(action.modal, payload.source === _constantsPayloadSources2['default'].PRELOADED_ACTION);
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].HIDE_MODAL:
	      hideModal(action.modal);
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SEND_FB_INVITE:
	      _isFacebookOwnModalVisible = true;
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].SEND_FB_INVITE_SUCCESS:
	    case _constantsActionTypes2['default'].SEND_FB_INVITE_ERROR:
	      _isFacebookOwnModalVisible = false;
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].HIDE_OVERLAY:
	      hideAll();
	      OverlayStore.emitChange();
	      break;

	    case _constantsActionTypes2['default'].CHANGE_ROUTE:
	      handleRouteChange();
	      OverlayStore.emitChange();
	      break;
	  }
	});

	exports['default'] = OverlayStore;
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var findWhere = _require.findWhere;
	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var MediaTypes = __webpack_require__(70);
	var ScreenSizeStore = __webpack_require__(121);
	var update = __webpack_require__(49);
	var keyMirror = __webpack_require__(24);
	var _require2 = __webpack_require__(30);

	var createStore = _require2.createStore;

	var PlaybackStates = keyMirror({
	  IDLE: null,
	  PLAYING: null,
	  PAUSED: null
	});

	var BACKWARD_THRESHOLD_SECONDS = 3,
	    DEFAULT_STATE = { playbackState: PlaybackStates.IDLE };

	var _mediaStates = {},
	    _pendingUnregister = {},
	    _stickyMediaId = null;

	function isStickyPlayerVisible() {
	  return !ScreenSizeStore.isMobile();
	}

	function isAudio(mediaId) {
	  switch (_mediaStates[mediaId].mediaType) {
	    case MediaTypes.AUDIO_TRACK:
	    case MediaTypes.AUDIO_PLAYLIST:
	      return true;
	    default:
	      return false;
	  }
	}

	function findMediaStateWhere(properties) {
	  return findWhere(_mediaStates, properties) || DEFAULT_STATE;
	}

	function isPlaying(mediaId) {
	  return findMediaStateWhere({ id: mediaId }).playbackState === PlaybackStates.PLAYING;
	}

	function isPaused(mediaId) {
	  return findMediaStateWhere({ id: mediaId }).playbackState === PlaybackStates.PAUSED;
	}

	function isIdle(mediaId) {
	  return findMediaStateWhere({ id: mediaId }).playbackState === PlaybackStates.IDLE;
	}

	function hasNextTrack(mediaId) {
	  var _mediaStates$mediaId = _mediaStates[mediaId];
	  var tracks = _mediaStates$mediaId.tracks;
	  var trackIndex = _mediaStates$mediaId.trackIndex;

	  return !!tracks[trackIndex + 1];
	}

	function hasPreviousTrack(mediaId) {
	  var _mediaStates$mediaId2 = _mediaStates[mediaId];
	  var tracks = _mediaStates$mediaId2.tracks;
	  var trackIndex = _mediaStates$mediaId2.trackIndex;

	  return !!tracks[trackIndex - 1];
	}

	function getCurrentTime(mediaId) {
	  return !isIdle(mediaId) && _mediaStates[mediaId].currentTime || 0;
	}

	function createMediaState(mediaId) {
	  _mediaStates[mediaId] = {
	    id: mediaId,
	    tracks: [],
	    trackIndex: 0,
	    playbackState: PlaybackStates.IDLE
	  };
	}

	function updateMediaState(mediaId, updateSpec) {
	  if (!_mediaStates[mediaId]) {
	    createMediaState(mediaId);
	  }

	  _mediaStates[mediaId] = update(_mediaStates[mediaId], updateSpec);
	}

	function setPlaybackState(mediaId, playbackState) {
	  updateMediaState(mediaId, {
	    playbackState: {
	      $set: playbackState
	    }
	  });
	}

	function registerAudio(mediaId, options) {
	  delete _pendingUnregister[mediaId];
	  updateMediaState(mediaId, { $merge: options });
	}

	function canUnregisterAudio(mediaId) {
	  return !isStickyPlayerVisible() || mediaId !== _stickyMediaId;
	}

	function unregisterAudio(mediaId, force) {
	  if (canUnregisterAudio(mediaId) || force) {
	    delete _mediaStates[mediaId];
	    delete _pendingUnregister[mediaId];
	  } else {
	    _pendingUnregister[mediaId] = true;
	  }
	}

	function considerSetStickyMedia(mediaId) {
	  if (_mediaStates[mediaId] && !_stickyMediaId) {
	    _stickyMediaId = mediaId;
	  }
	}

	function considerRemoveStickyMedia(force) {
	  if (!_stickyMediaId) {
	    return;
	  }

	  var shouldRemove = force || !isStickyPlayerVisible() || isIdle(_stickyMediaId);
	  if (!shouldRemove) {
	    return;
	  }

	  if (_pendingUnregister[_stickyMediaId]) {
	    unregisterAudio(_stickyMediaId, true);
	  }

	  _stickyMediaId = null;
	}

	function play(mediaId, options) {
	  if (options) {
	    updateMediaState(mediaId, { $merge: options });
	  }

	  var playingId = findMediaStateWhere({ playbackState: PlaybackStates.PLAYING }).id;
	  if (playingId !== mediaId) {
	    setPlaybackState(playingId, PlaybackStates.PAUSED);
	  }

	  setPlaybackState(mediaId, PlaybackStates.PLAYING);

	  if (isAudio(mediaId)) {
	    _stickyMediaId = mediaId;
	  }
	}

	function pause(mediaId) {
	  setPlaybackState(mediaId, PlaybackStates.PAUSED);
	}

	function playNext(mediaId) {
	  if (!hasNextTrack(mediaId)) {
	    setPlaybackState(mediaId, PlaybackStates.IDLE);
	  }

	  updateMediaState(mediaId, {
	    currentTime: {
	      $set: 0
	    },
	    trackIndex: {
	      $apply: function $apply(i) {
	        return hasNextTrack(mediaId) ? i + 1 : 0;
	      }
	    }
	  });
	}

	function playPrevious(mediaId) {
	  var hasPrevious = hasPreviousTrack(mediaId),
	      shouldPlayPrevious = hasPrevious && getCurrentTime(mediaId) < BACKWARD_THRESHOLD_SECONDS;

	  updateMediaState(mediaId, {
	    currentTime: {
	      $set: 0
	    },
	    trackIndex: {
	      $apply: function $apply(i) {
	        return shouldPlayPrevious ? i - 1 : i;
	      }
	    }
	  });
	}

	function setCurrentTime(mediaId, time) {
	  updateMediaState(mediaId, {
	    currentTime: {
	      $set: time
	    }
	  });
	}

	var PlayerStore = createStore({
	  isPlaying: isPlaying,

	  isPaused: isPaused,

	  isIdle: isIdle,

	  getCurrentTime: getCurrentTime,

	  getStickyMediaId: function getStickyMediaId() {
	    return _stickyMediaId;
	  },

	  getActiveTrackIndex: function getActiveTrackIndex(mediaId) {
	    return _mediaStates[mediaId] && _mediaStates[mediaId].trackIndex || 0;
	  },

	  getActiveTrack: function getActiveTrack(mediaId) {
	    return _mediaStates[mediaId] && _mediaStates[mediaId].tracks[_mediaStates[mediaId].trackIndex];
	  },

	  getSourceStampId: function getSourceStampId(mediaId) {
	    return _mediaStates[mediaId] && _mediaStates[mediaId].stampId;
	  },

	  getArtwork: function getArtwork(mediaId) {
	    var mediaState = _mediaStates[mediaId];
	    if (!mediaState) {
	      return;
	    }

	    var track = mediaState.tracks[mediaState.trackIndex];
	    return track && track.artwork || this.getBackground(mediaId);
	  },

	  getBackground: function getBackground(mediaId) {
	    var mediaState = _mediaStates[mediaId];
	    return mediaState && mediaState.background;
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.PLAYER_PLAY:
	      play(action.mediaId, action.options);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_PAUSE:
	      pause(action.mediaId);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_PLAY_NEXT:
	      playNext(action.mediaId);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_PLAY_PREVIOUS:
	      playPrevious(action.mediaId);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_SET_CURRENT_TIME:
	      setCurrentTime(action.mediaId, action.time);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_CONSIDER_SET_STICKY_MEDIA:
	      considerSetStickyMedia(action.mediaId);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_CONSIDER_REMOVE_STICKY_MEDIA:
	      considerRemoveStickyMedia(action.force);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_REGISTER_AUDIO:
	      registerAudio(action.mediaId, action.options);
	      PlayerStore.emitChange();
	      break;

	    case ActionTypes.PLAYER_UNREGISTER_AUDIO:
	      unregisterAudio(action.mediaId);
	      PlayerStore.emitChange();
	      break;
	  }
	});

	module.exports = PlayerStore;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;

	var _routerState;

	var RouterStore = createStore({
	  getRouterState: function getRouterState() {
	    return _routerState;
	  }
	});

	RouterStore.dispatchToken = AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.CHANGE_ROUTE:
	      _routerState = action.routerState;
	      RouterStore.emitChange();
	      break;
	  }
	});

	module.exports = RouterStore;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var ScreenSizes = __webpack_require__(400);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;

	function getScreenSize() {
	  if (typeof window === 'undefined') {
	    return ScreenSizes.EXTRA_SMALL;
	  }

	  if (window.matchMedia('(min-width: 100em)').matches) {
	    return ScreenSizes.EXTRA_LARGE;
	  } else if (window.matchMedia('(min-width: 75em)').matches) {
	    return ScreenSizes.LARGE;
	  } else if (window.matchMedia('(min-width: 62em)').matches) {
	    return ScreenSizes.MEDIUM;
	  } else if (window.matchMedia('(min-width: 40em)').matches) {
	    return ScreenSizes.SMALL;
	  } else {
	    return ScreenSizes.EXTRA_SMALL;
	  }
	}

	var MobileSizes = [ScreenSizes.EXTRA_SMALL],
	    TabletSizes = [ScreenSizes.SMALL],
	    DesktopSizes = [ScreenSizes.MEDIUM, ScreenSizes.LARGE, ScreenSizes.EXTRA_LARGE];

	var _screenSize = getScreenSize();

	var ScreenSizeStore = createStore({
	  getScreenSize: function getScreenSize() {
	    return _screenSize;
	  },

	  isMobile: function isMobile() {
	    return MobileSizes.indexOf(_screenSize) > -1;
	  },

	  isTablet: function isTablet() {
	    return TabletSizes.indexOf(_screenSize) > -1;
	  },

	  isDesktop: function isDesktop() {
	    return DesktopSizes.indexOf(_screenSize) > -1;
	  }
	});

	ScreenSizeStore.dispatchToken = AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.RESIZE_WINDOW:
	      var screenSize = getScreenSize();
	      if (screenSize !== _screenSize) {
	        _screenSize = screenSize;
	        ScreenSizeStore.emitChange();
	      }
	      break;
	  }
	});

	module.exports = ScreenSizeStore;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _superagent = __webpack_require__(385);

	var _superagent2 = _interopRequireDefault(_superagent);

	var _config = __webpack_require__(66);

	var _config2 = _interopRequireDefault(_config);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _utilsNormalizeError = __webpack_require__(450);

	var _utilsNormalizeError2 = _interopRequireDefault(_utilsNormalizeError);

	var _humps = __webpack_require__(186);

	var _lodashLangIsFunction = __webpack_require__(497);

	var _lodashLangIsFunction2 = _interopRequireDefault(_lodashLangIsFunction);

	'use strict';

	function ajax(req, data, callback, args) {
	  if ((0, _lodashLangIsFunction2['default'])(data)) {
	    args = [callback].concat(args);
	    callback = data;
	    data = null;
	  }

	  (0, _reactLibInvariant2['default'])((0, _lodashLangIsFunction2['default'])(callback), 'Callback is required and must be a function.');

	  if (data) {
	    req = req.send((0, _humps.decamelizeKeys)(data));
	  }

	  req.set('Accept', 'text/plain;application/json').set('X-Auth-Token', _config2['default'].localDevelopmentAPIToken).end(function (err, res) {
	    var body = undefined;

	    if (res && res.ok) {
	      body = res.body;
	    } else if (!err) {
	      err = (0, _utilsNormalizeError2['default'])(res);
	    }

	    callback.apply(null, [err, body].concat(args));
	  });
	}

	var APIUtils = {
	  get: function get(url, callback) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }

	    ajax(_superagent2['default'].get(url), null, callback, args);
	  },

	  post: function post(url, data, callback) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }

	    ajax(_superagent2['default'].post(url), data, callback, args);
	  },

	  put: function put(url, data, callback) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      args[_key3 - 3] = arguments[_key3];
	    }

	    ajax(_superagent2['default'].put(url), data, callback, args);
	  },

	  patch: function patch(url, data, callback) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      args[_key4 - 3] = arguments[_key4];
	    }

	    ajax(_superagent2['default'].patch(url), data, callback, args);
	  },

	  del: function del(url, data, callback) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	      args[_key5 - 3] = arguments[_key5];
	    }

	    ajax(_superagent2['default'].del(url), data, callback, args);
	  }
	};

	exports['default'] = APIUtils;
	module.exports = exports['default'];

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var GRADIENT_VARIANTS = {
	  'LinearGradient': 'linear-gradient',
	  'WebkitLinearGradient': '-webkit-linear-gradient',
	  'WebkitGradient': '-webkit-gradient',
	  'MozLinearGradient': '-moz-linear-gradient',
	  'msLinearGradient': '-ms-linear-gradient'
	};

	var test = function test(topColor, bottomColor) {
	  if (typeof document === 'undefined') {
	    console.log('document unavailable in node');
	    return;
	  }

	  var testEl = document.createElement('div'),
	      style = testEl.style;

	  for (var gradientName in GRADIENT_VARIANTS) {
	    var prefixedString = GRADIENT_VARIANTS[gradientName],
	        gradient = '',
	        templateString = '';

	    style.backgroundImage = '';

	    if (gradientName === 'LinearGradient') {
	      gradient = prefixedString + '(to bottom,' + topColor + ',' + bottomColor + ')';
	      templateString = prefixedString + '(to bottom, %topColor%, %bottomColor%)';
	    } else if (gradientName === 'WebkitGradient') {
	      gradient = prefixedString + '(linear,' + topColor + ',' + bottomColor + ')';
	      templateString = prefixedString + '(linear, %topColor%, %bottomColor%)';
	    } else {
	      gradient = prefixedString + '(top,' + topColor + ',' + bottomColor + ')';
	      templateString = prefixedString + '(top, %topColor%, %bottomColor%)';
	    }

	    style.backgroundImage = gradient;

	    if (style.backgroundImage.length) {
	      test.templateString = templateString;
	      return gradient;
	    }
	  }
	};

	var gradient = function gradient(topColor, bottomColor) {
	  if (!test.templateString) {
	    test(topColor, bottomColor);
	  }

	  return test.templateString.replace('%topColor%', topColor).replace('%bottomColor%', bottomColor);
	};

	module.exports = gradient;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25).g
	  , store  = __webpack_require__(457)('wks');
	module.exports = function(name){
	  return store[name] || (store[name] =
	    global.Symbol && global.Symbol[name] || __webpack_require__(226).safe('Symbol.' + name));
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// Optional / simple context binding
	var assertFunction = __webpack_require__(65).fn;
	module.exports = function(fn, that, length){
	  assertFunction(fn);
	  if(~length && that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	    };
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(88),
	    isNative = __webpack_require__(103),
	    isObject = __webpack_require__(104),
	    shimKeys = __webpack_require__(1037);

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  if (object) {
	    var Ctor = object.constructor,
	        length = object.length;
	  }
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	     (typeof object != 'function' && (length && isLength(length)))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};

	module.exports = keys;


/***/ },
/* 127 */,
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var onlyChild = __webpack_require__(245);
	var PureRenderMixin = __webpack_require__(2);
	var _require = __webpack_require__(1);

	var PropTypes = _require.PropTypes;

	var OffsetMonitor = React.createClass({
	  displayName: 'OffsetMonitor',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    onOffsetTopChange: PropTypes.func
	  },

	  componentDidMount: function componentDidMount() {
	    if (!this.props.onOffsetTopChange) {
	      return;
	    }

	    window.addEventListener('scroll', this._updateOffsetTop);
	    window.addEventListener('visibilitychange', this._updateOffsetTop);
	    window.addEventListener('resize', this._updateOffsetTop);
	    this._updateOffsetsInterval = setInterval(this._updateOffsetTop, 700);
	    this._updateOffsetTop();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (!this.props.onOffsetTopChange) {
	      return;
	    }

	    window.removeEventListener('scroll', this._requestFrame);
	    window.removeEventListener('visibilitychange', this._updateOffsetTop);
	    window.removeEventListener('resize', this._updateOffsetTop);
	    clearInterval(this._updateOffsetsInterval);
	  },

	  render: function render() {
	    return onlyChild(this.props.children);
	  },

	  _updateOffsetTop: function _updateOffsetTop() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var node = this.getDOMNode();
	    if (!node) {
	      return;
	    }

	    var offsetTop = node.offsetTop;
	    if (offsetTop !== this._lastOffsetTop) {
	      this._lastOffsetTop = offsetTop;
	      this.props.onOffsetTopChange(offsetTop);
	    }
	  }
	});

	module.exports = OffsetMonitor;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactLibObjectAssign = __webpack_require__(15);

	var _reactLibObjectAssign2 = _interopRequireDefault(_reactLibObjectAssign);

	var _mixinsRouterStateMixin = __webpack_require__(166);

	var _mixinsRouterStateMixin2 = _interopRequireDefault(_mixinsRouterStateMixin);

	var _underscore = __webpack_require__(4);

	var _react = __webpack_require__(1);

	var _router = __webpack_require__(50);

	'use strict';

	var SEPARATOR = '.';

	function formatPages(pages) {
	  for (var i = 0; i < pages.length; i++) {
	    if (!pages[i]) {
	      pages[i] = 0;
	    }
	  }

	  return pages.map(function (page) {
	    return ((page || 0) + 1).toString();
	  }).join(SEPARATOR);
	}

	function parsePages(formattedPages) {
	  if (!formattedPages || (0, _router.isInitialPath)()) {
	    return [];
	  }

	  return formattedPages.split(SEPARATOR).map(function (page) {
	    return page && parseInt(page - 1, 10) || undefined;
	  });
	}

	/**
	 * Reads ?p from route query and provides methods for parsing
	 * and replacing page number.
	 */
	var PageQueryMixin = {
	  mixins: [_mixinsRouterStateMixin2['default']],

	  propTypes: {
	    params: _react.PropTypes.object.isRequired,
	    query: _react.PropTypes.shape({
	      p: _react.PropTypes.string
	    }).isRequired
	  },

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  componentDidMount: function componentDidMount() {
	    if ((0, _router.isInitialPath)()) {
	      this._replacePageQuery(null);
	    }
	  },

	  parsePage: function parsePage(groupIndex) {
	    if (typeof groupIndex === 'undefined') {
	      groupIndex = 0;
	    }

	    return parsePages(this.props.query.p)[groupIndex];
	  },

	  replacePage: function replacePage(groupIndex, page) {
	    if (typeof page === 'undefined') {
	      page = groupIndex;
	      groupIndex = 0;
	    }

	    var pages = parsePages(this.props.query.p);
	    pages[groupIndex] = page;

	    this._replacePageQuery(pages);
	  },

	  _replacePageQuery: function _replacePageQuery(pages) {
	    pages = pages || [];

	    var _context$router = this.context.router;
	    var getCurrentRoutes = _context$router.getCurrentRoutes;
	    var getCurrentParams = _context$router.getCurrentParams;
	    var getCurrentQuery = _context$router.getCurrentQuery;

	    var routeName = (0, _underscore.last)(getCurrentRoutes()).name;
	    var params = getCurrentParams();
	    var query = getCurrentQuery();

	    query = (0, _reactLibObjectAssign2['default'])({}, query, {
	      p: formatPages(pages)
	    });

	    if (!pages.length) {
	      delete query.p;
	    }

	    (0, _router.replaceWith)(routeName, params, query);
	  }
	};

	exports['default'] = PageQueryMixin;
	module.exports = exports['default'];

/***/ },
/* 130 */,
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    FormInput = __webpack_require__(196),
	    ClassNameMixin = __webpack_require__(3),
	    FormLink = __webpack_require__(148),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(476);

	var FormInputRow = React.createClass({
	  displayName: 'FormInputRow',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    component: React.PropTypes.func,
	    formLink: React.PropTypes.instanceOf(FormLink).isRequired,
	    valueLink: function valueLink(props, propName) {
	      if (props[propName]) {
	        console.warn('Cannot use valueLink with FormInputRow. Use formLink instead.');
	      }
	    },
	    placeholder: React.PropTypes.string,
	    label: React.PropTypes.string,
	    color: React.PropTypes.oneOf(['light', 'dark']).isRequired,
	    size: React.PropTypes.oneOf(['big', 'medium']).isRequired,
	    blended: React.PropTypes.bool,
	    borderless: React.PropTypes.bool,
	    type: React.PropTypes.string,
	    name: React.PropTypes.string,
	    readOnly: React.PropTypes.bool,
	    bold: React.PropTypes.bool,
	    autofill: React.PropTypes.bool
	  },

	  className: 'FormInputRow',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'dark',
	      size: 'medium'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var fieldMessage = this.props.formLink.fieldMessage,
	        isError = fieldMessage && fieldMessage.isError;

	    return [this.props.color, this.props.size, isError && 'error', this.props.blended && 'blended', this.props.borderless && 'borderless'];
	  },

	  getInitialState: function getInitialState() {
	    return {
	      focus: false
	    };
	  },

	  handleBlur: function handleBlur(e) {
	    this.setState({
	      focus: false
	    });

	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },

	  handleFocus: function handleFocus(e) {
	    this.setState({
	      focus: true
	    });

	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	  },

	  handleKeyUp: function handleKeyUp(e) {
	    if (this.props.onKeyUp) {
	      this.props.onKeyUp(e);
	    }
	  },

	  isEmpty: function isEmpty() {
	    var value = this.props.formLink.value;
	    if (!value) {
	      return true;
	    }

	    if (typeof value.isEmpty === 'function') {
	      return value.isEmpty();
	    }

	    return false;
	  },

	  render: function render() {
	    var formLink = this.props.formLink;

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        'data-empty': this.isEmpty(),
	        'data-focus': this.state.focus,
	        onMouseDown: this.handleInputBoxClick },
	      this.props.label && React.createElement(
	        'label',
	        { className: 'FormInputRow-label' },
	        this.props.label
	      ),
	      React.createElement(
	        'div',
	        { className: 'FormInputRow-inputBox' },
	        React.createElement(FormInput, { ref: 'input',
	          component: this.props.component,
	          formLink: formLink,
	          color: this.props.color,
	          type: this.props.type,
	          name: this.props.name,
	          readOnly: this.props.readOnly,
	          placeholder: this.props.placeholder || this.props.label,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onKeyUp: this.handleKeyUp,
	          autofill: this.props.autofill })
	      ),
	      this.renderMessage()
	    );
	  },

	  handleInputBoxClick: function handleInputBoxClick(e) {
	    var inputEl = this.refs.input.getDOMNode();

	    if (inputEl !== e.target && !inputEl.contains(e.target)) {
	      e.preventDefault();
	      this.refs.input.focus();
	    }
	  },

	  renderMessage: function renderMessage() {
	    var formLink = this.props.formLink,
	        fieldMessage = formLink.fieldMessage;

	    if (!fieldMessage) {
	      return;
	    }

	    if (!fieldMessage.isError) {
	      return React.createElement(
	        'div',
	        { className: 'FormInputRow-help' },
	        fieldMessage.message
	      );
	    }

	    // hasFormError will get reset on next tick,
	    // so we use it to trigger the animation

	    var animateShake = !formLink.hasFormError;
	    return React.createElement(
	      'div',
	      { className: 'FormInputRow-error',
	        'data-animate': animateShake },
	      fieldMessage.message
	    );
	  },

	  focus: function focus() {
	    this.refs.input.focus();
	  }
	});

	module.exports = FormInputRow;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    UserLink = __webpack_require__(69),
	    Link = __webpack_require__(21),
	    MetaList = __webpack_require__(266),
	    UserImage = __webpack_require__(143),
	    Link = __webpack_require__(21),
	    Icon = __webpack_require__(10),
	    ServiceAccountStore = __webpack_require__(176),
	    createStoreMixin = __webpack_require__(8),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2),
	    normalizeUrl = __webpack_require__(451),
	    getServiceAccountUrl = __webpack_require__(440),
	    pluralize = __webpack_require__(98),
	    SidebarActionCreators = __webpack_require__(29),
	    SidebarTypes = __webpack_require__(39),
	    UserStore = __webpack_require__(5),
	    PropTypes = React.PropTypes;

	__webpack_require__(972);

	var UserInfo = React.createClass({
	  displayName: 'UserInfo',

	  mixins: [ClassNameMixin, PureRenderMixin, createStoreMixin(ServiceAccountStore, UserStore)],

	  propTypes: {
	    user: React.PropTypes.object.isRequired,
	    noLink: PropTypes.bool,
	    noName: PropTypes.bool,
	    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
	    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
	    vertical: PropTypes.bool,
	    showAbout: PropTypes.bool,
	    showLocation: PropTypes.bool,
	    showWebsite: PropTypes.bool,
	    showAccounts: PropTypes.bool,
	    showSubscribers: PropTypes.bool,
	    showSubscriptions: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      card: false,
	      showAbout: false,
	      showLocation: false,
	      showWebsite: false,
	      showAccounts: false,
	      showSubscribers: false,
	      showSubscriptions: false
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      accounts: props.showAccounts && ServiceAccountStore.getUserVisibleServiceAccounts(props.user.id)
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size, this.props.vertical && 'vertical', this.props.card && 'card'];
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.user !== nextProps.user) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.renderImage(),
	      this.renderBody()
	    );
	  },

	  renderImage: function renderImage() {
	    var image = React.createElement(UserImage, { user: this.props.user,
	      size: this.props.imageSize || this.props.size });

	    if (this.props.noLink) {
	      return image;
	    }

	    return React.createElement(
	      UserLink,
	      { user: this.props.user,
	        className: 'UserInfo-avatar',
	        showTitle: true },
	      image
	    );
	  },

	  renderBody: function renderBody() {
	    var name = this.renderName(),
	        user = this.props.user,
	        children = this.props.children,
	        isInNavBar = this.props.context === 'NavBar',
	        showAdditional;

	    showAdditional = this.props.showAbout || this.props.showLocation || this.props.showWebsite || this.props.showAccounts || this.props.showSubscribers || this.props.showSubscriptions || this.props.children;

	    if (!name && !children) {
	      return;
	    }

	    return React.createElement(
	      'div',
	      { className: 'UserInfo-body' },
	      React.createElement(
	        'span',
	        null,
	        isInNavBar && 'by ',
	        name
	      ),
	      this.props.showAbout && user.about && React.createElement(
	        'div',
	        { className: 'UserInfo-about' },
	        user.about
	      ),
	      showAdditional && React.createElement(
	        'div',
	        { className: 'UserInfo-additional' },
	        (this.props.showSubscribers || this.props.showSubscriptions) && React.createElement(
	          MetaList,
	          null,
	          this.props.showSubscribers && this.renderSubscribers(),
	          this.props.showSubscriptions && this.renderSubscriptions()
	        ),
	        (this.props.showLocation || this.props.showWebsite) && React.createElement(
	          'div',
	          { className: 'UserInfo-more' },
	          React.createElement(
	            MetaList,
	            { inline: true },
	            this.props.showWebsite && this.renderWebsite(),
	            this.props.showLocation && this.renderLocation()
	          )
	        ),
	        this.props.showAccounts && React.createElement(
	          'div',
	          { className: 'UserInfo-accounts' },
	          this.renderAccounts()
	        ),
	        children
	      )
	    );
	  },

	  renderSubscribers: function renderSubscribers() {
	    var user = this.props.user,
	        subscriberCount = user.subscriberCount;

	    return React.createElement(
	      Link,
	      { className: 'UserInfo-followerCount',
	        onClick: this.handleSubscribersClick },
	      React.createElement(
	        'b',
	        null,
	        subscriberCount
	      ),
	      ' ',
	      pluralize(subscriberCount, 'Follower', 'Followers')
	    );
	  },

	  renderSubscriptions: function renderSubscriptions() {
	    var user = this.props.user,
	        subscriptionCount = user.subscriptionCount;

	    return React.createElement(
	      Link,
	      { className: 'UserInfo-followingCount',
	        onClick: this.handleSubscriptionsClick },
	      React.createElement(
	        'b',
	        null,
	        subscriptionCount
	      ),
	      ' ',
	      'Following'
	    );
	  },

	  renderName: function renderName() {
	    if (this.props.noName) {
	      return;
	    }

	    if (this.props.noLink) {
	      return React.createElement(
	        'span',
	        { className: 'UserInfo-name' },
	        this.props.user.name
	      );
	    }

	    return React.createElement(UserLink, { user: this.props.user,
	      className: 'UserInfo-name' });
	  },

	  renderWebsite: function renderWebsite() {
	    var user = this.props.user,
	        website = user.website;

	    if (!website) {
	      return;
	    }

	    return React.createElement(
	      Link,
	      { href: normalizeUrl(website),
	        target: '_blank',
	        rel: 'me nofollow',
	        underline: 'hover' },
	      normalizeUrl(website, true)
	    );
	  },

	  renderLocation: function renderLocation() {
	    var user = this.props.user,
	        location = user.location;

	    if (!location) {
	      return;
	    }

	    return React.createElement(
	      'span',
	      null,
	      user.location
	    );
	  },

	  renderAccounts: function renderAccounts() {
	    var accounts = this.state.accounts;
	    if (!accounts.length) {
	      return;
	    }

	    return React.createElement(
	      MetaList,
	      { separated: false },
	      accounts.map(this.renderAccount)
	    );
	  },

	  renderAccount: function renderAccount(account) {
	    var serviceType = account.serviceType,
	        url = getServiceAccountUrl(account);

	    return React.createElement(
	      Link,
	      { key: serviceType,
	        href: url,
	        target: '_blank' },
	      React.createElement(Icon, { name: serviceType.toLowerCase(),
	        size: 'xsmall' })
	    );
	  },

	  handleSubscriptionsClick: function handleSubscriptionsClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.USER_SUBSCRIPTIONS, {
	      userId: this.props.user.id
	    });
	  },

	  handleSubscribersClick: function handleSubscribersClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.USER_SUBSCRIBERS, {
	      userId: this.props.user.id
	    });
	  }
	});

	module.exports = UserInfo;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    invariant = __webpack_require__(11);

	var ActionUtils = {
	  /**
	   * Requests a single entity.
	   */
	  requestEntity: function requestEntity(options) {
	    var idAttribute = options.idAttribute;
	    var fields = options.fields;
	    var store = options.store;
	    var action = options.action;
	    var callAPI = options.callAPI;
	    var getIdForStore = options.getIdForStore;
	    var id = options[idAttribute];
	    var storeId = getIdForStore ? getIdForStore(id) : id;

	    invariant(idAttribute, 'You forgot to pass idAttribute');
	    invariant(id, 'You forgot to pass ' + idAttribute);
	    invariant(action, 'You forgot to pass the action.');

	    if (store.contains(storeId, fields)) {
	      return;
	    }

	    var payload = {
	      type: action
	    };

	    payload[idAttribute] = id;
	    AppDispatcher.handleViewAction(payload);

	    callAPI(id);
	  },

	  /**
	   * Removes an entity
	   */
	  deleteEntity: function deleteEntity(options) {
	    var idAttribute = options.idAttribute;
	    var action = options.action;
	    var callAPI = options.callAPI;
	    var id = options[idAttribute];

	    invariant(idAttribute, 'You forgot to pass idAttribute');
	    invariant(id, 'You forgot to pass ' + idAttribute);
	    invariant(action, 'You forgot to pass the action.');

	    var payload = {
	      type: action
	    };

	    payload[idAttribute] = id;
	    AppDispatcher.handleViewAction(payload);

	    callAPI(id);
	  },

	  /**
	   * Posts an entity
	   */
	  postEntity: function postEntity(options) {
	    var entity = options.entity;
	    var action = options.action;
	    var callAPI = options.callAPI;

	    invariant(action, 'You forgot to pass the action.');

	    var payload = {
	      type: action,
	      entity: entity
	    };

	    AppDispatcher.handleViewAction(payload);

	    callAPI(entity);
	  },

	  /**
	   * Updates an entity
	   */
	  updateEntity: function updateEntity(options) {
	    var entity = options.entity;
	    var action = options.action;
	    var callAPI = options.callAPI;

	    invariant(action, 'You forgot to pass the action.');

	    var payload = {
	      type: action,
	      entity: entity
	    };

	    AppDispatcher.handleViewAction(payload);

	    callAPI(entity);
	  },

	  /**
	   * Requests a page for global list (such as feed).
	   */
	  requestPage: function requestPage(_ref) {
	    var isInitialRequest = _ref.isInitialRequest;
	    var store = _ref.store;
	    var action = _ref.action;
	    var callAPI = _ref.callAPI;

	    invariant(action, 'You forgot to pass the action.');

	    if (store.isExpectingPage()) {
	      return;
	    }

	    var pageCount = store.getPageCount(),
	        isInvalidated = store.isInvalidated(),
	        nextPageUrl;

	    if (isInitialRequest && pageCount > 0 && !isInvalidated) {
	      return;
	    }

	    if (!isInvalidated) {
	      nextPageUrl = store.getNextPageUrl();
	    }

	    AppDispatcher.handleViewAction({
	      type: action
	    });

	    callAPI(nextPageUrl);
	  },

	  /**
	   * Requests a page for indexed list (such as user's published).
	   */
	  requestIndexedPage: function requestIndexedPage(options) {
	    var idAttribute = options.idAttribute;
	    var isInitialRequest = options.isInitialRequest;
	    var store = options.store;
	    var action = options.action;
	    var callAPI = options.callAPI;
	    var getIdForStore = options.getIdForStore;
	    var id = options[idAttribute];
	    var storeId = getIdForStore ? getIdForStore(id) : id;

	    invariant(action, 'You forgot to pass the action.');
	    invariant(idAttribute, 'You forgot to pass idAttribute');
	    invariant(id, 'You forgot to pass ' + idAttribute);

	    if (store.isExpectingPage(storeId)) {
	      return;
	    }

	    var pageCount = store.getPageCount(storeId),
	        isInvalidated = store.isInvalidated(storeId),
	        nextPageUrl;

	    if (isInitialRequest && pageCount > 0 && !isInvalidated) {
	      return;
	    }

	    if (!isInvalidated) {
	      nextPageUrl = store.getNextPageUrl(storeId);
	    }

	    var payload = {
	      type: action
	    };

	    payload[idAttribute] = id;
	    AppDispatcher.handleViewAction(payload);

	    callAPI(id, nextPageUrl);
	  }
	};

	module.exports = ActionUtils;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function warn(method, error) {
	  console.warn('Error on calling localStorage.' + method + '\n', error.stack);
	}

	module.exports = {
	  getItem: function getItem() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    try {
	      return localStorage.getItem.apply(localStorage, args);
	    } catch (error) {
	      warn('getItem', error);
	    }
	  },

	  setItem: function setItem() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }

	    try {
	      localStorage.setItem.apply(localStorage, args);
	    } catch (error) {
	      warn('setItem', error);
	    }
	  },

	  removeItem: function removeItem() {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }

	    try {
	      localStorage.removeItem.apply(localStorage, args);
	    } catch (error) {
	      warn('removeItem', error);
	    }
	  }
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	function formatDate(date) {
	  if (typeof date === 'string') {
	    date = new Date(date);
	  }

	  return MONTHS[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
	}

	module.exports = formatDate;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function formatTime(totalSeconds) {
	    var hours = (totalSeconds - totalSeconds % 3600) / 3600,
	        minutes = (totalSeconds - totalSeconds % 60 - hours * 3600) / 60,
	        seconds = Math.round(totalSeconds % 60);

	    return hours > 0 ? hours + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2) : minutes + ':' + ('0' + seconds).slice(-2);
	}

	module.exports = formatTime;

/***/ },
/* 137 */,
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);
	var PathUtils = __webpack_require__(360);

	var _currentRoute;

	var Route = (function () {
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);

	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }

	  _createClass(Route, {
	    appendChild: {

	      /**
	       * Appends the given route to this route's child routes.
	       */

	      value: function appendChild(route) {
	        invariant(route instanceof Route, "route.appendChild must use a valid Route");

	        if (!this.childRoutes) this.childRoutes = [];

	        this.childRoutes.push(route);
	      }
	    },
	    toString: {
	      value: function toString() {
	        var string = "<Route";

	        if (this.name) string += " name=\"" + this.name + "\"";

	        string += " path=\"" + this.path + "\">";

	        return string;
	      }
	    }
	  }, {
	    createRoute: {

	      /**
	       * Creates and returns a new route. Options may be a URL pathname string
	       * with placeholders for named params or an object with any of the following
	       * properties:
	       *
	       * - name                     The name of the route. This is used to lookup a
	       *                            route relative to its parent route and should be
	       *                            unique among all child routes of the same parent
	       * - path                     A URL pathname string with optional placeholders
	       *                            that specify the names of params to extract from
	       *                            the URL when the path matches. Defaults to `/${name}`
	       *                            when there is a name given, or the path of the parent
	       *                            route, or /
	       * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	       *                            the scroll behavior of the router
	       * - isDefault                True to make this route the default route among all
	       *                            its siblings
	       * - isNotFound               True to make this route the "not found" route among
	       *                            all its siblings
	       * - onEnter                  A transition hook that will be called when the
	       *                            router is going to enter this route
	       * - onLeave                  A transition hook that will be called when the
	       *                            router is going to leave this route
	       * - handler                  A React component that will be rendered when
	       *                            this route is active
	       * - parentRoute              The parent route to use for this route. This option
	       *                            is automatically supplied when creating routes inside
	       *                            the callback to another invocation of createRoute. You
	       *                            only ever need to use this when declaring routes
	       *                            independently of one another to manually piece together
	       *                            the route hierarchy
	       *
	       * The callback may be used to structure your route hierarchy. Any call to
	       * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	       * inside the callback automatically uses this route as its parent.
	       */

	      value: function createRoute(options, callback) {
	        options = options || {};

	        if (typeof options === "string") options = { path: options };

	        var parentRoute = _currentRoute;

	        if (parentRoute) {
	          warning(options.parentRoute == null || options.parentRoute === parentRoute, "You should not use parentRoute with createRoute inside another route's child callback; it is ignored");
	        } else {
	          parentRoute = options.parentRoute;
	        }

	        var name = options.name;
	        var path = options.path || name;

	        if (path && !(options.isDefault || options.isNotFound)) {
	          if (PathUtils.isAbsolute(path)) {
	            if (parentRoute) {
	              invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, "You cannot nest path \"%s\" inside \"%s\"; the parent requires URL parameters", path, parentRoute.path);
	            }
	          } else if (parentRoute) {
	            // Relative paths extend their parent.
	            path = PathUtils.join(parentRoute.path, path);
	          } else {
	            path = "/" + path;
	          }
	        } else {
	          path = parentRoute ? parentRoute.path : "/";
	        }

	        if (options.isNotFound && !/\*$/.test(path)) path += "*"; // Auto-append * to the path of not found routes.

	        var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);

	        if (parentRoute) {
	          if (route.isDefault) {
	            invariant(parentRoute.defaultRoute == null, "%s may not have more than one default route", parentRoute);

	            parentRoute.defaultRoute = route;
	          } else if (route.isNotFound) {
	            invariant(parentRoute.notFoundRoute == null, "%s may not have more than one not found route", parentRoute);

	            parentRoute.notFoundRoute = route;
	          }

	          parentRoute.appendChild(route);
	        }

	        // Any routes created in the callback
	        // use this route as their parent.
	        if (typeof callback === "function") {
	          var currentRoute = _currentRoute;
	          _currentRoute = route;
	          callback.call(route, route);
	          _currentRoute = currentRoute;
	        }

	        return route;
	      }
	    },
	    createDefaultRoute: {

	      /**
	       * Creates and returns a route that is rendered when its parent matches
	       * the current URL.
	       */

	      value: function createDefaultRoute(options) {
	        return Route.createRoute(assign({}, options, { isDefault: true }));
	      }
	    },
	    createNotFoundRoute: {

	      /**
	       * Creates and returns a route that is rendered when its parent matches
	       * the current URL but none of its siblings do.
	       */

	      value: function createNotFoundRoute(options) {
	        return Route.createRoute(assign({}, options, { isNotFound: true }));
	      }
	    },
	    createRedirect: {

	      /**
	       * Creates and returns a route that automatically redirects the transition
	       * to another route. In addition to the normal options to createRoute, this
	       * function accepts the following options:
	       *
	       * - from         An alias for the `path` option. Defaults to *
	       * - to           The path/route/route name to redirect to
	       * - params       The params to use in the redirect URL. Defaults
	       *                to using the current params
	       * - query        The query to use in the redirect URL. Defaults
	       *                to using the current query
	       */

	      value: function createRedirect(options) {
	        return Route.createRoute(assign({}, options, {
	          path: options.path || options.from || "*",
	          onEnter: function onEnter(transition, params, query) {
	            transition.redirect(options.to, options.params || params, options.query || query);
	          }
	        }));
	      }
	    }
	  });

	  return Route;
	})();

	module.exports = Route;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPluginHub = __webpack_require__(156);

	var accumulateInto = __webpack_require__(243);
	var forEachAccumulated = __webpack_require__(377);

	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;

	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName =
	    event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}

	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    if (!domID) {
	      throw new Error('Dispatching id must not be null');
	    }
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners =
	      accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}

	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We can not perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(
	      event.dispatchMarker,
	      accumulateDirectionalDispatches,
	      event
	    );
	  }
	}


	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners =
	        accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}

	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}

	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}

	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(
	    fromID,
	    toID,
	    accumulateDispatches,
	    leave,
	    enter
	  );
	}


	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}



	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};

	module.exports = EventPropagators;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPluginHub = __webpack_require__(156);
	var EventPluginRegistry = __webpack_require__(523);
	var ReactEventEmitterMixin = __webpack_require__(1126);
	var ViewportMetrics = __webpack_require__(242);

	var assign = __webpack_require__(15);
	var isEventSupported = __webpack_require__(382);

	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */

	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;

	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topBlur: 'blur',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topScroll: 'scroll',
	  topSelectionChange: 'selectionchange',
	  topTextInput: 'textInput',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topWheel: 'wheel'
	};

	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}

	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {

	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,

	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(
	        ReactBrowserEventEmitter.handleTopLevel
	      );
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },

	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },

	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function() {
	    return !!(
	      (ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled())
	    );
	  },

	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.
	      registrationNameDependencies[registrationName];

	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0, l = dependencies.length; i < l; i++) {
	      var dependency = dependencies[i];
	      if (!(
	            (isListening.hasOwnProperty(dependency) && isListening[dependency])
	          )) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'wheel',
	              mountAt
	            );
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'mousewheel',
	              mountAt
	            );
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'DOMMouseScroll',
	              mountAt
	            );
	          }
	        } else if (dependency === topLevelTypes.topScroll) {

	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              mountAt
	            );
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE
	            );
	          }
	        } else if (dependency === topLevelTypes.topFocus ||
	            dependency === topLevelTypes.topBlur) {

	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topFocus,
	              'focus',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topBlur,
	              'blur',
	              mountAt
	            );
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topFocus,
	              'focusin',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topBlur,
	              'focusout',
	              mountAt
	            );
	          }

	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	            dependency,
	            topEventMapping[dependency],
	            mountAt
	          );
	        }

	        isListening[dependency] = true;
	      }
	    }
	  },

	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },

	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },

	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function() {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },

	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,

	  registrationNameModules: EventPluginHub.registrationNameModules,

	  putListener: EventPluginHub.putListener,

	  getListener: EventPluginHub.getListener,

	  deleteListener: EventPluginHub.deleteListener,

	  deleteAllListeners: EventPluginHub.deleteAllListeners

	});

	module.exports = ReactBrowserEventEmitter;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,

	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,

	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function(object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(
	          objectName,
	          methodNames[key],
	          object[key]
	        );
	      }
	    }
	  },

	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function(objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function() {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },

	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function(measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};

	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}

	module.exports = ReactPerf;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	
	//
	// Ported to React from http://jquery-elastic.googlecode.com/svn/trunk/jquery.elastic.source.js
	//

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1),
	    update = __webpack_require__(49),
	    shallowEqual = __webpack_require__(46),
	    PureRenderMixin = __webpack_require__(2);

	var MIMICS = ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontSize', 'lineHeight', 'fontFamily', 'width', 'fontWeight', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWsidth', 'borderTopStyle', 'borderTopColor', 'borderRightStyle', 'borderRightColor', 'borderBottomStyle', 'borderBottomColor', 'borderLeftStyle', 'borderLeftColor'];

	var Textarea = React.createClass({
	  displayName: 'Textarea',

	  mixins: [PureRenderMixin],

	  propTypes: {

	    // Controls whether TextArea is collapsed to the exact height of its content on blur.

	    // You might want to set it to `false` when there is just a single field and a button,
	    // so that the button doesn't jump out of the cursor when it is clicked.

	    collapseOnBlur: React.PropTypes.bool.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      collapseOnBlur: true,
	      extraLineCount: 1
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      style: {}
	    };
	  },

	  setStyle: function setStyle(style) {
	    var newStyle = update(this.state.style, {
	      $merge: style
	    });

	    if (shallowEqual(newStyle, this.state.style)) {
	      return;
	    }

	    this.setState({
	      style: newStyle
	    });
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.value !== this.props.value || this.state.twin !== prevState.twin) {

	      this.setStyleAccordingToTwin();
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    window.setTimeout(this.createTwin, 0);
	    window.addEventListener('resize', this.handleWindowResize, false);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.handleWindowResize, false);
	    this.destroyTwin();
	  },

	  render: function render() {
	    // Undefined value causes Textarea to retain previous value
	    var value = this.props.value || '';

	    return React.createElement('textarea', _extends({}, this.props, {
	      style: this.state.style,
	      value: value,
	      onBlur: this.handleBlur }));
	  },

	  handleWindowResize: function handleWindowResize() {
	    if (!this.isMounted() || !this.state.twin) {
	      return;
	    }

	    this.destroyTwin(true);
	    this.createTwin();
	    this.setStyleAccordingToTwin(true);
	  },

	  handleBlur: function handleBlur(e) {
	    var size = this.getTwinSize(),
	        height = size.height;

	    if (this.props.collapseOnBlur && height < this.state.maxHeight) {
	      this.setStyle({
	        height: Math.max(height, this.state.minHeight)
	      });
	    }

	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },

	  createTwin: function createTwin() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var el = this.getDOMNode(),
	        style = window.getComputedStyle(el),
	        lineHeight = parseInt(style.lineHeight, 10) || parseInt(style.fontSize, 10),
	        minHeight = parseInt(style.height, 10) || lineHeight * (1 + this.props.extraLineCount),
	        maxHeight = parseInt(style.maxHeight, 10) || Number.MAX_VALUE,
	        twin;

	    twin = document.createElement('div');
	    twin.setAttribute('style', 'position: absolute; display: none; visibility: hidden; word-wrap: break-word; white-space: pre-wrap;');

	    if (maxHeight < 0) {
	      maxHeight = Number.MAX_VALUE;
	    }

	    for (var i = 0; i < MIMICS.length; i++) {
	      twin.style[MIMICS[i]] = style[MIMICS[i]];
	    }

	    document.body.appendChild(twin);

	    this.setState({
	      lineHeight: lineHeight,
	      minHeight: minHeight,
	      maxHeight: maxHeight,
	      twin: twin,
	      style: {
	        overflow: 'hidden'
	      }
	    });
	  },

	  destroyTwin: function destroyTwin(resetState) {
	    var twin = this.state.twin;
	    if (twin && twin.parentNode === document.body) {
	      document.body.removeChild(twin);
	    }

	    if (resetState) {
	      this.setState({
	        lineHeight: null,
	        minHeight: null,
	        maxHeight: null,
	        twin: null,
	        style: {}
	      });
	    }
	  },

	  getTwinSize: function getTwinSize() {
	    var size = {},
	        twin = this.state.twin;

	    twin.style.display = 'block';

	    size.width = twin.offsetWidth;
	    size.height = twin.offsetHeight;

	    twin.style.display = 'none';

	    return size;
	  },

	  setStyleAccordingToTwin: function setStyleAccordingToTwin(forced) {
	    var el = this.getDOMNode(),
	        twin = this.state.twin,
	        lineHeight = this.state.lineHeight,
	        minHeight = this.state.minHeight,
	        maxHeight = this.state.maxHeight,
	        size;

	    if (!twin) {
	      return;
	    }

	    // Get curated content from the textarea.
	    var textareaContent = el.value.replace(/&/g, '&amp;').replace(/ {2}/g, '&nbsp;').replace(/<|>/g, '&gt;').replace(/\n/g, '<br />');

	    // Compare curated content with curated twin.
	    var twinContent = twin.innerHTML.replace(/<br>/ig, '<br />');

	    if (forced || textareaContent + '&nbsp;' !== twinContent) {
	      // Add an extra white space so new rows are added when you are at the end of a row.
	      twin.innerHTML = textareaContent + '&nbsp;';

	      size = this.getTwinSize();

	      var extraLineHeight = lineHeight * this.props.extraLineCount;

	      // Change textarea height if twin plus the height of one line differs more than 3 pixel from textarea height
	      if (Math.abs(size.height + extraLineHeight - el.offsetHeight) > 3) {
	        var goalHeight = size.height + extraLineHeight;
	        if (goalHeight >= maxHeight) {
	          this.setHeightAndOverflow(maxHeight, 'auto');
	        } else if (goalHeight <= minHeight) {
	          this.setHeightAndOverflow(minHeight, 'hidden');
	        } else {
	          this.setHeightAndOverflow(goalHeight, 'hidden');
	        }
	      }
	    }
	  },

	  setHeightAndOverflow: function setHeightAndOverflow(height, overflow) {
	    var el = this.getDOMNode(),
	        curatedHeight = Math.floor(parseInt(height, 10));

	    if (el.offsetHeight !== curatedHeight) {
	      this.setStyle({
	        height: curatedHeight,
	        overflow: overflow
	      });
	    }
	  }
	});

	module.exports = Textarea;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2),
	    _getThumbnailUrl = __webpack_require__(37),
	    getUserThumbnail = __webpack_require__(299),
	    PropTypes = React.PropTypes;

	__webpack_require__(915);

	// sync with sizes.less
	var thumbnailSizes = {
	  'xsmall': 28, // @UserImage--xsmall
	  'small': 32, // @UserImage--small
	  'medium': 44, // @UserImage--medium
	  'large': 80, // @UserImage--large
	  'xlarge': 120 // @UserImage--xlarge
	};

	var UserImage = React.createClass({
	  displayName: 'UserImage',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'UserImage',

	  propTypes: {
	    user: PropTypes.shape({
	      thumbnailUrl: PropTypes.string
	    }).isRequired,
	    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  getThumbnailUrl: function getThumbnailUrl() {
	    var thumbnail = getUserThumbnail(this.props.user),
	        size = thumbnailSizes[this.props.size];

	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    if (devicePixelRatio > 1.5) {
	      size *= 2;
	    }

	    return _getThumbnailUrl(thumbnail, {
	      allowExternal: true,
	      allowEmpty: true,
	      mode: 'scale_crop',
	      width: size,
	      height: size
	    });
	  },

	  render: function render() {
	    var style = {},
	        url = this.getThumbnailUrl();

	    if (url) {
	      style.backgroundImage = 'url(' + url + ')';
	    }

	    return React.createElement('div', { className: this.getClassName(),
	      style: style });
	  }
	});

	module.exports = UserImage;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/eee9813e-7403-4ee6-b317-1f60e3103e43.png',
	  colors: {
	    top: '999999',
	    bottom: '999999'
	  },
	  size: {
	    width: 1200,
	    height: 1200
	  }
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  BACKSPACE: 8,
	  COMMA: 188,
	  DELETE: 46,
	  DOWN: 40,
	  END: 35,
	  ENTER: 13,
	  ESCAPE: 27,
	  HOME: 36,
	  LEFT: 37,
	  NUMPAD_ADD: 107,
	  NUMPAD_DECIMAL: 110,
	  NUMPAD_DIVIDE: 111,
	  NUMPAD_ENTER: 108,
	  NUMPAD_MULTIPLY: 106,
	  NUMPAD_SUBTRACT: 109,
	  PAGE_DOWN: 34,
	  PAGE_UP: 33,
	  PERIOD: 190,
	  RIGHT: 39,
	  SPACE: 32,
	  TAB: 9,
	  UP: 38
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var findWhere = _require.findWhere;
	var AppDispatcher = __webpack_require__(6);
	var StampStore = __webpack_require__(17);
	var getAllStampImages = __webpack_require__(437);
	var _require2 = __webpack_require__(30);

	var createStore = _require2.createStore;
	var mergeIntoBag = _require2.mergeIntoBag;
	var isInBag = _require2.isInBag;

	var images = {};

	var ImageStore = createStore({
	  contains: function contains(slug, fields) {
	    return isInBag(images, slug, fields);
	  },

	  get: function get(id) {
	    return images[id];
	  },

	  getInStamp: function getInStamp(id, stampId) {
	    var image = this.get(id),
	        stamp = StampStore.get(stampId);

	    if (!id || !stamp || !stamp.content) {
	      return;
	    }

	    if (!image) {
	      image = findWhere(getAllStampImages(stamp), { uuid: id });
	    }

	    return image;
	  },

	  getSourceImage: function getSourceImage(image) {
	    if (!this.contains(image.uuid)) {
	      return image;
	    }

	    image = this.get(image.uuid);

	    if (image.sourceImage) {
	      return this.get(image.sourceImage);
	    } else {
	      return image;
	    }
	  },

	  getSourceStamp: function getSourceStamp(image, currentStampId) {
	    var sourceImage = this.getSourceImage(image);
	    return StampStore.get(sourceImage.stamp || currentStampId);
	  },

	  getUsageCount: function getUsageCount(image) {
	    var sourceImage = this.getSourceImage(image);
	    return sourceImage.usageCount || 0;
	  },

	  isInGrabbag: function isInGrabbag(image) {
	    var sourceImage = this.getSourceImage(image);
	    return sourceImage.isInGrabbag || false;
	  }
	});

	ImageStore.dispatchToken = AppDispatcher.register(function (payload) {
	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      receivedImages = entities && entities.images;

	  if (receivedImages) {
	    mergeIntoBag(images, receivedImages);
	    ImageStore.emitChange();
	  }
	});

	module.exports = ImageStore;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;

	var _image = null,
	    _sectionType = null;

	var LightboxStore = createStore({
	  isActive: function isActive() {
	    return !!_image;
	  },

	  getActiveImageUuid: function getActiveImageUuid() {
	    if (this.isActive()) {
	      return _image.uuid;
	    }
	  },

	  getActiveSectionType: function getActiveSectionType() {
	    if (this.isActive()) {
	      return _sectionType;
	    }
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.ENTER_LIGHTBOX:
	      _image = action.image;
	      _sectionType = action.sectionType;
	      LightboxStore.emitChange();
	      break;

	    case ActionTypes.LEAVE_LIGHTBOX:
	      _image = null;
	      _sectionType = null;
	      LightboxStore.emitChange();
	      break;
	  }
	});

	module.exports = LightboxStore;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);

	function FormLink(options) {
	  this.value = options.value;
	  this.fieldMessage = options.fieldMessage;
	  this.isFirstError = options.isFirstError;
	  this.hasFormError = options.hasFormError;

	  this._requestChange = options.requestChange;
	  this._validateField = options.validateField;
	}

	_.extend(FormLink.prototype, {
	  requestInit: function requestInit() {
	    this._validateField({
	      event: 'init'
	    });
	  },

	  requestFocus: function requestFocus(options) {
	    this._validateField({
	      showHelp: true,
	      showError: options.hasEdited,
	      event: 'focus'
	    });
	  },

	  requestBlur: function requestBlur() {
	    this._validateField({
	      showHelp: false,
	      showError: true,
	      event: 'blur'
	    });
	  },

	  requestChange: function requestChange(value) {
	    var callback = this._validateField.bind(this, {
	      showHelp: true,
	      showError: true,
	      event: 'change'
	    });

	    this._requestChange(value, callback);
	  }
	});

	module.exports = FormLink;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ScreenSizes = __webpack_require__(400);

	function getStampCountPerRow(screenSize, preferredColumns) {
	  switch (preferredColumns) {
	    case 3:
	      // Keep this synced with .Collection.Collection--3columns
	      switch (screenSize) {
	        case ScreenSizes.EXTRA_LARGE:
	          return 4;
	        case ScreenSizes.MEDIUM:
	        case ScreenSizes.LARGE:
	          return 3;
	        default:
	        case ScreenSizes.SMALL:
	        case ScreenSizes.EXTRA_SMALL:
	          return 2;
	      }
	      break;

	    case 4:
	      // Keep this synced with .Collection.Collection--4columns
	      switch (screenSize) {
	        case ScreenSizes.EXTRA_LARGE:
	          return 5;
	        case ScreenSizes.MEDIUM:
	        case ScreenSizes.LARGE:
	          return 4;
	        case ScreenSizes.SMALL:
	          return 3;
	        default:
	        case ScreenSizes.EXTRA_SMALL:
	          return 2;
	      }
	      break;

	    default:
	      throw new Error('We only care about 3 and 4 columns for now.');
	  }
	}

	module.exports = getStampCountPerRow;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(25)
	  , cof               = __webpack_require__(183)
	  , classof           = cof.classof
	  , assert            = __webpack_require__(182)
	  , assertObject      = assert.obj
	  , SYMBOL_ITERATOR   = __webpack_require__(124)('iterator')
	  , FF_ITERATOR       = '@@iterator'
	  , Iterators         = __webpack_require__(457)('iterators')
	  , IteratorPrototype = {};
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	setIterator(IteratorPrototype, $.that);
	function setIterator(O, value){
	  $.hide(O, SYMBOL_ITERATOR, value);
	  // Add iterator for FF iterator protocol
	  if(FF_ITERATOR in [])$.hide(O, FF_ITERATOR, value);
	}

	module.exports = {
	  // Safari has buggy iterators w/o `next`
	  BUGGY: 'keys' in [] && !('next' in [].keys()),
	  Iterators: Iterators,
	  step: function(done, value){
	    return {value: value, done: !!done};
	  },
	  is: function(it){
	    var O      = Object(it)
	      , Symbol = $.g.Symbol;
	    return (Symbol && Symbol.iterator || FF_ITERATOR) in O
	      || SYMBOL_ITERATOR in O
	      || $.has(Iterators, classof(O));
	  },
	  get: function(it){
	    var Symbol = $.g.Symbol
	      , getIter;
	    if(it != undefined){
	      getIter = it[Symbol && Symbol.iterator || FF_ITERATOR]
	        || it[SYMBOL_ITERATOR]
	        || Iterators[classof(it)];
	    }
	    assert($.isFunction(getIter), it, ' is not iterable!');
	    return assertObject(getIter.call(it));
	  },
	  set: setIterator,
	  create: function(Constructor, NAME, next, proto){
	    Constructor.prototype = $.create(proto || IteratorPrototype, {next: $.desc(1, next)});
	    cof.set(Constructor, NAME + ' Iterator');
	  }
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(73)('unscopables');
	if(!(UNSCOPABLES in []))__webpack_require__(14).hide(Array.prototype, UNSCOPABLES, {});
	module.exports = function(key){
	  [][UNSCOPABLES][key] = true;
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1017),
	    baseMatchesProperty = __webpack_require__(1018),
	    baseProperty = __webpack_require__(490),
	    bindCallback = __webpack_require__(187),
	    identity = __webpack_require__(353),
	    isBindable = __webpack_require__(1033);

	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return (typeof thisArg != 'undefined' && isBindable(func))
	      ? bindCallback(func, thisArg, argCount)
	      : func;
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return typeof thisArg == 'undefined'
	    ? baseProperty(func + '')
	    : baseMatchesProperty(func + '', thisArg);
	}

	module.exports = baseCallback;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var invariant = __webpack_require__(11);
	var canUseDOM = __webpack_require__(42).canUseDOM;

	var History = {

	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,

	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, "Cannot use History.back without a DOM");

	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;

	    window.history.back();
	  }

	};

	module.exports = History;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports.DefaultRoute = __webpack_require__(510);
	exports.Link = __webpack_require__(1082);
	exports.NotFoundRoute = __webpack_require__(511);
	exports.Redirect = __webpack_require__(512);
	exports.Route = __webpack_require__(235);
	exports.RouteHandler = __webpack_require__(236);

	exports.HashLocation = __webpack_require__(515);
	exports.HistoryLocation = __webpack_require__(361);
	exports.RefreshLocation = __webpack_require__(516);
	exports.StaticLocation = __webpack_require__(517);
	exports.TestLocation = __webpack_require__(1085);

	exports.ImitateBrowserBehavior = __webpack_require__(509);
	exports.ScrollToTopBehavior = __webpack_require__(1080);

	exports.History = __webpack_require__(153);
	exports.Navigation = __webpack_require__(1076);
	exports.State = __webpack_require__(1078);

	exports.createRoute = __webpack_require__(138).createRoute;
	exports.createDefaultRoute = __webpack_require__(138).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(138).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(138).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(514);
	exports.create = __webpack_require__(513);
	exports.run = __webpack_require__(1086);

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */

	/*jslint bitwise: true */

	'use strict';

	var invariant = __webpack_require__(11);

	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}

	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,

	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function(domPropertyConfig) {
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(
	        domPropertyConfig.isCustomAttribute
	      );
	    }

	    for (var propName in Properties) {
	      (false ? invariant(
	        !DOMProperty.isStandardName.hasOwnProperty(propName),
	        'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' +
	        '\'%s\' which has already been injected. You may be accidentally ' +
	        'injecting the same DOM property config twice, or you may be ' +
	        'injecting two configs that have conflicting property names.',
	        propName
	      ) : invariant(!DOMProperty.isStandardName.hasOwnProperty(propName)));

	      DOMProperty.isStandardName[propName] = true;

	      var lowerCased = propName.toLowerCase();
	      DOMProperty.getPossibleStandardName[lowerCased] = propName;

	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        DOMProperty.getPossibleStandardName[attributeName] = propName;
	        DOMProperty.getAttributeName[propName] = attributeName;
	      } else {
	        DOMProperty.getAttributeName[propName] = lowerCased;
	      }

	      DOMProperty.getPropertyName[propName] =
	        DOMPropertyNames.hasOwnProperty(propName) ?
	          DOMPropertyNames[propName] :
	          propName;

	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        DOMProperty.getMutationMethod[propName] = DOMMutationMethods[propName];
	      } else {
	        DOMProperty.getMutationMethod[propName] = null;
	      }

	      var propConfig = Properties[propName];
	      DOMProperty.mustUseAttribute[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_ATTRIBUTE);
	      DOMProperty.mustUseProperty[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_PROPERTY);
	      DOMProperty.hasSideEffects[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_SIDE_EFFECTS);
	      DOMProperty.hasBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_BOOLEAN_VALUE);
	      DOMProperty.hasNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_NUMERIC_VALUE);
	      DOMProperty.hasPositiveNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_POSITIVE_NUMERIC_VALUE);
	      DOMProperty.hasOverloadedBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_OVERLOADED_BOOLEAN_VALUE);

	      (false ? invariant(
	        !DOMProperty.mustUseAttribute[propName] ||
	          !DOMProperty.mustUseProperty[propName],
	        'DOMProperty: Cannot require using both attribute and property: %s',
	        propName
	      ) : invariant(!DOMProperty.mustUseAttribute[propName] ||
	        !DOMProperty.mustUseProperty[propName]));
	      (false ? invariant(
	        DOMProperty.mustUseProperty[propName] ||
	          !DOMProperty.hasSideEffects[propName],
	        'DOMProperty: Properties that have side effects must use property: %s',
	        propName
	      ) : invariant(DOMProperty.mustUseProperty[propName] ||
	        !DOMProperty.hasSideEffects[propName]));
	      (false ? invariant(
	        !!DOMProperty.hasBooleanValue[propName] +
	          !!DOMProperty.hasNumericValue[propName] +
	          !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1,
	        'DOMProperty: Value can be one of boolean, overloaded boolean, or ' +
	        'numeric value, but not a combination: %s',
	        propName
	      ) : invariant(!!DOMProperty.hasBooleanValue[propName] +
	        !!DOMProperty.hasNumericValue[propName] +
	        !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1));
	    }
	  }
	};
	var defaultValueCache = {};

	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {

	  ID_ATTRIBUTE_NAME: 'data-reactid',

	  /**
	   * Checks whether a property name is a standard property.
	   * @type {Object}
	   */
	  isStandardName: {},

	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties.
	   * @type {Object}
	   */
	  getPossibleStandardName: {},

	  /**
	   * Mapping from normalized names to attribute names that differ. Attribute
	   * names are used when rendering markup or with `*Attribute()`.
	   * @type {Object}
	   */
	  getAttributeName: {},

	  /**
	   * Mapping from normalized names to properties on DOM node instances.
	   * (This includes properties that mutate due to external factors.)
	   * @type {Object}
	   */
	  getPropertyName: {},

	  /**
	   * Mapping from normalized names to mutation methods. This will only exist if
	   * mutation cannot be set simply by the property or `setAttribute()`.
	   * @type {Object}
	   */
	  getMutationMethod: {},

	  /**
	   * Whether the property must be accessed and mutated as an object property.
	   * @type {Object}
	   */
	  mustUseAttribute: {},

	  /**
	   * Whether the property must be accessed and mutated using `*Attribute()`.
	   * (This includes anything that fails `<propName> in <element>`.)
	   * @type {Object}
	   */
	  mustUseProperty: {},

	  /**
	   * Whether or not setting a value causes side effects such as triggering
	   * resources to be loaded or text selection changes. We must ensure that
	   * the value is only set if it has changed.
	   * @type {Object}
	   */
	  hasSideEffects: {},

	  /**
	   * Whether the property should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasBooleanValue: {},

	  /**
	   * Whether the property must be numeric or parse as a
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasNumericValue: {},

	  /**
	   * Whether the property must be positive numeric or parse as a positive
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasPositiveNumericValue: {},

	  /**
	   * Whether the property can be used as a flag as well as with a value. Removed
	   * when strictly equal to false; present without a value when strictly equal
	   * to true; present with a value otherwise.
	   * @type {Object}
	   */
	  hasOverloadedBooleanValue: {},

	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],

	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },

	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function(nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },

	  injection: DOMPropertyInjection
	};

	module.exports = DOMProperty;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */

	'use strict';

	var EventPluginRegistry = __webpack_require__(523);
	var EventPluginUtils = __webpack_require__(192);

	var accumulateInto = __webpack_require__(243);
	var forEachAccumulated = __webpack_require__(377);
	var invariant = __webpack_require__(11);

	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};

	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;

	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @private
	 */
	var executeDispatchesAndRelease = function(event) {
	  if (event) {
	    var executeDispatch = EventPluginUtils.executeDispatch;
	    // Plugins can provide custom behavior when dispatching events.
	    var PluginModule = EventPluginRegistry.getPluginModuleForEvent(event);
	    if (PluginModule && PluginModule.executeDispatch) {
	      executeDispatch = PluginModule.executeDispatch;
	    }
	    EventPluginUtils.executeDispatchesInOrder(event, executeDispatch);

	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};

	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;

	function validateInstanceHandle() {
	  var valid =
	    InstanceHandle &&
	    InstanceHandle.traverseTwoPhase &&
	    InstanceHandle.traverseEnterLeave;
	  (false ? invariant(
	    valid,
	    'InstanceHandle not injected before use!'
	  ) : invariant(valid));
	}

	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {

	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {

	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,

	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function(InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },

	    getInstanceHandle: function() {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },

	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

	  },

	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,

	  registrationNameModules: EventPluginRegistry.registrationNameModules,

	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function(id, registrationName, listener) {
	    (false ? invariant(
	      !listener || typeof listener === 'function',
	      'Expected %s listener to be a function, instead got type %s',
	      registrationName, typeof listener
	    ) : invariant(!listener || typeof listener === 'function'));

	    var bankForRegistrationName =
	      listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	  },

	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },

	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },

	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function(id) {
	    for (var registrationName in listenerBank) {
	      delete listenerBank[registrationName][id];
	    }
	  },

	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0, l = plugins.length; i < l; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(
	          topLevelType,
	          topLevelTarget,
	          topLevelTargetID,
	          nativeEvent
	        );
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },

	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },

	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function() {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    forEachAccumulated(processingEventQueue, executeDispatchesAndRelease);
	    (false ? invariant(
	      !eventQueue,
	      'processEventQueue(): Additional events were enqueued while processing ' +
	      'an event queue. Support for this has not yet been implemented.'
	    ) : invariant(!eventQueue));
	  },

	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function() {
	    listenerBank = {};
	  },

	  __getListenerBank: function() {
	    return listenerBank;
	  }

	};

	module.exports = EventPluginHub;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */

	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

	'use strict';

	var EventPluginUtils = __webpack_require__(192);
	var ReactChildren = __webpack_require__(366);
	var ReactComponent = __webpack_require__(524);
	var ReactClass = __webpack_require__(75);
	var ReactContext = __webpack_require__(369);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactElement = __webpack_require__(31);
	var ReactElementValidator = __webpack_require__(193);
	var ReactDOM = __webpack_require__(1113);
	var ReactDOMTextComponent = __webpack_require__(527);
	var ReactDefaultInjection = __webpack_require__(1124);
	var ReactInstanceHandles = __webpack_require__(159);
	var ReactMount = __webpack_require__(109);
	var ReactPerf = __webpack_require__(141);
	var ReactPropTypes = __webpack_require__(531);
	var ReactReconciler = __webpack_require__(161);
	var ReactServerRendering = __webpack_require__(1135);

	var assign = __webpack_require__(15);
	var findDOMNode = __webpack_require__(535);
	var onlyChild = __webpack_require__(245);

	ReactDefaultInjection.inject();

	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;

	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}

	var render = ReactPerf.measure('React', 'render', ReactMount.render);

	var React = {
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    only: onlyChild
	  },
	  Component: ReactComponent,
	  DOM: ReactDOM,
	  PropTypes: ReactPropTypes,
	  initializeTouchEvents: function(shouldUseTouch) {
	    EventPluginUtils.useTouchEvents = shouldUseTouch;
	  },
	  createClass: ReactClass.createClass,
	  createElement: createElement,
	  cloneElement: cloneElement,
	  createFactory: createFactory,
	  createMixin: function(mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	  constructAndRenderComponent: ReactMount.constructAndRenderComponent,
	  constructAndRenderComponentByID: ReactMount.constructAndRenderComponentByID,
	  findDOMNode: findDOMNode,
	  render: render,
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  isValidElement: ReactElement.isValidElement,
	  withContext: ReactContext.withContext,

	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};

	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}

	if (false) {
	  var ExecutionEnvironment = require("./ExecutionEnvironment");
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

	    // If we're in Chrome, look for the devtools marker and provide a download
	    // link if not installed.
	    if (navigator.userAgent.indexOf('Chrome') > -1) {
	      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	        console.debug(
	          'Download the React DevTools for a better development experience: ' +
	          'http://fb.me/react-devtools'
	        );
	      }
	    }

	    var expectedFeatures = [
	      // shims
	      Array.isArray,
	      Array.prototype.every,
	      Array.prototype.forEach,
	      Array.prototype.indexOf,
	      Array.prototype.map,
	      Date.now,
	      Function.prototype.bind,
	      Object.keys,
	      String.prototype.split,
	      String.prototype.trim,

	      // shams
	      Object.create,
	      Object.freeze
	    ];

	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error(
	          'One or more ES5 shim/shams expected by React are not available: ' +
	          'http://fb.me/react-warning-polyfills'
	        );
	        break;
	      }
	    }
	  }
	}

	React.version = '0.13.2';

	module.exports = React;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactFragment
	*/

	'use strict';

	var ReactElement = __webpack_require__(31);

	var warning = __webpack_require__(26);

	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set a fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is opaque, for now.
	 */

	if (false) {
	  var fragmentKey = '_reactFragment';
	  var didWarnKey = '_reactDidWarn';
	  var canWarnForReactFragment = false;

	  try {
	    // Feature test. Don't even try to issue this warning if we can't use
	    // enumerable: false.

	    var dummy = function() {
	      return 1;
	    };

	    Object.defineProperty(
	      {},
	      fragmentKey,
	      {enumerable: false, value: true}
	    );

	    Object.defineProperty(
	      {},
	      'key',
	      {enumerable: true, get: dummy}
	    );

	    canWarnForReactFragment = true;
	  } catch (x) { }

	  var proxyPropertyAccessWithWarning = function(obj, key) {
	    Object.defineProperty(obj, key, {
	      enumerable: true,
	      get: function() {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an opaque type. Accessing any of its ' +
	          'properties is deprecated. Pass it to one of the React.Children ' +
	          'helpers.'
	        ) : null);
	        this[didWarnKey] = true;
	        return this[fragmentKey][key];
	      },
	      set: function(value) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an immutable opaque type. Mutating its ' +
	          'properties is deprecated.'
	        ) : null);
	        this[didWarnKey] = true;
	        this[fragmentKey][key] = value;
	      }
	    });
	  };

	  var issuedWarnings = {};

	  var didWarnForFragment = function(fragment) {
	    // We use the keys and the type of the value as a heuristic to dedupe the
	    // warning to avoid spamming too much.
	    var fragmentCacheKey = '';
	    for (var key in fragment) {
	      fragmentCacheKey += key + ':' + (typeof fragment[key]) + ',';
	    }
	    var alreadyWarnedOnce = !!issuedWarnings[fragmentCacheKey];
	    issuedWarnings[fragmentCacheKey] = true;
	    return alreadyWarnedOnce;
	  };
	}

	var ReactFragment = {
	  // Wrap a keyed object in an opaque proxy that warns you if you access any
	  // of its properties.
	  create: function(object) {
	    if (false) {
	      if (typeof object !== 'object' || !object || Array.isArray(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment only accepts a single object.',
	          object
	        ) : null);
	        return object;
	      }
	      if (ReactElement.isValidElement(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment does not accept a ReactElement ' +
	          'without a wrapper object.'
	        ) : null);
	        return object;
	      }
	      if (canWarnForReactFragment) {
	        var proxy = {};
	        Object.defineProperty(proxy, fragmentKey, {
	          enumerable: false,
	          value: object
	        });
	        Object.defineProperty(proxy, didWarnKey, {
	          writable: true,
	          enumerable: false,
	          value: false
	        });
	        for (var key in object) {
	          proxyPropertyAccessWithWarning(proxy, key);
	        }
	        Object.preventExtensions(proxy);
	        return proxy;
	      }
	    }
	    return object;
	  },
	  // Extract the original keyed object from the fragment opaque type. Warn if
	  // a plain object is passed here.
	  extract: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        if (!fragment[fragmentKey]) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnForFragment(fragment),
	            'Any use of a keyed object should be wrapped in ' +
	            'React.addons.createFragment(object) before being passed as a ' +
	            'child.'
	          ) : null);
	          return fragment;
	        }
	        return fragment[fragmentKey];
	      }
	    }
	    return fragment;
	  },
	  // Check if this is a fragment and if so, extract the keyed object. If it
	  // is a fragment-like object, warn that it should be wrapped. Ignore if we
	  // can't determine what kind of object this is.
	  extractIfFragment: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        // If it is the opaque type, return the keyed object.
	        if (fragment[fragmentKey]) {
	          return fragment[fragmentKey];
	        }
	        // Otherwise, check each property if it has an element, if it does
	        // it is probably meant as a fragment, so we can warn early. Defer,
	        // the warning to extract.
	        for (var key in fragment) {
	          if (fragment.hasOwnProperty(key) &&
	              ReactElement.isValidElement(fragment[key])) {
	            // This looks like a fragment object, we should provide an
	            // early warning.
	            return ReactFragment.extract(fragment);
	          }
	        }
	      }
	    }
	    return fragment;
	  }
	};

	module.exports = ReactFragment;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */

	'use strict';

	var ReactRootIndex = __webpack_require__(533);

	var invariant = __webpack_require__(11);

	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;

	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 100;

	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}

	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}

	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || (
	    id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR
	  );
	}

	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return (
	    descendantID.indexOf(ancestorID) === 0 &&
	    isBoundary(descendantID, ancestorID.length)
	  );
	}

	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}

	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  (false ? invariant(
	    isValidID(ancestorID) && isValidID(destinationID),
	    'getNextDescendantID(%s, %s): Received an invalid React DOM ID.',
	    ancestorID,
	    destinationID
	  ) : invariant(isValidID(ancestorID) && isValidID(destinationID)));
	  (false ? invariant(
	    isAncestorIDOf(ancestorID, destinationID),
	    'getNextDescendantID(...): React has made an invalid assumption about ' +
	    'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.',
	    ancestorID,
	    destinationID
	  ) : invariant(isAncestorIDOf(ancestorID, destinationID)));
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}

	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  (false ? invariant(
	    isValidID(longestCommonID),
	    'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s',
	    oneID,
	    twoID,
	    longestCommonID
	  ) : invariant(isValidID(longestCommonID)));
	  return longestCommonID;
	}

	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  (false ? invariant(
	    start !== stop,
	    'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.',
	    start
	  ) : invariant(start !== stop));
	  var traverseUp = isAncestorIDOf(stop, start);
	  (false ? invariant(
	    traverseUp || isAncestorIDOf(start, stop),
	    'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' +
	    'not have a parent path.',
	    start,
	    stop
	  ) : invariant(traverseUp || isAncestorIDOf(start, stop)));
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start; /* until break */; id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    (false ? invariant(
	      depth++ < MAX_TREE_DEPTH,
	      'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' +
	      'traversing the React DOM ID tree. This may be due to malformed IDs: %s',
	      start, stop
	    ) : invariant(depth++ < MAX_TREE_DEPTH));
	  }
	}

	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {

	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function() {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },

	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function(rootID, name) {
	    return rootID + name;
	  },

	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function(id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },

	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function(leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },

	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function(targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },

	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function(targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getFirstCommonAncestorID: getFirstCommonAncestorID,

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,

	  isAncestorIDOf: isAncestorIDOf,

	  SEPARATOR: SEPARATOR

	};

	module.exports = ReactInstanceHandles;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */

	'use strict';

	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */

	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {

	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function(key) {
	    key._reactInternalInstance = undefined;
	  },

	  get: function(key) {
	    return key._reactInternalInstance;
	  },

	  has: function(key) {
	    return key._reactInternalInstance !== undefined;
	  },

	  set: function(key, value) {
	    key._reactInternalInstance = value;
	  }

	};

	module.exports = ReactInstanceMap;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */

	'use strict';

	var ReactRef = __webpack_require__(1134);
	var ReactElementValidator = __webpack_require__(193);

	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}

	var ReactReconciler = {

	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(
	        internalInstance._currentElement
	      );
	    }
	    transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    return markup;
	  },

	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function(internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },

	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function(
	    internalInstance, nextElement, transaction, context
	  ) {
	    var prevElement = internalInstance._currentElement;

	    if (nextElement === prevElement && nextElement._owner != null) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }

	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }

	    var refsChanged = ReactRef.shouldUpdateRefs(
	      prevElement,
	      nextElement
	    );

	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }

	    internalInstance.receiveComponent(nextElement, transaction, context);

	    if (refsChanged) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },

	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(
	    internalInstance,
	    transaction
	  ) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }

	};

	module.exports = ReactReconciler;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticEvent = __webpack_require__(110);

	var getEventTarget = __webpack_require__(380);

	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function(event) {
	    if (event.view) {
	      return event.view;
	    }

	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }

	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function(event) {
	    return event.detail || 0;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

	module.exports = SyntheticUIEvent;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule cx
	 */

	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */

	'use strict';
	var warning = __webpack_require__(26);

	var warned = false;

	function cx(classNames) {
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      warned,
	      'React.addons.classSet will be deprecated in a future version. See ' +
	      'http://fb.me/react-addons-classset'
	    ) : null);
	    warned = true;
	  }

	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function(className) {
	      return classNames[className];
	    }).join(' ');
	  } else {
	    return Array.prototype.join.call(arguments, ' ');
	  }
	}

	module.exports = cx;


/***/ },
/* 164 */,
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(904);

	var Counter = React.createClass({
	  displayName: 'Counter',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    onClick: PropTypes.func,
	    count: PropTypes.number.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.onClick && 'clickable'];
	  },

	  render: function render() {
	    return React.createElement(
	      'span',
	      { className: this.getClassName(),
	        onClick: this.props.onClick },
	      this.props.count
	    );
	  }
	});

	module.exports = Counter;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _storesRouterStore = __webpack_require__(120);

	var _storesRouterStore2 = _interopRequireDefault(_storesRouterStore);

	'use strict';

	/**
	 * Provides exact same functionality to react-router's ActiveState mixin
	 * but without relying on context propagation that breaks shouldComponentUpdate:
	 *
	 * https://github.com/rackt/react-router/issues/470
	 * https://github.com/facebook/react/issues/2517
	 */
	var RouterStateMixin = {
	  getRouterState: function getRouterState() {
	    return {
	      routerState: _storesRouterStore2['default'].getRouterState()
	    };
	  },

	  getInitialState: function getInitialState() {
	    return this.getRouterState();
	  },

	  componentWillMount: function componentWillMount() {
	    _storesRouterStore2['default'].addChangeListener(this.handleRouterStateChange);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    _storesRouterStore2['default'].removeChangeListener(this.handleRouterStateChange);
	  },

	  handleRouterStateChange: function handleRouterStateChange() {
	    this.setState(this.getRouterState());
	  }
	};

	exports['default'] = RouterStateMixin;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);

	/**
	 * Listens to `transitionend` event on component's DOM node.
	 * Calls `handleTransitionEnd` when transitionend occurs.
	 */
	var TransitionEventsMixin = {
	  componentDidMount: function componentDidMount() {
	    if (!_.isFunction(this.handleTransitionEnd)) {
	      throw new Error('Define handleTransitionEnd to listen to transition events.');
	    }

	    this._bindTransitionEvents();
	  },

	  componentWillUpdate: function componentWillUpdate() {
	    this._unbindTransitionEvents();
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    this._bindTransitionEvents();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this._unbindTransitionEvents();
	  },

	  _bindTransitionEvents: function _bindTransitionEvents() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var node = this.getDOMNode();
	    node.addEventListener('transitionend', this._handleTransitionEnd);
	    node.addEventListener('webkitTransitionEnd', this._handleTransitionEnd);
	  },

	  _unbindTransitionEvents: function _unbindTransitionEvents() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var node = this.getDOMNode();
	    node.removeEventListener('transitionend', this._handleTransitionEnd);
	    node.removeEventListener('webkitTransitionEnd', this._handleTransitionEnd);
	  },

	  _handleTransitionEnd: function _handleTransitionEnd(e) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (e.target === e.currentTarget) {
	      this.handleTransitionEnd(e);
	    }
	  },

	  _withDOMNode: function _withDOMNode(action) {
	    if (this.isMounted()) {
	      action.call(this, this.getDOMNode());
	    }
	  }
	};

	module.exports = TransitionEventsMixin;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	/**
	 * Keeps track of whether component's DOM node is visible in viewport.
	 *
	 * You can optionally define a method called `getViewportLookaheadHeight`
	 * to specify how many pixels above or below the viewport will nevertheless
	 * be counted as "inside the viewport".
	 */
	var ViewportTestMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      isInViewport: false
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this._updateViewportState();
	    window.addEventListener('scroll', this._updateViewportState, false);
	    window.addEventListener('resize', this._updateViewportState, false);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('scroll', this._updateViewportState, false);
	    window.removeEventListener('resize', this._updateViewportState, false);
	  },

	  _updateViewportState: function _updateViewportState() {
	    if (this.isMounted()) {
	      this.setState(this._getViewportState());
	    }
	  },

	  _getViewportState: function _getViewportState() {
	    return {
	      isInViewport: this._isInViewport()
	    };
	  },

	  _isInViewport: function _isInViewport() {
	    var el = this.getDOMNode(),
	        rect = el.getBoundingClientRect();

	    return rect.height > 0 && rect.bottom >= 0 && rect.top <= window.innerHeight && rect.right >= 0 && rect.left <= window.innerWidth;
	  }
	};

	module.exports = ViewportTestMixin;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var invariant = __webpack_require__(11);
	var AnalyticsSources = __webpack_require__(34);
	var _require = __webpack_require__(4);

	var values = _require.values;

	function createAnalyticsContextMixin(source) {
	  invariant(typeof source === 'string', 'Expected a source.');

	  return {
	    childContextTypes: {
	      source: React.PropTypes.oneOf(values(AnalyticsSources)).isRequired
	    },

	    getChildContext: function getChildContext() {
	      return {
	        source: source
	      };
	    }
	  };
	}

	module.exports = createAnalyticsContextMixin;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var AudioProgress = __webpack_require__(580);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var gradient = __webpack_require__(123);
	var PlayerActionCreators = __webpack_require__(84);var PropTypes = React.PropTypes;

	__webpack_require__(930);

	var AudioCover = React.createClass({
	  displayName: 'AudioCover',

	  mixins: [ResponsiveImageQueueMixin, PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    size: React.PropTypes.oneOf(['small', 'large']).isRequired,
	    linkUrl: PropTypes.string.isRequired,
	    artwork: PropTypes.object.isRequired,
	    colors: PropTypes.shape({
	      top: PropTypes.string.isRequired,
	      bottom: PropTypes.string.isRequired
	    }).isRequired,
	    duration: PropTypes.number.isRequired,
	    alwaysShowControls: PropTypes.bool,
	    isPlaying: PropTypes.bool.isRequired,
	    isPaused: PropTypes.bool.isRequired,
	    onPlay: PropTypes.func.isRequired,
	    onPause: PropTypes.func.isRequired,
	    onForward: PropTypes.func.isRequired,
	    onBackward: PropTypes.func.isRequired,
	    currentTime: PropTypes.number.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'large'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      showControls: this.shouldShowControls(),
	      showProgress: this.shouldShowProgress()
	    };
	  },

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: this.props.artwork,
	      mode: 'scale_crop',
	      sizes: {
	        normal: true,
	        retina: devicePixelRatio > 1.5
	      }
	    };
	  },

	  getImageSizes: function getImageSizes() {
	    if (this.props.size === 'small') {
	      return {
	        'default': 112,
	        'xs': 112,
	        'sm': 112,
	        'md': 112,
	        'lg': 112,
	        'xl': 112
	      };
	    } else {
	      return {
	        'default': 480,
	        'xs': 640,
	        'sm': 288,
	        'md': 320,
	        'lg': 320,
	        'xl': 320
	      };
	    }
	  },

	  shouldShowControls: function shouldShowControls() {
	    return this.props.alwaysShowControls || this.props.isPlaying || this.props.isPaused;
	  },

	  shouldShowProgress: function shouldShowProgress() {
	    return this.props.isPlaying || this.props.isPaused;
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.artwork !== this.props.artwork) {
	      this.updateImageQueue();
	    }
	  },

	  getStyle: function getStyle() {
	    var colors = this.props.colors;
	    var background;

	    background = this.hasLoadedImage() ? this.getBackgroundImageUrl() : gradient('#' + colors.top, '#' + colors.bottom);

	    return {
	      backgroundImage: background
	    };
	  },

	  render: function render() {
	    var isLarge = this.props.size === 'large',
	        playIconSize = isLarge ? 'large' : 'small',
	        previousNextIconSize = isLarge ? 'small' : 'xxsmall',
	        playSize = isLarge ? 'xxlarge' : 'medium';

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: this.getStyle() },
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        { className: 'AudioCover-box' },
	        React.createElement(
	          'div',
	          { className: 'AudioCover-logo' },
	          React.createElement(
	            'a',
	            { target: '_blank',
	              href: this.props.linkUrl },
	            React.createElement('img', { className: 'AudioCover-logoImg',
	              src: '//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/soundcloud-logo--light.svg' })
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'AudioCover-backward' },
	          React.createElement(Icon, { name: 'backward',
	            size: previousNextIconSize,
	            mode: 'stroke',
	            onClick: this.handleBackwardClick })
	        ),
	        this.props.isPlaying && React.createElement(
	          Button,
	          { size: playSize,
	            context: 'AudioCover',
	            color: 'black',
	            overlay: true,
	            round: true,
	            className: 'AudioCover-pause',
	            onClick: this.props.onPause },
	          React.createElement(Icon, { name: 'pause',
	            size: playIconSize,
	            mode: 'stroke' })
	        ),
	        !this.props.isPlaying && React.createElement(
	          Button,
	          { size: playSize,
	            context: 'AudioCover',
	            color: 'black',
	            overlay: true,
	            round: true,
	            className: 'AudioCover-play',
	            onClick: this.props.onPlay },
	          React.createElement(Icon, { name: 'play',
	            size: playIconSize,
	            mode: 'stroke' })
	        ),
	        React.createElement(
	          'div',
	          { className: 'AudioCover-forward' },
	          React.createElement(Icon, { name: 'forward',
	            size: previousNextIconSize,
	            mode: 'stroke',
	            onClick: this.handleForwardClick })
	        ),
	        React.createElement(
	          'div',
	          { className: 'AudioCover-progress' },
	          React.createElement(AudioProgress, { currentTime: this.props.currentTime,
	            trackDuration: this.props.duration,
	            onChangeTime: this.handleProgressChangeTime,
	            context: this.props.context })
	        )
	      ),
	      this.props.children
	    );
	  },

	  handleProgressChangeTime: function handleProgressChangeTime(time) {
	    PlayerActionCreators.setCurrentTime(this.props.uuid, time);
	  },

	  handleBackwardClick: function handleBackwardClick() {
	    this.props.onBackward();
	  },

	  handleForwardClick: function handleForwardClick() {
	    this.setState({
	      currentTime: 0
	    });

	    this.props.onForward();
	  }
	});

	module.exports = AudioCover;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	__webpack_require__(947);

	var TabBar = _react2['default'].createClass({
	  displayName: 'TabBar',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsBackColorMixin2['default'], _mixinsPureRenderMixin2['default']],

	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      { className: this.getClassName() },
	      _react.Children.map(this.props.children, this.renderTabBarItem)
	    );
	  },

	  renderTabBarItem: function renderTabBarItem(item, index) {
	    return _react2['default'].createElement(
	      'li',
	      { key: index, className: 'TabBar-item' },
	      item
	    );
	  }
	});

	exports['default'] = TabBar;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defineProperty = __webpack_require__(181)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;
	var Children = React.Children;

	__webpack_require__(952);

	var AboutSection = React.createClass({
	  displayName: 'AboutSection',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    layout: PropTypes.oneOf(['full', 'section', 'banner']).isRequired,
	    active: PropTypes.bool.isRequired,
	    title: PropTypes.string.isRequired,
	    subtitle: PropTypes.string,
	    showLogo: PropTypes.bool,
	    footer: PropTypes.element,
	    color: PropTypes.string.isRequired,
	    backgroundColor: PropTypes.string.isRequired,
	    backgroundImage: PropTypes.string,
	    needsTopMarginOnTablet: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: true,
	      showLogo: false
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _ref;

	    var _props = this.props;
	    var layout = _props.layout;
	    var needsTopMarginOnTablet = _props.needsTopMarginOnTablet;
	    var active = _props.active;

	    return (_ref = {}, _defineProperty(_ref, layout, true), _defineProperty(_ref, 'needsTopMarginOnTablet', needsTopMarginOnTablet), _defineProperty(_ref, 'inactive', !active), _ref);
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: {
	          color: this.props.color,
	          backgroundColor: this.props.backgroundColor,
	          backgroundImage: this.props.backgroundImage,
	          backgroundSize: 'cover',
	          backgroundPosition: 'center'
	        } },
	      this.props.layout === 'full' ? this.props.children : this.renderSection()
	    );
	  },

	  renderSection: function renderSection() {
	    var _props2 = this.props;
	    var title = _props2.title;
	    var subtitle = _props2.subtitle;
	    var children = _props2.children;
	    var showLogo = _props2.showLogo;
	    var hasChildren = Children.count(children) > 0;

	    return [React.createElement(
	      'div',
	      { className: 'AboutSection-header', key: 'header' },
	      showLogo && React.createElement(
	        'h1',
	        { className: 'AboutSection-logo' },
	        'Stampsy'
	      ),
	      React.createElement(
	        'h2',
	        { className: 'AboutSection-title' },
	        title
	      ),
	      subtitle && React.createElement(
	        'h3',
	        { className: 'AboutSection-subtitle' },
	        subtitle
	      )
	    ), hasChildren && React.createElement(
	      'div',
	      { className: 'AboutSection-extra', key: 'extra' },
	      children
	    ), this.props.footer && React.createElement(
	      'div',
	      { className: 'AboutSection-footer', key: 'footer' },
	      this.props.footer
	    )];
	  }
	});

	module.exports = AboutSection;

/***/ },
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);
	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var UserStore = __webpack_require__(5);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;

	var mergeIntoBag = _require.mergeIntoBag;
	var update = __webpack_require__(49);
	var ServiceTypes = __webpack_require__(35);

	var _serviceAccounts = {},
	    _deleted = {},
	    _authServiceTypes = [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE],
	    _allServiceTypes = [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE, ServiceTypes.TUMBLR];

	function _get(id, allowDeleted) {
	  var serviceAccount = _serviceAccounts[id];
	  return serviceAccount && (allowDeleted || !_deleted[serviceAccount.id]) ? serviceAccount : null;
	}

	function _getByType(userId, serviceType, allowDeleted) {
	  var serviceIds = UserStore.get(userId).services;

	  return _.chain(serviceIds).map(function (id) {
	    return _get(id, allowDeleted);
	  }).find(function (acc) {
	    return acc && acc.serviceType === serviceType;
	  }).value();
	}

	function deleteByType(userId, serviceType) {
	  var serviceAccount = _getByType(userId, serviceType);
	  if (serviceAccount) {
	    _deleted[serviceAccount.id] = true;
	  }
	}

	function restoreByType(userId, serviceType) {
	  var serviceAccount = _getByType(userId, serviceType, true);
	  if (serviceAccount) {
	    delete _deleted[serviceAccount.id];
	  }
	}

	function _isAuthService(acc) {
	  return acc && _authServiceTypes.indexOf(acc.serviceType) !== -1;
	}

	var ServiceAccountStore = createStore({
	  get: function get(id) {
	    return _get(id);
	  },

	  getByType: function getByType(userId, serviceType) {
	    return _getByType(userId, serviceType);
	  },

	  getUserVisibleServiceAccounts: function getUserVisibleServiceAccounts(userId) {
	    return _.chain(_allServiceTypes).map(function (serviceType) {
	      return _getByType(userId, serviceType);
	    }).compact().filter(function (acc) {
	      return !acc.hidden;
	    }).value();
	  },

	  getUserServiceAccounts: function getUserServiceAccounts(userId) {
	    return _.chain(_allServiceTypes).map(function (serviceType) {
	      return [serviceType, _getByType(userId, serviceType)];
	    }).object().value();
	  },

	  getConnectedAuthServiceAccounts: function getConnectedAuthServiceAccounts(userId) {
	    var serviceIds = UserStore.get(userId).services;

	    return _.chain(serviceIds).map(function (id) {
	      return _get(id);
	    }).filter(function (acc) {
	      return _isAuthService(acc);
	    }).compact().value();
	  },

	  isConnected: function isConnected(userId, serviceType) {
	    return !!_getByType(userId, serviceType);
	  },

	  isAuthService: function isAuthService(userId, serviceType) {
	    return _isAuthService(_getByType(userId, serviceType));
	  }
	});

	ServiceAccountStore.dispatchToken = AppDispatcher.register(function (payload) {
	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      receivedServiceAccounts = entities && entities.serviceAccounts,
	      serviceAccount;

	  switch (action.type) {
	    case ActionTypes.DISCONNECT_SERVICE_ACCOUNT:
	      deleteByType(UserStore.getMe().id, action.serviceType);
	      ServiceAccountStore.emitChange();
	      break;

	    case ActionTypes.DISCONNECT_SERVICE_ACCOUNT_ERROR:
	      restoreByType(UserStore.getMe().id, action.serviceType);
	      ServiceAccountStore.emitChange();
	      break;

	    case ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN:
	    case ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR:
	      serviceAccount = _getByType(UserStore.getMe().id, action.serviceType);
	      _serviceAccounts[serviceAccount.id] = update(serviceAccount, {
	        hidden: {
	          $apply: function $apply(x) {
	            return !x;
	          }
	        }
	      });
	      ServiceAccountStore.emitChange();
	      break;

	    default:
	      if (receivedServiceAccounts) {
	        mergeIntoBag(_serviceAccounts, receivedServiceAccounts);
	        ServiceAccountStore.emitChange();
	      }
	      break;
	  }
	});

	module.exports = ServiceAccountStore;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	/**
	 * Adapted from https://github.com/Khan/react-components/blob/master/js/timeout-transition-group.jsx
	 * with the following additions:
	 *
	 * - Use BEM-ish modifiers (--enter, --enter--active, --leave, --leave--active)
	 * - Work better with rAF batching strategy (see https://github.com/facebook/react/issues/2292)
	 *
	 * The CSSTransitionGroup component uses the 'transitionend' event, which
	 * browsers will not send for any number of reasons, including the
	 * transitioning node not being painted or in an unfocused tab.
	 *
	 * This TimeoutTransitionGroup instead uses a user-defined timeout to determine
	 * when it is a good time to remove the component. Currently there is only one
	 * timeout specified, but in the future it would be nice to be able to specify
	 * separate timeouts for enter and leave, in case the timeouts for those
	 * animations differ. Even nicer would be some sort of inspection of the CSS to
	 * automatically determine the duration of the animation or transition.
	 *
	 * This is adapted from Facebook's CSSTransitionGroup which is in the React
	 * addons and under the Apache 2.0 License.
	 */

	var React = __webpack_require__(1),
	    ReactTransitionGroup = __webpack_require__(374),
	    CSSCore = __webpack_require__(520);

	var TICK = 17;

	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },

	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};

	var endEvents = [];

	(function detectEvents() {
	  if (typeof document === 'undefined') {
	    console.log('document unavailable in node');
	    return;
	  }

	  var testEl = document.createElement('div');
	  var style = testEl.style;

	  // On some platforms, in particular some releases of Android 4.x, the
	  // un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }

	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }

	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	})();

	function animationSupported() {
	  return endEvents.length !== 0;
	}

	var TimeoutTransitionGroupChild = React.createClass({
	  displayName: 'TimeoutTransitionGroupChild',

	  transition: function transition(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '--' + animationType;
	    var activeClassName = className + '--active';

	    var endListener = function endListener() {

	      // https://github.com/facebook/react/issues/2292

	      // We differ from original implementation in that we don't want --leave classes
	      // to be removed here if element is to be removed from DOM anyway, as this
	      // causes flicker with alternative batching strategies.
	      // Instead, we only remove `enter` classes in the end callback.
	      // We will remove `leave` classes only if we're about to `enter` again (see below).
	      if (animationType === 'enter') {
	        CSSCore.removeClass(node, className);
	        CSSCore.removeClass(node, activeClassName);
	      }

	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };

	    // Remove `leave` class if we're about to `enter` again.
	    // (See rationale above.)
	    if (animationType === 'enter') {
	      CSSCore.removeClass(node, this.props.name + '--leave');
	      CSSCore.removeClass(node, this.props.name + '--leave--active');
	    }

	    if (!animationSupported()) {
	      endListener();
	    } else {
	      if (animationType === 'enter') {
	        this.animationTimeout = setTimeout(endListener, this.props.enterTimeout);
	      } else if (animationType === 'leave') {
	        this.animationTimeout = setTimeout(endListener, this.props.leaveTimeout);
	      }
	    }

	    CSSCore.addClass(node, className);

	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	  },

	  queueClass: function queueClass(className) {
	    this.classNameQueue.push(className);

	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },

	  flushClassNameQueue: function flushClassNameQueue() {
	    if (this.isMounted()) {
	      var node = this.getDOMNode();
	      this.classNameQueue.forEach(function (className) {
	        return CSSCore.addClass(node, className);
	      });
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },

	  componentWillMount: function componentWillMount() {
	    this.classNameQueue = [];
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    if (this.animationTimeout) {
	      clearTimeout(this.animationTimeout);
	    }
	  },

	  componentWillEnter: function componentWillEnter(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },

	  componentWillLeave: function componentWillLeave(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },

	  render: function render() {
	    return React.Children.only(this.props.children);
	  }
	});

	var TimeoutTransitionGroup = React.createClass({
	  displayName: 'TimeoutTransitionGroup',

	  propTypes: {
	    enterTimeout: React.PropTypes.number.isRequired,
	    leaveTimeout: React.PropTypes.number.isRequired,
	    transitionName: React.PropTypes.string.isRequired,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },

	  _wrapChild: function _wrapChild(child) {
	    return React.createElement(
	      TimeoutTransitionGroupChild,
	      {
	        enterTimeout: this.props.enterTimeout,
	        leaveTimeout: this.props.leaveTimeout,
	        name: this.props.transitionName,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave },
	      child
	    );
	  },

	  render: function render() {
	    return React.createElement(ReactTransitionGroup, _extends({}, this.props, {
	      childFactory: this._wrapChild }));
	  }
	});

	module.exports = TimeoutTransitionGroup;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Keep in sync with zine.py

	var DEFAULT_THUMBNAILS = [1, 2, 3, 4, 5].map(function (i) {
	  return '//stampsy-eu-1.s3.amazonaws.com/2014/10/13/images/collection-' + i + '.png';
	});

	function getZineThumbnail(zine) {
	  if (zine.thumbnailUrl) {
	    return {
	      isDefault: false,
	      url: zine.thumbnailUrl
	    };
	  }

	  return {
	    isDefault: true,
	    url: DEFAULT_THUMBNAILS[zine.id % DEFAULT_THUMBNAILS.length || 0]
	  };
	}

	module.exports = getZineThumbnail;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var UserStore = __webpack_require__(5),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58);

	function handleUnauthAction(source) {
	  if (!UserStore.isAuthenticated()) {
	    ModalActionCreators.showModal(ModalTypes.ABOUT, {
	      source: source
	    });
	    return true;
	  }
	}

	module.exports = handleUnauthAction;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(809), __esModule: true };

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _Object$defineProperty = __webpack_require__(12)["default"];

	exports["default"] = function (obj, key, value) {
	  return _Object$defineProperty(obj, key, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: true
	  });
	};

	exports.__esModule = true;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(25);
	function assert(condition, msg1, msg2){
	  if(!condition)throw TypeError(msg2 ? msg1 + msg2 : msg1);
	}
	assert.def = $.assertDefined;
	assert.fn = function(it){
	  if(!$.isFunction(it))throw TypeError(it + ' is not a function!');
	  return it;
	};
	assert.obj = function(it){
	  if(!$.isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};
	assert.inst = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};
	module.exports = assert;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(25)
	  , TAG      = __webpack_require__(124)('toStringTag')
	  , toString = {}.toString;
	function cof(it){
	  return toString.call(it).slice(8, -1);
	}
	cof.classof = function(it){
	  var O, T;
	  return it == undefined ? it === undefined ? 'Undefined' : 'Null'
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T : cof(O);
	};
	cof.set = function(it, tag, stat){
	  if(it && !$.has(it = stat ? it : it.prototype, TAG))$.hide(it, TAG, tag);
	};
	module.exports = cof;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(25)
	  , global     = $.g
	  , core       = $.core
	  , isFunction = $.isFunction;
	function ctx(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	}
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	function $def(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] : (global[name] || {}).prototype
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    if(isGlobal && !isFunction(target[key]))exp = source[key];
	    // bind timers to global for call from export context
	    else if(type & $def.B && own)exp = ctx(out, global);
	    // wrap global constructors for prevent change them in library
	    else if(type & $def.W && target[key] == out)!function(C){
	      exp = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      exp.prototype = C.prototype;
	    }(out);
	    else exp = isProto && isFunction(out) ? ctx(Function.call, out) : out;
	    // export
	    exports[key] = exp;
	    if(isProto)(exports.prototype || (exports.prototype = {}))[key] = out;
	  }
	}
	module.exports = $def;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var ctx  = __webpack_require__(125)
	  , get  = __webpack_require__(100).get
	  , call = __webpack_require__(466);
	module.exports = function(iterable, entries, fn, that){
	  var iterator = get(iterable)
	    , f        = ctx(fn, that, entries ? 2 : 1)
	    , step;
	  while(!(step = iterator.next()).done){
	    if(call(iterator, f, step.value, entries) === false){
	      return call.close(iterator);
	    }
	  }
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// =========
	// = humps =
	// =========
	// version 0.4.1
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys

	// humps is copyright © 2013 Dom Christie
	// Released under the MIT license.


	;(function(global) {

	  var _processKeys = function(convert, obj, separator) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj)) {
	      return obj;
	    }

	    var output,
	        i = 0,
	        l = 0;

	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], separator));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(obj.hasOwnProperty(key)) {
	          var val = obj[key];
	          if(_isArray(val)) {
	            var convertedArray = [];
	            i = 0;
	            for(l=val.length; i<l; i++) {
	              convertedArray.push(_processKeys(convert, val[i], separator));
	            }
	            output[convert(key, separator)] = convertedArray;
	          }
	          else if(_isObject(val)) {
	            output[convert(key, separator)] =
	              _processKeys(convert, val, separator);
	          }
	          else {
	            output[convert(key, separator)] = val;
	          }
	        }
	      }
	    }
	    return output;
	  };

	  // String conversion methods

	  var separateWords = function(string, separator) {
	    if (separator === undefined) {
	      separator = '_';
	    }
	    return string.replace(/([a-z])([A-Z0-9])/g, '$1'+ separator +'$2');
	  };

	  var camelize = function(string) {
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.replace(/^([A-Z])/, function(match, chr) {
	      return chr ? chr.toLowerCase() : '';
	    });
	  };

	  var pascalize = function(string) {
	    return camelize(string).replace(/^([a-z])/, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	  };

	  var decamelize = function(string, separator) {
	    return separateWords(string, separator).toLowerCase();
	  };

	  // Utilities
	  // Taken from Underscore.js

	  var toString = Object.prototype.toString;

	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };

	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object) {
	      return _processKeys(camelize, object);
	    },
	    decamelizeKeys: function(object, separator) {
	      return _processKeys(decamelize, object, separator);
	    },
	    pascalizeKeys: function(object) {
	      return _processKeys(pascalize, object);
	    },
	    depascalizeKeys: this.decamelizeKeys
	  };

	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }

	})(this);


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(353);

	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (typeof thisArg == 'undefined') {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}

	module.exports = bindCallback;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return (value && typeof value == 'object') || false;
	}

	module.exports = isObjectLike;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);

	/**
	 * Converts `value` to an object if it is not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}

	module.exports = toObject;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * Actions that modify the URL.
	 */
	var LocationActions = {

	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: "push",

	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: "replace",

	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: "pop"

	};

	module.exports = LocationActions;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */

	'use strict';

	var DOMProperty = __webpack_require__(155);

	var quoteAttributeValueForBrowser = __webpack_require__(1172);
	var warning = __webpack_require__(26);

	function shouldIgnoreValue(name, value) {
	  return value == null ||
	    (DOMProperty.hasBooleanValue[name] && !value) ||
	    (DOMProperty.hasNumericValue[name] && isNaN(value)) ||
	    (DOMProperty.hasPositiveNumericValue[name] && (value < 1)) ||
	    (DOMProperty.hasOverloadedBooleanValue[name] && value === false);
	}

	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};

	  var warnUnknownProperty = function(name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] ||
	        warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }

	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();

	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = (
	      DOMProperty.isCustomAttribute(lowerCasedName) ?
	        lowerCasedName :
	      DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ?
	        DOMProperty.getPossibleStandardName[lowerCasedName] :
	        null
	    );

	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ("production" !== process.env.NODE_ENV ? warning(
	      standardName == null,
	      'Unknown DOM property %s. Did you mean %s?',
	      name,
	      standardName
	    ) : null);

	  };
	}

	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {

	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' +
	      quoteAttributeValueForBrowser(id);
	  },

	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function(name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      if (shouldIgnoreValue(name, value)) {
	        return '';
	      }
	      var attributeName = DOMProperty.getAttributeName[name];
	      if (DOMProperty.hasBooleanValue[name] ||
	          (DOMProperty.hasOverloadedBooleanValue[name] && value === true)) {
	        return attributeName;
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },

	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function(node, name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(name, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        node.setAttribute(DOMProperty.getAttributeName[name], '' + value);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== ('' + value)) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        node.removeAttribute(name);
	      } else {
	        node.setAttribute(name, '' + value);
	      }
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },

	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function(node, name) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.removeAttribute(DOMProperty.getAttributeName[name]);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        var defaultValue = DOMProperty.getDefaultValueForProperty(
	          node.nodeName,
	          propName
	        );
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }

	};

	module.exports = DOMPropertyOperations;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);

	var invariant = __webpack_require__(11);

	/**
	 * Injected dependencies:
	 */

	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function(InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? invariant(
	        InjectedMount && InjectedMount.getNode,
	        'EventPluginUtils.injection.injectMount(...): Injected Mount module ' +
	        'is missing getNode.'
	      ) : invariant(InjectedMount && InjectedMount.getNode));
	    }
	  }
	};

	var topLevelTypes = EventConstants.topLevelTypes;

	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp ||
	         topLevelType === topLevelTypes.topTouchEnd ||
	         topLevelType === topLevelTypes.topTouchCancel;
	}

	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove ||
	         topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown ||
	         topLevelType === topLevelTypes.topTouchStart;
	}


	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;

	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ?
	      dispatchListeners.length :
	      dispatchListeners ? 1 : 0;

	    ("production" !== process.env.NODE_ENV ? invariant(
	      idsIsArr === listenersIsArr && IDsLen === listenersLen,
	      'EventPluginUtils: Invalid `event`.'
	    ) : invariant(idsIsArr === listenersIsArr && IDsLen === listenersLen));
	  };
	}

	/**
	 * Invokes `cb(event, listener, id)`. Avoids using call if no scope is
	 * provided. The `(listener,id)` pair effectively forms the "dispatch" but are
	 * kept separate to conserve memory.
	 */
	function forEachEventDispatch(event, cb) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      cb(event, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    cb(event, dispatchListeners, dispatchIDs);
	  }
	}

	/**
	 * Default implementation of PluginModule.executeDispatch().
	 * @param {SyntheticEvent} SyntheticEvent to handle
	 * @param {function} Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, listener, domID) {
	  event.currentTarget = injection.Mount.getNode(domID);
	  var returnValue = listener(event, domID);
	  event.currentTarget = null;
	  return returnValue;
	}

	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, cb) {
	  forEachEventDispatch(event, cb);
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}

	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return id of the first dispatch execution who's listener returns true, or
	 * null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}

	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}

	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  (false ? invariant(
	    !Array.isArray(dispatchListener),
	    'executeDirectDispatch(...): Invalid `event`.'
	  ) : invariant(!Array.isArray(dispatchListener)));
	  var res = dispatchListener ?
	    dispatchListener(event, dispatchID) :
	    null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}

	/**
	 * @param {SyntheticEvent} event
	 * @return {bool} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}

	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,

	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatch: executeDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	  injection: injection,
	  useTouchEvents: false
	};

	module.exports = EventPluginUtils;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */

	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactFragment = __webpack_require__(158);
	var ReactPropTypeLocations = __webpack_require__(373);
	var ReactPropTypeLocationNames = __webpack_require__(239);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactNativeComponent = __webpack_require__(238);

	var getIteratorFn = __webpack_require__(538);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}

	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};

	var loggedTypeFailures = {};

	var NUMERIC_PROPERTY_REGEX = /^\d+$/;

	/**
	 * Gets the instance's name for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getName(instance) {
	  var publicInstance = instance && instance.getPublicInstance();
	  if (!publicInstance) {
	    return undefined;
	  }
	  var constructor = publicInstance.constructor;
	  if (!constructor) {
	    return undefined;
	  }
	  return constructor.displayName || constructor.name || undefined;
	}

	/**
	 * Gets the current owner's displayName for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getCurrentOwnerDisplayName() {
	  var current = ReactCurrentOwner.current;
	  return (
	    current && getName(current) || undefined
	  );
	}

	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;

	  warnAndMonitorForKeyUse(
	    'Each child in an array or iterator should have a unique "key" prop.',
	    element,
	    parentType
	  );
	}

	/**
	 * Warn if the key is being defined as an object property but has an incorrect
	 * value.
	 *
	 * @internal
	 * @param {string} name Property name of the key.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validatePropertyKey(name, element, parentType) {
	  if (!NUMERIC_PROPERTY_REGEX.test(name)) {
	    return;
	  }
	  warnAndMonitorForKeyUse(
	    'Child objects should have non-numeric keys so ordering is preserved.',
	    element,
	    parentType
	  );
	}

	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} message The base warning that gets output.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function warnAndMonitorForKeyUse(message, element, parentType) {
	  var ownerName = getCurrentOwnerDisplayName();
	  var parentName = typeof parentType === 'string' ?
	    parentType : parentType.displayName || parentType.name;

	  var useName = ownerName || parentName;
	  var memoizer = ownerHasKeyUseWarning[message] || (
	    (ownerHasKeyUseWarning[message] = {})
	  );
	  if (memoizer.hasOwnProperty(useName)) {
	    return;
	  }
	  memoizer[useName] = true;

	  var parentOrOwnerAddendum =
	    ownerName ? (" Check the render method of " + ownerName + ".") :
	    parentName ? (" Check the React.render call using <" + parentName + ">.") :
	    '';

	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwnerAddendum = '';
	  if (element &&
	      element._owner &&
	      element._owner !== ReactCurrentOwner.current) {
	    // Name of the component that originally created this child.
	    var childOwnerName = getName(element._owner);

	    childOwnerAddendum = (" It was passed a child from " + childOwnerName + ".");
	  }

	  (false ? warning(
	    false,
	    message + '%s%s See http://fb.me/react-warning-keys for more information.',
	    parentOrOwnerAddendum,
	    childOwnerAddendum
	  ) : null);
	}

	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    node._store.validated = true;
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    } else if (typeof node === 'object') {
	      var fragment = ReactFragment.extractIfFragment(node);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          validatePropertyKey(key, fragment[key], parentType);
	        }
	      }
	    }
	  }
	}

	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        (false ? invariant(
	          typeof propTypes[propName] === 'function',
	          '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	          'React.PropTypes.',
	          componentName || 'React class',
	          ReactPropTypeLocationNames[location],
	          propName
	        ) : invariant(typeof propTypes[propName] === 'function'));
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;

	        var addendum = getDeclarationErrorAddendum(this);
	        (false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : null);
	      }
	    }
	  }
	}

	var warnedPropsMutations = {};

	/**
	 * Warn about mutating props when setting `propName` on `element`.
	 *
	 * @param {string} propName The string key within props that was set
	 * @param {ReactElement} element
	 */
	function warnForPropsMutation(propName, element) {
	  var type = element.type;
	  var elementName = typeof type === 'string' ? type : type.displayName;
	  var ownerName = element._owner ?
	    element._owner.getPublicInstance().constructor.displayName : null;

	  var warningKey = propName + '|' + elementName + '|' + ownerName;
	  if (warnedPropsMutations.hasOwnProperty(warningKey)) {
	    return;
	  }
	  warnedPropsMutations[warningKey] = true;

	  var elementInfo = '';
	  if (elementName) {
	    elementInfo = ' <' + elementName + ' />';
	  }
	  var ownerInfo = '';
	  if (ownerName) {
	    ownerInfo = ' The element was created by ' + ownerName + '.';
	  }

	  (false ? warning(
	    false,
	    'Don\'t set .props.%s of the React component%s. Instead, specify the ' +
	    'correct value when initially creating the element or use ' +
	    'React.cloneElement to make a new element with updated props.%s',
	    propName,
	    elementInfo,
	    ownerInfo
	  ) : null);
	}

	// Inline Object.is polyfill
	function is(a, b) {
	  if (a !== a) {
	    // NaN
	    return b !== b;
	  }
	  if (a === 0 && b === 0) {
	    // +-0
	    return 1 / a === 1 / b;
	  }
	  return a === b;
	}

	/**
	 * Given an element, check if its props have been mutated since element
	 * creation (or the last call to this function). In particular, check if any
	 * new props have been added, which we can't directly catch by defining warning
	 * properties on the props object.
	 *
	 * @param {ReactElement} element
	 */
	function checkAndWarnForMutatedProps(element) {
	  if (!element._store) {
	    // Element was created using `new ReactElement` directly or with
	    // `ReactElement.createElement`; skip mutation checking
	    return;
	  }

	  var originalProps = element._store.originalProps;
	  var props = element.props;

	  for (var propName in props) {
	    if (props.hasOwnProperty(propName)) {
	      if (!originalProps.hasOwnProperty(propName) ||
	          !is(originalProps[propName], props[propName])) {
	        warnForPropsMutation(propName, element);

	        // Copy over the new value so that the two props objects match again
	        originalProps[propName] = props[propName];
	      }
	    }
	  }
	}

	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  if (element.type == null) {
	    // This has already warned. Don't throw.
	    return;
	  }
	  // Extract the component class from the element. Converts string types
	  // to a composite class which may have propTypes.
	  // TODO: Validating a string's propTypes is not decoupled from the
	  // rendering target which is problematic.
	  var componentClass = ReactNativeComponent.getComponentClassForElement(
	    element
	  );
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(
	      name,
	      componentClass.propTypes,
	      element.props,
	      ReactPropTypeLocations.prop
	    );
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    (false ? warning(
	      componentClass.getDefaultProps.isReactClassApproved,
	      'getDefaultProps is only used on classic React.createClass ' +
	      'definitions. Use a static property named `defaultProps` instead.'
	    ) : null);
	  }
	}

	var ReactElementValidator = {

	  checkAndWarnForMutatedProps: checkAndWarnForMutatedProps,

	  createElement: function(type, props, children) {
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    (false ? warning(
	      type != null,
	      'React.createElement: type should not be null or undefined. It should ' +
	        'be a string (for DOM elements) or a ReactClass (for composite ' +
	        'components).'
	    ) : null);

	    var element = ReactElement.createElement.apply(this, arguments);

	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }

	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], type);
	    }

	    validatePropTypes(element);

	    return element;
	  },

	  createFactory: function(type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(
	      null,
	      type
	    );
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;

	    if (false) {
	      try {
	        Object.defineProperty(
	          validatedFactory,
	          'type',
	          {
	            enumerable: false,
	            get: function() {
	              ("production" !== process.env.NODE_ENV ? warning(
	                false,
	                'Factory.type is deprecated. Access the class directly ' +
	                'before passing it to createFactory.'
	              ) : null);
	              Object.defineProperty(this, 'type', {
	                value: type
	              });
	              return type;
	            }
	          }
	        );
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }


	    return validatedFactory;
	  },

	  cloneElement: function(element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }

	};

	module.exports = ReactElementValidator;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */

	'use strict';

	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};

	var ESCAPE_REGEX = /[&><"']/g;

	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}

	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}

	module.exports = escapeTextContentForBrowser;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    AppDispatcher = __webpack_require__(6),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55),
	    InvitationAPI = __webpack_require__(391),
	    ActionUtils = __webpack_require__(133),
	    SentInvitationStore = __webpack_require__(425),
	    SocialFriendListStore = __webpack_require__(290);

	var InvitationActionCreators = {
	  requestInvitationsPage: function requestInvitationsPage(isInitialRequest) {
	    ActionUtils.requestPage({
	      isInitialRequest: isInitialRequest,
	      store: SentInvitationStore,
	      action: ActionTypes.REQUEST_INVITATIONS,
	      callAPI: InvitationAPI.requestInvitationsPage
	    });
	  },

	  requestSocialFriendsPage: function requestSocialFriendsPage(serviceType, isInitialRequest) {
	    ActionUtils.requestIndexedPage({
	      serviceType: serviceType,
	      idAttribute: 'serviceType',
	      isInitialRequest: isInitialRequest,
	      store: SocialFriendListStore,
	      action: ActionTypes.REQUEST_SOCIAL_FRIENDS,
	      callAPI: InvitationAPI.requestSocialFriendsPage
	    });
	  },

	  sendInvite: function sendInvite(invite) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SEND_INVITE
	    });

	    InvitationAPI.sendInvite(invite);

	    Analytics.trackGAEvent(AnalyticsEvents.FORMS_SEND_INVITE_SEND, invite.serviceType);
	    Analytics.trackEvent(AnalyticsEvents.FORMS_SEND_INVITE_SEND, {
	      serviceType: invite.serviceType,
	      serviceId: invite.serviceId,
	      name: invite.name
	    });
	  },

	  resendInvite: function resendInvite(invite) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.RESEND_INVITE
	    });

	    InvitationAPI.resendInvite(invite.id);
	  }
	};

	module.exports = InvitationActionCreators;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    ClassNameMixin = __webpack_require__(3),
	    FormLink = __webpack_require__(148),
	    SyntheticEvent = __webpack_require__(110),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(906);

	var FormInput = React.createClass({
	  displayName: 'FormInput',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    component: React.PropTypes.any,
	    formLink: React.PropTypes.instanceOf(FormLink).isRequired,
	    valueLink: function valueLink(props, propName) {
	      if (props[propName]) {
	        console.warn('Cannot use valueLink with FormInput. Use formLink instead.');
	      }
	    },
	    size: React.PropTypes.oneOf(['small', 'normal']),
	    hasMinHeight: React.PropTypes.bool,
	    color: React.PropTypes.oneOf(['light', 'dark']).isRequired,
	    placeholder: React.PropTypes.string,
	    type: React.PropTypes.string,
	    name: React.PropTypes.string,
	    autofill: React.PropTypes.bool
	  },

	  getInitialState: function getInitialState() {
	    return {
	      hasEdited: false
	    };
	  },

	  className: 'FormInput',

	  getCSSModifiers: function getCSSModifiers() {
	    var fieldMessage = this.props.formLink.fieldMessage,
	        isError = fieldMessage && fieldMessage.isError;

	    return {
	      'error': isError,
	      'light': this.props.color === 'light',
	      'minHeight': this.props.hasMinHeight
	    };
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'input',
	      color: 'dark',
	      size: 'normal'
	    };
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    var formLink = this.props.formLink;
	    if (formLink.hasFormError && formLink.isFirstError) {
	      this.refs.input.getDOMNode().scrollIntoViewIfNeeded();
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    this.props.formLink.requestInit();

	    if (this.props.autofill) {
	      this._syncWithAutofillInterval = window.setInterval(this.syncWithAutofill, 20);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.autofill) {
	      window.clearInterval(this._syncWithAutofillInterval);
	    }
	  },

	  syncWithAutofill: function syncWithAutofill() {
	    if (!this.isMounted() || !this.props.autofill) {
	      return;
	    }

	    var formLink = this.props.formLink,
	        value = this.refs.input.getDOMNode().value;

	    if (formLink.value !== value) {
	      this.handleChange(value);
	      return true;
	    }
	  },

	  render: function render() {
	    var Component = this.props.component,
	        value = this.props.formLink.value || '';

	    // Empty string value prevents browser autofill
	    if (this.props.autofill && value === '') {
	      value = undefined;
	    }

	    return React.createElement(Component, { className: this.getClassName(),
	      ref: 'input',
	      name: this.props.name,
	      extraLineCount: 0,
	      readOnly: this.props.readOnly,
	      type: this.props.type,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onKeyUp: this.props.onKeyUp,
	      onChange: this.handleChange,
	      value: value,
	      placeholder: this.props.placeholder });
	  },

	  handleChange: function handleChange(e) {
	    this.setState({
	      hasEdited: true
	    });

	    var value;
	    if (e instanceof SyntheticEvent) {
	      value = e.target.value;
	    } else {
	      value = e;
	    }

	    this.props.formLink.requestChange(value);
	  },

	  handleFocus: function handleFocus(e) {
	    this.setState({
	      focus: true
	    });

	    this.props.formLink.requestFocus({
	      hasEdited: this.state.hasEdited
	    });

	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	  },

	  handleBlur: function handleBlur(e) {
	    if (this.props.autofill) {
	      this.syncWithAutofill();
	    }

	    this.setState({
	      focus: false
	    });

	    this.props.formLink.requestBlur();

	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },

	  focus: function focus() {
	    if (_.isFunction(this.refs.input.focus)) {
	      this.refs.input.focus();
	    } else {
	      this.refs.input.getDOMNode().focus();
	    }
	  }
	});

	module.exports = FormInput;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _Link = __webpack_require__(21);

	var _Link2 = _interopRequireDefault(_Link);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	'use strict';

	var StampLink = _react2['default'].createClass({
	  displayName: 'StampLink',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stamp: _react.PropTypes.object.isRequired,
	    showTitle: _react.PropTypes.bool,
	    routeName: _react.PropTypes.string.isRequired,
	    routeParams: _react.PropTypes.object,
	    bold: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    target: _react.PropTypes.oneOf(['_blank'])
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      routeName: 'feedStamp'
	    };
	  },

	  getLinkTitle: function getLinkTitle() {
	    var _props = this.props;
	    var showTitle = _props.showTitle;
	    var stamp = _props.stamp;

	    if (!showTitle) {
	      return;
	    }

	    return stamp.title;
	  },

	  render: function render() {
	    var title = this.getLinkTitle();
	    var _props2 = this.props;
	    var className = _props2.className;
	    var routeName = _props2.routeName;
	    var routeParams = _props2.routeParams;
	    var stamp = _props2.stamp;
	    var bold = _props2.bold;
	    var underline = _props2.underline;
	    var target = _props2.target;
	    var children = _props2.children;

	    var params = _extends({
	      stampSegment: (0, _utilsGetStampSegment2['default'])(stamp) }, routeParams);

	    return _react2['default'].createElement(
	      _Link2['default'],
	      { className: className, to: routeName, bold: bold, underline: underline, target: target, params: params, title: title },
	      children || stamp.title
	    );
	  }
	});

	exports['default'] = StampLink;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _Link = __webpack_require__(21);

	var _Link2 = _interopRequireDefault(_Link);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	var TabLink = _react2['default'].createClass({
	  displayName: 'TabLink',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    onClick: _react2['default'].PropTypes.func,
	    to: _react2['default'].PropTypes.string,
	    color: _react2['default'].PropTypes.oneOf(['light', 'dark']),
	    params: _react2['default'].PropTypes.object,
	    active: _react2['default'].PropTypes.bool,
	    icon: _react2['default'].PropTypes.string,
	    mode: _react2['default'].PropTypes.string
	  },

	  render: function render() {
	    var icon = this.props.icon;

	    return _react2['default'].createElement(
	      _Link2['default'],
	      _extends({ context: 'TabBar',
	        bold: this.props.active,
	        underline: 'never'
	      }, this.props),
	      icon && _react2['default'].createElement(_atomsIcon2['default'], { name: icon,
	        color: this.props.color,
	        mode: this.props.mode }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'TabLink-extra' },
	        this.props.children
	      )
	    );
	  }
	});

	exports['default'] = TabLink;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  LOGIN: null,
	  CONNECT: null,
	  SIGNUP: null,
	  EMAIL: null
	});

/***/ },
/* 200 */,
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Keep synced with stampsy.models.User#EmailFlags on server
	var EmailFlags = {
	  // Your stamp is published
	  STAMP_PUBLISHED: 1,
	  // Your stamp becomes trending on Stampsy
	  TRENDING_STAMP: 2,
	  // Somebody follows me or my collections
	  NEW_SUBSCRIBER: 4,
	  // Your submission to another collection gets approved or declined
	  SUBMISSION_APPROVED_OR_DECLINED: 8,
	  // Weekly reminder about submissions to your collections
	  WEEKLY_PENDING_REMINDER: 16,
	  // Your collection gets a new submission
	  STAMP_SUBMITTED_TO_COLLECTION: 32,
	  // Somebody adds your stamp to their collection
	  YOUR_STAMP_ADDED_TO_COLLECTION: 64,
	  // Somebody used your image in their stamp
	  COLLECTED_IMAGE_PUBLISHED: 128,
	  // Weekly digest with best stamps and Stampsy updates
	  WEEKLY_DIGEST_AND_MISC: 256,
	  // Somebody left feedback to your draft
	  DRAFT_FEEDBACK: 512 };

	module.exports = EmailFlags;

/***/ },
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defineProperty = __webpack_require__(181)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);
	var getSupportedTransformProperty = __webpack_require__(298);
	var Easings = __webpack_require__(253);var PropTypes = React.PropTypes;
	var Children = React.Children;

	__webpack_require__(943);

	var DELAY = 400;

	var Rotator = React.createClass({
	  displayName: 'Rotator',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    activeIndex: PropTypes.number.isRequired
	  },

	  getChildStyle: function getChildStyle(index) {
	    var _ref;

	    var transformProperty = getSupportedTransformProperty(),
	        relativeIndex = index - this.props.activeIndex,
	        transform = 'translate3d(0, ' + relativeIndex * 150 + '%, 0)';

	    return (_ref = {}, _defineProperty(_ref, '' + transformProperty.js, transform), _defineProperty(_ref, 'opacity', index === this.props.activeIndex ? 1 : 0), _defineProperty(_ref, 'transition', '\n        ' + transformProperty.css + ' ' + DELAY + 'ms ' + Easings.BEZIER + ',\n        opacity ' + DELAY + 'ms ' + Easings.BEZIER + '\n      '), _ref);
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      Children.map(this.props.children, this.wrapChild)
	    );
	  },

	  wrapChild: function wrapChild(child, index) {
	    if (!child) {
	      return;
	    }

	    return React.createElement(
	      'div',
	      { className: 'Rotator-child',
	        style: this.getChildStyle(index) },
	      child
	    );
	  }
	});

	module.exports = Rotator;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _ = __webpack_require__(4);
	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var PureRenderMixin = __webpack_require__(2);
	var ServiceTypes = __webpack_require__(35);
	var getShareServiceTitle = __webpack_require__(442);var PropTypes = React.PropTypes;

	__webpack_require__(945);

	var iconSizes = {
	  'small': 'xsmall',
	  'medium': 'small',
	  'large': 'medium'
	};

	var Share = React.createClass({
	  displayName: 'Share',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    onShareClick: PropTypes.func.isRequired,
	    services: PropTypes.arrayOf(PropTypes.oneOf([ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE, ServiceTypes.PINTEREST, ServiceTypes.TUMBLR]).isRequired).isRequired,
	    color: PropTypes.oneOf(['black', 'dark', 'light', 'gray']).isRequired,
	    size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
	    context: PropTypes.string,
	    vertical: PropTypes.bool,
	    plainIcon: PropTypes.bool,
	    showServiceName: PropTypes.bool,
	    showShareWordPrefix: PropTypes.bool
	  },

	  className: 'Share',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'dark',
	      services: [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE, ServiceTypes.PINTEREST, ServiceTypes.TUMBLR]
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        BtnGroup,
	        { vertical: this.props.vertical },
	        _.map(this.props.services, this.props.plainIcon ? this.renderServiceIcon : this.renderServiceButton),
	        this.props.children
	      )
	    );
	  },

	  renderServiceButton: function renderServiceButton(service) {
	    var buttonProps = _.pick(this.props, ['color', 'size', 'context', 'overlay']),
	        iconSize = this.props.iconSize || iconSizes[this.props.size],
	        serviceTitle = getShareServiceTitle(service),
	        label;

	    if (this.props.showServiceName) {
	      label = serviceTitle;

	      if (this.props.showShareWordPrefix) {
	        label = 'Share on ' + label;
	      }
	    }

	    return React.createElement(
	      Button,
	      _extends({ key: service,
	        onClick: _.partial(this.handleShareClick, service),
	        round: !label
	      }, buttonProps),
	      React.createElement(Icon, { name: service.toLowerCase(),
	        size: iconSize }),
	      label
	    );
	  },

	  renderServiceIcon: function renderServiceIcon(service) {
	    var iconSize = this.props.iconSize || iconSizes[this.props.size];

	    return React.createElement(Icon, { key: service,
	      name: service.toLowerCase(),
	      size: iconSize,
	      context: 'share',
	      onClick: _.partial(this.handleShareClick, service) });
	  },

	  handleShareClick: function handleShareClick(service, e) {
	    e.stopPropagation();
	    this.props.onShareClick(service);
	  }
	});

	module.exports = Share;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    DelayActionMixin = __webpack_require__(256),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(958);

	var PALETTE = ['FECDD3', 'FD99A5', 'FC677A', 'FB334C', 'F6001F', 'C80019', '970013', '64000C', 'FFE8CD', 'FFD199', 'FFBA67', 'FFA333', 'FA8900', 'CC7000', '9A5400', '663800', 'FFF7CD', 'FFF09A', 'FFE969', 'FFE236', 'FAD603', 'CCAF03', '9A8402', '665701', 'E4F4DA', 'C9EAB4', 'AFE090', '93D56A', '76C743', '60A237', '497A29', '30511B', 'E0F7FB', 'C1F0F7', 'A3E9F3', '83E2EF', '63D6E6', '50AFBC', '3C848D', '28575E', 'D9E5FA', 'B3CBF5', '8DB1F0', '6797EB', '3F7AE1', '3464B8', '274B8A', '1A325C', 'F4D8F8', 'E9B1F2', 'DF8BEB', 'D463E5', 'C63BDA', 'A130B2', '792486', '501859', 'FFDAEE', 'FFB5DD', 'FF90CC', 'FF6BBB', 'FA44A7', 'CC3888', '9A2A67', '661C44', 'EFF1F5', 'DFE1E8', 'C0C5CF', '9CA2AD', '87939C', '6C7680', '4A5259', '30333B'];

	var STRIPE_WIDTH = 7,
	    ENTER_DELAY = 50;

	var ColorPicker = React.createClass({
	  displayName: 'ColorPicker',

	  mixins: [DelayActionMixin, ClassNameMixin, PureRenderMixin],

	  statics: {
	    getRandomColor: function getRandomColor() {
	      return PALETTE[Math.floor(Math.random() * PALETTE.length)];
	    }
	  },

	  propTypes: {
	    color: React.PropTypes.string,
	    onSelect: React.PropTypes.func.isRequired,
	    onChange: React.PropTypes.func.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      index: 0,
	      isActive: false
	    };
	  },

	  getSelectedIndex: function getSelectedIndex() {
	    return PALETTE.indexOf(this.props.color);
	  },

	  render: function render() {
	    var index = this.getSelectedIndex(),
	        sliderStyle,
	        colors;

	    sliderStyle = {
	      left: index * (STRIPE_WIDTH + 1) + 'px'
	    };

	    colors = _.map(PALETTE, function (color) {
	      return React.createElement('div', { className: 'ColorPicker-stripe',
	        key: 'stripe' + color,
	        style: { background: '#' + color },
	        onClick: this.handleStripClick.bind(this, color),
	        onMouseOver: this.handleStripMouseOver.bind(this, color) });
	    }, this);

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        onMouseLeave: this.handleMouseLeave },
	      colors,
	      React.createElement('div', { className: 'ColorPicker-slider',
	        style: sliderStyle,
	        'data-custom-color': index === -1 })
	    );
	  },

	  handleStripMouseOver: function handleStripMouseOver(color) {
	    if (this.state.isActive) {
	      this.setActiveColor(color);
	      return;
	    }

	    this.scheduleAction(this.setState.bind(this, {
	      isActive: true
	    }, this.setActiveColor.bind(this, color)), ENTER_DELAY);
	  },

	  handleStripClick: function handleStripClick(color) {
	    this.clearActiveColor();
	    this.props.onSelect(color);
	  },

	  handleMouseLeave: function handleMouseLeave() {
	    this.clearActiveColor();
	  },

	  clearActiveColor: function clearActiveColor() {
	    this.cancelScheduledAction();
	    this.setState({
	      isActive: false
	    });

	    this.setActiveColor(null);
	  },

	  setActiveColor: function setActiveColor(color) {
	    var index = PALETTE.indexOf(color);
	    if (index === -1) {
	      index = this.getSelectedIndex();
	    }

	    this.setState({
	      index: index
	    });

	    this.props.onChange(color);
	  }
	});

	module.exports = ColorPicker;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    FormStates = __webpack_require__(398),
	    AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    getServiceName = __webpack_require__(441),
	    StoreUtils = __webpack_require__(30),
	    FormMessageTypes = __webpack_require__(645),
	    mapValues = __webpack_require__(449),
	    assign = __webpack_require__(15),
	    createStore = StoreUtils.createStore;

	var _activeMessages = {},
	    _formState = FormStates.EDITABLE_STATE,
	    _defaultValues = {},
	    DEFAULT_FIELDS = ['email', 'name', 'password'];

	function renderMessage(message) {
	  switch (message && message.id) {
	    case FormMessageTypes.LOGIN_WRONG_CREDENTIALS:
	      return React.createElement(
	        'span',
	        null,
	        'Wrong email or password'
	      );
	    case FormMessageTypes.USER_WRONG_PASSWORD:
	      return React.createElement(
	        'span',
	        null,
	        'Wrong password'
	      );
	    case FormMessageTypes.USER_PASSWORD_TOO_SHORT:
	      return React.createElement(
	        'span',
	        null,
	        'Minimum 8 characters'
	      );
	    case FormMessageTypes.USER_INVALID_EMAIL:
	      return React.createElement(
	        'span',
	        null,
	        'Invalid email'
	      );
	    case FormMessageTypes.USER_EMAIL_EXISTS:
	      return React.createElement(
	        'span',
	        null,
	        'This email is already used by another user'
	      );
	    case FormMessageTypes.LOGIN_USER_NOT_FOUND:
	      return React.createElement(
	        'span',
	        null,
	        'User with this email is not found'
	      );
	    case FormMessageTypes.BAD_EMAIL:
	      return React.createElement(
	        'span',
	        null,
	        'Invalid email'
	      );
	    case FormMessageTypes.ACCOUNT_IS_USED:
	      return React.createElement(
	        'span',
	        null,
	        'Sorry, this account is already connected to another user.'
	      );
	    case FormMessageTypes.NOT_REGISTERED:
	      return React.createElement(
	        'span',
	        null,
	        'Sorry, this ',
	        getServiceName(message.serviceType),
	        ' account is not connected to any Stampsy profile.'
	      );
	    case FormMessageTypes.RECAPTCHA_FAILED:
	      return React.createElement(
	        'span',
	        null,
	        'reCAPTCHA verification failed.'
	      );
	    case FormMessageTypes.HAS_ANOTHER_ACCOUNT:
	      return React.createElement(
	        'span',
	        null,
	        'Sorry, you have already connected a different ',
	        getServiceName(message.serviceType),
	        ' account to this Stampsy profile.'
	      );
	  }

	  return message;
	}

	var FormStore = createStore({
	  get: function get(key) {
	    return FormStore.getActiveMessages()[key];
	  },

	  getFormState: function getFormState() {
	    return _formState;
	  },

	  getActiveMessages: function getActiveMessages() {
	    return mapValues(_activeMessages, function (message) {
	      return message && {
	        isError: message.isError,
	        message: renderMessage(message.message)
	      };
	    });
	  },

	  getFirstErrorKey: function getFirstErrorKey() {
	    return _.find(_.keys(_activeMessages), function (key) {
	      var message = _activeMessages[key];
	      return message && message.isError;
	    });
	  },

	  getDefaultValue: function getDefaultValue(key) {
	    return _defaultValues[key];
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.SHOW_MODAL:
	    case ActionTypes.SHOW_SIDEBAR:
	      _formState = FormStates.EDITABLE_STATE;
	      _activeMessages = {};
	      _defaultValues = assign(_.pick(action.modal || {}, DEFAULT_FIELDS), _defaultValues);
	      FormStore.emitChange();
	      break;

	    case ActionTypes.FORM_VALUE_CHANGED:
	      if (DEFAULT_FIELDS.indexOf(action.key) !== -1) {
	        _defaultValues[action.key] = action.value;
	        FormStore.emitChange();
	      }
	      break;

	    case ActionTypes.SUBMIT_FORM:
	      _formState = FormStates.SUBMITTING_STATE;
	      _activeMessages = {};
	      FormStore.emitChange();
	      break;

	    case ActionTypes.LOGIN_WITH_SERVICE_ACCOUNT:
	    case ActionTypes.SIGNUP_WITH_SERVICE_ACCOUNT:
	      _activeMessages = {};
	      FormStore.emitChange();
	      break;

	    case ActionTypes.SHOW_FORM_MESSAGES:
	    case ActionTypes.SUBMIT_FORM_ERROR:
	      _formState = FormStates.EDITABLE_STATE;
	      _activeMessages = assign({}, _activeMessages, action.messages);
	      FormStore.emitChange();
	      break;

	    case ActionTypes.HIDE_FORM_MESSAGES:
	      _formState = FormStates.EDITABLE_STATE;
	      _activeMessages = {};
	      FormStore.emitChange();
	      break;

	    case ActionTypes.SUBMIT_FORM_SUCCESS:
	      _formState = FormStates.SUBMITTED_STATE;
	      _activeMessages = {};
	      FormStore.emitChange();
	      break;

	    case ActionTypes.RESET_FORM:
	      _formState = FormStates.EDITABLE_STATE;
	      FormStore.emitChange();
	      break;
	  }
	});

	module.exports = FormStore;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var _require = __webpack_require__(4);

	var find = _require.find;

	var omit = _require.omit;
	var update = __webpack_require__(49);
	var guid = __webpack_require__(246);
	var StampStore = __webpack_require__(17);
	var SafeLocalStorage = __webpack_require__(134);
	var getUniqueStampImages = __webpack_require__(443);
	var _require2 = __webpack_require__(783);

	var migrateGrabbagFromOldEditor = _require2.migrateGrabbagFromOldEditor;
	var PaginatedStoreUtils = __webpack_require__(28);
	var ImageStore = __webpack_require__(146);
	var assign = __webpack_require__(15);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var _uploadedImageItems = [];

	var STORAGE_KEY = 'grabbag';

	function findItem(id) {
	  return _uploadedImageItems.indexOf(find(_uploadedImageItems, function (item) {
	    return item.uuid === id;
	  }));
	}

	function findItemByPath(filePath) {
	  return _uploadedImageItems.indexOf(find(_uploadedImageItems, function (item) {
	    return item.filePath === filePath;
	  }));
	}

	function loadGrabbagFromStorage() {
	  var json = SafeLocalStorage.getItem(STORAGE_KEY);
	  _uploadedImageItems = json ? JSON.parse(json) : [];
	}

	function addGrabbagItem(filePath) {
	  var item = {
	    filePath: filePath,
	    progress: 0,
	    uuid: guid(),
	    image: null
	  };

	  _uploadedImageItems = update(_uploadedImageItems, {
	    $splice: [[0, 0, item]]
	  });
	}

	function updateGrabbagItem(filePath, data) {
	  var index = findItemByPath(filePath),
	      updateData = {};

	  if (index === -1) {
	    return;
	  }

	  updateData[index] = {
	    $merge: data
	  };

	  _uploadedImageItems = update(_uploadedImageItems, updateData);
	}

	function deleteGrabbagItemByPath(filePath) {
	  var index = findItemByPath(filePath);
	  if (index === -1) {
	    return;
	  }

	  _uploadedImageItems = update(_uploadedImageItems, {
	    $splice: [[index, 1]]
	  });
	}

	function deleteGrabbagItemById(id) {
	  var index = findItem(id);
	  if (index === -1) {
	    return;
	  }

	  _uploadedImageItems = update(_uploadedImageItems, {
	    $splice: [[index, 1]]
	  });
	}

	var GrabbagImageStore = createIndexedListStore({
	  getUploadedImageItems: function getUploadedImageItems() {
	    return _uploadedImageItems;
	  },

	  getSavedImageItems: function getSavedImageItems() {
	    return this.getIds('saved').map(function (id) {
	      var image = ImageStore.get(id);
	      return {
	        uuid: image.uuid,
	        image: assign({ sourceImage: image.uuid, sourceStamp: image.stamp }, omit(image, ['uuid', 'caption', 'sourceImage', 'sourceStamp', 'stamp']))
	      };
	    });
	  },

	  getStampletImageItems: function getStampletImageItems() {
	    return this.getIds('stamplet').map(function (id) {
	      var image = ImageStore.get(id);
	      return {
	        uuid: image.uuid,
	        image: omit(image, ['uuid', 'caption', 'sourceImage', 'sourceStamp', 'stamp'])
	      };
	    });
	  },

	  isEmpty: function isEmpty() {
	    return !_uploadedImageItems.length && !this.getIds('saved').length && !this.getIds('stamplet').length;
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_GRABBAG_IMAGES,
	  error: ActionTypes.REQUEST_GRABBAG_IMAGES_ERROR,
	  success: ActionTypes.REQUEST_GRABBAG_IMAGES_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken, ImageStore.dispatchToken]);

	  var action = payload.action;

	  if (action.tab) {
	    handleListAction(action, GrabbagImageStore.getList(action.tab), GrabbagImageStore.emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.LOAD_EMPTY_DRAFT:
	      _uploadedImageItems = [];

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.LOAD_STAMP_IN_EDITOR:
	      _uploadedImageItems = [];

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.LOAD_DRAFT_IN_EDITOR_SUCCESS:
	      var draft = StampStore.get(action.draftUuid);

	      _uploadedImageItems = draft.grabbag || [];

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.LOAD_STAMP_IN_EDITOR_SUCCESS:
	      var stamp = StampStore.get(action.stampId);

	      _uploadedImageItems = getUniqueStampImages(stamp).map(function (image) {
	        return {
	          uuid: guid(),
	          image: omit(image, 'caption', 'uuid')
	        };
	      });

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.POST_STAMP_SUCCESS:
	      _uploadedImageItems = [];
	      break;

	    case ActionTypes.ADD_GRABBAG_ITEM:
	      addGrabbagItem(action.filePath);
	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.UPDATE_GRABBAG_ITEM:
	      updateGrabbagItem(action.filePath, action.data);

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.DELETE_GRABBAG_ITEM:
	      if (action.itemId) {
	        deleteGrabbagItemById(action.itemId);
	      } else if (action.filePath) {
	        deleteGrabbagItemByPath(action.filePath);
	      }

	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.IMAGE_ADD_TO_GRABBAG_SUCCESS:
	      GrabbagImageStore.getList('saved').invalidate();
	      break;

	    case ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_SUCCESS:
	      GrabbagImageStore.getList('saved').remove(action.uuid);
	      GrabbagImageStore.emitChange();
	      break;

	    case ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS:
	      GrabbagImageStore.getList('stamplet').remove(action.uuid);
	      GrabbagImageStore.emitChange();
	      break;
	  }
	});

	loadGrabbagFromStorage();

	if (GrabbagImageStore.isEmpty()) {
	  migrateGrabbagFromOldEditor();
	  loadGrabbagFromStorage();
	}

	module.exports = GrabbagImageStore;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StampStore = __webpack_require__(17);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var SearchStampStore = createIndexedListStore({
	  getStamps: function getStamps(terms) {
	    return this.getIds(terms).map(StampStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_STAMP_SEARCH,
	  error: ActionTypes.REQUEST_STAMP_SEARCH_ERROR,
	  success: ActionTypes.REQUEST_STAMP_SEARCH_SUCCESS
	});

	SearchStampStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);

	  var action = payload.action,
	      terms = action.terms;

	  handleListAction(payload.action, SearchStampStore.getList(terms), SearchStampStore.emitChange);
	});

	module.exports = SearchStampStore;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var UserStore = __webpack_require__(5);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var SearchUserStore = createIndexedListStore({
	  getUsers: function getUsers(terms) {
	    return this.getIds(terms).map(UserStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_SEARCH,
	  error: ActionTypes.REQUEST_USER_SEARCH_ERROR,
	  success: ActionTypes.REQUEST_USER_SEARCH_SUCCESS
	});

	SearchUserStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      terms = action.terms;

	  handleListAction(payload.action, SearchUserStore.getList(terms), SearchUserStore.emitChange);
	});

	module.exports = SearchUserStore;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var ZineStore = __webpack_require__(22);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var SearchZineStore = createIndexedListStore({
	  getZines: function getZines(terms) {
	    return this.getIds(terms).map(ZineStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_ZINE_SEARCH,
	  error: ActionTypes.REQUEST_ZINE_SEARCH_ERROR,
	  success: ActionTypes.REQUEST_ZINE_SEARCH_SUCCESS
	});

	SearchZineStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action,
	      terms = action.terms;

	  handleListAction(payload.action, SearchZineStore.getList(terms), SearchZineStore.emitChange);
	});

	module.exports = SearchZineStore;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var StampStore = __webpack_require__(17);
	var UserStore = __webpack_require__(5);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserLatestStampStore = createIndexedListStore({
	  getStamps: function getStamps(userId) {
	    return this.getIds(userId).map(StampStore.get);
	  }
	});

	function getList(userId) {
	  return UserLatestStampStore.getList(userId);
	}

	function emitChange() {
	  UserLatestStampStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_LATEST_STAMPS,
	  error: ActionTypes.REQUEST_USER_LATEST_STAMPS_ERROR,
	  success: ActionTypes.REQUEST_USER_LATEST_STAMPS_SUCCESS,
	  preload: ActionTypes.PRELOAD_USER_LATEST_STAMPS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.POST_STAMP_SUCCESS:
	      getList(UserStore.getMe().id).prepend(action.stampId);
	      emitChange();
	      break;

	    case ActionTypes.INVALIDATE_USER_LATEST_STAMPS:
	      getList(action.userId).invalidate();
	      break;
	  }
	});

	module.exports = UserLatestStampStore;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _StampStore = __webpack_require__(17);

	var _StampStore2 = _interopRequireDefault(_StampStore);

	var _UserStore = __webpack_require__(5);

	var _UserStore2 = _interopRequireDefault(_UserStore);

	var _utilsPaginatedStoreUtils = __webpack_require__(28);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	'use strict';

	var UserLikedStampStore = (0, _utilsPaginatedStoreUtils.createIndexedListStore)({
	  getStamps: function getStamps(userId) {
	    return this.getIds(userId).map(_StampStore2['default'].get);
	  }
	});

	function getList(userId) {
	  return UserLikedStampStore.getList(userId);
	}

	function emitChange() {
	  UserLikedStampStore.emitChange();
	}

	var handleListAction = (0, _utilsPaginatedStoreUtils.createListActionHandler)({
	  request: _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS,
	  error: _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS_ERROR,
	  success: _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS_SUCCESS,
	  preload: _constantsActionTypes2['default'].PRELOAD_USER_LIKED_STAMPS
	});

	_AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_StampStore2['default'].dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  var stampId = undefined;

	  if (action.stampSegment) {
	    stampId = (0, _utilsParseStampSegment2['default'])(action.stampSegment).stampId;
	  }

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case _constantsActionTypes2['default'].LIKE_STAMP_SUCCESS:
	      getList(_UserStore2['default'].getMe().id).prepend(stampId);
	      emitChange();
	      break;

	    case _constantsActionTypes2['default'].UNLIKE_STAMP_SUCCESS:
	      getList(_UserStore2['default'].getMe().id).remove(stampId);
	      emitChange();
	      break;
	  }
	});

	module.exports = UserLikedStampStore;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var assign = __webpack_require__(15);
	var ZineStore = __webpack_require__(22);
	var update = __webpack_require__(49);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;

	var _zineDraft = null;

	var ZineDraftStore = createStore({
	  isEditing: function isEditing() {
	    return !!_zineDraft;
	  },

	  getActiveDraft: function getActiveDraft() {
	    return _zineDraft;
	  }
	});

	ZineDraftStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.CREATE_ZINE_DRAFT:
	      _zineDraft = assign(action.isNew ? { isNew: true } : {}, action.zine);
	      ZineDraftStore.emitChange();
	      break;

	    case ActionTypes.UPDATE_ZINE_DRAFT:
	      var zineUpdate = {};
	      zineUpdate[action.key] = {
	        $set: action.value
	      };
	      _zineDraft = update(_zineDraft, zineUpdate);
	      ZineDraftStore.emitChange();
	      break;

	    case ActionTypes.DESTROY_ZINE_DRAFT:
	    case ActionTypes.UPDATE_ZINE_SUCCESS:
	    case ActionTypes.CREATE_ZINE_SUCCESS:
	      _zineDraft = null;
	      ZineDraftStore.emitChange();
	      break;
	  }
	});

	module.exports = ZineDraftStore;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StampStore = __webpack_require__(17);
	var PaginatedStoreUtils = __webpack_require__(28);
	var parseStampSegment = __webpack_require__(53);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var ZinePendingStampStore = createIndexedListStore({
	  getStamps: function getStamps(zineSlug) {
	    return this.getIds(zineSlug).map(StampStore.get);
	  }
	});

	function getList(zineSlug) {
	  return ZinePendingStampStore.getList(zineSlug);
	}

	function emitChange() {
	  ZinePendingStampStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_ZINE_PENDING_STAMPS,
	  error: ActionTypes.REQUEST_ZINE_PENDING_STAMPS_ERROR,
	  success: ActionTypes.REQUEST_ZINE_PENDING_STAMPS_SUCCESS,
	  preload: ActionTypes.PRELOAD_ZINE_PENDING_STAMPS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);

	  var action = payload.action,
	      zineSlug = action.zineSlug,
	      stampSegment = action.stampSegment,
	      stampId,
	      list;

	  if (!zineSlug) {
	    return;
	  }

	  list = getList(zineSlug);

	  if (stampSegment) {
	    stampId = parseStampSegment(stampSegment).stampId;
	  }

	  switch (action.type) {
	    case ActionTypes.ADD_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
	      list.remove(stampId);
	      break;

	    case ActionTypes.REMOVE_STAMP_FROM_ZINE_SUCCESS:
	    case ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS:
	      list.remove(stampId);
	      break;

	    default:
	      handleListAction(action, list, emitChange);
	      break;
	  }
	});

	module.exports = ZinePendingStampStore;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	'use strict';

	var STAMPSY_AUTH_SIZE = { w: 475, h: 620 };
	var SERVICE_AUTH_SIZE = { w: 550, h: 500 };

	function openUrl(url) {
	  var options = arguments[1] === undefined ? {} : arguments[1];
	  var _options$popup = options.popup;
	  var popup = _options$popup === undefined ? true : _options$popup;
	  var _options$size = options.size;
	  var size = _options$size === undefined ? SERVICE_AUTH_SIZE : _options$size;

	  if (popup) {
	    window.open(url, '', 'resizeable=true,height=' + size.h + ',width=' + size.w + ',left=' + (window.innerWidth - size.w) / 2 + ',top=' + (window.innerHeight - size.h) / 2);
	  } else {
	    window.location.href = url;
	  }
	}

	var PopupManager = {
	  openConnect: function openConnect(serviceType) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    var params = [];
	    var url = '/connect/' + serviceType.toLowerCase() + '/popup?';

	    if (options.scope) {
	      params.push('scope=' + options.scope);
	    }

	    url += params.join('&');

	    openUrl(url, options);
	  },

	  openLogin: function openLogin(serviceType) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    var url = serviceType ? '/login/' + serviceType.toLowerCase() + '/popup' : '/login/popup';

	    if (!options.size) {
	      options.size = serviceType ? SERVICE_AUTH_SIZE : STAMPSY_AUTH_SIZE;
	    }

	    openUrl(url, options);
	  },

	  openSignup: function openSignup(serviceType) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    var url = serviceType ? '/signup/' + serviceType.toLowerCase() + '/popup' : '/signup/popup';

	    if (!options.size) {
	      options.size = serviceType ? SERVICE_AUTH_SIZE : STAMPSY_AUTH_SIZE;
	    }

	    openUrl(url, options);
	  }
	};

	exports['default'] = PopupManager;
	module.exports = exports['default'];

/***/ },
/* 218 */,
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function formatCount(count) {
	  if (count >= 1000) {
	    return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
	  }

	  return count;
	}

	module.exports = formatCount;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function noop() {}

	module.exports = noop;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var isValidEmail = __webpack_require__(447);

	function validateEmail(email) {
	  if (!email) {
	    return {
	      error: 'Required'
	    };
	  }

	  if (!isValidEmail(email)) {
	    return {
	      error: 'Invalid email'
	    };
	  }
	}

	module.exports = validateEmail;

/***/ },
/* 222 */,
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	exports.__esModule = true;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _Object$defineProperty = __webpack_require__(12)["default"];

	exports["default"] = (function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;

	      _Object$defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	})();

	exports.__esModule = true;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// Optional / simple context binding
	var assertFunction = __webpack_require__(182).fn;
	module.exports = function(fn, that, length){
	  assertFunction(fn);
	  if(~length && that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	    };
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var sid = 0;
	function uid(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++sid + Math.random()).toString(36));
	}
	uid.safe = __webpack_require__(25).g.Symbol || uid;
	module.exports = uid;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var $   = __webpack_require__(14)
	  , ctx = __webpack_require__(125);
	module.exports = function(TYPE){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
	  return function($this, callbackfn, that){
	    var O      = Object($.assertDefined($this))
	      , self   = $.ES5Object(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = $.toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? Array(length) : IS_FILTER ? [] : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $     = __webpack_require__(14)
	  , $def  = __webpack_require__(23)
	  , BUGGY = __webpack_require__(100).BUGGY
	  , forOf = __webpack_require__(185)
	  , species = __webpack_require__(231)
	  , assertInstance = __webpack_require__(65).inst;

	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = $.g[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  function fixMethod(KEY){
	    var fn = proto[KEY];
	    __webpack_require__(101)(proto, KEY,
	      KEY == 'delete' ? function(a){ return fn.call(this, a === 0 ? 0 : a); }
	      : KEY == 'has' ? function has(a){ return fn.call(this, a === 0 ? 0 : a); }
	      : KEY == 'get' ? function get(a){ return fn.call(this, a === 0 ? 0 : a); }
	      : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	      : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  }
	  if(!$.isFunction(C) || !(IS_WEAK || !BUGGY && proto.forEach && proto.entries)){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    __webpack_require__(230)(C.prototype, methods);
	  } else {
	    var inst  = new C
	      , chain = inst[ADDER](IS_WEAK ? {} : -0, 1)
	      , buggyZero;
	    // wrap for init collections from iterable
	    if(!__webpack_require__(309)(function(iter){ new C(iter); })){ // eslint-disable-line no-new
	      C = wrapper(function(target, iterable){
	        assertInstance(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    IS_WEAK || inst.forEach(function(val, key){
	      buggyZero = 1 / key === -Infinity;
	    });
	    // fix converting -0 key to +0
	    if(buggyZero){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    // + fix .add & .set for chaining
	    if(buggyZero || chain !== inst)fixMethod(ADDER);
	  }

	  __webpack_require__(72).set(C, NAME);

	  O[NAME] = C;
	  $def($def.G + $def.W + $def.F * (C != Base), O);
	  species(C);
	  species($.core[NAME]); // for wrapper

	  if(!IS_WEAK)common.setIter(C, NAME, IS_MAP);

	  return C;
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// Fast apply
	// http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	    case 5: return un ? fn(args[0], args[1], args[2], args[3], args[4])
	                      : fn.call(that, args[0], args[1], args[2], args[3], args[4]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var $redef = __webpack_require__(101);
	module.exports = function(target, src){
	  for(var key in src)$redef(target, key, src[key]);
	  return target;
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(14)
	  , SPECIES = __webpack_require__(73)('species');
	module.exports = function(C){
	  if($.DESC && !(SPECIES in C))$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: $.that
	  });
	};

/***/ },
/* 232 */,
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(351),
	    isArray = __webpack_require__(102),
	    isIndex = __webpack_require__(350),
	    isLength = __webpack_require__(88),
	    isObject = __webpack_require__(104),
	    support = __webpack_require__(352);

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || (support.nonEnumArgs && isArguments(object))) && length) || 0;

	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;

	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	module.exports = keysIn;


/***/ },
/* 234 */,
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var React = __webpack_require__(1);
	var invariant = __webpack_require__(11);
	var PropTypes = __webpack_require__(105);
	var RouteHandler = __webpack_require__(236);

	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div class="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */

	var Route = (function (_React$Component) {
	  function Route() {
	    _classCallCheck(this, Route);

	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }

	  _inherits(Route, _React$Component);

	  _createClass(Route, {
	    render: {
	      value: function render() {
	        invariant(false, "%s elements are for router configuration only and should not be rendered", this.constructor.name);
	      }
	    }
	  });

	  return Route;
	})(React.Component);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};

	Route.defaultProps = {
	  handler: RouteHandler
	};

	module.exports = Route;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var React = __webpack_require__(1);
	var ContextWrapper = __webpack_require__(1081);
	var assign = __webpack_require__(15);
	var PropTypes = __webpack_require__(105);

	var REF_NAME = "__routeHandler__";

	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */

	var RouteHandler = (function (_React$Component) {
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);

	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }

	  _inherits(RouteHandler, _React$Component);

	  _createClass(RouteHandler, {
	    getChildContext: {
	      value: function getChildContext() {
	        return {
	          routeDepth: this.context.routeDepth + 1
	        };
	      }
	    },
	    componentDidMount: {
	      value: function componentDidMount() {
	        this._updateRouteComponent(this.refs[REF_NAME]);
	      }
	    },
	    componentDidUpdate: {
	      value: function componentDidUpdate() {
	        this._updateRouteComponent(this.refs[REF_NAME]);
	      }
	    },
	    componentWillUnmount: {
	      value: function componentWillUnmount() {
	        this._updateRouteComponent(null);
	      }
	    },
	    _updateRouteComponent: {
	      value: function _updateRouteComponent(component) {
	        this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	      }
	    },
	    getRouteDepth: {
	      value: function getRouteDepth() {
	        return this.context.routeDepth;
	      }
	    },
	    createChildRouteHandler: {
	      value: function createChildRouteHandler(props) {
	        var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	        return route ? React.createElement(route.handler, assign({}, props || this.props, { ref: REF_NAME })) : null;
	      }
	    },
	    render: {
	      value: function render() {
	        var handler = this.createChildRouteHandler();
	        // <script/> for things like <CSSTransitionGroup/> that don't like null
	        return handler ? React.createElement(
	          ContextWrapper,
	          null,
	          handler
	        ) : React.createElement("script", null);
	      }
	    }
	  });

	  return RouteHandler;
	})(React.Component);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};

	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};

	module.exports = RouteHandler;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusMixin
	 * @typechecks static-only
	 */

	'use strict';

	var focusNode = __webpack_require__(536);

	var AutoFocusMixin = {
	  componentDidMount: function() {
	    if (this.props.autoFocus) {
	      focusNode(this.getDOMNode());
	    }
	  }
	};

	module.exports = AutoFocusMixin;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */

	'use strict';

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);

	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags
	var tagToComponentClass = {};
	var textComponentClass = null;

	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function(componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function(componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  },
	  // Temporary hack since we expect DOM refs to behave like composites,
	  // for this release.
	  injectAutoWrapper: function(wrapperFactory) {
	    autoGenerateWrapperClass = wrapperFactory;
	  }
	};

	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}

	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  (false ? invariant(
	    genericComponentClass,
	    'There is no registered component for the tag %s',
	    element.type
	  ) : invariant(genericComponentClass));
	  return new genericComponentClass(element.type, element.props);
	}

	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}

	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}

	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};

	module.exports = ReactNativeComponent;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */

	'use strict';

	var ReactPropTypeLocationNames = {};

	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}

	module.exports = ReactPropTypeLocationNames;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticUIEvent = __webpack_require__(162);
	var ViewportMetrics = __webpack_require__(242);

	var getEventModifierState = __webpack_require__(379);

	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function(event) {
	    return event.relatedTarget || (
	      ((event.fromElement === event.srcElement ? event.toElement : event.fromElement))
	    );
	  },
	  // "Proprietary" Interface.
	  pageX: function(event) {
	    return 'pageX' in event ?
	      event.pageX :
	      event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function(event) {
	    return 'pageY' in event ?
	      event.pageY :
	      event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

	module.exports = SyntheticMouseEvent;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (!this.wrapperInitData) {
	      this.wrapperInitData = [];
	    } else {
	      this.wrapperInitData.length = 0;
	    }
	    this._isInTransaction = false;
	  },

	  _isInTransaction: false,

	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,

	  isInTransaction: function() {
	    return !!this._isInTransaction;
	  },

	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} args... Arguments to pass to the method (optional).
	   *                           Helps prevent need to bind in many cases.
	   * @return Return value from `method`.
	   */
	  perform: function(method, scope, a, b, c, d, e, f) {
	    (false ? invariant(
	      !this.isInTransaction(),
	      'Transaction.perform(...): Cannot initialize a transaction when there ' +
	      'is already an outstanding transaction.'
	    ) : invariant(!this.isInTransaction()));
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {
	          }
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },

	  initializeAll: function(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ?
	          wrapper.initialize.call(this) :
	          null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {
	          }
	        }
	      }
	    }
	  },

	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function(startIndex) {
	    (false ? invariant(
	      this.isInTransaction(),
	      'Transaction.closeAll(): Cannot close transaction when none are open.'
	    ) : invariant(this.isInTransaction()));
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {
	          }
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};

	var Transaction = {

	  Mixin: Mixin,

	  /**
	   * Token to look for to determine if an error occured.
	   */
	  OBSERVED_ERROR: {}

	};

	module.exports = Transaction;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */

	'use strict';

	var ViewportMetrics = {

	  currentScrollLeft: 0,

	  currentScrollTop: 0,

	  refreshScrollValues: function(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }

	};

	module.exports = ViewportMetrics;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */

	function accumulateInto(current, next) {
	  (false ? invariant(
	    next != null,
	    'accumulateInto(...): Accumulated items must not be null or undefined.'
	  ) : invariant(next != null));
	  if (current == null) {
	    return next;
	  }

	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);

	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }

	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }

	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }

	  return [current, next];
	}

	module.exports = accumulateInto;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */

	"use strict";

	var emptyObject = {};

	if (false) {
	  Object.freeze(emptyObject);
	}

	module.exports = emptyObject;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';

	var ReactElement = __webpack_require__(31);

	var invariant = __webpack_require__(11);

	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  (false ? invariant(
	    ReactElement.isValidElement(children),
	    'onlyChild must be passed a children with exactly one child.'
	  ) : invariant(ReactElement.isValidElement(children)));
	  return children;
	}

	module.exports = onlyChild;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	
	var guid = function() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	    var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
	    return v.toString(16);
	  }).toUpperCase();
	}

	module.exports = guid;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    AppDispatcher = __webpack_require__(6),
	    ActivityAPI = __webpack_require__(574),
	    ActionUtils = __webpack_require__(133),
	    ActivityListStore = __webpack_require__(287);

	var ActivityActionCreators = {
	  requestActivityPage: function requestActivityPage(isInitialRequest) {
	    if (isInitialRequest) {
	      AppDispatcher.handleViewAction({
	        type: ActionTypes.INVALIDATE_ACTIVITIES
	      });
	    }

	    ActionUtils.requestPage({
	      isInitialRequest: isInitialRequest,
	      store: ActivityListStore,
	      action: ActionTypes.REQUEST_ACTIVITIES,
	      callAPI: ActivityAPI.requestActivitiesPage
	    });
	  },

	  requestUnseenCount: function requestUnseenCount() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT
	    });

	    ActivityAPI.requestUnseenCount();
	  },

	  markAll: function markAll() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ACTIVITY_MARK_ALL
	    });

	    ActivityAPI.markAll();
	  },

	  expandActivity: function expandActivity(activityId) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ACTIVITY_EXPAND,
	      activityId: activityId
	    });
	  },

	  collapseActivity: function collapseActivity(activityId) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ACTIVITY_COLLAPSE,
	      activityId: activityId
	    });
	  }
	};

	module.exports = ActivityActionCreators;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    ImageAPI = __webpack_require__(576),
	    ActionUtils = __webpack_require__(133),
	    GrabbagImageStore = __webpack_require__(209),
	    ImageUsedInStampStore = __webpack_require__(421),
	    handleUnauthAction = __webpack_require__(179),
	    AnalyticsSources = __webpack_require__(34);

	var ImageActionCreators = {
	  addToGrabbag: function addToGrabbag(uuid, stampId) {
	    if (handleUnauthAction(AnalyticsSources.IMAGE_CONTROLS)) {
	      return;
	    }

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.IMAGE_ADD_TO_GRABBAG,
	      uuid: uuid
	    });

	    ImageAPI.addToGrabbag(uuid, stampId);
	  },

	  requestGrabbagImagesPage: function requestGrabbagImagesPage(tab, isInitialRequest) {
	    ActionUtils.requestIndexedPage({
	      tab: tab,
	      idAttribute: 'tab',
	      isInitialRequest: isInitialRequest,
	      store: GrabbagImageStore,
	      action: ActionTypes.REQUEST_GRABBAG_IMAGES,
	      callAPI: ImageAPI.requestGrabbagImagesPage
	    });
	  },

	  removeFromGrabbag: function removeFromGrabbag(uuid) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.IMAGE_REMOVE_FROM_GRABBAG,
	      uuid: uuid
	    });

	    ImageAPI.removeFromGrabbag(uuid);
	  },

	  removeStampletItem: function removeStampletItem(uuid) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM,
	      uuid: uuid
	    });

	    ImageAPI.removeStampletItem(uuid);
	  },

	  requestImageUsedInStampsPage: function requestImageUsedInStampsPage(imageUuid, isInitialRequest) {
	    ActionUtils.requestIndexedPage({
	      imageUuid: imageUuid,
	      idAttribute: 'imageUuid',
	      isInitialRequest: isInitialRequest,
	      store: ImageUsedInStampStore,
	      action: ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS,
	      callAPI: ImageAPI.requestImageUsedInStampsPage
	    });
	  }
	};

	module.exports = ImageActionCreators;

/***/ },
/* 249 */,
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var escapeTextContentForBrowser = __webpack_require__(194);
	var KeyCodes = __webpack_require__(145);
	var PureRenderMixin = __webpack_require__(2);
	var _require = __webpack_require__(36);

	var isIE = _require.isIE;var PropTypes = React.PropTypes;

	__webpack_require__(903);

	/**
	 * This component is purposefully uncontrolled
	 * to prevent caret jumps and other weird browser behavior.
	 */
	var ContentEditable = React.createClass({
	  displayName: 'ContentEditable',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    component: PropTypes.any,
	    onChange: PropTypes.func.isRequired,
	    text: PropTypes.string,
	    placeholder: PropTypes.string,
	    editable: PropTypes.bool,
	    allowReturn: PropTypes.bool,
	    maxLength: PropTypes.number,
	    onMouseEnter: PropTypes.func,
	    onMouseLeave: PropTypes.func
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'div',
	      editable: false,
	      allowReturn: false,
	      text: '',
	      maxLength: Infinity
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.editable && 'editable'];
	  },

	  getInitialState: function getInitialState() {
	    return {
	      initialText: this.props.text
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.editable && !this.props.editable) {
	      this.setState({
	        initialText: nextProps.text
	      });
	    }
	  },

	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!nextProps.editable && this.props.editable) {
	      this.getDOMNode().innerHTML = escapeTextContentForBrowser(this.state.initialText);
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    if (isIE() && typeof MutationObserver !== 'undefined') {
	      this.observer = new MutationObserver(this.handleChange);
	      this.observer.observe(this.getDOMNode(), {
	        attributes: true,
	        childList: true,
	        characterData: true,
	        characterDataOldValue: true,
	        subtree: true
	      });
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (this.observer) {
	      this.observer.disconnect();
	      this.observer = null;
	    }
	  },

	  render: function render() {
	    var html = escapeTextContentForBrowser(this.props.editable ? this.state.initialText : this.props.text);

	    var Component = this.props.component;
	    return React.createElement(Component, { className: this.getClassName(),
	      onInput: this.handleChange,
	      onBlur: this.handleBlur,
	      onFocus: this.handleFocus,
	      onKeyPress: this.handleKeyPress,
	      contentEditable: this.props.editable,
	      'data-placeholder': this.props.placeholder,
	      dangerouslySetInnerHTML: { __html: html },
	      onMouseEnter: this.props.onMouseEnter,
	      onMouseLeave: this.props.onMouseLeave });
	  },

	  handleFocus: function handleFocus(e) {
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }

	    this.handleChange();
	  },

	  handleBlur: function handleBlur(e) {
	    if (e.target.textContent.length > this.props.maxLength) {
	      e.target.innerHTML = e.target.textContent.substr(0, this.props.maxLength);
	      this.props.onChange(e.target.textContent);
	    }

	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },

	  handleChange: function handleChange() {
	    var node = this.getDOMNode();

	    if (!node.textContent.trim().length) {
	      node.innerHTML = '';
	    }

	    this.props.onChange(node.textContent);
	  },

	  handleKeyPress: function handleKeyPress(e) {
	    if (e.which === KeyCodes.ENTER) {
	      e.preventDefault();
	    }

	    if (e.target.textContent.length >= this.props.maxLength && document.getSelection().toString().length === 0) {

	      e.preventDefault();
	    }
	  }
	});

	module.exports = ContentEditable;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var formatTime = __webpack_require__(136);
	var Link = __webpack_require__(21);
	var extractSoundCloudUserUrl = __webpack_require__(790);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(913);

	var PlayerTitle = React.createClass({
	  displayName: 'PlayerTitle',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    title: PropTypes.string.isRequired,
	    username: PropTypes.string.isRequired,
	    duration: PropTypes.number,
	    linkUrl: PropTypes.string.isRequired
	  },

	  render: function render() {
	    var _props = this.props;
	    var username = _props.username;
	    var title = _props.title;
	    var duration = _props.duration;
	    var linkUrl = _props.linkUrl;
	    var userLinkUrl = extractSoundCloudUserUrl(linkUrl);

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'PlayerTitle-username' },
	        React.createElement(
	          Link,
	          { target: '_blank',
	            href: userLinkUrl },
	          username
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'PlayerTitle-header' },
	        React.createElement(
	          'span',
	          { className: 'PlayerTitle-title' },
	          React.createElement(
	            Link,
	            { target: '_blank',
	              href: linkUrl },
	            title
	          )
	        ),
	        this.props.duration && React.createElement(
	          'span',
	          { className: 'PlayerTitle-duration' },
	          formatTime(duration)
	        )
	      )
	    );
	  }
	});

	module.exports = PlayerTitle;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var Link = __webpack_require__(21);
	var Icon = __webpack_require__(10);
	var ShareTypes = __webpack_require__(113);
	var PureRenderMixin = __webpack_require__(2);
	var getShareServiceTitle = __webpack_require__(442);var PropTypes = React.PropTypes;

	var ShareLink = React.createClass({
	  displayName: 'ShareLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    service: PropTypes.oneOf(_.values(ShareTypes)).isRequired,
	    propagateClick: PropTypes.bool,
	    onClick: PropTypes.func.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      Link,
	      { onClick: this.props.onClick,
	        color: 'dark',
	        propagateClick: this.props.propagateClick,
	        context: this.props.context,
	        bold: this.props.bold,
	        underline: this.props.underline },
	      React.createElement(Icon, { name: this.props.service.toLowerCase(),
	        context: 'Link' }),
	      getShareServiceTitle(this.props.service)
	    );
	  }
	});

	module.exports = ShareLink;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Easings = {
	  BEZIER: 'cubic-bezier(.175, .885, .32, 1)',
	  BEZIER_SPRINGY: 'cubic-bezier(.175, .885, .32, 1.15)'
	};

	module.exports = Easings;

/***/ },
/* 254 */,
/* 255 */,
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var DelayActionMixin = {
	  componentWillUnmount: function componentWillUnmount() {
	    this.cancelScheduledAction();
	  },

	  scheduleAction: function scheduleAction(action, delay) {
	    this.cancelScheduledAction();
	    this._delayedActionTimeout = window.setTimeout(action, delay);
	  },

	  cancelScheduledAction: function cancelScheduledAction() {
	    if (this._delayedActionTimeout) {
	      window.clearTimeout(this._delayedActionTimeout);
	      this._delayedActionTimeout = null;
	    }
	  }
	};

	module.exports = DelayActionMixin;

/***/ },
/* 257 */,
/* 258 */,
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var getScrollY = __webpack_require__(82),
	    Animation = __webpack_require__(546);

	var SmoothScrollMixin = {
	  componentWillMount: function componentWillMount() {
	    this._animation = new Animation({
	      onRender: function onRender(state) {
	        window.scrollTo(0, state.y);
	      }
	    });
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this._animation.cancel();
	    this._animation = null;
	  },

	  isAnimatingScroll: function isAnimatingScroll() {
	    return this._animation.isAnimating();
	  },

	  stopAnimatingScroll: function stopAnimatingScroll() {
	    this._animation.cancel();
	  },

	  animateScroll: function animateScroll(targetY, duration) {
	    this._animation.animate({ y: getScrollY() }, { y: targetY }, duration);
	  }
	};

	module.exports = SmoothScrollMixin;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var StampActionCreators = __webpack_require__(54),
	    FeedWithTrendingStore = __webpack_require__(288),
	    UserLatestStampStore = __webpack_require__(213),
	    UserLikedStampStore = __webpack_require__(214),
	    ZineLatestStampStore = __webpack_require__(292),
	    ZinePendingStampStore = __webpack_require__(216),
	    StampStore = __webpack_require__(17),
	    ZineStore = __webpack_require__(22),
	    UserStore = __webpack_require__(5),
	    BackColorMixin = __webpack_require__(56),
	    createStoreMixin = __webpack_require__(8);

	var DEFAULT_COLORS = {
	  background: 'efefef',
	  text: 'dark'
	};

	module.exports = {
	  Feed: {
	    mixins: [createStoreMixin(FeedWithTrendingStore, StampStore, ZineStore)],

	    requestPage: function requestPage(isInitialRequest) {
	      StampActionCreators.requestFeedWithTrendingPage(isInitialRequest);
	    },

	    isExpectingPage: function isExpectingPage() {
	      return FeedWithTrendingStore.isExpectingPage();
	    },

	    isLastPage: function isLastPage() {
	      return FeedWithTrendingStore.isLastPage();
	    },

	    getPage: function getPage() {
	      return FeedWithTrendingStore.getStamps();
	    },

	    getStampPendingZine: function getStampPendingZine() {
	      return null;
	    },

	    getStampPrimaryZine: function getStampPrimaryZine(stampId) {
	      return StampStore.getPrimaryZine(stampId);
	    },

	    getNextUpTitle: function getNextUpTitle() {
	      if (UserStore.isAuthenticated()) {
	        return 'Next Up in Your Feed';
	      } else {
	        return 'Trending on Stampsy';
	      }
	    },

	    shouldShowPrimaryZineInNextUp: function shouldShowPrimaryZineInNextUp() {
	      return true;
	    },

	    getColors: function getColors() {
	      return DEFAULT_COLORS;
	    }
	  },

	  UserLatest: {
	    mixins: [createStoreMixin(UserLatestStampStore, StampStore, UserStore)],

	    getUserId: function getUserId() {
	      return parseInt(this.props.params.userId, 10);
	    },

	    isExpectingPage: function isExpectingPage() {
	      var userId = this.getUserId();
	      return UserLatestStampStore.isExpectingPage(userId);
	    },

	    isLastPage: function isLastPage() {
	      var userId = this.getUserId();
	      return UserLatestStampStore.isLastPage(userId);
	    },

	    requestPage: function requestPage(isInitialRequest) {
	      var userId = this.getUserId();
	      StampActionCreators.requestUserLatestPage(userId, isInitialRequest);
	    },

	    getPage: function getPage() {
	      var userId = this.getUserId();
	      return UserLatestStampStore.getStamps(userId);
	    },

	    getStampPendingZine: function getStampPendingZine() {
	      return null;
	    },

	    getStampPrimaryZine: function getStampPrimaryZine(stampId) {
	      return StampStore.getPrimaryZine(stampId);
	    },

	    getNextUpTitle: function getNextUpTitle() {
	      var userId = this.getUserId(),
	          user = UserStore.get(userId);

	      if (user) {
	        return 'Also by ' + user.name;
	      }
	    },

	    shouldShowPrimaryZineInNextUp: function shouldShowPrimaryZineInNextUp() {
	      return true;
	    },

	    getColors: function getColors() {
	      return DEFAULT_COLORS;
	    }
	  },

	  UserLiked: {
	    mixins: [createStoreMixin(UserLikedStampStore, StampStore, UserStore)],

	    getUserId: function getUserId() {
	      return parseInt(this.props.params.userId, 10);
	    },

	    isExpectingPage: function isExpectingPage() {
	      var userId = this.getUserId();
	      return UserLikedStampStore.isExpectingPage(userId);
	    },

	    isLastPage: function isLastPage() {
	      var userId = this.getUserId();
	      return UserLikedStampStore.isLastPage(userId);
	    },

	    requestPage: function requestPage(isInitialRequest) {
	      var userId = this.getUserId();
	      StampActionCreators.requestUserLikedPage(userId, isInitialRequest);
	    },

	    getPage: function getPage() {
	      var userId = this.getUserId();
	      return UserLikedStampStore.getStamps(userId);
	    },

	    getStampPrimaryZine: function getStampPrimaryZine(stampId) {
	      return StampStore.getPrimaryZine(stampId);
	    },

	    getStampPendingZine: function getStampPendingZine() {
	      return null;
	    },

	    getNextUpTitle: function getNextUpTitle() {
	      var userId = this.getUserId(),
	          user = UserStore.get(userId);

	      if (user) {
	        return 'Also Liked by ' + user.name;
	      }
	    },

	    shouldShowPrimaryZineInNextUp: function shouldShowPrimaryZineInNextUp() {
	      return true;
	    },

	    getColors: function getColors() {
	      return DEFAULT_COLORS;
	    }
	  },

	  ZineLatest: {
	    mixins: [createStoreMixin(ZineLatestStampStore, ZineStore, StampStore), BackColorMixin],

	    getZineSlug: function getZineSlug() {
	      return this.props.params.zineSlug;
	    },

	    isExpectingPage: function isExpectingPage() {
	      var zineSlug = this.getZineSlug();
	      return ZineLatestStampStore.isExpectingPage(zineSlug);
	    },

	    isLastPage: function isLastPage() {
	      var zineSlug = this.getZineSlug();
	      return ZineLatestStampStore.isLastPage(zineSlug);
	    },

	    requestPage: function requestPage(isInitialRequest) {
	      var zineSlug = this.getZineSlug();
	      StampActionCreators.requestZineLatestPage(zineSlug, isInitialRequest);
	    },

	    getPage: function getPage() {
	      var zineSlug = this.getZineSlug();
	      return ZineLatestStampStore.getStamps(zineSlug);
	    },

	    getStampPrimaryZine: function getStampPrimaryZine() {
	      var zineSlug = this.getZineSlug();
	      return ZineStore.get(zineSlug);
	    },

	    getStampPendingZine: function getStampPendingZine() {
	      return null;
	    },

	    getNextUpTitle: function getNextUpTitle() {
	      var zineSlug = this.getZineSlug(),
	          zine = ZineStore.get(zineSlug);

	      if (zine) {
	        return 'Next Up in ' + zine.title;
	      }
	    },

	    shouldShowPrimaryZineInNextUp: function shouldShowPrimaryZineInNextUp() {
	      return false;
	    },

	    getColors: function getColors(primaryZine) {
	      if (primaryZine) {
	        return {
	          background: primaryZine.backColor,
	          text: this.getTextColor(primaryZine.backColor)
	        };
	      } else {
	        return DEFAULT_COLORS;
	      }
	    }
	  },

	  ZinePending: {
	    mixins: [createStoreMixin(ZinePendingStampStore, ZineStore, StampStore), BackColorMixin],

	    getZineSlug: function getZineSlug() {
	      return this.props.params.zineSlug;
	    },

	    isExpectingPage: function isExpectingPage() {
	      var zineSlug = this.getZineSlug();
	      return ZinePendingStampStore.isExpectingPage(zineSlug);
	    },

	    isLastPage: function isLastPage() {
	      var zineSlug = this.getZineSlug();
	      return ZinePendingStampStore.isLastPage(zineSlug);
	    },

	    requestPage: function requestPage(isInitialRequest) {
	      var zineSlug = this.getZineSlug();
	      StampActionCreators.requestZinePendingPage(zineSlug, isInitialRequest);
	    },

	    getPage: function getPage() {
	      var zineSlug = this.getZineSlug();
	      return ZinePendingStampStore.getStamps(zineSlug);
	    },

	    getStampPrimaryZine: function getStampPrimaryZine(stampId) {
	      return StampStore.getPrimaryZine(stampId);
	    },

	    getStampPendingZine: function getStampPendingZine(stampId) {
	      var zineSlug = this.getZineSlug(),
	          stamp = StampStore.get(stampId);

	      if (stamp && stamp.pendingZines.indexOf(zineSlug) > -1) {
	        return ZineStore.get(zineSlug);
	      }
	    },

	    getNextUpTitle: function getNextUpTitle() {
	      var zineSlug = this.getZineSlug(),
	          zine = ZineStore.get(zineSlug);

	      if (zine) {
	        return 'Also Submitted to ' + zine.title;
	      }
	    },

	    shouldShowPrimaryZineInNextUp: function shouldShowPrimaryZineInNextUp() {
	      return true;
	    },

	    getColors: function getColors(primaryZine) {
	      if (primaryZine) {
	        return {
	          background: primaryZine.backColor,
	          text: this.getTextColor(primaryZine.backColor)
	        };
	      } else {
	        return DEFAULT_COLORS;
	      }
	    }
	  }
	};

/***/ },
/* 261 */,
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    BackColorMixin = __webpack_require__(56),
	    Button = __webpack_require__(13),
	    UserActionCreators = __webpack_require__(47),
	    PureRenderMixin = __webpack_require__(2),
	    PropTypes = React.PropTypes;

	var FollowUserButton = React.createClass({
	  displayName: 'FollowUserButton',

	  mixins: [BackColorMixin, PureRenderMixin],

	  propTypes: {
	    user: PropTypes.object.isRequired,
	    size: PropTypes.oneOf(['medium', 'large']).isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium'
	    };
	  },

	  render: function render() {
	    var user = this.props.user;

	    return React.createElement(
	      Button,
	      { color: 'green',
	        onClick: this.handleFollowClick,
	        active: user.isSubscribed,
	        size: this.props.size,
	        counter: user.subscriberCount,
	        context: this.props.context,
	        fill: true },
	      user.isSubscribed ? React.createElement(
	        'span',
	        null,
	        'Following'
	      ) : React.createElement(
	        'span',
	        null,
	        'Follow'
	      )
	    );
	  },

	  handleFollowClick: function handleFollowClick() {
	    var user = this.props.user;

	    if (user.isSubscribed) {
	      UserActionCreators.unfollowUser(user.id);
	    } else {
	      UserActionCreators.followUser(user.id);
	    }
	  }
	});

	module.exports = FollowUserButton;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var StampLink = __webpack_require__(197);
	var UserLink = __webpack_require__(69);
	var Link = __webpack_require__(21);
	var SidebarActionCreators = __webpack_require__(29);
	var SidebarTypes = __webpack_require__(39);
	var getThumbnailUrl = __webpack_require__(37);
	var pluralize = __webpack_require__(98);var PropTypes = React.PropTypes;

	__webpack_require__(936);
	__webpack_require__(478);

	var ImageAttribution = React.createClass({
	  displayName: 'ImageAttribution',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    sourceStamp: PropTypes.object.isRequired,
	    sourceImage: PropTypes.object.isRequired,
	    sourceUser: PropTypes.object.isRequired
	  },

	  render: function render() {
	    var _props = this.props;
	    var sourceStamp = _props.sourceStamp;
	    var sourceImage = _props.sourceImage;
	    var sourceUser = _props.sourceUser;
	    var stamp = _props.stamp;
	    var isInSourceStamp = sourceStamp.id === stamp.id;
	    var otherUsageCount = isInSourceStamp ? sourceImage.usageCount : sourceImage.usageCount - 1;
	    var hasOtherUsages = otherUsageCount > 0;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      !isInSourceStamp && React.createElement(
	        'div',
	        { className: 'ImageAttribution-image' },
	        React.createElement(
	          StampLink,
	          { stamp: sourceStamp },
	          React.createElement('img', { src: getThumbnailUrl(sourceStamp.thumbnail, {
	              mode: 'scale_crop',
	              width: 48,
	              height: 36
	            }) })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'ImageAttribution-meta' },
	        !isInSourceStamp && React.createElement(
	          'span',
	          { className: 'ImageAttribution-originalStamp' },
	          'Image from ',
	          React.createElement(StampLink, { bold: true, stamp: sourceStamp }),
	          ' by ',
	          React.createElement(UserLink, { user: sourceUser }),
	          '.'
	        ),
	        isInSourceStamp && !sourceImage.sourcePageUrl && React.createElement(
	          'span',
	          { className: 'ImageAttribution-originalStamp' },
	          'Uploaded by ',
	          React.createElement(UserLink, { user: sourceUser }),
	          '.'
	        ),
	        isInSourceStamp && sourceImage.sourcePageUrl && React.createElement(
	          'span',
	          { className: 'ImageAttribution-originalStamp' },
	          'Image from ',
	          React.createElement(
	            Link,
	            { href: sourceImage.sourcePageUrl, bold: true },
	            sourceImage.sourcePageTitle
	          )
	        ),
	        hasOtherUsages && this.renderOtherUsages(otherUsageCount)
	      )
	    );
	  },

	  renderOtherUsages: function renderOtherUsages(otherUsageCount) {
	    return React.createElement(
	      'span',
	      { className: 'ImageAttribution-otherUsages' },
	      'Also found in',
	      ' ',
	      React.createElement(
	        Link,
	        { bold: true, onClick: this.handleOtherUsagesClick },
	        otherUsageCount,
	        ' ',
	        pluralize(otherUsageCount, 'more stamp', 'other stamps')
	      ),
	      '.'
	    );
	  },

	  handleOtherUsagesClick: function handleOtherUsagesClick() {
	    var _props2 = this.props;
	    var stamp = _props2.stamp;
	    var sourceImage = _props2.sourceImage;

	    SidebarActionCreators.showSidebar(SidebarTypes.IMAGE_USED_IN_STAMPS, {
	      imageUuid: sourceImage.uuid,
	      excludeStampId: stamp.id
	    });
	  } });

	module.exports = ImageAttribution;

/***/ },
/* 264 */,
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	var _atomsUserImage = __webpack_require__(143);

	var _atomsUserImage2 = _interopRequireDefault(_atomsUserImage);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _atomsCounter = __webpack_require__(165);

	var _atomsCounter2 = _interopRequireDefault(_atomsCounter);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	__webpack_require__(937);

	'use strict';

	var LIKE_COUNT = 3;

	var LikeButton = _react2['default'].createClass({
	  displayName: 'LikeButton',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesUserStore2['default'])],

	  propTypes: {
	    size: _react.PropTypes.oneOf(['large', 'xlarge']),
	    iconSize: _react2['default'].PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large']),
	    fill: _react.PropTypes.bool,
	    stamp: _react.PropTypes.object.isRequired,
	    showLikers: _react.PropTypes.bool,
	    showCounter: _react.PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      iconSize: 'small'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var state = {};
	    if (props.showLikers) {
	      state.likers = props.stamp.likes.map(_storesUserStore2['default'].get);
	    }

	    return state;
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.stamp !== this.props.stamp) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    var stamp = this.props.stamp;

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName() },
	      _react2['default'].createElement(
	        _atomsButton2['default'],
	        { size: this.props.size,
	          color: this.props.color,
	          onClick: this.handleLikeClick,
	          active: stamp.isLiked,
	          overlay: this.props.overlay,
	          fill: this.props.fill,
	          context: this.props.context,
	          round: true,
	          like: true },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'like',
	          mode: 'fill',
	          context: 'LikeButton',
	          size: this.props.iconSize })
	      ),
	      this.props.showCounter && stamp.likeCount > 0 && _react2['default'].createElement(_atomsCounter2['default'], { count: stamp.likeCount,
	        onClick: this.handleShowMoreClick,
	        context: 'LikeButton' }),
	      this.props.showLikers && _react2['default'].createElement(
	        'ul',
	        { className: 'LikeButton-likers' },
	        this.renderLikers()
	      )
	    );
	  },

	  renderLikers: function renderLikers() {
	    var needShowMore = this.state.likers.length > LIKE_COUNT,
	        likers;

	    likers = this.state.likers.slice(0, LIKE_COUNT).map(function (liker) {
	      return _react2['default'].createElement(
	        'li',
	        { key: liker.id },
	        _react2['default'].createElement(
	          _atomsUserLink2['default'],
	          { user: liker, showTitle: true },
	          _react2['default'].createElement(_atomsUserImage2['default'], { user: liker,
	            size: 'small' })
	        )
	      );
	    });

	    if (needShowMore) {
	      likers.push(_react2['default'].createElement(
	        'li',
	        { key: 'more' },
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'small',
	            color: 'gray',
	            round: true,
	            onClick: this.handleShowMoreClick },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'more', size: 'small' })
	        )
	      ));
	    }

	    return likers;
	  },

	  handleShowMoreClick: function handleShowMoreClick() {
	    _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].STAMP_LIKES, {
	      stampId: this.props.stamp.id
	    });
	  },

	  handleLikeClick: function handleLikeClick() {
	    var stamp = this.props.stamp;

	    var stampSegment = (0, _utilsGetStampSegment2['default'])(stamp);

	    if (stamp.isLiked) {
	      _actionsStampActionCreators2['default'].unlikeStamp(stampSegment);
	    } else {
	      _actionsStampActionCreators2['default'].likeStamp(stampSegment);
	    }
	  }
	});

	exports['default'] = LikeButton;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(939);

	var MetaList = React.createClass({
	  displayName: 'MetaList',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    inline: PropTypes.bool,
	    separated: PropTypes.bool
	  },

	  className: 'MetaList',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      inline: true,
	      separated: true
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.inline && 'inline', this.props.separated && 'separated'];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.Children.map(this.props.children, this.renderItem)
	    );
	  },

	  renderItem: function renderItem(item) {
	    if (!item) {
	      return;
	    }

	    return React.createElement(
	      'li',
	      { className: 'MetaList-item' },
	      item
	    );
	  }
	});

	module.exports = MetaList;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55),
	    AnalyticsSources = __webpack_require__(34),
	    ClassNameMixin = __webpack_require__(3),
	    Button = __webpack_require__(13),
	    Link = __webpack_require__(21),
	    Icon = __webpack_require__(10),
	    BtnGroup = __webpack_require__(44),
	    ServiceTypes = __webpack_require__(35),
	    PopupManager = __webpack_require__(217),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58),
	    UserActionCreators = __webpack_require__(47),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(477);

	var ShortLogin = React.createClass({
	  displayName: 'ShortLogin',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    color: React.PropTypes.oneOf(['light', 'gray']),
	    size: React.PropTypes.oneOf(['small', 'medium', 'large']),
	    source: React.PropTypes.oneOf(_.values(AnalyticsSources))
	  },

	  className: 'ShortSignUp',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'large',
	      color: 'gray'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.color];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        BtnGroup,
	        { vertical: true },
	        React.createElement(
	          Button,
	          { size: this.props.size,
	            color: 'facebook',
	            onClick: this.handleFacebookClick,
	            fullWidth: true,
	            fill: true },
	          React.createElement(Icon, { name: 'facebook' }),
	          'Log In with Facebook'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'ShortSignUp-moreOptions' },
	        React.createElement(
	          Link,
	          { onClick: this.handleMoreClick,
	            color: this.props.color,
	            underline: 'never',
	            opaque: true },
	          'Show more options'
	        )
	      )
	    );
	  },

	  handleFacebookClick: function handleFacebookClick() {
	    UserActionCreators.loginWithServiceAccount(ServiceTypes.FACEBOOK);
	  },

	  handleMoreClick: function handleMoreClick() {
	    ModalActionCreators.showModal(ModalTypes.LOGIN, {
	      showComplementaryButtons: true,
	      source: this.props.source
	    });
	  }
	});

	module.exports = ShortLogin;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55),
	    AnalyticsSources = __webpack_require__(34),
	    ClassNameMixin = __webpack_require__(3),
	    Button = __webpack_require__(13),
	    Link = __webpack_require__(21),
	    Icon = __webpack_require__(10),
	    BtnGroup = __webpack_require__(44),
	    ServiceTypes = __webpack_require__(35),
	    PopupManager = __webpack_require__(217),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(477);

	var ShortSignUp = React.createClass({
	  displayName: 'ShortSignUp',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    color: React.PropTypes.oneOf(['light', 'gray']),
	    size: React.PropTypes.oneOf(['small', 'medium', 'large']),
	    source: React.PropTypes.oneOf(_.values(AnalyticsSources))
	  },

	  className: 'ShortSignUp',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'large',
	      color: 'gray'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.color];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        BtnGroup,
	        { vertical: true },
	        React.createElement(
	          Button,
	          { size: this.props.size,
	            color: 'facebook',
	            onClick: this.handleFacebookClick,
	            fullWidth: true,
	            fill: true },
	          React.createElement(Icon, { name: 'facebook' }),
	          'Sign Up with Facebook'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'ShortSignUp-moreOptions' },
	        React.createElement(
	          Link,
	          { onClick: this.handleMoreClick,
	            color: this.props.color,
	            underline: 'never',
	            opaque: true },
	          'Show more options'
	        )
	      )
	    );
	  },

	  handleFacebookClick: function handleFacebookClick() {
	    PopupManager.openSignup(ServiceTypes.FACEBOOK);

	    Analytics.trackGAEvent(AnalyticsEvents.FACEBOOK_BUTTON_CLICK, this.props.source);
	    Analytics.trackEvent(AnalyticsEvents.FACEBOOK_BUTTON_CLICK, {
	      source: this.props.source
	    });
	  },

	  handleEmailClick: function handleEmailClick() {
	    ModalActionCreators.showModal(ModalTypes.FINISH_SIGNUP, {
	      service: ServiceTypes.EMAIL,
	      source: this.props.source
	    });
	  },

	  handleMoreClick: function handleMoreClick() {
	    ModalActionCreators.showModal(ModalTypes.SIGNUP, {
	      showComplementaryButtons: true,
	      source: this.props.source
	    });
	  }
	});

	module.exports = ShortSignUp;
	/*<Button size={this.props.size}
	       color={this.props.color}
	       onClick={this.handleEmailClick}
	       fullWidth>
	 <Icon name='email'
	       mode='stroke' />
	 Sign Up with Email
	</Button>*/

/***/ },
/* 269 */,
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var AlertActionCreators = __webpack_require__(32);
	var AlertTypes = __webpack_require__(48);
	var ImageUploader = __webpack_require__(295);
	var PureRenderMixin = __webpack_require__(2);
	var createTokenSource = __webpack_require__(455);
	var _require = __webpack_require__(4);

	var each = _require.each;var PropTypes = React.PropTypes;

	__webpack_require__(963);

	var IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/tiff'],
	    CANCEL_REASON = {};

	var ImagePicker = React.createClass({
	  displayName: 'ImagePicker',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    imageUrl: PropTypes.string,
	    size: PropTypes.oneOf(['avatar', 'thumbnail', 'cover']),
	    onUploadSuccess: PropTypes.func.isRequired,
	    onUploadStart: PropTypes.func,
	    onUploadProgress: PropTypes.func,
	    onUploadError: PropTypes.func,
	    accept: PropTypes.arrayOf(PropTypes.string),
	    multiple: PropTypes.bool,
	    hideProgress: PropTypes.bool,
	    cancelOnChange: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      accept: IMAGE_TYPES
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      isUploading: false,
	      progress: 0
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  componentDidMount: function componentDidMount() {
	    this.tokenSource = createTokenSource();
	    this.imageUploader = ImageUploader.createFileUploader();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this.cancelUploadsIfNeeded();
	  },

	  getStyle: function getStyle() {
	    var imageUrl = this.props.imageUrl;
	    if (imageUrl) {
	      return {
	        backgroundImage: 'url(' + imageUrl + ')'
	      };
	    }
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: this.getStyle() },
	      React.createElement('input', { className: 'ImagePicker-input',
	        type: 'file',
	        value: '',
	        accept: this.props.accept,
	        multiple: this.props.multiple,
	        onChange: this.handleFileUpload }),
	      !this.props.hideProgress && React.createElement('div', { className: 'ImagePicker-progress',
	        'data-uploading': this.state.isUploading,
	        style: { width: Math.floor(this.state.progress * 100) + '%' } }),
	      React.createElement(
	        'div',
	        { className: 'ImagePicker-placeholder' },
	        this.props.children
	      )
	    );
	  },

	  handleFileUpload: function handleFileUpload(e) {
	    this.cancelUploadsIfNeeded();
	    each(e.target.files, this.uploadImage);
	  },

	  cancelUploadsIfNeeded: function cancelUploadsIfNeeded() {
	    if (!this.props.cancelOnChange) {
	      return;
	    }

	    if (this.tokenSource) {
	      this.tokenSource.cancel(CANCEL_REASON);
	    }

	    this.tokenSource = createTokenSource();
	  },

	  uploadImage: function uploadImage(filePath) {
	    var _this = this;

	    if (this.props.onUploadStart) {
	      this.props.onUploadStart(filePath);
	    }

	    var handleProgress = function handleProgress(progress) {
	      if (_this.props.onUploadProgress) {
	        _this.props.onUploadProgress(filePath, progress);
	      }

	      if (_this.isMounted()) {
	        _this.setState({
	          progress: progress,
	          isUploading: true
	        });
	      }
	    };

	    this.imageUploader.uploadFile(filePath, handleProgress, this.tokenSource.token).then(function (image) {
	      _this.props.onUploadSuccess(filePath, image);
	    })['catch'](function (err) {
	      if (err === CANCEL_REASON) {
	        return;
	      }

	      AlertActionCreators.showAlert(AlertTypes.UPLOAD_USER_IMAGE_ERROR);

	      if (_this.props.onUploadError) {
	        _this.props.onUploadError(filePath);
	      }
	    })['finally'](function () {
	      if (_this.isMounted()) {
	        _this.setState({
	          progress: 0,
	          isUploading: false
	        });
	      }
	    });
	  }
	});

	module.exports = ImagePicker;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var ShareAddButtons = __webpack_require__(411);
	var UserStore = __webpack_require__(5);
	var SidebarActionCreators = __webpack_require__(29);
	var SidebarTypes = __webpack_require__(39);
	var ContextMenuActionCreators = __webpack_require__(111);
	var ContextMenuTypes = __webpack_require__(112);
	var PureRenderMixin = __webpack_require__(2);
	var ScreenSizeMixin = __webpack_require__(71);
	var ShareTypes = __webpack_require__(113);
	var ShareActionCreators = __webpack_require__(91);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	var ShareAddStamp = React.createClass({
	  displayName: 'ShareAddStamp',

	  mixins: [ScreenSizeMixin, PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    primaryServices: PropTypes.arrayOf(PropTypes.oneOf(_.values(ShareTypes))),
	    showAddLabel: PropTypes.bool,
	    size: PropTypes.any,
	    split: PropTypes.bool,
	    fill: PropTypes.bool
	  },

	  contextTypes: {
	    source: React.PropTypes.string.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      primaryServices: []
	    };
	  },

	  getDisplayOptions: function getDisplayOptions() {
	    var stamp = this.props.stamp,
	        isMyStamp = UserStore.isMe(stamp.user),
	        primaryServices = this.props.primaryServices,
	        showShareButton = primaryServices.length === 0,
	        showEditMenu = isMyStamp && this.state.isDesktop && !isMobile(),
	        showMoreButton = showEditMenu || !showShareButton,
	        addButtonLabel;

	    if (this.state.isDesktop && this.props.showAddLabel) {
	      addButtonLabel = isMyStamp ? 'Submit to Collections' : 'Add to Collections';
	    }

	    return {
	      showEditMenu: showEditMenu,
	      showShareButton: showShareButton,
	      showMoreButton: showMoreButton,
	      addButtonLabel: addButtonLabel
	    };
	  },

	  render: function render() {
	    var _getDisplayOptions = this.getDisplayOptions();

	    var showShareButton = _getDisplayOptions.showShareButton;
	    var showMoreButton = _getDisplayOptions.showMoreButton;
	    var addButtonLabel = _getDisplayOptions.addButtonLabel;

	    return React.createElement(ShareAddButtons, { size: this.props.size,
	      onShareClick: this.handleShareClick,
	      onAddClick: this.handleAddClick,
	      onMoreClick: this.handleMoreClick,
	      context: this.props.context,
	      color: this.props.color,
	      primaryServices: this.props.primaryServices,
	      showMore: showMoreButton,
	      showShare: showShareButton,
	      addLabel: addButtonLabel,
	      split: this.props.split,
	      round: this.props.round,
	      overlay: this.props.overlay,
	      fill: this.props.fill });
	  },

	  handleAddClick: function handleAddClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMP_TO_ZINES, {
	      stampId: this.props.stamp.id
	    });
	  },

	  handleShareClick: function handleShareClick(e, service) {
	    var el = e.target,
	        stampId = this.props.stamp.id;

	    if (service) {
	      ShareActionCreators.shareStamp({
	        stampId: stampId,
	        service: service,
	        source: this.context.source
	      });
	    } else {
	      ContextMenuActionCreators.showContextMenu(ContextMenuTypes.STAMP_SHARE, el, {
	        stampId: stampId,
	        source: this.context.source
	      });
	    }
	  },

	  handleMoreClick: function handleMoreClick(e) {
	    var _getDisplayOptions2 = this.getDisplayOptions();

	    var showEditMenu = _getDisplayOptions2.showEditMenu;
	    var showShareButton = _getDisplayOptions2.showShareButton;

	    var secondaryServices;
	    if (!showShareButton) {
	      secondaryServices = _.difference(_.values(ShareTypes), this.props.primaryServices);
	    }

	    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.STAMP_MORE, e.target, {
	      stampId: this.props.stamp.id,
	      showEdit: showEditMenu,
	      shareServices: secondaryServices,
	      source: this.context.source
	    });
	  }
	});

	module.exports = ShareAddStamp;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    UserLink = __webpack_require__(69),
	    ServiceAccountStore = __webpack_require__(176),
	    createStoreMixin = __webpack_require__(8),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2),
	    UserStore = __webpack_require__(5),
	    FollowUserButton = __webpack_require__(262),
	    UserInfo = __webpack_require__(132),
	    pluralize = __webpack_require__(98),
	    formatCount = __webpack_require__(219),
	    PropTypes = React.PropTypes;

	__webpack_require__(973);

	var UserItem = React.createClass({
	  displayName: 'UserItem',

	  mixins: [ClassNameMixin, PureRenderMixin, createStoreMixin(ServiceAccountStore, UserStore)],

	  propTypes: {
	    user: React.PropTypes.object.isRequired,
	    size: PropTypes.oneOf(['small', 'medium', 'large']),
	    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
	    showAbout: PropTypes.bool,
	    showLocation: PropTypes.bool,
	    showWebsite: PropTypes.bool,
	    showAccounts: PropTypes.bool,
	    showSubscribers: PropTypes.bool,
	    showSubscriptions: PropTypes.bool,
	    showFollow: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      showAbout: false,
	      showLocation: false,
	      showWebsite: false,
	      showAccounts: false,
	      showSubscribers: false,
	      showSubscriptions: false,
	      showFollow: false
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      isMe: UserStore.isMe(props.user.id)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.user !== nextProps.user) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  render: function render() {
	    var _props = this.props;
	    var user = _props.user;
	    var showFollow = _props.showFollow;
	    var isMe = this.state.isMe;
	    var subscriberCount = this.props.user.subscriberCount;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'UserItem-body' },
	        React.createElement(
	          UserLink,
	          { user: user,
	            className: 'UserItem-link' },
	          ' '
	        ),
	        React.createElement(UserInfo, { user: user,
	          size: this.props.size,
	          imageSize: this.props.imageSize,
	          showAbout: this.props.showAbout,
	          showLocation: this.props.showLocation,
	          showWebsite: this.props.showWebsite,
	          showAccounts: this.props.showAccounts,
	          showSubscribers: this.props.showSubscribers,
	          showSubscriptions: this.props.showSubscriptions,
	          context: 'UserItem',
	          vertical: true })
	      ),
	      showFollow && !isMe && React.createElement(
	        'div',
	        { className: 'UserItem-footer' },
	        React.createElement(FollowUserButton, { user: user,
	          context: 'UserItem' })
	      ),
	      isMe && React.createElement(
	        'div',
	        { className: 'UserItem-footer' },
	        React.createElement(
	          'span',
	          null,
	          formatCount(subscriberCount),
	          ' ',
	          pluralize(subscriberCount, 'Follower', 'Followers')
	        )
	      )
	    );
	  }
	});

	module.exports = UserItem;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _atomsZineLink = __webpack_require__(93);

	var _atomsZineLink2 = _interopRequireDefault(_atomsZineLink);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	var _moleculesSubmitStampControl = __webpack_require__(412);

	var _moleculesSubmitStampControl2 = _interopRequireDefault(_moleculesSubmitStampControl);

	var _moleculesFollowZineButton = __webpack_require__(409);

	var _moleculesFollowZineButton2 = _interopRequireDefault(_moleculesFollowZineButton);

	var _atomsFontTest = __webpack_require__(92);

	var _atomsFontTest2 = _interopRequireDefault(_atomsFontTest);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _utilsPluralize = __webpack_require__(98);

	var _utilsPluralize2 = _interopRequireDefault(_utilsPluralize);

	var _utilsFormatCount = __webpack_require__(219);

	var _utilsFormatCount2 = _interopRequireDefault(_utilsFormatCount);

	var _utilsGetZineThumbnail = __webpack_require__(178);

	var _utilsGetZineThumbnail2 = _interopRequireDefault(_utilsGetZineThumbnail);

	var _utilsGetZineCover = __webpack_require__(444);

	var _utilsGetZineCover2 = _interopRequireDefault(_utilsGetZineCover);

	var _utilsGetThumbnailUrl = __webpack_require__(37);

	var _utilsGetThumbnailUrl2 = _interopRequireDefault(_utilsGetThumbnailUrl);

	var _utilsIsBestOf2014Special = __webpack_require__(83);

	var _utilsIsBestOf2014Special2 = _interopRequireDefault(_utilsIsBestOf2014Special);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	__webpack_require__(975);

	var ZineItem = _react2['default'].createClass({
	  displayName: 'ZineItem',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesUserStore2['default']), _mixinsBackColorMixin2['default'], _mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  className: 'ZineItem',

	  propTypes: {
	    zine: _react.PropTypes.object.isRequired,
	    stamp: _react.PropTypes.object,
	    showSubmit: _react.PropTypes.bool.isRequired,
	    showFollow: _react.PropTypes.bool.isRequired,
	    size: _react.PropTypes.oneOf(['small', 'medium', 'large']).isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      showSubmit: false,
	      showFollow: true,
	      size: 'medium'
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var zine = props.zine;

	    return {
	      curator: _storesUserStore2['default'].get(zine.curator),
	      recentContributors: (zine.recentContributors || []).map(_storesUserStore2['default'].get)
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size, this.getZineTextColor(), (0, _utilsIsBestOf2014Special2['default'])(this.props.zine) && '2014special'];
	  },

	  getZineBackColor: function getZineBackColor() {
	    return this.props.zine.backColor;
	  },

	  getZineTextColor: function getZineTextColor() {
	    return this.getTextColor(this.getZineBackColor());
	  },

	  getThumbnailUrl: function getThumbnailUrl() {
	    var thumbnail = (0, _utilsGetZineThumbnail2['default'])(this.props.zine);
	    var remSize = this.props.size === 'small' ? 5 : 7.5;
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    var size = remSize * 16 * Math.round(devicePixelRatio);

	    return (0, _utilsGetThumbnailUrl2['default'])(thumbnail, {
	      mode: 'scale_crop',
	      width: size,
	      height: size
	    });
	  },

	  getCoverStyle: function getCoverStyle(zine) {
	    var zineCover = (0, _utilsGetZineCover2['default'])(zine);
	    if (zineCover.isDefault) {
	      return {
	        backgroundSize: 'auto',
	        backgroundImage: 'url(' + zineCover.url + ')'
	      };
	    }
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    var size = 30 * 16 * Math.round(devicePixelRatio);
	    var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(zineCover, {
	      width: size,
	      height: size
	    });

	    return {
	      backgroundSize: 'cover',
	      backgroundImage: 'url(' + thumbnailUrl + ')'
	    };
	  },

	  render: function render() {
	    var zine = this.props.zine;
	    var titleFontFamily = (0, _utilsIsBestOf2014Special2['default'])(zine) ? 'playfair-display' : null;
	    var isUnlisted = zine.status === _constantsZineStatus2['default'].UNLISTED;

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName(),
	        style: {
	          backgroundColor: '#' + this.getZineBackColor()
	        } },
	      _react2['default'].createElement(
	        _atomsZineLink2['default'],
	        { className: 'ZineItem-body',
	          zine: zine,
	          underline: 'never',
	          withEllipsis: false },
	        _react2['default'].createElement(
	          'div',
	          { className: 'ZineItem-header' },
	          isUnlisted && _react2['default'].createElement(
	            'span',
	            { className: 'ZineItem-badge ZineItem-secret',
	              title: 'This Collection is only visible to those who have the direct link to it.' },
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	              mode: 'fill',
	              size: 'xsmall',
	              margin: 'right' }),
	            'Secret'
	          ),
	          _react2['default'].createElement('div', { className: 'ZineItem-avatar',
	            style: {
	              backgroundColor: '#' + this.getZineBackColor(),
	              backgroundImage: 'url(' + this.getThumbnailUrl() + ')'
	            } }),
	          _react2['default'].createElement('div', { className: 'ZineItem-coverImage',
	            style: this.getCoverStyle(zine) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'ZineItem-info' },
	          _react2['default'].createElement(
	            _atomsFontTest2['default'],
	            { family: titleFontFamily,
	              test: zine.title },
	            _react2['default'].createElement(
	              'h3',
	              { className: 'ZineItem-title' },
	              zine.title
	            )
	          ),
	          _react2['default'].createElement(
	            _atomsFontTest2['default'],
	            { family: 'minion-pro-condensed',
	              test: zine.description },
	            _react2['default'].createElement(
	              'p',
	              { className: 'ZineItem-description' },
	              zine.description
	            )
	          )
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  renderFooter: function renderFooter() {
	    if ((0, _utilsIsBestOf2014Special2['default'])(this.props.zine)) {
	      return null;
	    }

	    var _renderFooterContent = this.renderFooterContent();

	    var header = _renderFooterContent.header;
	    var content = _renderFooterContent.content;

	    if (!header && !content) {
	      return null;
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: 'ZineItem-footer' },
	      header && _react2['default'].createElement(
	        'div',
	        { className: 'ZineItem-footerHeader' },
	        header
	      ),
	      content && _react2['default'].createElement(
	        'div',
	        { className: 'ZineItem-footerContent' },
	        content
	      )
	    );
	  },

	  renderFooterContent: function renderFooterContent() {
	    var _props = this.props;
	    var showSubmit = _props.showSubmit;
	    var showFollow = _props.showFollow;
	    var zine = _props.zine;
	    var stamp = _props.stamp;
	    var size = _props.size;

	    var canShowFollow = zine.status === _constantsZineStatus2['default'].PUBLIC;
	    var isSmall = size === 'small';

	    if (showSubmit) {
	      return {
	        header: null,
	        content: _react2['default'].createElement(_moleculesSubmitStampControl2['default'], { zine: zine,
	          stamp: stamp,
	          color: this.getZineTextColor() })
	      };
	    } else if (showFollow) {
	      return {
	        header: !isSmall && this.renderCurator(),
	        content: canShowFollow && this.renderFollowButtonOrLabel()
	      };
	    } else {
	      return {
	        header: !isSmall && this.renderCurator(),
	        content: null
	      };
	    }
	  },

	  renderCurator: function renderCurator() {
	    var curator = this.state.curator;

	    return _react2['default'].createElement(
	      'div',
	      { className: 'ZineItem-curator' },
	      _react2['default'].createElement(
	        'span',
	        null,
	        'Curated by '
	      ),
	      _react2['default'].createElement(_atomsUserLink2['default'], { user: curator,
	        className: 'ZineItem-curatorLink',
	        bold: true })
	    );
	  },

	  renderFollowButtonOrLabel: function renderFollowButtonOrLabel() {
	    var zine = this.props.zine;
	    var curator = this.state.curator;
	    var subscriberCount = zine.subscriberCount;

	    if (_storesUserStore2['default'].isMe(curator)) {
	      return _react2['default'].createElement(
	        'span',
	        null,
	        (0, _utilsFormatCount2['default'])(subscriberCount),
	        ' ',
	        (0, _utilsPluralize2['default'])(subscriberCount, 'Follower', 'Followers')
	      );
	    }

	    return _react2['default'].createElement(_moleculesFollowZineButton2['default'], { zine: zine });
	  }
	});

	exports['default'] = ZineItem;
	module.exports = exports['default'];

/***/ },
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var ActivityStore = __webpack_require__(772);
	var UserStore = __webpack_require__(5);var createListStore = PaginatedStoreUtils.createListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var _unseenCount = 0,
	    _expanded = {};

	function expandActivities(activity) {
	  if (_expanded[activity.id]) {
	    return activity.aggregated.map(ActivityStore.get);
	  }
	  return activity;
	}

	var ActivityListStore = createListStore({
	  getActivities: function getActivities() {
	    return this.getIds(UserStore.getMe().id).map(ActivityStore.get).map(expandActivities);
	  },

	  getUnseenCount: function getUnseenCount() {
	    return _unseenCount;
	  }
	});

	function getList() {
	  return ActivityListStore.getList(UserStore.getMe().id);
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_ACTIVITIES,
	  error: ActionTypes.REQUEST_ACTIVITIES_ERROR,
	  success: ActionTypes.REQUEST_ACTIVITIES_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ActivityStore.dispatchToken]);

	  var action = payload.action,
	      list;

	  if (!UserStore.getMe()) {
	    return;
	  }

	  list = getList();

	  handleListAction(action, list, ActivityListStore.emitChange);

	  switch (action.type) {
	    case ActionTypes.INVALIDATE_ACTIVITIES:
	      ActivityListStore.invalidate();
	      break;

	    case ActionTypes.ACTIVITY_MARK_ALL_SUCCESS:
	      _unseenCount = 0;
	      ActivityListStore.emitChange();
	      break;

	    case ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS:
	      _unseenCount = action.count;
	      ActivityListStore.emitChange();
	      break;

	    case ActionTypes.ACTIVITY_EXPAND:
	      _expanded[action.activityId] = true;
	      ActivityListStore.emitChange();
	      break;
	  }
	});

	module.exports = ActivityListStore;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var FeedStore = __webpack_require__(420);
	var UserStore = __webpack_require__(5);
	var TrendingStore = __webpack_require__(428);
	var StampStore = __webpack_require__(17);
	var ScreenSizeStore = __webpack_require__(121);
	var getStampCountPerRow = __webpack_require__(149);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var _require2 = __webpack_require__(4);

	var chain = _require2.chain;
	var filter = _require2.filter;
	var groupBy = _require2.groupBy;
	var isArray = _require2.isArray;
	var last = _require2.last;
	var pluck = _require2.pluck;
	var uniq = _require2.uniq;
	var values = _require2.values;

	var FEED_PREFERRED_COLUMNS = 3,
	    FEED_CONSECUTIVE_ROWS = 2,
	    TRENDING_CONSECUTIVE_ROWS = 1;

	/**
	 * Makes sure that duplicate trending stamp is not in feed or at least far enough from feed stamp
	 * (so we don't have to refilter whole trending after fetching more feed)
	 */
	function filterDuplicatesFromTrending(trendingStampIds, feedStampIds) {
	  var screenSize = ScreenSizeStore.getScreenSize(),
	      stampsPerRow = getStampCountPerRow(screenSize, FEED_PREFERRED_COLUMNS);

	  return filter(trendingStampIds, function (stampId, idx) {
	    var feedIdx = feedStampIds.indexOf(stampId),
	        trendingRow = Math.floor(idx / stampsPerRow),
	        feedRow = Math.floor(feedIdx / stampsPerRow);

	    return feedIdx === -1 || feedRow > trendingRow * (FEED_CONSECUTIVE_ROWS / TRENDING_CONSECUTIVE_ROWS) + FEED_CONSECUTIVE_ROWS;
	  });
	}

	function groupByRow(stampIds, consecutiveRows) {
	  var screenSize = ScreenSizeStore.getScreenSize(),
	      stampsPerRow = getStampCountPerRow(screenSize, FEED_PREFERRED_COLUMNS);

	  return groupBy(stampIds, function (val, key) {
	    return Math.floor(key / (consecutiveRows * stampsPerRow));
	  });
	}

	function getGroupedIds() {
	  if (!UserStore.isAuthenticated()) {
	    return {
	      groupedFeedIds: [],
	      groupedTrendingIds: [TrendingStore.getIds()]
	    };
	  }

	  if (!TrendingStore.getPageCount() || !FeedStore.getPageCount()) {
	    return {
	      groupedFeedIds: [],
	      groupedTrendingIds: []
	    };
	  }

	  if (!FeedStore.getIds().length) {
	    return {
	      groupedFeedIds: [],
	      groupedTrendingIds: [TrendingStore.getIds()]
	    };
	  }

	  var feedStampIds = FeedStore.getIds(),
	      trendingStampIds = filterDuplicatesFromTrending(TrendingStore.getIds(), feedStampIds),
	      screenSize = ScreenSizeStore.getScreenSize(),
	      stampsPerRow = getStampCountPerRow(screenSize, FEED_PREFERRED_COLUMNS),
	      groupedFeedIds = values(groupByRow(feedStampIds, FEED_CONSECUTIVE_ROWS)),
	      groupedTrendingIds = values(groupByRow(trendingStampIds, TRENDING_CONSECUTIVE_ROWS));

	  // Throw away last few trending stamps that don't make a nice row
	  if (groupedTrendingIds.length && last(groupedTrendingIds).length < TRENDING_CONSECUTIVE_ROWS * stampsPerRow) {
	    groupedTrendingIds.splice(groupedTrendingIds.length - 1, 1);
	  }

	  return {
	    groupedFeedIds: groupedFeedIds,
	    groupedTrendingIds: groupedTrendingIds
	  };
	}

	var FeedWithTrendingStore = createStore({
	  getStamps: function getStamps() {
	    return uniq(pluck(this.getKeyedStamps(), 'item'));
	  },

	  getKeyedStamps: function getKeyedStamps() {
	    var _getGroupedIds = getGroupedIds();

	    var groupedFeedIds = _getGroupedIds.groupedFeedIds;
	    var groupedTrendingIds = _getGroupedIds.groupedTrendingIds;
	    var groupedFeedStamps;
	    var groupedTrendingStamps;

	    groupedFeedStamps = groupedFeedIds.map(function (group) {
	      return group.map(function (id) {
	        return {
	          key: id + '-feed',
	          item: StampStore.get(id),
	          isTrending: false
	        };
	      });
	    });

	    groupedTrendingStamps = groupedTrendingIds.map(function (group) {
	      return group.map(function (id) {
	        return {
	          key: id + '-trending',
	          item: StampStore.get(id),
	          isTrending: true
	        };
	      });
	    });

	    return chain(groupedFeedStamps).zip(groupedTrendingStamps)
	    // Avoid lots of trending getting ahead of next Feed page, unless that's the last one:
	    .filter(function (zipped) {
	      return isArray(zipped[0]) || FeedStore.isLastPage();
	    }).flatten().compact().value();
	  },

	  isExpectingPage: function isExpectingPage() {
	    return FeedStore.isExpectingPage() || TrendingStore.isExpectingPage();
	  },

	  isLastPage: function isLastPage() {
	    return FeedStore.isLastPage() && TrendingStore.isLastPage();
	  },

	  isInvalidated: function isInvalidated() {
	    return FeedStore.isInvalidated() || TrendingStore.isInvalidated();
	  },

	  needFeed: function needFeed(isInitialRequest) {
	    if (!UserStore.isAuthenticated()) {
	      return false;
	    }

	    var isEmpty = !FeedStore.getIds().length;
	    return isInitialRequest && isEmpty || !FeedStore.isLastPage() || FeedStore.isInvalidated();
	  },

	  needTrending: function needTrending(isInitialRequest) {
	    var isEmpty = !TrendingStore.getIds().length;
	    return isInitialRequest && isEmpty || !TrendingStore.isLastPage() || TrendingStore.isInvalidated();
	  }
	});

	FeedStore.addChangeListener(function () {
	  return FeedWithTrendingStore.emitChange();
	});

	TrendingStore.addChangeListener(function () {
	  return FeedWithTrendingStore.emitChange();
	});

	ScreenSizeStore.addChangeListener(function () {
	  return FeedWithTrendingStore.emitChange();
	});

	module.exports = FeedWithTrendingStore;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var UserStore = __webpack_require__(5);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var mergeIntoBag = _require.mergeIntoBag;
	var isInBag = _require.isInBag;

	var invitations = {};

	var InvitationStore = createStore({
	  contains: function contains(slug, fields) {
	    return isInBag(invitations, slug, fields);
	  },

	  get: function get(id) {
	    return invitations[id];
	  }
	});

	InvitationStore._objects = invitations;

	InvitationStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      receivedInvitations = entities && entities.userInvitations;

	  if (receivedInvitations) {
	    mergeIntoBag(invitations, receivedInvitations);
	    InvitationStore.emitChange();
	  }
	});

	module.exports = InvitationStore;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var SocialFriendStore = __webpack_require__(777);
	var UserStore = __webpack_require__(5);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var validLists = {};

	var SocialFriendListStore = createIndexedListStore({
	  getFriends: function getFriends(serviceType) {
	    if (!validLists[serviceType]) {
	      return null;
	    }

	    return this.getIds(serviceType).map(SocialFriendStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_SOCIAL_FRIENDS,
	  error: ActionTypes.REQUEST_SOCIAL_FRIENDS_ERROR,
	  success: ActionTypes.REQUEST_SOCIAL_FRIENDS_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([SocialFriendStore.dispatchToken]);

	  var action = payload.action,
	      serviceType = action.serviceType;

	  if (!UserStore.getMe()) {
	    return;
	  }

	  switch (action.type) {
	    case ActionTypes.REQUEST_SOCIAL_FRIENDS_ERROR:
	      delete validLists[action.serviceType];
	      break;

	    case ActionTypes.REQUEST_SOCIAL_FRIENDS_SUCCESS:
	      validLists[action.serviceType] = true;
	      break;
	  }

	  handleListAction(action, SocialFriendListStore.getList(serviceType), SocialFriendListStore.emitChange);
	});

	module.exports = SocialFriendListStore;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var ZineStore = __webpack_require__(22);
	var UserStore = __webpack_require__(5);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserCuratedZineStore = createIndexedListStore({
	  getZines: function getZines(userId) {
	    return this.getIds(userId).map(ZineStore.get);
	  }
	});

	function getList(userId) {
	  return UserCuratedZineStore.getList(userId);
	}

	function emitChange() {
	  UserCuratedZineStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_CURATED_ZINES,
	  error: ActionTypes.REQUEST_USER_CURATED_ZINES_ERROR,
	  success: ActionTypes.REQUEST_USER_CURATED_ZINES_SUCCESS,
	  preload: ActionTypes.PRELOAD_USER_CURATED_ZINES
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.CREATE_ZINE_SUCCESS:
	      getList(UserStore.getMe().id).prepend(action.zineSlug);
	      emitChange();
	      break;
	  }
	});

	module.exports = UserCuratedZineStore;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StampStore = __webpack_require__(17);
	var PaginatedStoreUtils = __webpack_require__(28);
	var parseStampSegment = __webpack_require__(53);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var ZineLatestStampStore = createIndexedListStore({
	  getStamps: function getStamps(zineSlug) {
	    return this.getIds(zineSlug).map(StampStore.get);
	  }
	});

	function getList(zineSlug) {
	  return ZineLatestStampStore.getList(zineSlug);
	}

	function emitChange() {
	  ZineLatestStampStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_ZINE_LATEST_STAMPS,
	  error: ActionTypes.REQUEST_ZINE_LATEST_STAMPS_ERROR,
	  success: ActionTypes.REQUEST_ZINE_LATEST_STAMPS_SUCCESS,
	  preload: ActionTypes.PRELOAD_ZINE_LATEST_STAMPS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);

	  var action = payload.action,
	      zineSlug = action.zineSlug,
	      stampSegment = action.stampSegment,
	      stampId,
	      list;

	  if (!zineSlug) {
	    return;
	  }

	  list = getList(zineSlug);
	  handleListAction(action, list, emitChange);

	  if (stampSegment) {
	    stampId = parseStampSegment(stampSegment).stampId;
	  }

	  switch (action.type) {
	    case ActionTypes.ADD_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
	      list.prepend(stampId);
	      ZineLatestStampStore.emitChange();
	      break;

	    case ActionTypes.REMOVE_STAMP_FROM_ZINE_SUCCESS:
	      list.remove(stampId);
	      ZineLatestStampStore.emitChange();
	      break;

	    case ActionTypes.INVALIDATE_ZINE_LATEST_STAMPS:
	      list.invalidate();
	      break;
	  }
	});

	module.exports = ZineLatestStampStore;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _SectionStore = __webpack_require__(775);

	var _SectionStore2 = _interopRequireDefault(_SectionStore);

	var _utilsPaginatedStoreUtils = __webpack_require__(28);

	'use strict';

	var ZineSectionsStore = (0, _utilsPaginatedStoreUtils.createListStore)({
	  getSections: function getSections() {
	    return this.getIds().map(_SectionStore2['default'].get);
	  }
	});

	var handleListAction = (0, _utilsPaginatedStoreUtils.createListActionHandler)({
	  request: _constantsActionTypes2['default'].REQUEST_ZINE_SECTIONS,
	  error: _constantsActionTypes2['default'].REQUEST_ZINE_SECTIONS_ERROR,
	  success: _constantsActionTypes2['default'].REQUEST_ZINE_SECTIONS_SUCCESS,
	  preload: _constantsActionTypes2['default'].PRELOAD_ZINE_SECTIONS
	});

	_AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_SectionStore2['default'].dispatchToken]);
	  handleListAction(payload.action, ZineSectionsStore.getList(), ZineSectionsStore.emitChange);
	});

	exports['default'] = ZineSectionsStore;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _ravenJs = __webpack_require__(992);

	var _ravenJs2 = _interopRequireDefault(_ravenJs);

	var _constantsApiKeys = __webpack_require__(396);

	var _constantsApiKeys2 = _interopRequireDefault(_constantsApiKeys);

	'use strict';

	var ravenEnabled = false;

	function setup() {
	  _ravenJs2['default'].config(_constantsApiKeys2['default'].SENTRY_URL);

	  if (("production") === 'production' && ravenEnabled) {
	    _ravenJs2['default'].install();
	  }
	}

	function associateWithUser(me) {
	  _ravenJs2['default'].setUserContext({
	    email: me.email,
	    id: me.id,
	    name: me.name
	  });
	}

	function wrap(f) {
	  if (("production") === 'production' && ravenEnabled) {
	    return _ravenJs2['default'].wrap(f);
	  } else {
	    return f;
	  }
	}

	exports['default'] = {
	  associateWithUser: associateWithUser,
	  setup: setup,
	  wrap: wrap
	};
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	var FileUploader = __webpack_require__(779),
	    UserStore = __webpack_require__(5),
	    request = __webpack_require__(385),
	    config = __webpack_require__(66);

	var uploaderBaseUrl = config.uploaderBaseUrl;
	if (!uploaderBaseUrl) {
	  throw new Error('You forgot to pass uploaderBaseUrl as config parameter.');
	}

	var urlUploaderBaseUrl = config.urlUploaderBaseUrl;
	if (!urlUploaderBaseUrl) {
	  throw new Error('You forgot to pass urlUploaderBaseUrl as config parameter.');
	}

	function rgbToHex(rgb) {
	  /*jshint bitwise: false*/
	  return ((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).substr(1);
	}

	function toImage(uploadResult) {
	  if (!uploadResult.url) {
	    throw {
	      description: 'The file you tried to upload is a type we don’t understand.\nSupported formats are JPEG, PNG and GIF.'
	    };
	  }

	  return {
	    type: 'image',
	    url: uploadResult.url,
	    size: uploadResult.size,
	    colors: {
	      top: rgbToHex(uploadResult.colors.top),
	      bottom: rgbToHex(uploadResult.colors.bottom)
	    }
	  };
	}

	function getUploaderData() {
	  return {
	    'user_id': UserStore.getMe().id
	  };
	}

	function createFileUploader() {
	  return new FileUploader({
	    uploadUrl: uploaderBaseUrl,
	    key: 'image',
	    transform: toImage,
	    maxSimultaneousUploads: 4,
	    data: getUploaderData()
	  });
	}

	function uploadFromUrl(url, cancellationToken) {
	  return new _Promise(function (resolve, reject) {
	    var req = request.post(urlUploaderBaseUrl).send({
	      url: url,
	      data: getUploaderData()
	    }).end(function (error, res) {
	      if (error) {
	        reject(error);
	      } else {
	        resolve(toImage(JSON.parse(res.text)));
	      }
	    });

	    if (cancellationToken) {
	      cancellationToken.onCancelled(function (reason) {
	        reject(reason);
	        req.abort();
	      });
	    }
	  });
	}

	var ImageUploader = {
	  createFileUploader: createFileUploader,
	  uploadFromUrl: uploadFromUrl
	};

	module.exports = ImageUploader;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var getInnerText = __webpack_require__(795);

	function dangerouslyStripHTML(html) {
	  var tmpEl = document.createElement('div');
	  tmpEl.innerHTML = html || '';
	  return getInnerText(tmpEl);
	}

	module.exports = dangerouslyStripHTML;

/***/ },
/* 297 */,
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _getIterator = __webpack_require__(302)['default'];

	var _Object$entries = __webpack_require__(803)['default'];

	var TRANSFORM_VARIANTS = {
	  'WebkitTransform': '-webkit-transform',
	  'transform': 'transform'
	};

	function test() {
	  if (typeof document === 'undefined') {
	    console.log('document unavailable in node');
	    return;
	  }
	  var testEl = document.createElement('div'),
	      style = testEl.style;

	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;

	  try {
	    for (var _iterator = _getIterator(_Object$entries(TRANSFORM_VARIANTS)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _step$value = _slicedToArray(_step.value, 2);

	      var jsProp = _step$value[0];
	      var cssProp = _step$value[1];

	      style.cssText = '' + cssProp + ': translate3d(0, 0, 0)';

	      if (style[jsProp] && style[jsProp].length) {
	        return {
	          js: jsProp,
	          css: cssProp
	        };
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}

	var property;
	function getSupportedTransformProperty() {
	  if (!property) {
	    property = test();
	  }

	  return property;
	}

	module.exports = getSupportedTransformProperty;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var DEFAULT_THUMBNAIL = '//stampsy-eu-1.s3.amazonaws.com/2014/10/14/images/user.png';

	function getUserThumbnail(user) {
	  if (user.thumbnailUrl) {
	    return {
	      isDefault: false,
	      url: user.thumbnailUrl
	    };
	  }

	  return {
	    isDefault: true,
	    url: DEFAULT_THUMBNAIL
	  };
	}

	module.exports = getUserThumbnail;

/***/ },
/* 300 */,
/* 301 */,
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(807), __esModule: true };

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(810), __esModule: true };

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(813), __esModule: true };

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(25).hide;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var set   = __webpack_require__(25).set
	  , $at   = __webpack_require__(828)(true)
	  , ITER  = __webpack_require__(226).safe('iter')
	  , $iter = __webpack_require__(150)
	  , step  = $iter.step;

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(456)(String, 'String', function(iterated){
	  set(this, ITER, {o: String(iterated), i: 0});
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var iter  = this[ITER]
	    , O     = iter.o
	    , index = iter.i
	    , point;
	  if(index >= O.length)return step(1);
	  point = $at(O, index);
	  iter.i += point.length;
	  return step(0, point);
	});

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(831);
	var $           = __webpack_require__(25)
	  , Iterators   = __webpack_require__(150).Iterators
	  , ITERATOR    = __webpack_require__(124)('iterator')
	  , ArrayValues = Iterators.Array
	  , NL          = $.g.NodeList
	  , HTC         = $.g.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype;
	if($.FW){
	  if(NL && !(ITERATOR in NLProto))$.hide(NLProto, ITERATOR, ArrayValues);
	  if(HTC && !(ITERATOR in HTCProto))$.hide(HTCProto, ITERATOR, ArrayValues);
	}
	Iterators.NodeList = Iterators.HTMLCollection = ArrayValues;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var $def            = __webpack_require__(23)
	  , $redef          = __webpack_require__(101)
	  , $               = __webpack_require__(14)
	  , cof             = __webpack_require__(72)
	  , $iter           = __webpack_require__(100)
	  , SYMBOL_ITERATOR = __webpack_require__(73)('iterator')
	  , FF_ITERATOR     = '@@iterator'
	  , KEYS            = 'keys'
	  , VALUES          = 'values'
	  , Iterators       = $iter.Iterators;
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE){
	  $iter.create(Constructor, NAME, next);
	  function createMethod(kind){
	    function $$(that){
	      return new Constructor(that, kind);
	    }
	    switch(kind){
	      case KEYS: return function keys(){ return $$(this); };
	      case VALUES: return function values(){ return $$(this); };
	    } return function entries(){ return $$(this); };
	  }
	  var TAG      = NAME + ' Iterator'
	    , proto    = Base.prototype
	    , _native  = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , _default = _native || createMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if(_native){
	    var IteratorPrototype = $.getProto(_default.call(new Base));
	    // Set @@toStringTag to native iterators
	    cof.set(IteratorPrototype, TAG, true);
	    // FF fix
	    if($.FW && $.has(proto, FF_ITERATOR))$iter.set(IteratorPrototype, $.that);
	  }
	  // Define iterator
	  if($.FW || FORCE)$iter.set(proto, _default);
	  // Plug for library
	  Iterators[NAME] = _default;
	  Iterators[TAG]  = $.that;
	  if(DEFAULT){
	    methods = {
	      keys:    IS_SET            ? _default : createMethod(KEYS),
	      values:  DEFAULT == VALUES ? _default : createMethod(VALUES),
	      entries: DEFAULT != VALUES ? _default : createMethod('entries')
	    };
	    if(FORCE)for(key in methods){
	      if(!(key in proto))$redef(proto, key, methods[key]);
	    } else $def($def.P + $def.F * $iter.BUGGY, NAME, methods);
	  }
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var SYMBOL_ITERATOR = __webpack_require__(73)('iterator')
	  , SAFE_CLOSING    = false;
	try {
	  var riter = [7][SYMBOL_ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	module.exports = function(exec){
	  if(!SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[SYMBOL_ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[SYMBOL_ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function(regExp, replace, isStatic){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(isStatic ? it : this).replace(regExp, replacer);
	  };
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var $      = __webpack_require__(14)
	  , assert = __webpack_require__(65);
	function check(O, proto){
	  assert.obj(O);
	  assert(proto === null || $.isObject(proto), proto, ": can't set as prototype!");
	}
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} // eslint-disable-line
	    ? function(buggy, set){
	        try {
	          set = __webpack_require__(125)(Function.call, $.getDesc(Object.prototype, '__proto__').set, 2);
	          set({}, []);
	        } catch(e){ buggy = true; }
	        return function setPrototypeOf(O, proto){
	          check(O, proto);
	          if(buggy)O.__proto__ = proto;
	          else set(O, proto);
	          return O;
	        };
	      }()
	    : undefined),
	  check: check
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var $      = __webpack_require__(14)
	  , SHARED = '__core-js_shared__'
	  , store  = $.g[SHARED] || ($.g[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// true  -> String#at
	// false -> String#codePointAt
	var $ = __webpack_require__(14);
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String($.assertDefined(that))
	      , i = $.toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l
	      || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	        ? TO_STRING ? s.charAt(i) : a
	        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(exec){
	  try {
	    exec();
	    return false;
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(189);

	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iterator functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	function baseFor(object, iteratee, keysFunc) {
	  var index = -1,
	      iterable = toObject(object),
	      props = keysFunc(object),
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];
	    if (iteratee(iterable[key], key, iterable) === false) {
	      break;
	    }
	  }
	  return object;
	}

	module.exports = baseFor;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(348),
	    keys = __webpack_require__(126);

	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}

	module.exports = baseForOwn;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Used as the maximum length of an array-like value.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * for more details.
	 */
	var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = +value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}

	module.exports = isIndex;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(88),
	    isObjectLike = __webpack_require__(188);

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  var length = isObjectLike(value) ? value.length : undefined;
	  return (isLength(length) && objToString.call(value) == argsTag) || false;
	}

	module.exports = isArguments;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var isNative = __webpack_require__(103);

	/** Used to detect functions containing a `this` reference. */
	var reThis = /\bthis\b/;

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to detect DOM support. */
	var document = (document = global.window) && document.document;

	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};

	(function(x) {

	  /**
	   * Detect if functions can be decompiled by `Function#toString`
	   * (all but Firefox OS certified apps, older Opera mobile browsers, and
	   * the PlayStation 3; forced `false` for Windows 8 apps).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.funcDecomp = !isNative(global.WinRTError) && reThis.test(function() { return this; });

	  /**
	   * Detect if `Function#name` is supported (all but IE).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.funcNames = typeof Function.name == 'string';

	  /**
	   * Detect if the DOM is supported.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  try {
	    support.dom = document.createDocumentFragment().nodeType === 11;
	  } catch(e) {
	    support.dom = false;
	  }

	  /**
	   * Detect if `arguments` object indexes are non-enumerable.
	   *
	   * In Firefox < 4, IE < 9, PhantomJS, and Safari < 5.1 `arguments` object
	   * indexes are non-enumerable. Chrome < 25 and Node.js < 0.11.0 treat
	   * `arguments` object indexes as non-enumerable and fail `hasOwnProperty`
	   * checks for indexes that exceed their function's formal parameters with
	   * associated values of `0`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  try {
	    support.nonEnumArgs = !propertyIsEnumerable.call(arguments, 1);
	  } catch(e) {
	    support.nonEnumArgs = true;
	  }
	}(0, 0));

	module.exports = support;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	module.exports = identity;


/***/ },
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var invariant = __webpack_require__(11);
	var objectAssign = __webpack_require__(1088);
	var qs = __webpack_require__(1089);

	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?/g;
	var queryMatcher = /\?(.*)$/;

	var _compiledPatterns = {};

	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return "([^/?#]+)";
	      } else if (match === "*") {
	        paramNames.push("splat");
	        return "(.*?)";
	      } else {
	        return "\\" + match;
	      }
	    });

	    _compiledPatterns[pattern] = {
	      matcher: new RegExp("^" + source + "$", "i"),
	      paramNames: paramNames
	    };
	  }

	  return _compiledPatterns[pattern];
	}

	var PathUtils = {

	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === "/";
	  },

	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, "/") + b;
	  },

	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },

	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);

	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;

	    var match = path.match(matcher);

	    if (!match) {
	      return null;
	    }var params = {};

	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });

	    return params;
	  },

	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};

	    var splatIndex = 0;

	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || "splat";

	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === "?") {
	        paramName = paramName.slice(0, -1);

	        if (params[paramName] == null) return "";
	      } else {
	        invariant(params[paramName] != null, "Missing \"%s\" parameter for path \"%s\"", paramName, pattern);
	      }

	      var segment;
	      if (paramName === "splat" && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];

	        invariant(segment != null, "Missing splat # %s for path \"%s\"", splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }

	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, "/");
	  },

	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },

	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, "");
	  },

	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);

	    if (existingQuery) query = query ? objectAssign(existingQuery, query) : existingQuery;

	    var queryString = qs.stringify(query, { arrayFormat: "brackets" });

	    if (queryString) {
	      return PathUtils.withoutQuery(path) + "?" + queryString;
	    }return PathUtils.withoutQuery(path);
	  }

	};

	module.exports = PathUtils;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var LocationActions = __webpack_require__(190);
	var History = __webpack_require__(153);

	var _listeners = [];
	var _isListening = false;

	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };

	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}

	function onPopState(event) {
	  if (event.state === undefined) {
	    return;
	  } // Ignore extraneous popstate events in WebKit.

	  notifyChange(LocationActions.POP);
	}

	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {

	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);

	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener("popstate", onPopState, false);
	      } else {
	        window.attachEvent("onpopstate", onPopState);
	      }

	      _isListening = true;
	    }
	  },

	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });

	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener("popstate", onPopState, false);
	      } else {
	        window.removeEvent("onpopstate", onPopState);
	      }

	      _isListening = false;
	    }
	  },

	  push: function push(path) {
	    window.history.pushState({ path: path }, "", path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },

	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, "", path);
	    notifyChange(LocationActions.REPLACE);
	  },

	  pop: History.back,

	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },

	  toString: function toString() {
	    return "<HistoryLocation>";
	  }

	};

	module.exports = HistoryLocation;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1140);


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);

	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}

	assign(CallbackQueue.prototype, {

	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },

	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      (false ? invariant(
	        callbacks.length === contexts.length,
	        'Mismatched list of contexts in callback queue'
	      ) : invariant(callbacks.length === contexts.length));
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0, l = callbacks.length; i < l; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },

	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function() {
	    this._callbacks = null;
	    this._contexts = null;
	  },

	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function() {
	    this.reset();
	  }

	});

	PooledClass.addPoolingTo(CallbackQueue);

	module.exports = CallbackQueue;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */

	'use strict';

	var ReactPropTypes = __webpack_require__(531);

	var invariant = __webpack_require__(11);

	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};

	function _assertSingleLink(input) {
	  (false ? invariant(
	    input.props.checkedLink == null || input.props.valueLink == null,
	    'Cannot provide a checkedLink and a valueLink. If you want to use ' +
	    'checkedLink, you probably don\'t want to use valueLink and vice versa.'
	  ) : invariant(input.props.checkedLink == null || input.props.valueLink == null));
	}
	function _assertValueLink(input) {
	  _assertSingleLink(input);
	  (false ? invariant(
	    input.props.value == null && input.props.onChange == null,
	    'Cannot provide a valueLink and a value or onChange event. If you want ' +
	    'to use value or onChange, you probably don\'t want to use valueLink.'
	  ) : invariant(input.props.value == null && input.props.onChange == null));
	}

	function _assertCheckedLink(input) {
	  _assertSingleLink(input);
	  (false ? invariant(
	    input.props.checked == null && input.props.onChange == null,
	    'Cannot provide a checkedLink and a checked property or onChange event. ' +
	    'If you want to use checked or onChange, you probably don\'t want to ' +
	    'use checkedLink'
	  ) : invariant(input.props.checked == null && input.props.onChange == null));
	}

	/**
	 * @param {SyntheticEvent} e change event to handle
	 */
	function _handleLinkedValueChange(e) {
	  /*jshint validthis:true */
	  this.props.valueLink.requestChange(e.target.value);
	}

	/**
	  * @param {SyntheticEvent} e change event to handle
	  */
	function _handleLinkedCheckChange(e) {
	  /*jshint validthis:true */
	  this.props.checkedLink.requestChange(e.target.checked);
	}

	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  Mixin: {
	    propTypes: {
	      value: function(props, propName, componentName) {
	        if (!props[propName] ||
	            hasReadOnlyValue[props.type] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `value` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultValue`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      checked: function(props, propName, componentName) {
	        if (!props[propName] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `checked` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultChecked`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      onChange: ReactPropTypes.func
	    }
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return input.props.valueLink.value;
	    }
	    return input.props.value;
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function(input) {
	    if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return input.props.checkedLink.value;
	    }
	    return input.props.checked;
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {function} change callback either from onChange prop or link.
	   */
	  getOnChange: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return _handleLinkedValueChange;
	    } else if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return _handleLinkedCheckChange;
	    }
	    return input.props.onChange;
	  }
	};

	module.exports = LinkedValueUtils;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LocalEventTrapMixin
	 */

	'use strict';

	var ReactBrowserEventEmitter = __webpack_require__(140);

	var accumulateInto = __webpack_require__(243);
	var forEachAccumulated = __webpack_require__(377);
	var invariant = __webpack_require__(11);

	function remove(event) {
	  event.remove();
	}

	var LocalEventTrapMixin = {
	  trapBubbledEvent:function(topLevelType, handlerBaseName) {
	    (false ? invariant(this.isMounted(), 'Must be mounted to trap events') : invariant(this.isMounted()));
	    // If a component renders to null or if another component fatals and causes
	    // the state of the tree to be corrupted, `node` here can be null.
	    var node = this.getDOMNode();
	    (false ? invariant(
	      node,
	      'LocalEventTrapMixin.trapBubbledEvent(...): Requires node to be rendered.'
	    ) : invariant(node));
	    var listener = ReactBrowserEventEmitter.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      node
	    );
	    this._localEventListeners =
	      accumulateInto(this._localEventListeners, listener);
	  },

	  // trapCapturedEvent would look nearly identical. We don't implement that
	  // method because it isn't currently needed.

	  componentWillUnmount:function() {
	    if (this._localEventListeners) {
	      forEachAccumulated(this._localEventListeners, remove);
	    }
	  }
	};

	module.exports = LocalEventTrapMixin;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);
	var ReactFragment = __webpack_require__(158);

	var traverseAllChildren = __webpack_require__(544);
	var warning = __webpack_require__(26);

	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var threeArgumentPooler = PooledClass.threeArgumentPooler;

	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.forEachFunction = forEachFunction;
	  this.forEachContext = forEachContext;
	}
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

	function forEachSingleChild(traverseContext, child, name, i) {
	  var forEachBookKeeping = traverseContext;
	  forEachBookKeeping.forEachFunction.call(
	    forEachBookKeeping.forEachContext, child, i);
	}

	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }

	  var traverseContext =
	    ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}

	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, mapFunction, mapContext) {
	  this.mapResult = mapResult;
	  this.mapFunction = mapFunction;
	  this.mapContext = mapContext;
	}
	PooledClass.addPoolingTo(MapBookKeeping, threeArgumentPooler);

	function mapSingleChildIntoContext(traverseContext, child, name, i) {
	  var mapBookKeeping = traverseContext;
	  var mapResult = mapBookKeeping.mapResult;

	  var keyUnique = !mapResult.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'ReactChildren.map(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }

	  if (keyUnique) {
	    var mappedChild =
	      mapBookKeeping.mapFunction.call(mapBookKeeping.mapContext, child, i);
	    mapResult[name] = mappedChild;
	  }
	}

	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * TODO: This may likely break any calls to `ReactChildren.map` that were
	 * previously relying on the fact that we guarded against null children.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }

	  var mapResult = {};
	  var traverseContext = MapBookKeeping.getPooled(mapResult, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	  return ReactFragment.create(mapResult);
	}

	function forEachSingleChildDummy(traverseContext, child, name, i) {
	  return null;
	}

	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}

	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  count: countChildren
	};

	module.exports = ReactChildren;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */

	/*jslint evil: true */

	'use strict';

	var ReactDOMIDOperations = __webpack_require__(526);
	var ReactMount = __webpack_require__(109);

	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {

	  processChildrenUpdates:
	    ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

	  replaceNodeWithMarkupByID:
	    ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,

	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function(rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }

	};

	module.exports = ReactComponentBrowserEnvironment;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	var injected = false;

	var ReactComponentEnvironment = {

	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,

	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,

	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,

	  injection: {
	    injectEnvironment: function(environment) {
	      (false ? invariant(
	        !injected,
	        'ReactCompositeComponent: injectEnvironment() can only be called once.'
	      ) : invariant(!injected));
	      ReactComponentEnvironment.unmountIDFromEnvironment =
	        environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID =
	        environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates =
	        environment.processChildrenUpdates;
	      injected = true;
	    }
	  }

	};

	module.exports = ReactComponentEnvironment;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactContext
	 */

	'use strict';

	var assign = __webpack_require__(15);
	var emptyObject = __webpack_require__(244);
	var warning = __webpack_require__(26);

	var didWarn = false;

	/**
	 * Keeps track of the current context.
	 *
	 * The context is automatically passed down the component ownership hierarchy
	 * and is accessible via `this.context` on ReactCompositeComponents.
	 */
	var ReactContext = {

	  /**
	   * @internal
	   * @type {object}
	   */
	  current: emptyObject,

	  /**
	   * Temporarily extends the current context while executing scopedCallback.
	   *
	   * A typical use case might look like
	   *
	   *  render: function() {
	   *    var children = ReactContext.withContext({foo: 'foo'}, () => (
	   *
	   *    ));
	   *    return <div>{children}</div>;
	   *  }
	   *
	   * @param {object} newContext New context to merge into the existing context
	   * @param {function} scopedCallback Callback to run with the new context
	   * @return {ReactComponent|array<ReactComponent>}
	   */
	  withContext: function(newContext, scopedCallback) {
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        didWarn,
	        'withContext is deprecated and will be removed in a future version. ' +
	        'Use a wrapper component with getChildContext instead.'
	      ) : null);

	      didWarn = true;
	    }

	    var result;
	    var previousContext = ReactContext.current;
	    ReactContext.current = assign({}, previousContext, newContext);
	    try {
	      result = scopedCallback();
	    } finally {
	      ReactContext.current = previousContext;
	    }
	    return result;
	  }

	};

	module.exports = ReactContext;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */

	/* global hasOwnProperty:true */

	'use strict';

	var CSSPropertyOperations = __webpack_require__(522);
	var DOMProperty = __webpack_require__(155);
	var DOMPropertyOperations = __webpack_require__(191);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(367);
	var ReactMount = __webpack_require__(109);
	var ReactMultiChild = __webpack_require__(1130);
	var ReactPerf = __webpack_require__(141);

	var assign = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(194);
	var invariant = __webpack_require__(11);
	var isEventSupported = __webpack_require__(382);
	var keyOf = __webpack_require__(76);
	var warning = __webpack_require__(26);

	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;

	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = {'string': true, 'number': true};

	var STYLE = keyOf({style: null});

	var ELEMENT_NODE_TYPE = 1;

	/**
	 * Optionally injectable operations for mutating the DOM
	 */
	var BackendIDOperations = null;

	/**
	 * @param {?object} props
	 */
	function assertValidProps(props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (props.dangerouslySetInnerHTML != null) {
	    (false ? invariant(
	      props.children == null,
	      'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
	    ) : invariant(props.children == null));
	    (false ? invariant(
	      props.dangerouslySetInnerHTML.__html != null,
	      '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' +
	      'Please visit http://fb.me/react-invariant-dangerously-set-inner-html ' +
	      'for more information.'
	    ) : invariant(props.dangerouslySetInnerHTML.__html != null));
	  }
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      props.innerHTML == null,
	      'Directly setting property `innerHTML` is not permitted. ' +
	      'For more information, lookup documentation on `dangerouslySetInnerHTML`.'
	    ) : null);
	    ("production" !== process.env.NODE_ENV ? warning(
	      !props.contentEditable || props.children == null,
	      'A component is `contentEditable` and contains `children` managed by ' +
	      'React. It is now your responsibility to guarantee that none of ' +
	      'those nodes are unexpectedly modified or duplicated. This is ' +
	      'probably not intentional.'
	    ) : null);
	  }
	  (false ? invariant(
	    props.style == null || typeof props.style === 'object',
	    'The `style` prop expects a mapping from style properties to values, ' +
	    'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' +
	    'using JSX.'
	  ) : invariant(props.style == null || typeof props.style === 'object'));
	}

	function putListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    ("production" !== process.env.NODE_ENV ? warning(
	      registrationName !== 'onScroll' || isEventSupported('scroll', true),
	      'This browser doesn\'t support the `onScroll` event'
	    ) : null);
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ?
	      container.ownerDocument :
	      container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getPutListenerQueue().enqueuePutListener(
	    id,
	    registrationName,
	    listener
	  );
	}

	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.

	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};

	// We accept any tag to be rendered but since this gets injected into abitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name

	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;

	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    (false ? invariant(VALID_TAG_REGEX.test(tag), 'Invalid tag: %s', tag) : invariant(VALID_TAG_REGEX.test(tag)));
	    validatedTagCache[tag] = true;
	  }
	}

	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag;
	  this._renderedChildren = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	}

	ReactDOMComponent.displayName = 'ReactDOMComponent';

	ReactDOMComponent.Mixin = {

	  construct: function(element) {
	    this._currentElement = element;
	  },

	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} The computed markup.
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    assertValidProps(this._currentElement.props);
	    var closeTag = omittedCloseTags[this._tag] ? '' : '</' + this._tag + '>';
	    return (
	      this._createOpenTagMarkupAndPutListeners(transaction) +
	      this._createContentMarkup(transaction, context) +
	      closeTag
	    );
	  },

	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function(transaction) {
	    var props = this._currentElement.props;
	    var ret = '<' + this._tag;

	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, propValue, transaction);
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup =
	          DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }

	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret + '>';
	    }

	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID + '>';
	  },

	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function(transaction, context) {
	    var prefix = '';
	    if (this._tag === 'listing' ||
	        this._tag === 'pre' ||
	        this._tag === 'textarea') {
	      // Add an initial newline because browsers ignore the first newline in
	      // a <listing>, <pre>, or <textarea> as an "authoring convenience" -- see
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody.
	      prefix = '\n';
	    }

	    var props = this._currentElement.props;

	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        return prefix + innerHTML.__html;
	      }
	    } else {
	      var contentToUse =
	        CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        return prefix + escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(
	          childrenToUse,
	          transaction,
	          context
	        );
	        return prefix + mountImages.join('');
	      }
	    }
	    return prefix;
	  },

	  receiveComponent: function(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },

	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(transaction, prevElement, nextElement, context) {
	    assertValidProps(this._currentElement.props);
	    this._updateDOMProperties(prevElement.props, transaction);
	    this._updateDOMChildren(prevElement.props, transaction, context);
	  },

	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMProperties: function(lastProps, transaction) {
	    var nextProps = this._currentElement.props;
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) ||
	         !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        deleteListener(this._rootNodeID, propKey);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.deletePropertyByID(
	          this._rootNodeID,
	          propKey
	        );
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ?
	        this._previousStyleCopy :
	        lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) &&
	                (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) &&
	                lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, nextProp, transaction);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.updatePropertyByID(
	          this._rootNodeID,
	          propKey,
	          nextProp
	        );
	      }
	    }
	    if (styleUpdates) {
	      BackendIDOperations.updateStylesByID(
	        this._rootNodeID,
	        styleUpdates
	      );
	    }
	  },

	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMChildren: function(lastProps, transaction, context) {
	    var nextProps = this._currentElement.props;

	    var lastContent =
	      CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent =
	      CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

	    var lastHtml =
	      lastProps.dangerouslySetInnerHTML &&
	      lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml =
	      nextProps.dangerouslySetInnerHTML &&
	      nextProps.dangerouslySetInnerHTML.__html;

	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;

	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }

	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        BackendIDOperations.updateInnerHTMLByID(
	          this._rootNodeID,
	          nextHtml
	        );
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },

	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function() {
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	  }

	};

	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});

	assign(
	  ReactDOMComponent.prototype,
	  ReactDOMComponent.Mixin,
	  ReactMultiChild.Mixin
	);

	ReactDOMComponent.injection = {
	  injectIDOperations: function(IDOperations) {
	    ReactDOMComponent.BackendIDOperations = BackendIDOperations = IDOperations;
	  }
	};

	module.exports = ReactDOMComponent;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactInstanceMap = __webpack_require__(160);

	var invariant = __webpack_require__(11);

	var component;
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};

	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function(emptyComponent) {
	    component = ReactElement.createFactory(emptyComponent);
	  }
	};

	var ReactEmptyComponentType = function() {};
	ReactEmptyComponentType.prototype.componentDidMount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Make sure we run these methods in the correct order, we shouldn't
	  // need this check. We're going to assume if we're here it means we ran
	  // componentWillUnmount already so there is no internal instance (it gets
	  // removed as part of the unmounting process).
	  if (!internalInstance) {
	    return;
	  }
	  registerNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.componentWillUnmount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Get rid of this check. See TODO in componentDidMount.
	  if (!internalInstance) {
	    return;
	  }
	  deregisterNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.render = function() {
	  (false ? invariant(
	    component,
	    'Trying to return null from a render, but no null placeholder component ' +
	    'was injected.'
	  ) : invariant(component));
	  return component();
	};

	var emptyElement = ReactElement.createElement(ReactEmptyComponentType);

	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}

	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}

	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}

	var ReactEmptyComponent = {
	  emptyElement: emptyElement,
	  injection: ReactEmptyComponentInjection,
	  isNullComponentID: isNullComponentID
	};

	module.exports = ReactEmptyComponent;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLifeCycle
	 */

	'use strict';

	/**
	 * This module manages the bookkeeping when a component is in the process
	 * of being mounted or being unmounted. This is used as a way to enforce
	 * invariants (or warnings) when it is not recommended to call
	 * setState/forceUpdate.
	 *
	 * currentlyMountingInstance: During the construction phase, it is not possible
	 * to trigger an update since the instance is not fully mounted yet. However, we
	 * currently allow this as a convenience for mutating the initial state.
	 *
	 * currentlyUnmountingInstance: During the unmounting phase, the instance is
	 * still mounted and can therefore schedule an update. However, this is not
	 * recommended and probably an error since it's about to be unmounted.
	 * Therefore we still want to trigger in an error for that case.
	 */

	var ReactLifeCycle = {
	  currentlyMountingInstance: null,
	  currentlyUnmountingInstance: null
	};

	module.exports = ReactLifeCycle;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */

	'use strict';

	var keyMirror = __webpack_require__(24);

	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});

	module.exports = ReactPropTypeLocations;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */

	'use strict';

	var React = __webpack_require__(157);
	var ReactTransitionChildMapping = __webpack_require__(1138);

	var assign = __webpack_require__(15);
	var cloneWithProps = __webpack_require__(376);
	var emptyFunction = __webpack_require__(89);

	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',

	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },

	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },

	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },

	  componentWillMount: function() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },

	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },

	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;

	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      )
	    });

	    var key;

	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }

	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }

	    // If we want to someday check for reordering, we could do it here.
	  },

	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);

	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },

	  performAppear: function(key) {
	    this.currentlyTransitioningKeys[key] = true;

	    var component = this.refs[key];

	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },

	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }

	    delete this.currentlyTransitioningKeys[key];

	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );

	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },

	  performEnter: function(key) {
	    this.currentlyTransitioningKeys[key] = true;

	    var component = this.refs[key];

	    if (component.componentWillEnter) {
	      component.componentWillEnter(
	        this._handleDoneEntering.bind(this, key)
	      );
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },

	  _handleDoneEntering: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }

	    delete this.currentlyTransitioningKeys[key];

	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );

	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },

	  performLeave: function(key) {
	    this.currentlyTransitioningKeys[key] = true;

	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },

	  _handleDoneLeaving: function(key) {
	    var component = this.refs[key];

	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }

	    delete this.currentlyTransitioningKeys[key];

	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );

	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      var newChildren = assign({}, this.state.children);
	      delete newChildren[key];
	      this.setState({children: newChildren});
	    }
	  },

	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(cloneWithProps(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.props,
	      childrenToRender
	    );
	  }
	});

	module.exports = ReactTransitionGroup;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */

	'use strict';

	var ReactLifeCycle = __webpack_require__(372);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactElement = __webpack_require__(31);
	var ReactInstanceMap = __webpack_require__(160);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	function enqueueUpdate(internalInstance) {
	  if (internalInstance !== ReactLifeCycle.currentlyMountingInstance) {
	    // If we're in a componentWillMount handler, don't enqueue a rerender
	    // because ReactUpdates assumes we're in a browser context (which is
	    // wrong for server rendering) and we're about to do a render anyway.
	    // See bug in #1740.
	    ReactUpdates.enqueueUpdate(internalInstance);
	  }
	}

	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  (false ? invariant(
	    ReactCurrentOwner.current == null,
	    '%s(...): Cannot update during an existing state transition ' +
	    '(such as within `render`). Render methods should be a pure function ' +
	    'of props and state.',
	    callerName
	  ) : invariant(ReactCurrentOwner.current == null));

	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !callerName,
	        '%s(...): Can only update a mounted or mounting component. ' +
	        'This usually means you called %s() on an unmounted ' +
	        'component. This is a no-op.',
	        callerName,
	        callerName
	      ) : null);
	    }
	    return null;
	  }

	  if (internalInstance === ReactLifeCycle.currentlyUnmountingInstance) {
	    return null;
	  }

	  return internalInstance;
	}

	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {

	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function(publicInstance, callback) {
	    (false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance ||
	        internalInstance === ReactLifeCycle.currentlyMountingInstance) {
	      return null;
	    }

	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },

	  enqueueCallbackInternal: function(internalInstance, callback) {
	    (false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },

	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldUpdateComponent`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'forceUpdate'
	    );

	    if (!internalInstance) {
	      return;
	    }

	    internalInstance._pendingForceUpdate = true;

	    enqueueUpdate(internalInstance);
	  },

	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function(publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceState'
	    );

	    if (!internalInstance) {
	      return;
	    }

	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;

	    enqueueUpdate(internalInstance);
	  },

	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function(publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setState'
	    );

	    if (!internalInstance) {
	      return;
	    }

	    var queue =
	      internalInstance._pendingStateQueue ||
	      (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);

	    enqueueUpdate(internalInstance);
	  },

	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function(publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setProps'
	    );

	    if (!internalInstance) {
	      return;
	    }

	    (false ? invariant(
	      internalInstance._isTopLevel,
	      'setProps(...): You called `setProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));

	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    var props = assign({}, element.props, partialProps);
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );

	    enqueueUpdate(internalInstance);
	  },

	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function(publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceProps'
	    );

	    if (!internalInstance) {
	      return;
	    }

	    (false ? invariant(
	      internalInstance._isTopLevel,
	      'replaceProps(...): You called `replaceProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));

	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );

	    enqueueUpdate(internalInstance);
	  },

	  enqueueElementInternal: function(internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }

	};

	module.exports = ReactUpdateQueue;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule cloneWithProps
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactPropTransferer = __webpack_require__(1132);

	var keyOf = __webpack_require__(76);
	var warning = __webpack_require__(26);

	var CHILDREN_PROP = keyOf({children: null});

	/**
	 * Sometimes you want to change the props of a child passed to you. Usually
	 * this is to add a CSS class.
	 *
	 * @param {ReactElement} child child element you'd like to clone
	 * @param {object} props props you'd like to modify. className and style will be
	 * merged automatically.
	 * @return {ReactElement} a clone of child with props merged in.
	 */
	function cloneWithProps(child, props) {
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      !child.ref,
	      'You are calling cloneWithProps() on a child with a ref. This is ' +
	      'dangerous because you\'re creating a new child which will not be ' +
	      'added as a ref to its parent.'
	    ) : null);
	  }

	  var newProps = ReactPropTransferer.mergeProps(props, child.props);

	  // Use `child.props.children` if it is provided.
	  if (!newProps.hasOwnProperty(CHILDREN_PROP) &&
	      child.props.hasOwnProperty(CHILDREN_PROP)) {
	    newProps.children = child.props.children;
	  }

	  // The current API doesn't retain _owner and _context, which is why this
	  // doesn't use ReactElement.cloneAndReplaceProps.
	  return ReactElement.createElement(child.type, newProps);
	}

	module.exports = cloneWithProps;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */

	'use strict';

	/**
	 * @param {array} an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};

	module.exports = forEachAccumulated;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;

	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;

	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }

	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }

	  return 0;
	}

	module.exports = getEventCharCode;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */

	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};

	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  /*jshint validthis:true */
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}

	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}

	module.exports = getEventModifierState;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}

	module.exports = getEventTarget;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */

	'use strict';

	var ReactCompositeComponent = __webpack_require__(1112);
	var ReactEmptyComponent = __webpack_require__(371);
	var ReactNativeComponent = __webpack_require__(238);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function() { };
	assign(
	  ReactCompositeComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin,
	  {
	    _instantiateReactComponent: instantiateReactComponent
	  }
	);

	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return (
	    typeof type === 'function' &&
	    typeof type.prototype !== 'undefined' &&
	    typeof type.prototype.mountComponent === 'function' &&
	    typeof type.prototype.receiveComponent === 'function'
	  );
	}

	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {*} parentCompositeType The composite type that resolved this.
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, parentCompositeType) {
	  var instance;

	  if (node === null || node === false) {
	    node = ReactEmptyComponent.emptyElement;
	  }

	  if (typeof node === 'object') {
	    var element = node;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        element && (typeof element.type === 'function' ||
	                    typeof element.type === 'string'),
	        'Only functions or strings can be mounted as React components.'
	      ) : null);
	    }

	    // Special case string values
	    if (parentCompositeType === element.type &&
	        typeof element.type === 'string') {
	      // Avoid recursion if the wrapper renders itself.
	      instance = ReactNativeComponent.createInternalComponent(element);
	      // All native components are currently wrapped in a composite so we're
	      // safe to assume that this is what we should instantiate.
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // represenations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	    (false ? invariant(
	      false,
	      'Encountered invalid React node of type %s',
	      typeof node
	    ) : invariant(false));
	  }

	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      typeof instance.construct === 'function' &&
	      typeof instance.mountComponent === 'function' &&
	      typeof instance.receiveComponent === 'function' &&
	      typeof instance.unmountComponent === 'function',
	      'Only React Components can be mounted.'
	    ) : null);
	  }

	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);

	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;

	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }

	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }

	  return instance;
	}

	module.exports = instantiateReactComponent;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}

	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }

	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;

	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }

	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }

	  return isSupported;
	}

	module.exports = isEventSupported;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */

	/* globals MSApp */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function(node, html) {
	  node.innerHTML = html;
	};

	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function(node, html) {
	    MSApp.execUnsafeLocalFunction(function() {
	      node.innerHTML = html;
	    });
	  };
	}

	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }

	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) ||
	          html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        node.innerHTML = '\uFEFF' + html;

	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}

	module.exports = setInnerHTML;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */

	'use strict';

	var warning = __webpack_require__(26);

	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  if (prevElement != null && nextElement != null) {
	    var prevType = typeof prevElement;
	    var nextType = typeof nextElement;
	    if (prevType === 'string' || prevType === 'number') {
	      return (nextType === 'string' || nextType === 'number');
	    } else {
	      if (nextType === 'object' &&
	          prevElement.type === nextElement.type &&
	          prevElement.key === nextElement.key) {
	        var ownersMatch = prevElement._owner === nextElement._owner;
	        var prevName = null;
	        var nextName = null;
	        var nextDisplayName = null;
	        if (false) {
	          if (!ownersMatch) {
	            if (prevElement._owner != null &&
	                prevElement._owner.getPublicInstance() != null &&
	                prevElement._owner.getPublicInstance().constructor != null) {
	              prevName =
	                prevElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement._owner != null &&
	                nextElement._owner.getPublicInstance() != null &&
	                nextElement._owner.getPublicInstance().constructor != null) {
	              nextName =
	                nextElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement.type != null &&
	                nextElement.type.displayName != null) {
	              nextDisplayName = nextElement.type.displayName;
	            }
	            if (nextElement.type != null && typeof nextElement.type === 'string') {
	              nextDisplayName = nextElement.type;
	            }
	            if (typeof nextElement.type !== 'string' ||
	                nextElement.type === 'input' ||
	                nextElement.type === 'textarea') {
	              if ((prevElement._owner != null &&
	                  prevElement._owner._isOwnerNecessary === false) ||
	                  (nextElement._owner != null &&
	                  nextElement._owner._isOwnerNecessary === false)) {
	                if (prevElement._owner != null) {
	                  prevElement._owner._isOwnerNecessary = true;
	                }
	                if (nextElement._owner != null) {
	                  nextElement._owner._isOwnerNecessary = true;
	                }
	                ("production" !== process.env.NODE_ENV ? warning(
	                  false,
	                  '<%s /> is being rendered by both %s and %s using the same ' +
	                  'key (%s) in the same place. Currently, this means that ' +
	                  'they don\'t preserve state. This behavior should be very ' +
	                  'rare so we\'re considering deprecating it. Please contact ' +
	                  'the React team and explain your use case so that we can ' +
	                  'take that into consideration.',
	                  nextDisplayName || 'Unknown Component',
	                  prevName || '[Unknown]',
	                  nextName || '[Unknown]',
	                  prevElement.key
	                ) : null);
	              }
	            }
	          }
	        }
	        return ownersMatch;
	      }
	    }
	  }
	  return false;
	}

	module.exports = shouldUpdateReactComponent;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var Emitter = __webpack_require__(805);
	var reduce = __webpack_require__(1175);

	/**
	 * Root reference for iframes.
	 */

	var root = 'undefined' == typeof window
	  ? this
	  : window;

	/**
	 * Noop.
	 */

	function noop(){};

	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */

	function isHost(obj) {
	  var str = {}.toString.call(obj);

	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}

	/**
	 * Determine XHR.
	 */

	function getXHR() {
	  if (root.XMLHttpRequest
	    && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	}

	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */

	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */

	function isObject(obj) {
	  return obj === Object(obj);
	}

	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */

	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}

	/**
	 * Expose serialization method.
	 */

	 request.serializeObject = serialize;

	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */

	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;

	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }

	  return obj;
	}

	/**
	 * Expose parser.
	 */

	request.parseString = parseString;

	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */

	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};

	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */

	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };

	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */

	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};

	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */

	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;

	  lines.pop(); // trailing CRLF

	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }

	  return fields;
	}

	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */

	function type(str){
	  return str.split(/ *; */).shift();
	};

	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */

	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();

	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};

	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */

	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  this.text = this.req.method !='HEAD' 
	     ? this.xhr.responseText 
	     : null;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text)
	    : null;
	}

	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */

	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};

	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */

	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);

	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};

	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */

	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse && str && str.length
	    ? parse(str)
	    : null;
	};

	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */

	Response.prototype.setStatusProperties = function(status){
	  var type = status / 100 | 0;

	  // status / class
	  this.status = status;
	  this.statusType = type;

	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;

	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status || 1223 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};

	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */

	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;

	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;

	  return err;
	};

	/**
	 * Expose `Response`.
	 */

	request.Response = Response;

	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */

	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;

	    try {
	      res = new Response(self); 
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	    }

	    self.callback(err, res);
	  });
	}

	/**
	 * Mixin `Emitter`.
	 */

	Emitter(Request.prototype);

	/**
	 * Allow for extension
	 */

	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}

	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};

	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};

	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */

	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};

	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};

	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};

	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */

	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};

	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};

	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};

	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};

	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/

	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};

	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new FormData();
	  this._formData.append(name, val);
	  return this;
	};

	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};

	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');

	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }

	  if (!obj) return this;
	  if (!type) this.type('json');
	  return this;
	};

	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */

	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  if (2 == fn.length) return fn(err, res);
	  if (err) return this.emit('error', err);
	  fn(res);
	};

	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */

	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};

	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */

	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};

	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */

	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};

	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;

	  // store callback
	  this._callback = fn || noop;

	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	    if (0 == xhr.status) {
	      if (self.aborted) return self.timeoutError();
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };

	  // progress
	  if (xhr.upload) {
	    xhr.upload.onprogress = function(e){
	      e.percent = e.loaded / e.total * 100;
	      self.emit('progress', e);
	    };
	  }

	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.abort();
	    }, timeout);
	  }

	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }

	  // initiate request
	  xhr.open(this.method, this.url, true);

	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;

	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var serialize = request.serialize[this.getHeader('Content-Type')];
	    if (serialize) data = serialize(data);
	  }

	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }

	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};

	/**
	 * Expose `Request`.
	 */

	request.Request = Request;

	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */

	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }

	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }

	  return new Request(method, url);
	}

	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * Expose `request`.
	 */

	module.exports = request;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    FacebookManager = __webpack_require__(435),
	    InvitationAPI = __webpack_require__(391),
	    ActionTypes = __webpack_require__(9);

	var FacebookActionCreators = {
	  sendFacebookInvite: function sendFacebookInvite(invite, resend) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SEND_FB_INVITE
	    });

	    FacebookManager.showFacebookSendDialog(invite).then(function () {
	      AppDispatcher.handleServerAction({
	        type: ActionTypes.SEND_FB_INVITE_SUCCESS
	      });

	      if (!resend) {
	        AppDispatcher.handleViewAction({
	          type: ActionTypes.UPDATE_INVITE
	        });

	        InvitationAPI.updateInvite(invite);
	      } else {
	        // lazy way to call RESEND_INVITE_SUCCESS for InvitationStore update
	        InvitationAPI.resendInvite(invite.id);
	      }
	    }, function () {
	      AppDispatcher.handleServerAction({
	        type: ActionTypes.SEND_FB_INVITE_ERROR
	      });
	    });
	  }
	};

	module.exports = FacebookActionCreators;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var FormActionCreators = {
	  submitForm: function submitForm() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SUBMIT_FORM
	    });
	  },

	  resetForm: function resetForm() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.RESET_FORM
	    });
	  },

	  showMessages: function showMessages(messages) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_FORM_MESSAGES,
	      messages: messages
	    });
	  },

	  valueChanged: function valueChanged(key, value) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.FORM_VALUE_CHANGED,
	      key: key,
	      value: value
	    });
	  }
	};

	module.exports = FormActionCreators;

/***/ },
/* 389 */,
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Alert = __webpack_require__(117);
	var Button = __webpack_require__(13);
	var AlertActionCreators = __webpack_require__(32);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var OkayAlert = React.createClass({
	  displayName: 'OkayAlert',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    title: PropTypes.string.isRequired,
	    message: PropTypes.node,
	    buttonText: PropTypes.string.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      buttonText: 'Okay'
	    };
	  },

	  render: function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var message = _props.message;
	    var buttonText = _props.buttonText;

	    return React.createElement(
	      Alert,
	      { title: title,
	        message: message },
	      React.createElement(
	        Button,
	        { size: 'large',
	          onClick: this.handleHideClick },
	        buttonText
	      )
	    );
	  },

	  handleHideClick: function handleHideClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = OkayAlert;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(556);
	var _require = __webpack_require__(122);

	var get = _require.get;
	var put = _require.put;
	var post = _require.post;

	var InvitationAPI = {
	  requestInvitationsPage: function requestInvitationsPage(url) {
	    url = url || '/api/invites';
	    get(url, Actions.handleInvitationsPage);
	  },

	  requestSocialFriendsPage: function requestSocialFriendsPage(serviceType, url) {
	    url = url || '/api/user/services/' + serviceType.toLowerCase() + '/friends';
	    get(url, Actions.handleSocialFriendsPage, serviceType);
	  },

	  sendInvite: function sendInvite(invite) {
	    post('/api/invites', invite, Actions.handleSendInvite);
	  },

	  resendInvite: function resendInvite(inviteId) {
	    post('/api/invites/' + inviteId + '/resend', Actions.handleResendInvite);
	  },

	  updateInvite: function updateInvite(invite) {
	    put('/api/invites/' + invite.id, { status: 'SENT' }, Actions.handleUpdateInvite);
	  }
	};

	module.exports = InvitationAPI;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(564);
	var noop = __webpack_require__(220);
	var getStampSegment = __webpack_require__(60);
	var _require = __webpack_require__(122);

	var del = _require.del;
	var get = _require.get;
	var post = _require.post;
	var put = _require.put;

	var StampAPI = {
	  postStamp: function postStamp(stamp) {
	    post('/api/stamps', stamp, Actions.handlePostStamp, stamp.id);
	  },

	  updateStamp: function updateStamp(stamp) {
	    var stampSegment = getStampSegment(stamp);
	    put('/api/stamps/' + stampSegment, stamp, Actions.handleUpdateStamp, stampSegment);
	  },

	  requestStamp: function requestStamp(stampSegment) {
	    get('/api/stamps/' + stampSegment, Actions.handleStamp, stampSegment);
	  },

	  deleteStamp: function deleteStamp(stampSegment) {
	    del('/api/stamps/' + stampSegment, Actions.handleDeleteStamp, stampSegment);
	  },

	  likeStamp: function likeStamp(stampSegment) {
	    post('/api/stamps/' + stampSegment + '/like', Actions.handleLikeStamp, stampSegment);
	  },

	  unlikeStamp: function unlikeStamp(stampSegment) {
	    del('/api/stamps/' + stampSegment + '/like', Actions.handleUnlikeStamp, stampSegment);
	  },

	  incrementStampViews: function incrementStampViews(stampSegment) {
	    post('/api/stamps/' + stampSegment + '/views', noop);
	  },

	  requestFeedPage: function requestFeedPage(url) {
	    url = url || '/api/stamps/feed';
	    get(url, Actions.handleFeedPage);
	  },

	  requestTrendingPage: function requestTrendingPage(url) {
	    url = url || '/api/stamps/trending';
	    get(url, Actions.handleTrendingPage);
	  },

	  requestUserLatestPage: function requestUserLatestPage(userId, url) {
	    url = url || '/api/users/' + userId + '/stamps/latest';
	    get(url, Actions.handleUserLatestPage, userId);
	  },

	  requestUserLikedPage: function requestUserLikedPage(userId, url) {
	    url = url || '/api/users/' + userId + '/stamps/likes';
	    get(url, Actions.handleUserLikedPage, userId);
	  },

	  requestZineLatestPage: function requestZineLatestPage(zineSlug, url) {
	    url = url || '/api/zines/' + zineSlug + '/stamps/latest';
	    get(url, Actions.handleZineLatestPage, zineSlug);
	  },

	  requestZinePendingPage: function requestZinePendingPage(zineSlug, url) {
	    url = url || '/api/zines/' + zineSlug + '/stamps/pending';
	    get(url, Actions.handleZinePendingPage, zineSlug);
	  },

	  requestStampLikePage: function requestStampLikePage(stampSegment, url) {
	    url = url || '/api/stamps/' + stampSegment + '/likes';
	    get(url, Actions.handleStampLikePage, stampSegment);
	  },

	  requestSearchPage: function requestSearchPage(terms, url) {
	    url = url || '/api/stamps/search?q=' + window.encodeURIComponent(terms);
	    get(url, Actions.handleSearchPage, terms);
	  }
	};

	module.exports = StampAPI;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	__webpack_require__(909);

	'use strict';

	var LinkDescription = _react2['default'].createClass({
	  displayName: 'LinkDescription',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    withMaxWidth: _react.PropTypes.bool
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      withMaxWidth: this.props.withMaxWidth
	    };
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      'p',
	      { className: this.getClassName() },
	      this.props.children
	    );
	  }
	});

	exports['default'] = LinkDescription;
	module.exports = exports['default'];

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ShareLink = __webpack_require__(252);
	var ShareActionCreators = __webpack_require__(91);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ShareStampLink = React.createClass({
	  displayName: 'ShareStampLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    service: PropTypes.any.isRequired,
	    propagateClick: PropTypes.bool
	  },

	  contextTypes: {
	    source: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(ShareLink, { service: this.props.service,
	      onClick: this.handleClick,
	      propagateClick: this.props.propagateClick,
	      context: this.props.context,
	      bold: this.props.bold,
	      underline: this.props.underline });
	  },

	  handleClick: function handleClick() {
	    var _props = this.props;
	    var service = _props.service;
	    var stampId = _props.stamp.id;

	    ShareActionCreators.shareStamp({
	      stampId: stampId,
	      service: service,
	      source: this.context.source
	    });
	  }
	});

	module.exports = ShareStampLink;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _TabLink = __webpack_require__(198);

	var _TabLink2 = _interopRequireDefault(_TabLink);

	var _mixinsRouterStateMixin = __webpack_require__(166);

	var _mixinsRouterStateMixin2 = _interopRequireDefault(_mixinsRouterStateMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	var TabRouterLink = _react2['default'].createClass({
	  displayName: 'TabRouterLink',

	  mixins: [_mixinsRouterStateMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    onClick: _react.PropTypes.func,
	    to: _react.PropTypes.string,
	    params: _react.PropTypes.object
	  },

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  render: function render() {
	    var isActive = this.context.router.isActive;

	    return _react2['default'].createElement(
	      _TabLink2['default'],
	      { to: this.props.to,
	        onClick: this.props.onClick,
	        params: this.props.params,
	        active: isActive(this.props.to) },
	      this.props.children
	    );
	  }
	});

	exports['default'] = TabRouterLink;
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  SOUNDCLOUD_CLIENT_ID: '1679645537cdb5235f979658aafd10d8',
	  SENTRY_URL: 'https://7d9ffb4b43494acabf3488e4ee30e368@app.getsentry.com/3729',
	  RE_CAPTCHA_SITEKEY: true ? '6Ld8ZykTAAAAALe9eOsFqq-F1Q9eHzhAOoUmEJb8' : '6LcTlykTAAAAAH8PE_QWHR2ytM5WtQm1KlG-nka2'
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Keep in sync with constants/colors.less
	var Colors = {
	  BLACK: '#000000',
	  WHITE: '#ffffff',
	  DARK: '#2e2f33',
	  LIGHT: '#fff',
	  GRAY_MID: '#797b80',
	  GRAY_LIGHT: '#e8e8e8',
	  GREEN: '#02cc7d',
	  RED: '#fc3224',
	  YELLOW: '#f5ba0a'
	};

	module.exports = Colors;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  EDITABLE_STATE: null,
	  SUBMITTING_STATE: null,
	  SUBMITTED_STATE: null
	});

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  SERVER_ACTION: null,
	  VIEW_ACTION: null,
	  PRELOADED_ACTION: null
	});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  EXTRA_SMALL: null,
	  SMALL: null,
	  MEDIUM: null,
	  LARGE: null,
	  EXTRA_LARGE: null
	});

/***/ },
/* 401 */,
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ModalTypes = __webpack_require__(58),
	    OverlayStore = __webpack_require__(118),
	    ModalActionCreators = __webpack_require__(77),
	    ZineStore = __webpack_require__(22),
	    createStoreMixin = __webpack_require__(8),
	    Terms = __webpack_require__(692),
	    ContactUs = __webpack_require__(681),
	    Settings = __webpack_require__(689),
	    ResetPassword = __webpack_require__(687),
	    Login = __webpack_require__(685),
	    Signup = __webpack_require__(690),
	    FinishSignup = __webpack_require__(684),
	    UserStore = __webpack_require__(5),
	    UserActionCreators = __webpack_require__(47),
	    AuthTypes = __webpack_require__(199),
	    RequestResetPassword = __webpack_require__(686),
	    SendInvite = __webpack_require__(688),
	    AboutForm = __webpack_require__(680),
	    Feedback = __webpack_require__(683),
	    EditorHelp = __webpack_require__(682),
	    Stamplet = __webpack_require__(691),
	    PureRenderMixin = __webpack_require__(2);

	var ModalHost = React.createClass({
	  displayName: 'ModalHost',

	  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    var modal = OverlayStore.getModal();
	    var state = {
	      modal: modal,
	      canHideModal: OverlayStore.canHideModal()
	    };

	    if (modal && modal.zineSlug) {
	      state.zine = ZineStore.get(modal.zineSlug);
	    }

	    return state;
	  },

	  handleCloseClick: function handleCloseClick() {
	    ModalActionCreators.hideModal();
	  },

	  handleWrapperClick: function handleWrapperClick(e) {
	    if (e.target === this.refs.wrapper.getDOMNode()) {
	      ModalActionCreators.hideModal();
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var modal = _state.modal;
	    var canHideModal = _state.canHideModal;

	    if (!modal) {
	      return null;
	    }

	    return React.createElement(
	      'div',
	      { className: 'Modal utils--hideScrollbars' },
	      React.createElement(
	        'div',
	        { className: 'Modal-wrapper utils--hideScrollbars',
	          ref: 'wrapper',
	          onTouchTap: this.handleWrapperClick },
	        this.getModal(modal, canHideModal)
	      )
	    );
	  },

	  getModal: function getModal(modal, canHideModal) {
	    switch (modal.id) {
	      case ModalTypes.TERMS:
	        return React.createElement(Terms, { onCloseClick: this.handleCloseClick });

	      case ModalTypes.CONTACT_US:
	        return React.createElement(ContactUs, { onCloseClick: this.handleCloseClick });

	      case ModalTypes.SETTINGS:
	        return React.createElement(Settings, { onCloseClick: this.handleCloseClick,
	          initialTabId: modal.tab });

	      case ModalTypes.RESET_PASSWORD:
	        return React.createElement(ResetPassword, { onCloseClick: this.handleCloseClick,
	          userId: modal.userId,
	          email: modal.email });

	      case ModalTypes.LOGIN:
	        return React.createElement(Login, { onCloseClick: this.handleCloseClick,
	          onSignupClick: this.handleSignupClick,
	          onResetPasswordClick: this.handleResetPasswordClick,
	          allowClose: canHideModal,
	          email: modal.email,
	          password: modal.password,
	          endpoints: UserStore.getLoginEndpoints(),
	          messages: modal.messages || [] });

	      case ModalTypes.SIGNUP:
	        return React.createElement(Signup, { onCloseClick: this.handleCloseClick,
	          onLoginClick: this.handleLoginClick,
	          onServiceClick: this.handleSignupServiceClick,
	          allowClose: canHideModal,
	          endpoints: UserStore.getSignupEndpoints(),
	          messages: modal.messages || [],
	          showComplementaryButtons: modal.showComplementaryButtons });

	      case ModalTypes.FINISH_SIGNUP:
	        return React.createElement(FinishSignup, { onCloseClick: this.handleCloseClick,
	          onLoginClick: this.handleLoginClick,
	          onTermsClick: this.handleTermsClick,
	          allowClose: canHideModal,
	          service: modal.service,
	          email: modal.email,
	          name: modal.name,
	          endpoints: UserStore.getSignupEndpoints(),
	          messages: modal.messages || [] });

	      case ModalTypes.REQUEST_RESET_PASSWORD:
	        return React.createElement(RequestResetPassword, { onCloseClick: this.handleCloseClick,
	          onCancelClick: this.handleResetCancelClick,
	          email: modal.email });

	      case ModalTypes.SEND_INVITE:
	        return React.createElement(SendInvite, { onCloseClick: this.handleCloseClick,
	          zineSlug: modal.zineSlug,
	          title: modal.zineSlug ? 'Invite Contributors' : 'Invite Friends',
	          setMayCloseOnClickOutside: this.handleMayCloseOnClickOutside });

	      case ModalTypes.ABOUT:
	        return React.createElement(AboutForm, { onCloseClick: this.handleCloseClick,
	          onLoginClick: this.handleLoginClick });

	      case ModalTypes.FEEDBACK:
	        return React.createElement(Feedback, { onCloseClick: this.handleCloseClick });

	      case ModalTypes.EDITOR_HELP:
	        return React.createElement(EditorHelp, { onCloseClick: this.handleCloseClick });

	      case ModalTypes.STAMPLET:
	        return React.createElement(Stamplet, { onCloseClick: this.handleCloseClick });
	    }
	  },

	  handleResetCancelClick: function handleResetCancelClick() {
	    ModalActionCreators.showModal(ModalTypes.LOGIN);
	  },

	  handleResetPasswordClick: function handleResetPasswordClick() {
	    ModalActionCreators.showModal(ModalTypes.REQUEST_RESET_PASSWORD);
	  },

	  handleLoginClick: function handleLoginClick() {
	    ModalActionCreators.showModal(ModalTypes.LOGIN);
	  },

	  handleSignupServiceClick: function handleSignupServiceClick(serviceType) {
	    if (serviceType !== AuthTypes.EMAIL) {
	      UserActionCreators.signupWithServiceAccount(serviceType);
	    } else {
	      ModalActionCreators.showModal(ModalTypes.FINISH_SIGNUP, { service: serviceType });
	    }
	  },

	  handleSignupClick: function handleSignupClick() {
	    ModalActionCreators.showModal(ModalTypes.SIGNUP);
	  },

	  handleTermsClick: function handleTermsClick() {
	    var modal = this.state.modal;
	    ModalActionCreators.showModal(ModalTypes.TERMS, { next: modal });
	  }
	});

	module.exports = ModalHost;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _underscore = __webpack_require__(4);

	var _storesLightboxStore = __webpack_require__(147);

	var _storesLightboxStore2 = _interopRequireDefault(_storesLightboxStore);

	var _constantsNotificationMessages = __webpack_require__(78);

	var _constantsNotificationMessages2 = _interopRequireDefault(_constantsNotificationMessages);

	var _organismsNotification = __webpack_require__(720);

	var _organismsNotification2 = _interopRequireDefault(_organismsNotification);

	var _storesNotificationStore = __webpack_require__(423);

	var _storesNotificationStore2 = _interopRequireDefault(_storesNotificationStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesPlayerStore = __webpack_require__(119);

	var _storesPlayerStore2 = _interopRequireDefault(_storesPlayerStore);

	var _actionsNotificationActionCreators = __webpack_require__(90);

	var _actionsNotificationActionCreators2 = _interopRequireDefault(_actionsNotificationActionCreators);

	var _actionsShareActionCreators = __webpack_require__(91);

	var _actionsShareActionCreators2 = _interopRequireDefault(_actionsShareActionCreators);

	var _atomsZineLink = __webpack_require__(93);

	var _atomsZineLink2 = _interopRequireDefault(_atomsZineLink);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _moleculesShare = __webpack_require__(206);

	var _moleculesShare2 = _interopRequireDefault(_moleculesShare);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _constantsServiceTypes = __webpack_require__(35);

	var _constantsServiceTypes2 = _interopRequireDefault(_constantsServiceTypes);

	var _utilsTimeoutTransitionGroup = __webpack_require__(177);

	var _utilsTimeoutTransitionGroup2 = _interopRequireDefault(_utilsTimeoutTransitionGroup);

	var _actionsUserActionCreators = __webpack_require__(47);

	var _actionsUserActionCreators2 = _interopRequireDefault(_actionsUserActionCreators);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	'use strict';

	var NotificationHost = _react2['default'].createClass({
	  displayName: 'NotificationHost',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesNotificationStore2['default'], _storesPlayerStore2['default'], _storesLightboxStore2['default']), _mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      notifications: _storesNotificationStore2['default'].getNotifications(),
	      isStickyPlayerActive: !!_storesPlayerStore2['default'].getStickyMediaId(),
	      isInLightbox: _storesLightboxStore2['default'].isActive()
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _state = this.state;
	    var isStickyPlayerActive = _state.isStickyPlayerActive;
	    var isInLightbox = _state.isInLightbox;

	    return [isStickyPlayerActive && !isInLightbox && 'withStickyPlayer'];
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _utilsTimeoutTransitionGroup2['default'],
	      { className: this.getClassName(),
	        transitionName: 'Notification',
	        enterTimeout: 500,
	        leaveTimeout: 500 },
	      (0, _underscore.map)(this.state.notifications, this.renderNotification)
	    );
	  },

	  renderNotification: function renderNotification(notification) {
	    var action = this.getAction(notification);
	    var content = this.getContent(notification);

	    return _react2['default'].createElement(_organismsNotification2['default'], { key: 'notification' + notification.id + notification.created,
	      content: content,
	      action: action,
	      onCloseClick: this.handleCloseClick.bind(this, notification) });
	  },

	  getContent: function getContent(notification) {
	    var promoteStamp = 'Share your work to give recognition it deserves.';
	    var zine = undefined;
	    var user = undefined;

	    if (notification.zineSlug) {
	      zine = _storesZineStore2['default'].get(notification.zineSlug);
	    }

	    if (notification.userId) {
	      user = _storesUserStore2['default'].get(notification.userId);
	    }

	    switch (notification.id) {
	      case _constantsNotificationMessages2['default'].UNSUPPORTED_BROWSER:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Stampsy does not support this browser.'
	        );
	      case _constantsNotificationMessages2['default'].STAMP_SUBMITTED_TO_ZINE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Submitted to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	          '.',
	          _react2['default'].createElement('br', null),
	          'You may have to wait for approval from the curator.'
	        );
	      case _constantsNotificationMessages2['default'].STAMP_APPROVED_TO_ZINE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Added to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true })
	        );
	      case _constantsNotificationMessages2['default'].STAMP_DECLINED_FROM_ZINE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Declined submission to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true })
	        );

	      case _constantsNotificationMessages2['default'].STAMP_HAS_BEEN_SAVED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your Stamp has been saved. ',
	          promoteStamp
	        );
	      case _constantsNotificationMessages2['default'].STAMP_HAS_BEEN_DELETED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your Stamp has been deleted'
	        );

	      case _constantsNotificationMessages2['default'].ZINE_CREATED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Collection created'
	        );
	      case _constantsNotificationMessages2['default'].ZINE_SAVED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Collection saved'
	        );
	      case _constantsNotificationMessages2['default'].ZINE_DELETED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Collection deleted'
	        );
	      case _constantsNotificationMessages2['default'].ZINE_FOLLOWED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You are now following ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true })
	        );

	      case _constantsNotificationMessages2['default'].YOU_CAN_CONTRIBUTE_TO_ZINE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You can now contribute to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	          ' collection'
	        );

	      case _constantsNotificationMessages2['default'].ACCOUNT_CONNECTED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Account connected'
	        );

	      case _constantsNotificationMessages2['default'].INVITE_SENT:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Invite sent'
	        );
	      case _constantsNotificationMessages2['default'].INVITE_SENT_ERROR:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Failed to send an invite'
	        );

	      case _constantsNotificationMessages2['default'].PASSWORD_RESET_CHECK_EMAIL:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'To change password, follow the instructions sent to your email.'
	        );
	      case _constantsNotificationMessages2['default'].PASSWORD_RESET_DONE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your password has been changed'
	        );

	      case _constantsNotificationMessages2['default'].USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You need to confirm your email. Verification message has been sent to ',
	          _react2['default'].createElement(
	            'b',
	            null,
	            notification.email
	          ),
	          '.'
	        );
	      case _constantsNotificationMessages2['default'].USER_NEW_EMAIL_NEEDS_CONFIRMATION:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You need to confirm your new email. Verification message has been sent to ',
	          _react2['default'].createElement(
	            'b',
	            null,
	            notification.email
	          ),
	          '.'
	        );
	      case _constantsNotificationMessages2['default'].USER_EMAIL_RESENT:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Message has been resent.'
	        );
	      case _constantsNotificationMessages2['default'].USER_EMAIL_CHANGE_CANCELED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Email change has been canceled.'
	        );
	      case _constantsNotificationMessages2['default'].EMAIL_CONFIRMED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You have successfully verified your email ',
	          _react2['default'].createElement(
	            'b',
	            null,
	            notification.email
	          ),
	          '. Thank you!'
	        );
	      case _constantsNotificationMessages2['default'].USER_FOLLOWED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You are now following ',
	          _react2['default'].createElement(_atomsUserLink2['default'], { user: user, bold: true })
	        );

	      case _constantsNotificationMessages2['default'].DASHBOARD_COLLECTION_LEARN_MORE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          notification.name,
	          ' must add five stamps to their collection and share it before you can exchange that link for a reward'
	        );
	      case _constantsNotificationMessages2['default'].DASHBOARD_MESSAGE_DECLINED_LEARN_MORE:
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Your link has been declined for one of two reasons:'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            _react2['default'].createElement(
	              'ul',
	              null,
	              _react2['default'].createElement(
	                'li',
	                null,
	                '1) A user deleted their status'
	              ),
	              _react2['default'].createElement(
	                'li',
	                null,
	                '2) A user has a private profile. Status privacy settings must be changed to Public.'
	              )
	            )
	          )
	        );

	      case _constantsNotificationMessages2['default'].WELCOME_FOLLOW_ZINES:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Follow interesting collections to fill your feed with stamps that matter to you.'
	        );

	      case _constantsNotificationMessages2['default'].FEEDBACK_SENT:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Thank you for your feedback.'
	        );

	      case _constantsNotificationMessages2['default'].EMAIL_UNSUBSCRIBE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You will not receive email notifications from Stampsy.'
	        );
	      case _constantsNotificationMessages2['default'].EMAIL_RESUBSCRIBED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You will receive email notifications from Stampsy.'
	        );
	      case _constantsNotificationMessages2['default'].EMAIL_UNSUBSCRIBE_ZINE:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'You have been unsubscribed from “',
	          notification.title,
	          '” collection.'
	        );

	      case _constantsNotificationMessages2['default'].INVITATION_ALREADY_USED:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'This invitation link has expired. Please try to log in or request a new invite.'
	        );
	      case _constantsNotificationMessages2['default'].INVITATION_FOR_OTHER_USER:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'This link does not work with the account you used to log in. Please, try and use another account.'
	        );

	      case _constantsNotificationMessages2['default'].IMAGE_ADDED_TO_GRABBAG:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Saved to the ',
	          _react2['default'].createElement(
	            _atomsLink2['default'],
	            { to: 'draftCompose', params: { stampSegment: 'new' } },
	            'Editor'
	          ),
	          '.'
	        );

	      case _constantsNotificationMessages2['default'].DRAFT_FEEDBACK_SENT:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your feedback was sent.'
	        );

	      default:
	        console.warn('Unrecognized notification', notification);
	    }
	  },

	  handleShareStampClick: function handleShareStampClick(stampId, service) {
	    _actionsShareActionCreators2['default'].shareStamp({
	      stampId: stampId,
	      service: service,
	      source: _constantsAnalyticsSources2['default'].NOTIFICATION
	    });
	  },

	  getAction: function getAction(notification) {
	    switch (notification.id) {
	      case _constantsNotificationMessages2['default'].UNSUPPORTED_BROWSER:
	        return _react2['default'].createElement(
	          _atomsLink2['default'],
	          { to: '/retrograde.htm', bold: true, target: '_blank' },
	          'Learn More'
	        );
	      case _constantsNotificationMessages2['default'].STAMP_HAS_BEEN_SAVED:
	        return _react2['default'].createElement(_moleculesShare2['default'], { onShareClick: this.handleShareStampClick.bind(this, notification.stampId),
	          services: [_constantsServiceTypes2['default'].FACEBOOK, _constantsServiceTypes2['default'].TWITTER],
	          size: 'small',
	          color: 'dark' });
	      case _constantsNotificationMessages2['default'].WELCOME_FOLLOW_ZINES:
	        return _react2['default'].createElement(
	          _atomsLink2['default'],
	          { to: 'zines', bold: true },
	          'View Recommended Collections'
	        );
	      case _constantsNotificationMessages2['default'].USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            _atomsLink2['default'],
	            { onClick: this.handleResendEmailClick, bold: true },
	            'Resend'
	          )
	        );
	      case _constantsNotificationMessages2['default'].USER_NEW_EMAIL_NEEDS_CONFIRMATION:
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            _atomsLink2['default'],
	            { onClick: this.handleResendEmailClick, bold: true },
	            'Resend'
	          ),
	          ' or ',
	          _react2['default'].createElement(
	            _atomsLink2['default'],
	            { onClick: this.handleCancelEmailClick, bold: true },
	            'Cancel'
	          )
	        );
	      case _constantsNotificationMessages2['default'].EMAIL_UNSUBSCRIBE:
	        return _react2['default'].createElement(
	          _atomsLink2['default'],
	          { onClick: this.handleResubscribeEmailClick.bind(this, notification) },
	          'Click here to restore your subscription'
	        );
	    }
	  },

	  handleResubscribeEmailClick: function handleResubscribeEmailClick(notification) {
	    _actionsUserActionCreators2['default'].resubscribeEmail({
	      userId: notification.userId,
	      emailHash: notification.emailHash
	    });
	  },

	  handleResendEmailClick: function handleResendEmailClick() {
	    _actionsUserActionCreators2['default'].resendUnconfirmedEmail();
	  },

	  handleCancelEmailClick: function handleCancelEmailClick() {
	    _actionsUserActionCreators2['default'].cancelUnconfirmedEmail();
	  },

	  handleCloseClick: function handleCloseClick(notification) {
	    _actionsNotificationActionCreators2['default'].hideNotification(notification.id, notification.created);
	  }
	});

	exports['default'] = NotificationHost;
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Overlay = __webpack_require__(584),
	    KeyCodes = __webpack_require__(145),
	    OverlayStore = __webpack_require__(118),
	    OverlayActionCreators = __webpack_require__(559),
	    ContextMenuActionCreators = __webpack_require__(111),
	    createStoreMixin = __webpack_require__(8),
	    PureRenderMixin = __webpack_require__(2),
	    TimeoutTransitionGroup = __webpack_require__(177);

	var OverlayHost = React.createClass({
	  displayName: 'OverlayHost',

	  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      hasAny: OverlayStore.hasAny(),
	      hasContextMenu: OverlayStore.hasContextMenu()
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var hasAny = this.state.hasAny;

	    if (hasAny && !prevState.hasAny) {
	      window.addEventListener('scroll', this.handleScroll, false);
	      window.addEventListener('keydown', this.handleKeyDown);
	    } else if (!hasAny && prevState.hasAny) {
	      window.removeEventListener('scroll', this.handleScroll, false);
	      window.removeEventListener('keydown', this.handleKeyDown);
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var hasAny = _state.hasAny;
	    var hasContextMenu = _state.hasContextMenu;
	    var dimComponent;

	    dimComponent = React.createElement(Overlay, { key: 'dim',
	      transparent: hasContextMenu,
	      onTouchTap: this.handleOverlayTouchTap });

	    if (hasContextMenu) {
	      return dimComponent;
	    }

	    return React.createElement(
	      TimeoutTransitionGroup,
	      { transitionName: 'Overlay',
	        enterTimeout: 300,
	        leaveTimeout: 300 },
	      hasAny && dimComponent
	    );
	  },

	  handleOverlayTouchTap: function handleOverlayTouchTap() {
	    OverlayActionCreators.hideOverlay();
	  },

	  handleKeyDown: function handleKeyDown(e) {
	    if (e.keyCode === KeyCodes.ESCAPE) {
	      OverlayActionCreators.hideOverlay();
	    }
	  },

	  handleScroll: function handleScroll() {
	    if (this.state.hasContextMenu) {
	      ContextMenuActionCreators.hideContextMenu();
	    }
	  }
	});

	module.exports = OverlayHost;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var debounce = _require.debounce;

	var IdleScrollMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      isScrolling: false
	    };
	  },

	  isScrolling: function isScrolling() {
	    return this.state.isScrolling;
	  },

	  componentDidMount: function componentDidMount() {
	    this._debounceSetScrolling = debounce(this._setScrolling, 800);
	  },

	  handleScroll: function handleScroll() {
	    this._setScrolling(true);
	    this._debounceSetScrolling(false);
	  },

	  _setScrolling: function _setScrolling(isScrolling) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (this.state.isScrolling === isScrolling) {
	      return;
	    }

	    this.setState({
	      isScrolling: isScrolling
	    });
	  }
	};

	module.exports = IdleScrollMixin;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    update = __webpack_require__(49),
	    _ = __webpack_require__(4),
	    getThumbnailUrl = __webpack_require__(37),
	    limitThumbnailSize = __webpack_require__(797),
	    shallowEqual = __webpack_require__(46);

	function getThumbnailOptions(size, normalSize, originalSize, mode, normalBlur, allowEmpty) {
	  var width, height, blur;

	  switch (size) {
	    case 'thumb':
	      if (normalSize.width) {
	        width = 8;
	      }

	      if (normalSize.height) {
	        height = 8;
	      }

	      if (normalBlur) {
	        blur = 0;
	      }
	      break;

	    case 'small':
	      if (normalSize.width) {
	        width = Math.round(normalSize.width / 2);
	      }

	      if (normalSize.height) {
	        height = Math.round(normalSize.height / 2);
	      }

	      if (normalBlur) {
	        blur = Math.round(normalBlur / 2);
	      }
	      break;

	    case 'normal':
	      if (normalSize.width) {
	        width = normalSize.width;
	      }

	      if (normalSize.height) {
	        height = normalSize.height;
	      }

	      if (normalBlur) {
	        blur = normalBlur;
	      }
	      break;

	    case 'retina':
	      if (normalSize.width) {
	        width = normalSize.width * 2;
	      }

	      if (normalSize.height) {
	        height = normalSize.height * 2;
	      }

	      if (normalBlur) {
	        blur = Math.round(normalBlur * 1.5);
	      }
	      break;

	    case 'original':
	      if (normalSize.width) {
	        width = originalSize.width;
	      }

	      if (normalSize.height) {
	        height = originalSize.height;
	      }

	      if (normalBlur) {
	        blur = 0;
	      }
	      break;
	  }

	  return _.extend(limitThumbnailSize({ width: width, height: height }, originalSize, mode), { blur: blur, mode: mode, allowEmpty: allowEmpty });
	}

	// XXX in server mode get this from ua agent
	var isFirefox = typeof navigator !== 'undefined' ? /firefox/i.test(navigator.userAgent) : false;

	/**
	 * Manages state of a sequential image queue.
	 *
	 * Use `ResponsiveImageQueueMixin` instead if you don't need
	 * fine control over requested width and if you are content
	 * with specifying widths for different @media-* queries.
	 *
	 * Use `createFlexibleImageQueueMixin(stepSize)` instead if you need the width
	 * to be exactly (or close to) DOM element's offsetWidth.
	 *
	 * Will load images sequentially. Requires an image in your markup:
	 *
	 * Specify `getNormalImageSize()` which the queue will use
	 * to calculate thumbnail widths in different situations.
	 *
	 * <img onload={this.handleImageLoad}
	 *      onError={this.handleImageError}
	 *      src={this.getImageSrcUrl()} />
	 *
	 * Requires two methods to be defined:
	 *
	 * * getNormalImageSize() -> { width, height }
	 * * getImageOptions: () -> {
	 *   image: ImageMedia,
	 *   sizes: {
	 *     [thumb|small|normal|retina|original]: bool,
	 *     ...
	 *   }
	 * }
	 *
	 * You can call `getBackgroundImageUrl()` to get CSS value
	 * for `background-image` of a `div` but you still have to embed `img`
	 * in your markup (for brevity you can use `renderLoaderImg` that renders
	 * an image with display:none).
	 *
	 * The queue gets updated whenever the next image is loaded
	 * but you can force updating it by calling `updateImageQueue`.
	 */
	var ImageQueueMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      requestedImages: [],
	      loadedImages: [],
	      loadingImage: null
	    };
	  },

	  hasLoadedImage: function hasLoadedImage() {
	    return this.state.loadedImages.length > 0;
	  },

	  componentWillMount: function componentWillMount() {
	    this.updateImageQueue();
	  },

	  handleImageError: function handleImageError() {
	    this.updateImageQueue();
	  },

	  handleImageLoad: function handleImageLoad() {
	    var _this = this;

	    var loadingImage = this.state.loadingImage;

	    setTimeout(function () {
	      if (_this.isMounted()) {
	        _this.updateImageQueue(loadingImage);
	      }
	    });
	  },

	  updateImageQueue: function updateImageQueue(loadedImage) {
	    var requestedImages = this._getImageQueue() || [],
	        loadedImages = this.state.loadedImages,
	        loadingImage;

	    if (loadedImage && loadedImages.indexOf(loadedImage) === -1) {
	      loadedImages = update(loadedImages, {
	        $push: [loadedImage]
	      });
	    }

	    loadedImages = _.filter(loadedImages, function (image) {
	      return _.contains(requestedImages, image);
	    });

	    loadingImage = _.find(requestedImages, function (image) {
	      return !_.contains(loadedImages, image);
	    });

	    if (shallowEqual(requestedImages, this.state.requestedImages) && shallowEqual(loadedImages, this.state.loadedImages) && shallowEqual(loadingImage, this.state.loadingImage)) {
	      return;
	    }

	    this.setState({
	      requestedImages: requestedImages,
	      loadedImages: loadedImages,
	      loadingImage: loadingImage
	    });
	  },

	  getBestLoadedUrls: function getBestLoadedUrls() {
	    var _state = this.state;
	    var requestedImages = _state.requestedImages;
	    var loadedImages = _state.loadedImages;

	    return requestedImages.slice().reverse().filter(function (url) {
	      return loadedImages.indexOf(url) > -1;
	    });
	  },

	  getBackgroundImageUrl: function getBackgroundImageUrl() {
	    var bestLoadedUrls = this.getBestLoadedUrls(),
	        bestLoadedUrl = bestLoadedUrls[0] || this.state.loadingImage,
	        nextBestLoadedUrl = bestLoadedUrls[1];

	    // Firefox flickers unless we show both previous and current image
	    if (bestLoadedUrl && nextBestLoadedUrl && isFirefox) {
	      return 'url(' + bestLoadedUrl + '), url(' + nextBestLoadedUrl + ')';
	    } else if (bestLoadedUrl) {
	      return 'url(' + bestLoadedUrl + ')';
	    }
	  },

	  getImageSrcUrl: function getImageSrcUrl() {
	    return this.state.loadingImage || this.getBestLoadedUrls()[0];
	  },

	  renderLoaderImg: function renderLoaderImg() {
	    var src = this.getImageSrcUrl();
	    if (!src) {
	      return;
	    }

	    return React.createElement('img', { onLoad: this.handleImageLoad,
	      onError: this.handleImageError,
	      src: src,
	      style: { display: 'none' } });
	  },

	  _getImageQueue: function _getImageQueue() {
	    var imageOptions = this.getImageOptions();
	    if (!imageOptions || !imageOptions.image) {
	      return;
	    }

	    var image = imageOptions.image;
	    var sizes = imageOptions.sizes;
	    var mode = imageOptions.mode;
	    var blur = imageOptions.blur;
	    var allowEmpty = imageOptions.allowEmpty;
	    var originalSize = image.size || { width: 2048, height: 2048 };
	    var normalSize = this.getNormalImageSize();

	    if (!normalSize) {
	      return;
	    }

	    return _.chain(sizes).map(function (enabled, size) {
	      return enabled && getThumbnailOptions(size, normalSize, originalSize, mode || 'preview', blur, allowEmpty);
	    }).compact().uniq(function (options) {
	      return (options.width || '') + 'x' + (options.height || '');
	    }).sortBy(function (options) {
	      return (options.width || options.height) * (options.height || options.width);
	    }).map(function (options) {
	      return getThumbnailUrl(image, options);
	    }).value();
	  }
	};

	module.exports = ImageQueueMixin;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var SafeLocalStorage = __webpack_require__(134);var PropTypes = React.PropTypes;

	/**
	 * TODO: use a dedicated Store instead when we rewrite to use new forms.
	 */
	var PendingStampMessageMixin = {
	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStorageKey: function getStorageKey() {
	    return 'PendingStampMessageMixin.review-' + this.props.stampId + '-' + this.props.zineSlug;
	  },

	  getInitialState: function getInitialState() {
	    var message = SafeLocalStorage.getItem(this.getStorageKey());

	    return {
	      message: message || ''
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.state.message === prevState.message) {
	      return;
	    }

	    SafeLocalStorage.setItem(this.getStorageKey(), this.state.message);
	  },

	  removeStoredPendingMessage: function removeStoredPendingMessage() {
	    SafeLocalStorage.removeItem(this.getStorageKey());
	  }
	};

	module.exports = PendingStampMessageMixin;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PropTypes = React.PropTypes;
	var FormLink = __webpack_require__(148);
	var PureRenderMixin = __webpack_require__(2);

	var FormMessage = React.createClass({
	  displayName: 'FormMessage',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    formLink: PropTypes.instanceOf(FormLink).isRequired
	  },

	  render: function render() {
	    var message = this.props.formLink.fieldMessage;

	    return message && React.createElement(
	      'div',
	      { className: 'FormMessage' },
	      message
	    ) || null;
	  }
	});

	module.exports = FormMessage;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    BackColorMixin = __webpack_require__(56),
	    Button = __webpack_require__(13),
	    ZineActionCreators = __webpack_require__(41),
	    PureRenderMixin = __webpack_require__(2),
	    PropTypes = React.PropTypes;

	var FollowZineButton = React.createClass({
	  displayName: 'FollowZineButton',

	  mixins: [BackColorMixin, PureRenderMixin],

	  propTypes: {
	    zine: PropTypes.object.isRequired,
	    size: PropTypes.oneOf(['medium', 'large']).isRequired,
	    useZineColor: PropTypes.bool,
	    overlay: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      useZineColor: false
	    };
	  },

	  render: function render() {
	    var zine = this.props.zine,
	        textColor;

	    if (this.props.useZineColor) {
	      textColor = this.getTextColor(zine.backColor);
	    }

	    return React.createElement(
	      Button,
	      { color: 'green',
	        onClick: this.handleFollowClick,
	        active: zine.isSubscribed,
	        size: this.props.size,
	        counter: zine.subscriberCount,
	        context: this.props.context,
	        fill: true },
	      zine.isSubscribed ? React.createElement(
	        'span',
	        null,
	        'Following'
	      ) : React.createElement(
	        'span',
	        null,
	        'Follow'
	      )
	    );
	  },

	  handleFollowClick: function handleFollowClick() {
	    var zine = this.props.zine;

	    if (zine.isSubscribed) {
	      ZineActionCreators.unfollowZine(zine.slug);
	    } else {
	      ZineActionCreators.followZine(zine.slug);
	    }
	  }
	});

	module.exports = FollowZineButton;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    PureRenderMixin = __webpack_require__(2);

	var IframeForm = React.createClass({
	  displayName: 'IframeForm',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    action: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    var iframeName = this.props.name + '-iframe';

	    var frameStyle = {
	      visibility: 'hidden',
	      position: 'absolute',
	      width: 0,
	      height: 0
	    };

	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'form',
	        { action: this.props.action, method: 'post', ref: 'form', className: 'Form', target: iframeName },
	        React.createElement('input', { name: 'form_name', value: this.props.name, type: 'hidden' }),
	        this.props.children
	      ),
	      React.createElement('iframe', { style: frameStyle,
	        ref: 'iframe',
	        id: iframeName,
	        name: iframeName,
	        src: '' })
	    );
	  },

	  submit: function submit() {
	    this.refs.form.getDOMNode().submit();
	  }
	});

	module.exports = IframeForm;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var ClassNameMixin = __webpack_require__(3);
	var ShareTypes = __webpack_require__(113);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ShareAddButtons = React.createClass({
	  displayName: 'ShareAddButtons',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    split: PropTypes.bool,
	    round: PropTypes.bool,
	    fill: PropTypes.bool,
	    overlay: PropTypes.bool,
	    size: PropTypes.oneOf(['small', 'medium', 'large']),
	    showMore: PropTypes.bool,
	    showShare: PropTypes.bool,
	    addLabel: PropTypes.string,
	    onShareClick: PropTypes.func.isRequired,
	    onAddClick: PropTypes.func.isRequired,
	    onMoreClick: PropTypes.func,
	    primaryServices: PropTypes.arrayOf(PropTypes.oneOf(_.values(ShareTypes)))
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      round: false,
	      split: false,
	      primaryServices: []
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  render: function render() {
	    var addIconSize = this.props.size === 'medium' ? 'xsmall' : 'small';

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { size: this.props.size,
	            color: this.props.color,
	            round: this.props.round && !this.props.addLabel,
	            split: this.props.split,
	            fill: this.props.fill,
	            overlay: this.props.overlay,
	            context: this.props.context,
	            onClick: this.props.onAddClick },
	          React.createElement(Icon, { name: 'plus',
	            mode: 'stroke',
	            size: addIconSize }),
	          this.props.addLabel
	        ),
	        this.renderPrimaryServiceButtons(),
	        this.props.showShare && React.createElement(
	          Button,
	          { size: this.props.size,
	            color: this.props.color,
	            round: this.props.round,
	            split: this.props.split,
	            fill: this.props.fill,
	            overlay: this.props.overlay,
	            context: this.props.context,
	            onClick: this.props.onShareClick },
	          React.createElement(Icon, { name: 'share',
	            mode: 'stroke',
	            size: 'small' })
	        ),
	        this.props.showMore && React.createElement(
	          Button,
	          { size: this.props.size,
	            color: this.props.color,
	            round: this.props.round,
	            split: this.props.split,
	            overlay: this.props.overlay,
	            context: this.props.context,
	            onClick: this.props.onMoreClick },
	          React.createElement(Icon, { name: 'more',
	            mode: 'fill',
	            size: 'small' })
	        )
	      )
	    );
	  },

	  renderPrimaryServiceButtons: function renderPrimaryServiceButtons() {
	    var _this = this;

	    return this.props.primaryServices.map(function (service) {
	      return React.createElement(
	        Button,
	        { key: service,
	          size: _this.props.size,
	          color: service.toLowerCase(),
	          round: _this.props.round,
	          split: _this.props.split,
	          fill: _this.props.fill,
	          overlay: _this.props.overlay,
	          context: _this.props.context,
	          onClick: _.partial(_this.props.onShareClick, _, service) },
	        React.createElement(Icon, { name: service.toLowerCase(),
	          mode: 'fill',
	          size: 'small' })
	      );
	    });
	  }
	});

	module.exports = ShareAddButtons;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var CheckLink = __webpack_require__(581);
	var PureRenderMixin = __webpack_require__(2);
	var ZineStampStatus = __webpack_require__(646);
	var ZineActionCreators = __webpack_require__(41);
	var getStampSegment = __webpack_require__(60);var PropTypes = React.PropTypes;

	var SubmitStampControl = React.createClass({
	  displayName: 'SubmitStampControl',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    zine: PropTypes.object.isRequired,
	    fill: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'dark',
	      fill: false };
	  },

	  canEditZine: function canEditZine() {
	    return this.props.zine.canEdit;
	  },

	  getStampStateInZine: function getStampStateInZine() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var zine = _props.zine;

	    if (stamp.zines.indexOf(zine.slug) > -1) {
	      return ZineStampStatus.APPROVED;
	    }

	    if (stamp.pendingZines.indexOf(zine.slug) > -1) {
	      return ZineStampStatus.PENDING;
	    }

	    return ZineStampStatus.INITIAL;
	  },

	  isInInitialState: function isInInitialState() {
	    return this.getStampStateInZine() === ZineStampStatus.INITIAL;
	  },

	  isInPendingState: function isInPendingState() {
	    return this.getStampStateInZine() === ZineStampStatus.PENDING;
	  },

	  isInApprovedState: function isInApprovedState() {
	    return this.getStampStateInZine() === ZineStampStatus.APPROVED;
	  },

	  render: function render() {
	    if (this.isInInitialState() || this.isInPendingState() && this.canEditZine()) {
	      return React.createElement(
	        Button,
	        { onClick: this.handleAddClick,
	          color: this.props.color,
	          fill: this.props.fill,
	          overlay: this.props.overlay },
	        React.createElement(Icon, { name: 'plus',
	          mode: 'stroke',
	          size: 'xsmall' }),
	        this.canEditZine() ? 'Add' : 'Submit'
	      );
	    }

	    if (this.isInPendingState()) {
	      return React.createElement(
	        Button,
	        { color: this.props.color,
	          fill: this.props.fill,
	          overlay: this.props.overlay,
	          disabled: true },
	        React.createElement(Icon, { name: 'clock',
	          size: 'small',
	          mode: 'stroke' }),
	        'In Review...'
	      );
	    }

	    if (this.isInApprovedState()) {
	      return React.createElement(
	        CheckLink,
	        { onClick: this.handleRemoveClick,
	          color: 'green' },
	        'Remove'
	      );
	    }
	  },

	  handleAddClick: function handleAddClick() {
	    var _props2 = this.props;
	    var zine = _props2.zine;
	    var stamp = _props2.stamp;

	    var stampSegment = getStampSegment(stamp);

	    if (!zine.canEdit) {
	      ZineActionCreators.submitStampToZine(zine.slug, stampSegment);
	      return;
	    }

	    if (this.isInPendingState()) {
	      ZineActionCreators.approveStampToZine(zine.slug, stampSegment);
	    } else {
	      ZineActionCreators.addStampToZine(zine.slug, stampSegment);
	    }
	  },

	  handleRemoveClick: function handleRemoveClick() {
	    var _props3 = this.props;
	    var zine = _props3.zine;
	    var stamp = _props3.stamp;

	    var stampSegment = getStampSegment(stamp);

	    if (this.isInPendingState()) {
	      ZineActionCreators.rejectStampFromZine(zine.slug, stampSegment);
	    } else {
	      ZineActionCreators.removeStampFromZine(zine.slug, stampSegment);
	    }
	  }
	});

	module.exports = SubmitStampControl;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    BackColorMixin = __webpack_require__(56),
	    ScreenSizeMixin = __webpack_require__(71),
	    ZineActionCreators = __webpack_require__(41),
	    ShareActionCreators = __webpack_require__(91),
	    ImagePicker = __webpack_require__(270),
	    Share = __webpack_require__(206),
	    ServiceTypes = __webpack_require__(35),
	    AnalyticsSources = __webpack_require__(34),
	    UserStore = __webpack_require__(5),
	    getZineThumbnail = __webpack_require__(178),
	    getZineCover = __webpack_require__(444),
	    ContentEditable = __webpack_require__(250),
	    ResponsiveImageQueueMixin = __webpack_require__(86),
	    PureRenderMixin = __webpack_require__(2),
	    createStoreMixin = __webpack_require__(8),
	    getThumbnailUrl = __webpack_require__(37),
	    formatCount = __webpack_require__(219),
	    pluralize = __webpack_require__(98),
	    Icon = __webpack_require__(10),
	    FontTest = __webpack_require__(92),
	    UserLink = __webpack_require__(69),
	    UserImage = __webpack_require__(143),
	    ZineStatus = __webpack_require__(114),
	    isBestOf2014Special = __webpack_require__(83);

	__webpack_require__(949);

	var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	var THUMBNAIL_SIZE = 10 * 16 * Math.round(devicePixelRatio);

	var ZineCover = React.createClass({
	  displayName: 'ZineCover',

	  mixins: [ClassNameMixin, PureRenderMixin, BackColorMixin, ResponsiveImageQueueMixin, createStoreMixin(UserStore), ScreenSizeMixin],

	  propTypes: {
	    zine: React.PropTypes.object.isRequired,
	    isEditing: React.PropTypes.bool.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      isEditing: false
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      recentContributors: (props.zine.recentContributors || []).map(UserStore.get),
	      isMeCurator: UserStore.isMe(props.zine.curator)
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var zine = this.props.zine;

	    return [this.getTextColor(zine.backColor), this.props.isEditing && 'editing', isBestOf2014Special(zine) && '2014special'];
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 992,
	      'md': 1200,
	      'lg': 1440,
	      'xl': 1600
	    };
	  },

	  /**
	   * Specifies progressive loading options for zine covers.
	   *
	   * For zines we curate, we only load *one* highres image (either normal or retina).
	   * This ensures instant switching between editing and viewing.
	   *
	   * For zines we don't curate, we load smaller thumbnails too to make loading appear faster.
	   */
	  getImageOptions: function getImageOptions() {
	    var zine = this.props.zine,
	        isMeCurator = this.state.isMeCurator,
	        cover = getZineCover(zine);

	    if (cover.isDefault) {
	      return;
	    }

	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: cover,
	      sizes: {
	        thumb: !isMeCurator,
	        small: !isMeCurator,
	        normal: devicePixelRatio <= 1.5,
	        retina: devicePixelRatio > 1.5
	      }
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.zine.recentContributors !== this.props.zine.recentContributors) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.zine.coverUrl !== this.props.zine.coverUrl) {
	      this.updateImageQueue();
	    }
	  },

	  /**
	   * Returns cover style when viewing a zine.
	   * For default covers, return them as is (they're SVG anyway).
	   * For custom covers, use progressively loaded sequence specified in `getImageQueue`.
	   */
	  getCoverStyle: function getCoverStyle() {
	    if (this.props.isEditing) {
	      return;
	    }

	    var zineCover = getZineCover(this.props.zine);
	    if (zineCover.isDefault) {
	      return {
	        backgroundImage: 'url(' + zineCover.url + ')',
	        backgroundSize: 'auto'
	      };
	    } else {
	      return {
	        backgroundImage: this.getBackgroundImageUrl(),
	        backgroundSize: 'cover'
	      };
	    }
	  },

	  /**
	   * Returns cover URL when editing a zine, if you're a curator.
	   * For default covers, we want it empty.
	   * For custom covers, we want the only loaded image to avoid flicker (see `getImageOptions`).
	   */
	  getCoverPickerImageUrl: function getCoverPickerImageUrl() {
	    var zineCover = getZineCover(this.props.zine);
	    if (zineCover.isDefault) {
	      return;
	    }

	    var normalOrRetinaUrl = this.getImageSrcUrl();
	    return normalOrRetinaUrl;
	  },

	  /**
	   * Returns thumbnail style when viewing a zine.
	   * Default or not, it will be resized and cropped to a prefedined size.
	   */
	  getThumbnailStyle: function getThumbnailStyle() {
	    if (this.props.isEditing) {
	      return;
	    }

	    var zineThumbnail = getZineThumbnail(this.props.zine),
	        thumbnailUrl;

	    thumbnailUrl = getThumbnailUrl(zineThumbnail, {
	      mode: 'scale_crop',
	      width: THUMBNAIL_SIZE,
	      height: THUMBNAIL_SIZE
	    });

	    return {
	      backgroundImage: 'url(' + thumbnailUrl + ')'
	    };
	  },

	  /**
	   * Returns thumbnail URL when editing a zine.
	   * For default thumbnails, we want it empty.
	   * For custom thumbnails, we want it resized and cropped to a prefedined size.
	   */
	  getThumbnailPickerUrl: function getThumbnailPickerUrl() {
	    var zineThumbnail = getZineThumbnail(this.props.zine);
	    if (zineThumbnail.isDefault) {
	      return;
	    }

	    return getThumbnailUrl(zineThumbnail, {
	      mode: 'scale_crop',
	      width: THUMBNAIL_SIZE,
	      height: THUMBNAIL_SIZE
	    });
	  },

	  render: function render() {
	    var zine = this.props.zine,
	        title = zine.title,
	        description = zine.description,
	        recentContributors = this.state.recentContributors,
	        isUnlisted = zine.status === ZineStatus.UNLISTED,
	        titleFontFamily = isBestOf2014Special(zine) ? 'playfair-display' : null;

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: { backgroundColor: '#' + zine.backColor } },
	      React.createElement(
	        'div',
	        { className: 'ZineCover-header' },
	        React.createElement(
	          'div',
	          { className: 'ZineCover-coverImage',
	            style: this.getCoverStyle() },
	          this.renderLoaderImg(),
	          this.props.isEditing && React.createElement(
	            ImagePicker,
	            { imageUrl: this.getCoverPickerImageUrl(),
	              size: 'cover',
	              onUploadSuccess: this.handleCoverUploaded,
	              cancelOnChange: true },
	            React.createElement(Icon, { name: 'poster',
	              size: 'large',
	              mode: 'stroke',
	              context: 'ZineCover' })
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'ZineCover-info' },
	        React.createElement(
	          'div',
	          { className: 'ZineCover-avatar',
	            style: this.getThumbnailStyle() },
	          this.props.isEditing && React.createElement(
	            ImagePicker,
	            { imageUrl: this.getThumbnailPickerUrl(),
	              size: 'thumbnail',
	              onUploadSuccess: this.handleThumbnailUploaded,
	              cancelOnChange: true },
	            React.createElement(Icon, { name: 'image',
	              size: 'medium',
	              mode: 'stroke' })
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'ZineCover-hgroup' },
	          React.createElement(
	            FontTest,
	            { family: titleFontFamily,
	              test: title },
	            React.createElement(ContentEditable, { className: 'ZineCover-title',
	              component: 'h3',
	              onChange: this.handleZineTitleChange,
	              placeholder: 'Name Your Collection',
	              editable: this.props.isEditing,
	              text: title,
	              maxLength: 40 })
	          ),
	          React.createElement(
	            FontTest,
	            { family: 'minion-pro-condensed',
	              test: description },
	            React.createElement(ContentEditable, { className: 'ZineCover-description',
	              component: 'p',
	              onChange: this.handleZineDescriptionChange,
	              placeholder: 'Add a description',
	              editable: this.props.isEditing,
	              text: description,
	              maxLength: 200 })
	          ),
	          isBestOf2014Special(zine) && React.createElement(Share, { services: [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER],
	            onShareClick: this.handleShareClick,
	            color: 'light',
	            size: 'medium',
	            showServiceName: !this.state.isMobile,
	            showShareWordPrefix: !this.state.isMobile }),
	          !isBestOf2014Special(zine) && !this.props.isEditing && !isUnlisted && this.renderFollowers()
	        ),
	        !this.props.isEditing && recentContributors.length > 0 && this.renderContributors(recentContributors)
	      )
	    );
	  },

	  renderFollowers: function renderFollowers() {
	    var zine = this.props.zine;

	    return React.createElement(
	      'div',
	      { className: 'ZineCover-followers' },
	      formatCount(zine.subscriberCount),
	      ' ',
	      pluralize(zine.subscriberCount, 'Follower', 'Followers')
	    );
	  },

	  renderContributors: function renderContributors(recentContributors) {
	    var items = recentContributors.map(function (user) {
	      return React.createElement(
	        'li',
	        { className: 'ZineCover-recentContributors-listItem',
	          key: user.id },
	        React.createElement(
	          UserLink,
	          { user: user, showTitle: true },
	          React.createElement(UserImage, { size: 'xsmall', user: user })
	        )
	      );
	    });

	    return React.createElement(
	      'div',
	      { className: 'ZineCover-recentContributors' },
	      React.createElement(
	        'h3',
	        { className: 'ZineCover-recentContributors-label utils--smallCaps' },
	        'Recent contributors'
	      ),
	      React.createElement(
	        'ul',
	        { className: 'ZineCover-recentContributors-list' },
	        items
	      )
	    );
	  },

	  handleThumbnailUploaded: function handleThumbnailUploaded(filePath, image) {
	    ZineActionCreators.updateZineDraft('thumbnailUrl', image.url);
	  },

	  handleCoverUploaded: function handleCoverUploaded(filePath, image) {
	    ZineActionCreators.updateZineDraft('coverUrl', image.url);
	  },

	  handleZineTitleChange: function handleZineTitleChange(textContent) {
	    ZineActionCreators.updateZineDraft('title', textContent);
	  },

	  handleZineDescriptionChange: function handleZineDescriptionChange(textContent) {
	    ZineActionCreators.updateZineDraft('description', textContent);
	  },

	  handleShareClick: function handleShareClick(service) {
	    ShareActionCreators.shareZine({
	      source: AnalyticsSources.BEST_OF_2014_SPECIAL,
	      zineSlug: this.props.zine.slug,
	      service: service
	    });
	  }
	});

	module.exports = ZineCover;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var UserStore = __webpack_require__(5);
	var AnalyticsSources = __webpack_require__(34);
	var AboutSection = __webpack_require__(172);
	var ShortSignUp = __webpack_require__(268);
	var ShortLogin = __webpack_require__(267);
	var PureRenderMixin = __webpack_require__(2);
	var ScreenSizeMixin = __webpack_require__(71);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var ClassNameMixin = __webpack_require__(3);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var config = __webpack_require__(66);var PropTypes = React.PropTypes;

	__webpack_require__(950);

	var iframeSrc = '//player.vimeo.com/video/120371713?autoplay=1&title=0&byline=0&badge=0';
	var backgroundImage = {
	  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/24/2015/79a15771-c461-41e3-bf97-721a04ee3e3f.jpg',
	  size: {
	    width: 2048,
	    height: 1152
	  }
	};

	var AboutCoverSection = React.createClass({
	  displayName: 'AboutCoverSection',

	  mixins: [ClassNameMixin, PureRenderMixin, ScreenSizeMixin, createFlexibleImageQueueMixin(200)],

	  propTypes: {
	    layout: PropTypes.oneOf(['full', 'section', 'banner']).isRequired,
	    active: PropTypes.bool.isRequired,
	    showLogo: PropTypes.bool,
	    showVideo: PropTypes.bool,
	    onRequestShowVideoChange: PropTypes.func,
	    footer: PropTypes.element
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: backgroundImage,
	      sizes: {
	        normal: true
	      }
	    };
	  },

	  getContentWindow: function getContentWindow() {
	    if (this.refs.iframe) {
	      return this.refs.iframe.getDOMNode().contentWindow;
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    window.addEventListener('message', this.handleIframeMessage);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('message', this.handleIframeMessage);
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      inactive: !this.props.active
	    };
	  },

	  render: function render() {
	    var _props = this.props;
	    var showVideo = _props.showVideo;
	    var layout = _props.layout;
	    var active = _props.active;
	    var showLogo = _props.showLogo;
	    var footer = this.props.footer;

	    if (showVideo) {
	      footer = null;
	    }

	    return React.createElement(
	      AboutSection,
	      { layout: layout,
	        active: active,
	        showLogo: showLogo,
	        title: 'A single place to share, curate and discover visual content that tells a story.',
	        backgroundColor: '#222',
	        backgroundImage: this.getBackgroundImageUrl(),
	        color: 'white',
	        footer: footer,
	        needsTopMarginOnTablet: layout !== 'banner' },
	      this.props.children || this.renderDefaultContent(),
	      this.renderLoaderImg()
	    );
	  },

	  renderDefaultContent: function renderDefaultContent() {
	    var showVideo = this.props.showVideo;
	    var isMobile = this.state.isMobile;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      !showVideo && React.createElement(
	        'div',
	        { className: 'AboutCoverSection-playButton' },
	        React.createElement(
	          Button,
	          { onClick: this.handleShowVideoClick,
	            color: 'light',
	            fill: true,
	            size: isMobile ? 'xlarge' : 'xlarge',
	            round: true },
	          React.createElement(Icon, { name: 'play',
	            size: isMobile ? 'medium' : 'medium' })
	        )
	      ),
	      !showVideo && !UserStore.isAuthenticated() && React.createElement(
	        'div',
	        { className: 'AboutCoverSection-signUpWrapper' },
	        config.signUpEnabled ? React.createElement(ShortSignUp, { color: 'light',
	          source: AnalyticsSources.ABOUT_PAGE_WELCOME }) : React.createElement(ShortLogin, { color: 'light',
	          source: AnalyticsSources.ABOUT_PAGE_WELCOME })
	      ),
	      showVideo && React.createElement(
	        'div',
	        { className: 'AboutCoverSection-videoWrapper' },
	        React.createElement('iframe', { src: iframeSrc,
	          frameBorder: '0',
	          webkitAllowFullScreen: true,
	          mozAllowFullscreen: true,
	          allowFullScreen: true,
	          ref: 'iframe' }),
	        React.createElement(
	          'div',
	          { className: 'AboutCoverSection-closeVideoButton' },
	          React.createElement(
	            Button,
	            { size: 'large',
	              round: true,
	              color: 'black',
	              overlay: true,
	              onClick: this.handleHideVideoClick },
	            React.createElement(Icon, { name: 'cross',
	              size: 'small',
	              mode: 'stroke' })
	          )
	        )
	      )
	    );
	  },

	  handleShowVideoClick: function handleShowVideoClick() {
	    this.props.onRequestShowVideoChange(true);
	  },

	  handleHideVideoClick: function handleHideVideoClick() {
	    this.props.onRequestShowVideoChange(false);
	  },

	  handleIframeMessage: function handleIframeMessage(e) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (e.source !== this.getContentWindow()) {
	      return;
	    }

	    var data = null;
	    try {
	      data = JSON.parse(e.data);
	    } catch (err) {
	      return;
	    }

	    switch (data.event) {
	      case 'ready':
	        this.postMessage('addEventListener', 'finish');
	        break;

	      case 'finish':
	        this.handleVideoEnd();
	        break;
	    }
	  },

	  handleVideoEnd: function handleVideoEnd() {
	    this.props.onRequestShowVideoChange(false);
	  },

	  postMessage: function postMessage(method, value) {
	    var contentWindow = this.getContentWindow();
	    if (contentWindow) {
	      contentWindow.postMessage(JSON.stringify({ method: method, value: value }), iframeSrc);
	    }
	  }
	});

	module.exports = AboutCoverSection;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defineProperty = __webpack_require__(181)['default'];

	var _createClass = __webpack_require__(224)['default'];

	var _classCallCheck = __webpack_require__(223)['default'];

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var getThumbnailUrl = __webpack_require__(37);
	var ImagePlaceholderCache = __webpack_require__(781);var PropTypes = React.PropTypes;
	var Children = React.Children;

	__webpack_require__(953);

	var AboutSectionCarousel = React.createClass({
	  displayName: 'AboutSectionCarousel',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    hidden: PropTypes.bool,
	    active: PropTypes.bool.isRequired,
	    type: PropTypes.oneOf(['stamps', 'zines']).isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _props = this.props;
	    var hidden = _props.hidden;
	    var active = _props.active;
	    var type = _props.type;

	    return _defineProperty({
	      hidden: hidden,
	      inactive: !active }, type, true);
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      Children.map(this.props.children, this.wrapChild)
	    );
	  },

	  wrapChild: function wrapChild(child, key) {
	    if (!child) {
	      return;
	    }

	    return React.createElement(
	      'div',
	      { className: 'AboutSectionCarousel-itemWrapper', key: key },
	      child
	    );
	  }
	});

	var NodeImagePlaceholderCache = (function () {
	  function NodeImagePlaceholderCache() {
	    _classCallCheck(this, NodeImagePlaceholderCache);
	  }

	  _createClass(NodeImagePlaceholderCache, [{
	    key: 'getDataURLForSize',
	    value: function getDataURLForSize(_ref2) {
	      var width = _ref2.width;
	      var height = _ref2.height;

	      console.log('Calling NodeImagePlaceholderCache');
	      return '';
	    }
	  }]);

	  return NodeImagePlaceholderCache;
	})();

	// We know the exact image size but we can't set
	// explicit size in CSS because we want to scale
	// down to parent's width. To avoid jumps when image
	// has loaded, we'll use a placeholder cache with
	// transparent canvas data URIs for given image size.

	var _placeholderCache = typeof navigator !== 'undefined' ? new ImagePlaceholderCache() : new NodeImagePlaceholderCache();

	var AboutSectionCarouselImage = React.createClass({
	  displayName: 'AboutSectionCarouselImage',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'AboutSectionCarousel-image',

	  propTypes: {
	    imageUrl: PropTypes.string.isRequired,
	    imageSize: PropTypes.shape({
	      width: PropTypes.number.isRequired,
	      height: PropTypes.number.isRequired
	    }).isRequired,
	    faded: PropTypes.bool
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      faded: this.props.faded
	    };
	  },

	  getInitialState: function getInitialState() {
	    var imageSize = this.props.imageSize;

	    return {
	      src: _placeholderCache.getDataURLForSize(imageSize)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.setSrcFromProps(this.props);
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setSrcFromProps(nextProps);
	  },

	  setSrcFromProps: function setSrcFromProps(props) {
	    var imageUrl = props.imageUrl;
	    var imageSize = props.imageSize;

	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    this.setState({
	      src: getThumbnailUrl({ url: imageUrl }, {
	        mode: 'preview',
	        width: imageSize.width * Math.round(devicePixelRatio),
	        height: imageSize.height * Math.round(devicePixelRatio)
	      })
	    });
	  },

	  render: function render() {
	    var src = this.state.src;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement('img', { src: src })
	    );
	  }
	});

	module.exports = AboutSectionCarousel;
	module.exports.Image = AboutSectionCarouselImage;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defineProperty = __webpack_require__(181)['default'];

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var getThumbnailUrl = __webpack_require__(37);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(954);

	var AboutSectionGrid = React.createClass({
	  displayName: 'AboutSectionGrid',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    type: PropTypes.oneOf(['feed', 'zinesLeft', 'zinesRight']).isRequired,
	    active: PropTypes.bool,
	    imageUrls: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	    imageSize: PropTypes.shape({
	      width: PropTypes.number.isRequired,
	      height: PropTypes.number
	    }).isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _props = this.props;
	    var type = _props.type;
	    var active = _props.active;

	    return _defineProperty({
	      inactive: !active }, type, true);
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.props.imageUrls.map(this.renderItem)
	    );
	  },

	  renderItem: function renderItem(imageUrl, index) {
	    var imageSize = this.props.imageSize;

	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return React.createElement(
	      'div',
	      { className: 'AboutSectionGrid-item', key: index },
	      React.createElement('img', _extends({}, imageSize, {
	        style: imageSize,
	        src: getThumbnailUrl({ url: imageUrl }, {
	          mode: 'preview',
	          width: imageSize.width * Math.round(devicePixelRatio),
	          height: imageSize.height * Math.round(devicePixelRatio)
	        }) }))
	    );
	  }
	});

	module.exports = AboutSectionGrid;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var _require = __webpack_require__(4);

	var isArray = _require.isArray;
	var ClassNameMixin = __webpack_require__(3);
	var StampItem = __webpack_require__(725);
	var ZineItem = __webpack_require__(273);
	var PinterestImage = __webpack_require__(701);
	var PureRenderMixin = __webpack_require__(2);
	var Activity = __webpack_require__(693);
	var UserItem = __webpack_require__(272);
	var assign = __webpack_require__(15);
	var Message = __webpack_require__(698);
	var PropTypes = React.PropTypes;

	__webpack_require__(957);

	var Collection = React.createClass({
	  displayName: 'Collection',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'Collection',

	  propTypes: {
	    type: PropTypes.oneOf(['stamps', 'zines', 'pinterestImages', 'activities', 'users', 'messages']),
	    mode: PropTypes.oneOf(['grid', 'list']),
	    columns: PropTypes.number,
	    keys: PropTypes.arrayOf(PropTypes.string),
	    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
	    itemProps: PropTypes.object,
	    getItemProps: PropTypes.func
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.mode, this.props.type, typeof this.props.columns === 'number' && this.props.columns + 'columns'];
	  },

	  getItemProps: function getItemProps(item, index) {
	    return assign({}, this.props.itemProps, this.props.getItemProps ? this.props.getItemProps(item, index) : null);
	  },

	  render: function render() {
	    var items = this.props.items;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      items.length > 0 && items.map(this.renderItem),
	      items.length === 0 && this.props.children
	    );
	  },

	  getItemKey: function getItemKey(item, index) {
	    if (this.props.keys) {
	      return this.props.keys[index];
	    }

	    switch (this.props.type) {
	      case 'stamps':
	        return item.id || item.uuid;

	      case 'users':
	      case 'activities':
	      case 'messages':
	        return item.id;

	      case 'zines':
	        return item.slug;

	      case 'pinterestImages':
	        return item.url;
	    }
	  },

	  renderItem: function renderItem(item, index) {
	    var itemComponent,
	        key = this.getItemKey(item, index);

	    switch (this.props.type) {
	      case 'stamps':
	        itemComponent = this.renderStamp(item, index);
	        break;

	      case 'zines':
	        itemComponent = this.renderZine(item, index);
	        break;

	      case 'pinterestImages':
	        itemComponent = this.renderPinterestImage(item, index);
	        break;

	      case 'activities':
	        itemComponent = this.renderActivities(item, index);
	        break;

	      case 'users':
	        itemComponent = this.renderUser(item, index);
	        break;

	      case 'messages':
	        itemComponent = this.renderMessage(item, index);
	        break;

	      default:
	        throw new Error('Unsupported type: ' + this.props.type);
	    }

	    return React.createElement(
	      'div',
	      { className: 'Collection-item', key: key },
	      itemComponent
	    );
	  },

	  renderStamp: function renderStamp(stamp, index) {
	    return React.createElement(StampItem, _extends({}, this.getItemProps(stamp, index), {
	      stamp: stamp,
	      context: 'collection' }));
	  },

	  renderZine: function renderZine(zine, index) {
	    return React.createElement(ZineItem, _extends({}, this.getItemProps(zine, index), {
	      zine: zine,
	      context: 'collection' }));
	  },

	  renderPinterestImage: function renderPinterestImage(image, index) {
	    return React.createElement(PinterestImage, _extends({}, this.getItemProps(image, index), {
	      image: image,
	      context: 'collection' }));
	  },

	  renderUser: function renderUser(user, index) {
	    return React.createElement(UserItem, _extends({}, this.getItemProps(user, index), {
	      user: user }));
	  },

	  renderActivities: function renderActivities(activityOrGroup) {
	    if (isArray(activityOrGroup)) {
	      return activityOrGroup.map(this.renderActivity);
	    } else {
	      return this.renderActivity(activityOrGroup);
	    }
	  },

	  renderActivity: function renderActivity(activity) {
	    return React.createElement(Activity, { key: activity.id,
	      activity: activity,
	      context: 'Collection' });
	  },

	  renderMessage: function renderMessage(message, index) {
	    return React.createElement(Message, _extends({}, this.getItemProps(message, index), {
	      message: message,
	      context: 'collection' }));
	  }
	});

	module.exports = Collection;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesPageControls = __webpack_require__(116);

	var _moleculesPageControls2 = _interopRequireDefault(_moleculesPageControls);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _moleculesBtnGroup = __webpack_require__(44);

	var _moleculesBtnGroup2 = _interopRequireDefault(_moleculesBtnGroup);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _actionsContextMenuActionCreators = __webpack_require__(111);

	var _actionsContextMenuActionCreators2 = _interopRequireDefault(_actionsContextMenuActionCreators);

	var _constantsContextMenuTypes = __webpack_require__(112);

	var _constantsContextMenuTypes2 = _interopRequireDefault(_constantsContextMenuTypes);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	'use strict';

	var DraftPageControls = _react2['default'].createClass({
	  displayName: 'DraftPageControls',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    isUnlisted: _react.PropTypes.bool.isRequired,
	    isPublishing: _react.PropTypes.bool.isRequired,
	    canPublish: _react.PropTypes.bool.isRequired,
	    stampSegment: _react.PropTypes.string.isRequired,
	    showOptions: _react.PropTypes.bool
	  },

	  render: function render() {
	    var _props = this.props;
	    var isPublishing = _props.isPublishing;
	    var stampSegment = _props.stampSegment;
	    var canPublish = _props.canPublish;
	    var children = _props.children;
	    var isUnlisted = _props.isUnlisted;
	    var showOptions = _props.showOptions;

	    var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	    var isDraft = _parseStampSegment.isDraft;

	    var isProAccount = _storesUserStore2['default'].isAuthenticated() && _storesUserStore2['default'].getMe().isProAccount;

	    return _react2['default'].createElement(
	      _moleculesPageControls2['default'],
	      { context: 'Draft' },
	      showOptions && _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        { fill: true },
	        _react2['default'].createElement(
	          _moleculesBtnGroup2['default'],
	          null,
	          isProAccount && _react2['default'].createElement(
	            _atomsButton2['default'],
	            { onClick: this.handleSwitchStatusClick,
	              context: 'PageControls',
	              overlay: true,
	              color: 'black',
	              size: 'medium' },
	            _react2['default'].createElement(_atomsIcon2['default'], { name: isUnlisted ? 'eyeCrossed' : 'eye',
	              mode: isUnlisted ? 'fill' : 'stroke',
	              size: 'small' }),
	            isUnlisted ? 'Secret' : 'Public',
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'arrowUp',
	              mode: 'stroke',
	              size: 'xsmall',
	              margin: 'left' })
	          ),
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { onClick: this.handleShowMoreClick,
	              context: 'PageControls',
	              overlay: true,
	              color: 'black',
	              size: 'medium',
	              round: true },
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'more', mode: 'fill' })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(
	          _moleculesBtnGroup2['default'],
	          null,
	          children
	        ),
	        _react2['default'].createElement(
	          _moleculesBtnGroup2['default'],
	          null,
	          !isDraft && !isPublishing && _react2['default'].createElement(
	            _atomsButton2['default'],
	            { size: 'medium',
	              overlay: true,
	              split: true,
	              color: 'black',
	              context: 'PageControls',
	              onClick: this.handleCancelClick },
	            'Cancel'
	          ),
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { color: 'green',
	              fill: true,
	              split: !isDraft,
	              disabled: !canPublish,
	              onClick: this.handlePostClick,
	              context: 'PageControls',
	              size: 'medium' },
	            isDraft && !isPublishing && 'Post',
	            isDraft && isPublishing && 'Posting...',
	            !isDraft && !isPublishing && 'Save',
	            !isDraft && isPublishing && 'Saving...'
	          )
	        )
	      )
	    );
	  },

	  handleSwitchStatusClick: function handleSwitchStatusClick(e) {
	    var el = e.target;

	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].STAMP_STATUS_PICKER, el);
	  },

	  handleCancelClick: function handleCancelClick() {
	    _actionsDraftActionCreators2['default'].cancelEditingStamp();
	  },

	  handlePostClick: function handlePostClick() {
	    _actionsDraftActionCreators2['default'].postOrUpdateStamp();
	  },

	  handleShowMoreClick: function handleShowMoreClick(e) {
	    var el = e.target;
	    var stampSegment = this.props.stampSegment;

	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].EDITOR_MORE, el, {
	      stampSegment: stampSegment
	    });
	  }
	});

	module.exports = DraftPageControls;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _MessageStore = __webpack_require__(773);

	var _MessageStore2 = _interopRequireDefault(_MessageStore);

	var _utilsPaginatedStoreUtils = __webpack_require__(28);

	'use strict';

	var DraftFeedbackStore = (0, _utilsPaginatedStoreUtils.createIndexedListStore)({
	  getDraftFeedbacks: function getDraftFeedbacks(draftUuid) {
	    return this.getIds(draftUuid).map(_MessageStore2['default'].get);
	  }
	});

	var handleListAction = (0, _utilsPaginatedStoreUtils.createListActionHandler)({
	  request: _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS,
	  error: _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS_ERROR,
	  success: _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS_SUCCESS
	});

	_AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_MessageStore2['default'].dispatchToken]);

	  var action = payload.action,
	      draftUuid = action.draftUuid;

	  if (draftUuid) {
	    handleListAction(action, DraftFeedbackStore.getList(draftUuid), DraftFeedbackStore.emitChange);
	  }

	  switch (action.type) {
	    case _constantsActionTypes2['default'].INVALIDATE_DRAFT_FEEDBACKS:
	      DraftFeedbackStore.invalidate(draftUuid);
	      break;
	  }
	});

	module.exports = DraftFeedbackStore;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);var createListStore = PaginatedStoreUtils.createListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var FeedStore = createListStore();

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_FEED,
	  error: ActionTypes.REQUEST_FEED_ERROR,
	  success: ActionTypes.REQUEST_FEED_SUCCESS,
	  preload: ActionTypes.PRELOAD_FEED
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken, ZineStore.dispatchToken]);
	  handleListAction(payload.action, FeedStore.getList(), FeedStore.emitChange);

	  switch (payload.action.type) {
	    case ActionTypes.FOLLOW_ZINE_SUCCESS:
	    case ActionTypes.UNFOLLOW_ZINE_SUCCESS:
	    case ActionTypes.FOLLOW_USER_SUCCESS:
	    case ActionTypes.UNFOLLOW_USER_SUCCESS:
	    case ActionTypes.SUBMIT_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.ADD_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.REMOVE_STAMP_FROM_ZINE_SUCCESS:
	    case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
	    case ActionTypes.INVALIDATE_FEED_WITH_TRENDING:
	      FeedStore.invalidate();
	      break;
	  }
	});

	module.exports = FeedStore;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StampStore = __webpack_require__(17);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var ImageUsedInStampStore = createIndexedListStore({
	  getStamps: function getStamps(imageUuid) {
	    return this.getIds(imageUuid).map(StampStore.get);
	  }
	});

	function getList(imageUuid) {
	  return ImageUsedInStampStore.getList(imageUuid);
	}

	function emitChange() {
	  ImageUsedInStampStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS,
	  error: ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_ERROR,
	  success: ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);

	  var action = payload.action,
	      imageUuid = action.imageUuid,
	      list;

	  if (!imageUuid) {
	    return;
	  }

	  list = getList(imageUuid);

	  handleListAction(action, list, emitChange);
	});

	module.exports = ImageUsedInStampStore;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    StoreUtils = __webpack_require__(30),
	    createStore = StoreUtils.createStore;

	var _context = null;

	function setContext(context) {
	  _context = context;
	}

	var NavigationStore = createStore({
	  getContext: function getContext() {
	    return _context;
	  },

	  isActive: function isActive(id) {
	    return _context && _context.id === id;
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.SET_NAVIGATION_CONTEXT:
	      setContext(action.context);
	      NavigationStore.emitChange();
	      break;
	    case ActionTypes.CLEAR_NAVIGATION_CONTEXT:
	      setContext(null);
	      NavigationStore.emitChange();
	      break;
	  }
	});

	module.exports = NavigationStore;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StoreUtils = __webpack_require__(30);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var Messages = __webpack_require__(78);
	var _require = __webpack_require__(4);

	var filter = _require.filter;
	var createStore = StoreUtils.createStore;

	var STACK_LENGTH_LIMIT = 3,
	    NORMAL_DURATION = 5 * 1000,
	    ACTION_DURATION = 250 * 1000;

	var _notificationStack = [];

	function isSticky(id) {
	  switch (id) {
	    case Messages.UNSUPPORTED_BROWSER:
	    case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
	    case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
	      return true;
	  }

	  return false;
	}

	function hasAction(id) {
	  switch (id) {
	    case Messages.STAMP_HAS_BEEN_SAVED:
	    case Messages.WELCOME_FOLLOW_ZINES:
	    case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
	    case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
	    case Messages.EMAIL_UNSUBSCRIBE:
	      return true;
	  }
	}

	function getDuration(id) {
	  if (isSticky(id)) {
	    return 0;
	  } else if (hasAction(id)) {
	    return ACTION_DURATION;
	  } else {
	    return NORMAL_DURATION;
	  }
	}

	function setNotification(notification) {
	  _notificationStack = [notification].concat(_notificationStack);

	  if (_notificationStack.length > STACK_LENGTH_LIMIT) {
	    var stickyCount = filter(_notificationStack, function (n) {
	      return isSticky(n.id);
	    }).length;

	    _notificationStack = filter(_notificationStack, function (n, idx) {
	      return idx < STACK_LENGTH_LIMIT - stickyCount || isSticky(n.id);
	    });
	  }
	}

	function hideNotification(action) {
	  _notificationStack = _notificationStack.filter(function (n) {
	    return n.id !== action.id || action.created && action.created !== n.created;
	  });
	}

	var NotificationStore = createStore({
	  getNotifications: function getNotifications() {
	    return _notificationStack;
	  },

	  getDuration: getDuration
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken, ZineStore.dispatchToken]);

	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.SHOW_NOTIFICATION:
	      setNotification(action.notification);
	      NotificationStore.emitChange();
	      break;

	    case ActionTypes.HIDE_NOTIFICATION:
	      hideNotification(action);
	      NotificationStore.emitChange();
	      break;
	  }
	});

	module.exports = NotificationStore;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _getIterator = __webpack_require__(302)['default'];

	var AppDispatcher = __webpack_require__(6);
	var SearchStampStore = __webpack_require__(210);
	var SearchUserStore = __webpack_require__(211);
	var SearchZineStore = __webpack_require__(212);
	var RouterStore = __webpack_require__(120);
	var ActionTypes = __webpack_require__(9);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var update = __webpack_require__(49);

	var _history = [];

	function clearHistory() {
	  _history = [];
	}

	function addToHistory(terms) {
	  var index = _history.indexOf(terms);
	  if (index > -1) {
	    _history = update(_history, {
	      $splice: [[index, 1]]
	    });
	  }

	  _history = update(_history, {
	    $splice: [[0, 0, terms]]
	  });
	}

	function hasDataFor(terms) {
	  return SearchStampStore.getPageCount(terms) > 0 && SearchUserStore.getPageCount(terms) > 0 && SearchZineStore.getPageCount(terms) > 0;
	}

	var SearchStore = createStore({
	  getTermsFromRoute: function getTermsFromRoute() {
	    var terms = RouterStore.getRouterState().query.q || '';
	    return terms.trim();
	  },

	  getLastTermsWithData: function getLastTermsWithData() {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;

	    try {
	      for (var _iterator = _getIterator(_history), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var terms = _step.value;

	        if (hasDataFor(terms)) {
	          return terms;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }

	    return '';
	  }
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([SearchStampStore.dispatchToken, SearchUserStore.dispatchToken, SearchZineStore.dispatchToken, RouterStore.dispatchToken]);

	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.CHANGE_ROUTE:
	      var terms = SearchStore.getTermsFromRoute();
	      if (terms.length > 0) {
	        addToHistory(terms);
	      } else {
	        clearHistory();
	      }
	      SearchStore.emitChange();
	      break;

	    case ActionTypes.REQUEST_STAMP_SEARCH_SUCCESS:
	    case ActionTypes.REQUEST_USER_SEARCH_SUCCESS:
	    case ActionTypes.REQUEST_ZINE_SEARCH_SUCCESS:
	      SearchStore.emitChange();
	      break;
	  }
	});

	module.exports = SearchStore;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var InvitationStore = __webpack_require__(289);
	var UserStore = __webpack_require__(5);
	var ServiceTypes = __webpack_require__(35);var createListStore = PaginatedStoreUtils.createListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var SentInvitationStore = createListStore({
	  getInvitations: function getInvitations() {
	    return this.getIds(UserStore.getMe().id).map(InvitationStore.get);
	  }
	});

	function getList() {
	  return SentInvitationStore.getList(UserStore.getMe().id);
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_INVITATIONS,
	  error: ActionTypes.REQUEST_INVITATIONS_ERROR,
	  success: ActionTypes.REQUEST_INVITATIONS_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([InvitationStore.dispatchToken]);

	  var action = payload.action,
	      inviteId,
	      invite,
	      list;

	  if (!UserStore.getMe()) {
	    return;
	  }

	  list = getList();

	  handleListAction(action, list, SentInvitationStore.emitChange);

	  switch (action.type) {
	    case ActionTypes.SEND_INVITE_SUCCESS:
	      inviteId = action.response.result;
	      invite = action.response.entities.userInvitations[inviteId];
	      if (!list.contains(inviteId) && invite.serviceType !== ServiceTypes.FACEBOOK) {
	        list.prepend(inviteId);
	      }
	      SentInvitationStore.emitChange();
	      break;

	    case ActionTypes.UPDATE_INVITE_SUCCESS:
	      inviteId = action.response.result;
	      invite = action.response.entities.userInvitations[inviteId];
	      if (!list.contains(inviteId)) {
	        list.prepend(inviteId);
	      }
	      SentInvitationStore.emitChange();
	      break;
	  }
	});

	module.exports = SentInvitationStore;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var UserStore = __webpack_require__(5);
	var parseStampSegment = __webpack_require__(53);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var StampLikesStore = createIndexedListStore({
	  getStampLikes: function getStampLikes(stampId) {
	    return this.getIds(stampId).map(UserStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_STAMP_LIKES,
	  error: ActionTypes.REQUEST_STAMP_LIKES_ERROR,
	  success: ActionTypes.REQUEST_STAMP_LIKES_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action;
	  var stampSegment = action.stampSegment;

	  if (stampSegment) {
	    var _parseStampSegment = parseStampSegment(stampSegment);

	    var isStamp = _parseStampSegment.isStamp;
	    var stampId = _parseStampSegment.stampId;

	    if (isStamp) {
	      handleListAction(action, StampLikesStore.getList(stampId), StampLikesStore.emitChange);
	    }
	  }
	});

	module.exports = StampLikesStore;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var ZineStore = __webpack_require__(22);var createListStore = PaginatedStoreUtils.createListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var SuggestedZineStore = createListStore({
	  getZines: function getZines() {
	    return this.getIds().map(ZineStore.get);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_SUGGESTED_ZINES,
	  error: ActionTypes.REQUEST_SUGGESTED_ZINES_ERROR,
	  success: ActionTypes.REQUEST_SUGGESTED_ZINES_SUCCESS,
	  preload: ActionTypes.PRELOAD_SUGGESTED_ZINES
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);
	  handleListAction(payload.action, SuggestedZineStore.getList(), SuggestedZineStore.emitChange);
	});

	module.exports = SuggestedZineStore;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var StampStore = __webpack_require__(17);
	var PaginatedStoreUtils = __webpack_require__(28);var createListStore = PaginatedStoreUtils.createListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var TrendingStore = createListStore();

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_TRENDING_STAMPS,
	  error: ActionTypes.REQUEST_TRENDING_STAMPS_ERROR,
	  success: ActionTypes.REQUEST_TRENDING_STAMPS_SUCCESS,
	  preload: ActionTypes.PRELOAD_TRENDING_STAMPS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([StampStore.dispatchToken]);
	  handleListAction(payload.action, TrendingStore.getList(), TrendingStore.emitChange);

	  switch (payload.action.type) {
	    case ActionTypes.FOLLOW_ZINE_SUCCESS:
	    case ActionTypes.UNFOLLOW_ZINE_SUCCESS:
	    case ActionTypes.FOLLOW_USER_SUCCESS:
	    case ActionTypes.UNFOLLOW_USER_SUCCESS:
	    case ActionTypes.INVALIDATE_FEED_WITH_TRENDING:
	      TrendingStore.invalidate();
	      break;
	  }
	});

	module.exports = TrendingStore;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var reject = _require.reject;
	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var ZineStore = __webpack_require__(22);
	var isBestOf2014Special = __webpack_require__(83);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserContributedUnlistedZineStore = createIndexedListStore({
	  getZines: function getZines(userId) {
	    var zines = this.getIds(userId).map(ZineStore.get);
	    return reject(zines, isBestOf2014Special);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES,
	  error: ActionTypes.REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_ERROR,
	  success: ActionTypes.REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (!userId) {
	    return;
	  }

	  handleListAction(action, UserContributedUnlistedZineStore.getList(userId), UserContributedUnlistedZineStore.emitChange);
	});

	module.exports = UserContributedUnlistedZineStore;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var reject = _require.reject;
	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var ZineStore = __webpack_require__(22);
	var isBestOf2014Special = __webpack_require__(83);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserContributedZineStore = createIndexedListStore({
	  getZines: function getZines(userId) {
	    var zines = this.getIds(userId).map(ZineStore.get);
	    return reject(zines, isBestOf2014Special);
	  }
	});

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_CONTRIBUTED_ZINES,
	  error: ActionTypes.REQUEST_USER_CONTRIBUTED_ZINES_ERROR,
	  success: ActionTypes.REQUEST_USER_CONTRIBUTED_ZINES_SUCCESS,
	  preload: ActionTypes.PRELOAD_USER_CONTRIBUTED_ZINES
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (!userId) {
	    return;
	  }

	  handleListAction(action, UserContributedZineStore.getList(userId), UserContributedZineStore.emitChange);
	});

	module.exports = UserContributedZineStore;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var ZineStore = __webpack_require__(22);
	var UserStore = __webpack_require__(5);
	var PaginatedStoreUtils = __webpack_require__(28);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserCuratedUnlistedZineStore = createIndexedListStore({
	  getZines: function getZines(userId) {
	    return this.getIds(userId).map(ZineStore.get);
	  }
	});

	function getList(userId) {
	  return UserCuratedUnlistedZineStore.getList(userId);
	}

	function emitChange() {
	  UserCuratedUnlistedZineStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_CURATED_UNLISTED_ZINES,
	  error: ActionTypes.REQUEST_USER_CURATED_UNLISTED_ZINES_ERROR,
	  success: ActionTypes.REQUEST_USER_CURATED_UNLISTED_ZINES_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([ZineStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.CREATE_ZINE_SUCCESS:
	      getList(UserStore.getMe().id).prepend(action.zineSlug);
	      emitChange();
	      break;
	  }
	});

	module.exports = UserCuratedUnlistedZineStore;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var UserStore = __webpack_require__(5);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserSubscribersStore = createIndexedListStore({
	  getUserSubscribers: function getUserSubscribers(userId) {
	    return this.getIds(userId).map(UserStore.get);
	  }
	});

	function getList(userId) {
	  return UserSubscribersStore.getList(userId);
	}

	function emitChange() {
	  UserSubscribersStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_SUBSCRIBERS,
	  error: ActionTypes.REQUEST_USER_SUBSCRIBERS_ERROR,
	  success: ActionTypes.REQUEST_USER_SUBSCRIBERS_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.FOLLOW_USER_SUCCESS:
	      getList(action.userId).prepend(UserStore.getMe().id);
	      emitChange();
	      break;

	    case ActionTypes.UNFOLLOW_USER_SUCCESS:
	      getList(action.userId).remove(UserStore.getMe().id);
	      emitChange();
	      break;

	    case ActionTypes.INVALIDATE_USER_SUBSCRIBERS:
	      getList(action.userId).invalidate();
	      break;
	  }
	});

	module.exports = UserSubscribersStore;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var PaginatedStoreUtils = __webpack_require__(28);
	var UserStore = __webpack_require__(5);var createIndexedListStore = PaginatedStoreUtils.createIndexedListStore;
	var createListActionHandler = PaginatedStoreUtils.createListActionHandler;

	var UserSubscriptionsStore = createIndexedListStore({
	  getUserSubscriptions: function getUserSubscriptions(userId) {
	    return this.getIds(userId).map(UserStore.get);
	  }
	});

	function getList(userId) {
	  return UserSubscriptionsStore.getList(userId);
	}

	function emitChange() {
	  UserSubscriptionsStore.emitChange();
	}

	var handleListAction = createListActionHandler({
	  request: ActionTypes.REQUEST_USER_SUBSCRIPTIONS,
	  error: ActionTypes.REQUEST_USER_SUBSCRIPTIONS_ERROR,
	  success: ActionTypes.REQUEST_USER_SUBSCRIPTIONS_SUCCESS
	});

	AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      userId = action.userId;

	  if (userId) {
	    handleListAction(action, getList(userId), emitChange);
	  }

	  switch (action.type) {
	    case ActionTypes.FOLLOW_USER_SUCCESS:
	      getList(UserStore.getMe().id).prepend(action.userId);
	      emitChange();
	      break;

	    case ActionTypes.UNFOLLOW_USER_SUCCESS:
	      getList(UserStore.getMe().id).remove(action.userId);
	      emitChange();
	      break;

	    case ActionTypes.INVALIDATE_USER_SUBSCRIPTIONS:
	      getList(action.userId).invalidate();
	      break;
	  }
	});

	module.exports = UserSubscriptionsStore;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _lodashCollectionReject = __webpack_require__(1000);

	var _lodashCollectionReject2 = _interopRequireDefault(_lodashCollectionReject);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _ZineStore = __webpack_require__(22);

	var _ZineStore2 = _interopRequireDefault(_ZineStore);

	var _utilsIsBestOf2014Special = __webpack_require__(83);

	var _utilsIsBestOf2014Special2 = _interopRequireDefault(_utilsIsBestOf2014Special);

	var _utilsPaginatedStoreUtils = __webpack_require__(28);

	'use strict';

	var ZineSectionStore = (0, _utilsPaginatedStoreUtils.createIndexedListStore)({
	  getZines: function getZines(sectionId) {
	    var zines = this.getIds(sectionId).map(_ZineStore2['default'].get);
	    var specialZine = zines.filter(_utilsIsBestOf2014Special2['default'])[0];

	    if (!specialZine) {
	      return zines;
	    } else {
	      return [specialZine].concat((0, _lodashCollectionReject2['default'])(zines, _utilsIsBestOf2014Special2['default']));
	    }
	  }
	});

	var handleListAction = (0, _utilsPaginatedStoreUtils.createListActionHandler)({
	  request: _constantsActionTypes2['default'].REQUEST_ZINES_IN_SECTION,
	  error: _constantsActionTypes2['default'].REQUEST_ZINES_IN_SECTION_ERROR,
	  success: _constantsActionTypes2['default'].REQUEST_ZINES_IN_SECTION_SUCCESS,
	  preload: _constantsActionTypes2['default'].PRELOAD_ZINES_IN_SECTION
	});

	_AppDispatcher2['default'].register(function (payload) {
	  _AppDispatcher2['default'].waitFor([_ZineStore2['default'].dispatchToken]);
	  var sectionId = payload.action.sectionId;

	  if (sectionId) {
	    handleListAction(payload.action, ZineSectionStore.getList(sectionId), ZineSectionStore.emitChange);
	  }
	});

	exports['default'] = ZineSectionStore;
	module.exports = exports['default'];

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(303)['default'];

	var _Promise = __webpack_require__(99)['default'];

	var loadFacebookChunk = __webpack_require__(1049);

	function FacebookDialogError() {}
	FacebookDialogError.prototype = _Object$create(Error.prototype);

	var didInit = false;

	function prepareSDK() {
	  return loadFacebookChunk().then(function (chunk) {
	    var fb = chunk.facebook;
	    if (!didInit) {
	      fb.init({
	        appId: '419123104792477',
	        version: 'v2.0',
	        status: true
	      });
	      didInit = true;
	    }

	    return fb;
	  });
	}

	var FacebookManager = {
	  init: function init() {
	    prepareSDK();
	  },

	  showFacebookSendDialog: function showFacebookSendDialog(invite) {
	    var link = invite.link,
	        userId = invite.serviceId;

	    return prepareSDK().then(function (fb) {
	      return new _Promise(function (resolve, reject) {

	        // Scraping may help Facebook pick up the link: http://stackoverflow.com/a/18217741/458193
	        // No guarantees though.

	        fb.api('https://graph.facebook.com/', 'post', {
	          id: link,
	          scrape: true
	        }, function () {
	          fb.ui({
	            display: 'iframe',
	            to: userId,
	            method: 'send',
	            link: link
	          }, function (response) {
	            if (response && response.success) {
	              resolve();
	            } else {
	              reject(new FacebookDialogError());
	            }
	          });
	        });
	      });
	    });
	  }
	};

	module.exports = FacebookManager;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ReactUpdates = __webpack_require__(63);

	function flushUpdates(action) {
	  ReactUpdates.batchedUpdates(action);
	  ReactUpdates.flushBatchedUpdates();
	}

	module.exports = flushUpdates;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    SectionTypes = __webpack_require__(40);

	var AllowedTypes = [SectionTypes.COVER, SectionTypes.GALLERY, SectionTypes.POSTER];

	function getAllStampImages(stamp) {
	  return _.chain(stamp.content.sections).filter(function (section) {
	    return AllowedTypes.indexOf(section.type) > -1;
	  }).map(function (section) {
	    return section.background || section.images;
	  }).flatten().compact().value();
	}

	module.exports = getAllStampImages;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$keys = __webpack_require__(304)['default'];

	function getQueryUrl(url, params) {
	  params = _Object$keys(params)
	  /* jshint eqnull: true */
	  .filter(function (key) {
	    return params[key] != null;
	  }).map(function (key) {
	    return '' + key + '=' + window.encodeURIComponent(params[key]);
	  }).join('&');

	  if (params) {
	    url += '?' + params;
	  }

	  return url;
	}

	module.exports = getQueryUrl;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var reject = _require.reject;
	var isSectionEmpty = __webpack_require__(446);
	var cloneDeep = __webpack_require__(496);

	function getRefinedStamp(stamp) {
	  if (!stamp) {
	    return null;
	  }

	  stamp = cloneDeep(stamp);
	  stamp.content = {
	    sections: reject(stamp.content.sections, function (section) {
	      return isSectionEmpty(section, true);
	    })
	  };

	  return stamp;
	}

	module.exports = getRefinedStamp;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceTypes = __webpack_require__(35);

	function getServiceAccountUrl(serviceAccount) {
	  if (serviceAccount.url) {
	    return serviceAccount.url;
	  }

	  switch (serviceAccount.serviceType) {
	    case ServiceTypes.FACEBOOK:
	      return 'https://facebook.com/' + serviceAccount.externalId;
	    case ServiceTypes.TWITTER:
	      return 'https://twitter.com/account/redirect_by_id/' + serviceAccount.externalId;
	    case ServiceTypes.GOOGLE:
	      return 'https://plus.google.com/' + serviceAccount.externalId;
	    case ServiceTypes.TUMBLR:
	      return 'https://' + serviceAccount.externalId + '.tumblr.com';
	    case ServiceTypes.INSTAGRAM:
	      return 'https://instagram.com/' + serviceAccount.externalId;
	  }
	}

	module.exports = getServiceAccountUrl;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceTypes = __webpack_require__(35);

	var getServiceName = function getServiceName(serviceType) {
	  switch (serviceType) {
	    case ServiceTypes.FACEBOOK:
	      return 'Facebook';
	    case ServiceTypes.TWITTER:
	      return 'Twitter';
	    case ServiceTypes.GOOGLE:
	      return 'Google';
	    case ServiceTypes.TUMBLR:
	      return 'Tumblr';
	    case ServiceTypes.INSTAGRAM:
	      return 'Instagram';
	  }
	};

	module.exports = getServiceName;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ShareTypes = __webpack_require__(113);

	function getShareServiceTitle(service) {
	  switch (service) {
	    case ShareTypes.FACEBOOK:
	      return 'Facebook';
	    case ShareTypes.TWITTER:
	      return 'Twitter';
	    case ShareTypes.GOOGLE:
	      return 'Google';
	    case ShareTypes.PINTEREST:
	      return 'Pinterest';
	    case ShareTypes.TUMBLR:
	      return 'Tumblr';
	    default:
	      throw new Error('Unknown service: ' + service);
	  }
	}

	module.exports = getShareServiceTitle;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var uniq = _require.uniq;
	var getAllStampImages = __webpack_require__(437);

	function getUniqueStampImages(stamp) {
	  return uniq(getAllStampImages(stamp), function (image) {
	    return image.url;
	  });
	}

	module.exports = getUniqueStampImages;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Keep in sync with zine.py

	var DEFAULT_COVERS = [1, 2, 3, 4, 5].map(function (i) {
	  return '//stampsy-eu-1.s3.amazonaws.com/2014/10/13/patters/' + i + '.svg';
	});

	function getZineCover(zine) {
	  if (zine.coverUrl) {
	    return {
	      isDefault: false,
	      url: zine.coverUrl
	    };
	  }

	  return {
	    isDefault: true,
	    url: DEFAULT_COVERS[zine.id % DEFAULT_COVERS.length || 0]
	  };
	}

	module.exports = getZineCover;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    dangerouslyStripHTML = __webpack_require__(296);

	function isEmptyishHTML(html) {
	  return _.isEmpty(dangerouslyStripHTML(html).trim());
	}

	module.exports = isEmptyishHTML;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var SectionTypes = __webpack_require__(40);
	var isEmptyishHTML = __webpack_require__(445);
	var _require = __webpack_require__(4);

	var isEmpty = _require.isEmpty;
	var isUndefined = _require.isUndefined;

	function isSectionEmpty(section, ignoreCover) {
	  switch (section.type) {
	    case SectionTypes.COVER:
	      return !ignoreCover && isEmpty(section.title) && isEmpty(section.subtitle) && isEmpty(section.background);
	    case SectionTypes.TEXT:
	      return isEmpty(section.text) || isEmptyishHTML(section.text);
	    case SectionTypes.GALLERY:
	      return section.images.length === 0;
	    case SectionTypes.POSTER:
	      return isEmpty(section.background);
	    case SectionTypes.MEDIA:
	      return isEmpty(section.url) || isUndefined(section.background);
	  }
	}

	module.exports = isSectionEmpty;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

	function isValidEmail(email) {
	  return EMAIL_RE.test(email);
	}

	module.exports = isValidEmail;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _lodashArrayZipObject = __webpack_require__(997);

	var _lodashArrayZipObject2 = _interopRequireDefault(_lodashArrayZipObject);

	var _lodashCollectionMap = __webpack_require__(481);

	var _lodashCollectionMap2 = _interopRequireDefault(_lodashCollectionMap);

	var _lodashObjectKeys = __webpack_require__(126);

	var _lodashObjectKeys2 = _interopRequireDefault(_lodashObjectKeys);

	var _lodashObjectValues = __webpack_require__(498);

	var _lodashObjectValues2 = _interopRequireDefault(_lodashObjectValues);

	'use strict';

	function mapKeys(obj, iterator, context) {
	  return (0, _lodashArrayZipObject2['default'])((0, _lodashCollectionMap2['default'])((0, _lodashObjectKeys2['default'])(obj), iterator, context), (0, _lodashObjectValues2['default'])(obj));
	}

	exports['default'] = mapKeys;
	module.exports = exports['default'];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);

	function mapValues(obj, iterator, context) {
	  return _.object(_.keys(obj), _.map(_.values(obj), iterator, context));
	}

	module.exports = mapValues;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(186);

	var camelizeKeys = _require.camelizeKeys;

	function normalizeError(res) {
	  var err = new Error(res.text);
	  err.status = res.status;
	  err.body = res.body && camelizeKeys(res.body);

	  return err;
	}

	module.exports = normalizeError;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var PROTOCOL_RE = /^https?:\/\//;

	function normalizeUrl(url, excludeProtocol) {
	  if (!url) {
	    return url;
	  }

	  if (!PROTOCOL_RE.test(url)) {
	    url = '' + window.location.protocol + '//' + url;
	  }

	  return excludeProtocol ? url.replace(PROTOCOL_RE, '') : url;
	}

	module.exports = normalizeUrl;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var parseHostname = ({"NODE_ENV":"production"}).BROWSER ? function (url) {
	    var testLink = document.createElement('a');
	    testLink.href = url;
	    return testLink.hostname;
	} : function (url) {
	    var urlParser = __webpack_require__(1180);
	    return urlParser.parse(url).hostname;
	};

	module.exports = parseHostname;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function isLeftClickEvent(e) {
	  return e.button === 0;
	}

	function isModifiedEvent(e) {
	  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
	}

	function shouldHandleClick(e) {
	  var target = e.target.getAttribute('target');
	  return !target && !isModifiedEvent(e) && isLeftClickEvent(e);
	}

	module.exports = shouldHandleClick;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function validateRequiredString(string) {
	  string = string || '';

	  if (string.trim().length === 0) {
	    return {
	      error: 'Required'
	    };
	  }
	}

	module.exports = validateRequiredString;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = tokenSource;
	module.exports.empty = tokenSource().token;

	function tokenSource() {
	  var data = {
	    reason: null,
	    isCancelled: false,
	    listeners: []
	  };
	  function cancel(reason) {
	    data.isCancelled = true;
	    reason = reason || 'Operation Cancelled';
	    if (typeof reason == 'string') reason = new Error(reason);
	    reason.code = 'OperationCancelled';
	    data.reason = reason;
	    setTimeout(function () {
	      for (var i = 0; i < data.listeners.length; i++) {
	        if (typeof data.listeners[i] === 'function') {
	          data.listeners[i](reason);
	        }
	      }
	    }, 0);
	  }
	  return {
	    cancel: cancel,
	    token: token(data)
	  };
	}

	function token(data) {
	  var exports = {};
	  exports.isCancelled = isCancelled;
	  function isCancelled() {
	    return data.isCancelled;
	  }
	  exports.throwIfCancelled = throwIfCancelled;
	  function throwIfCancelled() {
	    if (isCancelled()) {
	      throw data.reason;
	    }
	  }
	  exports.onCancelled = onCancelled;
	  function onCancelled(cb) {
	    if (isCancelled()) {
	      setTimeout(function () {
	        cb(data.reason);
	      }, 0);
	    } else {
	      data.listeners.push(cb);
	    }
	  }
	  return exports;
	}


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var $def            = __webpack_require__(184)
	  , $redef          = __webpack_require__(305)
	  , $               = __webpack_require__(25)
	  , cof             = __webpack_require__(183)
	  , $iter           = __webpack_require__(150)
	  , SYMBOL_ITERATOR = __webpack_require__(124)('iterator')
	  , FF_ITERATOR     = '@@iterator'
	  , KEYS            = 'keys'
	  , VALUES          = 'values'
	  , Iterators       = $iter.Iterators;
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE){
	  $iter.create(Constructor, NAME, next);
	  function createMethod(kind){
	    function $$(that){
	      return new Constructor(that, kind);
	    }
	    switch(kind){
	      case KEYS: return function keys(){ return $$(this); };
	      case VALUES: return function values(){ return $$(this); };
	    } return function entries(){ return $$(this); };
	  }
	  var TAG      = NAME + ' Iterator'
	    , proto    = Base.prototype
	    , _native  = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , _default = _native || createMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if(_native){
	    var IteratorPrototype = $.getProto(_default.call(new Base));
	    // Set @@toStringTag to native iterators
	    cof.set(IteratorPrototype, TAG, true);
	    // FF fix
	    if($.FW && $.has(proto, FF_ITERATOR))$iter.set(IteratorPrototype, $.that);
	  }
	  // Define iterator
	  if($.FW || FORCE)$iter.set(proto, _default);
	  // Plug for library
	  Iterators[NAME] = _default;
	  Iterators[TAG]  = $.that;
	  if(DEFAULT){
	    methods = {
	      keys:    IS_SET            ? _default : createMethod(KEYS),
	      values:  DEFAULT == VALUES ? _default : createMethod(VALUES),
	      entries: DEFAULT != VALUES ? _default : createMethod('entries')
	    };
	    if(FORCE)for(key in methods){
	      if(!(key in proto))$redef(proto, key, methods[key]);
	    } else $def($def.P + $def.F * $iter.BUGGY, NAME, methods);
	  }
	};

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var $      = __webpack_require__(25)
	  , SHARED = '__core-js_shared__'
	  , store  = $.g[SHARED] || ($.g[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(25).core
	  , $iter = __webpack_require__(150);
	core.isIterable  = $iter.is;
	core.getIterator = $iter.get;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var $ = __webpack_require__(14);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = $.toObject($this)
	      , length = $.toLength(O.length)
	      , index  = $.toIndex(fromIndex, length)
	      , value;
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $        = __webpack_require__(14)
	  , ctx      = __webpack_require__(125)
	  , safe     = __webpack_require__(87).safe
	  , assert   = __webpack_require__(65)
	  , forOf    = __webpack_require__(185)
	  , step     = __webpack_require__(100).step
	  , $has     = $.has
	  , set      = $.set
	  , isObject = $.isObject
	  , hide     = $.hide
	  , isExtensible = Object.isExtensible || isObject
	  , ID       = safe('id')
	  , O1       = safe('O1')
	  , LAST     = safe('last')
	  , FIRST    = safe('first')
	  , ITER     = safe('iter')
	  , SIZE     = $.DESC ? safe('size') : 'size'
	  , id       = 0;

	function fastKey(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	}

	function getEntry(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that[O1][index];
	  // frozen object case
	  for(entry = that[FIRST]; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	}

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      assert.inst(that, C, NAME);
	      set(that, O1, $.create(null));
	      set(that, SIZE, 0);
	      set(that, LAST, undefined);
	      set(that, FIRST, undefined);
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    __webpack_require__(230)(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that[O1], entry = that[FIRST]; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that[FIRST] = that[LAST] = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that[O1][entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that[FIRST] == entry)that[FIRST] = next;
	          if(that[LAST] == entry)that[LAST] = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments[1], 3)
	          , entry;
	        while(entry = entry ? entry.n : this[FIRST]){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if($.DESC)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return assert.def(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that[LAST] = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that[LAST],          // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that[FIRST])that[FIRST] = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that[O1][index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  // add .keys, .values, .entries, [@@iterator]
	  // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	  setIter: function(C, NAME, IS_MAP){
	    __webpack_require__(308)(C, NAME, function(iterated, kind){
	      set(this, ITER, {o: iterated, k: kind});
	    }, function(){
	      var iter  = this[ITER]
	        , kind  = iter.k
	        , entry = iter.l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!iter.o || !(iter.l = entry = entry ? entry.n : iter.o[FIRST])){
	        // or finish the iteration
	        iter.o = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	  }
	};

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $def  = __webpack_require__(23)
	  , forOf = __webpack_require__(185);
	module.exports = function(NAME){
	  $def($def.P, NAME, {
	    toJSON: function toJSON(){
	      var arr = [];
	      forOf(this, false, arr.push, arr);
	      return arr;
	    }
	  });
	};

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $         = __webpack_require__(14)
	  , safe      = __webpack_require__(87).safe
	  , assert    = __webpack_require__(65)
	  , forOf     = __webpack_require__(185)
	  , $has      = $.has
	  , isObject  = $.isObject
	  , hide      = $.hide
	  , isExtensible = Object.isExtensible || isObject
	  , id        = 0
	  , ID        = safe('id')
	  , WEAK      = safe('weak')
	  , LEAK      = safe('leak')
	  , method    = __webpack_require__(227)
	  , find      = method(5)
	  , findIndex = method(6);
	function findFrozen(store, key){
	  return find(store.array, function(it){
	    return it[0] === key;
	  });
	}
	// fallback for frozen keys
	function leakStore(that){
	  return that[LEAK] || hide(that, LEAK, {
	    array: [],
	    get: function(key){
	      var entry = findFrozen(this, key);
	      if(entry)return entry[1];
	    },
	    has: function(key){
	      return !!findFrozen(this, key);
	    },
	    set: function(key, value){
	      var entry = findFrozen(this, key);
	      if(entry)entry[1] = value;
	      else this.array.push([key, value]);
	    },
	    'delete': function(key){
	      var index = findIndex(this.array, function(it){
	        return it[0] === key;
	      });
	      if(~index)this.array.splice(index, 1);
	      return !!~index;
	    }
	  })[LEAK];
	}

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      $.set(assert.inst(that, C, NAME), ID, id++);
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    __webpack_require__(230)(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return leakStore(this)['delete'](key);
	        return $has(key, WEAK) && $has(key[WEAK], this[ID]) && delete key[WEAK][this[ID]];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return leakStore(this).has(key);
	        return $has(key, WEAK) && $has(key[WEAK], this[ID]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    if(!isExtensible(assert.obj(key))){
	      leakStore(that).set(key, value);
	    } else {
	      $has(key, WEAK) || hide(key, WEAK, {});
	      key[WEAK][that[ID]] = value;
	    } return that;
	  },
	  leakStore: leakStore,
	  WEAK: WEAK,
	  ID: ID
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(14)
	  , document = $.g.document
	  , isObject = $.isObject
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(14);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getDesc    = $.getDesc
	    , getSymbols = $.getSymbols;
	  if(getSymbols)$.each.call(getSymbols(it), function(key){
	    if(getDesc(it, key).enumerable)keys.push(key);
	  });
	  return keys;
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var $ = __webpack_require__(14)
	  , toString = {}.toString
	  , getNames = $.getNames;

	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	function getWindowNames(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	}

	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames($.toObject(it));
	};

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var assertObject = __webpack_require__(65).obj;
	function close(iterator){
	  var ret = iterator['return'];
	  if(ret !== undefined)assertObject(ret.call(iterator));
	}
	function call(iterator, fn, value, entries){
	  try {
	    return entries ? fn(assertObject(value)[0], value[1]) : fn(value);
	  } catch(e){
	    close(iterator);
	    throw e;
	  }
	}
	call.close = close;
	module.exports = call;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var $            = __webpack_require__(14)
	  , assertObject = __webpack_require__(65).obj;
	module.exports = function ownKeys(it){
	  assertObject(it);
	  var keys       = $.getNames(it)
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	// http://wiki.ecmascript.org/doku.php?id=strawman:string_padding
	var $      = __webpack_require__(14)
	  , repeat = __webpack_require__(470);

	module.exports = function(that, minLength, fillChar, left){
	  // 1. Let O be CheckObjectCoercible(this value).
	  // 2. Let S be ToString(O).
	  var S = String($.assertDefined(that));
	  // 4. If intMinLength is undefined, return S.
	  if(minLength === undefined)return S;
	  // 4. Let intMinLength be ToInteger(minLength).
	  var intMinLength = $.toInteger(minLength);
	  // 5. Let fillLen be the number of characters in S minus intMinLength.
	  var fillLen = intMinLength - S.length;
	  // 6. If fillLen < 0, then throw a RangeError exception.
	  // 7. If fillLen is +∞, then throw a RangeError exception.
	  if(fillLen < 0 || fillLen === Infinity){
	    throw new RangeError('Cannot satisfy string length ' + minLength + ' for string: ' + S);
	  }
	  // 8. Let sFillStr be the string represented by fillStr.
	  // 9. If sFillStr is undefined, let sFillStr be a space character.
	  var sFillStr = fillChar === undefined ? ' ' : String(fillChar);
	  // 10. Let sFillVal be a String made of sFillStr, repeated until fillLen is met.
	  var sFillVal = repeat.call(sFillStr, Math.ceil(fillLen / sFillStr.length));
	  // truncate if we overflowed
	  if(sFillVal.length > fillLen)sFillVal = left
	    ? sFillVal.slice(sFillVal.length - fillLen)
	    : sFillVal.slice(0, fillLen);
	  // 11. Return a string made from sFillVal, followed by S.
	  // 11. Return a String made from S, followed by sFillVal.
	  return left ? sFillVal.concat(S) : S.concat(sFillVal);
	};

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(14);

	module.exports = function repeat(count){
	  var str = String($.assertDefined(this))
	    , res = ''
	    , n   = $.toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $      = __webpack_require__(14)
	  , ctx    = __webpack_require__(125)
	  , cof    = __webpack_require__(72)
	  , invoke = __webpack_require__(229)
	  , cel    = __webpack_require__(463)
	  , global             = $.g
	  , isFunction         = $.isFunction
	  , html               = $.html
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	function run(){
	  var id = +this;
	  if($.has(queue, id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	}
	function listner(event){
	  run.call(event.data);
	}
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!isFunction(setTask) || !isFunction(clearTask)){
	  setTask = function(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(isFunction(fn) ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(cof(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Modern browsers, skip implementation for WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is object
	  } else if(global.addEventListener && isFunction(global.postMessage) && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id, '*');
	    };
	    global.addEventListener('message', listner, false);
	  // WebWorkers
	  } else if(isFunction(MessageChannel)){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(14)
	  , setUnscope = __webpack_require__(151)
	  , ITER       = __webpack_require__(87).safe('iter')
	  , $iter      = __webpack_require__(100)
	  , step       = $iter.step
	  , Iterators  = $iter.Iterators;

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	__webpack_require__(308)(Array, 'Array', function(iterated, kind){
	  $.set(this, ITER, {o: $.toObject(iterated), i: 0, k: kind});
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var iter  = this[ITER]
	    , O     = iter.o
	    , kind  = iter.k
	    , index = iter.i++;
	  if(!O || index >= O.length){
	    iter.o = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	setUnscope('keys');
	setUnscope('values');
	setUnscope('entries');

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */

	module.exports.Dispatcher = __webpack_require__(990)


/***/ },
/* 480 */,
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(483),
	    baseCallback = __webpack_require__(152),
	    baseMap = __webpack_require__(1016),
	    isArray = __webpack_require__(102);

	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments; (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as interatees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`, `drop`,
	 * `dropRight`, `fill`, `flatten`, `invert`, `max`, `min`, `parseInt`, `slice`,
	 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimLeft`, `trimRight`,
	 * `trunc`, `random`, `range`, `sample`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 *  create a `_.property` or `_.matches` style callback respectively.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}

	module.exports = map;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	module.exports = arrayCopy;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	module.exports = arrayMap;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copies the properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Array} props The property names to copy.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, object, props) {
	  if (!props) {
	    props = object;
	    object = {};
	  }
	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}

	module.exports = baseCopy;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(488),
	    cacheIndexOf = __webpack_require__(492),
	    createCache = __webpack_require__(493);

	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];

	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= 200) ? createCache(values) : null,
	      valuesLength = values.length;

	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];

	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}

	module.exports = baseDifference;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(349),
	    isLength = __webpack_require__(88),
	    toObject = __webpack_require__(189);

	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	function baseEach(collection, iteratee) {
	  var length = collection ? collection.length : 0;
	  if (!isLength(length)) {
	    return baseForOwn(collection, iteratee);
	  }
	  var index = -1,
	      iterable = toObject(collection);

	  while (++index < length) {
	    if (iteratee(iterable[index], index, iterable) === false) {
	      break;
	    }
	  }
	  return collection;
	}

	module.exports = baseEach;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(351),
	    isArray = __webpack_require__(102),
	    isLength = __webpack_require__(88),
	    isObjectLike = __webpack_require__(188);

	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays and `arguments` objects.
	 * @param {number} [fromIndex=0] The index to start from.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, fromIndex) {
	  var index = (fromIndex || 0) - 1,
	      length = array.length,
	      resIndex = -1,
	      result = [];

	  while (++index < length) {
	    var value = array[index];

	    if (isObjectLike(value) && isLength(value.length) && (isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        value = baseFlatten(value, isDeep, isStrict);
	      }
	      var valIndex = -1,
	          valLength = value.length;

	      result.length += valLength;
	      while (++valIndex < valLength) {
	        result[++resIndex] = value[valIndex];
	      }
	    } else if (!isStrict) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}

	module.exports = baseFlatten;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(1029);

	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = (fromIndex || 0) - 1,
	      length = array.length;

	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}

	module.exports = baseIndexOf;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1013);

	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isWhere, stackA, stackB) {
	  // Exit early for identical values.
	  if (value === other) {
	    // Treat `+0` vs. `-0` as not equal.
	    return value !== 0 || (1 / value == 1 / other);
	  }
	  var valType = typeof value,
	      othType = typeof other;

	  // Exit early for unlike primitive values.
	  if ((valType != 'function' && valType != 'object' && othType != 'function' && othType != 'object') ||
	      value == null || other == null) {
	    // Return `false` unless both values are `NaN`.
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isWhere, stackA, stackB);
	}

	module.exports = baseIsEqual;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The base implementation of `_.property` which does not coerce `key` to a string.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	module.exports = baseProperty;


/***/ },
/* 491 */,
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);

	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

	  return result ? 0 : -1;
	}

	module.exports = cacheIndexOf;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(1001),
	    constant = __webpack_require__(499),
	    isNative = __webpack_require__(103);

	/** Native method references. */
	var Set = isNative(Set = global.Set) && Set;

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;

	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
	  return new SetCache(values);
	};

	module.exports = createCache;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 494 */,
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && (value === 0 ? ((1 / value) > 0) : !isObject(value));
	}

	module.exports = isStrictComparable;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1006),
	    bindCallback = __webpack_require__(187);

	/**
	 * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	 * to produce the cloned values. If `customizer` returns `undefined` cloning
	 * is handled by the method instead. The `customizer` is bound to `thisArg`
	 * and invoked with two argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the structured clone algorithm.
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps. See the [HTML5 specification](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var deep = _.cloneDeep(users);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.cloneDeep(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 20
	 */
	function cloneDeep(value, customizer, thisArg) {
	  customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
	  return baseClone(value, true, customizer);
	}

	module.exports = cloneDeep;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var baseIsFunction = __webpack_require__(1014),
	    isNative = __webpack_require__(103);

	/** `Object#toString` result references. */
	var funcTag = '[object Function]';

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/** Native method references. */
	var Uint8Array = isNative(Uint8Array = global.Uint8Array) && Uint8Array;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return objToString.call(value) == funcTag;
	};

	module.exports = isFunction;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1022),
	    keys = __webpack_require__(126);

	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return baseValues(object, keys(object));
	}

	module.exports = values;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	module.exports = constant;


/***/ },
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	function Cancellation() {}

	module.exports = Cancellation;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * Encapsulates a redirect to the given route.
	 */
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}

	module.exports = Redirect;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var LocationActions = __webpack_require__(190);

	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {

	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }

	};

	module.exports = ImitateBrowserBehavior;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var PropTypes = __webpack_require__(105);
	var RouteHandler = __webpack_require__(236);
	var Route = __webpack_require__(235);

	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */

	var DefaultRoute = (function (_Route) {
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);

	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }

	  _inherits(DefaultRoute, _Route);

	  return DefaultRoute;
	})(Route);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};

	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};

	module.exports = DefaultRoute;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var PropTypes = __webpack_require__(105);
	var RouteHandler = __webpack_require__(236);
	var Route = __webpack_require__(235);

	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */

	var NotFoundRoute = (function (_Route) {
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);

	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }

	  _inherits(NotFoundRoute, _Route);

	  return NotFoundRoute;
	})(Route);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};

	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};

	module.exports = NotFoundRoute;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var PropTypes = __webpack_require__(105);
	var Route = __webpack_require__(235);

	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */

	var Redirect = (function (_Route) {
	  function Redirect() {
	    _classCallCheck(this, Redirect);

	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }

	  _inherits(Redirect, _Route);

	  return Redirect;
	})(Route);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};

	// Redirects should not have a default handler
	Redirect.defaultProps = {};

	module.exports = Redirect;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/* jshint -W058 */
	var React = __webpack_require__(1);
	var warning = __webpack_require__(26);
	var invariant = __webpack_require__(11);
	var canUseDOM = __webpack_require__(42).canUseDOM;
	var LocationActions = __webpack_require__(190);
	var ImitateBrowserBehavior = __webpack_require__(509);
	var HashLocation = __webpack_require__(515);
	var HistoryLocation = __webpack_require__(361);
	var RefreshLocation = __webpack_require__(516);
	var StaticLocation = __webpack_require__(517);
	var ScrollHistory = __webpack_require__(1077);
	var createRoutesFromReactChildren = __webpack_require__(514);
	var isReactChildren = __webpack_require__(1084);
	var Transition = __webpack_require__(1079);
	var PropTypes = __webpack_require__(105);
	var Redirect = __webpack_require__(508);
	var History = __webpack_require__(153);
	var Cancellation = __webpack_require__(507);
	var Match = __webpack_require__(1075);
	var Route = __webpack_require__(138);
	var supportsHistory = __webpack_require__(1087);
	var PathUtils = __webpack_require__(360);

	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : "/";

	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;

	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) {
	    return false;
	  }return true;
	}

	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;

	    var paramNames = route.paramNames;
	    var paramName;

	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];

	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }

	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}

	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];

	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, "You may not have more than one route named \"%s\"", route.name);

	      namedRoutes[route.name] = route;
	    }

	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}

	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}

	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) {
	    return false;
	  }return true;
	}

	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) {
	    return false;
	  }return true;
	}

	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};

	  if (isReactChildren(options)) options = { routes: options };

	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;

	  if (typeof location === "string") location = new StaticLocation(location);

	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ("production") === "test", "You should not use a static location in a DOM environment because " + "the router will not be kept in sync with the current URL");
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, "You cannot use %s without a DOM", location);
	  }

	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;

	  var Router = React.createClass({

	    displayName: "Router",

	    statics: {

	      isRunning: false,

	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },

	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },

	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);

	        addRoutesToNamedRoutes(routes, Router.namedRoutes);

	        Router.routes.push.apply(Router.routes, routes);
	      },

	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },

	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },

	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];

	          invariant(route instanceof Route, "Cannot find a route named \"%s\"", to);

	          path = route.path;
	        }

	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },

	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? "#" + path : path;
	      },

	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);

	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },

	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },

	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }

	        warning(false, "goBack() was ignored because there is no router history");

	        return false;
	      },

	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error("Unhandled aborted transition! Reason: " + abortReason);

	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },

	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },

	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },

	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();

	        var prevPath = state.path;
	        var isRefreshing = action == null;

	        if (prevPath === path && !isRefreshing) {
	          return;
	        } // Nothing to do!

	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);

	        var match = Router.match(path);

	        warning(match != null, "No route matches path \"%s\". Make sure you have <Route path=\"%s\"> somewhere in your routes", path, path);

	        if (match == null) match = {};

	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};

	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};

	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });

	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }

	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;

	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);

	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.

	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },

	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, "Router is already running");

	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);

	          if (pendingTransition !== transition) return;

	          pendingTransition = null;

	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };

	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);

	          Router.isRunning = true;
	        }

	        // Bootstrap using the current path.
	        Router.refresh();
	      },

	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },

	      stop: function stop() {
	        Router.cancelPendingTransition();

	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);

	        Router.isRunning = false;
	      },

	      getLocation: function getLocation() {
	        return location;
	      },

	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },

	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },

	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },

	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },

	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },

	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },

	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },

	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },

	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) {
	          return to === state.path;
	        }return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }

	    },

	    mixins: [ScrollHistory],

	    propTypes: {
	      children: PropTypes.falsy
	    },

	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },

	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },

	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },

	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },

	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },

	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }

	  });

	  Router.clearAllRoutes();

	  if (options.routes) Router.addRoutes(options.routes);

	  return Router;
	}

	module.exports = createRouter;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/* jshint -W084 */
	var React = __webpack_require__(1);
	var assign = __webpack_require__(15);
	var warning = __webpack_require__(26);
	var DefaultRoute = __webpack_require__(510);
	var NotFoundRoute = __webpack_require__(511);
	var Redirect = __webpack_require__(512);
	var Route = __webpack_require__(138);

	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || "UnknownComponent";

	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);

	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}

	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;

	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }

	  return options;
	}

	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) {
	    return;
	  }var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);

	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);

	  if (type === DefaultRoute) {
	    return Route.createDefaultRoute(createRouteOptions(props));
	  }if (type === NotFoundRoute) {
	    return Route.createNotFoundRoute(createRouteOptions(props));
	  }if (type === Redirect) {
	    return Route.createRedirect(createRouteOptions(props));
	  }return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}

	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];

	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });

	  return routes;
	}

	module.exports = createRoutesFromReactChildren;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var LocationActions = __webpack_require__(190);
	var History = __webpack_require__(153);

	var _listeners = [];
	var _isListening = false;
	var _actionType;

	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;

	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };

	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}

	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();

	  if (path.charAt(0) === "/") {
	    return true;
	  }HashLocation.replace("/" + path);

	  return false;
	}

	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}

	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {

	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);

	    // Do this BEFORE listening for hashchange.
	    ensureSlash();

	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener("hashchange", onHashChange, false);
	      } else {
	        window.attachEvent("onhashchange", onHashChange);
	      }

	      _isListening = true;
	    }
	  },

	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });

	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener("hashchange", onHashChange, false);
	      } else {
	        window.removeEvent("onhashchange", onHashChange);
	      }

	      _isListening = false;
	    }
	  },

	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },

	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + "#" + path);
	  },

	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },

	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split("#")[1] || "");
	  },

	  toString: function toString() {
	    return "<HashLocation>";
	  }

	};

	module.exports = HashLocation;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var HistoryLocation = __webpack_require__(361);
	var History = __webpack_require__(153);

	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {

	  push: function push(path) {
	    window.location = path;
	  },

	  replace: function replace(path) {
	    window.location.replace(path);
	  },

	  pop: History.back,

	  getCurrentPath: HistoryLocation.getCurrentPath,

	  toString: function toString() {
	    return "<RefreshLocation>";
	  }

	};

	module.exports = RefreshLocation;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var invariant = __webpack_require__(11);

	function throwCannotModify() {
	  invariant(false, "You cannot modify a static location");
	}

	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */

	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);

	    this.path = path;
	  }

	  _createClass(StaticLocation, {
	    getCurrentPath: {
	      value: function getCurrentPath() {
	        return this.path;
	      }
	    },
	    toString: {
	      value: function toString() {
	        return "<StaticLocation path=\"" + this.path + "\">";
	      }
	    }
	  });

	  return StaticLocation;
	})();

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;

	module.exports = StaticLocation;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules


	// Declare internals

	var internals = {};


	exports.arrayToObject = function (source) {

	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {

	            obj[i] = source[i];
	        }
	    }

	    return obj;
	};


	exports.merge = function (target, source) {

	    if (!source) {
	        return target;
	    }

	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }

	        return target;
	    }

	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }

	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {

	        target = exports.arrayToObject(target);
	    }

	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];

	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }

	    return target;
	};


	exports.decode = function (str) {

	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};


	exports.compact = function (obj, refs) {

	    if (typeof obj !== 'object' ||
	        obj === null) {

	        return obj;
	    }

	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }

	    refs.push(obj);

	    if (Array.isArray(obj)) {
	        var compacted = [];

	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }

	        return compacted;
	    }

	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }

	    return obj;
	};


	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};


	exports.isBuffer = function (obj) {

	    if (obj === null ||
	        typeof obj === 'undefined') {

	        return false;
	    }

	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    invariant = __webpack_require__(11),
	    shallowEqual = __webpack_require__(46);

	function createSideEffect(onChange, mixin) {
	  invariant(
	    typeof onChange === 'function',
	    'onChange(propsList) is a required argument.'
	  );

	  var mountedInstances = [];

	  function emitChange() {
	    onChange(mountedInstances.map(function (instance) {
	      return instance.props;
	    }));
	  }

	  return React.createClass({
	    mixins: [mixin],

	    statics: {
	      dispose: function () {
	        mountedInstances = [];
	        emitChange();
	      }
	    },

	    shouldComponentUpdate: function (nextProps) {
	      return !shallowEqual(nextProps, this.props);
	    },

	    componentWillMount: function () {
	      mountedInstances.push(this);
	      emitChange();
	    },

	    componentDidUpdate: function () {
	      emitChange();
	    },

	    componentWillUnmount: function () {
	      var index = mountedInstances.indexOf(this);
	      mountedInstances.splice(index, 1);
	      emitChange();
	    },

	    render: function () {
	      if (this.props.children) {
	        return React.Children.only(this.props.children);
	      } else {
	        return null;
	      }
	    }
	  });
	}

	module.exports = createSideEffect;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */

	var invariant = __webpack_require__(11);

	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */

	var CSSCore = {

	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function(element, className) {
	    (false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.addClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));

	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },

	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function(element, className) {
	    (false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.removeClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));

	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className
	          .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
	          .replace(/\s+/g, ' ') // multiple spaces to one
	          .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },

	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },

	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function(element, className) {
	    (false ? invariant(
	      !/\s/.test(className),
	      'CSS.hasClass takes only a single class name.'
	    ) : invariant(!/\s/.test(className)));
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }

	};

	module.exports = CSSCore;


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */

	'use strict';

	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,

	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};

	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}

	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function(prop) {
	  prefixes.forEach(function(prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});

	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundImage: true,
	    backgroundPosition: true,
	    backgroundRepeat: true,
	    backgroundColor: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  }
	};

	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};

	module.exports = CSSProperty;


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */

	'use strict';

	var CSSProperty = __webpack_require__(521);
	var ExecutionEnvironment = __webpack_require__(42);

	var camelizeStyleName = __webpack_require__(1155);
	var dangerousStyleValue = __webpack_require__(1159);
	var hyphenateStyleName = __webpack_require__(1165);
	var memoizeStringOnly = __webpack_require__(1169);
	var warning = __webpack_require__(26);

	var processStyleName = memoizeStringOnly(function(styleName) {
	  return hyphenateStyleName(styleName);
	});

	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}

	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;

	  var warnedStyleNames = {};
	  var warnedStyleValues = {};

	  var warnHyphenatedStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }

	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported style property %s. Did you mean %s?',
	      name,
	      camelizeStyleName(name)
	    ) : null);
	  };

	  var warnBadVendoredStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }

	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported vendor-prefixed style property %s. Did you mean %s?',
	      name,
	      name.charAt(0).toUpperCase() + name.slice(1)
	    ) : null);
	  };

	  var warnStyleValueWithSemicolon = function(name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }

	    warnedStyleValues[value] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Style property values shouldn\'t contain a semicolon. ' +
	      'Try "%s: %s" instead.',
	      name,
	      value.replace(badStyleValueWithSemicolonPattern, '')
	    ) : null);
	  };

	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function(name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}

	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {

	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function(styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },

	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function(node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }

	};

	module.exports = CSSPropertyOperations;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;

	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};

	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    (false ? invariant(
	      pluginIndex > -1,
	      'EventPluginRegistry: Cannot inject event plugins that do not exist in ' +
	      'the plugin ordering, `%s`.',
	      pluginName
	    ) : invariant(pluginIndex > -1));
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    (false ? invariant(
	      PluginModule.extractEvents,
	      'EventPluginRegistry: Event plugins must implement an `extractEvents` ' +
	      'method, but `%s` does not.',
	      pluginName
	    ) : invariant(PluginModule.extractEvents));
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      (false ? invariant(
	        publishEventForPlugin(
	          publishedEvents[eventName],
	          PluginModule,
	          eventName
	        ),
	        'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.',
	        eventName,
	        pluginName
	      ) : invariant(publishEventForPlugin(
	        publishedEvents[eventName],
	        PluginModule,
	        eventName
	      )));
	    }
	  }
	}

	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  (false ? invariant(
	    !EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName),
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'event name, `%s`.',
	    eventName
	  ) : invariant(!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName)));
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(
	          phasedRegistrationName,
	          PluginModule,
	          eventName
	        );
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(
	      dispatchConfig.registrationName,
	      PluginModule,
	      eventName
	    );
	    return true;
	  }
	  return false;
	}

	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  (false ? invariant(
	    !EventPluginRegistry.registrationNameModules[registrationName],
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'registration name, `%s`.',
	    registrationName
	  ) : invariant(!EventPluginRegistry.registrationNameModules[registrationName]));
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] =
	    PluginModule.eventTypes[eventName].dependencies;
	}

	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {

	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],

	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},

	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},

	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},

	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function(InjectedEventPluginOrder) {
	    (false ? invariant(
	      !EventPluginOrder,
	      'EventPluginRegistry: Cannot inject event plugin ordering more than ' +
	      'once. You are likely trying to load more than one copy of React.'
	    ) : invariant(!EventPluginOrder));
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },

	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) ||
	          namesToPlugins[pluginName] !== PluginModule) {
	        (false ? invariant(
	          !namesToPlugins[pluginName],
	          'EventPluginRegistry: Cannot inject two different event plugins ' +
	          'using the same name, `%s`.',
	          pluginName
	        ) : invariant(!namesToPlugins[pluginName]));
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },

	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[
	        dispatchConfig.registrationName
	      ] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[
	        dispatchConfig.phasedRegistrationNames[phase]
	      ];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function() {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;

	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }

	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }

	};

	module.exports = EventPluginRegistry;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */

	'use strict';

	var ReactUpdateQueue = __webpack_require__(375);

	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context) {
	  this.props = props;
	  this.context = context;
	}

	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function(partialState, callback) {
	  (false ? invariant(
	    typeof partialState === 'object' ||
	    typeof partialState === 'function' ||
	    partialState == null,
	    'setState(...): takes an object of state variables to update or a ' +
	    'function which returns an object of state variables.'
	  ) : invariant(typeof partialState === 'object' ||
	  typeof partialState === 'function' ||
	  partialState == null));
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      partialState != null,
	      'setState(...): You passed an undefined or null state object; ' +
	      'instead, use forceUpdate().'
	    ) : null);
	  }
	  ReactUpdateQueue.enqueueSetState(this, partialState);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};

	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function(callback) {
	  ReactUpdateQueue.enqueueForceUpdate(this);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};

	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: 'getDOMNode',
	    isMounted: 'isMounted',
	    replaceProps: 'replaceProps',
	    replaceState: 'replaceState',
	    setProps: 'setProps'
	  };
	  var defineDeprecationWarning = function(methodName, displayName) {
	    try {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function() {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            '%s(...) is deprecated in plain JavaScript React classes.',
	            displayName
	          ) : null);
	          return undefined;
	        }
	      });
	    } catch (x) {
	      // IE will fail on defineProperty (es5-shim/sham too)
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}

	module.exports = ReactComponent;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactComponentWithPureRenderMixin
	*/

	'use strict';

	var shallowEqual = __webpack_require__(46);

	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	           !shallowEqual(this.state, nextState);
	  }
	};

	module.exports = ReactComponentWithPureRenderMixin;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */

	/*jslint evil: true */

	'use strict';

	var CSSPropertyOperations = __webpack_require__(522);
	var DOMChildrenOperations = __webpack_require__(1100);
	var DOMPropertyOperations = __webpack_require__(191);
	var ReactMount = __webpack_require__(109);
	var ReactPerf = __webpack_require__(141);

	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(383);

	/**
	 * Errors for properties that should not be updated with `updatePropertyById()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML:
	    '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};

	/**
	 * Operations used to process updates to DOM nodes. This is made injectable via
	 * `ReactDOMComponent.BackendIDOperations`.
	 */
	var ReactDOMIDOperations = {

	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    (false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));

	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },

	  /**
	   * Updates a DOM node to remove a property. This should only be used to remove
	   * DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A property name to remove, see `DOMProperty`.
	   * @internal
	   */
	  deletePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    (false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	    DOMPropertyOperations.deleteValueForProperty(node, name, value);
	  },

	  /**
	   * Updates a DOM node with new style values. If a value is specified as '',
	   * the corresponding style property will be unset.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {object} styles Mapping from styles to values.
	   * @internal
	   */
	  updateStylesByID: function(id, styles) {
	    var node = ReactMount.getNode(id);
	    CSSPropertyOperations.setValueForStyles(node, styles);
	  },

	  /**
	   * Updates a DOM node's innerHTML.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} html An HTML string.
	   * @internal
	   */
	  updateInnerHTMLByID: function(id, html) {
	    var node = ReactMount.getNode(id);
	    setInnerHTML(node, html);
	  },

	  /**
	   * Updates a DOM node's text content set by `props.content`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} content Text content.
	   * @internal
	   */
	  updateTextContentByID: function(id, content) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.updateTextContent(node, content);
	  },

	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function(id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },

	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function(updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};

	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  updatePropertyByID: 'updatePropertyByID',
	  deletePropertyByID: 'deletePropertyByID',
	  updateStylesByID: 'updateStylesByID',
	  updateInnerHTMLByID: 'updateInnerHTMLByID',
	  updateTextContentByID: 'updateTextContentByID',
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});

	module.exports = ReactDOMIDOperations;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */

	'use strict';

	var DOMPropertyOperations = __webpack_require__(191);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(367);
	var ReactDOMComponent = __webpack_require__(370);

	var assign = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(194);

	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function(props) {
	  // This constructor and its argument is currently used by mocks.
	};

	assign(ReactDOMTextComponent.prototype, {

	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function(text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;

	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },

	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    var escapedText = escapeTextContentForBrowser(this._stringText);

	    if (transaction.renderToStaticMarkup) {
	      // Normally we'd wrap this in a `span` for the reasons stated above, but
	      // since this is a situation where React won't take over (static pages),
	      // we can simply return the text as it is.
	      return escapedText;
	    }

	    return (
	      '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' +
	        escapedText +
	      '</span>'
	    );
	  },

	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        ReactDOMComponent.BackendIDOperations.updateTextContentByID(
	          this._rootNodeID,
	          nextStringText
	        );
	      }
	    }
	  },

	  unmountComponent: function() {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }

	});

	module.exports = ReactDOMTextComponent;


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */

	'use strict';

	var ReactDOMSelection = __webpack_require__(1121);

	var containsNode = __webpack_require__(534);
	var focusNode = __webpack_require__(536);
	var getActiveElement = __webpack_require__(537);

	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}

	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {

	  hasSelectionCapabilities: function(elem) {
	    return elem && (
	      ((elem.nodeName === 'INPUT' && elem.type === 'text') ||
	      elem.nodeName === 'TEXTAREA' || elem.contentEditable === 'true')
	    );
	  },

	  getSelectionInformation: function() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange:
	          ReactInputSelection.hasSelectionCapabilities(focusedElem) ?
	          ReactInputSelection.getSelection(focusedElem) :
	          null
	    };
	  },

	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem &&
	        isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(
	          priorFocusedElem,
	          priorSelectionRange
	        );
	      }
	      focusNode(priorFocusedElem);
	    }
	  },

	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function(input) {
	    var selection;

	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }

	    return selection || {start: 0, end: 0};
	  },

	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }

	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};

	module.exports = ReactInputSelection;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */

	'use strict';

	var adler32 = __webpack_require__(1153);

	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',

	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function(markup) {
	    var checksum = adler32(markup);
	    return markup.replace(
	      '>',
	      ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '">'
	    );
	  },

	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function(markup, element) {
	    var existingChecksum = element.getAttribute(
	      ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	    );
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};

	module.exports = ReactMarkupChecksum;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */

	'use strict';

	var keyMirror = __webpack_require__(24);

	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  TEXT_CONTENT: null
	});

	module.exports = ReactMultiChildUpdateTypes;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactFragment = __webpack_require__(158);
	var ReactPropTypeLocationNames = __webpack_require__(239);

	var emptyFunction = __webpack_require__(89);

	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */

	var ANONYMOUS = '<<anonymous>>';

	var elementTypeChecker = createElementTypeChecker();
	var nodeTypeChecker = createNodeChecker();

	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),

	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: elementTypeChecker,
	  instanceOf: createInstanceTypeChecker,
	  node: nodeTypeChecker,
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};

	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error(
	          ("Required " + locationName + " `" + propName + "` was not specified in ") +
	          ("`" + componentName + "`.")
	        );
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }

	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);

	  return chainedCheckType;
	}

	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);

	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + preciseType + "` ") +
	        ("supplied to `" + componentName + "`, expected `" + expectedType + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}

	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an array.")
	      );
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactElement.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected instance of `" + expectedClassName + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createEnumTypeChecker(expectedValues) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }

	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` of value `" + propValue + "` ") +
	      ("supplied to `" + componentName + "`, expected one of " + valuesString + ".")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}

	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an object.")
	      );
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  function validate(props, propName, componentName, location) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location) == null) {
	        return null;
	      }
	    }

	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	      ("`" + componentName + "`.")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}

	function createNodeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactNode.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `object`.")
	      );
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}

	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	      propValue = ReactFragment.extractIfFragment(propValue);
	      for (var k in propValue) {
	        if (!isNode(propValue[k])) {
	          return false;
	        }
	      }
	      return true;
	    default:
	      return false;
	  }
	}

	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}

	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}

	module.exports = ReactPropTypes;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPutListenerQueue
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);
	var ReactBrowserEventEmitter = __webpack_require__(140);

	var assign = __webpack_require__(15);

	function ReactPutListenerQueue() {
	  this.listenersToPut = [];
	}

	assign(ReactPutListenerQueue.prototype, {
	  enqueuePutListener: function(rootNodeID, propKey, propValue) {
	    this.listenersToPut.push({
	      rootNodeID: rootNodeID,
	      propKey: propKey,
	      propValue: propValue
	    });
	  },

	  putListeners: function() {
	    for (var i = 0; i < this.listenersToPut.length; i++) {
	      var listenerToPut = this.listenersToPut[i];
	      ReactBrowserEventEmitter.putListener(
	        listenerToPut.rootNodeID,
	        listenerToPut.propKey,
	        listenerToPut.propValue
	      );
	    }
	  },

	  reset: function() {
	    this.listenersToPut.length = 0;
	  },

	  destructor: function() {
	    this.reset();
	  }
	});

	PooledClass.addPoolingTo(ReactPutListenerQueue);

	module.exports = ReactPutListenerQueue;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */

	'use strict';

	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function(_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};

	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};

	module.exports = ReactRootIndex;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */

	var isTextNode = __webpack_require__(1166);

	/*jslint bitwise:true */

	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if (outerNode.contains) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}

	module.exports = containsNode;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */

	'use strict';

	var ReactCurrentOwner = __webpack_require__(108);
	var ReactInstanceMap = __webpack_require__(160);
	var ReactMount = __webpack_require__(109);

	var invariant = __webpack_require__(11);
	var isNode = __webpack_require__(542);
	var warning = __webpack_require__(26);

	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        owner._warnedAboutRefsInRender,
	        '%s is accessing getDOMNode or findDOMNode inside its render(). ' +
	        'render() should be a pure function of props and state. It should ' +
	        'never access something that requires stale data from the previous ' +
	        'render, such as refs. Move this logic to componentDidMount and ' +
	        'componentDidUpdate instead.',
	        owner.getName() || 'A component'
	      ) : null);
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (isNode(componentOrElement)) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  (false ? invariant(
	    componentOrElement.render == null ||
	    typeof componentOrElement.render !== 'function',
	    'Component (with keys: %s) contains `render` method ' +
	    'but is not mounted in the DOM',
	    Object.keys(componentOrElement)
	  ) : invariant(componentOrElement.render == null ||
	  typeof componentOrElement.render !== 'function'));
	  (false ? invariant(
	    false,
	    'Element appears to be neither ReactComponent nor DOMNode (keys: %s)',
	    Object.keys(componentOrElement)
	  ) : invariant(false));
	}

	module.exports = findDOMNode;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */

	"use strict";

	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch(e) {
	  }
	}

	module.exports = focusNode;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */

	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document body is not yet defined.
	 */
	function getActiveElement() /*?DOMElement*/ {
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}

	module.exports = getActiveElement;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */

	'use strict';

	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (
	    (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL])
	  );
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}

	module.exports = getIteratorFn;


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */

	var ExecutionEnvironment = __webpack_require__(42);

	var invariant = __webpack_require__(11);

	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	var shouldWrap = {
	  // Force wrapping for SVG elements because if they get created inside a <div>,
	  // they will be initialized in the wrong namespace (and will not display).
	  'circle': true,
	  'defs': true,
	  'ellipse': true,
	  'g': true,
	  'line': true,
	  'linearGradient': true,
	  'path': true,
	  'polygon': true,
	  'polyline': true,
	  'radialGradient': true,
	  'rect': true,
	  'stop': true,
	  'text': true
	};

	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

	var svgWrap = [1, '<svg>', '</svg>'];

	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],

	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],

	  'optgroup': selectWrap,
	  'option': selectWrap,

	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,

	  'td': trWrap,
	  'th': trWrap,

	  'circle': svgWrap,
	  'defs': svgWrap,
	  'ellipse': svgWrap,
	  'g': svgWrap,
	  'line': svgWrap,
	  'linearGradient': svgWrap,
	  'path': svgWrap,
	  'polygon': svgWrap,
	  'polyline': svgWrap,
	  'radialGradient': svgWrap,
	  'rect': svgWrap,
	  'stop': svgWrap,
	  'text': svgWrap
	};

	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  (false ? invariant(!!dummyNode, 'Markup wrapping node not initialized') : invariant(!!dummyNode));
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}


	module.exports = getMarkupWrap;


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	var contentKey = null;

	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ?
	      'textContent' :
	      'innerText';
	  }
	  return contentKey;
	}

	module.exports = getTextContentAccessor;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */

	"use strict";

	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}

	module.exports = getUnboundedScrollPosition;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */

	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (
	    ((typeof Node === 'function' ? object instanceof Node : typeof object === 'object' &&
	    typeof object.nodeType === 'number' &&
	    typeof object.nodeName === 'string'))
	  ));
	}

	module.exports = isNode;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */

	'use strict';

	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};

	function isTextInputElement(elem) {
	  return elem && (
	    (elem.nodeName === 'INPUT' && supportedInputTypes[elem.type] || elem.nodeName === 'TEXTAREA')
	  );
	}

	module.exports = isTextInputElement;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactFragment = __webpack_require__(158);
	var ReactInstanceHandles = __webpack_require__(159);

	var getIteratorFn = __webpack_require__(538);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(26);

	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';

	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */

	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};

	var userProvidedKeyEscapeRegex = /[=.:]/g;

	var didWarnAboutMaps = false;

	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}

	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}

	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} key Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(
	    userProvidedKeyEscapeRegex,
	    userProvidedKeyEscaper
	  );
	}

	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}

	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!number} indexSoFar Number of children encountered until this point.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  indexSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;

	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }

	  if (children === null ||
	      type === 'string' ||
	      type === 'number' ||
	      ReactElement.isValidElement(children)) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar,
	      indexSoFar
	    );
	    return 1;
	  }

	  var child, nextName, nextIndex;
	  var subtreeCount = 0; // Count of children found in the current subtree.

	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = (
	        (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	        getComponentKey(child, i)
	      );
	      nextIndex = indexSoFar + subtreeCount;
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        nextIndex,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            getComponentKey(child, ii++)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      } else {
	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnAboutMaps,
	            'Using Maps as children is not yet fully supported. It is an ' +
	            'experimental feature that might be removed. Convert it to a ' +
	            'sequence / iterable of keyed ReactElements instead.'
	          ) : null);
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = (
	              (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	              wrapUserProvidedKey(entry[0]) + SUBSEPARATOR +
	              getComponentKey(child, 0)
	            );
	            nextIndex = indexSoFar + subtreeCount;
	            subtreeCount += traverseAllChildrenImpl(
	              child,
	              nextName,
	              nextIndex,
	              callback,
	              traverseContext
	            );
	          }
	        }
	      }
	    } else if (type === 'object') {
	      (false ? invariant(
	        children.nodeType !== 1,
	        'traverseAllChildren(...): Encountered an invalid child; DOM ' +
	        'elements are not valid children of React components.'
	      ) : invariant(children.nodeType !== 1));
	      var fragment = ReactFragment.extract(children);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          child = fragment[key];
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            wrapUserProvidedKey(key) + SUBSEPARATOR +
	            getComponentKey(child, 0)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      }
	    }
	  }

	  return subtreeCount;
	}

	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }

	  return traverseAllChildrenImpl(children, '', 0, callback, traverseContext);
	}

	module.exports = traverseAllChildren;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Easing Functions - inspired from http://gizma.com/easing/
	 * only considering the t value for the range [0, 1] => [0, 1]
	 *
	 * https://gist.github.com/gre/1650294
	 */
	EasingFunctions = {
	  // no easing, no acceleration
	  linear: function (t) { return t; },
	  // accelerating from zero velocity
	  easeInQuad: function (t) { return t * t; },
	  // decelerating to zero velocity
	  easeOutQuad: function (t) { return t * (2 - t); },
	  // acceleration until halfway, then deceleration
	  easeInOutQuad: function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
	  // accelerating from zero velocity 
	  easeInCubic: function (t) { return t * t * t; },
	  // decelerating to zero velocity 
	  easeOutCubic: function (t) { return (--t) * t * t + 1; },
	  // acceleration until halfway, then deceleration 
	  easeInOutCubic: function (t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
	  // accelerating from zero velocity 
	  easeInQuart: function (t) { return t * t * t * t; },
	  // decelerating to zero velocity 
	  easeOutQuart: function (t) { return 1 - (--t) * t * t * t; },
	  // acceleration until halfway, then deceleration
	  easeInOutQuart: function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
	  // accelerating from zero velocity
	  easeInQuint: function (t) { return t * t * t * t * t; },
	  // decelerating to zero velocity
	  easeOutQuint: function (t) { return 1 + (--t) * t * t * t * t; },
	  // acceleration until halfway, then deceleration 
	  easeInOutQuint: function (t) { return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; }
	};

	module.exports = EasingFunctions;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var EasingFunctions = __webpack_require__(545),
	    noop = function() {};

	/**
	 * Animates object state, combining concurrent animations. It uses "Additive animation" algorithm, described here:
	 *
	 * https://developer.apple.com/videos/wwdc/2014/#236
	 *
	 * Sample code:
	 *
	 *   function onRender(state) {
	 *     window.scrollTo(0, state.y);
	 *   }
	 *
	 *   var animation = Animation({ onRender: onRender });
	 *
	 *   animation.animate({ y: 0 }, { y: 1000 }, 'easeInOutQuad');
	 *
	 *   ...
	 *
	 *   animation.animate({ y: 1000 }, { y: 2000 }, 'linear');
	 */

	var Animation = function (options) {
	  var frame = null,
	      lastTargetState = null,
	      currentState = null,
	      animationStack = [],
	      onRender = options.onRender || noop,
	      onFinish = options.onFinish || noop,
	      onCancel = options.onCancel || noop,
	      enabledRAF = options.enabledRAF || options.enabledRAF === undefined,
	      fps = options.fps || 60,
	      stepFunc;

	  stepFunc = enabledRAF && window.requestAnimationFrame || function(func) { setTimeout(func, 1000 / fps); };

	  function now() {
	    if (window.performance && window.performance.now) {
	      return window.performance.now();
	    }

	    if (Date.now) {
	      return Date.now();
	    }

	    return new Date().getTime();
	  }

	  function isAnimating() {
	    return !!lastTargetState;
	  }

	  function finish() {
	    if (lastTargetState !== null) {
	      onFinish(lastTargetState);

	      lastTargetState = null;
	      currentState = null;
	    }
	  }

	  function cancel() {
	    if (lastTargetState !== null) {
	      if (enabledRAF && window.cancelAnimationFrame) {
	        window.cancelAnimationFrame(frame);
	        frame = null;
	      }
	      onCancel();

	      lastTargetState = null;
	      currentState = null;
	    }
	  }

	  function filterOutdatedTargetsFromStack(time) {
	    var filteredStack = [];
	    for (var i = animationStack.length - 1; i >= 0; i--) {
	      if (animationStack[i].end > time) {
	        filteredStack.push(animationStack[i]);
	      }
	    }

	    animationStack = filteredStack;
	  }

	  function getCurrentState(time) {
	    var target = {},
	        animation,
	        remain,
	        key;

	    for (key in lastTargetState) {
	      target[key] = lastTargetState[key];
	    }

	    for (var i = animationStack.length - 1; i >= 0; i--) {
	      animation = animationStack[i];
	      if (animation.end < time) { continue; }
	      remain = (animation.end - time) / animation.duration;
	      for (key in target) {
	        target[key] -= (animation.toState[key] - animation.fromState[key]) * animation.easing(remain);
	      }
	    }

	    return target;
	  }

	  function hasActiveAnimation(time) {
	    for (var i = animationStack.length - 1; i >= 0; i--) {
	      var animation = animationStack[i];
	      if (animation.end >= time) { return true; }
	    }    
	  }

	  function animationStep() {
	    if (lastTargetState === null) { return; }

	    var time = now();
	    
	    currentState = getCurrentState(time);

	    onRender(currentState);

	    if (hasActiveAnimation(time)) {
	      frame = stepFunc(animationStep);
	    } else {
	      finish();
	    }
	  }

	  function animate(fromState, toState, duration, easing) {
	    var time = now(),
	        animation;

	    animation = {
	      duration: duration,
	      end: time + duration,
	      fromState: lastTargetState === null ? fromState : lastTargetState,
	      toState: toState,
	      easing: ((typeof easing === 'string') ? EasingFunctions[easing] : easing) || EasingFunctions.easeInOutQuad
	    };

	    filterOutdatedTargetsFromStack(time);

	    animationStack.push(animation);

	    lastTargetState = toState;

	    frame = stepFunc(animationStep);
	  }

	  return {
	    animate: animate,
	    isAnimating: isAnimating,
	    cancel: cancel
	  };
	};


	module.exports = Animation;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * An even better animation frame.
	 *
	 * @copyright Oleg Slobodskoi 2013
	 * @website https://github.com/kof/animationFrame
	 * @license MIT
	 */

	;(function(window) {
	'use strict'

	var nativeRequestAnimationFrame,
	    nativeCancelAnimationFrame

	// Grab the native request and cancel functions.
	;(function() {
	    var i,
	        vendors = ['webkit', 'moz', 'ms', 'o'],
	        top

	    // Test if we are within a foreign domain. Use raf from the top if possible.
	    try {
	        // Accessing .name will throw SecurityError within a foreign domain.
	        window.top.name
	        top = window.top
	    } catch(e) {
	        top = window
	    }

	    nativeRequestAnimationFrame = top.requestAnimationFrame
	    nativeCancelAnimationFrame = top.cancelAnimationFrame || top.cancelRequestAnimationFrame


	    // Grab the native implementation.
	    for (i = 0; i < vendors.length && !nativeRequestAnimationFrame; i++) {
	        nativeRequestAnimationFrame = top[vendors[i] + 'RequestAnimationFrame']
	        nativeCancelAnimationFrame = top[vendors[i] + 'CancelAnimationFrame'] ||
	            top[vendors[i] + 'CancelRequestAnimationFrame']
	    }

	    // Test if native implementation works.
	    // There are some issues on ios6
	    // http://shitwebkitdoes.tumblr.com/post/47186945856/native-requestanimationframe-broken-on-ios-6
	    // https://gist.github.com/KrofDrakula/5318048
	    nativeRequestAnimationFrame && nativeRequestAnimationFrame(function() {
	        AnimationFrame.hasNative = true
	    })
	}())

	/**
	 * Animation frame constructor.
	 *
	 * Options:
	 *   - `useNative` use the native animation frame if possible, defaults to true
	 *   - `frameRate` pass a custom frame rate
	 *
	 * @param {Object|Number} options
	 */
	function AnimationFrame(options) {
	    if (!(this instanceof AnimationFrame)) return new AnimationFrame(options)
	    options || (options = {})

	    // Its a frame rate.
	    if (typeof options == 'number') options = {frameRate: options}
	    options.useNative != null || (options.useNative = true)
	    this.options = options
	    this.frameRate = options.frameRate || AnimationFrame.FRAME_RATE
	    this._frameLength = 1000 / this.frameRate
	    this._isCustomFrameRate = this.frameRate !== AnimationFrame.FRAME_RATE
	    this._timeoutId = null
	    this._callbacks = {}
	    this._lastTickTime = 0
	    this._tickCounter = 0
	}

	/**
	 * Default frame rate used for shim implementation. Native implementation
	 * will use the screen frame rate, but js have no way to detect it.
	 *
	 * If you know your target device, define it manually.
	 *
	 * @type {Number}
	 * @api public
	 */
	AnimationFrame.FRAME_RATE = 60

	/**
	 * Replace the globally defined implementation or define it globally.
	 *
	 * @param {Object|Number} [options]
	 * @api public
	 */
	AnimationFrame.shim = function(options) {
	    var animationFrame = new AnimationFrame(options)

	    window.requestAnimationFrame = function(callback) {
	        return animationFrame.request(callback)
	    }
	    window.cancelAnimationFrame = function(id) {
	        return animationFrame.cancel(id)
	    }

	    return animationFrame
	}

	/**
	 * Crossplatform Date.now()
	 *
	 * @return {Number} time in ms
	 * @api public
	 */
	AnimationFrame.now = Date.now || function() {
	    return (new Date).getTime()
	}

	/**
	 * Replacement for PerformanceTiming.navigationStart for the case when
	 * performance.now is not implemented.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming.navigationStart
	 *
	 * @type {Number}
	 * @api public
	 */
	AnimationFrame.navigationStart = AnimationFrame.now()

	/**
	 * Crossplatform performance.now()
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/Performance.now()
	 *
	 * @return {Number} relative time in ms
	 * @api public
	 */
	AnimationFrame.perfNow = function() {
	    if (window.performance && window.performance.now) return window.performance.now()
	    return AnimationFrame.now() - AnimationFrame.navigationStart
	}

	/**
	 * Is native animation frame implemented. The right value is set during feature
	 * detection step.
	 *
	 * @type {Boolean}
	 * @api public
	 */
	AnimationFrame.hasNative = false

	/**
	 * Request animation frame.
	 * We will use the native RAF as soon as we know it does works.
	 *
	 * @param {Function} callback
	 * @return {Number} timeout id or requested animation frame id
	 * @api public
	 */
	AnimationFrame.prototype.request = function(callback) {
	    var self = this,
	        delay

	    // Alawys inc counter to ensure it never has a conflict with the native counter.
	    // After the feature test phase we don't know exactly which implementation has been used.
	    // Therefore on #cancel we do it for both.
	    ++this._tickCounter

	    if (AnimationFrame.hasNative && self.options.useNative && !this._isCustomFrameRate) {
	        return nativeRequestAnimationFrame(callback)
	    }

	    if (!callback) throw new TypeError('Not enough arguments')

	    if (this._timeoutId == null) {
	        // Much faster than Math.max
	        // http://jsperf.com/math-max-vs-comparison/3
	        // http://jsperf.com/date-now-vs-date-gettime/11
	        delay = this._frameLength + this._lastTickTime - AnimationFrame.now()
	        if (delay < 0) delay = 0

	        this._timeoutId = window.setTimeout(function() {
	            var id

	            self._lastTickTime = AnimationFrame.now()
	            self._timeoutId = null
	            ++self._tickCounter

	            for (id in self._callbacks) {
	                if (self._callbacks[id]) {
	                    if (AnimationFrame.hasNative && self.options.useNative) {
	                        nativeRequestAnimationFrame(self._callbacks[id])
	                    } else {
	                        self._callbacks[id](AnimationFrame.perfNow())
	                    }
	                    delete self._callbacks[id]
	                }
	            }
	        }, delay)
	    }

	    this._callbacks[this._tickCounter] = callback
	    return this._tickCounter
	}

	/**
	 * Cancel animation frame.
	 *
	 * @param {Number} timeout id or requested animation frame id
	 *
	 * @api public
	 */
	AnimationFrame.prototype.cancel = function(id) {
	    if (AnimationFrame.hasNative && this.options.useNative) nativeCancelAnimationFrame(id)
	    delete this._callbacks[id]
	}


	// Support commonjs wrapper, amd define and plain window.
	if (true) {
	    module.exports = AnimationFrame
	} else if (typeof define == 'function' && define.amd) {
	    define(function() { return AnimationFrame })
	} else {
	    window.AnimationFrame = AnimationFrame
	}

	}(window));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";

	__webpack_require__(888);

	__webpack_require__(1177);

	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel/polyfill is allowed");
	}
	global._babelPolyfill = true;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(548);


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _hostsNotificationHost = __webpack_require__(403);

	var _hostsNotificationHost2 = _interopRequireDefault(_hostsNotificationHost);

	var _hostsAlertHost = __webpack_require__(672);

	var _hostsAlertHost2 = _interopRequireDefault(_hostsAlertHost);

	var _hostsModalHost = __webpack_require__(402);

	var _hostsModalHost2 = _interopRequireDefault(_hostsModalHost);

	var _hostsOverlayHost = __webpack_require__(404);

	var _hostsOverlayHost2 = _interopRequireDefault(_hostsOverlayHost);

	var _hostsSidebarHost = __webpack_require__(675);

	var _hostsSidebarHost2 = _interopRequireDefault(_hostsSidebarHost);

	var _hostsPageControlsHost = __webpack_require__(674);

	var _hostsPageControlsHost2 = _interopRequireDefault(_hostsPageControlsHost);

	var _hostsContextMenuHost = __webpack_require__(673);

	var _hostsContextMenuHost2 = _interopRequireDefault(_hostsContextMenuHost);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _organismsNavBar = __webpack_require__(719);

	var _organismsNavBar2 = _interopRequireDefault(_organismsNavBar);

	var _storesOverlayStore = __webpack_require__(118);

	var _storesOverlayStore2 = _interopRequireDefault(_storesOverlayStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsIdleScrollMixin = __webpack_require__(405);

	var _mixinsIdleScrollMixin2 = _interopRequireDefault(_mixinsIdleScrollMixin);

	var _mixinsRouterStateMixin = __webpack_require__(166);

	var _mixinsRouterStateMixin2 = _interopRequireDefault(_mixinsRouterStateMixin);

	var _actionsScreenSizeActionCreators = __webpack_require__(562);

	var _actionsScreenSizeActionCreators2 = _interopRequireDefault(_actionsScreenSizeActionCreators);

	var _hostsStickyPlayerHost = __webpack_require__(676);

	var _hostsStickyPlayerHost2 = _interopRequireDefault(_hostsStickyPlayerHost);

	var _utilsBrowser = __webpack_require__(36);

	var _reactRouter = __webpack_require__(154);

	var _storesStampDraftStore = __webpack_require__(64);

	var _storesStampDraftStore2 = _interopRequireDefault(_storesStampDraftStore);

	'use strict';

	var App = _react2['default'].createClass({
	  displayName: 'App',

	  mixins: [_mixinsClassNameMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesOverlayStore2['default'], _storesStampDraftStore2['default']), _mixinsRouterStateMixin2['default'], _mixinsIdleScrollMixin2['default'], _mixinsPureRenderMixin2['default']],

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.isScrolling() && 'scrolling', (0, _utilsBrowser.getBrowserName)().toLowerCase()];
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      shouldDisableScroll: _storesOverlayStore2['default'].hasAny() && !_storesOverlayStore2['default'].hasContextMenu(),
	      hasUnsavedChanges: _storesStampDraftStore2['default'].hasUnsavedChanges()
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.updateBodyOverflow();
	    window.addEventListener('resize', this.handleWindowResize);
	    window.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('beforeunload', this.handleBeforeUnload);
	  },

	  handleBeforeUnload: function handleBeforeUnload(e) {
	    if (this.state.hasUnsavedChanges) {
	      var message = 'Changes to your draft have not been saved.';
	      (e || window.event).returnValue = message;
	      return message;
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.shouldDisableScroll !== this.state.shouldDisableScroll) {
	      this.updateBodyOverflow();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.handleWindowResize);
	    window.removeEventListener('scroll', this.handleScroll);
	    window.removeEventListener('beforeunload', this.handleBeforeUnload);
	  },

	  updateBodyOverflow: function updateBodyOverflow() {
	    var shouldOverflow = this.state.shouldDisableScroll;
	    document.body.style.overflow = shouldOverflow ? 'hidden' : 'auto';
	  },

	  handleWindowResize: function handleWindowResize() {
	    _actionsScreenSizeActionCreators2['default'].handleWindowResize();
	  },

	  getHandlerKey: function getHandlerKey() {
	    var childDepth = 1;
	    var _context$router = this.context.router;
	    var getCurrentRoutes = _context$router.getCurrentRoutes;
	    var getCurrentParams = _context$router.getCurrentParams;
	    var getCurrentQuery = _context$router.getCurrentQuery;

	    var childHandler = getCurrentRoutes()[childDepth].handler;
	    var params = getCurrentParams();
	    var query = getCurrentQuery();

	    if (childHandler.getHandlerKey) {
	      return childHandler.getHandlerKey(params, query);
	    }
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _atomsDocumentTitle2['default'],
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: this.getClassName() },
	        _react2['default'].createElement(_organismsNavBar2['default'], null),
	        _react2['default'].createElement(_reactRouter.RouteHandler, _extends({}, this.props, { key: this.getHandlerKey() })),
	        _react2['default'].createElement(_hostsNotificationHost2['default'], null),
	        _react2['default'].createElement(_hostsOverlayHost2['default'], null),
	        _react2['default'].createElement(_hostsModalHost2['default'], null),
	        _react2['default'].createElement(_hostsSidebarHost2['default'], null),
	        _react2['default'].createElement(_hostsContextMenuHost2['default'], null),
	        _react2['default'].createElement(_hostsPageControlsHost2['default'], null),
	        _react2['default'].createElement(_hostsAlertHost2['default'], null),
	        _react2['default'].createElement(_hostsStickyPlayerHost2['default'], null)
	      )
	    );
	  }
	});

	exports['default'] = App;
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _inherits = __webpack_require__(804)['default'];

	var _createClass = __webpack_require__(224)['default'];

	var _classCallCheck = __webpack_require__(223)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _hostsNotificationHost = __webpack_require__(403);

	var _hostsNotificationHost2 = _interopRequireDefault(_hostsNotificationHost);

	var _hostsOverlayHost = __webpack_require__(404);

	var _hostsOverlayHost2 = _interopRequireDefault(_hostsOverlayHost);

	var _hostsModalHost = __webpack_require__(402);

	var _hostsModalHost2 = _interopRequireDefault(_hostsModalHost);

	var _actionsModalActionCreators = __webpack_require__(77);

	var _actionsModalActionCreators2 = _interopRequireDefault(_actionsModalActionCreators);

	var _constantsModalTypes = __webpack_require__(58);

	var _constantsModalTypes2 = _interopRequireDefault(_constantsModalTypes);

	var _constantsAuthTypes = __webpack_require__(199);

	var _constantsAuthTypes2 = _interopRequireDefault(_constantsAuthTypes);

	'use strict';

	var AuthPopup = (function (_Component) {
	  function AuthPopup() {
	    _classCallCheck(this, AuthPopup);

	    if (_Component != null) {
	      _Component.apply(this, arguments);
	    }
	  }

	  _inherits(AuthPopup, _Component);

	  _createClass(AuthPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var authType = this.props.authType;

	      _actionsModalActionCreators2['default'].showModal(authType === _constantsAuthTypes2['default'].SIGNUP ? _constantsModalTypes2['default'].SIGNUP : _constantsModalTypes2['default'].LOGIN);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _atomsDocumentTitle2['default'],
	        null,
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_hostsNotificationHost2['default'], null),
	          _react2['default'].createElement(_hostsOverlayHost2['default'], null),
	          _react2['default'].createElement(_hostsModalHost2['default'], null)
	        )
	      );
	    }
	  }]);

	  return AuthPopup;
	})(_react.Component);

	exports['default'] = AuthPopup;

	AuthPopup.propTypes = {
	  authType: _react.PropTypes.oneOf([_constantsAuthTypes2['default'].LOGIN, _constantsAuthTypes2['default'].SIGNUP]).isRequired
	};
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    AppDispatcher = __webpack_require__(6);

	var ActivityServerActionCreators = {
	  handleActivitiesPage: function handleActivitiesPage(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_ACTIVITIES_ERROR : ActionTypes.REQUEST_ACTIVITIES_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUnseenCount: function handleUnseenCount(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_ERROR : ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS,
	      count: response && response.count
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleMarkAll: function handleMarkAll(err) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.ACTIVITY_MARK_ALL_ERROR : ActionTypes.ACTIVITY_MARK_ALL_SUCCESS
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	module.exports = ActivityServerActionCreators;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _storesRouterStore = __webpack_require__(120);

	var _storesRouterStore2 = _interopRequireDefault(_storesRouterStore);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _SidebarActionCreators = __webpack_require__(29);

	var _SidebarActionCreators2 = _interopRequireDefault(_SidebarActionCreators);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _actionsNotificationActionCreators = __webpack_require__(90);

	var _actionsNotificationActionCreators2 = _interopRequireDefault(_actionsNotificationActionCreators);

	var _constantsNotificationMessages = __webpack_require__(78);

	var _constantsNotificationMessages2 = _interopRequireDefault(_constantsNotificationMessages);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	var _router = __webpack_require__(50);

	'use strict';

	var DraftServerActionCreators = {
	  handleSaveDraft: function handleSaveDraft(err, response, previousDraftUuid) {
	    var isNewDraft = !previousDraftUuid;
	    var draftUuid = undefined;
	    if (!err) {
	      draftUuid = response.result;
	    }

	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].SAVE_DRAFT_ERROR : _constantsActionTypes2['default'].SAVE_DRAFT_SUCCESS,
	      response: response,
	      draftUuid: draftUuid,
	      isNewDraft: isNewDraft
	    });

	    if (err) {
	      console.error(err);
	    } else if (isNewDraft) {
	      var _RouterStore$getRouterState = _storesRouterStore2['default'].getRouterState();

	      var stampSegment = _RouterStore$getRouterState.params.stampSegment;

	      var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	      var isStillAtNewDraftRoute = _parseStampSegment.isNewDraft;

	      if (isStillAtNewDraftRoute) {
	        (0, _router.replaceWith)('draftCompose', { stampSegment: draftUuid });
	      }
	    }
	  },

	  handleLoadStampInEditor: function handleLoadStampInEditor(err, response, stampId) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].LOAD_STAMP_IN_EDITOR_ERROR : _constantsActionTypes2['default'].LOAD_STAMP_IN_EDITOR_SUCCESS,
	      response: response,
	      stampId: stampId
	    });

	    if (err) {
	      console.log(err);
	    }
	  },

	  handleLoadDraftInEditor: function handleLoadDraftInEditor(err, response, draftUuid) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].LOAD_DRAFT_IN_EDITOR_ERROR : _constantsActionTypes2['default'].LOAD_DRAFT_IN_EDITOR_SUCCESS,
	      response: response,
	      draftUuid: draftUuid
	    });

	    if (err) {
	      var _RouterStore$getRouterState2 = _storesRouterStore2['default'].getRouterState();

	      var stampSegment = _RouterStore$getRouterState2.params.stampSegment;

	      if (err.status === 404 && stampSegment === draftUuid) {
	        _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].NOT_FOUND, { hideOnRouteChange: false });
	        (0, _router.replaceWith)('feed');
	      } else {
	        console.error(err);
	      }
	    }
	  },

	  handleDeleteDraft: function handleDeleteDraft(err, response, draftUuid) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].DELETE_DRAFT_ERROR : _constantsActionTypes2['default'].DELETE_DRAFT_SUCCESS,
	      response: response,
	      draftUuid: draftUuid
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      (0, _router.replaceWith)('draftCompose', { stampSegment: 'new' });
	    }
	  },

	  handleSendFeedback: function handleSendFeedback(err, response, draftUuid) {
	    _AppDispatcher2['default'].handleServerFormAction({
	      type: err ? _constantsActionTypes2['default'].SEND_DRAFT_FEEDBACK_ERROR : _constantsActionTypes2['default'].SEND_DRAFT_FEEDBACK_SUCCESS,
	      response: response,
	      err: err,
	      draftUuid: draftUuid
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      _SidebarActionCreators2['default'].hideSidebar();
	      _actionsNotificationActionCreators2['default'].showNotification(_constantsNotificationMessages2['default'].DRAFT_FEEDBACK_SENT);
	    }
	  },

	  handleDraftsPage: function handleDraftsPage(err, response) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_DRAFTS_ERROR : _constantsActionTypes2['default'].REQUEST_DRAFTS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleDraftFeedbacksPage: function handleDraftFeedbacksPage(err, response, draftUuid) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS_ERROR : _constantsActionTypes2['default'].REQUEST_DRAFT_FEEDBACKS_SUCCESS,
	      response: response,
	      draftUuid: draftUuid
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	exports['default'] = DraftServerActionCreators;
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _constantsAuthTypes = __webpack_require__(199);

	var _constantsAuthTypes2 = _interopRequireDefault(_constantsAuthTypes);

	var _utilsNormalizeError = __webpack_require__(450);

	var _utilsNormalizeError2 = _interopRequireDefault(_utilsNormalizeError);

	var _storesOverlayStore = __webpack_require__(118);

	var _storesOverlayStore2 = _interopRequireDefault(_storesOverlayStore);

	var _constantsModalTypes = __webpack_require__(58);

	var _constantsModalTypes2 = _interopRequireDefault(_constantsModalTypes);

	var _constantsNotificationMessages = __webpack_require__(78);

	var _constantsNotificationMessages2 = _interopRequireDefault(_constantsNotificationMessages);

	var _actionsInvitationActionCreators = __webpack_require__(195);

	var _actionsInvitationActionCreators2 = _interopRequireDefault(_actionsInvitationActionCreators);

	var _actionsNotificationActionCreators = __webpack_require__(90);

	var _actionsNotificationActionCreators2 = _interopRequireDefault(_actionsNotificationActionCreators);

	'use strict';

	var ExternalActionCreators = {
	  /**
	   * An event will be triggered by auth_popup.html like this:
	   * window.opener.require('ExternalActionCreators').handleAuthService({{ error | tojson | safe }}, {{ account | tojson | safe }}, '{{ service_type }}');
	   */
	  handleAuthService: function handleAuthService(err, response, serviceType, authType, next) {
	    var actionType = undefined;

	    switch (authType) {
	      case _constantsAuthTypes2['default'].CONNECT:
	        actionType = err ? _constantsActionTypes2['default'].CONNECT_SERVICE_ACCOUNT_ERROR : _constantsActionTypes2['default'].CONNECT_SERVICE_ACCOUNT_SUCCESS;
	        break;
	      case _constantsAuthTypes2['default'].LOGIN:
	        actionType = err ? _constantsActionTypes2['default'].LOGIN_WITH_SERVICE_ACCOUNT_ERROR : _constantsActionTypes2['default'].LOGIN_WITH_SERVICE_ACCOUNT_SUCCESS;
	        break;
	      case _constantsAuthTypes2['default'].SIGNUP:
	        actionType = err ? _constantsActionTypes2['default'].SIGNUP_WITH_SERVICE_ACCOUNT_ERROR : _constantsActionTypes2['default'].SIGNUP_WITH_SERVICE_ACCOUNT_SUCCESS;
	        break;
	    }

	    _AppDispatcher2['default'].handleServerFormAction({
	      type: actionType,
	      serviceType: serviceType,
	      response: response,
	      err: err ? (0, _utilsNormalizeError2['default'])(err) : null
	    });

	    if (err) {
	      console.log(err);
	    } else {
	      if (authType === _constantsAuthTypes2['default'].CONNECT) {
	        _actionsNotificationActionCreators2['default'].showNotification(_constantsNotificationMessages2['default'].ACCOUNT_CONNECTED);
	      }

	      if (authType === _constantsAuthTypes2['default'].CONNECT && _storesOverlayStore2['default'].hasModal(_constantsModalTypes2['default'].SEND_INVITE)) {
	        _actionsInvitationActionCreators2['default'].requestSocialFriendsPage(serviceType);
	      } else if (next) {
	        window.location = next;
	      }
	    }
	  },

	  handleFormResponse: function handleFormResponse(err, response) {
	    _AppDispatcher2['default'].handleServerFormAction({
	      type: err ? _constantsActionTypes2['default'].LOGIN_WITH_EMAIL_SUCCESS : _constantsActionTypes2['default'].LOGIN_WITH_EMAIL_ERROR,
	      response: response,
	      err: err ? (0, _utilsNormalizeError2['default'])(err) : null
	    });

	    if (err) {
	      console.log(err);
	    } else {
	      window.location.href = response && response.next || '/';
	    }
	  }
	};

	exports['default'] = ExternalActionCreators;
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    AppDispatcher = __webpack_require__(6),
	    NotificationActionCreators = __webpack_require__(90),
	    Messages = __webpack_require__(78);

	var InvitationServerActionCreators = {
	  handleAddToGrabbag: function handleAddToGrabbag(err, response, uuid, stampId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.IMAGE_ADD_TO_GRABBAG_ERROR : ActionTypes.IMAGE_ADD_TO_GRABBAG_SUCCESS,
	      response: response,
	      uuid: uuid,
	      stampId: stampId
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(Messages.IMAGE_ADDED_TO_GRABBAG);
	    }
	  },

	  handleGrabbagImagesPage: function handleGrabbagImagesPage(err, response, tab) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_GRABBAG_IMAGES_ERROR : ActionTypes.REQUEST_GRABBAG_IMAGES_SUCCESS,
	      response: response,
	      tab: tab
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleRemoveFromGrabbag: function handleRemoveFromGrabbag(err, response, uuid) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_ERROR : ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_SUCCESS,
	      response: response,
	      uuid: uuid
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleRemoveStampletItem: function handleRemoveStampletItem(err, response, uuid) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_ERROR : ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS,
	      response: response,
	      uuid: uuid
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleImageUsedInStampsPage: function handleImageUsedInStampsPage(err, response, imageUuid) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_ERROR : ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_SUCCESS,
	      response: response,
	      imageUuid: imageUuid
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	module.exports = InvitationServerActionCreators;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    ServiceTypes = __webpack_require__(35),
	    AppDispatcher = __webpack_require__(6),
	    InvitationStore = __webpack_require__(289),
	    FormActionCreators = __webpack_require__(388),
	    NotificationActionCreators = __webpack_require__(90),
	    Messages = __webpack_require__(78);

	var InvitationServerActionCreators = {
	  handleInvitationsPage: function handleInvitationsPage(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_INVITATIONS_ERROR : ActionTypes.REQUEST_INVITATIONS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSocialFriendsPage: function handleSocialFriendsPage(err, response, serviceType) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_SOCIAL_FRIENDS_ERROR : ActionTypes.REQUEST_SOCIAL_FRIENDS_SUCCESS,
	      serviceType: serviceType,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleResendInvite: function handleResendInvite(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.RESEND_INVITE_ERROR : ActionTypes.RESEND_INVITE_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(Messages.INVITE_SENT);
	    }
	  },

	  handleSendInvite: function handleSendInvite(err, response) {
	    AppDispatcher.handleServerFormAction({
	      type: err ? ActionTypes.SEND_INVITE_ERROR : ActionTypes.SEND_INVITE_SUCCESS,
	      response: response,
	      err: err
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      var inviteId = response.result,
	          invite = InvitationStore.get(inviteId);

	      FormActionCreators.resetForm();

	      if (invite.serviceType === ServiceTypes.FACEBOOK) {
	        // TODO: do it right
	        var FacebookActionCreators = __webpack_require__(387);
	        FacebookActionCreators.sendFacebookInvite(invite);
	      } else {
	        var InvitationActionCreators = __webpack_require__(195);
	        InvitationActionCreators.requestInvitationsPage();
	        NotificationActionCreators.showNotification(Messages.INVITE_SENT);
	      }
	    }
	  },

	  handleUpdateInvite: function handleUpdateInvite(err, response) {
	    AppDispatcher.handleServerFormAction({
	      type: err ? ActionTypes.UPDATE_INVITE_ERROR : ActionTypes.UPDATE_INVITE_SUCCESS,
	      response: response,
	      err: err
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      var InvitationActionCreators = __webpack_require__(195);
	      InvitationActionCreators.requestInvitationsPage();
	      NotificationActionCreators.showNotification(Messages.INVITE_SENT);
	    }
	  }
	};

	module.exports = InvitationServerActionCreators;

/***/ },
/* 557 */,
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    NavigationContextTypes = __webpack_require__(51),
	    invariant = __webpack_require__(11),
	    assign = __webpack_require__(15);

	var NavigationActionCreators = {
	  setContext: function setContext(id, options) {
	    invariant(NavigationContextTypes.hasOwnProperty(id), 'set() accepts a constant from NavigationContextTypes. You passed %s', id);

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SET_NAVIGATION_CONTEXT,
	      context: assign({ id: id }, options)
	    });
	  },

	  clearContext: function clearContext() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.CLEAR_NAVIGATION_CONTEXT
	    });
	  }
	};

	module.exports = NavigationActionCreators;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var OverlayActionCreators = {
	  hideOverlay: function hideOverlay() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_OVERLAY
	    });
	  }
	};

	module.exports = OverlayActionCreators;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    PageControlsTypes = __webpack_require__(94),
	    assign = __webpack_require__(15),
	    invariant = __webpack_require__(11);

	var PageControlsActionCreators = {
	  showPageControls: function showPageControls(id, options) {
	    invariant(PageControlsTypes.hasOwnProperty(id), 'showPageControls() accepts a constant from PageControlsTypes. You passed %s', id);

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.SHOW_PAGE_CONTROLS,
	      pageControls: assign({ id: id }, options)
	    });
	  },

	  hidePageControls: function hidePageControls() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.HIDE_PAGE_CONTROLS
	    });
	  }
	};

	module.exports = PageControlsActionCreators;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    Analytics = __webpack_require__(52);

	var currentPath = null;

	var RouterActionCreators = {
	  changeRoute: function changeRoute(routerState) {
	    var path = routerState.path;
	    var routes = routerState.routes;
	    var params = routerState.params;

	    if (false) {
	      // Only fire an action if the path has really changed.
	      // This will always be true except when hot reloading routes.
	      return;
	    }

	    currentPath = path;

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.CHANGE_ROUTE,
	      routerState: routerState
	    });

	    Analytics.trackPageView(path, routes, params);
	  }
	};

	module.exports = RouterActionCreators;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var ScreenSizeActionCreators = {
	  handleWindowResize: function handleWindowResize() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.RESIZE_WINDOW
	    });
	  }
	};

	module.exports = ScreenSizeActionCreators;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var SendInvitationFormActionCreators = {
	  pushTag: function pushTag(tag) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.INVITATION_FORM_PUSH_TAG,
	      tag: tag
	    });
	  },

	  clearSuggested: function clearSuggested() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.INVITATION_FORM_CLEAR_SUGGESTED
	    });
	  }
	};

	module.exports = SendInvitationFormActionCreators;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _Object$assign = __webpack_require__(180)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _constantsActionTypes = __webpack_require__(9);

	var _constantsActionTypes2 = _interopRequireDefault(_constantsActionTypes);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _storesRouterStore = __webpack_require__(120);

	var _storesRouterStore2 = _interopRequireDefault(_storesRouterStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _actionsNotificationActionCreators = __webpack_require__(90);

	var _actionsNotificationActionCreators2 = _interopRequireDefault(_actionsNotificationActionCreators);

	var _constantsNotificationMessages = __webpack_require__(78);

	var _constantsNotificationMessages2 = _interopRequireDefault(_constantsNotificationMessages);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _router = __webpack_require__(50);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	var _SidebarActionCreators = __webpack_require__(29);

	var _SidebarActionCreators2 = _interopRequireDefault(_SidebarActionCreators);

	'use strict';

	var StampServerActionCreators = {
	  handleStamp: function handleStamp(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_STAMP_ERROR : _constantsActionTypes2['default'].REQUEST_STAMP_SUCCESS,
	      response: response,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);

	      var params = _storesRouterStore2['default'].getRouterState().params;
	      if (err.status === 404 && params.stampSegment === stampSegment) {
	        _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].NOT_FOUND);
	      }
	    }
	  },

	  handleDeleteStamp: function handleDeleteStamp(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].DELETE_STAMP_ERROR : _constantsActionTypes2['default'].DELETE_STAMP_SUCCESS,
	      response: response,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      // Bail out of reconciling changes
	      window.location = (0, _router.makeHref)('user', {
	        userId: _storesUserStore2['default'].getMe().id
	      });
	    }
	  },

	  handlePostStamp: function handlePostStamp(err, response) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].POST_STAMP_ERROR : _constantsActionTypes2['default'].POST_STAMP_SUCCESS,
	      response: response,
	      stampId: err ? null : response.result
	    });

	    if (err) {
	      console.error(err);
	      _actionsAlertActionCreators2['default'].showAlert(err.status ? _constantsAlertTypes2['default'].SERVER_ERROR : _constantsAlertTypes2['default'].CONNECTION_ERROR);
	    } else {
	      var stamp = _storesStampStore2['default'].get(response.result);
	      (0, _router.replaceWith)('userLatestStamp', _Object$assign({
	        userId: _storesUserStore2['default'].getMe().id,
	        stampSegment: (0, _utilsGetStampSegment2['default'])(stamp)
	      }));

	      window.setTimeout(function () {
	        _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].SHARE_POSTED_STAMP, {
	          stampId: response.result
	        });
	      }, 500);
	    }
	  },

	  handleUpdateStamp: function handleUpdateStamp(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].UPDATE_STAMP_ERROR : _constantsActionTypes2['default'].UPDATE_STAMP_SUCCESS,
	      response: response,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	      _actionsAlertActionCreators2['default'].showAlert(err.status ? _constantsAlertTypes2['default'].SERVER_ERROR : _constantsAlertTypes2['default'].CONNECTION_ERROR);
	    } else {
	      var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	      var stampId = _parseStampSegment.stampId;

	      var newStampSegment = (0, _utilsGetStampSegment2['default'])(_storesStampStore2['default'].get(stampId));

	      (0, _router.replaceWith)('userLatestStamp', {
	        userId: _storesUserStore2['default'].getMe().id,
	        stampSegment: newStampSegment
	      });

	      _actionsNotificationActionCreators2['default'].showNotification(_constantsNotificationMessages2['default'].STAMP_HAS_BEEN_SAVED, { stampId: stampId });
	    }
	  },

	  handleLikeStamp: function handleLikeStamp(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].LIKE_STAMP_ERROR : _constantsActionTypes2['default'].LIKE_STAMP_SUCCESS,
	      response: response,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUnlikeStamp: function handleUnlikeStamp(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].UNLIKE_STAMP_ERROR : _constantsActionTypes2['default'].UNLIKE_STAMP_SUCCESS,
	      response: response,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleAboutPage: function handleAboutPage(err, response) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_ABOUT_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_ABOUT_STAMPS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleFeedPage: function handleFeedPage(err, response) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_FEED_ERROR : _constantsActionTypes2['default'].REQUEST_FEED_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleTrendingPage: function handleTrendingPage(err, response) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_TRENDING_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_TRENDING_STAMPS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserLatestPage: function handleUserLatestPage(err, response, userId) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_USER_LATEST_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_USER_LATEST_STAMPS_SUCCESS,
	      userId: userId,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserLikedPage: function handleUserLikedPage(err, response, userId) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_USER_LIKED_STAMPS_SUCCESS,
	      userId: userId,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleZineLatestPage: function handleZineLatestPage(err, response, zineSlug) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_ZINE_LATEST_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_ZINE_LATEST_STAMPS_SUCCESS,
	      zineSlug: zineSlug,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleZinePendingPage: function handleZinePendingPage(err, response, zineSlug) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_ZINE_PENDING_STAMPS_ERROR : _constantsActionTypes2['default'].REQUEST_ZINE_PENDING_STAMPS_SUCCESS,
	      zineSlug: zineSlug,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleStampLikePage: function handleStampLikePage(err, response, stampSegment) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_STAMP_LIKES_ERROR : _constantsActionTypes2['default'].REQUEST_STAMP_LIKES_SUCCESS,
	      stampSegment: stampSegment,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSearchPage: function handleSearchPage(err, response, terms) {
	    _AppDispatcher2['default'].handleServerAction({
	      type: err ? _constantsActionTypes2['default'].REQUEST_STAMP_SEARCH_ERROR : _constantsActionTypes2['default'].REQUEST_STAMP_SEARCH_SUCCESS,
	      terms: terms,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	exports['default'] = StampServerActionCreators;
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9),
	    AppDispatcher = __webpack_require__(6),
	    NotificationActionCreators = __webpack_require__(90),
	    NotificationMessages = __webpack_require__(78),
	    UserStore = __webpack_require__(5),
	    RouterStore = __webpack_require__(120),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58),
	    AlertActionCreators = __webpack_require__(32),
	    AlertTypes = __webpack_require__(48);

	var UserServerActionCreators = {
	  handleUser: function handleUser(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_ERROR : ActionTypes.REQUEST_USER_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);

	      var params = RouterStore.getRouterState().params;
	      if (err.status === 404 && parseInt(params.userId, 10) === userId) {
	        AlertActionCreators.showAlert(AlertTypes.NOT_FOUND);
	      }
	    }
	  },

	  handleToggleServiceAccountHidden: function handleToggleServiceAccountHidden(err, response, serviceType) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR : ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_SUCCESS,
	      response: response,
	      serviceType: serviceType
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleDisconnectServiceAccount: function handleDisconnectServiceAccount(err, response, serviceType) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.DISCONNECT_SERVICE_ACCOUNT_ERROR : ActionTypes.DISCONNECT_SERVICE_ACCOUNT_SUCCESS,
	      response: response,
	      serviceType: serviceType
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSaveSettings: function handleSaveSettings(err, response) {
	    AppDispatcher.handleServerFormAction({
	      type: err ? ActionTypes.SAVE_SETTINGS_ERROR : ActionTypes.SAVE_SETTINGS_SUCCESS,
	      response: response,
	      err: err
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      var me = UserStore.getMe();
	      if (me.isUnconfirmedEmail) {
	        var messageId = me.confirmedEmail ? NotificationMessages.USER_NEW_EMAIL_NEEDS_CONFIRMATION : NotificationMessages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION;

	        NotificationActionCreators.showNotification(messageId, {
	          email: me.email
	        });
	      }
	    }
	  },

	  handleRequestResetPassword: function handleRequestResetPassword(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_RESET_PASSWORD_ERROR : ActionTypes.REQUEST_RESET_PASSWORD_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.PASSWORD_RESET_CHECK_EMAIL);

	      if (!UserStore.isAuthenticated()) {
	        ModalActionCreators.showModal(ModalTypes.LOGIN);
	      }
	    }
	  },

	  handleResetPassword: function handleResetPassword(err, response) {
	    AppDispatcher.handleServerFormAction({
	      type: err ? ActionTypes.RESET_PASSWORD_ERROR : ActionTypes.RESET_PASSWORD_SUCCESS,
	      response: response,
	      err: err
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.PASSWORD_RESET_DONE);

	      if (!UserStore.isAuthenticated()) {
	        ModalActionCreators.showModal(ModalTypes.LOGIN);
	      } else {
	        ModalActionCreators.hideModal(ModalTypes.RESET_PASSWORD);
	      }
	    }
	  },

	  handleInvitationsPage: function handleInvitationsPage(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_INVITATIONS_ERROR : ActionTypes.REQUEST_INVITATIONS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleFeedback: function handleFeedback(err, response) {
	    AppDispatcher.handleServerFormAction({
	      type: err ? ActionTypes.FEEDBACK_ERROR : ActionTypes.FEEDBACK_SUCCESS,
	      response: response,
	      err: err
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      ModalActionCreators.hideModal(ModalTypes.FEEDBACK);
	      NotificationActionCreators.showNotification(NotificationMessages.FEEDBACK_SENT);
	    }
	  },

	  handleResendUnconfirmedEmail: function handleResendUnconfirmedEmail(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.RESEND_UNCONFIRMED_EMAIL_ERROR : ActionTypes.RESEND_UNCONFIRMED_EMAIL_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.USER_EMAIL_RESENT);
	    }
	  },

	  handleCancelUnconfirmedEmail: function handleCancelUnconfirmedEmail(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.CANCEL_UNCONFIRMED_EMAIL_ERROR : ActionTypes.CANCEL_UNCONFIRMED_EMAIL_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.hideNotification(NotificationMessages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION);
	      NotificationActionCreators.hideNotification(NotificationMessages.USER_NEW_EMAIL_NEEDS_CONFIRMATION);
	    }
	  },

	  handleResubscribeEmail: function handleResubscribeEmail(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.RESUBSCRIBE_EMAIL_ERROR : ActionTypes.RESUBSCRIBE_EMAIL_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.hideNotification(NotificationMessages.EMAIL_UNSUBSCRIBE);
	      NotificationActionCreators.showNotification(NotificationMessages.EMAIL_RESUBSCRIBED);
	    }
	  },

	  handleSaveEmailNotificationSettings: function handleSaveEmailNotificationSettings(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.SAVE_EMAIL_NOTIFICATION_SETTINGS_ERROR : ActionTypes.SAVE_EMAIL_NOTIFICATION_SETTINGS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleFollowUser: function handleFollowUser(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.FOLLOW_USER_ERROR : ActionTypes.FOLLOW_USER_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.USER_FOLLOWED, {
	        userId: userId
	      });
	    }
	  },

	  handleUnfollowUser: function handleUnfollowUser(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.UNFOLLOW_USER_ERROR : ActionTypes.UNFOLLOW_USER_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserSubscriberPage: function handleUserSubscriberPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_SUBSCRIBERS_ERROR : ActionTypes.REQUEST_USER_SUBSCRIBERS_SUCCESS,
	      userId: userId,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserSubscriptionPage: function handleUserSubscriptionPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_SUBSCRIPTIONS_ERROR : ActionTypes.REQUEST_USER_SUBSCRIPTIONS_SUCCESS,
	      userId: userId,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSearchPage: function handleSearchPage(err, response, terms) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_SEARCH_ERROR : ActionTypes.REQUEST_USER_SEARCH_SUCCESS,
	      terms: terms,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	module.exports = UserServerActionCreators;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$keys = __webpack_require__(304)['default'];

	var _ = __webpack_require__(4);
	var ActionTypes = __webpack_require__(9);
	var AppDispatcher = __webpack_require__(6);
	var SidebarActionCreators = __webpack_require__(29);
	var AlertActionCreators = __webpack_require__(32);
	var NotificationActionCreators = __webpack_require__(90);
	var NotificationMessages = __webpack_require__(78);
	var AlertTypes = __webpack_require__(48);
	var UserStore = __webpack_require__(5);
	var RouterStore = __webpack_require__(120);
	var _require = __webpack_require__(50);

	var replaceWith = _require.replaceWith;
	var makeHref = _require.makeHref;

	function makeErrorAlert(err) {
	  var body = err.body;
	  var status = err.status;

	  if (!status) {
	    return { id: AlertTypes.CONNECTION_ERROR };
	  }

	  if (!body) {
	    return { id: AlertTypes.SERVER_ERROR };
	  }

	  var firstErrorKey = _Object$keys(body).filter(function (key) {
	    return body[key];
	  })[0];
	  if (!firstErrorKey) {
	    return { id: AlertTypes.SERVER_ERROR };
	  }

	  var message = body[firstErrorKey].message;
	  return {
	    id: message.id,
	    options: _.omit(message, 'id')
	  };
	}

	var ZineServerActionCreators = {
	  handleZine: function handleZine(err, response, zineSlug) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_ZINE_ERROR : ActionTypes.REQUEST_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug
	    });

	    if (err) {
	      console.error(err);

	      var params = RouterStore.getRouterState().params;
	      if (err.status === 404 && params.zineSlug === zineSlug) {
	        AlertActionCreators.showAlert(AlertTypes.NOT_FOUND);
	      }
	    }
	  },

	  handleCreateZine: function handleCreateZine(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.CREATE_ZINE_ERROR : ActionTypes.CREATE_ZINE_SUCCESS,
	      response: response,
	      zineSlug: err ? null : response.result
	    });

	    if (err) {
	      var _makeErrorAlert = makeErrorAlert(err);

	      var id = _makeErrorAlert.id;
	      var options = _makeErrorAlert.options;

	      AlertActionCreators.showAlert(id, options);
	    } else {
	      replaceWith('zine', {
	        zineSlug: response.result
	      });
	    }
	  },

	  handleUpdateZine: function handleUpdateZine(err, response, zine) {
	    if (!err && response.result !== zine.slug) {
	      // Bail out of reconciling when slug changes
	      window.location = makeHref('zine', {
	        zineSlug: response.result
	      });
	      return;
	    }

	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.UPDATE_ZINE_ERROR : ActionTypes.UPDATE_ZINE_SUCCESS,
	      response: response,
	      zine: zine
	    });

	    if (err) {
	      var _makeErrorAlert2 = makeErrorAlert(err);

	      var id = _makeErrorAlert2.id;
	      var options = _makeErrorAlert2.options;

	      AlertActionCreators.showAlert(id, options);
	    }
	  },

	  handleFollowZine: function handleFollowZine(err, response, zineSlug) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.FOLLOW_ZINE_ERROR : ActionTypes.FOLLOW_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.ZINE_FOLLOWED, {
	        zineSlug: zineSlug
	      });
	    }
	  },

	  handleUnfollowZine: function handleUnfollowZine(err, response, zineSlug) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.UNFOLLOW_ZINE_ERROR : ActionTypes.UNFOLLOW_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleDeleteZine: function handleDeleteZine(err, response, zineSlug) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.DELETE_ZINE_ERROR : ActionTypes.DELETE_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      // Bail out of reconciling changes
	      window.location = makeHref('user', {
	        userId: UserStore.getMe().id
	      });
	    }
	  },

	  handleSubmitStampToZine: function handleSubmitStampToZine(err, response, zineSlug, stampSegment) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.SUBMIT_STAMP_TO_ZINE_ERROR : ActionTypes.SUBMIT_STAMP_TO_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      NotificationActionCreators.showNotification(NotificationMessages.STAMP_SUBMITTED_TO_ZINE, { zineSlug: zineSlug });
	    }
	  },

	  handleAddStampToZine: function handleAddStampToZine(err, response, zineSlug, stampSegment) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.ADD_STAMP_TO_ZINE_ERROR : ActionTypes.ADD_STAMP_TO_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment,
	      zineStampId: err ? null : response.result
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleRemoveStampFromZine: function handleRemoveStampFromZine(err, response, zineSlug, stampSegment) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REMOVE_STAMP_FROM_ZINE_ERROR : ActionTypes.REMOVE_STAMP_FROM_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleApproveStampToZine: function handleApproveStampToZine(err, response, zineSlug, stampSegment) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.APPROVE_STAMP_TO_ZINE_ERROR : ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment,
	      zineStampId: err ? null : response.result
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      SidebarActionCreators.hideSidebar();

	      NotificationActionCreators.showNotification(NotificationMessages.STAMP_APPROVED_TO_ZINE, { zineSlug: zineSlug });
	    }
	  },

	  handleRejectStampFromZine: function handleRejectStampFromZine(err, response, zineSlug, stampSegment, message) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REJECT_STAMP_FROM_ZINE_ERROR : ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS,
	      response: response,
	      zineSlug: zineSlug,
	      stampSegment: stampSegment,
	      message: message
	    });

	    if (err) {
	      console.error(err);
	    } else {
	      SidebarActionCreators.hideSidebar();

	      NotificationActionCreators.showNotification(NotificationMessages.STAMP_DECLINED_FROM_ZINE, { zineSlug: zineSlug });
	    }
	  },

	  handleRequestZineSections: function handleRequestZineSections(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_ZINE_SECTIONS_ERROR : ActionTypes.REQUEST_ZINE_SECTIONS_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleRequestZinesInSection: function handleRequestZinesInSection(err, response, sectionId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_ZINES_IN_SECTION_ERROR : ActionTypes.REQUEST_ZINES_IN_SECTION_SUCCESS,
	      response: response,
	      sectionId: sectionId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSuggestedPage: function handleSuggestedPage(err, response) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_SUGGESTED_ZINES_ERROR : ActionTypes.REQUEST_SUGGESTED_ZINES_SUCCESS,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserCuratedPage: function handleUserCuratedPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_CURATED_ZINES_ERROR : ActionTypes.REQUEST_USER_CURATED_ZINES_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserCuratedUnlistedPage: function handleUserCuratedUnlistedPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_CURATED_UNLISTED_ZINES_ERROR : ActionTypes.REQUEST_USER_CURATED_UNLISTED_ZINES_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserContributedPage: function handleUserContributedPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_CONTRIBUTED_ZINES_ERROR : ActionTypes.REQUEST_USER_CONTRIBUTED_ZINES_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleUserContributedUnlistedPage: function handleUserContributedUnlistedPage(err, response, userId) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_ERROR : ActionTypes.REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_SUCCESS,
	      response: response,
	      userId: userId
	    });

	    if (err) {
	      console.error(err);
	    }
	  },

	  handleSearchPage: function handleSearchPage(err, response, terms) {
	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_ZINE_SEARCH_ERROR : ActionTypes.REQUEST_ZINE_SEARCH_SUCCESS,
	      terms: terms,
	      response: response
	    });

	    if (err) {
	      console.error(err);
	    }
	  }
	};

	module.exports = ZineServerActionCreators;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Alert = __webpack_require__(117);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var AlertActionCreators = __webpack_require__(32);
	var PureRenderMixin = __webpack_require__(2);
	var DraftActionCreators = __webpack_require__(33);var PropTypes = React.PropTypes;

	var DeleteDraftAlert = React.createClass({
	  displayName: 'DeleteDraftAlert',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    draftUuid: PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      Alert,
	      { title: 'Delete Draft?',
	        message: 'Are you sure? Once it’s gone — it’s gone.' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleDeleteClick },
	          'Delete'
	        ),
	        React.createElement(
	          Button,
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    DraftActionCreators.deleteDraft(this.props.draftUuid);
	  },

	  handleCancelClick: function handleCancelClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = DeleteDraftAlert;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsAlert = __webpack_require__(117);

	var _organismsAlert2 = _interopRequireDefault(_organismsAlert);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _moleculesBtnGroup = __webpack_require__(44);

	var _moleculesBtnGroup2 = _interopRequireDefault(_moleculesBtnGroup);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	'use strict';

	var DeleteStampAlert = _react2['default'].createClass({
	  displayName: 'DeleteStampAlert',

	  mixins: [_mixinsPureRenderMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default'])],

	  propTypes: {
	    stampId: _react.PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      stamp: _storesStampStore2['default'].get(this.props.stampId)
	    };
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _organismsAlert2['default'],
	      { title: 'Delete Stamp?',
	        message: 'Are you sure? Once it’s gone — it’s gone.' },
	      _react2['default'].createElement(
	        _moleculesBtnGroup2['default'],
	        null,
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleDeleteClick },
	          'Delete'
	        ),
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(this.state.stamp);
	    _actionsStampActionCreators2['default'].deleteStamp(stampSegment);
	  },

	  handleCancelClick: function handleCancelClick() {
	    _actionsAlertActionCreators2['default'].hideAlert();
	  }
	});

	module.exports = DeleteStampAlert;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Alert = __webpack_require__(117);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var AlertActionCreators = __webpack_require__(32);
	var ZineActionCreators = __webpack_require__(41);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var DeleteZineAlert = React.createClass({
	  displayName: 'DeleteZineAlert',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    zineSlug: PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      Alert,
	      { title: 'Delete Collection?',
	        message: 'Are you sure? Once it’s gone — it’s gone.' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleDeleteClick },
	          'Delete'
	        ),
	        React.createElement(
	          Button,
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    ZineActionCreators.deleteZine(this.props.zineSlug);
	  },

	  handleCancelClick: function handleCancelClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = DeleteZineAlert;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Alert = __webpack_require__(117);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var AlertActionCreators = __webpack_require__(32);
	var DraftActionCreators = __webpack_require__(33);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var EditorDeleteSectionAlert = React.createClass({
	  displayName: 'EditorDeleteSectionAlert',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    sectionId: PropTypes.number.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      Alert,
	      { title: 'Delete this block?' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleDeleteClick },
	          'Delete'
	        ),
	        React.createElement(
	          Button,
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    DraftActionCreators.deleteSection(this.props.sectionId);
	    AlertActionCreators.hideAlert();
	  },

	  handleCancelClick: function handleCancelClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = EditorDeleteSectionAlert;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Alert = __webpack_require__(117),
	    Button = __webpack_require__(13),
	    BtnGroup = __webpack_require__(44),
	    AlertActionCreators = __webpack_require__(32),
	    DraftActionCreators = __webpack_require__(33),
	    PureRenderMixin = __webpack_require__(2);

	var EditorDisregardChangesAlert = React.createClass({
	  displayName: 'EditorDisregardChangesAlert',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      Alert,
	      { title: 'Don’t Save?',
	        message: 'The changes you made will not be saved.' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleLeaveClick },
	          'Don’t Save'
	        ),
	        React.createElement(
	          Button,
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleLeaveClick: function handleLeaveClick() {
	    DraftActionCreators.cancelEditingStamp(true);
	    AlertActionCreators.hideAlert();
	  },

	  handleCancelClick: function handleCancelClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = EditorDisregardChangesAlert;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Alert = __webpack_require__(117),
	    Button = __webpack_require__(13),
	    BtnGroup = __webpack_require__(44),
	    AlertActionCreators = __webpack_require__(32),
	    UserActionCreators = __webpack_require__(47),
	    PureRenderMixin = __webpack_require__(2);

	var LogOutAlert = React.createClass({
	  displayName: 'LogOutAlert',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      Alert,
	      { title: 'Log Out?' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'red',
	            size: 'large',
	            onClick: this.handleLogOut },
	          'Log Out'
	        ),
	        React.createElement(
	          Button,
	          { size: 'large',
	            onClick: this.handleCancelClick },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleLogOut: function handleLogOut() {
	    UserActionCreators.logOut();
	  },

	  handleCancelClick: function handleCancelClick() {
	    AlertActionCreators.hideAlert();
	  }
	});

	module.exports = LogOutAlert;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsAlert = __webpack_require__(117);

	var _organismsAlert2 = _interopRequireDefault(_organismsAlert);

	var _alertsOkayAlert = __webpack_require__(390);

	var _alertsOkayAlert2 = _interopRequireDefault(_alertsOkayAlert);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _actionsShareActionCreators = __webpack_require__(91);

	var _actionsShareActionCreators2 = _interopRequireDefault(_actionsShareActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _moleculesShare = __webpack_require__(206);

	var _moleculesShare2 = _interopRequireDefault(_moleculesShare);

	var _constantsServiceTypes = __webpack_require__(35);

	var _constantsServiceTypes2 = _interopRequireDefault(_constantsServiceTypes);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _router = __webpack_require__(50);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	'use strict';

	var SharePostedStampAlert = _react2['default'].createClass({
	  displayName: 'SharePostedStampAlert',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      stamp: _storesStampStore2['default'].get(props.stampId)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    var stampId = this.props.stampId;

	    (0, _reactLibInvariant2['default'])(_storesStampStore2['default'].contains(stampId), 'Expected stamp %s to exist in store', stampId);
	  },

	  render: function render() {
	    var stamp = this.state.stamp;

	    switch (stamp.status) {
	      case _constantsStampStatus2['default'].PUBLIC:
	        return _react2['default'].createElement(
	          _organismsAlert2['default'],
	          { title: 'Your Stamp has been posted',
	            message: 'Share your work to give recognition it deserves.' },
	          _react2['default'].createElement(_moleculesShare2['default'], { onShareClick: this.handleShareClick,
	            services: [_constantsServiceTypes2['default'].FACEBOOK, _constantsServiceTypes2['default'].TWITTER, _constantsServiceTypes2['default'].GOOGLE],
	            size: 'medium' })
	        );
	      case _constantsStampStatus2['default'].UNLISTED:
	        var stampSegment = (0, _utilsGetStampSegment2['default'])(stamp);
	        var stampLink = window.location.origin + (0, _router.makeHref)('feedStamp', { stampSegment: stampSegment });
	        var handleClick = function handleClick(e) {
	          e.target.select();
	        };

	        return _react2['default'].createElement(_alertsOkayAlert2['default'], { title: 'Your Stamp has been posted',
	          message: _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	              mode: 'fill',
	              size: 'medium' }),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            'It is visible only to those who have the link. Copy and paste the link below to share it:',
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('input', { className: 'FormInput', value: stampLink, readOnly: true, onClick: handleClick })
	          ),
	          buttonText: 'Got it' });
	    }
	  },

	  handleShareClick: function handleShareClick(service) {
	    _actionsShareActionCreators2['default'].shareStamp({
	      stampId: this.props.stampId,
	      service: service,
	      source: _constantsAnalyticsSources2['default'].ALERT
	    });
	  }
	});

	module.exports = SharePostedStampAlert;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(552);
	var _require = __webpack_require__(122);

	var get = _require.get;
	var del = _require.del;

	var ActivityAPI = {
	  requestActivitiesPage: function requestActivitiesPage(url) {
	    url = url || '/api/user/activities';
	    get(url, Actions.handleActivitiesPage);
	  },

	  requestUnseenCount: function requestUnseenCount() {
	    get('/api/user/activities/unseen', Actions.handleUnseenCount);
	  },

	  markAll: function markAll() {
	    del('/api/user/activities/unseen', Actions.handleMarkAll);
	  }
	};

	module.exports = ActivityAPI;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _actionsDraftServerActionCreators = __webpack_require__(553);

	var _actionsDraftServerActionCreators2 = _interopRequireDefault(_actionsDraftServerActionCreators);

	var _utilsAPIUtils = __webpack_require__(122);

	'use strict';

	var DraftAPI = {
	  saveDraft: function saveDraft(draft) {
	    if (draft.uuid) {
	      (0, _utilsAPIUtils.put)('/api/drafts/' + draft.uuid, draft, _actionsDraftServerActionCreators2['default'].handleSaveDraft, draft.uuid);
	    } else {
	      (0, _utilsAPIUtils.post)('/api/drafts', draft, _actionsDraftServerActionCreators2['default'].handleSaveDraft, null);
	    }
	  },

	  loadStampInEditor: function loadStampInEditor(stampId) {
	    (0, _utilsAPIUtils.get)('/api/stamps/' + stampId, _actionsDraftServerActionCreators2['default'].handleLoadStampInEditor, stampId);
	  },

	  loadDraftInEditor: function loadDraftInEditor(draftUuid) {
	    (0, _utilsAPIUtils.get)('/api/drafts/' + draftUuid, _actionsDraftServerActionCreators2['default'].handleLoadDraftInEditor, draftUuid);
	  },

	  deleteDraft: function deleteDraft(draftUuid) {
	    (0, _utilsAPIUtils.del)('/api/drafts/' + draftUuid, _actionsDraftServerActionCreators2['default'].handleDeleteDraft, draftUuid);
	  },

	  sendFeedback: function sendFeedback(draftUuid, message) {
	    (0, _utilsAPIUtils.post)('/api/drafts/' + draftUuid + '/feedback', { message: message }, _actionsDraftServerActionCreators2['default'].handleSendFeedback, draftUuid);
	  },

	  requestDraftsPage: function requestDraftsPage(url) {
	    url = url || '/api/drafts';
	    (0, _utilsAPIUtils.get)(url, _actionsDraftServerActionCreators2['default'].handleDraftsPage);
	  },

	  requestDraftFeedbacksPage: function requestDraftFeedbacksPage(draftUuid, url) {
	    url = url || '/api/drafts/' + draftUuid + '/feedback';
	    (0, _utilsAPIUtils.get)(url, _actionsDraftServerActionCreators2['default'].handleDraftFeedbacksPage, draftUuid);
	  }
	};

	exports['default'] = DraftAPI;
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(555);
	var _require = __webpack_require__(122);

	var get = _require.get;
	var post = _require.post;
	var del = _require.del;

	var ImageAPI = {
	  addToGrabbag: function addToGrabbag(uuid, stampId) {
	    post('/api/images/saved', { uuid: uuid, stampId: stampId }, Actions.handleAddToGrabbag, uuid, stampId);
	  },

	  requestGrabbagImagesPage: function requestGrabbagImagesPage(tab, url) {
	    url = url || '/api/images/' + tab;
	    get(url, Actions.handleGrabbagImagesPage, tab);
	  },

	  removeFromGrabbag: function removeFromGrabbag(uuid) {
	    del('/api/images/saved/' + uuid, { uuid: uuid }, Actions.handleRemoveFromGrabbag, uuid);
	  },

	  removeStampletItem: function removeStampletItem(uuid) {
	    del('/api/images/stamplet/' + uuid, { uuid: uuid }, Actions.handleRemoveStampletItem, uuid);
	  },

	  requestImageUsedInStampsPage: function requestImageUsedInStampsPage(imageUuid, url) {
	    url = url || '/api/images/' + imageUuid + '/stamps';
	    get(url, Actions.handleImageUsedInStampsPage, imageUuid);
	  }
	};

	module.exports = ImageAPI;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(565);
	var UserStore = __webpack_require__(5);
	var _require = __webpack_require__(122);

	var get = _require.get;
	var patch = _require.patch;
	var del = _require.del;

	var post = _require.post;
	var _require2 = __webpack_require__(4);

	var pick = _require2.pick;

	var UserAPI = {
	  requestUser: function requestUser(userId) {
	    var url = '/api/users/' + userId;
	    get(url, Actions.handleUser, userId);
	  },

	  toggleServiceAccountHidden: function toggleServiceAccountHidden(serviceType, hidden) {
	    var data = { hidden: hidden };
	    patch('/api/user/services/' + serviceType, data, Actions.handleToggleServiceAccountHidden, serviceType);
	  },

	  disconnectServiceAccount: function disconnectServiceAccount(serviceType) {
	    del('/api/user/services/' + serviceType, Actions.handleDisconnectServiceAccount, serviceType);
	  },

	  saveSettings: function saveSettings(settings) {
	    patch('/api/user', settings, Actions.handleSaveSettings);
	  },

	  requestResetPassword: function requestResetPassword(data) {
	    post('/api/user/reset-password', data, Actions.handleRequestResetPassword);
	  },

	  resetPassword: function resetPassword(data) {
	    patch('/api/user', data, Actions.handleResetPassword);
	  },

	  sendFeedback: function sendFeedback(data) {
	    post('/api/feedback', data, Actions.handleFeedback);
	  },

	  resendUnconfirmedEmail: function resendUnconfirmedEmail() {
	    post('/api/user/unconfirmed-email/resend', Actions.handleResendUnconfirmedEmail);
	  },

	  cancelUnconfirmedEmail: function cancelUnconfirmedEmail() {
	    del('/api/user/unconfirmed-email', Actions.handleCancelUnconfirmedEmail);
	  },

	  resubscribeEmail: function resubscribeEmail(data) {
	    post('/api/user/resubscribe-email', data, Actions.handleResubscribeEmail);
	  },

	  saveEmailNotificationSettings: function saveEmailNotificationSettings() {
	    var data = pick(UserStore.getMe(), 'emailFlags');
	    patch('/api/user', data, Actions.handleSaveEmailNotificationSettings);
	  },

	  followUser: function followUser(userId) {
	    post('/api/users/' + userId + '/subscriptions', Actions.handleFollowUser, userId);
	  },

	  unfollowUser: function unfollowUser(userId) {
	    del('/api/users/' + userId + '/subscriptions', Actions.handleUnfollowUser, userId);
	  },

	  requestUserSubscriberPage: function requestUserSubscriberPage(userId, url) {
	    url = url || '/api/users/' + userId + '/subscribers';
	    get(url, Actions.handleUserSubscriberPage, userId);
	  },

	  requestUserSubscriptionPage: function requestUserSubscriptionPage(userId, url) {
	    url = url || '/api/users/' + userId + '/subscriptions';
	    get(url, Actions.handleUserSubscriptionPage, userId);
	  },

	  requestSearchPage: function requestSearchPage(terms, url) {
	    url = url || '/api/users/search?q=' + window.encodeURIComponent(terms);
	    get(url, Actions.handleSearchPage, terms);
	  }
	};

	module.exports = UserAPI;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Actions = __webpack_require__(566);
	var _require = __webpack_require__(122);

	var get = _require.get;
	var del = _require.del;
	var put = _require.put;
	var post = _require.post;

	var ZineAPI = {
	  requestZine: function requestZine(zineSlug) {
	    var url = '/api/zines/' + zineSlug;
	    get(url, Actions.handleZine, zineSlug);
	  },

	  createZine: function createZine(zine) {
	    var url = '/api/zines';
	    post(url, zine, Actions.handleCreateZine, zine);
	  },

	  updateZine: function updateZine(zine) {
	    var url = '/api/zines/' + zine.slug;
	    put(url, zine, Actions.handleUpdateZine, zine);
	  },

	  followZine: function followZine(zineSlug) {
	    var url = '/api/zines/' + zineSlug + '/subscriptions';
	    post(url, Actions.handleFollowZine, zineSlug);
	  },

	  unfollowZine: function unfollowZine(zineSlug) {
	    var url = '/api/zines/' + zineSlug + '/subscriptions';
	    del(url, Actions.handleUnfollowZine, zineSlug);
	  },

	  deleteZine: function deleteZine(zineSlug) {
	    var url = '/api/zines/' + zineSlug;
	    del(url, Actions.handleDeleteZine, zineSlug);
	  },

	  submitStampToZine: function submitStampToZine(zineSlug, stampSegment) {
	    var url = '/api/zines/' + zineSlug + '/stamps/' + stampSegment;
	    put(url, Actions.handleSubmitStampToZine, zineSlug, stampSegment);
	  },

	  addStampToZine: function addStampToZine(zineSlug, stampSegment) {
	    var url = '/api/zines/' + zineSlug + '/stamps/' + stampSegment;
	    put(url, Actions.handleAddStampToZine, zineSlug, stampSegment);
	  },

	  removeStampFromZine: function removeStampFromZine(zineSlug, stampSegment) {
	    var url = '/api/zines/' + zineSlug + '/stamps/' + stampSegment;
	    del(url, Actions.handleRemoveStampFromZine, zineSlug, stampSegment);
	  },

	  approveStampToZine: function approveStampToZine(zineSlug, stampSegment, message) {
	    var url = '/api/zines/' + zineSlug + '/stamps/' + stampSegment + '/approve';
	    post(url, {
	      message: message
	    }, Actions.handleApproveStampToZine, zineSlug, stampSegment, message);
	  },

	  rejectStampFromZine: function rejectStampFromZine(zineSlug, stampSegment, message) {
	    var url = '/api/zines/' + zineSlug + '/stamps/' + stampSegment;
	    del(url, {
	      message: message
	    }, Actions.handleRejectStampFromZine, zineSlug, stampSegment, message);
	  },

	  requestZinesInSection: function requestZinesInSection(sectionId, url) {
	    url = url || '/api/zines/sections/' + sectionId + '/zines';
	    get(url, Actions.handleRequestZinesInSection, sectionId);
	  },

	  requestZineSections: function requestZineSections(url) {
	    url = url || '/api/zines/sections';
	    get(url, Actions.handleRequestZineSections);
	  },

	  requestSuggestedPage: function requestSuggestedPage(url) {
	    url = url || '/api/zines/suggested';
	    get(url, Actions.handleSuggestedPage);
	  },

	  requestUserCuratedPage: function requestUserCuratedPage(userId, url) {
	    url = url || '/api/users/' + userId + '/zines/curated';
	    get(url, Actions.handleUserCuratedPage, userId);
	  },

	  requestUserCuratedUnlistedPage: function requestUserCuratedUnlistedPage(userId, url) {
	    url = url || '/api/users/' + userId + '/zines/curated/unlisted';
	    get(url, Actions.handleUserCuratedUnlistedPage, userId);
	  },

	  requestUserContributedPage: function requestUserContributedPage(userId, url) {
	    url = url || '/api/users/' + userId + '/zines/contributed';
	    get(url, Actions.handleUserContributedPage, userId);
	  },

	  requestUserContributedUnlistedPage: function requestUserContributedUnlistedPage(userId, url) {
	    url = url || '/api/users/' + userId + '/zines/contributed/unlisted';
	    get(url, Actions.handleUserContributedUnlistedPage, userId);
	  },

	  requestSearchPage: function requestSearchPage(terms, url) {
	    url = url || '/api/zines/search?q=' + window.encodeURIComponent(terms);
	    get(url, Actions.handleSearchPage, terms);
	  }
	};

	module.exports = ZineAPI;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var AudioPlayer = React.createClass({
	  displayName: 'AudioPlayer',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    source: PropTypes.string.isRequired,
	    isPlaying: PropTypes.bool.isRequired,
	    currentTime: PropTypes.number.isRequired,
	    onTimeUpdate: PropTypes.func.isRequired,
	    onProgress: PropTypes.func,
	    onEnd: PropTypes.func.isRequired,
	    onError: PropTypes.func.isRequired
	  },

	  componentDidMount: function componentDidMount() {
	    var node = this.getDOMNode();

	    node.addEventListener('loadedmetadata', this.handleLoadedMetadata);
	    node.addEventListener('progress', this.handleProgress);
	    node.addEventListener('timeupdate', this.handleTimeUpdate);
	    node.addEventListener('ended', this.handleMediaEnd);
	    node.addEventListener('error', this.handleError, true);

	    // It is important to begin loading as soon as possible
	    // so we learn about errors. Safari doesn't even emit
	    // error event for the first time if we don't call load here.

	    node.load();
	    this.updateIsPlaying();
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.source !== this.props.source) {
	      this.updateSource();
	    }

	    if (prevProps.isPlaying !== this.props.isPlaying) {
	      this.updateIsPlaying();
	    }

	    if (this.props.currentTime !== this._lastReportedTime) {
	      this.updateCurrentTime();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    var node = this.getDOMNode();

	    node.removeEventListener('loadedmetadata', this.handleLoadedMetadata);
	    node.removeEventListener('progress', this.handleProgress);
	    node.removeEventListener('timeupdate', this.handleTimeUpdate);
	    node.removeEventListener('ended', this.handleMediaEnd);
	    node.removeEventListener('error', this.handleError, true);
	  },

	  render: function render() {
	    return React.createElement(
	      'audio',
	      { preload: 'none' },
	      React.createElement('source', { src: this.props.source,
	        type: 'audio/mpeg' })
	    );
	  },

	  handleLoadedMetadata: function handleLoadedMetadata() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.updateCurrentTime();
	  },

	  handleTimeUpdate: function handleTimeUpdate() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var node = this.getDOMNode(),
	        currentTime = node.currentTime,
	        trackDuration = node.duration;

	    this._lastReportedTime = currentTime;
	    this.props.onTimeUpdate({
	      currentTime: currentTime,
	      trackDuration: trackDuration
	    });
	  },

	  handleMediaEnd: function handleMediaEnd() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.getDOMNode().currentTime = 0;
	    this.props.onEnd();
	  },

	  handleProgress: function handleProgress() {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (!this.props.onProgress) {
	      return;
	    }

	    var node = this.getDOMNode(),
	        trackDuration = node.duration,
	        buffered = node.buffered;

	    this.props.onProgress({
	      trackDuration: trackDuration,
	      buffered: buffered
	    });
	  },

	  handleError: function handleError() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.props.onError();
	  },

	  updateCurrentTime: function updateCurrentTime() {
	    var node = this.getDOMNode();
	    if (node.readyState) {
	      node.currentTime = this.props.currentTime;
	    }
	  },

	  updateIsPlaying: function updateIsPlaying() {
	    var node = this.getDOMNode(),
	        isPlaying = this.props.isPlaying;

	    if (isPlaying) {
	      node.play();
	    } else {
	      node.pause();
	    }
	  },

	  updateSource: function updateSource() {
	    var node = this.getDOMNode(),
	        isPlaying = this.props.isPlaying;

	    node.pause();
	    node.load();

	    if (isPlaying) {
	      node.play();
	    }
	  }
	});

	module.exports = AudioPlayer;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(900);

	var MIN_PROGRESS = 0.005;

	var AudioProgress = React.createClass({
	  displayName: 'AudioProgress',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    trackDuration: PropTypes.number.isRequired,
	    currentTime: PropTypes.number.isRequired,
	    onChangeTime: PropTypes.func.isRequired
	  },

	  handleChangeTime: function handleChangeTime(event) {
	    var clickOffset = event.pageX,
	        clickTarget = event.target,
	        width = this.getDOMNode().offsetWidth;

	    if (width === 0) {
	      return;
	    }

	    while (clickTarget) {
	      clickOffset -= clickTarget.offsetLeft;
	      clickTarget = clickTarget.offsetParent;
	    }

	    var time = Math.min(Math.ceil(clickOffset * this.props.trackDuration / width), this.props.trackDuration);

	    this.props.onChangeTime(time);
	  },

	  render: function render() {
	    var _props = this.props;
	    var currentTime = _props.currentTime;
	    var trackDuration = _props.trackDuration;
	    var progress = 0;

	    if (currentTime && trackDuration) {
	      progress = Math.max(MIN_PROGRESS, currentTime / trackDuration);
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        onClick: this.handleChangeTime },
	      React.createElement('div', { className: 'AudioProgress-currentTime',
	        style: {
	          width: Math.round(progress * 100) + '%'
	        } })
	    );
	  }
	});

	module.exports = AudioProgress;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Link = __webpack_require__(21);
	var Icon = __webpack_require__(10);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(902);

	var CheckLink = React.createClass({
	  displayName: 'CheckLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    onClick: PropTypes.func.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'span',
	      { className: 'CheckLink' },
	      React.createElement(
	        Link,
	        { className: 'CheckLink-label',
	          onClick: this.props.onClick },
	        this.props.children
	      ),
	      React.createElement(
	        'div',
	        { className: 'CheckLink-check' },
	        React.createElement(Icon, { name: 'check',
	          size: 'small',
	          mode: 'stroke' })
	      )
	    );
	  }
	});

	module.exports = CheckLink;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(905);

	var Dot = React.createClass({
	  displayName: 'Dot',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    active: PropTypes.bool.isRequired,
	    onClick: PropTypes.func.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      active: this.props.active
	    };
	  },

	  render: function render() {
	    return React.createElement('div', { className: this.getClassName(),
	      onClick: this.props.onClick });
	  }
	});

	module.exports = Dot;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Link = __webpack_require__(21);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var DraftLink = React.createClass({
	  displayName: 'DraftLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    draft: PropTypes.object.isRequired,
	    emptyTitle: PropTypes.string,
	    bold: PropTypes.bool
	  },

	  render: function render() {
	    var _props = this.props;
	    var draft = _props.draft;
	    var children = _props.children;
	    var bold = _props.bold;
	    var showTitle = _props.showTitle;
	    var emptyTitle = _props.emptyTitle;

	    return React.createElement(
	      Link,
	      { to: 'draftPreview',
	        params: { stampSegment: draft.uuid },
	        bold: bold,
	        title: showTitle && draft.title },
	      children || draft.title || emptyTitle
	    );
	  }
	});

	module.exports = DraftLink;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(911);

	var Overlay = React.createClass({
	  displayName: 'Overlay',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    transparent: PropTypes.bool,
	    onTouchTap: PropTypes.func.isRequired
	  },

	  className: 'Overlay',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.transparent && 'transparent'];
	  },

	  render: function render() {
	    return React.createElement('div', { className: this.getClassName(),
	      onTouchTap: this.props.onTouchTap });
	  }
	});

	module.exports = Overlay;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(912);

	var PinIt = React.createClass({
	  displayName: 'PinIt',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'PinIt',

	  propTypes: {
	    onTouchTap: React.PropTypes.func
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        onTouchTap: this.props.onTouchTap },
	      React.createElement('div', { className: 'PinIt-button' })
	    );
	  }
	});

	module.exports = PinIt;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ShareLink = __webpack_require__(252);
	var ShareActionCreators = __webpack_require__(91);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ShareUserLink = React.createClass({
	  displayName: 'ShareUserLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    user: PropTypes.object.isRequired,
	    service: PropTypes.any.isRequired,
	    propagateClick: PropTypes.bool
	  },

	  contextTypes: {
	    source: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(ShareLink, { service: this.props.service,
	      onClick: this.handleClick,
	      propagateClick: this.props.propagateClick,
	      context: this.props.context,
	      underline: this.props.underline,
	      bold: this.props.bold });
	  },

	  handleClick: function handleClick() {
	    var _props = this.props;
	    var service = _props.service;
	    var userId = _props.user.id;

	    ShareActionCreators.shareUser({
	      userId: userId,
	      service: service,
	      source: this.context.source
	    });
	  }
	});

	module.exports = ShareUserLink;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ShareLink = __webpack_require__(252);
	var ShareActionCreators = __webpack_require__(91);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ShareZineLink = React.createClass({
	  displayName: 'ShareZineLink',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    zine: PropTypes.object.isRequired,
	    service: PropTypes.any.isRequired,
	    propagateClick: PropTypes.bool
	  },

	  contextTypes: {
	    source: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(ShareLink, { service: this.props.service,
	      onClick: this.handleClick,
	      propagateClick: this.props.propagateClick,
	      context: this.props.context,
	      underline: this.props.underline,
	      bold: this.props.bold });
	  },

	  handleClick: function handleClick() {
	    var _props = this.props;
	    var service = _props.service;
	    var zineSlug = _props.zine.slug;

	    ShareActionCreators.shareZine({
	      zineSlug: zineSlug,
	      service: service,
	      source: this.context.source
	    });
	  }
	});

	module.exports = ShareZineLink;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var getQueryUrl = __webpack_require__(438);
	var flushUpdates = __webpack_require__(436);
	var loadSoundCloudAPI = __webpack_require__(1178)('https://w.soundcloud.com/player/api.js', 'SC');
	var SC = null;
	var assign = __webpack_require__(15);var PropTypes = React.PropTypes;

	var OPTIONS = {
	  'auto_play': false,
	  'buying': false,
	  'liking': false,
	  'download': false,
	  'sharing': false,
	  'show_artwork': false,
	  'show_comments': false,
	  'show_playcount': false,
	  'show_user': false
	};

	var SoundCloudPlayer = React.createClass({
	  displayName: 'SoundCloudPlayer',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    source: PropTypes.string.isRequired,
	    isPlaying: PropTypes.bool.isRequired,
	    preload: PropTypes.bool,
	    currentTime: PropTypes.number,
	    onTimeUpdate: PropTypes.func.isRequired,
	    onEnd: PropTypes.func.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      isInitialized: false,
	      isReady: false
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var _this = this;

	    var source = this.props.source;
	    var iframe = document.createElement('iframe');

	    // Create iframe after mounting to work around WebKit bug
	    // that caused <img onload> not firing for images added in same tick.

	    // Put iframe into body to avoid layout issues in Firefox.
	    // Note that with display:none sound wouldn't play in Firefox.

	    iframe.style.position = 'absolute';
	    iframe.style.pointerEvents = 'none';
	    iframe.style.opacity = 0;
	    iframe.style.left = '-9999px';
	    iframe.style.top = '-9999px';
	    iframe.style.width = 0;
	    iframe.style.height = 0;
	    iframe.style.zIndex = -999;
	    iframe.src = getQueryUrl('//w.soundcloud.com/player/', assign({
	      url: source
	    }, OPTIONS));

	    document.body.appendChild(iframe);
	    this._iframe = iframe;

	    loadSoundCloudAPI(function (error, api) {
	      if (!_this.isMounted()) {
	        return;
	      }

	      SC = api;

	      _this.widget = SC.Widget(iframe);

	      _this.widget.bind(SC.Widget.Events.PLAY, _this.handlePlay);
	      _this.widget.bind(SC.Widget.Events.PLAY_PROGRESS, _this.handleTimeUpdate);
	      _this.widget.bind(SC.Widget.Events.FINISH, _this.handleMediaEnd);
	      _this.widget.bind(SC.Widget.Events.READY, function () {
	        return _this.handleWidgetIsReady(source);
	      });
	    });
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.source !== this.props.source) {
	      this.updateSource();
	    }

	    if (prevProps.isPlaying !== this.props.isPlaying) {
	      this.updateIsPlaying();
	    }

	    if (this._lastReportedTime !== this.props.currentTime) {
	      this.updateCurrentTime();
	    }

	    if (prevState.isReady !== this.state.isReady) {
	      this.updateIsPlaying();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (this.widget) {
	      this.widget.unbind(SC.Widget.Events.READY);
	      this.widget.unbind(SC.Widget.Events.PLAY);
	      this.widget.unbind(SC.Widget.Events.PLAY_PROGRESS);
	      this.widget.unbind(SC.Widget.Events.FINISH);
	    }

	    document.body.removeChild(this._iframe);
	  },

	  render: function render() {
	    return null;
	  },

	  handleWidgetIsReady: function handleWidgetIsReady(source) {
	    var _this2 = this;

	    if (!this.isMounted()) {
	      return;
	    }

	    this.widget.getDuration(function (duration) {
	      if (!_this2.isMounted()) {
	        return;
	      }

	      var sourceChanged = _this2.props.source !== source,
	          isInitialized = _this2.state.isInitialized;

	      if (_this2.state.isReady || sourceChanged && isInitialized) {
	        return;
	      }

	      flushUpdates(function () {
	        _this2.setState({
	          trackDuration: duration,
	          isReady: true,
	          isInitialized: true
	        }, function () {
	          if (sourceChanged && !isInitialized) {
	            _this2.updateSource();
	          }
	        });
	      });
	    });
	  },

	  handleTimeUpdate: function handleTimeUpdate(time) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (this.state.trackDuration) {
	      var currentTime = Math.floor(time.currentPosition / 1000),
	          trackDuration = Math.floor(this.state.trackDuration / 1000);

	      this._lastReportedTime = currentTime;
	      this.props.onTimeUpdate({
	        currentTime: currentTime,
	        trackDuration: trackDuration
	      });
	    }
	  },

	  handleMediaEnd: function handleMediaEnd() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.props.onEnd();
	  },

	  handlePlay: function handlePlay() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.updateCurrentTime();
	  },

	  updateCurrentTime: function updateCurrentTime() {
	    if (!this.state.isReady) {
	      return;
	    }

	    this.widget.seekTo(this.props.currentTime * 1000);
	  },

	  updateIsPlaying: function updateIsPlaying() {
	    if (!this.state.isReady) {
	      return;
	    }

	    if (this.props.isPlaying) {
	      this.widget.play();
	    } else {
	      this.widget.pause();
	    }
	  },

	  updateSource: function updateSource() {
	    var _this3 = this;

	    if (!this.state.isInitialized) {
	      return;
	    }

	    flushUpdates(function () {
	      _this3.setState({
	        isReady: false,
	        trackDuration: null
	      });
	    });

	    var source = this.props.source;

	    this.widget.pause();
	    this.widget.load(source, assign({
	      callback: function callback() {
	        return _this3.handleWidgetIsReady(source);
	      }
	    }, OPTIONS));
	  }
	});

	module.exports = SoundCloudPlayer;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Icon = __webpack_require__(10),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(914);

	var Tag = React.createClass({
	  displayName: 'Tag',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    content: React.PropTypes.string.isRequired,
	    icon: React.PropTypes.string,
	    onRemove: React.PropTypes.func
	  },

	  className: 'Tag',

	  render: function render() {
	    return React.createElement(
	      'span',
	      { className: this.getClassName() },
	      this.props.icon && React.createElement(Icon, { name: this.props.icon,
	        size: 'xsmall',
	        mode: this.props.icon === 'email' ? 'stroke' : 'fill' }),
	      React.createElement(
	        'span',
	        { className: 'Tag-content' },
	        this.props.content
	      ),
	      this.props.onRemove && React.createElement(Icon, { name: 'cross',
	        size: 'xxsmall',
	        mode: 'stroke',
	        onClick: this.props.onRemove })
	    );
	  }
	});

	module.exports = Tag;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2),
	    _getThumbnailUrl = __webpack_require__(37),
	    getZineThumbnail = __webpack_require__(178),
	    PropTypes = React.PropTypes;

	__webpack_require__(916);

	// sync with sizes.less
	var thumbnailSizes = {
	  'xsmall': 28, // @UserImage--xsmall
	  'small': 32, // @UserImage--small
	  'medium': 44, // @UserImage--medium
	  'large': 80, // @UserImage--large
	  'xlarge': 120 // @UserImage--xlarge
	};

	var ZineImage = React.createClass({
	  displayName: 'ZineImage',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'ZineImage',

	  propTypes: {
	    zine: PropTypes.shape({
	      thumbnailUrl: PropTypes.string
	    }).isRequired,
	    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium'
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  getThumbnailUrl: function getThumbnailUrl() {
	    var thumbnail = getZineThumbnail(this.props.zine),
	        size = thumbnailSizes[this.props.size];

	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    if (devicePixelRatio > 1.5) {
	      size *= 2;
	    }

	    return _getThumbnailUrl(thumbnail, {
	      allowExternal: true,
	      allowEmpty: true,
	      mode: 'scale_crop',
	      width: size,
	      height: size
	    });
	  },

	  render: function render() {
	    var style = {},
	        url = this.getThumbnailUrl();

	    if (url) {
	      style.backgroundImage = 'url(' + url + ')';
	    }

	    return React.createElement('div', { className: this.getClassName(),
	      style: style });
	  }
	});

	module.exports = ZineImage;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ArrowDownIcon = React.createClass({
	  displayName: 'ArrowDownIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 5.000000)"><path d="M0 0L7 7"/><path d="M14 0L7 7"/></g></g></g>';
	      case 'medium':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 8.000000)"><path d="M0 0L14 14"/><path d="M28 0L14 14"/></g></g></g>';
	      case 'large':
	        return '<g stroke-width="1"><g stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 11.000000)"><path d="M0 1L22 22.88"/><path d="M44 1L22 22.87"/></g></g></g>';
	    }
	  }
	});

	module.exports = ArrowDownIcon;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ArrowLeftIcon = React.createClass({
	  displayName: 'ArrowLeftIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 5.000000)"><path d="M0 0L7 7"/><path d="M14 0L7 7"/></g></g></g>';
	      case 'medium':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 8.000000)"><path d="M0 0L14 14"/><path d="M28 0L14 14"/></g></g></g>';
	      case 'large':
	        return '<g stroke-width="1"><g stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 11.000000)"><path d="M0 1L22 22.88"/><path d="M44 1L22 22.87"/></g></g></g>';
	    }
	  }
	});

	module.exports = ArrowLeftIcon;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ArrowRightIcon = React.createClass({
	  displayName: 'ArrowRightIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 5.000000)"><path d="M0 0L7 7"/><path d="M14 0L7 7"/></g></g></g>';
	      case 'medium':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 8.000000)"><path d="M0 0L14 14"/><path d="M28 0L14 14"/></g></g></g>';
	      case 'large':
	        return '<g stroke-width="1"><g stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 11.000000)"><path d="M0 1L22 22.88"/><path d="M44 1L22 22.87"/></g></g></g>';
	    }
	  }
	});

	module.exports = ArrowRightIcon;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ArrowUpIcon = React.createClass({
	  displayName: 'ArrowUpIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 5.000000)"><path d="M0 0L7 7"/><path d="M14 0L7 7"/></g></g></g>';
	      case 'medium':
	        return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 8.000000)"><path d="M0 0L14 14"/><path d="M28 0L14 14"/></g></g></g>';
	      case 'large':
	        return '<g stroke-width="1"><g stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 11.000000)"><path d="M0 1L22 22.88"/><path d="M44 1L22 22.87"/></g></g></g>';
	    }
	  }
	});

	module.exports = ArrowUpIcon;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var AudioIcon = React.createClass({
	  displayName: 'AudioIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="4" cy="14" r="3"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="13" cy="12" r="3"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="12.23" x2="16" y2="1.23"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="7" y1="14" x2="7" y2="3"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="7" y1="3" x2="16" y2="1"/>';
	      case 'medium':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="8" cy="26" r="5"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="24" cy="22" r="5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="29" y1="22" x2="29" y2="1"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="26" x2="13" y2="5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="5" x2="29" y2="1"/>';
	      case 'large':
	        return '<circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="12" cy="39" r="7.5"/><circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36" cy="33" r="7.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="43.5" y1="33" x2="43.5" y2="1.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="19.5" y1="39" x2="19.5" y2="7"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="19.5" y1="7" x2="43.5" y2="1.5"/>';
	    }
	  }
	});

	module.exports = AudioIcon;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var BackwardIcon = React.createClass({
	  displayName: 'BackwardIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  5,1 5,7.286 16,1 16,17 5,10.714 5,17 1,17 1,1 "/>';
	      case 'medium':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  8,1 8,13.692 30,1 30,31 8,18.308 8,31 2,31 2,1 "/>';
	      case 'large':
	        return '<polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  12.562,1.5 12.562,20.538 45.562,1.5 45.562,46.5 12.562,27.462 12.562,46.5 2.438,46.5 2.438,1.5 "/>';
	    }
	  }
	});

	module.exports = BackwardIcon;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var CheckIcon = React.createClass({
	  displayName: 'CheckIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="1" y1="8.66" x2="6.49" y2="16.5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="1.5" x2="6.49" y2="16.5"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="1" y1="15.37" x2="11.29" y2="30"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="2" x2="11.29" y2="30"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="1.5" y1="23.06" x2="16.94" y2="45"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="3" x2="16.94" y2="45"/>';
	    }
	  }
	});

	module.exports = CheckIcon;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ChromeIcon = React.createClass({
	  displayName: 'ChromeIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M4.54 7.85l-2.58-4.46c1.65-2.06 4.19-3.39 7.04-3.39 3.3 0 6.18 1.77 7.74 4.41h-7.34c-0.13-0.01-0.26-0.02-0.4-0.02-2.14 0-3.95 1.47-4.46 3.46zM12.22 5.71h5.16c0.4 1.02 0.62 2.13 0.62 3.29 0 4.94-3.97 8.94-8.9 9l3.68-6.37c0.52-0.74 0.82-1.65 0.82-2.62 0-1.29-0.53-2.45-1.38-3.29zM5.73 9c0-1.8 1.47-3.27 3.27-3.27s3.27 1.47 3.27 3.27c0 1.8-1.47 3.27-3.27 3.27-1.8 0-3.27-1.47-3.27-3.27zM10.23 13.44l-2.58 4.46c-4.33-0.65-7.66-4.39-7.66-8.9 0-1.6 0.42-3.11 1.16-4.41l3.67 6.36c0.74 1.57 2.33 2.65 4.17 2.65 0.43 0 0.84-0.06 1.23-0.17z"/>';
	      case 'medium':
	        return '<path d="M8.071 13.954l-4.579-7.931c2.932-3.671 7.445-6.023 12.508-6.023 5.857 0 10.978 3.148 13.767 7.844h-13.055c-0.235-0.020-0.472-0.031-0.711-0.031-3.809 0-7.018 2.614-7.929 6.142zM21.728 10.156h9.171c0.711 1.81 1.101 3.781 1.101 5.844 0 8.776-7.066 15.9-15.818 15.998l6.544-11.334c0.921-1.324 1.462-2.932 1.462-4.664 0-2.287-0.943-4.357-2.459-5.844zM10.188 16c0-3.205 2.607-5.813 5.813-5.813s5.813 2.607 5.813 5.813c0 3.205-2.608 5.813-5.813 5.813-3.205 0-5.813-2.608-5.813-5.813zM18.193 23.889l-4.581 7.934c-7.704-1.153-13.613-7.797-13.613-15.822 0-2.851 0.746-5.526 2.053-7.845l6.532 11.314c1.308 2.785 4.14 4.718 7.415 4.718 0.759 0 1.495-0.104 2.193-0.299z"/>';
	      case 'large':
	        return '<path d="M12.107 20.932l-6.869-11.897c4.398-5.506 11.167-9.035 18.762-9.035 8.786 0 16.468 4.722 20.65 11.766h-19.583c-0.352-0.030-0.707-0.047-1.067-0.047-5.713 0-10.527 3.921-11.893 9.213zM32.592 15.234h13.756c1.066 2.715 1.652 5.672 1.652 8.766 0 13.164-10.598 23.85-23.727 23.997l9.815-17.001c1.382-1.986 2.193-4.398 2.193-6.996 0-3.43-1.414-6.535-3.689-8.766zM15.281 24c0-4.808 3.911-8.719 8.719-8.719s8.719 3.911 8.719 8.719c0 4.807-3.911 8.719-8.719 8.719-4.808 0-8.719-3.911-8.719-8.719zM27.29 35.833l-6.871 11.901c-11.556-1.729-20.419-11.696-20.419-23.734 0-4.276 1.12-8.29 3.079-11.767l9.798 16.971c1.963 4.177 6.21 7.077 11.122 7.077 1.139 0 2.242-0.157 3.29-0.448z"/>';
	    }
	  }
	});

	module.exports = ChromeIcon;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ClockIcon = React.createClass({
	  displayName: 'ClockIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="4" x2="9" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="11.83" y1="11.83" x2="9" y2="9"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="9" cy="9" r="8"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="6.63" x2="16" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="21.3" y1="21.3" x2="16" y2="16"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="16" cy="16" r="15"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="24" y1="10.25" x2="24" y2="24"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31.756" y1="31.756" x2="24.244" y2="24.244"/><circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="24" cy="24" r="22.5"/>';
	    }
	  }
	});

	module.exports = ClockIcon;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PlusIcon = React.createClass({
	  displayName: 'PlusIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="10.496" y1="1" x2="13.996" y2="4.5"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="10.496" y1="8" x2="13.996" y2="4.5"/></g><path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M2.004,9.5c0-2.761,2.239-5,5-5"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13.996" y1="4.5" x2="7.004" y2="4.5"/><g><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="7.504" y1="17" x2="4.004" y2="13.5"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="7.504" y1="10" x2="4.004" y2="13.5"/></g><path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M15.996,8.5c0,2.761-2.239,5-5,5"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.004" y1="13.5" x2="10.996" y2="13.5"/>';
	      case 'medium':
	        return '<g><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="18.805" y1="1" x2="25.367" y2="7.562"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="18.805" y1="14.125" x2="25.367" y2="7.562"/></g><path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M2.883,16.938c0-5.178,4.197-9.375,9.375-9.375"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25.367" y1="7.562" x2="12.258" y2="7.562"/><g><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13.195" y1="31" x2="6.633" y2="24.438"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13.195" y1="17.875" x2="6.633" y2="24.438"/></g><path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M29.117,15.062c0,5.178-4.197,9.375-9.375,9.375"/><line fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="6.633" y1="24.438" x2="19.742" y2="24.438"/>';
	      case 'large':
	        return '<g><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="30.581" y1="1.5" x2="41.3" y2="12.219"/><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="30.581" y1="22.938" x2="41.3" y2="12.219"/></g><path fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M4.575,27.531c0-8.457,6.856-15.312,15.312-15.312"/><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="41.3" y1="12.219" x2="19.888" y2="12.219"/><g><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="21.419" y1="50.5" x2="10.7" y2="39.781"/><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="21.419" y1="29.062" x2="10.7" y2="39.781"/></g><path fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M47.425,24.469c0,8.457-6.856,15.312-15.312,15.312"/><line fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="10.7" y1="39.781" x2="32.112" y2="39.781"/>';
	    }
	  }
	});

	module.exports = PlusIcon;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var CrossIcon = React.createClass({
	  displayName: 'CrossIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2" y1="2" x2="16" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2" y1="16" x2="16" y2="2"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="3" x2="29" y2="29"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="29" x2="29" y2="3"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="4.5" x2="43.5" y2="43.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="43.5" x2="43.5" y2="4.5"/>';
	    }
	  }
	});

	module.exports = CrossIcon;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var EmailIcon = React.createClass({
	  displayName: 'EmailIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16.86 3.61l-7.06 7.06c-0.45 0.45-1.17 0.45-1.62 0L1.14 3.61"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 14c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V4c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V14z"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M30.75 5.89L17.52 19.12c-0.84 0.84-2.19 0.84-3.03 0L1.25 5.89"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 26.13C31 27.16 30.16 28 29.13 28H2.88C1.84 28 1 27.16 1 26.13V6.88C1 5.84 1.84 5 2.88 5h26.25C30.16 5 31 5.84 31 6.88V26.13z"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.12 8.84L26.27 28.68c-1.25 1.25-3.29 1.25-4.55 0L1.88 8.84"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 38.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V10.31C1.5 8.76 2.76 7.5 4.31 7.5h39.38c1.55 0 2.81 1.26 2.81 2.81V38.69z"/>';
	    }
	  }
	});

	module.exports = EmailIcon;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var EyeIcon = React.createClass({
	  displayName: 'EyeIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 3.5C5.58 3.5 2.6 5.72 1 9c1.6 3.29 4.58 5.5 8 5.5s6.4-2.21 8-5.5C15.4 5.72 12.42 3.5 9 3.5z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="9" cy="9" r="2.5"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 5.69C9.59 5.69 4 9.84 1 16c3 6.16 8.59 10.31 15 10.31S28 22.16 31 16C28 9.84 22.41 5.69 16 5.69z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="16" cy="16" r="4.69"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 8.53C14.38 8.53 6 14.76 1.5 24 6 33.24 14.38 39.47 24 39.47S42 33.24 46.5 24C42 14.76 33.62 8.53 24 8.53z"/><circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="24" cy="24" r="7.03"/>';
	    }
	  }
	});

	module.exports = EyeIcon;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var EyeCrossedIcon = React.createClass({
	  displayName: 'EyeCrossedIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<g transform="translate(-0.500000, 2.000000)"><path d="M3.03 10.72C2.11 9.81 1.32 8.7 0.71 7.44L0.5 7 0.71 6.56C2.49 2.86 5.81 0.5 9.5 0.5 10.56 0.5 11.6 0.7 12.57 1.06L10.98 2.67C10.5 2.56 10 2.5 9.5 2.5 6.61 2.5 3.96 4.39 2.5 7.44L2.5 6.56C3.01 7.63 3.67 8.55 4.43 9.3L3.03 10.72ZM6.43 12.94C7.4 13.3 8.44 13.5 9.5 13.5 13.19 13.5 16.51 11.14 18.29 7.44L18.5 7 18.29 6.56C17.68 5.3 16.89 4.19 15.97 3.28L14.57 4.7C15.33 5.45 15.99 6.37 16.5 7.44L16.5 6.56C15.04 9.61 12.39 11.5 9.5 11.5 9 11.5 8.5 11.44 8.02 11.33L6.43 12.94ZM12.94 6.35C12.98 6.56 13 6.78 13 7 13 8.93 11.43 10.5 9.5 10.5 9.29 10.5 9.09 10.48 8.89 10.45L12.94 6.35ZM10.11 3.55C9.91 3.52 9.71 3.5 9.5 3.5 7.57 3.5 6 5.07 6 7 6 7.22 6.02 7.44 6.06 7.65L10.11 3.55Z"/></g><path d="M2 16L16 2" stroke-width="2" stroke="currentColor" stroke-linecap="round"/>';
	      case 'medium':
	        return '<path d="M26.21 8.79C26.76 9.27 27.3 9.77 27.81 10.32 28.89 11.46 29.79 12.69 30.53 13.92 30.97 14.67 31.27 15.25 31.42 15.61L31.59 16 31.42 16.39C31.27 16.75 30.97 17.33 30.53 18.08 29.79 19.31 28.89 20.54 27.81 21.68 24.69 25 20.77 27 16 27 14.01 27 12.15 26.64 10.41 25.97 10.08 25.84 9.76 25.71 9.44 25.56L10.96 24.04C11.02 24.06 11.08 24.08 11.14 24.11 12.64 24.69 14.26 25 16 25L16 25C20.16 25 23.59 23.25 26.35 20.32 27.32 19.28 28.14 18.16 28.81 17.05 29.04 16.66 29.24 16.3 29.4 15.98 29.5 15.79 29.56 15.67 29.58 15.61L29.58 16.39C29.56 16.33 29.5 16.21 29.4 16.02 29.24 15.7 29.04 15.34 28.81 14.95 28.14 13.84 27.32 12.72 26.35 11.68 25.85 11.16 25.33 10.67 24.79 10.21L26.21 8.79ZM22.56 6.44C22.24 6.29 21.92 6.16 21.59 6.03 19.85 5.36 17.99 5 16 5 11.23 5 7.31 7 4.19 10.32 3.11 11.46 2.21 12.69 1.47 13.92 1.03 14.67 0.73 15.25 0.58 15.61L0.41 16 0.58 16.39C0.73 16.75 1.03 17.33 1.47 18.08 2.21 19.31 3.11 20.54 4.19 21.68 4.7 22.23 5.24 22.73 5.79 23.21L7.21 21.79C6.67 21.33 6.15 20.84 5.65 20.32 4.68 19.28 3.86 18.16 3.19 17.05 2.96 16.66 2.76 16.3 2.6 15.98 2.5 15.79 2.44 15.67 2.42 15.61L2.42 16.39C2.44 16.33 2.5 16.21 2.6 16.02 2.76 15.7 2.96 15.34 3.19 14.95 3.86 13.84 4.68 12.72 5.65 11.68 8.41 8.75 11.84 7 16 7 17.74 7 19.36 7.31 20.86 7.89 20.92 7.92 20.98 7.94 21.04 7.96L22.56 6.44ZM22.22 12.78C22.72 13.75 23 14.84 23 16 23 19.87 19.87 23 16 23 14.84 23 13.75 22.72 12.78 22.22L14.3 20.7C14.83 20.9 15.4 21 16 21 18.76 21 21 18.76 21 16 21 15.4 20.9 14.83 20.7 14.3L22.22 12.78ZM19.22 9.78C18.25 9.28 17.16 9 16 9 12.13 9 9 12.13 9 16 9 17.16 9.28 18.25 9.78 19.22L11.3 17.7C11.1 17.17 11 16.6 11 16 11 13.24 13.24 11 16 11 16.6 11 17.17 11.1 17.7 11.3L19.22 9.78Z" id="Shape"/><path d="M4 28L28 4" id="dash" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="4.5" x2="43.5" y2="43.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4.5" y1="43.5" x2="43.5" y2="4.5"/>';
	    }
	  }
	});

	module.exports = EyeCrossedIcon;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var FacebookIcon = React.createClass({
	  displayName: 'FacebookIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M18 17.17V0.83C18 0.37 17.63 0 17.18 0h-1.46H2.29 0.82C0.37 0 0 0.37 0 0.83v14.85l0 1.49C0 17.63 0.37 18 0.82 18h9.08v-7.23H7.56v-2.49h2.35V5.58c0-1.62 1.45-2.71 2.61-2.71h2.63v2.27h-1.21c-0.6 0-1.39 0.49-1.39 1.1v2.05h2.37v2.49H12.54V18h3.17 1.47C17.63 18 18 17.63 18 17.17z"/>';
	      case 'medium':
	        return '<path d="M32 30.52V1.48C32 0.66 31.35 0 30.54 0h-2.6H4.06 1.46C0.66 0 0 0.66 0 1.48v26.39L0 30.52C0 31.34 0.65 32 1.46 32h16.15V19.15h-4.17v-4.43h4.17V9.92c0-2.88 2.57-4.82 4.64-4.82h4.67v4.03h-2.15c-1.06 0-2.47 0.88-2.47 1.95v3.65h4.2v4.43h-4.2V32h5.64 2.6C31.35 32 32 31.34 32 30.52z"/>';
	      case 'large':
	        return '<path d="M48 45.78V2.23C48 1 47.02 0 45.81 0h-3.91H6.1 2.19C0.98 0 0.01 0.99 0 2.21v39.59L0 45.78C0 47.01 0.98 48 2.19 48h24.22V28.73h-6.25V22.09h6.25v-7.21c0-4.32 3.86-7.22 6.97-7.22h7v6.04h-3.23c-1.59 0-3.71 1.31-3.71 2.93v5.47h6.31v6.64h-6.31V48h8.47 3.91C47.02 48 48 47 48 45.78z"/>';
	    }
	  }
	});

	module.exports = FacebookIcon;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var FirefoxIcon = React.createClass({
	  displayName: 'FirefoxIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M17.974 5.874l-0.208 1.337c0 0-0.298-2.476-0.663-3.402-0.56-1.418-0.809-1.407-0.81-1.405 0.375 0.953 0.307 1.465 0.307 1.465s-0.664-1.811-2.421-2.387c-1.946-0.638-2.998-0.463-3.12-0.43-0.018 0-0.036 0-0.053 0 0.014 0.001 0.028 0.003 0.043 0.004-0.001 0-0.002 0.001-0.001 0.001 0.008 0.01 2.15 0.374 2.53 0.896 0 0-0.91 0-1.815 0.261-0.041 0.012 3.331 0.421 4.021 3.791 0 0-0.37-0.771-0.827-0.902 0.301 0.915 0.223 2.65-0.063 3.513-0.037 0.111-0.075-0.48-0.639-0.734 0.181 1.295-0.011 3.348-0.909 3.913-0.07 0.044 0.563-2.027 0.127-1.226-2.509 3.846-5.474 1.775-6.807 0.863 0.683 0.149 1.98-0.023 2.554-0.45 0.001-0.001 0.001-0.001 0.002-0.002 0.623-0.426 0.993-0.738 1.324-0.664 0.332 0.074 0.553-0.259 0.295-0.554-0.258-0.296-0.884-0.703-1.732-0.481-0.598 0.157-1.338 0.818-2.469 0.148-0.868-0.514-0.949-0.941-0.957-1.237 0.021-0.105 0.048-0.203 0.08-0.292 0.1-0.279 0.403-0.363 0.571-0.43 0.286 0.049 0.532 0.138 0.79 0.271 0.003-0.086 0.004-0.2 0-0.33 0.025-0.049 0.009-0.198-0.03-0.379-0.023-0.181-0.06-0.369-0.119-0.54 0 0 0 0 0.001 0 0.001 0 0.002-0.001 0.003-0.001 0.001-0.001 0.003-0.002 0.004-0.003 0 0 0.001-0.001 0.001-0.001 0.001-0.002 0.003-0.005 0.003-0.008 0.018-0.081 0.211-0.238 0.452-0.406 0.216-0.151 0.469-0.311 0.669-0.435 0.177-0.11 0.311-0.191 0.34-0.213 0.011-0.008 0.024-0.018 0.038-0.029 0.003-0.002 0.005-0.004 0.008-0.006 0.002-0.001 0.003-0.003 0.005-0.004 0.095-0.076 0.237-0.219 0.267-0.52 0-0.001 0-0.001 0-0.002 0.001-0.009 0.002-0.018 0.002-0.027 0-0.006 0.001-0.013 0.001-0.019 0-0.005 0.001-0.01 0.001-0.015 0.001-0.012 0.001-0.024 0.001-0.036 0-0.001 0-0.001 0-0.002 0-0.029 0-0.06-0.002-0.091-0.001-0.018-0.002-0.034-0.005-0.049 0-0.001 0-0.002 0-0.002 0-0.001-0.001-0.003-0.001-0.004-0.001-0.003-0.001-0.005-0.002-0.008 0 0 0-0.001 0-0.001-0.001-0.003-0.002-0.006-0.003-0.008 0 0 0 0 0 0-0.031-0.072-0.146-0.099-0.623-0.108 0 0-0.001 0-0.001 0v0c-0.195-0.003-0.449-0.003-0.782-0.002-0.584 0.002-0.908-0.571-1.011-0.793 0.141-0.782 0.55-1.338 1.221-1.716 0.013-0.007 0.01-0.013-0.005-0.017 0.131-0.079-1.586-0.002-2.376 1.003-0.701-0.174-1.312-0.163-1.839-0.039-0.101-0.003-0.227-0.015-0.377-0.047-0.35-0.317-0.852-0.904-0.878-1.603 0 0-0.002 0.001-0.004 0.004 0-0.007-0.001-0.013-0.001-0.02 0 0-1.067 0.82-0.908 3.057 0 0.036-0.001 0.07-0.002 0.103-0.289 0.392-0.432 0.721-0.443 0.794-0.256 0.521-0.516 1.305-0.727 2.496 0 0 0.148-0.469 0.444-1-0.218 0.668-0.39 1.708-0.289 3.267 0 0 0.027-0.346 0.121-0.844 0.074 0.967 0.396 2.161 1.21 3.565 1.564 2.695 3.967 4.056 6.623 4.265 0.472 0.039 0.95 0.04 1.431 0.003 0.044-0.003 0.088-0.006 0.133-0.01 0.544-0.038 1.092-0.12 1.639-0.253 7.474-1.807 6.661-10.832 6.661-10.832z"/>';
	      case 'medium':
	        return '<path d="M31.954 10.442l-0.371 2.377c0 0-0.53-4.402-1.179-6.047-0.995-2.521-1.438-2.501-1.441-2.498 0.667 1.694 0.546 2.604 0.546 2.604s-1.181-3.219-4.303-4.243c-3.459-1.134-5.33-0.824-5.547-0.765-0.033-0-0.064-0-0.095-0 0.026 0.002 0.050 0.005 0.076 0.007-0.001 0.001-0.003 0.001-0.003 0.002 0.014 0.017 3.822 0.666 4.497 1.594 0 0-1.617 0-3.227 0.464-0.073 0.021 5.923 0.749 7.148 6.74 0 0-0.657-1.371-1.47-1.604 0.535 1.626 0.397 4.712-0.112 6.245-0.066 0.197-0.133-0.853-1.135-1.305 0.321 2.301-0.019 5.952-1.616 6.957-0.124 0.078 1.001-3.603 0.226-2.18-4.46 6.838-9.731 3.155-12.101 1.535 1.215 0.264 3.52-0.041 4.541-0.8 0.001-0.001 0.002-0.002 0.004-0.003 1.108-0.758 1.765-1.311 2.354-1.18 0.59 0.132 0.982-0.46 0.524-0.985-0.459-0.526-1.572-1.249-3.079-0.855-1.063 0.278-2.379 1.454-4.389 0.264-1.543-0.914-1.688-1.673-1.702-2.199 0.038-0.186 0.086-0.361 0.143-0.52 0.178-0.496 0.716-0.646 1.015-0.764 0.508 0.087 0.946 0.246 1.405 0.481 0.006-0.153 0.008-0.356-0.001-0.586 0.044-0.088 0.017-0.352-0.054-0.674-0.041-0.322-0.107-0.655-0.211-0.959 0-0 0.001-0 0.001-0 0.002-0.001 0.003-0.001 0.005-0.002 0.002-0.001 0.005-0.004 0.007-0.006 0-0.001 0.001-0.001 0.001-0.002 0.003-0.004 0.005-0.008 0.006-0.015 0.032-0.144 0.376-0.423 0.804-0.722 0.383-0.268 0.834-0.553 1.19-0.774 0.314-0.195 0.554-0.34 0.605-0.378 0.019-0.015 0.042-0.032 0.068-0.051 0.005-0.004 0.009-0.007 0.014-0.011 0.003-0.002 0.006-0.005 0.009-0.007 0.169-0.135 0.421-0.389 0.474-0.924 0-0.001 0-0.002 0-0.004 0.002-0.016 0.003-0.032 0.004-0.048 0.001-0.011 0.002-0.023 0.002-0.034 0-0.009 0.001-0.018 0.001-0.027 0.001-0.021 0.002-0.043 0.002-0.065 0-0.001 0-0.002 0-0.004 0.001-0.052-0-0.106-0.003-0.163-0.002-0.032-0.004-0.060-0.009-0.086-0-0.001-0.001-0.003-0.001-0.004-0.001-0.003-0.001-0.005-0.002-0.008-0.001-0.005-0.002-0.009-0.004-0.013-0-0.001-0-0.001-0.001-0.001-0.002-0.005-0.004-0.010-0.005-0.014-0-0-0-0-0-0.001-0.055-0.128-0.26-0.177-1.108-0.191-0.001-0-0.002-0-0.002-0v0c-0.346-0.006-0.798-0.006-1.391-0.004-1.039 0.004-1.613-1.016-1.797-1.41 0.251-1.389 0.977-2.379 2.17-3.051 0.023-0.013 0.018-0.023-0.009-0.031 0.233-0.141-2.82-0.004-4.225 1.782-1.247-0.31-2.333-0.289-3.269-0.069-0.18-0.005-0.404-0.027-0.67-0.083-0.623-0.564-1.514-1.606-1.562-2.85 0 0-0.003 0.002-0.008 0.006-0.001-0.012-0.002-0.024-0.002-0.036 0 0-1.897 1.458-1.613 5.434-0.001 0.064-0.002 0.125-0.004 0.184-0.514 0.696-0.768 1.282-0.787 1.411-0.455 0.926-0.917 2.32-1.292 4.437 0 0 0.263-0.833 0.79-1.777-0.388 1.188-0.693 3.036-0.514 5.808 0 0 0.047-0.615 0.215-1.5 0.131 1.719 0.704 3.841 2.152 6.337 2.78 4.791 7.052 7.211 11.775 7.582 0.839 0.069 1.689 0.071 2.544 0.006 0.079-0.006 0.157-0.011 0.236-0.018 0.968-0.068 1.942-0.214 2.914-0.449 13.287-3.212 11.842-19.256 11.842-19.256z"/>';
	      case 'large':
	        return '<path d="M47.931 15.663l-0.556 3.566c0 0-0.795-6.603-1.769-9.071-1.493-3.782-2.157-3.752-2.161-3.746 1 2.541 0.819 3.906 0.819 3.906s-1.772-4.828-6.455-6.364c-5.188-1.701-7.995-1.236-8.32-1.148-0.049-0-0.097-0-0.142-0 0.038 0.003 0.076 0.007 0.114 0.010-0.002 0.001-0.004 0.002-0.004 0.002 0.021 0.026 5.733 0.999 6.746 2.39 0 0-2.426 0-4.841 0.696-0.109 0.031 8.884 1.123 10.722 10.11 0 0-0.986-2.057-2.205-2.406 0.802 2.439 0.596 7.068-0.168 9.368-0.098 0.296-0.199-1.279-1.703-1.957 0.482 3.452-0.029 8.928-2.424 10.436-0.187 0.117 1.501-5.405 0.339-3.27-6.689 10.256-14.597 4.733-18.152 2.302 1.822 0.397 5.281-0.062 6.812-1.201 0.002-0.001 0.004-0.003 0.006-0.004 1.663-1.137 2.647-1.967 3.531-1.771 0.885 0.198 1.474-0.69 0.787-1.478-0.688-0.789-2.358-1.874-4.618-1.283-1.594 0.417-3.569 2.181-6.584 0.395-2.314-1.371-2.532-2.51-2.552-3.299 0.057-0.28 0.129-0.541 0.215-0.779 0.266-0.744 1.074-0.968 1.523-1.146 0.762 0.131 1.419 0.369 2.108 0.722 0.009-0.229 0.012-0.534-0.001-0.879 0.066-0.131 0.025-0.527-0.081-1.012-0.061-0.483-0.16-0.983-0.317-1.439 0.001-0 0.001-0 0.001-0.001 0.003-0.001 0.005-0.002 0.007-0.003 0.004-0.002 0.007-0.005 0.010-0.009 0.001-0.001 0.001-0.002 0.002-0.002 0.004-0.006 0.007-0.013 0.009-0.022 0.048-0.216 0.564-0.634 1.206-1.083 0.575-0.402 1.252-0.83 1.784-1.16 0.472-0.293 0.831-0.51 0.907-0.567 0.029-0.022 0.064-0.047 0.101-0.077 0.007-0.005 0.014-0.011 0.021-0.017 0.004-0.003 0.009-0.007 0.013-0.011 0.254-0.202 0.632-0.583 0.711-1.386 0-0.002 0-0.004 0.001-0.006 0.002-0.024 0.004-0.048 0.006-0.072 0.001-0.017 0.002-0.034 0.003-0.051 0.001-0.013 0.002-0.027 0.002-0.040 0.001-0.032 0.002-0.064 0.003-0.097 0-0.002 0-0.004 0-0.005 0.001-0.078-0-0.159-0.005-0.244-0.003-0.048-0.006-0.090-0.014-0.129-0-0.002-0.001-0.004-0.001-0.006-0.001-0.004-0.002-0.008-0.003-0.011-0.002-0.007-0.004-0.014-0.006-0.020-0-0.001-0-0.002-0.001-0.002-0.002-0.008-0.005-0.015-0.008-0.022-0-0-0-0-0-0.001-0.082-0.193-0.39-0.265-1.661-0.287-0.001-0-0.002-0-0.004-0v0c-0.519-0.009-1.197-0.009-2.086-0.006-1.559 0.006-2.42-1.524-2.695-2.116 0.377-2.084 1.466-3.569 3.255-4.576 0.034-0.019 0.027-0.035-0.013-0.046 0.35-0.212-4.23-0.006-6.337 2.674-1.87-0.465-3.499-0.433-4.904-0.104-0.27-0.008-0.606-0.041-1.005-0.124-0.934-0.846-2.271-2.409-2.343-4.275 0 0-0.004 0.003-0.012 0.010-0.001-0.018-0.003-0.036-0.003-0.054 0 0-2.846 2.187-2.42 8.151-0.001 0.095-0.003 0.187-0.006 0.275-0.77 1.045-1.152 1.923-1.181 2.117-0.683 1.39-1.375 3.481-1.939 6.655 0 0 0.394-1.25 1.185-2.666-0.582 1.782-1.039 4.554-0.77 8.712 0 0 0.071-0.922 0.322-2.25 0.196 2.579 1.056 5.762 3.228 9.506 4.169 7.187 10.578 10.816 17.662 11.373 1.258 0.104 2.534 0.106 3.817 0.009 0.118-0.008 0.236-0.017 0.354-0.027 1.451-0.102 2.913-0.321 4.371-0.673 19.93-4.819 17.763-28.884 17.763-28.884z"/>';
	    }
	  }
	});

	module.exports = FirefoxIcon;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ForwardIcon = React.createClass({
	  displayName: 'ForwardIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  13,1 13,7.286 2,1 2,17 13,10.714 13,17 17,17 17,1 "/>';
	      case 'medium':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  24,1 24,13.692 2,1 2,31 24,18.308 24,31 30,31 30,1 "/>';
	      case 'large':
	        return '<polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  35.438,1.5 35.438,20.538 2.438,1.5 2.438,46.5 35.438,27.462 35.438,46.5 45.562,46.5 45.562,1.5 "/>';
	    }
	  }
	});

	module.exports = ForwardIcon;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var GoogleIcon = React.createClass({
	  displayName: 'GoogleIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M1.791 5.03c0 1.344 0.449 2.315 1.334 2.885 0.724 0.467 1.566 0.537 2.003 0.537 0.106 0 0.191-0.004 0.25-0.008 0 0-0.139 0.903 0.531 1.796l-0.031-0.001c-1.16 0-4.945 0.243-4.945 3.354 0 3.165 3.476 3.325 4.172 3.325 0.055 0 0.086-0.001 0.086-0.001 0.008 0 0.058 0.002 0.142 0.002 0.447 0 1.604-0.056 2.678-0.579 1.393-0.676 2.101-1.853 2.101-3.496 0-1.588-1.076-2.533-1.863-3.225-0.48-0.421-0.895-0.785-0.895-1.139 0-0.36 0.302-0.631 0.686-0.974 0.619-0.554 1.204-1.344 1.204-2.836 0-1.312-0.17-2.192-1.219-2.75 0.11-0.056 0.496-0.096 0.688-0.123 0.568-0.077 1.399-0.166 1.399-0.629v-0.089h-4.138c-0.041 0.001-4.185 0.155-4.185 3.95zM8.472 13.142c0.079 1.265-1.003 2.2-2.629 2.317-1.651 0.122-3.011-0.622-3.09-1.887-0.038-0.607 0.229-1.202 0.752-1.677 0.531-0.48 1.258-0.776 2.051-0.835 0.094-0.005 0.186-0.01 0.279-0.01 1.527 0 2.562 0.898 2.637 2.092zM7.391 4.163c0.406 1.428-0.207 2.921-1.184 3.197-0.112 0.032-0.229 0.048-0.346 0.048-0.896 0-1.782-0.905-2.111-2.153-0.184-0.701-0.169-1.313 0.041-1.903 0.207-0.579 0.579-0.971 1.047-1.103 0.112-0.032 0.229-0.048 0.346-0.048 1.08 0 1.775 0.448 2.205 1.961zM14.365 7.274v-2.7h-1.71v2.7h-2.7v1.71h2.7v2.7h1.71v-2.7h2.7v-1.71h-2.7z"/>';
	      case 'medium':
	        return '<path d="M3.184 8.942c0 2.389 0.798 4.115 2.371 5.128 1.288 0.83 2.784 0.955 3.562 0.955 0.189 0 0.339-0.008 0.445-0.014 0 0-0.246 1.605 0.944 3.194l-0.054-0.002c-2.062 0-8.79 0.432-8.79 5.963 0 5.627 6.179 5.912 7.418 5.912 0.098 0 0.154-0.002 0.154-0.002 0.014 0 0.102 0.003 0.253 0.003 0.795 0 2.851-0.099 4.762-1.029 2.477-1.202 3.734-3.294 3.734-6.216 0-2.824-1.914-4.504-3.312-5.733-0.853-0.749-1.59-1.395-1.59-2.024 0-0.64 0.538-1.122 1.219-1.731 1.101-0.986 2.141-2.389 2.141-5.042 0-2.333-0.302-3.898-2.166-4.89 0.195-0.099 0.882-0.171 1.222-0.219 1.010-0.138 2.486-0.294 2.486-1.118v-0.158h-7.357c-0.074 0.002-7.44 0.275-7.44 7.022zM15.061 23.363c0.141 2.25-1.784 3.91-4.674 4.12-2.934 0.216-5.352-1.106-5.493-3.355-0.067-1.080 0.406-2.138 1.336-2.981 0.944-0.853 2.237-1.379 3.646-1.485 0.166-0.010 0.331-0.018 0.496-0.018 2.715 0 4.555 1.597 4.688 3.718zM13.139 7.402c0.722 2.539-0.368 5.194-2.104 5.683-0.2 0.056-0.406 0.085-0.614 0.085-1.592 0-3.168-1.61-3.752-3.827-0.326-1.246-0.301-2.334 0.074-3.382 0.368-1.029 1.029-1.726 1.861-1.96 0.2-0.058 0.408-0.085 0.616-0.085 1.92 0 3.155 0.797 3.92 3.486zM25.538 12.931v-4.8h-3.040v4.8h-4.8v3.040h4.8v4.8h3.040v-4.8h4.8v-3.040h-4.8z"/>';
	      case 'large':
	        return '<path d="M4.776 13.414c0 3.583 1.198 6.173 3.557 7.692 1.932 1.246 4.176 1.433 5.342 1.433 0.283 0 0.509-0.012 0.667-0.022 0 0-0.37 2.407 1.416 4.79l-0.082-0.002c-3.094 0-13.186 0.648-13.186 8.945 0 8.441 9.269 8.868 11.126 8.868 0.146 0 0.23-0.002 0.23-0.002 0.022 0 0.154 0.005 0.379 0.005 1.193 0 4.277-0.149 7.142-1.543 3.715-1.802 5.602-4.942 5.602-9.324 0-4.236-2.87-6.756-4.968-8.599-1.279-1.123-2.386-2.093-2.386-3.036 0-0.96 0.806-1.682 1.829-2.597 1.651-1.478 3.211-3.583 3.211-7.562 0-3.499-0.454-5.846-3.25-7.334 0.293-0.149 1.322-0.257 1.834-0.329 1.514-0.206 3.73-0.442 3.73-1.678v-0.238h-11.035c-0.11 0.002-11.16 0.413-11.16 10.534zM22.591 35.045c0.211 3.374-2.676 5.866-7.010 6.18-4.402 0.324-8.028-1.658-8.239-5.033-0.101-1.62 0.61-3.206 2.004-4.471 1.416-1.279 3.355-2.069 5.47-2.227 0.25-0.014 0.497-0.026 0.744-0.026 4.073 0 6.833 2.395 7.032 5.578zM19.709 11.102c1.082 3.809-0.552 7.79-3.156 8.525-0.3 0.084-0.61 0.127-0.922 0.127-2.388 0-4.752-2.414-5.628-5.741-0.49-1.87-0.451-3.502 0.11-5.074 0.552-1.543 1.543-2.59 2.791-2.94 0.3-0.086 0.612-0.127 0.924-0.127 2.88 0 4.733 1.195 5.88 5.23zM38.306 19.397v-7.2h-4.56v7.2h-7.2v4.56h7.2v7.2h4.56v-7.2h7.2v-4.56h-7.2z"/>';
	    }
	  }
	});

	module.exports = GoogleIcon;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var GridIcon = React.createClass({
	  displayName: 'GridIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="9" x2="1" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="2" x2="9" y2="16"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 12.13C14 13.16 13.16 14 12.13 14h-9.25C1.84 14 1 13.16 1 12.13v-7.25C1 3.84 1.84 3 2.88 3h9.25C13.16 3 14 3.84 14 4.88V12.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 12.13C31 13.16 30.16 14 29.13 14h-9.25C18.84 14 18 13.16 18 12.13v-7.25C18 3.84 18.84 3 19.88 3h9.25C30.16 3 31 3.84 31 4.88V12.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 27.13C14 28.16 13.16 29 12.13 29h-9.25C1.84 29 1 28.16 1 27.13v-7.25C1 18.84 1.84 18 2.88 18h9.25C13.16 18 14 18.84 14 19.88V27.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29h-9.25C18.84 29 18 28.16 18 27.13v-7.25C18 18.84 18.84 18 19.88 18h9.25C30.16 18 31 18.84 31 19.88V27.13z"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M21.5 18.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h14.38c1.55 0 2.81 1.26 2.81 2.81V18.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 18.69c0 1.55-1.26 2.81-2.81 2.81H29.31c-1.55 0-2.81-1.26-2.81-2.81V7.31c0-1.55 1.26-2.81 2.81-2.81h14.38c1.55 0 2.81 1.26 2.81 2.81V18.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M21.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V29.31c0-1.55 1.26-2.81 2.81-2.81h14.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H29.31c-1.55 0-2.81-1.26-2.81-2.81V29.31c0-1.55 1.26-2.81 2.81-2.81h14.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/>';
	    }
	  }
	});

	module.exports = GridIcon;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var IeIcon = React.createClass({
	  displayName: 'IeIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M12.91 11.05h4.15c0.03-0.29 0.05-0.58 0.05-0.88 0-1.41-0.38-2.73-1.04-3.87 0.68-1.82 0.66-3.36-0.26-4.28-0.87-0.87-3.2-0.73-5.84 0.44-0.19-0.01-0.39-0.02-0.59-0.02-3.62 0-6.66 2.49-7.5 5.85 1.14-1.45 2.33-2.51 3.93-3.28-0.14 0.14-0.99 0.98-1.13 1.12-4.21 4.21-5.54 9.71-4.11 11.14 1.09 1.09 3.05 0.9 5.32-0.2 1.05 0.54 2.24 0.84 3.5 0.84 3.4 0 6.27-2.18 7.31-5.23h-4.18c-0.57 1.06-1.7 1.78-2.99 1.78-1.29 0-2.42-0.72-2.99-1.78-0.26-0.48-0.4-1.03-0.4-1.61v-0.01h6.79zM6.12 9.01c0.1-1.71 1.52-3.07 3.25-3.07s3.15 1.36 3.25 3.07h-6.5zM15.77 2.88c0.59 0.6 0.57 1.69 0.07 3.06-0.86-1.32-2.12-2.35-3.6-2.95 1.58-0.68 2.87-0.77 3.53-0.11zM1.64 17c-0.75-0.75-0.52-2.33 0.44-4.23 0.6 1.69 1.78 3.11 3.29 4.03-1.68 0.76-3.05 0.89-3.74 0.21z"/>';
	      case 'medium':
	        return '<path d="M22.944 19.651h7.377c0.057-0.512 0.080-1.034 0.080-1.569 0-2.507-0.673-4.858-1.848-6.883 1.215-3.228 1.172-5.968-0.455-7.606-1.547-1.54-5.697-1.29-10.388 0.787-0.347-0.026-0.697-0.040-1.051-0.040-6.439 0-11.841 4.431-13.335 10.402 2.020-2.586 4.145-4.461 6.984-5.826-0.258 0.242-1.764 1.739-2.018 1.993-7.486 7.484-9.847 17.26-7.306 19.8 1.931 1.93 5.43 1.604 9.449-0.364 1.869 0.952 3.984 1.488 6.226 1.488 6.035 0 11.15-3.885 13.003-9.295h-7.433c-1.023 1.887-3.023 3.171-5.319 3.171-2.296 0-4.296-1.284-5.319-3.171-0.455-0.852-0.716-1.83-0.716-2.864v-0.023h12.071zM10.884 16.025c0.171-3.035 2.694-5.456 5.774-5.456s5.604 2.421 5.774 5.456h-11.548zM28.030 5.119c1.048 1.059 1.021 3.007 0.125 5.438-1.535-2.341-3.766-4.186-6.4-5.239 2.816-1.207 5.106-1.367 6.274-0.199zM2.921 30.227c-1.337-1.337-0.934-4.144 0.788-7.526 1.072 3.008 3.161 5.534 5.854 7.161-2.982 1.354-5.423 1.584-6.643 0.365z"/>';
	      case 'large':
	        return '<path d="M34.416 29.476h11.065c0.085-0.767 0.119-1.551 0.119-2.353 0-3.761-1.009-7.288-2.771-10.325 1.822-4.843 1.757-8.953-0.682-11.409-2.32-2.31-8.545-1.935-15.582 1.181-0.521-0.039-1.046-0.060-1.577-0.060-9.659 0-17.762 6.647-20.002 15.602 3.030-3.879 6.217-6.692 10.476-8.74-0.387 0.363-2.646 2.609-3.026 2.989-11.229 11.226-14.77 25.889-10.96 29.7 2.896 2.896 8.145 2.407 14.174-0.546 2.803 1.428 5.977 2.233 9.338 2.233 9.053 0 16.725-5.827 19.504-13.943h-11.15c-1.534 2.83-4.535 4.757-7.979 4.757-3.444 0-6.445-1.926-7.979-4.757-0.682-1.278-1.074-2.745-1.074-4.296v-0.034h18.106zM16.327 24.038c0.256-4.552 4.041-8.184 8.661-8.184s8.405 3.631 8.661 8.184h-17.322zM42.045 7.678c1.572 1.588 1.532 4.51 0.188 8.157-2.303-3.511-5.649-6.278-9.6-7.858 4.224-1.811 7.66-2.051 9.412-0.299zM4.382 45.34c-2.005-2.006-1.401-6.216 1.183-11.289 1.608 4.513 4.742 8.301 8.781 10.742-4.473 2.031-8.134 2.375-9.964 0.547z"/>';
	    }
	  }
	});

	module.exports = IeIcon;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ImageIcon = React.createClass({
	  displayName: 'ImageIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<circle cx="12" cy="7" r="2"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.01 7.99C1.01 6.34 2.35 5 4 5c1.65 0 2.99 1.34 2.99 2.99 0 2.76 2.24 5 5 5s5-2.24 5-5"/>';
	      case 'medium':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="21.5" cy="12.5" r="3.75"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29H2.88C1.84 29 1 28.16 1 27.13V4.88C1 3.84 1.84 3 2.88 3h26.25C30.16 3 31 3.84 31 4.88V27.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.02 14.11c0-3.1 2.51-5.61 5.61-5.61s5.61 2.51 5.61 5.61c0 5.18 4.2 9.38 9.38 9.38s9.38-4.2 9.38-9.37"/>';
	      case 'large':
	        return '<circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="32.5" cy="18.5" r="5.5"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h39.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.52 21.16c0-4.65 3.77-8.41 8.41-8.41s8.41 3.77 8.41 8.41c0 7.77 6.3 14.06 14.06 14.06s14.06-6.3 14.06-14.06"/>';
	    }
	  }
	});

	module.exports = ImageIcon;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var InstagramIcon = React.createClass({
	  displayName: 'InstagramIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M13.68 9c0 2.59-2.1 4.68-4.68 4.68-2.58 0-4.68-2.1-4.68-4.68 0-0.31 0.03-0.61 0.09-0.9h-3.15v6.22c0 1.34 1.08 2.42 2.42 2.42h10.64c1.34 0 2.42-1.08 2.42-2.42v-6.22h-3.15c0.06 0.29 0.09 0.59 0.09 0.9zM14.32 1.26h-10.64c-1.34 0-2.42 1.08-2.42 2.42v2.62h3.92c0.85-1.2 2.24-1.98 3.82-1.98s2.98 0.78 3.82 1.98h3.92v-2.62c0-1.34-1.08-2.42-2.42-2.42zM15.5 4.25c0 0.24-0.19 0.43-0.43 0.43h-1.29c-0.24 0-0.43-0.19-0.43-0.43v-1.3c0-0.24 0.2-0.43 0.43-0.43h1.3c0.24 0 0.43 0.19 0.43 0.43v1.3zM11.88 9c0-1.59-1.29-2.88-2.88-2.88s-2.88 1.29-2.88 2.88 1.29 2.88 2.88 2.88 2.88-1.29 2.88-2.88z"/>';
	      case 'medium':
	        return '<path d="M24.32 16c0 4.595-3.726 8.32-8.32 8.32-4.595 0-8.32-3.725-8.32-8.32 0-0.547 0.054-1.082 0.157-1.6h-5.597v11.059c0 2.374 1.923 4.301 4.301 4.301h18.918c2.374 0 4.301-1.925 4.301-4.301v-11.059h-5.595c0.101 0.518 0.155 1.053 0.155 1.6zM25.459 2.24h-18.918c-2.376 0-4.301 1.926-4.301 4.301v4.659h6.966c1.506-2.128 3.987-3.52 6.794-3.52s5.288 1.392 6.794 3.52h6.966v-4.659c0-2.374-1.926-4.301-4.301-4.301zM27.563 7.552c0 0.424-0.346 0.768-0.768 0.768h-2.302c-0.422 0-0.768-0.346-0.768-0.768v-2.304c0-0.424 0.347-0.768 0.768-0.768h2.302c0.424 0 0.768 0.346 0.768 0.768v2.304zM21.12 16c0-2.829-2.293-5.12-5.12-5.12s-5.12 2.291-5.12 5.12 2.293 5.12 5.12 5.12 5.12-2.291 5.12-5.12z"/>';
	      case 'large':
	        return '<path d="M36.48 24c0 6.893-5.59 12.48-12.48 12.48-6.893 0-12.48-5.587-12.48-12.48 0-0.821 0.082-1.622 0.235-2.4h-8.395v16.589c0 3.562 2.885 6.451 6.451 6.451h28.378c3.562 0 6.451-2.887 6.451-6.451v-16.589h-8.393c0.151 0.778 0.233 1.579 0.233 2.4zM38.189 3.36h-28.378c-3.564 0-6.451 2.89-6.451 6.451v6.989h10.45c2.258-3.192 5.981-5.28 10.19-5.28s7.932 2.088 10.19 5.28h10.45v-6.989c0-3.562-2.89-6.451-6.451-6.451zM41.345 11.328c0 0.636-0.518 1.152-1.152 1.152h-3.454c-0.634 0-1.152-0.518-1.152-1.152v-3.456c0-0.636 0.521-1.152 1.152-1.152h3.454c0.636 0 1.152 0.518 1.152 1.152v3.456zM31.68 24c0-4.243-3.439-7.68-7.68-7.68s-7.68 3.437-7.68 7.68 3.439 7.68 7.68 7.68 7.68-3.437 7.68-7.68z"/>';
	    }
	  }
	});

	module.exports = InstagramIcon;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var InviteIcon = React.createClass({
	  displayName: 'InviteIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="6.5" cy="3.5" r="2.5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="14" y1="4.5" x2="14" y2="9.5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="11.5" y1="7" x2="16.5" y2="7"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M2 13c0-2.209 2.015-4 4.5-4s4.5 1.791 4.5 4v1.978C9.972 16.199 8.347 17 6.5 17S3.028 16.199 2 14.978V13z"/>';
	      case 'medium':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="11.5" cy="6.5" r="4.5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25" y1="8" x2="25" y2="18"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="20" y1="13" x2="30" y2="13"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M4 22.5c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v4.71C18 29.498 14.579 31 11.5 31S6 29.498 4 27.21V22.5z"/>';
	      case 'large':
	        return '<circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="15.5" cy="9.5" r="7"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="36.5" y1="11.5" x2="36.5" y2="27.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="28.5" y1="19.5" x2="44.5" y2="19.5"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M4.5 32.583c0-6.075 4.925-11 11-11s11 4.925 11 11v7.274c-2.513 3.356-6.485 5.559-11 5.559s-8.487-2.203-11-5.559L4.5 32.583z"/>';
	    }
	  }
	});

	module.exports = InviteIcon;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var LikeIcon = React.createClass({
	  displayName: 'LikeIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 16c4.25-3.26 8-5.15 8-9.68C17 3.67 14.92 2 12.86 2 11.27 2 9.66 2.87 9 4.69 8.33 2.87 6.73 2 5.14 2 3.08 2 1 3.67 1 6.32 1 10.85 4.75 12.74 9 16z"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 30c7.96-6.06 15-9.56 15-17.98C31 7.11 27.1 4 23.24 4 20.26 4 17.25 5.61 16 8.99 14.75 5.61 11.74 4 8.76 4 4.9 4 1 7.11 1 12.02 1 20.44 8.04 23.94 16 30z"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 45c11.94-9.32 22.5-14.7 22.5-27.65C46.5 9.78 40.65 5 34.86 5 30.4 5 25.87 7.48 24 12.69 22.13 7.48 17.6 5 13.14 5 7.35 5 1.5 9.78 1.5 17.35 1.5 30.3 12.06 35.68 24 45z"/>';
	    }
	  }
	});

	module.exports = LikeIcon;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var LinkIcon = React.createClass({
	  displayName: 'LinkIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 3.54l1.49-1.49c1.44-1.44 3.83-1.38 5.34 0.13l0 0c1.51 1.51 1.57 3.9 0.13 5.34l-2.98 2.98c-1.44 1.44-3.83 1.39-5.34-0.12l0 0"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 14.47l-1.49 1.49c-1.44 1.44-3.83 1.39-5.34-0.12l0 0c-1.51-1.51-1.56-3.9-0.12-5.34l2.98-2.98c1.44-1.44 3.83-1.38 5.34 0.13l0 0"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 5.75l2.79-2.79c2.7-2.7 7.18-2.6 10.01 0.23l0 0c2.83 2.83 2.93 7.31 0.23 10.01l-5.59 5.59c-2.7 2.7-7.18 2.6-10.01-0.23l0 0"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 26.25l-2.79 2.79c-2.7 2.7-7.18 2.6-10.01-0.23l0 0c-2.83-2.83-2.93-7.31-0.23-10.01l5.59-5.59c2.7-2.7 7.18-2.6 10.01 0.23l0 0"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 8.63l4.19-4.19c4.05-4.05 10.78-3.89 15.02 0.35l0 0c4.24 4.24 4.4 10.97 0.35 15.02l-8.38 8.38c-4.05 4.05-10.78 3.89-15.02-0.35l0 0"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 39.37l-4.19 4.19c-4.05 4.05-10.78 3.89-15.02-0.35l0 0c-4.24-4.24-4.4-10.97-0.35-15.02l8.38-8.38c4.05-4.05 10.78-3.89 15.02 0.35l0 0"/>';
	    }
	  }
	});

	module.exports = LinkIcon;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ListIcon = React.createClass({
	  displayName: 'ListIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="9" x2="1" y2="9"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 12.13C31 13.16 30.16 14 29.13 14H2.88C1.84 14 1 13.16 1 12.13v-7.25C1 3.84 1.84 3 2.88 3h26.25C30.16 3 31 3.84 31 4.88V12.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29H2.88C1.84 29 1 28.16 1 27.13v-7.25C1 18.84 1.84 18 2.88 18h26.25C30.16 18 31 18.84 31 19.88V27.13z"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 18.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h39.38c1.55 0 2.81 1.26 2.81 2.81V18.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V29.31c0-1.55 1.26-2.81 2.81-2.81h39.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/>';
	    }
	  }
	});

	module.exports = ListIcon;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var LogoIcon = React.createClass({
	  displayName: 'LogoIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M9,0 C4.0275,0 0,4.0275 0,9 C0,13.9725 4.0275,18 9,18 C13.9725,18 18,13.9725 18,9 C18,4.0275 13.9725,0 9,0 L9,0 Z M10.839375,12.290625 C10.366875,12.72375 9.748125,12.9375 8.971875,12.9375 C8.19,12.931875 7.57125,12.718125 7.115625,12.285 C6.676875,11.863125 6.451875,11.289375 6.451875,10.575 L6.451875,10.575 L6.451875,10.558125 L6.451875,10.575 L8.083125,10.575 L8.083125,10.670625 C8.083125,10.906875 8.1675,11.109375 8.341875,11.26125 C8.51625,11.41875 8.735625,11.4975 8.994375,11.4975 C9.275625,11.4975 9.511875,11.41875 9.703125,11.266875 C9.894375,11.115 9.99,10.92375 9.99,10.69875 C9.99,10.456875 9.88875,10.26 9.68625,10.108125 C9.59625,10.040625 9.495,9.97875 9.388125,9.93375 C9.28125,9.88875 9.073125,9.804375 8.76375,9.691875 C7.993125,9.405 7.425,9.084375 7.065,8.735625 C6.705,8.386875 6.525,7.925625 6.525,7.3575 C6.525,6.67125 6.755625,6.114375 7.216875,5.6925 C7.6725,5.27625 8.274375,5.0625 9.01125,5.0625 C9.73125,5.0625 10.310625,5.265 10.755,5.675625 C11.199375,6.08625 11.446875,6.654375 11.50875,7.38 L10.006875,7.38 C9.97875,7.0875 9.883125,6.8625 9.72,6.721875 C9.556875,6.575625 9.32625,6.508125 9.016875,6.508125 C8.74125,6.508125 8.51625,6.575625 8.341875,6.71625 C8.1675,6.85125 8.083125,7.03125 8.083125,7.250625 C8.083125,7.54875 8.240625,7.779375 8.55,7.948125 C8.71875,8.038125 9.016875,8.161875 9.43875,8.31375 C9.855,8.465625 10.175625,8.600625 10.40625,8.724375 C10.63125,8.848125 10.8225,8.98875 10.98,9.14625 C11.3625,9.5175 11.55375,9.995625 11.55375,10.58625 C11.55375,11.28375 11.311875,11.8575 10.839375,12.290625 L10.839375,12.290625 Z" />';
	      case 'medium':
	        return '<path d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0zM19.27 21.85C18.43 22.62 17.33 23 15.95 23c-1.39-0.01-2.49-0.39-3.3-1.16 -0.78-0.75-1.18-1.77-1.18-3.04h0c0-0.01 0-0.02 0-0.03 0 0.01 0 0.02 0 0.03h2.9v0.17c0 0.42 0.15 0.78 0.46 1.05 0.31 0.28 0.7 0.42 1.16 0.42 0.5 0 0.92-0.14 1.26-0.41 0.34-0.27 0.51-0.61 0.51-1.01 0-0.43-0.18-0.78-0.54-1.05 -0.16-0.12-0.34-0.23-0.53-0.31 -0.19-0.08-0.56-0.23-1.11-0.43 -1.37-0.51-2.38-1.08-3.02-1.7 -0.64-0.62-0.96-1.44-0.96-2.45 0-1.22 0.41-2.21 1.23-2.96C13.64 9.38 14.71 9 16.02 9c1.28 0 2.31 0.36 3.1 1.09 0.79 0.73 1.23 1.74 1.34 3.03h-2.67c-0.05-0.52-0.22-0.92-0.51-1.17 -0.29-0.26-0.7-0.38-1.25-0.38 -0.49 0-0.89 0.12-1.2 0.37 -0.31 0.24-0.46 0.56-0.46 0.95 0 0.53 0.28 0.94 0.83 1.24 0.3 0.16 0.83 0.38 1.58 0.65 0.74 0.27 1.31 0.51 1.72 0.73 0.4 0.22 0.74 0.47 1.02 0.75 0.68 0.66 1.02 1.51 1.02 2.56C20.54 20.06 20.11 21.08 19.27 21.85z"/>';
	      case 'large':
	        return '<path d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0zM19.27 21.85C18.43 22.62 17.33 23 15.95 23c-1.39-0.01-2.49-0.39-3.3-1.16 -0.78-0.75-1.18-1.77-1.18-3.04h0c0-0.01 0-0.02 0-0.03 0 0.01 0 0.02 0 0.03h2.9v0.17c0 0.42 0.15 0.78 0.46 1.05 0.31 0.28 0.7 0.42 1.16 0.42 0.5 0 0.92-0.14 1.26-0.41 0.34-0.27 0.51-0.61 0.51-1.01 0-0.43-0.18-0.78-0.54-1.05 -0.16-0.12-0.34-0.23-0.53-0.31 -0.19-0.08-0.56-0.23-1.11-0.43 -1.37-0.51-2.38-1.08-3.02-1.7 -0.64-0.62-0.96-1.44-0.96-2.45 0-1.22 0.41-2.21 1.23-2.96C13.64 9.38 14.71 9 16.02 9c1.28 0 2.31 0.36 3.1 1.09 0.79 0.73 1.23 1.74 1.34 3.03h-2.67c-0.05-0.52-0.22-0.92-0.51-1.17 -0.29-0.26-0.7-0.38-1.25-0.38 -0.49 0-0.89 0.12-1.2 0.37 -0.31 0.24-0.46 0.56-0.46 0.95 0 0.53 0.28 0.94 0.83 1.24 0.3 0.16 0.83 0.38 1.58 0.65 0.74 0.27 1.31 0.51 1.72 0.73 0.4 0.22 0.74 0.47 1.02 0.75 0.68 0.66 1.02 1.51 1.02 2.56C20.54 20.06 20.11 21.08 19.27 21.85z"/>';
	    }
	  }
	});

	module.exports = LogoIcon;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var MoreIcon = React.createClass({
	  displayName: 'MoreIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<circle cx="16" cy="9" r="2"/><circle cx="9" cy="9" r="2"/><circle cx="2" cy="9" r="2"/>';
	      case 'medium':
	        return '<circle cx="29" cy="16" r="3"/><circle cx="16" cy="16" r="3"/><circle cx="3" cy="16" r="3"/>';
	      case 'large':
	        return '<circle cx="37" cy="24" r="3"/><circle cx="24" cy="24" r="3"/><circle cx="11" cy="24" r="3"/>';
	    }
	  }
	});

	module.exports = MoreIcon;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var NotificationIcon = React.createClass({
	  displayName: 'NotificationIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="13" x2="9" y2="17"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M2 13h14 0.01l-3.1-9.27C12.33 2.14 10.8 1 9 1S5.68 2.14 5.1 3.73L2 13"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="25" x2="16" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="1" x2="16" y2="3"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M5 25h21.99H27L23.25 8C22.17 5.08 19.33 3 16 3S9.83 5.08 8.75 8L5 25"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="25" x2="29" y2="25"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.99" y1="39.28" x2="23.99" y2="46.28"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.99" y1="2" x2="23.99" y2="4.81"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M7.87 38.5h32.25 0.01l-5.5-25.66C33.05 8.56 28.88 5.5 24 5.5s-9.05 3.06-10.63 7.34L7.87 38.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5" y1="38.5" x2="43" y2="38.5"/>';
	    }
	  }
	});

	module.exports = NotificationIcon;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var OperaIcon = React.createClass({
	  displayName: 'OperaIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M8.97 0c-4.92 0-8.45 3.57-8.45 8.92 0 4.76 3.44 9.08 8.45 9.08 5.06 0 8.52-4.32 8.52-9.08 0-5.39-3.65-8.92-8.52-8.92zM12.1 8.76c0 2.98-0.16 7.22-3.13 7.22v0c-2.93 0-3.05-4.24-3.05-7.21 0-3.49 0.33-6.83 3.05-6.83 2.72 0 3.13 3.39 3.13 6.83z"/>';
	      case 'medium':
	        return '<path d="M15.939 0c-8.741 0-15.023 6.34-15.023 15.851 0 8.463 6.109 16.149 15.024 16.149 9.002 0 15.144-7.684 15.144-16.149 0-9.586-6.483-15.851-15.146-15.851zM21.511 15.579c-0.002 5.292-0.284 12.828-5.571 12.828v0.001c-5.212 0-5.42-7.54-5.42-12.822 0-6.199 0.58-12.143 5.42-12.143 4.84 0 5.571 6.018 5.571 12.136z"/>';
	      case 'large':
	        return '<path d="M23.908 0c-13.112 0-22.535 9.511-22.535 23.776 0 12.695 9.164 24.224 22.537 24.224 13.504 0 22.717-11.526 22.717-24.224 0-14.379-9.724-23.776-22.718-23.776zM32.267 23.369c-0.003 7.938-0.426 19.241-8.357 19.241v0.002c-7.818 0-8.13-11.309-8.13-19.233 0-9.299 0.87-18.214 8.13-18.214 7.26 0 8.357 9.027 8.357 18.204z"/>';
	    }
	  }
	});

	module.exports = OperaIcon;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PauseIcon = React.createClass({
	  displayName: 'PauseIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   2,1 2,17 7,17 7,1 "/><polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   11,1 11,17 16,17 16,1 "/>';
	      case 'medium':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   3,1 3,31 13,31 13,1 "/><polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   19,1 19,31 29,31 29,1 "/>';
	      case 'large':
	        return '<polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   4.5,1.5 4.5,46.5 19.5,46.5 19.5,1.5 "/><polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   28.5,1.5 28.5,46.5 43.5,46.5 43.5,1.5 "/>';
	    }
	  }
	});

	module.exports = PauseIcon;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PinterestIcon = React.createClass({
	  displayName: 'PinterestIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M7.75 11.91c-0.47 2.48-1.05 4.85-2.76 6.1-0.53-3.75 0.78-6.56 1.38-9.54-1.03-1.74 0.12-5.23 2.3-4.37 2.68 1.06-2.32 6.46 1.03 7.13 3.5 0.7 4.93-6.07 2.76-8.28-3.14-3.18-9.13-0.07-8.39 4.48 0.18 1.11 1.33 1.45 0.46 2.99-2.01-0.44-2.61-2.03-2.53-4.14 0.12-3.45 3.11-5.87 6.1-6.21 3.78-0.42 7.33 1.39 7.82 4.95 0.55 4.01-1.71 8.36-5.75 8.05-1.09-0.08-1.55-0.63-2.41-1.15z"/>';
	      case 'medium':
	        return '<path d="M13.786 21.165c-0.84 4.405-1.866 8.629-4.906 10.835-0.938-6.659 1.378-11.659 2.453-16.968-1.834-3.088 0.221-9.299 4.090-7.768 4.76 1.883-4.122 11.477 1.84 12.675 6.226 1.251 8.766-10.8 4.907-14.718-5.578-5.661-16.237-0.131-14.925 7.97 0.318 1.981 2.365 2.582 0.818 5.315-3.57-0.79-4.635-3.606-4.498-7.36 0.221-6.142 5.52-10.443 10.835-11.038 6.723-0.754 13.032 2.467 13.901 8.79 0.981 7.136-3.032 14.866-10.222 14.309-1.947-0.149-2.765-1.114-4.293-2.042z"/>';
	      case 'large':
	        return '<path d="M20.678 31.747c-1.26 6.607-2.798 12.943-7.358 16.253-1.406-9.989 2.066-17.489 3.679-25.452-2.75-4.632 0.331-13.949 6.134-11.652 7.14 2.825-6.182 17.215 2.76 19.013 9.338 1.877 13.15-16.2 7.361-22.078-8.366-8.491-24.355-0.197-22.387 11.954 0.478 2.971 3.547 3.874 1.226 7.973-5.354-1.186-6.953-5.41-6.746-11.040 0.331-9.214 8.28-15.665 16.253-16.558 10.085-1.13 19.548 3.701 20.851 13.186 1.471 10.704-4.548 22.298-15.334 21.463-2.921-0.223-4.147-1.67-6.439-3.062z"/>';
	    }
	  }
	});

	module.exports = PinterestIcon;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PlayIcon = React.createClass({
	  displayName: 'PlayIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  2,1 16,9 2,17 "/>';
	      case 'medium':
	        return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   3,1 29,16 3,31  "/>';
	      case 'large':
	        return '<polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="   5.5,1.5 44.5,24 5.5,46.5  "/>';
	    }
	  }
	});

	module.exports = PlayIcon;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PlusIcon = React.createClass({
	  displayName: 'PlusIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="1" x2="9" y2="17"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="1" y1="9" x2="17" y2="9"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="1" x2="16" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="1" y1="16" x2="31" y2="16"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.5" y1="2" x2="23.5" y2="46"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2" y1="24.5" x2="46" y2="24.5"/>';
	    }
	  }
	});

	module.exports = PlusIcon;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var PosterIcon = React.createClass({
	  displayName: 'PosterIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4" y1="5" x2="4" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="4" y1="5" x2="8" y2="5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="14" y1="13" x2="14" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="14" y1="13" x2="10" y2="13"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29H2.88C1.84 29 1 28.16 1 27.13V4.88C1 3.84 1.84 3 2.88 3h26.25C30.16 3 31 3.84 31 4.88V27.13z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5" y1="7" x2="5" y2="14"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5" y1="7" x2="12" y2="7"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="27" y1="25" x2="27" y2="18"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="27" y1="25" x2="20" y2="25"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h39.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="7.5" y1="11" x2="7.5" y2="22"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="8" y1="10.5" x2="19" y2="10.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="40.5" y1="37" x2="40.5" y2="26"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="40" y1="37.5" x2="29" y2="37.5"/>';
	    }
	  }
	});

	module.exports = PosterIcon;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var SafariIcon = React.createClass({
	  displayName: 'SafariIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M9 1.125c-0.423 0-0.839 0.032-1.245 0.092-0.005-0.014-0.011-0.027-0.017-0.04 0.225-0.176 0.344-0.419 0.292-0.66-0.066-0.309-0.394-0.516-0.816-0.516-0.091 0-0.184 0.01-0.276 0.029-0.53 0.113-0.881 0.503-0.799 0.889 0.05 0.234 0.251 0.41 0.53 0.481-0.001 0.017 0 0.034 0.001 0.052-3.527 1.011-6.107 4.26-6.107 8.111 0 4.66 3.778 8.438 8.438 8.438 4.66 0 8.438-3.778 8.438-8.438 0-4.66-3.778-8.438-8.438-8.438zM6.414 0.86c-0.048-0.224 0.219-0.478 0.583-0.555 0.073-0.015 0.146-0.023 0.217-0.023 0.282 0 0.504 0.121 0.541 0.293 0.028 0.132-0.054 0.274-0.2 0.385-0.124-0.087-0.282-0.125-0.441-0.091-0.159 0.034-0.287 0.132-0.365 0.261-0.179-0.043-0.308-0.142-0.335-0.27zM13.524 14.087c-0.773 0.773-1.709 1.323-2.73 1.62l-0.745-1.209-0.189 1.406c-0.283 0.038-0.57 0.057-0.86 0.057-1.709 0-3.316-0.666-4.524-1.874-0.773-0.773-1.323-1.709-1.62-2.73l1.209-0.745-1.406-0.189c-0.038-0.283-0.057-0.57-0.057-0.86 0-1.709 0.666-3.316 1.874-4.524 0.773-0.773 1.709-1.323 2.73-1.62l0.745 1.209 0.189-1.406c0.283-0.038 0.57-0.057 0.86-0.057 1.709 0 3.316 0.666 4.524 1.874 0.773 0.773 1.323 1.709 1.62 2.73l-1.209 0.745 1.406 0.189c0.038 0.283 0.057 0.57 0.057 0.86 0 1.709-0.666 3.316-1.874 4.524zM13.375 5.187l-3.463 2.632c-0.257-0.135-0.543-0.212-0.833-0.224l-0.898-1.884-0.054 2.086c-0.234 0.115-0.441 0.275-0.613 0.474l-1.109-0.393 0.81 0.853c-0.111 0.238-0.173 0.493-0.183 0.753l-1.884 0.898 2.087 0.054c0.007 0.014 0.014 0.027 0.021 0.04l-2.632 3.463 3.463-2.632c0.257 0.135 0.543 0.212 0.833 0.224l0.898 1.884 0.054-2.086c0.234-0.115 0.441-0.275 0.613-0.474l1.109 0.393-0.81-0.853c0.111-0.238 0.173-0.493 0.183-0.753l1.884-0.898-2.087-0.054c-0.007-0.013-0.014-0.027-0.021-0.04l2.631-3.463zM9.002 7.814v0zM8.649 7.912c0.118-0.025 0.236-0.037 0.353-0.037 0.073 0 0.145 0.005 0.216 0.014l0.002 0.001 0 0c0.153 0.02 0.302 0.062 0.442 0.121l-1.258 0.956-0.956 1.258c-0.042-0.098-0.075-0.202-0.098-0.31-0.194-0.912 0.388-1.808 1.3-2.001zM9.881 11.002v0 0c-0.159 0.097-0.337 0.17-0.53 0.211-0.118 0.025-0.236 0.037-0.353 0.037-0.073 0-0.145-0.005-0.216-0.014l-0.001 0c-0.154-0.02-0.302-0.062-0.442-0.121l1.258-0.956 0.956-1.258c0.042 0.098 0.075 0.202 0.098 0.31 0.153 0.719-0.177 1.427-0.77 1.79z"/>';
	      case 'medium':
	        return '<path d="M16 2c-0.752 0-1.491 0.056-2.213 0.163-0.009-0.024-0.020-0.048-0.031-0.072 0.401-0.313 0.611-0.745 0.52-1.173-0.117-0.549-0.7-0.918-1.451-0.918-0.162 0-0.327 0.018-0.49 0.052-0.943 0.2-1.567 0.894-1.421 1.58 0.089 0.417 0.447 0.729 0.943 0.856-0.001 0.030-0.001 0.061 0.001 0.092-6.269 1.798-10.857 7.573-10.857 14.42 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zM11.403 1.528c-0.085-0.398 0.39-0.85 1.036-0.987 0.129-0.027 0.259-0.041 0.386-0.041 0.501 0 0.897 0.215 0.962 0.522 0.050 0.235-0.096 0.488-0.356 0.684-0.22-0.155-0.501-0.223-0.784-0.162-0.283 0.060-0.511 0.235-0.649 0.464-0.318-0.077-0.547-0.253-0.595-0.48zM24.043 25.043c-1.374 1.374-3.038 2.352-4.853 2.88l-1.325-2.149-0.336 2.499c-0.503 0.067-1.013 0.102-1.529 0.102-3.038 0-5.895-1.183-8.043-3.332-1.374-1.374-2.352-3.038-2.88-4.853l2.149-1.325-2.499-0.336c-0.067-0.503-0.102-1.013-0.102-1.529 0-3.038 1.183-5.895 3.332-8.043 1.374-1.374 3.038-2.352 4.853-2.88l1.325 2.149 0.336-2.499c0.503-0.067 1.013-0.102 1.529-0.102 3.038 0 5.895 1.183 8.043 3.332 1.374 1.374 2.352 3.038 2.88 4.853l-2.149 1.325 2.499 0.336c0.067 0.503 0.102 1.013 0.102 1.529 0 3.038-1.183 5.895-3.332 8.043zM23.778 9.222l-6.156 4.678c-0.458-0.239-0.965-0.377-1.482-0.398l-1.596-3.349-0.096 3.708c-0.415 0.204-0.784 0.489-1.090 0.842l-1.972-0.699 1.44 1.517c-0.198 0.422-0.308 0.876-0.326 1.338l-3.349 1.596 3.711 0.096c0.012 0.024 0.024 0.048 0.037 0.071l-4.678 6.156 6.156-4.678c0.458 0.239 0.965 0.377 1.482 0.398l1.596 3.349 0.096-3.708c0.415-0.204 0.785-0.489 1.090-0.842l1.972 0.699-1.44-1.517c0.198-0.422 0.308-0.876 0.326-1.338l3.349-1.596-3.71-0.096c-0.012-0.024-0.024-0.048-0.037-0.071l4.678-6.156zM16.003 13.892v0zM15.376 14.066c0.21-0.045 0.42-0.066 0.627-0.066 0.13 0 0.258 0.008 0.384 0.025l0.003 0.001-0-0.001c0.273 0.036 0.537 0.109 0.785 0.216l-2.236 1.699-1.699 2.236c-0.074-0.175-0.133-0.359-0.174-0.552-0.345-1.621 0.69-3.214 2.311-3.558zM17.566 19.559v0 0c-0.283 0.173-0.599 0.303-0.942 0.376-0.21 0.045-0.42 0.066-0.627 0.066-0.13 0-0.258-0.009-0.385-0.025l-0.002-0c-0.273-0.036-0.537-0.109-0.785-0.215l2.236-1.699 1.699-2.236c0.074 0.175 0.133 0.359 0.174 0.552 0.272 1.278-0.314 2.538-1.368 3.183z"/>';
	      case 'large':
	        return '<path d="M24 3c-1.128 0-2.236 0.084-3.32 0.244-0.014-0.037-0.029-0.073-0.046-0.108 0.601-0.469 0.916-1.117 0.78-1.76-0.175-0.823-1.050-1.376-2.177-1.376-0.243 0-0.49 0.026-0.735 0.078-1.414 0.301-2.351 1.342-2.132 2.37 0.133 0.625 0.67 1.094 1.414 1.284-0.002 0.046-0.001 0.091 0.002 0.138-9.404 2.697-16.286 11.36-16.286 21.63 0 12.426 10.074 22.5 22.5 22.5 12.426 0 22.5-10.074 22.5-22.5 0-12.426-10.074-22.5-22.5-22.5zM17.104 2.293c-0.127-0.597 0.585-1.275 1.554-1.48 0.194-0.041 0.389-0.062 0.579-0.062 0.752 0 1.345 0.322 1.443 0.782 0.075 0.352-0.144 0.732-0.534 1.027-0.33-0.233-0.751-0.334-1.177-0.244-0.424 0.090-0.766 0.352-0.973 0.696-0.477-0.115-0.821-0.379-0.893-0.719zM36.065 37.565c-2.061 2.061-4.557 3.529-7.28 4.32l-1.987-3.224-0.504 3.748c-0.754 0.101-1.52 0.153-2.294 0.153-4.558 0-8.842-1.775-12.065-4.998-2.061-2.061-3.529-4.557-4.32-7.28l3.224-1.987-3.748-0.504c-0.101-0.754-0.153-1.52-0.153-2.294 0-4.558 1.775-8.842 4.998-12.065 2.061-2.061 4.557-3.529 7.28-4.32l1.987 3.224 0.504-3.748c0.754-0.101 1.52-0.153 2.294-0.153 4.558 0 8.842 1.775 12.065 4.998 2.061 2.061 3.529 4.557 4.32 7.28l-3.224 1.987 3.748 0.504c0.101 0.754 0.153 1.52 0.153 2.294 0 4.558-1.775 8.842-4.998 12.065zM35.667 13.833l-9.233 7.017c-0.686-0.359-1.447-0.565-2.223-0.597l-2.394-5.024-0.144 5.562c-0.623 0.306-1.177 0.734-1.635 1.263l-2.957-1.048 2.161 2.275c-0.297 0.634-0.462 1.314-0.489 2.007l-5.023 2.394 5.566 0.144c0.018 0.036 0.036 0.072 0.055 0.107l-7.017 9.233 9.233-7.017c0.686 0.359 1.447 0.565 2.223 0.596l2.394 5.024 0.144-5.562c0.623-0.306 1.177-0.734 1.635-1.263l2.957 1.049-2.161-2.275c0.297-0.634 0.463-1.314 0.489-2.007l5.023-2.394-5.566-0.144c-0.018-0.036-0.036-0.071-0.055-0.107l7.017-9.233zM24.005 20.838v0zM23.064 21.098c0.315-0.067 0.63-0.099 0.94-0.099 0.194 0 0.387 0.013 0.576 0.037l0.004 0.002-0-0.001c0.409 0.054 0.805 0.164 1.178 0.323l-3.354 2.549-2.549 3.354c-0.111-0.262-0.2-0.538-0.262-0.827-0.517-2.431 1.035-4.82 3.466-5.337zM26.349 29.338v0 0c-0.425 0.26-0.899 0.454-1.414 0.563-0.315 0.067-0.63 0.099-0.94 0.099-0.195 0-0.387-0.013-0.577-0.037l-0.003-0c-0.409-0.054-0.805-0.164-1.178-0.323l3.354-2.549 2.549-3.354c0.111 0.262 0.2 0.538 0.262 0.828 0.407 1.916-0.471 3.806-2.052 4.774z"/>';
	    }
	  }
	});

	module.exports = SafariIcon;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var SearchIcon = React.createClass({
	  displayName: 'SearchIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<circle cx="7.5" cy="7.5" r="5.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M15.53 15.53L11.47 11.47"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
	      case 'medium':
	        return '<circle cx="13" cy="13" r="11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M29.51 29.51L21 21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
	      case 'large':
	        return '<circle cx="20.5" cy="20.5" r="17" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M44.5 44.5L32.5 32.5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
	    }
	  }
	});

	module.exports = SearchIcon;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var SetIcon = React.createClass({
	  displayName: 'SetIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V6c0-0.55 0.45-1 1-1h11c0.55 0 1 0.45 1 1V15z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 13h2c0.55 0 1-0.45 1-1V3c0-0.55-0.45-1-1-1H5C4.45 2 4 2.45 4 3v2"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M25 27.13C25 28.16 24.16 29 23.13 29H2.88C1.84 29 1 28.16 1 27.13v-16.25C1 9.84 1.84 9 2.88 9h20.25C24.16 9 25 9.84 25 10.88V27.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M28 23h0.97C29.99 23 31 22.37 31 21.37V5.01C31 4 29.99 3 28.97 3H8.66C7.64 3 7 4 7 5.01V6"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M25 26h0.84C26.86 26 28 25.5 28 24.49V8.13C28 7.13 26.86 6 25.84 6H5.53C4.51 6 4 7.13 4 8.13V9"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M36.5 40.77c0 1.51-1.22 2.73-2.73 2.73H4.23c-1.51 0-2.73-1.22-2.73-2.73V17.23c0-1.51 1.22-2.73 2.73-2.73h29.53c1.51 0 2.73 1.22 2.73 2.73V40.77z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M37 39.5h2c1.55 0 2.5-0.82 2.5-2.37V11.81c0-1.55-0.95-2.31-2.5-2.31H8.06C6.51 9.5 5.5 10.26 5.5 11.81V14"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M42 34.5h2c1.55 0 2.5-0.82 2.5-2.37V6.81C46.5 5.26 45.55 4.5 44 4.5H13.06c-1.55 0-2.56 0.76-2.56 2.31V9"/>';
	    }
	  }
	});

	module.exports = SetIcon;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var SettingsIcon = React.createClass({
	  displayName: 'SettingsIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path fill="currentColor" stroke-width="0" d="M17.916 7.764c-0.019-0.141-0.104-0.267-0.218-0.351 -0.076-0.056-0.167-0.089-0.26-0.1L15.581 6.98c-0.127-0.415-0.294-0.817-0.498-1.202l1.06-1.522c0.176-0.185 0.196-0.475 0.037-0.685 -0.251-0.33-0.524-0.643-0.815-0.934 -0.295-0.294-0.609-0.568-0.935-0.815 -0.114-0.088-0.265-0.114-0.405-0.094 -0.092 0.015-0.179 0.055-0.252 0.114l-1.548 1.076c-0.384-0.203-0.786-0.37-1.203-0.498l-0.327-1.822c-0.002-0.109-0.038-0.215-0.103-0.303 -0.085-0.115-0.212-0.191-0.354-0.21 -0.812-0.113-1.662-0.113-2.475 0C7.621 0.104 7.496 0.189 7.411 0.304 7.355 0.378 7.322 0.469 7.312 0.562L6.979 2.419C6.563 2.546 6.161 2.712 5.776 2.917L4.256 1.86C4.18 1.785 4.079 1.735 3.969 1.718c-0.136-0.022-0.285 0.014-0.4 0.102C3.242 2.069 2.928 2.343 2.635 2.635 2.344 2.925 2.07 3.24 1.82 3.569 1.734 3.683 1.705 3.831 1.726 3.971 1.74 4.064 1.78 4.152 1.839 4.226l1.077 1.549c-0.203 0.384-0.37 0.786-0.497 1.202L0.597 7.304C0.488 7.306 0.382 7.342 0.293 7.408 0.179 7.493 0.104 7.62 0.084 7.761 0.028 8.166-0.001 8.583-0.001 8.998c0 0.416 0.029 0.833 0.085 1.238 0.019 0.141 0.104 0.267 0.218 0.351 0.076 0.056 0.167 0.089 0.26 0.1l1.857 0.333c0.127 0.415 0.294 0.817 0.498 1.202l-1.056 1.519C1.784 13.82 1.735 13.92 1.718 14.03c-0.022 0.141 0.015 0.285 0.101 0.399 0.251 0.33 0.524 0.643 0.815 0.934 0.295 0.294 0.609 0.568 0.935 0.815 0.114 0.088 0.265 0.117 0.405 0.094 0.092-0.015 0.179-0.055 0.252-0.114l1.548-1.076c0.385 0.204 0.787 0.37 1.203 0.498l0.328 1.822c0.002 0.109 0.038 0.215 0.103 0.303 0.085 0.115 0.212 0.19 0.354 0.21C8.168 17.972 8.583 18 8.999 18c0.416 0 0.832-0.029 1.239-0.084 0.142-0.019 0.267-0.104 0.352-0.219 0.056-0.074 0.089-0.165 0.099-0.258l0.333-1.857c0.414-0.127 0.816-0.293 1.201-0.498l1.52 1.057c0.077 0.075 0.177 0.125 0.287 0.142 0.136 0.022 0.285-0.015 0.4-0.102 0.327-0.249 0.641-0.523 0.934-0.815 0.291-0.29 0.565-0.605 0.815-0.934 0.086-0.114 0.115-0.262 0.094-0.402 -0.014-0.093-0.054-0.181-0.113-0.255 -0.519-0.746-0.854-1.227-1.085-1.535 0.207-0.388 0.376-0.796 0.505-1.217l1.821-0.327c0.11-0.002 0.216-0.038 0.305-0.104 0.114-0.085 0.189-0.212 0.209-0.353 0.056-0.405 0.085-0.822 0.085-1.237C18.001 8.586 17.972 8.169 17.916 7.764zM8.999 13.5c-2.485 0-4.5-2.015-4.5-4.5 0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5C13.499 11.485 11.485 13.5 8.999 13.5z"/><circle fill="currentColor" stroke-width="0" cx="9" cy="9" r="2"/>';
	      case 'medium':
	        return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="15.999" cy="16" r="5.5"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M13.238 5.092l0.704-3.917 -0.005-0.034C14.611 1.048 15.3 1 16 1s1.388 0.048 2.063 0.141l-0.005 0.034 0.704 3.917 0 0c1.042 0.263 2.054 0.677 3.001 1.242h-0.001l3.267-2.272 0.02-0.028c0.542 0.411 1.063 0.864 1.558 1.359s0.948 1.016 1.359 1.558l-0.028 0.02 -2.272 3.267c0.551 0.923 0.974 1.931 1.243 3 -0.001 0 3.916 0.703 3.916 0.703l0.034-0.005C30.952 14.61 31 15.299 31 15.999s-0.048 1.388-0.141 2.063l-0.034-0.005 -3.917 0.704c-0.263 1.042-0.677 2.054-1.242 3.001 0-0.001 2.272 3.267 2.272 3.267l0.028 0.02c-0.411 0.542-0.864 1.063-1.359 1.558 -0.495 0.495-1.016 0.948-1.558 1.359l-0.02-0.028 -3.267-2.272c-0.923 0.551-1.931 0.974-3 1.243v-0.001l-0.704 3.917 0.005 0.034C17.389 30.952 16.7 31 16 31s-1.388-0.048-2.063-0.141l0.005-0.034 -0.704-3.917c-1.042-0.263-2.054-0.677-3.001-1.242h0.001l-3.267 2.272 -0.02 0.028c-0.542-0.411-1.063-0.864-1.558-1.359s-0.948-1.016-1.359-1.558l0.028-0.02 2.272-3.267c-0.551-0.923-0.974-1.931-1.243-3h0.001l-3.917-0.704 -0.034 0.005C1.048 17.389 1 16.7 1 16c0-0.7 0.048-1.388 0.141-2.063l0.034 0.005 3.917-0.704 0 0c0.263-1.042 0.677-2.054 1.242-3.001v0.001L4.062 6.971l-0.028-0.02c0.411-0.542 0.864-1.063 1.359-1.558 0.495-0.495 1.016-0.948 1.558-1.359l0.02 0.028 3.267 2.272C11.161 5.784 12.169 5.361 13.238 5.092z"/>';
	      case 'large':
	        return '<circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="23.999" cy="24" r="8.5"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M19.858 7.638l1.056-5.875 -0.008-0.052c1.012-0.139 2.045-0.211 3.094-0.211 1.05 0 2.082 0.072 3.094 0.211l-0.008 0.052 1.056 5.875 0 0c1.563 0.394 3.082 1.015 4.501 1.863L32.64 9.502l4.901-3.409 0.031-0.042c0.814 0.617 1.595 1.297 2.337 2.039s1.421 1.523 2.039 2.337l-0.042 0.031 -3.409 4.901c0.827 1.384 1.461 2.897 1.866 4.5l5.874 1.055 0.052-0.008C46.428 21.917 46.5 22.95 46.5 24c0 1.05-0.072 2.082-0.211 3.094l-0.052-0.008 -5.875 1.056c-0.395 1.563-1.015 3.081-1.863 4.501 -0.001-0.001 3.408 4.899 3.408 4.899l0.042 0.031c-0.617 0.814-1.297 1.595-2.039 2.337 -0.742 0.742-1.523 1.422-2.337 2.039l-0.031-0.042 -4.9-3.409c-1.384 0.827-2.897 1.461-4.5 1.866v-0.001l-1.056 5.875 0.008 0.052c-1.012 0.139-2.045 0.211-3.094 0.211 -1.05 0-2.082-0.072-3.094-0.211l0.008-0.052 -1.056-5.875c-1.563-0.395-3.082-1.015-4.501-1.864l0.001-0.001 -4.901 3.409 -0.031 0.042c-0.814-0.617-1.595-1.297-2.337-2.039s-1.422-1.523-2.039-2.337l0.042-0.031 3.409-4.901c-0.827-1.384-1.461-2.897-1.866-4.5h0.001l-5.875-1.056 -0.052 0.008C1.572 26.081 1.5 25.048 1.5 23.999c0-1.05 0.072-2.082 0.211-3.094l0.052 0.008 5.875-1.056 0 0c0.394-1.564 1.015-3.082 1.863-4.502l0.001 0.001 -3.409-4.901 -0.042-0.031C6.667 9.611 7.347 8.83 8.09 8.087c0.742-0.742 1.523-1.422 2.337-2.039l0.031 0.042 4.901 3.409C16.742 8.676 18.254 8.042 19.858 7.638z"/>';
	    }
	  }
	});

	module.exports = SettingsIcon;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ShareIcon = React.createClass({
	  displayName: 'ShareIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M15 10.98v5c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1v-12c0-0.55 0.45-1 1-1h5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="11" y2="0.98"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="17" y2="6.98"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="7.92" y2="10.06"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M27 19.86v9.29C27 30.17 26.17 31 25.14 31H2.86C1.83 31 1 30.17 1 29.14V6.86C1 5.83 1.83 5 2.86 5h9.29"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="19.75" y2="1"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="31" y2="12.25"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="13.98" y2="18.02"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M39.5 30.314v13.571c0 1.499-1.215 2.714-2.714 2.714H4.214c-1.499 0-2.714-1.215-2.714-2.714V11.314C1.5 9.815 2.715 8.6 4.214 8.6h13.571"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="29.625" y2="1.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="46.5" y2="18.375"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="20.969" y2="27.031"/>';
	    }
	  }
	});

	module.exports = ShareIcon;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var SpinnerIcon = React.createClass({
	  displayName: 'SpinnerIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"/><path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"><animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.5s" repeatCount="indefinite" /></path>';
	      case 'medium':
	        return '<path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"/><path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"><animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.5s" repeatCount="indefinite" /></path>';
	      case 'large':
	        return '<path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"/><path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"><animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.5s" repeatCount="indefinite" /></path>';
	    }
	  }
	});

	module.exports = SpinnerIcon;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var StampIcon = React.createClass({
	  displayName: 'StampIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 1c0.55 0 1 0.45 1 1v14c0 0.55-0.45 1-1 1H4c-0.55 0-1-0.45-1-1V2c0-0.55 0.45-1 1-1H14z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="12" x2="15" y2="12"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M23.13 1C24.16 1 25 1.84 25 2.88v25.25C25 29.16 24.16 30 23.13 30H6.88C5.84 30 5 29.16 5 28.13V2.88C5 1.84 5.84 1 6.88 1H23.13z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25" y1="20" x2="5" y2="20"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="20" y1="9" x2="10" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="19" y1="12" x2="11" y2="12"/><circle stroke="none" fill="#4dbd10" cx="25" cy="25" r="7"/><line stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25" y1="22" x2="25" y2="28"/><line stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="22" y1="25" x2="28" y2="25"/>';
	      case 'large':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M35.19 1C36.74 1 38 2.32 38 3.94v39.11C38 44.68 36.74 46 35.19 46H10.81C9.26 46 8 44.68 8 43.06V3.94C8 2.32 9.26 1 10.81 1H35.19z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="38" y1="31" x2="8" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="30.5" y1="13" x2="15.5" y2="13"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="29" y1="18" x2="17" y2="18"/><circle stroke="none" fill="#4dbd10" cx="38" cy="38" r="10"/><line stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="38" y1="33.5" x2="38" y2="42.5"/><line stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="33.5" y1="38" x2="42.5" y2="38"/>';
	    }
	  }
	});

	module.exports = StampIcon;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var TextIcon = React.createClass({
	  displayName: 'TextIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="6" x2="5" y2="6"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="9" x2="5" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="12" x2="5" y2="12"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29H2.88C1.84 29 1 28.16 1 27.13V4.88C1 3.84 1.84 3 2.88 3h26.25C30.16 3 31 3.84 31 4.88V27.13z"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="12" x2="9" y2="12"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="8" x2="9" y2="8"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="16" x2="9" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="20" x2="9" y2="20"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="24" x2="9" y2="24"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h39.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35" y1="11.5" x2="13" y2="11.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35" y1="17.5" x2="13" y2="17.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35" y1="23.5" x2="13" y2="23.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35" y1="29.5" x2="13" y2="29.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35" y1="35.5" x2="13" y2="35.5"/>';
	    }
	  }
	});

	module.exports = TextIcon;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var TrendingIcon = React.createClass({
	  displayName: 'TrendingIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="10.63" y1="1" x2="5" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13" y1="9" x2="7.38" y2="17"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5" y1="9" x2="13" y2="9"/>';
	      case 'medium':
	        return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="18.55" y1="1" x2="8" y2="16.01"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23" y1="16" x2="12.45" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="8" y1="16.01" x2="23" y2="16.01"/>';
	      case 'large':
	        return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="29.07" y1="1.5" x2="13.25" y2="24.01"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="35.75" y1="23.99" x2="19.93" y2="46.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13.25" y1="24.01" x2="35.75" y2="24.01"/>';
	    }
	  }
	});

	module.exports = TrendingIcon;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var TumblrIcon = React.createClass({
	  displayName: 'TumblrIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M14.04 16.38c-0.7 0.33-1.33 0.57-1.9 0.7-0.57 0.13-1.18 0.2-1.84 0.2-0.75 0-1.41-0.1-1.98-0.29-0.57-0.19-1.06-0.46-1.47-0.82-0.41-0.35-0.69-0.73-0.84-1.13-0.16-0.4-0.24-0.98-0.24-1.73v-5.81h-1.81v-2.34c0.64-0.21 1.19-0.51 1.65-0.91 0.46-0.39 0.83-0.87 1.1-1.42 0.28-0.55 0.47-1.26 0.57-2.11h2.33v4.19h3.88v2.6h-3.88v4.25c0 0.96 0.05 1.58 0.15 1.85 0.1 0.27 0.29 0.49 0.56 0.65 0.36 0.22 0.78 0.33 1.24 0.33 0.83 0 1.65-0.27 2.47-0.82v2.61z"/>';
	      case 'medium':
	        return '<path d="M24.96 29.114c-1.242 0.592-2.368 1.010-3.374 1.248-1.008 0.237-2.099 0.358-3.269 0.358-1.33 0-2.504-0.171-3.528-0.51-1.021-0.341-1.891-0.826-2.614-1.451-0.722-0.632-1.222-1.299-1.501-2.008-0.28-0.709-0.419-1.736-0.419-3.082v-10.326h-3.214v-4.166c1.142-0.376 2.123-0.912 2.936-1.614 0.816-0.701 1.469-1.544 1.963-2.528 0.493-0.984 0.83-2.234 1.018-3.754h4.136v7.442h6.904v4.621h-6.904v7.55c0 1.706 0.090 2.802 0.27 3.288 0.176 0.483 0.509 0.87 0.994 1.16 0.646 0.39 1.381 0.586 2.21 0.586 1.474 0 2.938-0.485 4.394-1.453v4.64z"/>';
	      case 'large':
	        return '<path d="M37.44 43.67c-1.862 0.888-3.552 1.514-5.062 1.872-1.512 0.355-3.149 0.538-4.903 0.538-1.994 0-3.756-0.257-5.292-0.766-1.531-0.511-2.837-1.238-3.922-2.177-1.082-0.948-1.834-1.949-2.251-3.012-0.42-1.063-0.629-2.604-0.629-4.622v-15.49h-4.822v-6.25c1.714-0.564 3.185-1.368 4.404-2.422 1.224-1.051 2.203-2.316 2.945-3.792 0.739-1.476 1.246-3.35 1.526-5.63h6.204v11.162h10.356v6.931h-10.356v11.326c0 2.558 0.134 4.202 0.406 4.932 0.264 0.725 0.763 1.306 1.49 1.74 0.97 0.586 2.071 0.878 3.314 0.878 2.21 0 4.406-0.727 6.59-2.179v6.96z"/>';
	    }
	  }
	});

	module.exports = TumblrIcon;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var TwitterIcon = React.createClass({
	  displayName: 'TwitterIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path d="M17.28 3.864c-0.61 0.271-1.265 0.453-1.952 0.535 0.702-0.42 1.241-1.086 1.494-1.879-0.656 0.389-1.383 0.672-2.156 0.824-0.62-0.661-1.503-1.073-2.48-1.073-1.877 0-3.397 1.521-3.397 3.397 0 0.266 0.03 0.526 0.088 0.774-2.823-0.141-5.327-1.494-7.002-3.55-0.293 0.501-0.462 1.085-0.462 1.708 0 1.179 0.6 2.219 1.512 2.828-0.557-0.018-1.081-0.17-1.539-0.425 0 0.014 0 0.028 0 0.042 0 1.646 1.172 3.019 2.725 3.332-0.284 0.077-0.585 0.119-0.896 0.119-0.219 0-0.431-0.021-0.639-0.06 0.432 1.35 1.688 2.332 3.173 2.359-1.163 0.912-2.627 1.454-4.219 1.454-0.275 0-0.545-0.016-0.81-0.048 1.503 0.964 3.289 1.526 5.208 1.526 6.249 0 9.666-5.177 9.666-9.667 0-0.147-0.003-0.293-0.01-0.439 0.664-0.479 1.239-1.077 1.696-1.759z"/>';
	      case 'medium':
	        return '<path d="M30.72 6.869c-1.085 0.482-2.248 0.805-3.47 0.952 1.248-0.747 2.206-1.931 2.656-3.341-1.166 0.691-2.459 1.195-3.834 1.466-1.102-1.174-2.672-1.907-4.41-1.907-3.336 0-6.040 2.704-6.040 6.038 0 0.474 0.053 0.934 0.157 1.376-5.019-0.251-9.47-2.656-12.448-6.31-0.522 0.891-0.821 1.93-0.821 3.037 0 2.096 1.067 3.944 2.688 5.027-0.99-0.032-1.922-0.302-2.736-0.755 0 0.026 0 0.050 0 0.075 0 2.926 2.083 5.366 4.845 5.923-0.506 0.138-1.040 0.211-1.592 0.211-0.389 0-0.766-0.037-1.136-0.107 0.768 2.4 3 4.146 5.642 4.194-2.067 1.621-4.67 2.586-7.501 2.586-0.488 0-0.968-0.029-1.44-0.085 2.672 1.714 5.846 2.714 9.259 2.714 11.109 0 17.184-9.203 17.184-17.186 0-0.261-0.005-0.522-0.018-0.781 1.181-0.851 2.203-1.915 3.014-3.126z"/>';
	      case 'large':
	        return '<path d="M46.080 10.303c-1.627 0.722-3.372 1.207-5.206 1.428 1.872-1.121 3.31-2.897 3.984-5.011-1.75 1.037-3.689 1.793-5.75 2.198-1.654-1.762-4.008-2.861-6.614-2.861-5.004 0-9.060 4.056-9.060 9.058 0 0.71 0.079 1.402 0.235 2.064-7.529-0.377-14.206-3.984-18.672-9.466-0.782 1.337-1.231 2.894-1.231 4.555 0 3.144 1.601 5.916 4.032 7.541-1.486-0.048-2.882-0.454-4.104-1.133 0 0.038 0 0.074 0 0.113 0 4.39 3.125 8.050 7.267 8.885-0.758 0.206-1.56 0.317-2.388 0.317-0.583 0-1.15-0.055-1.704-0.161 1.152 3.6 4.5 6.218 8.462 6.29-3.101 2.431-7.006 3.878-11.251 3.878-0.732 0-1.452-0.043-2.16-0.127 4.008 2.57 8.77 4.070 13.889 4.070 16.663 0 25.776-13.805 25.776-25.778 0-0.391-0.007-0.782-0.026-1.171 1.771-1.277 3.305-2.873 4.522-4.69z"/>';
	    }
	  }
	});

	module.exports = TwitterIcon;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var VideoIcon = React.createClass({
	  displayName: 'VideoIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 4l-5 3V4c0-0.55-0.45-1-1-1H2C1.45 3 1 3.45 1 4v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-2.97L17 14V4z"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 6.88L22 12V7c0-1.03-0.96-2-2-2L2.88 5C1.84 5 1 5.84 1 6.88v18.25C1 26.16 1.84 27 2.88 27H20c1.03 0 2-0.96 2-2v-5l9 5.13V6.88z"/>';
	      case 'large':
	        return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 10.33L32.5 19v-8.67c0-1.56-1.32-2.83-2.87-2.83H4.31C2.76 7.5 1.5 8.77 1.5 10.33v28.33c0 1.57 1.26 2.83 2.81 2.83h25.31c1.55 0 2.88-1.27 2.88-2.83V30l14 8.67V10.33z"/>';
	    }
	  }
	});

	module.exports = VideoIcon;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    IconMixin = __webpack_require__(16);

	var ZineIcon = React.createClass({
	  displayName: 'ZineIcon',

	  mixins: [IconMixin],

	  renderSVG: function renderSVG(size) {
	    switch (size) {
	      case 'small':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M14 1c0.55 0 1 0.45 1 1v14c0 0.55-0.45 1-1 1H4c-0.55 0-1-0.45-1-1V2c0-0.55 0.45-1 1-1H14z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="9" cy="8" r="3"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="12" y1="8" x2="15" y2="8"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="8" x2="6" y2="8"/>';
	      case 'medium':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M23.13 1C24.16 1 25 1.84 25 2.88v25.25C25 29.16 24.16 30 23.13 30H6.88C5.84 30 5 29.16 5 28.13V2.88C5 1.84 5.84 1 6.88 1H23.13z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="15" cy="11" r="5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="10" y1="11" x2="5" y2="11"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25" y1="11" x2="20" y2="11"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="20" y1="22" x2="10" y2="22"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="19" y1="25" x2="11" y2="25"/><circle stroke="none" fill="#4dbd10" cx="25" cy="25" r="7"/><line fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="25" y1="22" x2="25" y2="28"/><line fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="22" y1="25" x2="28" y2="25"/>';
	      case 'large':
	        return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M35.19 1C36.74 1 38 2.32 38 3.94v39.11C38 44.68 36.74 46 35.19 46H10.81C9.26 46 8 44.68 8 43.06V3.94C8 2.32 9.26 1 10.81 1H35.19z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="23" cy="16" r="7"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="15.5" y1="16" x2="8" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="38" y1="16" x2="30.5" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="30.5" y1="31" x2="15.5" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="29" y1="36" x2="17" y2="36"/><circle stroke="none" fill="#4dbd10" cx="38" cy="38" r="10"/><line stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="38" y1="33.5" x2="38" y2="42.5"/><line stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="33.5" y1="38" x2="42.5" y2="38"/>';
	    }
	  }
	});

	module.exports = ZineIcon;

/***/ },
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  COVER: null,
	  STAMPS: null,
	  ZINES: null,
	  FEED: null,
	  SOCIAL_PROOF: null
	});

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  STAMP_IN_TRENDING: null,
	  STAMP_APPROVED_IN_ZINE: null,
	  STAMP_REJECTED_FROM_ZINE: null,
	  STAMP_SUBMITTED_TO_ZINE: null,
	  STAMP_LIKED: null,
	  STAMP_ADDED_TO_ZINE: null,
	  ZINE_FOLLOWED: null,
	  WELCOME_MESSAGE: null,
	  USER_FOLLOWED: null,
	  COLLECTED_IMAGE_PUBLISHED: null,
	  DRAFT_FEEDBACK: null
	});

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9);

	module.exports = [ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT, ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS, ActionTypes.PLAYER_SET_CURRENT_TIME];

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  LOGIN_WRONG_CREDENTIALS: null,
	  USER_WRONG_PASSWORD: null,
	  USER_PASSWORD_TOO_SHORT: null,
	  USER_INVALID_EMAIL: null,
	  USER_EMAIL_EXISTS: null,
	  LOGIN_USER_NOT_FOUND: null,
	  BAD_EMAIL: null,
	  ACCOUNT_IS_USED: null,
	  NOT_REGISTERED: null,
	  HAS_ANOTHER_ACCOUNT: null,
	  RECAPTCHA_FAILED: null
	});

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  INITIAL: null,
	  PENDING: null,
	  APPROVED: null
	});

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ContextMenu = __webpack_require__(80);
	var Link = __webpack_require__(21);
	var Icon = __webpack_require__(10);
	var PureRenderMixin = __webpack_require__(2);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var CreateStampOrZineContextMenu = React.createClass({
	  displayName: 'CreateStampOrZineContextMenu',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    anchorRect: React.PropTypes.object.isRequired
	  },

	  render: function render() {
	    var canCreateStamp = !isMobile();

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      canCreateStamp && React.createElement(
	        Link,
	        { propagateClick: true,
	          to: 'draftCompose',
	          params: { stampSegment: 'new' },
	          context: 'ContextMenu',
	          underline: 'never',
	          bold: true },
	        React.createElement(Icon, { name: 'stamp',
	          size: 'large',
	          mode: 'stroke',
	          style: { color: '#abadb3' },
	          context: 'link' }),
	        'New Stamp'
	      ),
	      canCreateStamp && React.createElement(ContextMenu.Separator, null),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          to: 'zineNew',
	          context: 'ContextMenu',
	          underline: 'never',
	          bold: true },
	        React.createElement(Icon, { name: 'zine',
	          size: 'large',
	          mode: 'stroke',
	          style: { color: '#abadb3' },
	          context: 'link' }),
	        'New Collection'
	      )
	    );
	  }
	});

	module.exports = CreateStampOrZineContextMenu;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ContextMenu = __webpack_require__(80);
	var StampDraftStore = __webpack_require__(64);
	var StampStore = __webpack_require__(17);
	var createStoreMixin = __webpack_require__(8);
	var Link = __webpack_require__(21);
	var PureRenderMixin = __webpack_require__(2);
	var AlertActionCreators = __webpack_require__(32);
	var AlertTypes = __webpack_require__(48);
	var SidebarActionCreators = __webpack_require__(29);
	var SidebarTypes = __webpack_require__(39);
	var parseStampSegment = __webpack_require__(53);
	var PropTypes = React.PropTypes;
	var DraftActionCreators = __webpack_require__(33);

	var EditorMoreContextMenu = React.createClass({
	  displayName: 'EditorMoreContextMenu',

	  mixins: [createStoreMixin(StampDraftStore, StampStore), PureRenderMixin],

	  propTypes: {
	    stampSegment: PropTypes.string.isRequired,
	    anchorRect: PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var _parseStampSegment = parseStampSegment(props.stampSegment);

	    var stampId = _parseStampSegment.stampId;
	    var draftUuid = _parseStampSegment.draftUuid;

	    return {
	      draft: StampStore.get(stampId || draftUuid)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var _parseStampSegment2 = parseStampSegment(this.props.stampSegment);

	    var isDraft = _parseStampSegment2.isDraft;
	    var draftUuid = _parseStampSegment2.draftUuid;

	    if (isDraft) {
	      DraftActionCreators.requestDraftFeedbackPage(draftUuid, true);
	    }
	  },

	  render: function render() {
	    var stampSegment = this.props.stampSegment;

	    var _parseStampSegment3 = parseStampSegment(stampSegment);

	    var isDraft = _parseStampSegment3.isDraft;
	    var draft = this.state.draft;

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      isDraft && draft.feedbackCount > 0 && React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleShowFeedbacksClick,
	          context: 'contextMenu',
	          underline: 'never' },
	        'Feedback ',
	        React.createElement(
	          'span',
	          { className: 'Counter' },
	          draft.feedbackCount
	        )
	      ),
	      isDraft && React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleShareDraftClick,
	          context: 'contextMenu',
	          underline: 'never' },
	        'Share Draft'
	      ),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleDeleteClick,
	          context: 'contextMenu',
	          underline: 'never',
	          color: 'red' },
	        isDraft ? 'Delete Draft' : 'Delete Stamp'
	      )
	    );
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    var stampSegment = this.props.stampSegment;

	    var _parseStampSegment4 = parseStampSegment(stampSegment);

	    var isDraft = _parseStampSegment4.isDraft;
	    var draftUuid = _parseStampSegment4.draftUuid;
	    var stampId = _parseStampSegment4.stampId;

	    if (isDraft) {
	      AlertActionCreators.showAlert(AlertTypes.DELETE_DRAFT, { draftUuid: draftUuid });
	    } else {
	      AlertActionCreators.showAlert(AlertTypes.DELETE_STAMP, { stampId: stampId });
	    }
	  },

	  handleShowFeedbacksClick: function handleShowFeedbacksClick() {
	    var stampSegment = this.props.stampSegment;

	    var _parseStampSegment5 = parseStampSegment(stampSegment);

	    var draftUuid = _parseStampSegment5.draftUuid;

	    SidebarActionCreators.showSidebar(SidebarTypes.DRAFT_FEEDBACKS, { draftUuid: draftUuid });
	  },

	  handleShareDraftClick: function handleShareDraftClick() {
	    var stampSegment = this.props.stampSegment;

	    var _parseStampSegment6 = parseStampSegment(stampSegment);

	    var draftUuid = _parseStampSegment6.draftUuid;

	    AlertActionCreators.showAlert(AlertTypes.SHARE_DRAFT, { draftUuid: draftUuid });
	  }
	});

	module.exports = EditorMoreContextMenu;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _underscore = __webpack_require__(4);

	var _moleculesContextMenu = __webpack_require__(80);

	var _moleculesContextMenu2 = _interopRequireDefault(_moleculesContextMenu);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _constantsShareTypes = __webpack_require__(113);

	var _constantsShareTypes2 = _interopRequireDefault(_constantsShareTypes);

	var _atomsShareStampLink = __webpack_require__(394);

	var _atomsShareStampLink2 = _interopRequireDefault(_atomsShareStampLink);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	'use strict';

	var StampMoreContextMenu = _react2['default'].createClass({
	  displayName: 'StampMoreContextMenu',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired,
	    anchorRect: _react.PropTypes.object.isRequired,
	    showEdit: _react.PropTypes.bool.isRequired,
	    shareServices: _react.PropTypes.arrayOf(_react.PropTypes.oneOf((0, _underscore.values)(_constantsShareTypes2['default'])))
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      shareServices: []
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      stamp: _storesStampStore2['default'].get(props.stampId)
	    };
	  },

	  render: function render() {
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(this.state.stamp);

	    return _react2['default'].createElement(
	      _moleculesContextMenu2['default'],
	      { anchorRect: this.props.anchorRect },
	      this.props.shareServices.map(this.renderShareItem),
	      this.props.shareServices.length > 0 && this.props.showEdit && _react2['default'].createElement(_moleculesContextMenu2['default'].Separator, null),
	      this.props.showEdit && _react2['default'].createElement(
	        _atomsLink2['default'],
	        { propagateClick: true,
	          to: 'stampEditCompose',
	          context: 'ContextMenu',
	          underline: 'never',
	          params: { stampSegment: stampSegment } },
	        'Edit Stamp'
	      ),
	      this.props.showEdit && _react2['default'].createElement(
	        _atomsLink2['default'],
	        { onClick: this.confirmDeleteStamp,
	          context: 'ContextMenu',
	          underline: 'never',
	          color: 'red' },
	        'Delete Stamp'
	      )
	    );
	  },

	  confirmDeleteStamp: function confirmDeleteStamp() {
	    if (this.props.isPublishing) {
	      return;
	    }

	    _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].DELETE_STAMP, {
	      stampId: this.props.stampId
	    });
	  },

	  renderShareItem: function renderShareItem(service) {
	    var stamp = this.state.stamp;

	    return _react2['default'].createElement(_atomsShareStampLink2['default'], { key: service,
	      propagateClick: true,
	      service: service,
	      stamp: stamp,
	      context: 'ContextMenu',
	      underline: 'never' });
	  }
	});

	module.exports = StampMoreContextMenu;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _require = __webpack_require__(4);

	var values = _require.values;
	var ContextMenu = __webpack_require__(80);
	var StampStore = __webpack_require__(17);
	var createStoreMixin = __webpack_require__(8);
	var ShareTypes = __webpack_require__(113);
	var ShareStampLink = __webpack_require__(394);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var StampShareContextMenu = React.createClass({
	  displayName: 'StampShareContextMenu',

	  mixins: [createStoreMixin(StampStore), PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    anchorRect: PropTypes.object.isRequired,
	    services: PropTypes.arrayOf(PropTypes.oneOf(values(ShareTypes)))
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      services: values(ShareTypes)
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      stamp: StampStore.get(props.stampId)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.stampId !== this.props.stampId) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var items = this.props.services.map(this.renderMenuItem);

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      items
	    );
	  },

	  renderMenuItem: function renderMenuItem(service) {
	    var stamp = this.state.stamp;

	    return React.createElement(ShareStampLink, { key: service,
	      service: service,
	      stamp: stamp,
	      context: 'ContextMenu',
	      underline: 'never',
	      propagateClick: true });
	  }
	});

	module.exports = StampShareContextMenu;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _atomsLinkDescription = __webpack_require__(393);

	var _atomsLinkDescription2 = _interopRequireDefault(_atomsLinkDescription);

	var _moleculesContextMenu = __webpack_require__(80);

	var _moleculesContextMenu2 = _interopRequireDefault(_moleculesContextMenu);

	var _organismsColorPicker = __webpack_require__(207);

	var _organismsColorPicker2 = _interopRequireDefault(_organismsColorPicker);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	var StampStatusPickerContextMenu = _react2['default'].createClass({
	  displayName: 'StampStatusPickerContextMenu',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  render: function render() {
	    return _react2['default'].createElement(
	      _moleculesContextMenu2['default'],
	      { anchorRect: this.props.anchorRect },
	      _react2['default'].createElement(
	        _atomsLink2['default'],
	        { context: 'contextMenu',
	          underline: 'never',
	          onClick: this.handlePublicClick,
	          propagateClick: true },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eye',
	          mode: 'stroke',
	          size: 'small',
	          margin: 'right' }),
	        _react2['default'].createElement(
	          'b',
	          null,
	          'Public'
	        ),
	        _react2['default'].createElement(
	          _atomsLinkDescription2['default'],
	          { withMaxWidth: true },
	          'Stamp will be public and visible to anyone on your profile page.'
	        )
	      ),
	      _react2['default'].createElement(
	        _atomsLink2['default'],
	        { context: 'contextMenu',
	          underline: 'never',
	          onClick: this.handleUnlistedClick,
	          propagateClick: true },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	          mode: 'fill',
	          size: 'small',
	          margin: 'right' }),
	        _react2['default'].createElement(
	          'b',
	          null,
	          'Secret'
	        ),
	        _react2['default'].createElement(
	          _atomsLinkDescription2['default'],
	          { withMaxWidth: true },
	          'Stamp will be visible only to those who have the link. It won’t be listed on your profile page.'
	        )
	      )
	    );
	  },

	  handlePublicClick: function handlePublicClick() {
	    _actionsDraftActionCreators2['default'].setStatus(_constantsStampStatus2['default'].PUBLIC);
	  },

	  handleUnlistedClick: function handleUnlistedClick() {
	    _actionsDraftActionCreators2['default'].setStatus(_constantsStampStatus2['default'].UNLISTED);
	  }
	});

	exports['default'] = StampStatusPickerContextMenu;
	module.exports = exports['default'];

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ContextMenu = __webpack_require__(80),
	    UserStore = __webpack_require__(5),
	    createStoreMixin = __webpack_require__(8),
	    Link = __webpack_require__(21),
	    Counter = __webpack_require__(165),
	    ModalActionCreators = __webpack_require__(77),
	    AlertActionCreators = __webpack_require__(32),
	    ModalTypes = __webpack_require__(58),
	    AlertTypes = __webpack_require__(48),
	    PureRenderMixin = __webpack_require__(2),
	    SidebarTypes = __webpack_require__(39),
	    SidebarActionCreators = __webpack_require__(29);

	var UserProfileContextMenu = React.createClass({
	  displayName: 'UserProfileContextMenu',

	  mixins: [createStoreMixin(UserStore), PureRenderMixin],

	  propTypes: {
	    userId: React.PropTypes.number.isRequired,
	    anchorRect: React.PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: UserStore.get(props.userId)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.userId !== this.props.userId) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var user = this.state.user;

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          to: 'user',
	          params: { userId: user.id },
	          context: 'ContextMenu',
	          underline: 'never',
	          bold: true },
	        'My Profile'
	      ),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleDraftsClick,
	          context: 'ContextMenu',
	          underline: 'never' },
	        'My Drafts',
	        ' ',
	        user.draftCount > 0 && React.createElement(Counter, { count: user.draftCount })
	      ),
	      React.createElement(ContextMenu.Separator, null),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleInviteFriendsClick,
	          context: 'ContextMenu',
	          underline: 'never' },
	        'Invite Friends'
	      ),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleSettingsClick,
	          context: 'ContextMenu',
	          underline: 'never' },
	        'Settings'
	      ),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleFeedbackClick,
	          context: 'ContextMenu',
	          underline: 'never' },
	        'Send Feedback'
	      ),
	      React.createElement(
	        Link,
	        { propagateClick: true,
	          onClick: this.handleLogoutClick,
	          context: 'ContextMenu',
	          underline: 'never' },
	        'Log Out'
	      )
	    );
	  },

	  handleLogoutClick: function handleLogoutClick() {
	    AlertActionCreators.showAlert(AlertTypes.LOGOUT);
	  },

	  handleSettingsClick: function handleSettingsClick() {
	    ModalActionCreators.showModal(ModalTypes.SETTINGS);
	  },

	  handleFeedbackClick: function handleFeedbackClick() {
	    ModalActionCreators.showModal(ModalTypes.FEEDBACK);
	  },

	  handleInviteFriendsClick: function handleInviteFriendsClick() {
	    ModalActionCreators.showModal(ModalTypes.SEND_INVITE);
	  },

	  handleDraftsClick: function handleDraftsClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.DRAFTS);
	  }
	});

	module.exports = UserProfileContextMenu;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ContextMenu = __webpack_require__(80),
	    UserStore = __webpack_require__(5),
	    createStoreMixin = __webpack_require__(8),
	    ServiceTypes = __webpack_require__(35),
	    ShareUserLink = __webpack_require__(586),
	    PureRenderMixin = __webpack_require__(2);

	var UserShareContextMenu = React.createClass({
	  displayName: 'UserShareContextMenu',

	  mixins: [createStoreMixin(UserStore), PureRenderMixin],

	  propTypes: {
	    userId: React.PropTypes.number.isRequired,
	    anchorRect: React.PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: UserStore.get(props.userId)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.userId !== this.props.userId) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var items = [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE].map(this.renderMenuItem);

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      items
	    );
	  },

	  renderMenuItem: function renderMenuItem(service) {
	    var user = this.state.user;

	    return React.createElement(ShareUserLink, { key: service,
	      service: service,
	      user: user,
	      context: 'ContextMenu',
	      underline: 'never',
	      propagateClick: true });
	  }
	});

	module.exports = UserShareContextMenu;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesContextMenu = __webpack_require__(80);

	var _moleculesContextMenu2 = _interopRequireDefault(_moleculesContextMenu);

	var _organismsColorPicker = __webpack_require__(207);

	var _organismsColorPicker2 = _interopRequireDefault(_organismsColorPicker);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	var ZineColorPickerContextMenu = _react2['default'].createClass({
	  displayName: 'ZineColorPickerContextMenu',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    anchorRect: _react.PropTypes.object.isRequired,
	    previousColor: _react.PropTypes.string
	  },

	  getInitialState: function getInitialState() {
	    return {
	      didSelect: false
	    };
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _moleculesContextMenu2['default'],
	      { anchorRect: this.props.anchorRect },
	      _react2['default'].createElement(_organismsColorPicker2['default'], { onSelect: this.handleSelect,
	        onChange: this.handleChange,
	        context: 'ContextMenu' })
	    );
	  },

	  handleSelect: function handleSelect(color) {
	    _actionsZineActionCreators2['default'].updateZineDraft('backColor', color);

	    this.setState({
	      didSelect: true
	    });
	  },

	  handleChange: function handleChange(color) {
	    // Avoid accidental changes while context menu is fading away
	    if (this.state.didSelect) {
	      return;
	    }

	    color = color || this.props.previousColor;
	    _actionsZineActionCreators2['default'].updateZineDraft('backColor', color);
	  }
	});

	exports['default'] = ZineColorPickerContextMenu;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ContextMenu = __webpack_require__(80),
	    ZineStore = __webpack_require__(22),
	    SidebarActionCreators = __webpack_require__(29),
	    SidebarTypes = __webpack_require__(39),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58),
	    ZineActionCreators = __webpack_require__(41),
	    createStoreMixin = __webpack_require__(8),
	    Link = __webpack_require__(21),
	    Counter = __webpack_require__(165),
	    AlertActionCreators = __webpack_require__(32),
	    AlertTypes = __webpack_require__(48),
	    PureRenderMixin = __webpack_require__(2);

	var ZineMoreContextMenu = React.createClass({
	  displayName: 'ZineMoreContextMenu',

	  mixins: [createStoreMixin(ZineStore), PureRenderMixin],

	  propTypes: {
	    zineSlug: React.PropTypes.string.isRequired,
	    isMeCurator: React.PropTypes.bool.isRequired,
	    anchorRect: React.PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      zine: ZineStore.get(props.zineSlug)
	    };
	  },

	  render: function render() {
	    var items = this.props.isMeCurator ? this.renderCuratorItems() : this.renderGeneralItems();

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      items
	    );
	  },

	  renderCuratorItems: function renderCuratorItems() {
	    var zine = this.state.zine;

	    return [React.createElement(
	      Link,
	      { propagateClick: true,
	        onClick: this.handlePendingClick,
	        context: 'contextMenu',
	        underline: 'never',
	        bold: true },
	      'Submissions',
	      zine.pendingCount > 0 && React.createElement(Counter, { count: zine.pendingCount })
	    ), React.createElement(ContextMenu.Separator, null), React.createElement(
	      Link,
	      { propagateClick: true,
	        onClick: this.handleInviteClick,
	        context: 'contextMenu',
	        underline: 'never' },
	      'Invite Contributors'
	    ), React.createElement(
	      Link,
	      { propagateClick: true,
	        onClick: this.handleEditClick,
	        context: 'contextMenu',
	        underline: 'never',
	        hideOnTablet: true },
	      'Edit Collection'
	    ), React.createElement(ContextMenu.Separator, { hideOnTablet: true }), React.createElement(
	      Link,
	      { propagateClick: true,
	        onClick: this.handleDeleteClick,
	        context: 'contextMenu',
	        underline: 'never',
	        hideOnTablet: true,
	        color: 'red' },
	      'Delete Collection'
	    )];
	  },

	  renderGeneralItems: function renderGeneralItems() {
	    return [React.createElement(
	      Link,
	      { propagateClick: true,
	        onClick: this.handleUnfollowClick,
	        context: 'contextMenu',
	        underline: 'never' },
	      'Unfollow Collection'
	    )];
	  },

	  handlePendingClick: function handlePendingClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.ZINE_PENDING_STAMPS, {
	      zineSlug: this.props.zineSlug
	    });
	  },

	  handleInviteClick: function handleInviteClick() {
	    ModalActionCreators.showModal(ModalTypes.SEND_INVITE, {
	      zineSlug: this.props.zineSlug
	    });
	  },

	  handleEditClick: function handleEditClick() {
	    ZineActionCreators.createZineDraftFromZine(this.state.zine);
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    AlertActionCreators.showAlert(AlertTypes.DELETE_ZINE, {
	      zineSlug: this.props.zineSlug
	    });
	  },

	  handleUnfollowClick: function handleUnfollowClick() {
	    ZineActionCreators.unfollowZine(this.props.zineSlug);
	  }
	});

	module.exports = ZineMoreContextMenu;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ContextMenu = __webpack_require__(80),
	    ZineStore = __webpack_require__(22),
	    createStoreMixin = __webpack_require__(8),
	    ServiceTypes = __webpack_require__(35),
	    ShareZineLink = __webpack_require__(587),
	    PureRenderMixin = __webpack_require__(2);

	var ZineShareContextMenu = React.createClass({
	  displayName: 'ZineShareContextMenu',

	  mixins: [createStoreMixin(ZineStore), PureRenderMixin],

	  propTypes: {
	    zineSlug: React.PropTypes.string.isRequired,
	    anchorRect: React.PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      zine: ZineStore.get(props.zineSlug)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.zineSlug !== this.props.zineSlug) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var items = [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE].map(this.renderMenuItem);

	    return React.createElement(
	      ContextMenu,
	      { anchorRect: this.props.anchorRect },
	      items
	    );
	  },

	  renderMenuItem: function renderMenuItem(service) {
	    var zine = this.state.zine;

	    return React.createElement(ShareZineLink, { key: service,
	      service: service,
	      zine: zine,
	      context: 'ContextMenu',
	      underline: 'never',
	      propagateClick: true });
	  }
	});

	module.exports = ZineShareContextMenu;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _atomsLinkDescription = __webpack_require__(393);

	var _atomsLinkDescription2 = _interopRequireDefault(_atomsLinkDescription);

	var _moleculesContextMenu = __webpack_require__(80);

	var _moleculesContextMenu2 = _interopRequireDefault(_moleculesContextMenu);

	var _organismsColorPicker = __webpack_require__(207);

	var _organismsColorPicker2 = _interopRequireDefault(_organismsColorPicker);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	var ZineStatusPickerContextMenu = _react2['default'].createClass({
	  displayName: 'ZineStatusPickerContextMenu',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  render: function render() {
	    return _react2['default'].createElement(
	      _moleculesContextMenu2['default'],
	      { anchorRect: this.props.anchorRect },
	      _react2['default'].createElement(
	        _atomsLink2['default'],
	        { context: 'contextMenu',
	          underline: 'never',
	          onClick: this.handlePublicClick,
	          propagateClick: true },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eye',
	          mode: 'stroke',
	          size: 'small',
	          margin: 'right' }),
	        _react2['default'].createElement(
	          'b',
	          null,
	          'Public'
	        ),
	        _react2['default'].createElement(
	          _atomsLinkDescription2['default'],
	          { withMaxWidth: true },
	          'Collection will be public and visible to anyone on your profile page.'
	        )
	      ),
	      _react2['default'].createElement(
	        _atomsLink2['default'],
	        { context: 'contextMenu',
	          underline: 'never',
	          onClick: this.handleUnlistedClick,
	          propagateClick: true },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	          mode: 'fill',
	          size: 'small',
	          margin: 'right' }),
	        _react2['default'].createElement(
	          'b',
	          null,
	          'Secret'
	        ),
	        _react2['default'].createElement(
	          _atomsLinkDescription2['default'],
	          { withMaxWidth: true },
	          'Collection will be visible only to those who have the link. It won’t be listed on your profile page.'
	        )
	      )
	    );
	  },

	  handlePublicClick: function handlePublicClick() {
	    _actionsZineActionCreators2['default'].updateZineDraft('status', _constantsZineStatus2['default'].PUBLIC);
	  },

	  handleUnlistedClick: function handleUnlistedClick() {
	    _actionsZineActionCreators2['default'].updateZineDraft('status', _constantsZineStatus2['default'].UNLISTED);
	  }
	});

	exports['default'] = ZineStatusPickerContextMenu;
	module.exports = exports['default'];

/***/ },
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AlertTypes = __webpack_require__(48);
	var SidebarTypes = __webpack_require__(39);
	var OverlayStore = __webpack_require__(118);
	var createStoreMixin = __webpack_require__(8);
	var PureRenderMixin = __webpack_require__(2);
	var OkayAlert = __webpack_require__(390);
	var ZineLink = __webpack_require__(93);
	var LogOutAlert = __webpack_require__(572);
	var SharePostedStampAlert = __webpack_require__(573);
	var DeleteDraftAlert = __webpack_require__(567);
	var DeleteStampAlert = __webpack_require__(568);
	var DeleteZineAlert = __webpack_require__(569);
	var EditorDeleteSectionAlert = __webpack_require__(570);
	var EditorDisregardChangesAlert = __webpack_require__(571);
	var UserStore = __webpack_require__(5);
	var Link = __webpack_require__(21);
	var SidebarActionCreators = __webpack_require__(29);
	var _require = __webpack_require__(50);

	var transitionTo = _require.transitionTo;
	var makeHref = _require.makeHref;

	var AlertHost = React.createClass({
	  displayName: 'AlertHost',

	  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      alert: OverlayStore.getAlert()
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var prevAlertId = prevState && prevState.alert && prevState.alert.id,
	        alertId = this.state.alert && this.state.alert.id;

	    if (alertId) {
	      return;
	    }

	    switch (prevAlertId) {
	      case AlertTypes.SHARE_POSTED_STAMP:
	        SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMP_TO_ZINES, {
	          stampId: prevState.alert.stampId
	        });
	        break;
	      case AlertTypes.NOT_FOUND:
	        transitionTo('home');
	        break;
	    }
	  },

	  render: function render() {
	    var alert = this.state.alert;
	    if (!alert) {
	      return null;
	    }

	    switch (alert.id) {
	      case AlertTypes.SERVER_ERROR:
	        return React.createElement(OkayAlert, { title: 'Something went wrong',
	          message: React.createElement(
	            'span',
	            null,
	            'Sorry! We are working to resolve this issue.',
	            React.createElement('br', null),
	            'Please, try again later.'
	          ) });
	      case AlertTypes.CONNECTION_ERROR:
	        return React.createElement(OkayAlert, { title: 'Something went wrong',
	          message: 'There seems to be a problem with your Internet connection.' });
	      case AlertTypes.LOGOUT:
	        return React.createElement(LogOutAlert, null);
	      case AlertTypes.NOT_FOUND:
	        return React.createElement(OkayAlert, { title: 'Not Found',
	          message: 'We could not find what you were looking for.',
	          buttonText: 'Go to Home' });
	      case AlertTypes.DELETE_DRAFT:
	        return React.createElement(DeleteDraftAlert, { draftUuid: alert.draftUuid });
	      case AlertTypes.DELETE_STAMP:
	        return React.createElement(DeleteStampAlert, { stampId: alert.stampId });
	      case AlertTypes.DELETE_ZINE:
	        return React.createElement(DeleteZineAlert, { zineSlug: alert.zineSlug });
	      case AlertTypes.SHARE_POSTED_STAMP:
	        return React.createElement(SharePostedStampAlert, { stampId: alert.stampId });
	      case AlertTypes.EDITOR_DESKTOP_ONLY:
	        return React.createElement(OkayAlert, { title: 'Oops',
	          message: 'Please, use laptop or desktop computer to create a stamp.' });
	      case AlertTypes.EDITOR_COVER_TITLE_REQUIRED:
	        return React.createElement(OkayAlert, { title: 'Cover image and title are required' });
	      case AlertTypes.EDITOR_COVER_REQUIRED:
	        return React.createElement(OkayAlert, { title: 'Cover image is required' });
	      case AlertTypes.EDITOR_TITLE_REQUIRED:
	        return React.createElement(OkayAlert, { title: 'Title is required' });
	      case AlertTypes.EDITOR_ADD_MORE_CONTENT:
	        return React.createElement(OkayAlert, { title: 'Add content before posting',
	          message: 'Press “+” button to add more content.' });
	      case AlertTypes.EDITOR_DELETE_SECTION:
	        return React.createElement(EditorDeleteSectionAlert, { sectionId: alert.sectionId });
	      case AlertTypes.EDITOR_DISREGARD_CHANGES:
	        return React.createElement(EditorDisregardChangesAlert, null);
	      case AlertTypes.UPLOAD_USER_IMAGE_ERROR:
	        return React.createElement(OkayAlert, { title: 'Oops!',
	          message: 'Something went wrong uploading your image.' });
	      case AlertTypes.AUDIO_NOT_FOUND:
	        return React.createElement(OkayAlert, { title: 'Audio not found' });
	      case AlertTypes.VIDEO_NOT_FOUND:
	        return React.createElement(OkayAlert, { title: 'Video not found' });
	      case AlertTypes.VIDEO_EMBED_FORBIDDEN:
	        return React.createElement(OkayAlert, { title: 'Can’t embed this video',
	          message: React.createElement(
	            'span',
	            null,
	            'This video cannot be embedded',
	            React.createElement('br', null),
	            'due to its privacy settings.'
	          ) });
	      case AlertTypes.ZINE_ALREADY_EXISTS:
	        return React.createElement(OkayAlert, { title: 'Collection Already Exists',
	          message: React.createElement(
	            'span',
	            null,
	            'Collection called ',
	            React.createElement(ZineLink, { zine: alert.zine, bold: true }),
	            ' already exists.'
	          ) });
	      case AlertTypes.ZINE_TITLE_TOO_SHORT:
	        return React.createElement(OkayAlert, { title: 'Title Too Short',
	          message: 'Title should be eight characters minimum.' });
	      case AlertTypes.ZINE_TITLE_TWO_WORDS:
	        return React.createElement(OkayAlert, { title: 'Title Too Short',
	          message: 'Title should be two words minimum.' });
	      case AlertTypes.ZINE_DESCRIPTION_TOO_SHORT:
	        return React.createElement(OkayAlert, { title: 'Description Too Short',
	          message: 'Description should be 20 characters minimum.' });
	      case AlertTypes.STAMP_SAVE_IMAGE_HELP:
	        var editorLink = UserStore.isAuthenticated() ? React.createElement(
	          Link,
	          { to: 'draftCompose', params: { stampSegment: 'new' } },
	          'Editor'
	        ) : 'Editor';

	        return React.createElement(OkayAlert, { title: 'What’s this?',
	          message: React.createElement(
	            'span',
	            null,
	            'This button lets you collect inspiring images to your ',
	            editorLink,
	            '.',
	            React.createElement('br', null),
	            React.createElement('br', null),
	            'Collected images can then be used to create your own moodboards or illustrate stories.',
	            React.createElement('br', null),
	            React.createElement('br', null),
	            'All images will come with a credit and a link back to the source. This gives their authors additional exposure.'
	          ),
	          buttonText: 'Got it' });
	      case AlertTypes.SHARE_DRAFT:
	        var draftHref = makeHref('draftPreview', { stampSegment: alert.draftUuid });
	        var previewLink = window.location.origin + draftHref;
	        var handleClick = function handleClick(e) {
	          e.target.select();
	        };

	        return React.createElement(OkayAlert, { title: 'Share Draft',
	          message: React.createElement(
	            'span',
	            null,
	            'Share your draft to get feedback:',
	            React.createElement('br', null),
	            React.createElement('br', null),
	            React.createElement('input', { className: 'FormInput', value: previewLink, readOnly: true, onClick: handleClick })
	          ) });
	      default:
	        console.warn('Bad alert type', alert);
	    }
	  }
	});

	module.exports = AlertHost;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactAddons = __webpack_require__(362);

	var _reactAddons2 = _interopRequireDefault(_reactAddons);

	var _underscore = __webpack_require__(4);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _storesOverlayStore = __webpack_require__(118);

	var _storesOverlayStore2 = _interopRequireDefault(_storesOverlayStore);

	var _constantsContextMenuTypes = __webpack_require__(112);

	var _constantsContextMenuTypes2 = _interopRequireDefault(_constantsContextMenuTypes);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _contextMenusUserProfileContextMenu = __webpack_require__(652);

	var _contextMenusUserProfileContextMenu2 = _interopRequireDefault(_contextMenusUserProfileContextMenu);

	var _contextMenusStampShareContextMenu = __webpack_require__(650);

	var _contextMenusStampShareContextMenu2 = _interopRequireDefault(_contextMenusStampShareContextMenu);

	var _contextMenusZineShareContextMenu = __webpack_require__(656);

	var _contextMenusZineShareContextMenu2 = _interopRequireDefault(_contextMenusZineShareContextMenu);

	var _contextMenusUserShareContextMenu = __webpack_require__(653);

	var _contextMenusUserShareContextMenu2 = _interopRequireDefault(_contextMenusUserShareContextMenu);

	var _contextMenusStampMoreContextMenu = __webpack_require__(649);

	var _contextMenusStampMoreContextMenu2 = _interopRequireDefault(_contextMenusStampMoreContextMenu);

	var _contextMenusZineMoreContextMenu = __webpack_require__(655);

	var _contextMenusZineMoreContextMenu2 = _interopRequireDefault(_contextMenusZineMoreContextMenu);

	var _contextMenusCreateStampOrZineContextMenu = __webpack_require__(647);

	var _contextMenusCreateStampOrZineContextMenu2 = _interopRequireDefault(_contextMenusCreateStampOrZineContextMenu);

	var _contextMenusZineColorPickerContextMenu = __webpack_require__(654);

	var _contextMenusZineColorPickerContextMenu2 = _interopRequireDefault(_contextMenusZineColorPickerContextMenu);

	var _contextMenusZineStatusPickerContextMenu = __webpack_require__(657);

	var _contextMenusZineStatusPickerContextMenu2 = _interopRequireDefault(_contextMenusZineStatusPickerContextMenu);

	var _contextMenusEditorMoreContextMenu = __webpack_require__(648);

	var _contextMenusEditorMoreContextMenu2 = _interopRequireDefault(_contextMenusEditorMoreContextMenu);

	var _utilsTimeoutTransitionGroup = __webpack_require__(177);

	var _utilsTimeoutTransitionGroup2 = _interopRequireDefault(_utilsTimeoutTransitionGroup);

	var _contextMenusStampStatusPickerContextMenu = __webpack_require__(651);

	var _contextMenusStampStatusPickerContextMenu2 = _interopRequireDefault(_contextMenusStampStatusPickerContextMenu);

	'use strict';

	var ContextMenuHost = _reactAddons2['default'].createClass({
	  displayName: 'ContextMenuHost',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesOverlayStore2['default']), _mixinsPureRenderMixin2['default']],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      contextMenu: _storesOverlayStore2['default'].getContextMenu()
	    };
	  },

	  childContextTypes: {
	    source: _reactAddons2['default'].PropTypes.oneOf((0, _underscore.values)(_constantsAnalyticsSources2['default']))
	  },

	  getChildContext: function getChildContext() {
	    return {
	      source: this.state.contextMenu && this.state.contextMenu.source
	    };
	  },

	  render: function render() {
	    var menu = this.renderMenu(this.state.contextMenu);

	    return _reactAddons2['default'].createElement(
	      _utilsTimeoutTransitionGroup2['default'],
	      { transitionName: 'ContextMenu',
	        enterTimeout: 200,
	        leaveTimeout: 200 },
	      menu
	    );
	  },

	  renderMenu: function renderMenu(contextMenu) {
	    if (!contextMenu) {
	      return null;
	    }

	    switch (contextMenu.id) {
	      case _constantsContextMenuTypes2['default'].STAMP_SHARE:
	        return _reactAddons2['default'].createElement(_contextMenusStampShareContextMenu2['default'], { key: 'stampShare',
	          stampId: contextMenu.stampId,
	          anchorRect: contextMenu.anchorRect,
	          services: contextMenu.services });

	      case _constantsContextMenuTypes2['default'].ZINE_SHARE:
	        return _reactAddons2['default'].createElement(_contextMenusZineShareContextMenu2['default'], { key: 'zineShare',
	          zineSlug: contextMenu.zineSlug,
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].USER_SHARE:
	        return _reactAddons2['default'].createElement(_contextMenusUserShareContextMenu2['default'], { key: 'userShare',
	          userId: contextMenu.userId,
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].STAMP_MORE:
	        return _reactAddons2['default'].createElement(_contextMenusStampMoreContextMenu2['default'], { key: 'stampMore',
	          stampId: contextMenu.stampId,
	          showEdit: contextMenu.showEdit,
	          shareServices: contextMenu.shareServices,
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].ZINE_MORE:
	        return _reactAddons2['default'].createElement(_contextMenusZineMoreContextMenu2['default'], { key: 'zineMore',
	          zineSlug: contextMenu.zineSlug,
	          isMeCurator: contextMenu.isMeCurator,
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].USER_PROFILE:
	        return _reactAddons2['default'].createElement(_contextMenusUserProfileContextMenu2['default'], { key: 'user',
	          userId: contextMenu.userId,
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].CREATE:
	        return _reactAddons2['default'].createElement(_contextMenusCreateStampOrZineContextMenu2['default'], { key: 'createStampOrZine',
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].ZINE_COLOR_PICKER:
	        return _reactAddons2['default'].createElement(_contextMenusZineColorPickerContextMenu2['default'], { key: 'zineColorPicker',
	          anchorRect: contextMenu.anchorRect,
	          previousColor: contextMenu.previousColor });

	      case _constantsContextMenuTypes2['default'].ZINE_STATUS_PICKER:
	        return _reactAddons2['default'].createElement(_contextMenusZineStatusPickerContextMenu2['default'], { key: 'zineColorPicker',
	          anchorRect: contextMenu.anchorRect });

	      case _constantsContextMenuTypes2['default'].EDITOR_MORE:
	        return _reactAddons2['default'].createElement(_contextMenusEditorMoreContextMenu2['default'], { key: 'editorMore',
	          anchorRect: contextMenu.anchorRect,
	          stampSegment: contextMenu.stampSegment });

	      case _constantsContextMenuTypes2['default'].STAMP_STATUS_PICKER:
	        return _reactAddons2['default'].createElement(_contextMenusStampStatusPickerContextMenu2['default'], { key: 'stampColorPicker',
	          anchorRect: contextMenu.anchorRect });
	    }
	  }
	});

	exports['default'] = ContextMenuHost;
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    LightboxStore = __webpack_require__(147),
	    PageControlsStore = __webpack_require__(774),
	    PageControlsTypes = __webpack_require__(94),
	    createStoreMixin = __webpack_require__(8),
	    PureRenderMixin = __webpack_require__(2),
	    StampPageControls = __webpack_require__(735),
	    StampReviewPageControls = __webpack_require__(736),
	    ZinePageControls = __webpack_require__(739),
	    ZineEditPageControls = __webpack_require__(738),
	    DraftPreviewPageControls = __webpack_require__(733),
	    DraftComposePageControls = __webpack_require__(731),
	    UserPageControls = __webpack_require__(737),
	    ImagePageControls = __webpack_require__(734),
	    DraftFeedbackControls = __webpack_require__(732),
	    TimeoutTransitionGroup = __webpack_require__(177);

	var PageControlsHost = React.createClass({
	  displayName: 'PageControlsHost',

	  mixins: [createStoreMixin(PageControlsStore, LightboxStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      pageControls: PageControlsStore.getPageControls()
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      TimeoutTransitionGroup,
	      { transitionName: 'PageControls',
	        enterTimeout: 300 + 300,
	        leaveTimeout: 300 },
	      this.renderPageControls()
	    );
	  },

	  renderPageControls: function renderPageControls() {
	    var pageControls = this.state.pageControls;

	    if (!pageControls) {
	      return null;
	    }

	    switch (pageControls.id) {
	      case PageControlsTypes.STAMP:
	        return React.createElement(StampPageControls, { key: 'stamp-' + pageControls.stampId,
	          stampId: pageControls.stampId });

	      case PageControlsTypes.STAMP_REVIEW:
	        return React.createElement(StampReviewPageControls, { key: 'stampReview-' + pageControls.stampId,
	          stampId: pageControls.stampId,
	          zineSlug: pageControls.zineSlug });

	      case PageControlsTypes.ZINE:
	        return React.createElement(ZinePageControls, { key: 'zine-' + pageControls.zineSlug,
	          zineSlug: pageControls.zineSlug });

	      case PageControlsTypes.ZINE_EDIT:
	        return React.createElement(ZineEditPageControls, { key: 'zineEdit-' + (pageControls.zineSlug || 'new') });

	      case PageControlsTypes.DRAFT_COMPOSE:
	        return React.createElement(DraftComposePageControls, { key: 'draftCompose',
	          stampSegment: pageControls.stampSegment });

	      case PageControlsTypes.DRAFT_PREVIEW:
	        return React.createElement(DraftPreviewPageControls, { key: 'draftPreview',
	          stampSegment: pageControls.stampSegment });

	      case PageControlsTypes.DRAFT_FEEDBACK:
	        return React.createElement(DraftFeedbackControls, { key: 'draftFeedback',
	          draftUuid: pageControls.draftUuid });

	      case PageControlsTypes.USER:
	        return React.createElement(UserPageControls, { key: 'user-' + pageControls.userId,
	          userId: pageControls.userId });

	      case PageControlsTypes.IMAGE:
	        return React.createElement(ImagePageControls, { key: 'image-' + pageControls.imageUuid,
	          stampId: pageControls.stampId,
	          imageUuid: pageControls.imageUuid,
	          sectionType: pageControls.sectionType });
	    }
	  }
	});

	module.exports = PageControlsHost;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsSidebar = __webpack_require__(724);

	var _organismsSidebar2 = _interopRequireDefault(_organismsSidebar);

	var _storesOverlayStore = __webpack_require__(118);

	var _storesOverlayStore2 = _interopRequireDefault(_storesOverlayStore);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _sidebarPinterestPicker = __webpack_require__(765);

	var _sidebarPinterestPicker2 = _interopRequireDefault(_sidebarPinterestPicker);

	var _sidebarStampOtherZines = __webpack_require__(768);

	var _sidebarStampOtherZines2 = _interopRequireDefault(_sidebarStampOtherZines);

	var _sidebarAddStampToZines = __webpack_require__(758);

	var _sidebarAddStampToZines2 = _interopRequireDefault(_sidebarAddStampToZines);

	var _sidebarAddStampsToZine = __webpack_require__(759);

	var _sidebarAddStampsToZine2 = _interopRequireDefault(_sidebarAddStampsToZine);

	var _sidebarApprovePendingStamp = __webpack_require__(760);

	var _sidebarApprovePendingStamp2 = _interopRequireDefault(_sidebarApprovePendingStamp);

	var _sidebarRejectPendingStamp = __webpack_require__(766);

	var _sidebarRejectPendingStamp2 = _interopRequireDefault(_sidebarRejectPendingStamp);

	var _sidebarZinePendingStamps = __webpack_require__(771);

	var _sidebarZinePendingStamps2 = _interopRequireDefault(_sidebarZinePendingStamps);

	var _sidebarActivities = __webpack_require__(757);

	var _sidebarActivities2 = _interopRequireDefault(_sidebarActivities);

	var _sidebarStampLikes = __webpack_require__(767);

	var _sidebarStampLikes2 = _interopRequireDefault(_sidebarStampLikes);

	var _sidebarUserSubscribers = __webpack_require__(769);

	var _sidebarUserSubscribers2 = _interopRequireDefault(_sidebarUserSubscribers);

	var _sidebarUserSubscriptions = __webpack_require__(770);

	var _sidebarUserSubscriptions2 = _interopRequireDefault(_sidebarUserSubscriptions);

	var _sidebarImageUsedInStamps = __webpack_require__(763);

	var _sidebarImageUsedInStamps2 = _interopRequireDefault(_sidebarImageUsedInStamps);

	var _sidebarDrafts = __webpack_require__(762);

	var _sidebarDrafts2 = _interopRequireDefault(_sidebarDrafts);

	var _sidebarLeaveDraftFeedback = __webpack_require__(764);

	var _sidebarLeaveDraftFeedback2 = _interopRequireDefault(_sidebarLeaveDraftFeedback);

	var _sidebarDraftFeedbacks = __webpack_require__(761);

	var _sidebarDraftFeedbacks2 = _interopRequireDefault(_sidebarDraftFeedbacks);

	'use strict';

	var SidebarHost = _react2['default'].createClass({
	  displayName: 'SidebarHost',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesOverlayStore2['default']), _mixinsPureRenderMixin2['default']],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      sidebar: _storesOverlayStore2['default'].getSidebar()
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (!prevState.sidebar && this.state.sidebar) {
	      this.getDOMNode().scrollTop = 0;
	    }
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _organismsSidebar2['default'],
	      { active: !!this.state.sidebar },
	      this.renderBody(this.state.sidebar)
	    );
	  },

	  renderBody: function renderBody(sidebar) {
	    if (!sidebar) {
	      return null;
	    }

	    switch (sidebar.id) {
	      case _constantsSidebarTypes2['default'].PINTEREST_PICKER:
	        return _react2['default'].createElement(_sidebarPinterestPicker2['default'], { stampId: sidebar.stampId });

	      case _constantsSidebarTypes2['default'].STAMP_OTHER_ZINES:
	        return _react2['default'].createElement(_sidebarStampOtherZines2['default'], { stampId: sidebar.stampId,
	          zineSlugs: sidebar.zineSlugs });

	      case _constantsSidebarTypes2['default'].ADD_STAMP_TO_ZINES:
	        return _react2['default'].createElement(_sidebarAddStampToZines2['default'], { stampId: sidebar.stampId });

	      case _constantsSidebarTypes2['default'].ADD_STAMPS_TO_ZINE:
	        return _react2['default'].createElement(_sidebarAddStampsToZine2['default'], { zineSlug: sidebar.zineSlug });

	      case _constantsSidebarTypes2['default'].ZINE_PENDING_STAMPS:
	        return _react2['default'].createElement(_sidebarZinePendingStamps2['default'], { zineSlug: sidebar.zineSlug });

	      case _constantsSidebarTypes2['default'].APPROVE_PENDING_STAMP:
	        return _react2['default'].createElement(_sidebarApprovePendingStamp2['default'], { stampId: sidebar.stampId,
	          zineSlug: sidebar.zineSlug });

	      case _constantsSidebarTypes2['default'].REJECT_PENDING_STAMP:
	        return _react2['default'].createElement(_sidebarRejectPendingStamp2['default'], { stampId: sidebar.stampId,
	          zineSlug: sidebar.zineSlug });

	      case _constantsSidebarTypes2['default'].ACTIVITIES:
	        return _react2['default'].createElement(_sidebarActivities2['default'], null);

	      case _constantsSidebarTypes2['default'].STAMP_LIKES:
	        return _react2['default'].createElement(_sidebarStampLikes2['default'], { stampId: sidebar.stampId });

	      case _constantsSidebarTypes2['default'].USER_SUBSCRIBERS:
	        return _react2['default'].createElement(_sidebarUserSubscribers2['default'], { userId: sidebar.userId });

	      case _constantsSidebarTypes2['default'].USER_SUBSCRIPTIONS:
	        return _react2['default'].createElement(_sidebarUserSubscriptions2['default'], { userId: sidebar.userId });

	      case _constantsSidebarTypes2['default'].IMAGE_USED_IN_STAMPS:
	        return _react2['default'].createElement(_sidebarImageUsedInStamps2['default'], { imageUuid: sidebar.imageUuid,
	          excludeStampId: sidebar.excludeStampId });

	      case _constantsSidebarTypes2['default'].DRAFTS:
	        return _react2['default'].createElement(_sidebarDrafts2['default'], null);

	      case _constantsSidebarTypes2['default'].LEAVE_DRAFT_FEEDBACK:
	        return _react2['default'].createElement(_sidebarLeaveDraftFeedback2['default'], { draftUuid: sidebar.draftUuid });

	      case _constantsSidebarTypes2['default'].DRAFT_FEEDBACKS:
	        return _react2['default'].createElement(_sidebarDraftFeedbacks2['default'], { draftUuid: sidebar.draftUuid });

	      default:
	        console.warn('Unsupported sidebar', sidebar.id);
	    }
	  }
	});

	exports['default'] = SidebarHost;
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    createStoreMixin = __webpack_require__(8),
	    PlayerStore = __webpack_require__(119),
	    StampStore = __webpack_require__(17),
	    LightboxStore = __webpack_require__(147),
	    PureRenderMixin = __webpack_require__(2),
	    ClassNameMixin = __webpack_require__(3),
	    SoundCloudPlayer = __webpack_require__(588),
	    AudioPlayer = __webpack_require__(579),
	    getStreamUrl = __webpack_require__(796),
	    PlayerActionCreators = __webpack_require__(84),
	    TimeoutTransitionGroup = __webpack_require__(177),
	    DefaultAudioImage = __webpack_require__(144),
	    StickyPlayer = __webpack_require__(726);

	var StickyPlayerHost = React.createClass({
	  displayName: 'StickyPlayerHost',

	  mixins: [createStoreMixin(PlayerStore, StampStore, LightboxStore), PureRenderMixin, ClassNameMixin],

	  getInitialState: function getInitialState() {
	    return {
	      hasErrored: false
	    };
	  },

	  getStateFromStores: function getStateFromStores() {
	    var mediaId = PlayerStore.getStickyMediaId(),
	        sourceStampId = PlayerStore.getSourceStampId(mediaId);

	    return {
	      activeMediaId: mediaId,
	      isPlaying: PlayerStore.isPlaying(mediaId),
	      isPaused: PlayerStore.isPaused(mediaId),
	      activeTrack: PlayerStore.getActiveTrack(mediaId),
	      activeTrackIndex: PlayerStore.getActiveTrackIndex(mediaId),
	      currentTime: PlayerStore.getCurrentTime(mediaId),
	      sourceStamp: sourceStampId ? StampStore.get(sourceStampId) : null,
	      isInLightbox: LightboxStore.isActive(),
	      artwork: PlayerStore.getArtwork(mediaId) || DefaultAudioImage,
	      background: PlayerStore.getBackground(mediaId) || DefaultAudioImage
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.activeTrack !== this.state.activeTrack) {
	      this.setState({
	        hasErrored: false
	      });
	    }
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      null,
	      this.renderPlayer(),
	      React.createElement(
	        TimeoutTransitionGroup,
	        { className: this.getClassName(),
	          transitionName: 'StickyPlayer',
	          enterTimeout: 500 + 500,
	          leaveTimeout: 500 },
	        this.renderStickyPlayer()
	      )
	    );
	  },

	  renderPlayer: function renderPlayer() {
	    var _state = this.state;
	    var hasErrored = _state.hasErrored;
	    var activeTrack = _state.activeTrack;
	    var isPlaying = _state.isPlaying;
	    var activeMediaId = _state.activeMediaId;
	    var activeTrackIndex = _state.activeTrackIndex;
	    var streamUrl = activeTrack && getStreamUrl(activeTrack);
	    var soundCloudUrl = activeTrack && activeTrack.url;
	    var useNativePlayer = !hasErrored && streamUrl;
	    var Player = useNativePlayer ? AudioPlayer : SoundCloudPlayer;
	    var source = useNativePlayer ? streamUrl : soundCloudUrl;

	    if (!activeTrack) {
	      return null;
	    }

	    return React.createElement(Player, { key: 'player-' + activeMediaId + '-' + activeTrackIndex,
	      source: source,
	      isPlaying: isPlaying,
	      currentTime: this.state.currentTime,
	      onTimeUpdate: this.handlePlayerTimeUpdate,
	      onEnd: this.handlePlayerEnd,
	      onError: this.handlePlayerError });
	  },

	  renderStickyPlayer: function renderStickyPlayer() {
	    var _state2 = this.state;
	    var activeTrack = _state2.activeTrack;
	    var isPlaying = _state2.isPlaying;
	    var isPaused = _state2.isPaused;
	    var sourceStamp = _state2.sourceStamp;
	    var isInLightbox = _state2.isInLightbox;
	    var activeMediaId = _state2.activeMediaId;
	    var artwork = _state2.artwork;
	    var background = _state2.background;

	    if (!activeTrack || isInLightbox) {
	      return null;
	    }

	    return React.createElement(StickyPlayer, { key: 'StickyPlayer-' + activeMediaId,
	      uuid: activeMediaId,
	      track: activeTrack,
	      artwork: artwork,
	      colors: background.colors,
	      sourceStamp: sourceStamp,
	      currentTime: this.state.currentTime,
	      isPlaying: isPlaying,
	      isPaused: isPaused,
	      onPlay: this.handlePlayPauseClick,
	      onPause: this.handlePlayPauseClick,
	      onBackward: this.handlePreviousClick,
	      onForward: this.handleNextClick });
	  },

	  handlePlayerTimeUpdate: function handlePlayerTimeUpdate(time) {
	    var activeMediaId = this.state.activeMediaId;

	    PlayerActionCreators.setCurrentTime(activeMediaId, time.currentTime);
	  },

	  handlePlayerError: function handlePlayerError() {
	    this.setState({
	      hasErrored: true
	    });
	  },

	  handlePlayPauseClick: function handlePlayPauseClick() {
	    var _state3 = this.state;
	    var activeMediaId = _state3.activeMediaId;
	    var isPlaying = _state3.isPlaying;

	    if (isPlaying) {
	      PlayerActionCreators.pause(activeMediaId);
	    } else {
	      PlayerActionCreators.play(activeMediaId);
	    }
	  },

	  handlePreviousClick: function handlePreviousClick() {
	    var activeMediaId = this.state.activeMediaId;

	    PlayerActionCreators.playPrevious(activeMediaId);
	  },

	  handleNextClick: function handleNextClick() {
	    var activeMediaId = this.state.activeMediaId;

	    PlayerActionCreators.playNext(activeMediaId);
	  },

	  handlePlayerEnd: function handlePlayerEnd() {
	    var activeMediaId = this.state.activeMediaId;

	    PlayerActionCreators.playNext(activeMediaId);
	  }
	});

	module.exports = StickyPlayerHost;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _router = __webpack_require__(50);

	var _router2 = _interopRequireDefault(_router);

	var _animationFrame = __webpack_require__(547);

	var _animationFrame2 = _interopRequireDefault(_animationFrame);

	var _utilsAnalytics = __webpack_require__(52);

	var _utilsAnalytics2 = _interopRequireDefault(_utilsAnalytics);

	var _constantsAnalyticsEvents = __webpack_require__(55);

	var _constantsAnalyticsEvents2 = _interopRequireDefault(_constantsAnalyticsEvents);

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _utilsRAFBatchingStrategy = __webpack_require__(786);

	var _utilsRAFBatchingStrategy2 = _interopRequireDefault(_utilsRAFBatchingStrategy);

	var _reactLibReactUpdates = __webpack_require__(63);

	var _reactLibReactUpdates2 = _interopRequireDefault(_reactLibReactUpdates);

	var _reactTapEventPlugin = __webpack_require__(1096);

	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

	var _config = __webpack_require__(66);

	var _config2 = _interopRequireDefault(_config);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _CrashReporter = __webpack_require__(294);

	var _CrashReporter2 = _interopRequireDefault(_CrashReporter);

	var _constantsNotificationMessages = __webpack_require__(78);

	var _constantsNotificationMessages2 = _interopRequireDefault(_constantsNotificationMessages);

	var _actionsRouterActionCreators = __webpack_require__(561);

	var _actionsRouterActionCreators2 = _interopRequireDefault(_actionsRouterActionCreators);

	var _actionsNotificationActionCreators = __webpack_require__(90);

	var _actionsNotificationActionCreators2 = _interopRequireDefault(_actionsNotificationActionCreators);

	var _utilsBrowser = __webpack_require__(36);

	var _AuthPopup = __webpack_require__(551);

	var _AuthPopup2 = _interopRequireDefault(_AuthPopup);

	'use strict';

	__webpack_require__(549);
	__webpack_require__(806);
	__webpack_require__(1051);
	__webpack_require__(799);
	__webpack_require__(801);
	__webpack_require__(800);

	// looks weird, I know. core-js Promise is not always the same as window.Promise,
	// which is polyfilled with `promise.prototype.finally`

	_Promise.prototype['finally'] = window.Promise.prototype['finally'];

	__webpack_require__(976);

	window.addEventListener('DOMContentLoaded', function () {
	  // It is essential to render to a div we control,
	  // because Google Font Loader will put junk in <body>
	  var rootEl = document.getElementById('root');

	  if (_config2['default'].isAuthPopup) {
	    _react2['default'].render(_react2['default'].createElement(_AuthPopup2['default'], { authType: _config2['default'].authType }), rootEl);
	  } else {
	    _router2['default'].run(function (Handler, state) {
	      _actionsRouterActionCreators2['default'].changeRoute(state);
	      _react2['default'].render(_react2['default'].createElement(Handler, state), rootEl);
	    });
	  }
	});

	_CrashReporter2['default'].setup();
	_animationFrame2['default'].shim();
	_reactLibReactUpdates2['default'].injection.injectBatchingStrategy(_utilsRAFBatchingStrategy2['default']);
	(0, _reactTapEventPlugin2['default'])();

	_config2['default'].actions.forEach(function (action) {
	  _AppDispatcher2['default'].handlePreloadedAction(action);
	});

	if (_storesUserStore2['default'].isAuthenticated()) {
	  _CrashReporter2['default'].associateWithUser(_storesUserStore2['default'].getMe());
	}

	_utilsAnalytics2['default'].start();

	if (_config2['default'].trackSignUp) {
	  _utilsAnalytics2['default'].trackGAEvent(_constantsAnalyticsEvents2['default'].STAMPSY_SIGNUP);
	  _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].STAMPSY_SIGNUP);
	}

	if ((0, _utilsBrowser.isIE10)()) {
	  _actionsNotificationActionCreators2['default'].showNotification(_constantsNotificationMessages2['default'].UNSUPPORTED_BROWSER);
	}

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    DelayActionMixin = __webpack_require__(256);

	var DELAY_AFTER_RESIZE_EVENT = 1000,
	    MEDIA_QUERIES;

	// See atoms/media_queries.less

	MEDIA_QUERIES = [{
	  'key': 'default',
	  'query': 'only screen'
	}, {
	  'key': 'xs',
	  'query': 'only screen and (min-width: 30em)'
	}, {
	  'key': 'sm',
	  'query': 'only screen and (min-width: 40em)'
	}, {
	  'key': 'md',
	  'query': 'only screen and (min-width: 62em)'
	}, {
	  'key': 'lg',
	  'query': 'only screen and (min-width: 75em)' }, {
	  'key': 'xl',
	  'query': 'only screen and (min-width: 100em)'
	}].reverse();

	function validateImageSizes(imageSizes) {
	  if (!imageSizes) {
	    throw new Error('You need to define imageSizes to use ResponsiveImageMixin');
	  }

	  var allKeys = _.pluck(MEDIA_QUERIES, 'key'),
	      definedKeys = _.keys(imageSizes);

	  if (_.difference(allKeys, definedKeys).length) {
	    throw new Error('Not all media keys are defined');
	  }
	}

	/**
	 * Provides an image size that matches current window size.
	 *
	 * The sizes for different width breakpoints can be defined
	 * by providing `getImageSizes` method.
	 */
	var ResponsiveImageMixin = {
	  mixins: [DelayActionMixin],

	  getInitialState: function getInitialState() {
	    return {
	      imageSize: this._findMatchingSize()
	    };
	  },

	  getImageSize: function getImageSize() {
	    return this.state.imageSize;
	  },

	  componentWillMount: function componentWillMount() {
	    window.addEventListener('resize', this._handleWindowResize);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this._handleWindowResize);
	  },

	  _handleWindowResize: function _handleWindowResize() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.scheduleAction(this._updateImageSize, DELAY_AFTER_RESIZE_EVENT);
	  },

	  _updateImageSize: function _updateImageSize() {
	    var imageSize = Math.max(this.state.imageSize, this._findMatchingSize());

	    this.setState({
	      imageSize: imageSize
	    });
	  },

	  _findMatchingSize: function _findMatchingSize() {
	    var imageSizes = this.getImageSizes(),
	        mediaQuery;

	    if (false) {
	      validateImageSizes(imageSizes);
	    }

	    mediaQuery = _.find(MEDIA_QUERIES, function (mediaQuery) {
	      return window.matchMedia(mediaQuery.query).matches;
	    });

	    return imageSizes[mediaQuery.key];
	  }
	};

	module.exports = ResponsiveImageMixin;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var DelayActionMixin = __webpack_require__(256);

	var DELAY_AFTER_RESIZE_EVENT = 1000;

	/**
	 * Maintains `offsetWidth` and `offsetHeight` in state.
	 * When the window is resized, updates it after a short interval.
	 */
	var SizeMonitorMixin = {
	  mixins: [DelayActionMixin],

	  getInitialState: function getInitialState() {
	    return {
	      offsetWidth: undefined,
	      offsetHeight: undefined
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this._updateDimensions();
	    window.addEventListener('resize', this._handleWindowResize);
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    if (!this.state.offsetWidth || !this.state.offsetHeight) {
	      this._updateDimensions();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this._handleWindowResize);
	  },

	  _handleWindowResize: function _handleWindowResize() {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.scheduleAction(this._updateDimensions, DELAY_AFTER_RESIZE_EVENT);
	  },

	  _updateDimensions: function _updateDimensions() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var node = this.getDOMNode();
	    if (!node) {
	      return;
	    }

	    this.setState({
	      offsetWidth: node.offsetWidth,
	      offsetHeight: node.offsetHeight
	    });
	  }
	};

	module.exports = SizeMonitorMixin;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    config = __webpack_require__(66),
	    AnalyticsSources = __webpack_require__(34),
	    ClassNameMixin = __webpack_require__(3),
	    AboutCoverSection = __webpack_require__(414),
	    ShortSignUp = __webpack_require__(268),
	    ShortLogin = __webpack_require__(267),
	    Link = __webpack_require__(21),
	    Icon = __webpack_require__(10),
	    PureRenderMixin = __webpack_require__(2);

	var AboutForm = React.createClass({
	  displayName: 'AboutForm',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    onLoginClick: React.PropTypes.func.isRequired,
	    hideAboutLink: React.PropTypes.bool
	  },

	  className: 'Modal-body',

	  getCSSModifiers: function getCSSModifiers() {
	    return ['about'];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { onTouchTap: this.props.onCloseClick,
	          className: 'Modal-close' },
	        React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	      ),
	      React.createElement(
	        'div',
	        null,
	        React.createElement(
	          AboutCoverSection,
	          { layout: 'banner' },
	          this.renderAboutFooter()
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content Modal-content--stickToBottom' },
	        config.signUpEnabled ? React.createElement(ShortSignUp, { source: AnalyticsSources.ABOUT_FORM }) : React.createElement(ShortLogin, { source: AnalyticsSources.ABOUT_FORM })
	      ),
	      this.renderFooter()
	    );
	  },

	  renderAboutFooter: function renderAboutFooter() {
	    if (this.props.hideAboutLink) {
	      return;
	    }

	    return React.createElement(
	      Link,
	      { color: 'light',
	        to: 'about',
	        underline: 'never',
	        opaque: true,
	        bold: true },
	      'Learn More'
	    );
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer Modal-center' },
	      config.signUpEnabled && React.createElement(
	        'span',
	        { className: 'Modal-footerText' },
	        React.createElement(
	          'small',
	          null,
	          'We value your privacy and won’t post anything on your behalf without your permission.'
	        ),
	        React.createElement('br', null),
	        React.createElement('br', null),
	        'Already have an account?',
	        ' ',
	        React.createElement(
	          Link,
	          { onClick: this.props.onLoginClick,
	            color: 'green',
	            bold: true },
	          'Log In'
	        ),
	        '.'
	      )
	    );
	  }
	});

	module.exports = AboutForm;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Icon = __webpack_require__(10),
	    Link = __webpack_require__(21),
	    PureRenderMixin = __webpack_require__(2);

	var ContactUs = React.createClass({
	  displayName: 'ContactUs',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body Modal-body--wide' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Contact Us'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'If you find an issue or have a suggestion for how we can make Stampsy better, let us know! You can either email us at ',
	          React.createElement(
	            Link,
	            { bold: true, href: 'mailto:hello@stampsy.com', target: '_blank' },
	            'hello@stampsy.com'
	          ),
	          ', or click ',
	          React.createElement(
	            'b',
	            null,
	            '“Send Feedback”'
	          ),
	          ' in the profile menu in the upper right corner when you’re logged in.'
	        ),
	        React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'For press requests, additional information and high resolution imagery, contact Serious Business: ',
	          React.createElement(
	            Link,
	            { bold: true, href: 'mailto:info@seriousbusinesspr.com', target: '_blank' },
	            'info@seriousbusinesspr.com'
	          ),
	          ', +1.646-559-2248.'
	        )
	      )
	    );
	  }
	});

	module.exports = ContactUs;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Icon = __webpack_require__(10),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(475);

	var HelpSection = React.createClass({
	  displayName: 'HelpSection',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    title: React.PropTypes.string.isRequired,
	    image: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'EditorHelp-section' },
	      React.createElement(
	        'h2',
	        { className: 'EditorHelp-subtitle' },
	        this.props.title
	      ),
	      React.createElement(
	        'p',
	        { className: 'EditorHelp-paragraph' },
	        this.props.children
	      ),
	      React.createElement('img', { className: 'EditorHelp-image',
	        src: this.props.image, alt: this.props.title })
	    );
	  }
	});

	var EditorHelp = React.createClass({
	  displayName: 'EditorHelp',

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body Modal-body--wide EditorHelp' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'How to Create a Stamp?'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Modal-message' },
	          React.createElement(
	            HelpSection,
	            { image: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/f8d790a9-804a-4045-8cee-2f225eae30fd.jpg',
	              title: '1. Add Content' },
	            'Drag and drop images from the left sidebar and place them within content blocks. Add text and audio/video by pressing “+” button and choosing a relevant block.'
	          ),
	          React.createElement(
	            HelpSection,
	            { image: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/74cb29c2-a85f-4c1b-bb0a-29b2cbbb1232.jpg',
	              title: '2. Provide Structure' },
	            'Combine content blocks together and provide structure for your stamp. Create any format you need by changing block combination and order.'
	          ),
	          React.createElement(
	            HelpSection,
	            { image: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/4cfcefba-0df7-4280-af03-be401ea7febb.jpg',
	              title: '3. Post and Submit to Collections' },
	            'After you have created and previewed your stamp, submit to a relevant collection to gain instant exposure or or create a collection of your own.'
	          )
	        )
	      )
	    );
	  } });

	module.exports = EditorHelp;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55),
	    FormMixin = __webpack_require__(79),
	    FormInputRow = __webpack_require__(131),
	    Textarea = __webpack_require__(142),
	    Icon = __webpack_require__(10),
	    Button = __webpack_require__(13),
	    validateRequiredString = __webpack_require__(454),
	    UserActionCreators = __webpack_require__(47),
	    SafeLocalStorage = __webpack_require__(134),
	    PureRenderMixin = __webpack_require__(2);

	var UNSENT_FEEDBACK_KEY = 'components.pages.Feedback.unsentFeedback';

	var Feedback = React.createClass({
	  displayName: 'Feedback',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      text: this.getFeedbackFromLocalStorage() || ''
	    };
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    if (this.isFormSubmitted()) {
	      this.clearFeedbackInLocalStorage();
	    } else if (this.isFormEditable()) {
	      this.saveFeedbackToLocalStorage();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (this.isFormSubmitted()) {
	      this.clearFeedbackInLocalStorage();
	    }
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body Feedback' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Send Feedback'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'Tell us about your idea, question or problem.'
	        ),
	        React.createElement(
	          'div',
	          { className: 'Form' },
	          React.createElement(FormInputRow, { component: Textarea,
	            label: 'Type your message',
	            formLink: this.linkValidatedState('text', validateRequiredString),
	            readOnly: !this.isFormEditable() })
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer' },
	      React.createElement(
	        Button,
	        { color: 'green',
	          onClick: this.submitForm.bind(this, this.sendRequest),
	          disabled: !this.isFormEditable(),
	          size: 'large' },
	        'Send'
	      )
	    );
	  },

	  sendRequest: function sendRequest() {
	    var data = {
	      'feedback': this.state.text,
	      'current_url': window.location.href
	    };

	    UserActionCreators.sendFeedback(data);
	    Analytics.trackEvent(AnalyticsEvents.FORMS_FEEDBACK_SEND);
	  },

	  getFeedbackFromLocalStorage: function getFeedbackFromLocalStorage() {
	    return SafeLocalStorage.getItem(UNSENT_FEEDBACK_KEY);
	  },

	  saveFeedbackToLocalStorage: function saveFeedbackToLocalStorage() {
	    SafeLocalStorage.setItem(UNSENT_FEEDBACK_KEY, this.state.text);
	  },

	  clearFeedbackInLocalStorage: function clearFeedbackInLocalStorage() {
	    SafeLocalStorage.removeItem(UNSENT_FEEDBACK_KEY);
	  }
	});

	module.exports = Feedback;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var IframeForm = __webpack_require__(410);
	var FormMixin = __webpack_require__(79);
	var FormInputRow = __webpack_require__(131);
	var RecaptchaFormRow = __webpack_require__(721);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var Link = __webpack_require__(21);
	var validateEmail = __webpack_require__(221);
	var validateRequiredString = __webpack_require__(454);
	var FormStore = __webpack_require__(208);
	var ServiceTypes = __webpack_require__(35);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var FinishSignup = React.createClass({
	  displayName: 'FinishSignup',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    onCloseClick: PropTypes.func.isRequired,
	    onLoginClick: PropTypes.func.isRequired,
	    onTermsClick: PropTypes.func.isRequired,
	    allowClose: PropTypes.bool.isRequired,
	    service: PropTypes.oneOf([ServiceTypes.EMAIL, ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE]).isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      name: FormStore.getDefaultValue('name') || '',
	      email: FormStore.getDefaultValue('email') || '',
	      password: FormStore.getDefaultValue('password') || '',
	      recaptcha: FormStore.getDefaultValue('recaptcha') || ''
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Almost There'
	        ),
	        this.props.allowClose && React.createElement(
	          'div',
	          { onTouchTap: _.partial(this.props.onCloseClick, undefined), className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'Finish creating your Stampsy account.'
	        ),
	        React.createElement(
	          IframeForm,
	          { ref: 'signupForm', name: 'signup', action: '/signup' },
	          React.createElement(FormInputRow, { ref: 'name',
	            name: 'name',
	            formLink: this.linkValidatedState('name', validateRequiredString),
	            label: 'Full Name',
	            onKeyUp: this.handleKeyUp,
	            readOnly: !this.isFormEditable(),
	            autofill: true }),
	          React.createElement(FormInputRow, { type: 'email',
	            ref: 'email',
	            name: 'email',
	            formLink: this.linkValidatedState('email', validateEmail),
	            label: 'Email',
	            onKeyUp: this.handleKeyUp,
	            readOnly: !this.isFormEditable(),
	            autofill: true }),
	          this.props.service === ServiceTypes.EMAIL && [React.createElement(FormInputRow, { type: 'password',
	            ref: 'password',
	            name: 'password',
	            formLink: this.linkValidatedState('password', this.validatePassword),
	            label: 'Password',
	            onKeyUp: this.handleKeyUp,
	            readOnly: !this.isFormEditable(),
	            autofill: true }), React.createElement(RecaptchaFormRow, { formLink: this.linkValidatedState('recaptcha', validateRequiredString) })]
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer' },
	      React.createElement(
	        Button,
	        { color: 'green',
	          size: 'large',
	          context: 'Modal',
	          fill: true,
	          onClick: this.submitForm.bind(this, this.sendRequest),
	          disabled: !this.isFormEditable() },
	        'Sign Up'
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-footerText' },
	        React.createElement(
	          'span',
	          null,
	          'By signing up you accept Stampsy’s',
	          ' ',
	          React.createElement(
	            Link,
	            { onClick: this.props.onTermsClick },
	            'Terms of Service'
	          ),
	          '.'
	        ),
	        React.createElement('br', null),
	        React.createElement('br', null),
	        this.props.service === ServiceTypes.EMAIL && React.createElement(
	          'span',
	          null,
	          'Already have an account?',
	          ' ',
	          React.createElement(
	            Link,
	            { onClick: this.props.onLoginClick,
	              color: 'green',
	              bold: true },
	            'Log In'
	          ),
	          '.'
	        )
	      )
	    );
	  },

	  handleKeyUp: function handleKeyUp(e) {
	    if (!this.isEnterKey(e)) {
	      return;
	    }

	    if (!this.state.name) {
	      this.refs.name.focus();
	    } else if (!this.state.email) {
	      this.refs.email.focus();
	    } else if (this.refs.password && !this.state.password) {
	      this.refs.password.focus();
	    }

	    this.submitForm(this.sendRequest);
	  },

	  validatePassword: function validatePassword(password) {
	    password = (password || '').trim();

	    if (!password) {
	      return {
	        error: 'Required'
	      };
	    }

	    if (password.length < 8) {
	      return {
	        error: 'Minimum 8 characters'
	      };
	    }
	  },

	  sendRequest: function sendRequest() {
	    return this.refs.signupForm.submit();
	  }
	});

	module.exports = FinishSignup;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var FormMixin = __webpack_require__(79);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var Icon = __webpack_require__(10);
	var Link = __webpack_require__(21);
	var FormInputRow = __webpack_require__(131);
	var Analytics = __webpack_require__(52);
	var IframeForm = __webpack_require__(410);
	var validateEmail = __webpack_require__(221);
	var UserActionCreators = __webpack_require__(47);
	var FormMessage = __webpack_require__(408);
	var FormStore = __webpack_require__(208);
	var PureRenderMixin = __webpack_require__(2);
	var config = __webpack_require__(66);var PropTypes = React.PropTypes;

	__webpack_require__(925);

	var Login = React.createClass({
	  displayName: 'Login',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    allowClose: PropTypes.bool.isRequired,
	    onCloseClick: PropTypes.func.isRequired,
	    onSignupClick: PropTypes.func.isRequired,
	    onResetPasswordClick: PropTypes.func.isRequired,
	    endpoints: PropTypes.array.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      email: FormStore.getDefaultValue('email') || '',
	      password: FormStore.getDefaultValue('password') || ''
	    };
	  },

	  render: function render() {
	    var emailCredentials = React.createElement(
	      IframeForm,
	      { ref: 'loginForm', name: 'login', action: '/login' },
	      React.createElement(FormInputRow, { type: 'email',
	        name: 'email',
	        ref: 'email',
	        formLink: this.linkValidatedState('email', validateEmail),
	        label: 'Email',
	        onKeyUp: this.handleKeyUp,
	        autofill: true }),
	      React.createElement(FormInputRow, { type: 'password',
	        name: 'password',
	        ref: 'password',
	        formLink: this.linkValidatedState('password', this.validatePassword),
	        label: 'Password',
	        onKeyUp: this.handleKeyUp,
	        autofill: true })
	    );

	    return React.createElement(
	      'div',
	      { className: 'Modal-body' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Log In'
	        ),
	        this.props.allowClose && React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Modal-error' },
	          this.renderErrors()
	        ),
	        React.createElement(
	          'div',
	          { className: 'Login-services' },
	          React.createElement(
	            BtnGroup,
	            { vertical: true },
	            this.renderButtons()
	          ),
	          React.createElement(
	            'div',
	            { className: 'Login-or utils--smallCaps' },
	            'or'
	          )
	        ),
	        emailCredentials
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-footer' },
	        React.createElement(
	          Button,
	          { size: 'large',
	            color: 'green',
	            onClick: this.submitForm.bind(this, this.sendRequest),
	            disabled: !this.isFormEditable() },
	          'Log In'
	        ),
	        React.createElement(
	          'div',
	          { className: 'Modal-footerText' },
	          config.signUpEnabled && React.createElement(
	            'span',
	            null,
	            'Don’t have an account?',
	            ' ',
	            React.createElement(
	              Link,
	              { onClick: this.props.onSignupClick,
	                color: 'green',
	                bold: true },
	              'Sign Up'
	            ),
	            '.'
	          )
	        )
	      )
	    );
	  },

	  handleKeyUp: function handleKeyUp(e) {
	    if (!this.isEnterKey(e)) {
	      return;
	    }

	    if (!this.state.email) {
	      this.refs.email.focus();
	    } else if (!this.state.password) {
	      this.refs.password.focus();
	    }

	    this.submitForm(this.sendRequest);
	  },

	  renderButtons: function renderButtons() {
	    return _.map(this.props.endpoints, (function (endpoint) {
	      return React.createElement(
	        Button,
	        { key: endpoint.id,
	          href: endpoint.url,
	          color: endpoint.id.toLowerCase(),
	          onClick: this.handleLoginClick.bind(this, endpoint.id),
	          size: 'large',
	          fullWidth: true },
	        React.createElement(Icon, { name: endpoint.id.toLowerCase(), size: 'small' }),
	        'Log In with ' + endpoint.title
	      );
	    }).bind(this));
	  },

	  renderErrors: function renderErrors() {
	    return _.map(this.props.endpoints, (function (endpoint) {
	      return React.createElement(FormMessage, { key: endpoint.id,
	        formLink: this.linkState(endpoint.id.toLowerCase()) });
	    }).bind(this));
	  },

	  handleLoginClick: function handleLoginClick(serviceType) {
	    UserActionCreators.loginWithServiceAccount(serviceType);
	  },

	  validatePassword: function validatePassword(password) {
	    var permanentHelp = React.createElement(
	      Link,
	      { color: 'gray', onClick: this.props.onResetPasswordClick },
	      'Forgot your password?'
	    );
	    password = (password || '').trim();

	    if (!password) {
	      return {
	        permanentHelp: permanentHelp,
	        error: 'Required'
	      };
	    }

	    return {
	      permanentHelp: permanentHelp
	    };
	  },

	  sendRequest: function sendRequest() {
	    Analytics.trackEvent('forms.login.send', _.pick(this.state, 'email'));
	    this.refs.loginForm.submit();
	  }
	});

	module.exports = Login;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    FormMixin = __webpack_require__(79),
	    FormInputRow = __webpack_require__(131),
	    Icon = __webpack_require__(10),
	    Button = __webpack_require__(13),
	    BtnGroup = __webpack_require__(44),
	    validateEmail = __webpack_require__(221),
	    FormStore = __webpack_require__(208),
	    UserActionCreators = __webpack_require__(47),
	    PureRenderMixin = __webpack_require__(2);

	var RequestResetPassword = React.createClass({
	  displayName: 'RequestResetPassword',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired,
	    onCancelClick: React.PropTypes.func.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      email: FormStore.getDefaultValue('email') };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Reset Password'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: _.partial(this.props.onCloseClick, undefined), className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Form' },
	          React.createElement(FormInputRow, { label: 'Email Address',
	            type: 'email',
	            formLink: this.linkValidatedState('email', validateEmail) })
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer' },
	      React.createElement(
	        BtnGroup,
	        null,
	        React.createElement(
	          Button,
	          { color: 'green',
	            size: 'large',
	            onClick: this.submitForm.bind(this, this.sendRequest),
	            disabled: !this.isFormEditable() },
	          'Reset'
	        ),
	        React.createElement(
	          Button,
	          { color: 'gray',
	            size: 'large',
	            onClick: this.handleCancelClick,
	            disabled: !this.isFormEditable() },
	          'Cancel'
	        )
	      )
	    );
	  },

	  handleCancelClick: function handleCancelClick() {
	    this.props.onCancelClick({
	      email: this.state.email
	    });
	  },

	  sendRequest: function sendRequest() {
	    UserActionCreators.requestResetPassword({
	      email: this.state.email
	    });
	  }
	});

	module.exports = RequestResetPassword;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    FormMixin = __webpack_require__(79),
	    FormInputRow = __webpack_require__(131),
	    Button = __webpack_require__(13),
	    UserActionCreators = __webpack_require__(47),
	    PureRenderMixin = __webpack_require__(2);

	var ResetPassword = React.createClass({
	  displayName: 'ResetPassword',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired,
	    userId: React.PropTypes.string
	  },

	  getInitialState: function getInitialState() {
	    return {
	      password: '',
	      confirmPassword: ''
	    };
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    if (this.isFormSubmitted()) {
	      this.props.onCloseClick(true);
	    }
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Reset Password'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Form' },
	          React.createElement(FormInputRow, { label: 'New Password',
	            type: 'password',
	            formLink: this.linkValidatedState('password', this.validatePassword) }),
	          React.createElement(FormInputRow, { label: 'New Password, Again',
	            type: 'password',
	            formLink: this.linkValidatedState('confirmPassword', this.validateConfirmPassword) })
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer' },
	      React.createElement(
	        Button,
	        { color: 'green',
	          onClick: this.submitForm.bind(this, this.sendRequest),
	          disabled: !this.isFormEditable(),
	          size: 'large' },
	        'Save'
	      )
	    );
	  },

	  validatePassword: function validatePassword(password) {
	    password = (password || '').trim();

	    if (!password) {
	      return {
	        error: 'Required'
	      };
	    } else if (password.length < 8) {
	      return {
	        error: 'Minimum 8 characters'
	      };
	    }
	  },

	  validateConfirmPassword: function validateConfirmPassword(confirmPassword) {
	    confirmPassword = (confirmPassword || '').trim();

	    if (!confirmPassword && !this.state.password) {
	      return;
	    }

	    if (confirmPassword !== this.state.password) {
	      return {
	        error: 'Password doesn’t match'
	      };
	    }
	  },

	  sendRequest: function sendRequest() {
	    var data = {
	      password: this.state.password,
	      userId: this.props.userId
	    };

	    UserActionCreators.resetPassword(data);
	  }
	});

	module.exports = ResetPassword;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    classSet = __webpack_require__(163),
	    PopupManager = __webpack_require__(217),
	    FormMixin = __webpack_require__(79),
	    Icon = __webpack_require__(10),
	    Button = __webpack_require__(13),
	    Textarea = __webpack_require__(142),
	    FormInputRow = __webpack_require__(131),
	    TagInput = __webpack_require__(708),
	    ContactImporter = __webpack_require__(694),
	    ContactList = __webpack_require__(716),
	    InviteList = __webpack_require__(718),
	    PureRenderMixin = __webpack_require__(2),
	    isValidEmail = __webpack_require__(447),
	    ServiceTypes = __webpack_require__(35),
	    createStoreMixin = __webpack_require__(8),
	    InvitationStore = __webpack_require__(289),
	    InvitationActionCreators = __webpack_require__(195),
	    FacebookManager = __webpack_require__(435),
	    FacebookActionCreators = __webpack_require__(387),
	    SendInvitationFormStore = __webpack_require__(776),
	    SocialFriendListStore = __webpack_require__(290),
	    SentInvitationStore = __webpack_require__(425),
	    UserStore = __webpack_require__(5),
	    SendInvitationFormActionCreators = __webpack_require__(563);

	__webpack_require__(926);

	var SendInvite = React.createClass({
	  displayName: 'SendInvite',

	  mixins: [FormMixin, PureRenderMixin, createStoreMixin(InvitationStore, SendInvitationFormStore, SocialFriendListStore, UserStore)],

	  propTypes: {
	    title: React.PropTypes.string.isRequired,
	    zineSlug: React.PropTypes.string,
	    onCloseClick: React.PropTypes.func.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return _.extend(SendInvitationFormStore.getFormState(), {
	      invited: SentInvitationStore.getInvitations(),
	      isFacebookConnected: !!SocialFriendListStore.getFriends(ServiceTypes.FACEBOOK),
	      isGoogleConnected: !!SocialFriendListStore.getFriends(ServiceTypes.GOOGLE) });
	  },

	  componentDidMount: function componentDidMount() {
	    FacebookManager.init();

	    InvitationActionCreators.requestInvitationsPage(true);
	    InvitationActionCreators.requestSocialFriendsPage(ServiceTypes.FACEBOOK);
	    InvitationActionCreators.requestSocialFriendsPage(ServiceTypes.GOOGLE);
	  },

	  render: function render() {
	    var forZine = !!this.props.zineSlug,
	        invited = this.state.invited,
	        classes;

	    classes = classSet({
	      'Modal-body': true,
	      'Modal-body--wide': true,
	      'Modal-body--hidden': this.state.isFormHidden
	    });

	    return React.createElement(
	      'div',
	      { className: classes },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          this.props.title
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'To invite a ',
	          forZine ? 'contributor to your Collection' : 'friend',
	          ', enter their email address below or connect ',
	          React.createElement(
	            'b',
	            null,
	            'Facebook'
	          ),
	          ' and ',
	          React.createElement(
	            'b',
	            null,
	            'Gmail'
	          ),
	          ' to import your contacts.'
	        ),
	        forZine && React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          'Your Collection will appear in the ',
	          React.createElement(
	            'b',
	            null,
	            'Suggested Collections'
	          ),
	          ' list of the users you have invited. They will be able to add stamps to your Collection after your approval.'
	        ),
	        this.renderContactImporter(),
	        this.renderForm(),
	        invited.length > 0 && React.createElement(
	          'h4',
	          { className: 'Modal-subtitle utils--smallCaps' },
	          'Invited'
	        ),
	        invited.length > 0 && React.createElement(InviteList, { invites: invited,
	          reInvited: this.state.resentInvites,
	          onResendClick: this.handleResendClick })
	      )
	    );
	  },

	  renderContactImporter: function renderContactImporter() {
	    var state = this.state,
	        connectedServices = [];

	    if (state.isFacebookConnected) {
	      connectedServices.push(ServiceTypes.FACEBOOK);
	    }

	    if (state.isGoogleConnected) {
	      connectedServices.push(ServiceTypes.GOOGLE);
	    }

	    return React.createElement(ContactImporter, { services: [ServiceTypes.FACEBOOK, ServiceTypes.GOOGLE],
	      connectedServices: connectedServices,
	      onConnectClick: this.handleAccountConnect });
	  },

	  renderForm: function renderForm() {
	    var state = this.state,
	        recipient = state.recipient,
	        tag = recipient.tags[0] || false,
	        suggested = state.suggested;

	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'Form' },
	        React.createElement(FormInputRow, { label: 'Enter name or email',
	          component: TagInput,
	          formLink: this.linkValidatedState('recipient', this.validateNameOrEmail),
	          onBlur: this.handleRecipientBlur,
	          onKeyUp: this.handleRecipientKeyUp }),
	        suggested.length > 0 && React.createElement(ContactList, { contacts: suggested,
	          onSelect: this.handleSuggestedFriendSelect }),
	        (!tag || tag.type !== ServiceTypes.FACEBOOK) && React.createElement(FormInputRow, { label: 'Add an optional message',
	          component: Textarea,
	          formLink: this.linkValidatedState('message', function () {}) })
	      ),
	      React.createElement(
	        Button,
	        { className: 'SendInvite-button',
	          color: 'green',
	          onClick: this.submitForm.bind(this, this.sendInvite),
	          disabled: this.state.isSending,
	          size: 'large' },
	        'Send an Invite'
	      )
	    );
	  },

	  validateNameOrEmail: function validateNameOrEmail(recipient, data) {
	    if (recipient.text.length === 0 && recipient.tags.length === 0 && data.event === 'submit') {
	      return { error: 'Name or email is required' };
	    }

	    if (data.event === 'tagBlur' || data.event === 'submit') {
	      if (!isValidEmail(recipient.text) && recipient.tags.length === 0) {
	        return { error: 'Invalid email' };
	      }
	    }
	  },

	  handleResendClick: function handleResendClick(invite) {
	    if (this.state.isSending) {
	      return;
	    }

	    if (invite.serviceType === ServiceTypes.FACEBOOK) {
	      FacebookActionCreators.sendFacebookInvite(invite, true);
	    } else {
	      InvitationActionCreators.resendInvite(invite);
	    }
	  },

	  sendInvite: function sendInvite() {
	    var state = this.state,
	        zineSlug = this.props.zineSlug,
	        recipient = state.recipient,
	        tag = recipient.tags[0];

	    if (!tag) {
	      return;
	    }

	    InvitationActionCreators.sendInvite({
	      serviceType: tag.type,
	      serviceId: tag.user ? tag.user.contactId : tag.content,
	      name: tag.user && tag.user.name,
	      message: this.state.message,
	      zineSlug: zineSlug
	    });
	  },

	  handleAccountConnect: function handleAccountConnect(serviceType) {
	    PopupManager.openConnect(serviceType, { scope: 'contacts' });
	  },

	  handleRecipientBlur: function handleRecipientBlur() {
	    var state = this.state,
	        recipient = state.recipient,
	        suggested = state.suggested;

	    if (recipient.text.length > 0 && suggested.length === 0 && this.isFormValid({ event: 'tagBlur', showError: true })) {

	      this.pushTagAndClearText({
	        icon: 'email',
	        type: ServiceTypes.EMAIL,
	        content: recipient.text
	      });
	    } else if (suggested.length > 0) {
	      this.clearSuggested();
	    }
	  },

	  handleRecipientKeyUp: function handleRecipientKeyUp(e) {
	    if (!this.isEnterKey(e)) {
	      return;
	    }

	    var suggested = this.state.suggested;
	    if (suggested.length === 0) {
	      return;
	    }

	    var firstSuggested = suggested[0],
	        serviceType = firstSuggested.serviceType,
	        content = firstSuggested.name;

	    this.pushTagAndClearText({
	      icon: serviceType === ServiceTypes.FACEBOOK ? 'facebook' : 'email',
	      type: serviceType,
	      content: content,
	      user: firstSuggested
	    });
	  },

	  handleSuggestedFriendSelect: function handleSuggestedFriendSelect(friend) {
	    var serviceType = friend.serviceType;

	    this.pushTagAndClearText({
	      icon: serviceType === ServiceTypes.FACEBOOK ? 'facebook' : 'email',
	      type: serviceType,
	      content: friend.name,
	      user: friend
	    });
	  },

	  pushTagAndClearText: function pushTagAndClearText(tag) {
	    SendInvitationFormActionCreators.pushTag(tag);
	  },

	  clearSuggested: function clearSuggested() {
	    SendInvitationFormActionCreators.clearSuggested();
	  }
	});

	module.exports = SendInvite;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var FormMixin = __webpack_require__(79);
	var FormInputRow = __webpack_require__(131);
	var ServiceAccountRow = __webpack_require__(703);
	var NotificationSwitchRow = __webpack_require__(699);
	var Textarea = __webpack_require__(142);
	var Link = __webpack_require__(21);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var ImagePicker = __webpack_require__(270);
	var TabBar = __webpack_require__(171);
	var TabLink = __webpack_require__(198);
	var validateEmail = __webpack_require__(221);
	var UserStore = __webpack_require__(5);
	var ServiceAccountStore = __webpack_require__(176);
	var createStoreMixin = __webpack_require__(8);
	var getUserThumbnail = __webpack_require__(299);
	var _getThumbnailUrl = __webpack_require__(37);
	var UserActionCreators = __webpack_require__(47);
	var PureRenderMixin = __webpack_require__(2);
	var EmailFlags = __webpack_require__(201);
	var keyMirror = __webpack_require__(24);var PropTypes = React.PropTypes;

	var TABS = keyMirror({
	  GENERAL: null,
	  ACCOUNT: null,
	  SOCIAL: null,
	  NOTIFICATIONS: null
	});

	var Settings = React.createClass({
	  displayName: 'Settings',

	  mixins: [FormMixin, createStoreMixin(UserStore, ServiceAccountStore), PureRenderMixin],

	  propTypes: {
	    initialTabId: PropTypes.string,
	    onCloseClick: PropTypes.func.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      activeTabId: this.props.initialTabId || TABS.GENERAL
	    };
	  },

	  getStateFromStores: function getStateFromStores() {
	    var user = UserStore.getMe(),
	        fields;

	    fields = _.flatten(_.map([TABS.ACCOUNT, TABS.GENERAL, TABS.SOCIAL], this.getTabFields));

	    return _.extend({
	      user: user,
	      dummyPassword: '********',
	      showChangePassword: false,
	      password: '',
	      confirmPassword: ''
	    }, _.pick(user, fields));
	  },

	  getTabs: function getTabs() {
	    return [{
	      id: TABS.GENERAL,
	      title: 'Info'
	    }, {
	      id: TABS.ACCOUNT,
	      title: 'Account'
	    }, {
	      id: TABS.SOCIAL,
	      title: 'Services'
	    }, {
	      id: TABS.NOTIFICATIONS,
	      title: 'Notifications'
	    }];
	  },

	  getTabFields: function getTabFields(tabId) {
	    var fields = ['thumbnailUrl'];

	    switch (tabId) {
	      case TABS.GENERAL:
	        fields = fields.concat(['name', 'about', 'location', 'website']);
	        break;
	      case TABS.ACCOUNT:
	        fields = fields.concat(['email', 'confirmedEmail']);
	        if (this.state && this.state.password) {
	          fields = fields.concat(['oldPassword', 'password']);
	        }
	        break;
	    }

	    return fields;
	  },

	  getThumbnailUrl: function getThumbnailUrl() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    var size = 6 * 16 * Math.round(devicePixelRatio),
	        image;

	    if (this.state.thumbnailUrl) {
	      image = { url: this.state.thumbnailUrl };
	    } else {
	      image = getUserThumbnail(this.state.user);
	    }

	    return _getThumbnailUrl(image, {
	      allowExternal: true,
	      mode: 'scale_crop',
	      width: size,
	      height: size
	    });
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.activeTabId === TABS.ACCOUNT && this.state.activeTabId !== TABS.ACCOUNT && !this.state.password) {

	      this.setState({
	        showChangePassword: false
	      });
	    }
	  },

	  render: function render() {
	    var _this = this;

	    var activeTabId = this.state.activeTabId;

	    var footer = this.renderFooter(activeTabId);

	    return React.createElement(
	      'div',
	      { className: 'Modal-body Modal-body--wide' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Settings'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: _.partial(this.props.onCloseClick, false),
	            className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          ImagePicker,
	          { imageUrl: this.getThumbnailUrl(),
	            size: 'avatar',
	            onUploadSuccess: this.handleAvatarUploaded,
	            cancelOnChange: true },
	          React.createElement(Icon, { name: 'image',
	            size: 'medium',
	            mode: 'stroke' })
	        ),
	        React.createElement(
	          'div',
	          { className: 'Modal-tabs' },
	          React.createElement(
	            TabBar,
	            null,
	            this.getTabs().map(function (tab) {
	              return React.createElement(
	                TabLink,
	                { key: tab.id,
	                  active: tab.id === activeTabId,
	                  onClick: function () {
	                    return _this.handleTabClick(tab.id);
	                  } },
	                tab.title
	              );
	            })
	          )
	        ),
	        this.renderTab(activeTabId)
	      ),
	      footer && React.createElement(
	        'div',
	        { className: 'Modal-footer' },
	        footer
	      )
	    );
	  },

	  handleTabClick: function handleTabClick(tabId) {
	    this.setState({
	      activeTabId: tabId
	    });
	  },

	  handleAvatarUploaded: function handleAvatarUploaded(filePath, image) {
	    if (this.isMounted()) {
	      this.setState({
	        thumbnailUrl: image.url
	      });
	    }
	  },

	  renderTab: function renderTab(tabId) {
	    switch (tabId) {
	      case TABS.GENERAL:
	        return React.createElement(
	          'div',
	          { key: 'general' },
	          React.createElement(
	            'div',
	            { className: 'Form' },
	            React.createElement(FormInputRow, { label: 'Name',
	              formLink: this.linkValidatedState('name', this.validateName) }),
	            React.createElement(FormInputRow, { component: Textarea,
	              label: 'Short Bio',
	              formLink: this.linkValidatedState('about', this.validateAbout) }),
	            React.createElement(FormInputRow, { label: 'Location',
	              formLink: this.linkState('location') }),
	            React.createElement(FormInputRow, { label: 'Website',
	              formLink: this.linkState('website') })
	          )
	        );

	      case TABS.ACCOUNT:
	        var showChangePassword = this.state.showChangePassword;

	        return React.createElement(
	          'div',
	          { key: 'account' },
	          React.createElement(
	            'div',
	            { className: 'Form' },
	            React.createElement(FormInputRow, { label: 'Email Address',
	              formLink: this.linkValidatedState('email', validateEmail) }),
	            !showChangePassword && React.createElement(FormInputRow, { label: 'Password',
	              key: 'focus-password',
	              type: 'password',
	              formLink: this.linkState('dummyPassword'),
	              onFocus: this.handleChangePasswordClick }),
	            showChangePassword && React.createElement(FormInputRow, { label: 'Old Password',
	              key: 'focus-password',
	              type: 'password',
	              formLink: this.linkValidatedState('oldPassword', this.validateOldPassword) }),
	            showChangePassword && React.createElement(FormInputRow, { label: 'New Password',
	              type: 'password',
	              formLink: this.linkValidatedState('password', this.validatePassword) }),
	            showChangePassword && React.createElement(FormInputRow, { label: 'New Password, Again',
	              type: 'password',
	              formLink: this.linkValidatedState('confirmPassword', this.validateConfirmPassword) })
	          )
	        );

	      case TABS.SOCIAL:
	        var userId = this.state.user.id,
	            serviceAccounts = ServiceAccountStore.getUserServiceAccounts(userId),
	            authServiceAccounts = ServiceAccountStore.getConnectedAuthServiceAccounts(userId),
	            allowDisconnectAuthService;

	        allowDisconnectAuthService = authServiceAccounts.length > 1 || this.state.user.hasPassword;

	        return React.createElement(
	          'div',
	          { key: 'social' },
	          React.createElement(
	            'div',
	            { className: 'Form' },
	            _.map(serviceAccounts, (function (acc, key) {
	              return React.createElement(ServiceAccountRow, { key: key,
	                serviceType: key,
	                formLink: this.linkState(key.toLowerCase()),
	                allowDisconnect: allowDisconnectAuthService || !ServiceAccountStore.isAuthService(userId, key) });
	            }).bind(this))
	          )
	        );

	      case TABS.NOTIFICATIONS:
	        return React.createElement(
	          'div',
	          { key: 'notifications' },
	          React.createElement(
	            'p',
	            { className: 'Modal-message' },
	            'Choose when Stampsy sends you emails.'
	          ),
	          React.createElement(
	            'div',
	            { className: 'Form' },
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.STAMP_PUBLISHED,
	              label: 'Your stamp is posted' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.TRENDING_STAMP,
	              label: 'Your stamp is trending' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.NEW_SUBSCRIBER,
	              label: 'Somebody follows you or your collections' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.YOUR_STAMP_ADDED_TO_COLLECTION,
	              label: 'Your stamp is added to a collection' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.STAMP_SUBMITTED_TO_COLLECTION,
	              label: 'A stamp is submitted to your collection' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.SUBMISSION_APPROVED_OR_DECLINED,
	              label: 'Your submission to another collection is approved or declined' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.COLLECTED_IMAGE_PUBLISHED,
	              label: 'Your image gets credited in other stamp' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.DRAFT_FEEDBACK,
	              label: 'Someone leaves feedback on your draft' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.WEEKLY_PENDING_REMINDER,
	              label: 'Weekly reminder about submissions to your collections' }),
	            React.createElement(NotificationSwitchRow, { flag: EmailFlags.WEEKLY_DIGEST_AND_MISC,
	              label: 'Weekly digest with best stamps and Stampsy updates' })
	          )
	        );
	    }
	  },

	  renderFooter: function renderFooter(tabId) {
	    if (!this.isSaveButtonVisible(tabId)) {
	      if (tabId === TABS.ACCOUNT) {
	        return React.createElement(
	          'p',
	          { className: 'Modal-message' },
	          React.createElement(
	            'a',
	            { className: 'Link Link--red Link--bold Link--underlineHover', href: '/account/delete' },
	            'Delete my Stampsy account'
	          )
	        );
	      }

	      return;
	    }

	    return React.createElement(
	      BtnGroup,
	      null,
	      React.createElement(
	        Button,
	        { size: 'large',
	          color: 'green',
	          onClick: this.handleSubmitClick.bind(this, tabId) },
	        'Save Changes'
	      ),
	      React.createElement(
	        Button,
	        { size: 'large',
	          color: 'gray',
	          onClick: _.partial(this.rollbackChanges.bind(this, tabId), false) },
	        'Cancel'
	      )
	    );
	  },

	  rollbackChanges: function rollbackChanges(tabId) {
	    var fields = this.getTabFields(tabId),
	        newState = _.pick(this.state.user, fields);

	    if (tabId === TABS.ACCOUNT) {
	      _.extend(newState, {
	        password: '',
	        confirmPassword: '',
	        showChangePassword: false
	      });
	    }

	    this.setState(newState);
	  },

	  isSaveButtonVisible: function isSaveButtonVisible(tabId) {
	    if (!this.isFormEditable()) {
	      return false;
	    }

	    var fields = this.getTabFields(tabId),
	        values = _.pick(this.state, fields);

	    return _.any(values, this.hasValueChanged);
	  },

	  hasValueChanged: function hasValueChanged(newValue, key) {
	    newValue = newValue || '';
	    var oldValue = this.state.user[key] || '';
	    return oldValue !== newValue;
	  },

	  handleChangePasswordClick: function handleChangePasswordClick() {
	    this.setState({
	      showChangePassword: true
	    }, (function () {
	      this.validateFields(['oldPassword'], {
	        showHelp: true
	      });
	    }).bind(this));
	  },

	  handleSubmitClick: function handleSubmitClick(tabId) {
	    this.submitForm(this.sendRequest.bind(this, tabId));
	  },

	  validateOldPassword: function validateOldPassword(oldPassword) {
	    oldPassword = (oldPassword || '').trim();

	    if (this.state.password && !oldPassword) {
	      return {
	        error: 'Required'
	      };
	    }

	    return {
	      permanentHelp: React.createElement(
	        Link,
	        { color: 'gray', onClick: this.handleResetPasswordClick },
	        'Forgot your password?'
	      )
	    };
	  },

	  handleResetPasswordClick: function handleResetPasswordClick() {
	    UserActionCreators.requestResetPassword();
	  },

	  validatePassword: function validatePassword(password) {
	    password = (password || '').trim();

	    if (password && password.length < 8) {
	      return {
	        error: 'Minimum 8 characters'
	      };
	    }
	  },

	  validateConfirmPassword: function validateConfirmPassword(confirmPassword) {
	    confirmPassword = (confirmPassword || '').trim();

	    if (!confirmPassword && !this.state.password) {
	      return;
	    }

	    if (confirmPassword !== this.state.password) {
	      return {
	        error: 'Password doesn’t match'
	      };
	    }
	  },

	  validateName: function validateName(name) {
	    name = (name || '').trim();
	    if (!name) {
	      return {
	        error: 'Required'
	      };
	    }

	    if (name.length < 3) {
	      return {
	        error: 'Minimum three characters'
	      };
	    }
	  },

	  validateAbout: function validateAbout(about) {
	    var charsLeft = 140 - (about || '').length;

	    return {
	      help: charsLeft.toString(),
	      error: charsLeft < 0 && charsLeft.toString()
	    };
	  },

	  sendRequest: function sendRequest(tabId) {
	    var fields = this.getTabFields(tabId),
	        data;

	    data = _.pick(this.state, fields);
	    UserActionCreators.saveSettings(data);
	  }
	});

	module.exports = Settings;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    FormMixin = __webpack_require__(79),
	    Button = __webpack_require__(13),
	    BtnGroup = __webpack_require__(44),
	    Icon = __webpack_require__(10),
	    Link = __webpack_require__(21),
	    AuthTypes = __webpack_require__(199),
	    FormMessage = __webpack_require__(408),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(927);

	var Signup = React.createClass({
	  displayName: 'Signup',

	  mixins: [FormMixin, PureRenderMixin],

	  propTypes: {
	    endpoints: React.PropTypes.array.isRequired,
	    onCloseClick: React.PropTypes.func.isRequired,
	    onServiceClick: React.PropTypes.func.isRequired,
	    onLoginClick: React.PropTypes.func.isRequired,
	    allowClose: React.PropTypes.bool.isRequired,
	    showComplementaryButtons: React.PropTypes.bool
	  },

	  getInitialState: function getInitialState() {
	    return {
	      showComplementaryButtons: !!this.props.showComplementaryButtons
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Sign Up'
	        ),
	        this.props.allowClose && React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Modal-error' },
	          this.renderErrors()
	        ),
	        React.createElement(
	          'div',
	          { className: 'Signup-services' },
	          React.createElement(
	            BtnGroup,
	            { vertical: true },
	            this.renderPrimaryButtons()
	          ),
	          this.state.showComplementaryButtons ? React.createElement(
	            BtnGroup,
	            { vertical: true },
	            this.renderComplementaryButtons()
	          ) : React.createElement(
	            'div',
	            { className: 'Signup-showMore' },
	            React.createElement(
	              Link,
	              { onClick: this.handleShowMoreServices,
	                color: 'gray',
	                underline: 'hover' },
	              'Show more options'
	            )
	          )
	        )
	      ),
	      this.renderFooter()
	    );
	  },

	  handleShowMoreServices: function handleShowMoreServices() {
	    this.setState({
	      showComplementaryButtons: true
	    });
	  },

	  renderErrors: function renderErrors() {
	    return _.map(_.omit(this.props.endpoints, ['email']), (function (endpoint) {
	      return React.createElement(FormMessage, { key: endpoint.id,
	        formLink: this.linkState(endpoint.id.toLowerCase()) });
	    }).bind(this));
	  },

	  renderComplementaryButtons: function renderComplementaryButtons() {
	    var complementaryEndpoints = this.props.endpoints.filter(function (endpoint) {
	      return !endpoint.isPrimary;
	    });

	    return _.map(complementaryEndpoints, function (endpoint) {
	      return React.createElement(
	        Button,
	        { key: endpoint.id,
	          href: endpoint.url,
	          color: endpoint.id.toLowerCase(),
	          size: 'large',
	          onClick: this.props.onServiceClick.bind(this, endpoint.id),
	          fullWidth: true },
	        React.createElement(Icon, { name: endpoint.id.toLowerCase(),
	          mode: endpoint.id === AuthTypes.EMAIL ? 'stroke' : 'fill' }),
	        'Sign Up with ' + endpoint.title
	      );
	    }, this);
	  },

	  renderPrimaryButtons: function renderPrimaryButtons() {
	    var primaryEndpoints = this.props.endpoints.filter(function (endpoint) {
	      return endpoint.isPrimary;
	    });

	    return _.map(primaryEndpoints, (function (endpoint) {
	      return React.createElement(
	        Button,
	        { href: endpoint.url,
	          color: endpoint.id.toLowerCase(),
	          key: endpoint.id,
	          size: 'large',
	          onClick: this.props.onServiceClick.bind(this, endpoint.id),
	          fill: endpoint.isDefault,
	          fullWidth: true },
	        React.createElement(Icon, { name: endpoint.id.toLowerCase(),
	          mode: endpoint.id === AuthTypes.EMAIL ? 'stroke' : 'fill' }),
	        'Sign Up with ' + endpoint.title
	      );
	    }).bind(this));
	  },

	  renderFooter: function renderFooter() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-footer Modal-center' },
	      React.createElement(
	        'p',
	        { className: 'Modal-footerText' },
	        React.createElement(
	          'small',
	          null,
	          'We value your privacy and won’t post anything on your behalf without your permission.'
	        ),
	        React.createElement('br', null),
	        React.createElement('br', null),
	        'Already have an account?',
	        ' ',
	        React.createElement(
	          Link,
	          { onClick: this.props.onLoginClick,
	            color: 'green',
	            bold: true },
	          'Log In'
	        ),
	        '.'
	      )
	    );
	  }
	});

	module.exports = Signup;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	__webpack_require__(475);

	'use strict';

	var Stamplet = _react2['default'].createClass({
	  displayName: 'Stamplet',

	  propTypes: {
	    onCloseClick: _react2['default'].PropTypes.func.isRequired
	  },

	  render: function render() {
	    var notAllowedMessage = 'Sorry, this button doesn’t work on Stampsy.\\n\\nUse this button on the web page with images you want to collect.';
	    var forbiddenMessage = 'Oups, it seems that Stampsy Bookmarklet cannot be used on this site, sorry.';

	    var siteUrl = 'https://' + window.location.host;
	    var loaderScript = ('\n      (function(d){\n      var h=window.location.host;\n      if(h.substr(-11)===\'stampsy.com\'||h.substr(0,9)===\'localhost\'){alert(\'' + notAllowedMessage + '\');return;}\n      var e=d.createElement(\'script\');\n      e.setAttribute(\'type\',\'text/javascript\');\n      e.setAttribute(\'charset\',\'UTF-8\');\n      e.setAttribute(\'src\',\'' + siteUrl + '/static/stamplet/loader.js?r=\'+Math.random()*99999999);\n      e.onerror=function(){alert(\'' + forbiddenMessage + '\')};\n      d.body.appendChild(e)})(document)\n      ').replace(/(\n|\s{2,})/g, '');
	    var stampletUrl = 'javascript' + ':' + encodeURIComponent(loaderScript);

	    var stampletImageUrl = 'http://stampsy-eu-1.s3.amazonaws.com/uploads/05/07/2015/user/7/39377d0c-ca1a-428c-9325-d9830543edac.jpg';

	    return _react2['default'].createElement(
	      'div',
	      { className: 'Modal-body Modal-body--wide EditorHelp' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'Modal-header' },
	        _react2['default'].createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Stampsy Bookmarklet'
	        ),
	        _react2['default'].createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'Modal-content' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'Modal-message' },
	          'Stampsy Bookmarklet makes it easy to save images you find on the web straight to your Stampsy Editor.'
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'Modal-message' },
	          _react2['default'].createElement('img', { className: 'utils--maxWidth', src: stampletImageUrl })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'Modal-message Modal-message--centered' },
	          _react2['default'].createElement(
	            'b',
	            null,
	            '↓ Drag this button to your bookmarks toolbar'
	          )
	        ),
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { color: 'green',
	            fill: true,
	            fullWidth: true,
	            size: 'large',
	            onClick: this.handleStampletClick,
	            href: stampletUrl },
	          'Send to Stampsy'
	        )
	      )
	    );
	  },

	  handleStampletClick: function handleStampletClick() {
	    /* eslint-disable no-alert */
	    alert('To install the Stampsy Bookmarklet, drag it to your bookmarks toolbar!');
	    /* eslint-enable no-alert */
	  }
	});

	exports['default'] = Stamplet;
	module.exports = exports['default'];

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Icon = __webpack_require__(10),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(928);

	var Terms = React.createClass({
	  displayName: 'Terms',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    onCloseClick: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'Modal-body Modal-body--wide Terms' },
	      React.createElement(
	        'div',
	        { className: 'Modal-header' },
	        React.createElement(
	          'h3',
	          { className: 'Modal-title' },
	          'Terms of Service'
	        ),
	        React.createElement(
	          'div',
	          { onTouchTap: this.props.onCloseClick, className: 'Modal-close' },
	          React.createElement(Icon, { name: 'cross', size: 'small', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Modal-content' },
	        React.createElement(
	          'div',
	          { className: 'Modal-message' },
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'The following terms and conditions govern all use of the Stampsy Application and all content, services and products available at or through the application. The Application is owned and operated by Stampsy Limited (“Stampsy”), whose principal place of business is at 1306B Asian House, 1 Hennessy Road, Wanchai, Hong Kong. The Application offered subject to your acceptance without modification of all of the terms and conditions contained herein and all other operating rules, policies (including, without limitation, Stampsy\'s Privacy Policy) and procedures that may be published from time to time by Stampsy (collectively, the “Agreement”).'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Please read this Agreement carefully before accessing the Application. By accessing or using any part of the Application, you agree to become bound by the terms and conditions of this agreement. If you do not agree to all the terms and conditions of this agreement, then you may not access the Application or use any other services provided by Stampsy. If these terms and conditions are considered an offer by Stampsy, acceptance is expressly limited to these terms. The Application is available only to individuals who are at least 13 years old.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '1. Your Stampsy Account'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'If you create account using the Application, you are responsible for maintaining the security of your account, and you are fully responsible for all activities that occur under the account and any other actions taken in connection with the account. You must not describe or assign keywords to your Content in a misleading or unlawful manner, including in a manner intended to trade on the name or reputation of others, and Stampsy may change or remove any description or keyword that it considers inappropriate or unlawful, or otherwise likely to cause Stampsy liability. You must immediately notify Stampsy of any unauthorized uses of your account or any other breaches of security. Stampsy will not be liable for any acts or omissions by You, including any damages of any kind incurred as a result of such acts or omissions.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '2. Responsibility of Contributors'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'If you operate an account, comment on a stamp, publish material using the Application, post links within a stamp, or otherwise make (or allow any third party to make) material available by means of the Application (any such material, “Content”), You are entirely responsible for the content of, and any harm resulting from, that Content. That is the case regardless of whether the Content in question constitutes text, graphics, an audio file, or a video file. By making Content available, you represent and warrant that:'
	          ),
	          React.createElement(
	            'ul',
	            null,
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'the downloading, copying and use of the Content will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark or trade secret rights, of any third party;'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'if your employer has rights to intellectual property you create, you have either (i) received permission from your employer to post or make available the Content, or (ii) secured from your employer a waiver as to all rights in or to the Content;'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'you have fully complied with any third-party licenses relating to the Content, and have done all things necessary to successfully pass through to end users any required terms;'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'the Content does not contain or install any viruses, worms, malware, Trojan horses or other harmful or destructive content;'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'the Content is not spam, is not machine- or randomly-generated, and does not contain unethical or unwanted commercial content designed to drive traffic to third party sites or boost the search engine rankings of third party sites, or to further unlawful acts (such as phishing) or mislead recipients as to the source of the material (such as spoofing);'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'the Content is not pornographic, does not contain sexual themes or nudity, does not contain threats, incite or demonstrate violence, and does not violate the privacy or publicity rights of any third party;'
	            ),
	            React.createElement(
	              'li',
	              { className: 'Terms-paragraph' },
	              'your account or your stamp is not named in a manner that misleads your readers into thinking that you are another person or company. For example, your account’s URL or name is not the name of a person other than yourself or company other than your own; and'
	            )
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'By submitting Content to Stampsy for inclusion to your account, you grant Stampsy a world-wide, royalty-free, and non-exclusive license to reproduce, modify, adapt and publish the Content solely for the purpose of displaying, distributing and promoting your account. If you delete Content, Stampsy will use reasonable efforts to remove it, but you acknowledge that caching or references to the Content may not be made immediately unavailable.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Without limiting any of those representations or warranties, Stampsy has the right (though not the obligation) to, in Stampsy’s sole discretion (i) refuse or remove any content that, in Stampsy’s reasonable opinion, violates any Stampsy policy or is in any way harmful or objectionable, or (ii) terminate or deny access to and use of the Application to any individual or entity for any reason, in Stampsy’s sole discretion.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '3. Restricted Use'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'You may not use the Stampsy Application to substantially replicate products or services offered by Stampsy. If Stampsy believes, in its sole discretion, that you have violated or attempted to violate these conditions or the spirit of these terms, your ability to use and access the Stampsy Application may be temporarily or permanently revoked, with or without notice.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '4. Responsibility of Application users'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Stampsy has not reviewed, and cannot review, all of the material posted using the Application, and cannot therefore be responsible for that material’s content, use or effects. By operating the Application, Stampsy does not represent or imply that it endorses the material there posted, or that it believes such material to be accurate, useful or non-harmful. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. The Application may contain content that is offensive, indecent, or otherwise objectionable, as well as content containing technical inaccuracies, typographical mistakes, and other errors. The Application may also contain material that violates the privacy or publicity rights, or infringes the intellectual property and other proprietary rights, of third parties, or the downloading, copying or use of which is subject to additional terms and conditions, stated or unstated. Stampsy disclaims any responsibility for any harm resulting from the use by visitors of the Application, or from any downloading by those visitors of content there posted.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '5. Content Posted on Other Websites'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'We have not reviewed, and cannot review, all of the material, made available through the websites and webpages to which Stampsy links, and that link to Stampsy. Stampsy does not have any control over those non-Stampsy websites, webpages or posted stamps on those websites, and is not responsible for their contents or their use. By linking to a non-Stampsy website or webpage, Stampsy does not represent or imply that it endorses such website or webpage. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. Stampsy disclaims any responsibility for any harm resulting from your use of non-Stampsy websites and webpages.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '6. Copyright Infringement and DMCA Policy'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'As Stampsy asks others to respect its intellectual property rights, it respects the intellectual property rights of others. If you believe that material in the Application violates your copyright, you are encouraged to notify Stampsy in accordance with Stampsy’s Digital Millennium Copyright Act (“DMCA”) Policy. Stampsy will respond to all such notices, including as required or appropriate by removing the infringing material or disabling all links to the infringing material. Stampsy will terminate a visitor’s access to and use of the Application if, under appropriate circumstances, the visitor is determined to be a repeat infringer of the copyrights or other intellectual property rights of Stampsy or others. In the case of such termination, Stampsy will have no obligation to provide a refund of any amounts previously paid to Stampsy.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '7. Intellectual Property'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'This Agreement does not transfer from Stampsy to you any Stampsy or third party intellectual property, and all right, title and interest in and to such property will remain (as between the parties) solely with Stampsy. Stampsy, Stampsy.com, Stampsy Application, the Stampsy logo, and all other trademarks, service marks, graphics and logos used in connection with the Application are trademarks or registered trademarks of Stampsy or Stampsy’s licensors. Other trademarks, service marks, graphics and logos used in connection with the Application may be the trademarks of other third parties. Your use of the Application grants you no right or license to reproduce or otherwise use any Stampsy or third-party trademarks.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '8. Attribution'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Stampsy reserves the right to display attribution links such as ‘Stampsy’ theme author, and font attribution in your blog footer or toolbar. Footer credits and the Stampsy toolbar may not be removed.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '9. Changes'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Stampsy reserves the right, at its sole discretion, to modify or replace any part of this Agreement. It is your responsibility to check this Agreement periodically for changes. Your continued use of or access to the Application following the posting of any changes to this Agreement constitutes acceptance of those changes. Stampsy may also, in the future, offer new services and/or features through the Application (including, the release of new tools and resources). Such new features and/or services shall be subject to the terms and conditions of this Agreement.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '10. Termination'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'Stampsy may terminate your access to all or any part of the Application at any time, with or without cause, with or without notice, effective immediately. If you wish to terminate this Agreement or your Stampsy account (if you have one), you may simply discontinue using the Application. All provisions of this Agreement which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '11. Disclaimer of Warranties'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'The Application is provided “as is”. Stampsy and its suppliers and licensors hereby disclaim all warranties of any kind, express or implied, including, without limitation, the warranties of merchantability, fitness for a particular purpose and non-infringement. Neither Stampsy nor its suppliers and licensors, makes any warranty that the Application will be error free or that access thereto will be continuous or uninterrupted. You understand that you download from, or otherwise obtain content or services through, the Application at your own discretion and risk.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '12. Limitation of Liability'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'In no event will Stampsy, or its suppliers or licensors, be liable with respect to any subject matter of this agreement under any contract, negligence, strict liability or other legal or equitable theory for: (i) any special, incidental or consequential damages; (ii) the cost of procurement for substitute products or services; (iii) for interruption of use or loss or corruption of data. Stampsy shall have no liability for any failure or delay due to matters beyond their reasonable control. The foregoing shall not apply to the extent prohibited by applicable law.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '13. General Representation and Warranty'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'You represent and warrant that (i) your use of the Application will be in strict accordance with the Stampsy Privacy Policy, with this Agreement and with all applicable laws and regulations (including without limitation any local laws or regulations in your country, state, city, or other governmental area, regarding online conduct and acceptable content, and including all applicable laws regarding the transmission of technical data exported from the United States or the country in which you reside) and (ii) your use of the Application will not infringe or misappropriate the intellectual property rights of any third party.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '14. Indemnification'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'You agree to indemnify and hold harmless Stampsy, its contractors, and its licensors, and their respective directors, officers, employees and agents from and against any and all claims and expenses, including attorneys’ fees, arising out of your use of the Application, including but not limited to your violation of this Agreement.'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-subtitle' },
	            '15. Miscellaneous'
	          ),
	          React.createElement(
	            'span',
	            { className: 'Terms-paragraph' },
	            'This Agreement constitutes the entire agreement between Stampsy and you concerning the subject matter hereof, and they may only be modified by a written amendment signed by an authorized executive of Stampsy, or by the posting by Stampsy of a revised version. Except to the extent applicable law, if any, provides otherwise, this Agreement, any access to or use of the Application will be governed by the English law. You and Stampsy agree to submit to the exclusive jurisdiction of the courts of England to resolve any legal matter arising from the Terms. Notwithstanding this, you agree that Stampsy shall still be allowed to apply for injunctive remedies (or other equivalent types of urgent legal remedy) in any jurisdiction. The prevailing party in any action or proceeding to enforce this Agreement shall be entitled to costs and attorneys’ fees. If any part of this Agreement is held invalid or unenforceable, that part will be construed to reflect the parties’ original intent, and the remaining portions will remain in full force and effect. A waiver by either party of any term or condition of this Agreement or any breach thereof, in any one instance, will not waive such term or condition or any subsequent breach thereof. You may assign your rights under this Agreement to any party that consents to, and agrees to be bound by, its terms and conditions; Stampsy may assign its rights under this Agreement without condition. This Agreement will be binding upon and will inure to the benefit of the parties, their successors and permitted assigns.'
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = Terms;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesImageStore = __webpack_require__(146);

	var _storesImageStore2 = _interopRequireDefault(_storesImageStore);

	var _organismsUserInfo = __webpack_require__(132);

	var _organismsUserInfo2 = _interopRequireDefault(_organismsUserInfo);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	var _atomsStampLink = __webpack_require__(197);

	var _atomsStampLink2 = _interopRequireDefault(_atomsStampLink);

	var _atomsZineLink = __webpack_require__(93);

	var _atomsZineLink2 = _interopRequireDefault(_atomsZineLink);

	var _atomsDraftLink = __webpack_require__(583);

	var _atomsDraftLink2 = _interopRequireDefault(_atomsDraftLink);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _utilsGetThumbnailUrl = __webpack_require__(37);

	var _utilsGetThumbnailUrl2 = _interopRequireDefault(_utilsGetThumbnailUrl);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _organismsTimeAgo = __webpack_require__(727);

	var _organismsTimeAgo2 = _interopRequireDefault(_organismsTimeAgo);

	var _utilsGetZineThumbnail = __webpack_require__(178);

	var _utilsGetZineThumbnail2 = _interopRequireDefault(_utilsGetZineThumbnail);

	var _utilsGetUserThumbnail = __webpack_require__(299);

	var _utilsGetUserThumbnail2 = _interopRequireDefault(_utilsGetUserThumbnail);

	var _actionsActivityActionCreators = __webpack_require__(247);

	var _actionsActivityActionCreators2 = _interopRequireDefault(_actionsActivityActionCreators);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _actionsUserActionCreators = __webpack_require__(47);

	var _actionsUserActionCreators2 = _interopRequireDefault(_actionsUserActionCreators);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _constantsActivityTypes = __webpack_require__(643);

	var _constantsActivityTypes2 = _interopRequireDefault(_constantsActivityTypes);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _router = __webpack_require__(50);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	__webpack_require__(929);

	'use strict';

	var STAMPSY_AVATAR = {
	  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/10/06/2014/user/9/d8300036-1d75-4c4d-8210-98248a6d2244.jpg'
	};

	var Activity = _react2['default'].createClass({
	  displayName: 'Activity',

	  mixins: [_mixinsClassNameMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesUserStore2['default'], _storesZineStore2['default'], _storesImageStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    activity: _react.PropTypes.object.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.activity.isSeen && 'seen', this.isExpandable() && 'expandable'];
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var _props$activity = props.activity;
	    var actorIds = _props$activity.actorIds;
	    var objectIds = _props$activity.objectIds;
	    var targetIds = _props$activity.targetIds;
	    var verb = _props$activity.verb;
	    var objectStore;
	    var targetStore;

	    function getObjectStore(verb) {
	      switch (verb) {
	        case _constantsActivityTypes2['default'].STAMP_LIKED:
	        case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_IN_TRENDING:
	        case _constantsActivityTypes2['default'].DRAFT_FEEDBACK:
	          return _storesStampStore2['default'];
	        case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	        case _constantsActivityTypes2['default'].WELCOME_MESSAGE:
	          return _storesZineStore2['default'];
	        case _constantsActivityTypes2['default'].COLLECTED_IMAGE_PUBLISHED:
	          return _storesImageStore2['default'];
	      }
	    }

	    function getTargetStore(verb) {
	      switch (verb) {
	        case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	        case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	          return _storesZineStore2['default'];
	        case _constantsActivityTypes2['default'].COLLECTED_IMAGE_PUBLISHED:
	          return _storesStampStore2['default'];
	      }
	    }

	    objectStore = getObjectStore(verb);
	    targetStore = getTargetStore(verb);

	    return {
	      actors: actorIds.map(_storesUserStore2['default'].get),
	      objects: objectStore && objectIds.map(objectStore.get),
	      targets: targetStore && targetIds.map(targetStore.get)
	    };
	  },

	  isExpandable: function isExpandable() {
	    var activity = this.props.activity;

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_LIKED:
	        return activity.actorIds.length > 2;
	      case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	        return activity.objectIds.length > 2;
	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	        return activity.actorIds.length > 1;
	    }
	  },

	  getIcon: function getIcon(activity) {
	    var color, icon, classes;

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_LIKED:
	        color = 'red';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'like', mode: 'fill', size: 'xxsmall' });
	        break;

	      case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	        color = 'green';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'plus', mode: 'stroke', size: 'xxsmall' });
	        break;

	      case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	        color = 'green';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'check', mode: 'stroke', size: 'xxsmall' });
	        break;

	      case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	        color = 'red';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'cross', mode: 'stroke', size: 'xxsmall' });
	        break;

	      case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        color = 'yellow';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'clock', mode: 'stroke', size: 'xxsmall' });
	        break;

	      case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	        return null;

	      case _constantsActivityTypes2['default'].STAMP_IN_TRENDING:
	        color = 'green';
	        icon = _react2['default'].createElement(_atomsIcon2['default'], { name: 'trending', mode: 'stroke', size: 'xxsmall' });
	        break;

	      default:
	        return null;
	    }

	    classes = ['Activity-icon', 'Activity-icon--' + color].join(' ');

	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      icon
	    );
	  },

	  getAvatar: function getAvatar(activity) {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    function renderDefaultAvatar() {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(STAMPSY_AVATAR, {
	        mode: 'scale_crop',
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio)
	      });

	      return _react2['default'].createElement('img', { className: 'Activity-avatarImage', src: thumbnailUrl });
	    }

	    function renderUserAvatar(user) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])((0, _utilsGetUserThumbnail2['default'])(user), {
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        allowExternal: true,
	        allowEmpty: true,
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsUserLink2['default'],
	        { user: user, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-avatarImage', src: thumbnailUrl })
	      );
	    }

	    function renderZineAvatar(zine) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])((0, _utilsGetZineThumbnail2['default'])(zine), {
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsZineLink2['default'],
	        { zine: zine, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-avatarImage', src: thumbnailUrl })
	      );
	    }

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_IN_TRENDING:
	      case _constantsActivityTypes2['default'].WELCOME_MESSAGE:
	        return renderDefaultAvatar();

	      case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	      case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	      case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	        return renderZineAvatar(this.state.targets[0]);

	      case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	      case _constantsActivityTypes2['default'].DRAFT_FEEDBACK:
	        if (activity.extraContext.isGrouping) {
	          return renderDefaultAvatar();
	        }
	        return renderUserAvatar(this.state.actors[0]);

	      case _constantsActivityTypes2['default'].STAMP_LIKED:
	      case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	      case _constantsActivityTypes2['default'].COLLECTED_IMAGE_PUBLISHED:
	        return renderUserAvatar(this.state.actors[0]);
	    }
	  },

	  getPreview: function getPreview(activity) {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    function getStampPreview(stamp) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(stamp.thumbnail, {
	        width: 52 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsStampLink2['default'],
	        { stamp: stamp, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-stampPreview',
	          src: thumbnailUrl })
	      );
	    }

	    function getDraftPreview(draft) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(draft.thumbnail, {
	        width: 52 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop',
	        allowEmpty: true
	      });

	      return _react2['default'].createElement(
	        _atomsDraftLink2['default'],
	        { draft: draft,
	          showTitle: true },
	        thumbnailUrl ? _react2['default'].createElement('img', { className: 'Activity-stampPreview',
	          src: thumbnailUrl }) : _react2['default'].createElement('div', { className: 'Activity-stampPreview' })
	      );
	    }

	    function getZinePreview(zine) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])((0, _utilsGetZineThumbnail2['default'])(zine), {
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsZineLink2['default'],
	        { zine: zine, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-zinePreview',
	          src: thumbnailUrl })
	      );
	    }

	    function getUserPreview(user) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])((0, _utilsGetUserThumbnail2['default'])(user), {
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsUserLink2['default'],
	        { user: user, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-userPreview',
	          src: thumbnailUrl })
	      );
	    }

	    function getImagePreview(image, stamp) {
	      var thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(image, {
	        width: 44 * Math.round(devicePixelRatio),
	        height: 44 * Math.round(devicePixelRatio),
	        mode: 'scale_crop'
	      });

	      return _react2['default'].createElement(
	        _atomsStampLink2['default'],
	        { stamp: stamp, showTitle: true },
	        _react2['default'].createElement('img', { className: 'Activity-imagePreview',
	          src: thumbnailUrl })
	      );
	    }

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_LIKED:
	      case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	      case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	      case _constantsActivityTypes2['default'].STAMP_IN_TRENDING:
	      case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	        return getStampPreview(this.state.objects[0]);

	      case _constantsActivityTypes2['default'].DRAFT_FEEDBACK:
	        return getDraftPreview(this.state.objects[0]);

	      case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        return getZinePreview(this.state.targets[0]);

	      case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	      case _constantsActivityTypes2['default'].WELCOME_MESSAGE:
	        return getZinePreview(this.state.objects[0]);

	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	        return getUserPreview(_storesUserStore2['default'].getMe());

	      case _constantsActivityTypes2['default'].COLLECTED_IMAGE_PUBLISHED:
	        return getImagePreview(this.state.objects[0], this.state.targets[0]);
	    }
	  },

	  getAction: function getAction(activity) {
	    function renderReviewButton(stamp, zine) {
	      function handleClick() {
	        (0, _router.transitionTo)('zinePendingStamp', {
	          zineSlug: zine.slug,
	          stampSegment: (0, _utilsGetStampSegment2['default'])(stamp)
	        });
	      }

	      return _react2['default'].createElement(
	        _atomsButton2['default'],
	        { color: 'yellow',
	          size: 'small',
	          fill: true,
	          context: 'Activity',
	          onClick: handleClick },
	        'Review Submission'
	      );
	    }

	    function renderZineFollowButton(zine) {
	      function handleClick() {
	        _actionsZineActionCreators2['default'].followZine(zine.slug);
	      }

	      if (zine.isSubscribed) {
	        return;
	      }

	      return _react2['default'].createElement(
	        _atomsButton2['default'],
	        { color: 'green',
	          size: 'small',
	          fill: true,
	          context: 'Activity', onClick: handleClick },
	        'Follow Collection'
	      );
	    }

	    function renderUserFollowButton(user) {
	      function handleClick() {
	        _actionsUserActionCreators2['default'].followUser(user.id);
	      }

	      if (user.isSubscribed) {
	        return;
	      }

	      return _react2['default'].createElement(
	        _atomsButton2['default'],
	        { color: 'green',
	          size: 'small',
	          fill: true,
	          context: 'Activity', onClick: handleClick },
	        'Follow ' + user.name.split(' ')[0]
	      );
	    }

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        return renderReviewButton(this.state.objects[0], this.state.targets[0]);
	      case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	        return renderZineFollowButton(this.state.targets[0]);
	      case _constantsActivityTypes2['default'].WELCOME_MESSAGE:
	        return renderZineFollowButton(this.state.objects[0]);
	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	        return renderUserFollowButton(this.state.actors[0]);
	    }
	  },

	  getMessage: function getMessage(activity) {
	    var actors = this.state.actors;

	    var stamp = undefined,
	        stamps = undefined,
	        stampProps = undefined,
	        zine = undefined,
	        draft = undefined,
	        message = undefined;

	    switch (activity.verb) {
	      case _constantsActivityTypes2['default'].STAMP_LIKED:
	        stamp = this.state.objects[0];
	        if (actors.length > 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(
	              _atomsLink2['default'],
	              { bold: true, onClick: this.handleExpandClick },
	              actors.length - 1,
	              ' others'
	            ),
	            ' like your Stamp ',
	            _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	            '.'
	          );
	        } else if (actors.length === 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[1] }),
	            ' like your Stamp ',
	            _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	            '.'
	          );
	        } else {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' likes your Stamp ',
	            _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	            '.'
	          );
	        }
	        break;

	      case _constantsActivityTypes2['default'].STAMP_SUBMITTED_TO_ZINE:
	        zine = this.state.targets[0];
	        stamps = this.state.objects;
	        stampProps = {
	          routeName: 'zinePendingStamp',
	          routeParams: { zineSlug: activity.targetIds[0] }
	        };

	        if (activity.extraContext.isGrouping) {
	          if (stamps.length > 2) {
	            return _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	              ' and ',
	              _react2['default'].createElement(
	                _atomsLink2['default'],
	                { bold: true, onClick: this.handleExpandClick },
	                stamps.length - 1,
	                ' more stamps'
	              ),
	              ' are waiting for your approval to ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	              '.'
	            );
	          } else if (stamps.length === 2) {
	            return _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	              ' and ',
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[1], bold: true }, stampProps)),
	              ' are waiting for your approval to ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	              '.'
	            );
	          } else {
	            return _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	              ' by ',
	              _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0], bold: true }),
	              ' is waiting for your approval to ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	              '.'
	            );
	          }
	        } else {
	          if (stamps.length > 2) {
	            return _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	              ' and ',
	              _react2['default'].createElement(
	                _atomsLink2['default'],
	                { bold: true, onClick: this.handleExpandClick },
	                stamps.length - 1,
	                ' more stamps'
	              ),
	              ' were submitted to ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	              '.'
	            );
	          } else if (stamps.length === 2) {
	            return _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	              ' and ',
	              _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[1], bold: true }, stampProps)),
	              ' were submitted to ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	              '.'
	            );
	          } else {
	            return _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0], bold: true }),
	                ' submitted ',
	                _react2['default'].createElement(_atomsStampLink2['default'], _extends({ stamp: stamps[0], bold: true }, stampProps)),
	                ' to ',
	                _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	                '.'
	              )
	            );
	          }
	        }
	        break;

	      case _constantsActivityTypes2['default'].DRAFT_FEEDBACK:
	        draft = this.state.objects[0];
	        message = activity.extraContext.message;
	        return _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	          ' sent you feedback on ',
	          _react2['default'].createElement(_atomsDraftLink2['default'], { draft: draft, emptyTitle: 'your draft', bold: true }),
	          ':',
	          _react2['default'].createElement(
	            'div',
	            null,
	            message
	          )
	        );

	      case _constantsActivityTypes2['default'].STAMP_APPROVED_IN_ZINE:
	        zine = this.state.targets[0];
	        stamp = this.state.objects[0];
	        message = activity.extraContext.message;
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your submission to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	          ' has been approved.',
	          _react2['default'].createElement('br', null),
	          message && _react2['default'].createElement(
	            'span',
	            null,
	            'Curator sent you a message regarding ',
	            _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	            ':',
	            _react2['default'].createElement(
	              _organismsUserInfo2['default'],
	              { user: actors[0],
	                size: 'xsmall',
	                context: 'Activity' },
	              '“',
	              message,
	              '”'
	            )
	          )
	        );

	      case _constantsActivityTypes2['default'].STAMP_REJECTED_FROM_ZINE:
	        zine = this.state.targets[0];
	        stamp = this.state.objects[0];
	        message = activity.extraContext.message;
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your submission to ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	          ' has been declined.',
	          _react2['default'].createElement('br', null),
	          message && _react2['default'].createElement(
	            'span',
	            null,
	            'Curator sent you a message regarding ',
	            _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	            ':',
	            _react2['default'].createElement(
	              _organismsUserInfo2['default'],
	              { user: actors[0],
	                size: 'xsmall',
	                context: 'Activity' },
	              '“',
	              message,
	              '”'
	            )
	          )
	        );

	      case _constantsActivityTypes2['default'].ZINE_FOLLOWED:
	        zine = this.state.objects[0];
	        if (actors.length > 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(
	              _atomsLink2['default'],
	              { bold: true, onClick: this.handleExpandClick },
	              actors.length - 1,
	              ' others'
	            ),
	            ' started following your Collection ',
	            _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	            '.'
	          );
	        } else if (actors.length === 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[1] }),
	            ' started following your Collection ',
	            _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	            '.'
	          );
	        } else {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' started following your Collection ',
	            _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	            '.'
	          );
	        }
	        break;

	      case _constantsActivityTypes2['default'].USER_FOLLOWED:
	        if (actors.length > 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(
	              _atomsLink2['default'],
	              { bold: true, onClick: this.handleExpandClick },
	              actors.length - 1,
	              ' others'
	            ),
	            ' started following you.'
	          );
	        } else if (actors.length === 2) {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' and ',
	            _react2['default'].createElement(
	              _atomsLink2['default'],
	              { bold: true, onClick: this.handleExpandClick },
	              '1 other'
	            ),
	            ' started following you.'
	          );
	        } else {
	          return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	            ' started following you.'
	          );
	        }
	        break;

	      case _constantsActivityTypes2['default'].STAMP_ADDED_TO_ZINE:
	        zine = this.state.targets[0];
	        stamp = this.state.objects[0];
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your Stamp ',
	          _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	          ' was added to Collection ',
	          _react2['default'].createElement(_atomsZineLink2['default'], { zine: zine, bold: true }),
	          '.'
	        );

	      case _constantsActivityTypes2['default'].STAMP_IN_TRENDING:
	        stamp = this.state.objects[0];
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Your stamp ',
	          _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	          ' is now trending on Stampsy, as it has been viewed more than ',
	          activity.extraContext.viewCount,
	          ' times.'
	        );

	      case _constantsActivityTypes2['default'].WELCOME_MESSAGE:
	        zine = this.state.objects[0];
	        return _react2['default'].createElement(
	          'span',
	          null,
	          'Welcome to Stampsy! Learn more about how everything works by following ',
	          _react2['default'].createElement(
	            _atomsZineLink2['default'],
	            { zine: zine, bold: true },
	            'About Stampsy'
	          ),
	          ' collection.'
	        );

	      case _constantsActivityTypes2['default'].COLLECTED_IMAGE_PUBLISHED:
	        stamp = this.state.targets[0];
	        return _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(_atomsUserLink2['default'], { user: actors[0] }),
	          ' credited your image in their Stamp ',
	          _react2['default'].createElement(_atomsStampLink2['default'], { stamp: stamp, bold: true }),
	          '.'
	        );
	    }
	  },

	  render: function render() {
	    var activity = this.props.activity,
	        message = this.getMessage(activity),
	        action = this.getAction(activity),
	        preview = this.getPreview(activity),
	        avatar = this.getAvatar(activity),
	        icon = this.getIcon(activity),
	        time;

	    time = _react2['default'].createElement(_organismsTimeAgo2['default'], { className: 'Activity-time',
	      date: activity.created });

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'Activity-avatar' },
	        avatar,
	        icon
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'Activity-message' },
	        message,
	        action,
	        time
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'Activity-thumbnail utils--hideOnMobile' },
	        preview
	      )
	    );
	  },

	  handleExpandClick: function handleExpandClick() {
	    if (!this.isExpandable()) {
	      return;
	    }

	    _actionsActivityActionCreators2['default'].expandActivity(this.props.activity.id);
	  }
	});

	exports['default'] = Activity;
	module.exports = exports['default'];

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    Link = __webpack_require__(21),
	    ServiceTypes = __webpack_require__(35),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(932);

	var ContactImporter = React.createClass({
	  displayName: 'ContactImporter',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    services: React.PropTypes.array.isRequired,
	    connectedServices: React.PropTypes.array.isRequired,
	    onConnectClick: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    var services = _.map(this.props.services, this.renderService);

	    return React.createElement(
	      'div',
	      { className: 'ContactImporter' },
	      React.createElement(
	        'ul',
	        { className: 'MetaList MetaList--inline MetaList--separated' },
	        services
	      )
	    );
	  },

	  getServiceName: function getServiceName(serviceType) {
	    switch (serviceType) {
	      case ServiceTypes.GOOGLE:
	        return 'Gmail';
	      case ServiceTypes.FACEBOOK:
	        return 'Facebook';
	    }
	  },

	  renderService: function renderService(serviceType) {
	    var isConnected = this.props.connectedServices.indexOf(serviceType) !== -1,
	        classes = ['ContactImporter-' + serviceType.toLowerCase(), 'MetaList-item'],
	        name = this.getServiceName(serviceType);

	    if (isConnected) {
	      classes.push('ContactImporter-' + serviceType.toLowerCase() + '--connected');
	    }

	    return React.createElement(
	      'li',
	      { className: classes.join(' '), key: serviceType },
	      isConnected && React.createElement(
	        'span',
	        null,
	        React.createElement(
	          'b',
	          null,
	          name
	        ),
	        ' ',
	        '(Connected)'
	      ),
	      !isConnected && React.createElement(
	        'span',
	        null,
	        React.createElement(
	          'b',
	          null,
	          name
	        ),
	        ' ',
	        '(',
	        React.createElement(
	          Link,
	          { onClick: this.handleConnectClick.bind(this, serviceType),
	            color: 'green',
	            bold: true },
	          'Connect'
	        ),
	        ')'
	      )
	    );
	  },

	  handleConnectClick: function handleConnectClick(serviceType) {
	    this.props.onConnectClick(serviceType);
	  }
	});

	module.exports = ContactImporter;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var Dot = __webpack_require__(582);var PropTypes = React.PropTypes;

	__webpack_require__(934);

	var Dots = React.createClass({
	  displayName: 'Dots',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    activeIndex: PropTypes.number.isRequired,
	    requestActiveIndexChange: PropTypes.func.isRequired,
	    count: PropTypes.number.isRequired,
	    style: PropTypes.object
	  },

	  render: function render() {
	    var _props = this.props;
	    var count = _props.count;
	    var activeIndex = _props.activeIndex;
	    var style = _props.style;
	    var dots = [];

	    for (var i = 0; i < count; i++) {
	      dots.push(React.createElement(Dot, { key: i,
	        active: i === activeIndex,
	        onClick: this.handleDotClick.bind(this, i) }));
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style },
	      dots
	    );
	  },

	  handleDotClick: function handleDotClick(index) {
	    this.props.requestActiveIndexChange(index);
	  }
	});

	module.exports = Dots;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    createStoreMixin = __webpack_require__(8),
	    StampDraftStore = __webpack_require__(64),
	    UserStore = __webpack_require__(5),
	    ScreenSizeMixin = __webpack_require__(71),
	    MetaList = __webpack_require__(266),
	    UserInfo = __webpack_require__(132),
	    shallowEqual = __webpack_require__(46),
	    formatDate = __webpack_require__(135),
	    PureRenderMixin = __webpack_require__(2);

	var DraftPreviewNavHeader = React.createClass({
	  displayName: 'DraftPreviewNavHeader',

	  mixins: [createStoreMixin(StampDraftStore, UserStore), ScreenSizeMixin, PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    var draft = StampDraftStore.getDraftStamp();
	    var user = undefined;

	    if (draft) {
	      user = UserStore.get(draft.user);
	    }

	    return { draft: draft, user: user };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var draft = _state.draft;
	    var user = _state.user;
	    var isMobile = _state.isMobile;

	    if (!draft || !user) {
	      return null;
	    }

	    var published = draft.published ? new Date(draft.published) : new Date();

	    return React.createElement(
	      MetaList,
	      { context: 'NavBar',
	        inline: !isMobile,
	        separated: !isMobile },
	      React.createElement(
	        UserInfo,
	        { user: user,
	          context: 'NavBar',
	          imageSize: 'small',
	          size: 'xsmall' },
	        React.createElement(
	          'span',
	          null,
	          ' on ',
	          formatDate(published)
	        )
	      )
	    );
	  }
	});

	module.exports = DraftPreviewNavHeader;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);

	var TabBar = __webpack_require__(171),
	    TabRouterLink = __webpack_require__(395),
	    PureRenderMixin = __webpack_require__(2);

	var HomeNavHeader = React.createClass({
	  displayName: 'HomeNavHeader',

	  mixins: [PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      TabBar,
	      { context: 'NavBar' },
	      React.createElement(
	        TabRouterLink,
	        { to: 'feed' },
	        'My Feed'
	      ),
	      React.createElement(
	        TabRouterLink,
	        { to: 'zines' },
	        'Collections'
	      )
	    );
	  }
	});

	module.exports = HomeNavHeader;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var UserInfo = __webpack_require__(132);
	var UserLink = __webpack_require__(69);
	var createStoreMixin = __webpack_require__(8);
	var UserStore = __webpack_require__(5);
	var PropTypes = React.PropTypes;
	var formatDate = __webpack_require__(135);

	__webpack_require__(938);

	var Message = React.createClass({
	  displayName: 'Message',

	  mixins: [PureRenderMixin, createStoreMixin(UserStore)],

	  propTypes: {
	    message: PropTypes.object.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      sender: UserStore.get(props.message.sender)
	    };
	  },

	  render: function render() {
	    var message = this.props.message;

	    return React.createElement(
	      'div',
	      { className: 'Message' },
	      React.createElement(UserInfo, { user: this.state.sender, noName: true }),
	      React.createElement(
	        'div',
	        { className: 'Message-content' },
	        React.createElement(UserLink, { user: this.state.sender }),
	        React.createElement(
	          'div',
	          { className: 'Message-text' },
	          message.message
	        ),
	        React.createElement(
	          'div',
	          { className: 'Message-date' },
	          formatDate(message.created)
	        )
	      )
	    );
	  }
	});

	module.exports = Message;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var UserStore = __webpack_require__(5);
	var EmailFlags = __webpack_require__(201);
	var PureRenderMixin = __webpack_require__(2);
	var Button = __webpack_require__(13);
	var UserActionCreators = __webpack_require__(47);
	var _require = __webpack_require__(1);

	var PropTypes = _require.PropTypes;
	var _require2 = __webpack_require__(4);

	var values = _require2.values;

	__webpack_require__(940);

	var NotificationSwitchRow = React.createClass({
	  displayName: 'NotificationSwitchRow',

	  mixins: [createStoreMixin(UserStore), PureRenderMixin],

	  propTypes: {
	    flag: PropTypes.oneOf(values(EmailFlags)).isRequired,
	    label: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      enabled: UserStore.isEmailNotificationEnabled(props.flag)
	    };
	  },

	  render: function render() {
	    var label = this.props.label;var enabled = this.state.enabled;

	    return React.createElement(
	      'div',
	      { className: 'NotificationSwitchRow' },
	      React.createElement(
	        'span',
	        { className: 'NotificationSwitchRow-label' },
	        label
	      ),
	      React.createElement(Button, { onClick: this.handleToggleClick,
	        active: enabled,
	        'switch': true })
	    );
	  },

	  handleToggleClick: function handleToggleClick() {
	    var flag = this.props.flag;var enabled = this.state.enabled;

	    if (enabled) {
	      UserActionCreators.disableEmailNotification(flag);
	    } else {
	      UserActionCreators.enableEmailNotification(flag);
	    }
	  }
	});

	module.exports = NotificationSwitchRow;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    Button = __webpack_require__(13),
	    Icon = __webpack_require__(10),
	    Counter = __webpack_require__(165),
	    UserImage = __webpack_require__(143),
	    PureRenderMixin = __webpack_require__(2),
	    SidebarActionCreators = __webpack_require__(29),
	    SidebarTypes = __webpack_require__(39),
	    PropTypes = React.PropTypes;

	var PendingZineButton = React.createClass({
	  displayName: 'PendingZineButton',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    size: PropTypes.oneOf(['medium', 'large']).isRequired,
	    zine: PropTypes.object.isRequired,
	    pendingStampUsers: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium'
	    };
	  },

	  render: function render() {
	    var zine = this.props.zine;

	    return React.createElement(
	      Button,
	      { size: this.props.size,
	        color: 'red',
	        onClick: this.handleClick,
	        className: 'Btn--pending',
	        context: 'PageControls',
	        fill: true },
	      React.createElement(Icon, { name: 'notification',
	        mode: 'stroke' }),
	      React.createElement(Counter, { count: zine.pendingCount,
	        context: 'PendingZineButton' }),
	      this.renderPendingUsers()
	    );
	  },

	  renderPendingUsers: function renderPendingUsers() {
	    return _.take(this.props.pendingStampUsers, 3).map(function (user) {
	      return React.createElement(UserImage, { user: user,
	        size: 'xsmall',
	        context: 'PageControls',
	        hideOnMobile: true });
	    });
	  },

	  handleClick: function handleClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.ZINE_PENDING_STAMPS, {
	      zineSlug: this.props.zine.slug
	    });
	  }
	});

	module.exports = PendingZineButton;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PinIt = __webpack_require__(585);
	var getThumbnailUrl = __webpack_require__(37);
	var ShareActionCreators = __webpack_require__(91);
	var PureRenderMixin = __webpack_require__(2);
	var ServiceTypes = __webpack_require__(35);
	var AnalyticsSources = __webpack_require__(34);var PropTypes = React.PropTypes;

	__webpack_require__(942);

	var PinterestImage = React.createClass({
	  displayName: 'PinterestImage',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    image: PropTypes.object.isRequired
	  },

	  render: function render() {
	    var thumbnailUrl = getThumbnailUrl(this.props.image, {
	      width: 256,
	      height: 256,
	      mode: 'preview'
	    });

	    return React.createElement(
	      'a',
	      { className: 'PinterestImage',
	        onClick: this.handleImageClick },
	      React.createElement('img', { src: thumbnailUrl }),
	      React.createElement(
	        'div',
	        { className: 'PinterestImage-button' },
	        React.createElement(PinIt, null)
	      )
	    );
	  },

	  handleImageClick: function handleImageClick() {
	    ShareActionCreators.shareStamp({
	      stampId: this.props.stampId,
	      service: ServiceTypes.PINTEREST,
	      imageUrl: this.props.image.url,
	      source: AnalyticsSources.PINTEREST_PICKER
	    });
	  }
	});

	module.exports = PinterestImage;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Rotator = __webpack_require__(205);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var SearchNavHeader = React.createClass({
	  displayName: 'SearchNavHeader',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    scrolledPastZines: PropTypes.bool.isRequired,
	    scrolledPastUsers: PropTypes.bool.isRequired,
	    scrolledPastStamps: PropTypes.bool.isRequired
	  },

	  render: function render() {
	    var activeIndex;
	    if (this.props.scrolledPastStamps) {
	      activeIndex = 3;
	    } else if (this.props.scrolledPastUsers) {
	      activeIndex = 2;
	    } else if (this.props.scrolledPastZines) {
	      activeIndex = 1;
	    } else {
	      activeIndex = 0;
	    }

	    return React.createElement(
	      Rotator,
	      { activeIndex: activeIndex },
	      React.createElement('span', null),
	      React.createElement(
	        'span',
	        null,
	        'Matching Collections'
	      ),
	      React.createElement(
	        'span',
	        null,
	        'Matching Users'
	      ),
	      React.createElement(
	        'span',
	        null,
	        'Matching Stamps'
	      )
	    );
	  }
	});

	module.exports = SearchNavHeader;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    createStoreMixin = __webpack_require__(8),
	    ServiceAccountStore = __webpack_require__(176),
	    UserStore = __webpack_require__(5),
	    Button = __webpack_require__(13),
	    Link = __webpack_require__(21),
	    UserActionCreators = __webpack_require__(47),
	    FormLink = __webpack_require__(148),
	    getServiceName = __webpack_require__(441),
	    getServiceAccountUrl = __webpack_require__(440),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(944);

	var ServiceAccountRow = React.createClass({
	  displayName: 'ServiceAccountRow',

	  mixins: [createStoreMixin(ServiceAccountStore), PureRenderMixin],

	  propTypes: {
	    serviceType: React.PropTypes.string.isRequired,
	    allowDisconnect: React.PropTypes.bool.isRequired,
	    formLink: React.PropTypes.instanceOf(FormLink).isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      serviceAccount: ServiceAccountStore.getByType(UserStore.getMe().id, this.props.serviceType)
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'ServiceAccountRow' },
	      React.createElement(
	        'div',
	        { className: 'ServiceAccountRow-label' },
	        getServiceName(this.props.serviceType)
	      ),
	      ServiceAccountStore.isConnected(UserStore.getMe().id, this.props.serviceType) ? this.renderConnectedRow() : this.renderDisconnectedRow()
	    );
	  },

	  renderConnectedRow: function renderConnectedRow() {
	    var serviceAccount = this.state.serviceAccount,
	        hidden = serviceAccount && serviceAccount.hidden,
	        externalName = serviceAccount && serviceAccount.externalName,
	        externalLink = serviceAccount && getServiceAccountUrl(serviceAccount);

	    return React.createElement(
	      'div',
	      { className: 'ServiceAccountRow-body' },
	      this.props.allowDisconnect && React.createElement(
	        Link,
	        { className: 'utils--floatRight',
	          color: 'gray',
	          onClick: this.handleDisconnectClick },
	        'Disconnect'
	      ),
	      React.createElement(
	        Link,
	        { className: 'ServiceAccountRow-name',
	          target: '_blank',
	          href: externalLink,
	          bold: true },
	        externalName
	      ),
	      React.createElement(
	        'div',
	        { className: 'ServiceAccountRow-toggle' },
	        React.createElement(Button, { onClick: this.handleShowClick,
	          active: !hidden,
	          'switch': true }),
	        React.createElement(
	          'span',
	          { className: 'ServiceAccountRow-toggleLabel' },
	          hidden ? 'Don’t show in profile' : 'Show in profile'
	        )
	      )
	    );
	  },

	  renderDisconnectedRow: function renderDisconnectedRow() {
	    var errorMessage = this.props.formLink.fieldMessage;

	    return React.createElement(
	      'div',
	      { className: 'ServiceAccountRow-body' },
	      React.createElement(
	        Link,
	        { onClick: this.handleConnectClick,
	          color: 'green',
	          bold: true },
	        'Connect'
	      ),
	      errorMessage && React.createElement(
	        'div',
	        { className: 'ServiceAccountRow-error' },
	        errorMessage
	      )
	    );
	  },

	  handleShowClick: function handleShowClick() {
	    var hidden = this.state.serviceAccount.hidden;
	    UserActionCreators.toggleServiceAccountHidden(this.props.serviceType, !hidden);
	  },

	  handleConnectClick: function handleConnectClick() {
	    UserActionCreators.connectServiceAccount(this.props.serviceType);
	  },

	  handleDisconnectClick: function handleDisconnectClick() {
	    UserActionCreators.disconnectServiceAccount(this.props.serviceType);
	  }
	});

	module.exports = ServiceAccountRow;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(946);

	var SidebarHeader = React.createClass({
	  displayName: 'SidebarHeader',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    title: PropTypes.node.isRequired,
	    subtitle: PropTypes.node
	  },

	  className: 'SidebarHeader',

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'SidebarHeader-title' },
	        this.props.title
	      ),
	      this.props.subtitle && React.createElement(
	        'div',
	        { className: 'SidebarHeader-subtitle' },
	        this.props.subtitle
	      )
	    );
	  }
	});

	module.exports = SidebarHeader;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _mixinsScreenSizeMixin = __webpack_require__(71);

	var _mixinsScreenSizeMixin2 = _interopRequireDefault(_mixinsScreenSizeMixin);

	var _moleculesMetaList = __webpack_require__(266);

	var _moleculesMetaList2 = _interopRequireDefault(_moleculesMetaList);

	var _organismsUserInfo = __webpack_require__(132);

	var _organismsUserInfo2 = _interopRequireDefault(_organismsUserInfo);

	var _organismsZineInfo = __webpack_require__(729);

	var _organismsZineInfo2 = _interopRequireDefault(_organismsZineInfo);

	var _reactLibShallowEqual = __webpack_require__(46);

	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);

	var _utilsFormatDate = __webpack_require__(135);

	var _utilsFormatDate2 = _interopRequireDefault(_utilsFormatDate);

	var _moleculesRotator = __webpack_require__(205);

	var _moleculesRotator2 = _interopRequireDefault(_moleculesRotator);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	var StampNavHeader = _react2['default'].createClass({
	  displayName: 'StampNavHeader',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default'], _storesUserStore2['default'], _storesZineStore2['default']), _mixinsScreenSizeMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired,
	    primaryZineSlug: _react.PropTypes.string,
	    scrolledPastNextUp: _react.PropTypes.bool.isRequired,
	    nextUpTitle: _react.PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = _storesStampStore2['default'].get(props.stampId),
	        primaryZine,
	        user;

	    if (stamp) {
	      user = _storesUserStore2['default'].get(stamp.user);
	    }

	    if (props.primaryZineSlug) {
	      primaryZine = _storesZineStore2['default'].get(props.primaryZineSlug);
	    }

	    return {
	      stamp: stamp,
	      primaryZine: primaryZine,
	      user: user
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!(0, _reactLibShallowEqual2['default'])(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    if (!this.state.stamp || !this.state.user) {
	      return null;
	    }

	    return _react2['default'].createElement(
	      _moleculesRotator2['default'],
	      { activeIndex: this.props.scrolledPastNextUp ? 1 : 0 },
	      this.renderStampInfo(),
	      this.renderNextUpTitle()
	    );
	  },

	  renderNextUpTitle: function renderNextUpTitle() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.props.nextUpTitle
	    );
	  },

	  renderStampInfo: function renderStampInfo() {
	    var _state = this.state;
	    var isMobile = _state.isMobile;
	    var stamp = _state.stamp;
	    var primaryZine = _state.primaryZine;
	    var user = _state.user;

	    var published = new Date(stamp.published);
	    var isUnlisted = stamp.status === _constantsStampStatus2['default'].UNLISTED;

	    return _react2['default'].createElement(
	      _moleculesMetaList2['default'],
	      { context: 'NavBar',
	        inline: !isMobile,
	        separated: !isMobile },
	      this.state.primaryZine && !isMobile && _react2['default'].createElement(_organismsZineInfo2['default'], { zine: primaryZine,
	        context: 'NavBar',
	        imageSize: 'small',
	        size: 'small' }),
	      _react2['default'].createElement(
	        _organismsUserInfo2['default'],
	        { user: user,
	          context: 'NavBar',
	          imageSize: 'small',
	          size: 'xsmall' },
	        _react2['default'].createElement(
	          'span',
	          null,
	          ' on ',
	          (0, _utilsFormatDate2['default'])(published),
	          isUnlisted && _react2['default'].createElement(
	            'span',
	            { title: 'This Stamp is only visible to those with the direct link to it.' },
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	              mode: 'fill',
	              size: isMobile ? 'xsmall' : 'small',
	              margin: 'left' })
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = StampNavHeader;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	var StampRichThumbnail = _react2['default'].createClass({
	  displayName: 'StampRichThumbnail',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    counts: _react.PropTypes.object.isRequired,
	    iconSize: _react.PropTypes.oneOf(['xxsmall', 'xsmall']).isRequired
	  },

	  render: function render() {
	    var counts = this.props.counts;

	    return _react2['default'].createElement(
	      'ul',
	      { className: 'StampItem-contents' },
	      counts.audios > 0 && _react2['default'].createElement(
	        'li',
	        { className: 'StampItem-contentItem StampItem-contentItem--audio' },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'audio',
	          size: this.props.iconSize,
	          mode: 'stroke' })
	      ),
	      counts.videos > 0 && _react2['default'].createElement(
	        'li',
	        { className: 'StampItem-contentItem StampItem-contentItem--video' },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'video',
	          size: this.props.iconSize,
	          mode: 'stroke' })
	      )
	    );
	  }
	});

	exports['default'] = StampRichThumbnail;
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _mixinsCreateFlexibleImageQueueMixin = __webpack_require__(96);

	var _mixinsCreateFlexibleImageQueueMixin2 = _interopRequireDefault(_mixinsCreateFlexibleImageQueueMixin);

	var _mixinsViewportTestMixin = __webpack_require__(168);

	var _mixinsViewportTestMixin2 = _interopRequireDefault(_mixinsViewportTestMixin);

	var _constantsColors = __webpack_require__(397);

	var _constantsColors2 = _interopRequireDefault(_constantsColors);

	var _utilsGradient = __webpack_require__(123);

	var _utilsGradient2 = _interopRequireDefault(_utilsGradient);

	'use strict';

	var StampThumbnail = _react2['default'].createClass({
	  displayName: 'StampThumbnail',

	  mixins: [(0, _mixinsCreateFlexibleImageQueueMixin2['default'])(60), _mixinsPureRenderMixin2['default'], _mixinsViewportTestMixin2['default']],

	  propTypes: {
	    thumbnail: _react.PropTypes.object,
	    allowEmpty: _react.PropTypes.bool
	  },

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: this.props.thumbnail,
	      allowEmpty: this.props.allowEmpty,
	      mode: 'scale_crop',
	      sizes: {
	        normal: true,
	        retina: devicePixelRatio > 1.5 && this.state.isInViewport
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.thumbnail !== this.props.thumbnail || prevState.isInViewport !== this.state.isInViewport) {

	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var thumbnail = this.props.thumbnail;
	    var style = {};

	    if (!thumbnail) {
	      style.backgroundColor = _constantsColors2['default'].GRAY_MID;
	    } else if (!this.hasLoadedImage()) {
	      style.backgroundImage = (0, _utilsGradient2['default'])('#' + thumbnail.colors.top, '#' + thumbnail.colors.bottom);
	    } else {
	      style.backgroundImage = this.getBackgroundImageUrl();
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: 'StampItem-preview' },
	      this.renderLoaderImg(),
	      _react2['default'].createElement(
	        'div',
	        { className: 'StampItem-coverImage',
	          style: style },
	        this.props.children
	      )
	    );
	  }
	});

	exports['default'] = StampThumbnail;
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    React = __webpack_require__(1),
	    update = __webpack_require__(49),
	    Tag = __webpack_require__(589),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(948);

	var TagInput = React.createClass({
	  displayName: 'TagInput',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    value: React.PropTypes.object.isRequired,
	    onChange: React.PropTypes.func.isRequired,
	    placeholder: React.PropTypes.string
	  },

	  focus: function focus() {
	    this.refs.input.getDOMNode().focus();
	  },

	  render: function render() {
	    var tags = this.props.value.tags,
	        text = this.props.value.text;

	    return React.createElement(
	      'div',
	      { className: 'TagInput' },
	      tags.length > 0 ? _.map(tags, this.renderTag) : React.createElement('input', { ref: 'input',
	        className: this.props.className,
	        readOnly: this.props.readOnly,
	        placeholder: this.props.placeholder,
	        value: text,
	        onChange: this.handleChange,
	        onFocus: this.props.onFocus,
	        onBlur: this.props.onBlur,
	        onKeyUp: this.props.onKeyUp })
	    );
	  },

	  renderTag: function renderTag(tag, index) {
	    return React.createElement(Tag, { key: index,
	      content: tag.content,
	      icon: tag.icon,
	      onRemove: this.handleRemoveTag.bind(this, index) });
	  },

	  handleChange: function handleChange(e) {
	    this.requestChange({
	      text: {
	        $set: e.target.value
	      }
	    });
	  },

	  handleRemoveTag: function handleRemoveTag(index) {
	    this.requestChange({
	      tags: {
	        $splice: [[index, 1]]
	      }
	    });
	  },

	  requestChange: function requestChange(valueUpdate) {
	    this.props.onChange(update(this.props.value, valueUpdate));
	  }
	});

	module.exports = TagInput;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var UserStore = __webpack_require__(5);
	var Rotator = __webpack_require__(205);
	var shallowEqual = __webpack_require__(46);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var UserNavHeader = React.createClass({
	  displayName: 'UserNavHeader',

	  mixins: [createStoreMixin(UserStore), PureRenderMixin],

	  propTypes: {
	    userId: PropTypes.number.isRequired,
	    scrolledPastPublished: PropTypes.bool.isRequired,
	    scrolledPastCurated: PropTypes.bool.isRequired,
	    scrolledPastLiked: PropTypes.bool.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var user = UserStore.get(props.userId);

	    return {
	      user: user
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    if (!this.state.user) {
	      return null;
	    }

	    var activeIndex;
	    if (this.props.scrolledPastLiked) {
	      activeIndex = 3;
	    } else if (this.props.scrolledPastCurated) {
	      activeIndex = 2;
	    } else if (this.props.scrolledPastPublished) {
	      activeIndex = 1;
	    } else {
	      activeIndex = 0;
	    }

	    return React.createElement(
	      Rotator,
	      { activeIndex: activeIndex },
	      React.createElement('span', null),
	      React.createElement(
	        'span',
	        null,
	        'Published Stamps'
	      ),
	      React.createElement(
	        'span',
	        null,
	        'Curated Collections'
	      ),
	      React.createElement(
	        'span',
	        null,
	        'Liked Stamps'
	      )
	    );
	  }
	});

	module.exports = UserNavHeader;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesZineDraftStore = __webpack_require__(215);

	var _storesZineDraftStore2 = _interopRequireDefault(_storesZineDraftStore);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	var _reactLibShallowEqual = __webpack_require__(46);

	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);

	var _mixinsScreenSizeMixin = __webpack_require__(71);

	var _mixinsScreenSizeMixin2 = _interopRequireDefault(_mixinsScreenSizeMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	var ZineNavHeader = _react2['default'].createClass({
	  displayName: 'ZineNavHeader',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesUserStore2['default'], _storesZineStore2['default'], _storesZineDraftStore2['default']), _mixinsScreenSizeMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    zineSlug: _react.PropTypes.string,
	    isEditing: _react.PropTypes.bool.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var zine = props.isEditing ? _storesZineDraftStore2['default'].getActiveDraft() : _storesZineStore2['default'].get(props.zineSlug);

	    var curator = undefined;
	    if (zine) {
	      curator = _storesUserStore2['default'].get(zine.curator);
	    }

	    return { zine: zine, curator: curator };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!(0, _reactLibShallowEqual2['default'])(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var isMobile = _state.isMobile;
	    var zine = _state.zine;
	    var curator = _state.curator;

	    if (!zine || !curator) {
	      return null;
	    }

	    var isUnlisted = zine.status === _constantsZineStatus2['default'].UNLISTED;
	    return _react2['default'].createElement(
	      'span',
	      null,
	      'Collection curated by ',
	      _react2['default'].createElement(_atomsUserLink2['default'], { user: curator, bold: true }),
	      isUnlisted && _react2['default'].createElement(
	        'span',
	        { title: 'This Collection is only visible to those with the direct link to it.' },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	          mode: 'fill',
	          size: isMobile ? 'xsmall' : 'small',
	          margin: 'left' })
	      )
	    );
	  }
	});

	exports['default'] = ZineNavHeader;
	module.exports = exports['default'];

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesTabBar = __webpack_require__(171);

	var _moleculesTabBar2 = _interopRequireDefault(_moleculesTabBar);

	var _atomsTabRouterLink = __webpack_require__(395);

	var _atomsTabRouterLink2 = _interopRequireDefault(_atomsTabRouterLink);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _storesZineSectionsStore = __webpack_require__(293);

	var _storesZineSectionsStore2 = _interopRequireDefault(_storesZineSectionsStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _Rotator = __webpack_require__(205);

	var _Rotator2 = _interopRequireDefault(_Rotator);

	var _lodashArrayFindIndex = __webpack_require__(994);

	var _lodashArrayFindIndex2 = _interopRequireDefault(_lodashArrayFindIndex);

	'use strict';

	var ZinesNavHeader = _react2['default'].createClass({
	  displayName: 'ZinesNavHeader',

	  mixins: [_mixinsPureRenderMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesZineSectionsStore2['default'])],

	  propTypes: {
	    scrolledSectionId: _react.PropTypes.number,
	    scrolled: _react.PropTypes.bool.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      sections: _storesZineSectionsStore2['default'].getSections()
	    };
	  },

	  render: function render() {
	    var sections = this.state.sections;
	    var _props = this.props;
	    var scrolled = _props.scrolled;
	    var scrolledSectionId = _props.scrolledSectionId;

	    var activeIndex = (0, _lodashArrayFindIndex2['default'])(sections, function (section) {
	      return section.id === scrolledSectionId;
	    });

	    if (!scrolled) {
	      return _react2['default'].createElement(
	        _moleculesTabBar2['default'],
	        { context: 'NavBar' },
	        _react2['default'].createElement(
	          _atomsTabRouterLink2['default'],
	          { to: 'feed' },
	          'My Feed'
	        ),
	        _react2['default'].createElement(
	          _atomsTabRouterLink2['default'],
	          { to: 'zines' },
	          'Collections'
	        )
	      );
	    }

	    return _react2['default'].createElement(
	      _Rotator2['default'],
	      { activeIndex: activeIndex },
	      sections.map(function (section) {
	        return _react2['default'].createElement(
	          'span',
	          { key: 'rotator-' + section.id },
	          section.name
	        );
	      })
	    );
	  }
	});

	exports['default'] = ZinesNavHeader;
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AboutSection = __webpack_require__(172);
	var Icon = __webpack_require__(10);
	var getThumbnailUrl = __webpack_require__(37);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var AboutSectionGrid = __webpack_require__(416);var PropTypes = React.PropTypes;

	var userpic = '//stampsy-eu-1.s3.amazonaws.com/uploads/production/24/06/2014/user/7/ef79a1ca-d39f-4708-93d1-0031838c02d4.jpg';
	var stampPreviews = ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f78ebc30-2c58-47aa-8a67-b482829e07c3.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/649da9dc-159b-4261-97c9-6110c6e8ffff.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/11e65697-130d-477a-aa90-36652e9e9b7d.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/58a2b34f-eae7-45ef-8844-d445ede7e64d.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/63641ee8-2727-44d0-9a7a-87005719195e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/2d09ccd3-7f03-4140-a200-f52baf5ac5c1.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/fc17923c-24dd-45e5-95d0-53467ae61d80.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/67bcfc4b-b2e5-48cd-ac7b-1c45c51fdc81.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/83e8a3b5-59c9-4cba-b7d3-f78adde05d28.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/630e78cd-7a45-47ab-b6c3-915e46586035.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/e78dce38-5a1b-4bbc-aef7-3cb045dccfb8.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9dc562ce-2d9a-47d1-aabf-69b25ad5de1a.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bb9ca7c4-565c-48f6-9cc5-8220785dfe0e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5d3a8577-ca6c-4c9b-8af6-994016f1b28e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/551572c2-cb83-4216-bb6f-c6266ed6dda0.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5a1f7319-7521-47e7-a792-41b29629efa9.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8cb29bd2-d759-4e7a-8f6d-84c6a688f7b5.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c4b30059-be35-4ea2-9d29-afd90479e8b6.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/72f4d28b-36d8-4ee9-8999-dcfba37a6137.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/daf9fc2d-21f3-4457-9818-17b937161865.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/37018538-adff-4aa2-b7d2-6145804f3db9.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/557c15db-1fa4-4f24-9b26-b5513da0d0ff.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/eb281f73-d609-4e47-9342-7de3b4083dab.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a9095a72-3900-4103-a4ca-38a367bfcd8e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f87fb207-efbc-4ea0-9e07-7d78ba131a44.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/4519a07d-e9fa-44f6-863e-a6be63bed68e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/dda8d3b7-87e4-4470-a1f0-0997b6a51148.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/1c9daac4-2f94-4b60-8dec-4167d78520e1.jpg'];

	__webpack_require__(951);

	var AboutFeedSection = React.createClass({
	  displayName: 'AboutFeedSection',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    layout: PropTypes.any.isRequired,
	    active: PropTypes.bool.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      inactive: !this.props.active
	    };
	  },

	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var layout = _props.layout;

	    return React.createElement(
	      AboutSection,
	      { layout: layout,
	        active: active,
	        title: 'Enjoy your personal magazine, filled with the things you care about.',
	        subtitle: 'Once you follow a collection, all of its stamps show up in your feed. Follow cool collections and discover extraordinary publications from the world’s top creators or stories from your friends.',
	        backgroundColor: '#FF5252',
	        color: 'white' },
	      React.createElement(
	        'div',
	        { className: this.getClassName() },
	        React.createElement(
	          'div',
	          { className: 'AboutFeedSection-navBar' },
	          React.createElement(
	            'div',
	            { className: 'AboutFeedSection-logo' },
	            React.createElement(Icon, { name: 'logo',
	              size: 'small' })
	          ),
	          React.createElement(
	            'div',
	            { className: 'AboutFeedSection-header' },
	            'Stampsy'
	          ),
	          React.createElement(
	            'div',
	            { className: 'AboutFeedSection-user' },
	            React.createElement(
	              'div',
	              { className: 'AboutFeedSection-notification' },
	              '1'
	            ),
	            React.createElement(
	              'div',
	              { className: 'AboutFeedSection-userpic' },
	              React.createElement('img', { src: getThumbnailUrl({ url: userpic }, {
	                  mode: 'scale_crop',
	                  width: 18 * Math.round(typeof window !== 'undefined' ? window.devicePixelRatio : 1)
	                }) })
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'AboutFeedSection-wrapper' },
	          React.createElement(AboutSectionGrid, { imageSize: { width: 132 },
	            imageUrls: stampPreviews,
	            active: active,
	            type: 'feed' })
	        )
	      )
	    );
	  }
	});

	module.exports = AboutFeedSection;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var config = __webpack_require__(66);
	var UserStore = __webpack_require__(5);
	var AnalyticsSources = __webpack_require__(34);
	var AboutSection = __webpack_require__(172);
	var ShortSignUp = __webpack_require__(268);
	var ShortLogin = __webpack_require__(267);
	var Link = __webpack_require__(21);
	var PureRenderMixin = __webpack_require__(2);
	var getThumbnailUrl = __webpack_require__(37);
	var ClassNameMixin = __webpack_require__(3);
	var cx = __webpack_require__(163);var PropTypes = React.PropTypes;

	__webpack_require__(955);

	var DELAY = 7000;
	var tweets = [{
	  text: 'Future platform for all visual minds! Key differences from @tumblr and @wordpressdotcom make their mark. #stampsy @hellostampsy',
	  sourceUrl: '//twitter.com/artshaman/status/565493279509467138',
	  user: {
	    name: 'Matthew Stone',
	    profileUrl: '//twitter.com/artshaman',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/23/2015/8fcd23a0-eecb-49d1-98c8-8f7372eb99a3.jpg'
	  }
	}, {
	  text: 'I love how @HelloStampsy makes my photos look better than they actually are. It became my website to show my work to potential clients.',
	  sourceUrl: '//twitter.com/LauraZalenga/status/565776531658924032',
	  user: {
	    name: 'Laura Zalenga',
	    profileUrl: '//stampsy.com/user/13910',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/production/25/06/2014/user/13910/f80b9d12-ba1f-4381-9609-a3462e0bac9b.jpg'
	  }
	}, {
	  text: 'stampsy.com  (@HelloStampsy) is a great tool for visual stories. Give it a try! It\'s a good way to fill your daily inspiration.',
	  sourceUrl: '//twitter.com/Guitouxx/status/565619914770485249',
	  user: {
	    name: 'Guillaume Tomasi',
	    profileUrl: '//stampsy.com/user/17933',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/08/28/2014/user/17933/3cccdb7b-4a0e-4a89-be41-ccf4c1c6887d.png'
	  }
	}, {
	  text: 'If you haven\'t heard of @HelloStampsy yet check it out! Lovely full screen interface, see my portfolio here https://stampsy.com/user/17816',
	  sourceUrl: '//twitter.com/tim_bowditch/status/565774606615580672',
	  user: {
	    name: 'Tim Bowditch',
	    profileUrl: '//stampsy.com/user/17816',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/09/02/2014/user/17816/d2bc4948-2c1d-4c41-9d6c-da168e0e480a.jpg'
	  }
	}, {
	  text: 'It\'s about time: a site for #photography with #stories behind. Clever in its great yet simple design: https://stampsy.com/about @HelloStampsy',
	  sourceUrl: '//twitter.com/GBenard/status/565628470156603392',
	  user: {
	    name: 'Gonzalo W. Bénard',
	    profileUrl: '//stampsy.com/user/16102',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/production/28/11/2014/user/16102/scale_crop/512x512/91f0801f-bdd7-4fd6-8c4a-c8a3cef33316.jpg'
	  }
	}, {
	  text: 'Discover @HelloStampsy Great #photography #platform Huge visibility and many contributors from all around the world! https://stampsy.com/',
	  sourceUrl: '//twitter.com/giangallucci/status/565630498085806080',
	  user: {
	    name: 'Gianfranco Gallucci',
	    profileUrl: '//stampsy.com/user/16873',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/07/21/2014/user/16873/7cae50fe-82d7-4973-931f-ed270125485e.jpg'
	  }
	}, {
	  text: 'I\'ve been keeping my eye on @HelloStampsy for a while. Quality photo presentations. They\'ve updated, great new look. https://stampsy.com',
	  sourceUrl: '//twitter.com/MOSSLESS/status/568409756831911936',
	  user: {
	    name: 'Romke Hoogwaerts',
	    profileUrl: '//stampsy.com/user/10169',
	    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/23/2015/d05498a6-466d-4517-bcb1-59f39a453f6c.png'
	  }
	}];

	var AboutSocialProofSection = React.createClass({
	  displayName: 'AboutSocialProofSection',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    layout: PropTypes.any.isRequired,
	    active: PropTypes.bool.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      visibleTweetIndex: 0
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.interval = setInterval(this.switchTweet, DELAY);
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.active && !this.props.active) {
	      clearInterval(this.interval);
	      this.interval = setInterval(this.switchTweet, DELAY);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    clearInterval(this.interval);
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      inactive: !this.props.active
	    };
	  },

	  render: function render() {
	    var isAuthenticated = UserStore.isAuthenticated();

	    return React.createElement(
	      AboutSection,
	      { layout: this.props.layout,
	        active: this.props.active,
	        title: 'Connect with the evergrowing Stampsy Community!',
	        backgroundColor: '#38c591',
	        color: 'white' },
	      React.createElement(
	        'div',
	        { className: this.getClassName() },
	        !isAuthenticated && React.createElement(
	          'div',
	          { className: 'AboutSocialProofSection-signUpWrapper' },
	          config.signUpEnabled ? React.createElement(ShortSignUp, { color: 'light',
	            source: AnalyticsSources.ABOUT_PAGE_WELCOME }) : React.createElement(ShortLogin, { color: 'light',
	            source: AnalyticsSources.ABOUT_PAGE_WELCOME })
	        ),
	        React.createElement(
	          'div',
	          { className: 'AboutSocialProofSection-tweets' },
	          tweets.map(this.renderTweet)
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'Footer Footer-about-page' },
	        React.createElement(
	          'ul',
	          { className: 'Footer-list' },
	          React.createElement(
	            'li',
	            { className: 'Footer-item' },
	            React.createElement(
	              Link,
	              { to: 'terms',
	                underline: 'never' },
	              'Terms of Service'
	            )
	          ),
	          React.createElement(
	            'li',
	            { className: 'Footer-item' },
	            React.createElement(
	              Link,
	              { to: 'privacy',
	                underline: 'never' },
	              'Privacy Policy'
	            )
	          ),
	          React.createElement(
	            'li',
	            { className: 'Footer-item' },
	            React.createElement(
	              Link,
	              { href: 'https://www.facebook.com/HelloStampsy',
	                target: '_blank',
	                underline: 'never' },
	              'Facebook'
	            )
	          ),
	          React.createElement(
	            'li',
	            { className: 'Footer-item' },
	            React.createElement(
	              Link,
	              { href: 'https://twitter.com/HelloStampsy',
	                target: '_blank',
	                underline: 'never' },
	              'Twitter'
	            )
	          ),
	          React.createElement(
	            'li',
	            { className: 'Footer-item' },
	            React.createElement(
	              Link,
	              { href: 'https://www.pinterest.com/HelloStampsy/',
	                target: '_blank',
	                underline: 'never' },
	              'Pinterest'
	            )
	          )
	        )
	      )
	    );
	  },

	  renderTweet: function renderTweet(tweet, index) {
	    var visibleTweetIndex = this.state.visibleTweetIndex;

	    var className = cx({
	      'AboutSocialProofSection-tweet': true,
	      'AboutSocialProofSection-tweet--hidden': index !== visibleTweetIndex
	    });
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return React.createElement(
	      'div',
	      { className: className, key: index },
	      React.createElement(
	        Link,
	        { href: tweet.sourceUrl,
	          className: 'AboutSocialProofSection-message',
	          target: '_blank',
	          underline: 'never' },
	        tweet.text
	      ),
	      React.createElement(
	        'div',
	        { className: 'AboutSocialProofSection-author' },
	        React.createElement(
	          'a',
	          { className: 'AboutSocialProofSection-authorPic',
	            href: tweet.user.profileUrl,
	            title: tweet.user.name,
	            target: '_blank' },
	          React.createElement('img', { key: tweet.user.thumbnailUrl,
	            alt: tweet.user.name,
	            src: getThumbnailUrl({ url: tweet.user.thumbnailUrl }, {
	              mode: 'scale_crop',
	              width: 44 * Math.round(devicePixelRatio)
	            }) })
	        ),
	        React.createElement(
	          Link,
	          { href: tweet.user.profileUrl,
	            title: tweet.user.name,
	            target: '_blank',
	            underline: 'never',
	            bold: true },
	          tweet.user.name
	        )
	      )
	    );
	  },

	  switchTweet: function switchTweet() {
	    this.setState({
	      visibleTweetIndex: (this.state.visibleTweetIndex + 1) % tweets.length
	    });
	  }
	});

	module.exports = AboutSocialProofSection;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AboutSection = __webpack_require__(172);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var AboutSectionCarousel = __webpack_require__(415);var PropTypes = React.PropTypes;

	var stampScreenshots = ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/8bbec3a4-4902-4a03-b186-e43a2cbe8830.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/b949b46a-9b34-4a2d-b451-179d2a876206.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/f7ec6b00-1ef3-4165-8165-cc10ef29c9e9.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/26824141-87d4-4235-b78a-675a2c439801.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/0c4a53ad-87c8-4fa9-ad93-6fe742b99e2b.jpg'];

	var AboutStampsSection = React.createClass({
	  displayName: 'AboutStampsSection',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    layout: PropTypes.any.isRequired,
	    active: PropTypes.bool.isRequired
	  },

	  statics: {
	    backgroundColor: '#FF4081'
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      inactive: !this.props.active
	    };
	  },

	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var layout = _props.layout;

	    return React.createElement(
	      AboutSection,
	      { layout: layout,
	        active: active,
	        title: 'Create beautiful photo stories, mood boards, visual essays and much more. It’s easy and free!',
	        backgroundColor: this.constructor.backgroundColor,
	        color: 'white' },
	      React.createElement(
	        'div',
	        { className: this.getClassName() },
	        React.createElement(
	          AboutSectionCarousel,
	          { type: 'stamps',
	            active: active,
	            hideScrollbars: true },
	          stampScreenshots.map(function (src, index) {
	            return React.createElement(AboutSectionCarousel.Image, { key: index,
	              faded: index !== 2,
	              imageUrl: src,
	              imageSize: { width: 330, height: 560 } });
	          })
	        )
	      )
	    );
	  }
	});

	module.exports = AboutStampsSection;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AboutSection = __webpack_require__(172);
	var TabBar = __webpack_require__(171);
	var TabLink = __webpack_require__(198);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var ScreenSizeMixin = __webpack_require__(71);
	var AboutSectionGrid = __webpack_require__(416);
	var AboutSectionCarousel = __webpack_require__(415);var PropTypes = React.PropTypes;

	var zineTabs = [{
	  title: 'Photography',
	  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/bc69ea56-c793-4302-a377-ea40dd6285a1.jpg',
	  url: '/fotografia-magazine',
	  previews: ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bb9ca7c4-565c-48f6-9cc5-8220785dfe0e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/77aae748-dacc-41b0-bef4-d3badbc99f2a.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5d3a8577-ca6c-4c9b-8af6-994016f1b28e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f7426f46-555c-4ebe-b060-59ef51cdbfd0.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/551572c2-cb83-4216-bb6f-c6266ed6dda0.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/3be32c7c-431d-4360-bee8-fcf0dccbb485.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/242c15d6-bb22-4b16-8b8f-517d365cdf78.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/6268f1e5-1fc8-4905-9542-f1ae6adcd40d.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/eb281f73-d609-4e47-9342-7de3b4083dab.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/e516ee96-a2c6-4304-939d-69f7ccbefab7.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/98658acd-6484-40c3-ad89-04e7648da196.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/4519a07d-e9fa-44f6-863e-a6be63bed68e.jpg']
	}, {
	  title: 'Art',
	  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/eecf1aeb-4830-4cb7-982c-774f0ef25c33.jpg',
	  url: '/uncollected',
	  previews: ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5a1f7319-7521-47e7-a792-41b29629efa9.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/54940b80-12cd-4108-90b7-197d1cf00d85.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8cb29bd2-d759-4e7a-8f6d-84c6a688f7b5.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/05299dbd-d442-484a-9b7e-e0e88205bf2f.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c4b30059-be35-4ea2-9d29-afd90479e8b6.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c3527dc6-d24a-49f6-8021-3c1965337691.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d59366a0-feaa-4d01-8689-201cd21c3e72.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a9095a72-3900-4103-a4ca-38a367bfcd8e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/b1542e51-7557-460b-870a-987554a11609.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9170f288-b9fd-4303-abd3-93e85507ddfa.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5831efcf-bc6e-4c66-b370-2033d5e0cd63.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f87fb207-efbc-4ea0-9e07-7d78ba131a44.jpg']
	}, {
	  title: 'Film',
	  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/5d9f99cb-63da-40b5-ac27-3bdef5b40751.jpg',
	  url: '/movie-stills',
	  previews: ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/58a2b34f-eae7-45ef-8844-d445ede7e64d.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9a7b45b2-7d2b-44cf-931a-7d842aa46765.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/63641ee8-2727-44d0-9a7a-87005719195e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/0934153a-ad90-41be-ad64-b7be778f297c.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/2d09ccd3-7f03-4140-a200-f52baf5ac5c1.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/084b2f34-509a-4de7-81e8-a4c2a90636dc.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/989c9eb4-6b0c-4e45-be61-1e0ea3e64963.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/daf9fc2d-21f3-4457-9818-17b937161865.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/26fc97d6-d28a-4d03-89dc-833b65b16398.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/96e63175-d091-49c8-a664-6d1faaec57eb.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/05fbaa96-fd62-4ef2-9e4b-bbf9930e728a.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5623a5e7-1b7c-4b02-94e3-f7d49fa0a7f6.jpg']
	}, {
	  title: 'Music',
	  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/11cd2e80-c8d6-4122-be49-266e4086e63b.jpg',
	  url: '/music-photography',
	  previews: ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f78ebc30-2c58-47aa-8a67-b482829e07c3.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8d6178f3-cb72-4694-9400-5cbfd93ecf3c.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/649da9dc-159b-4261-97c9-6110c6e8ffff.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d10b2eb2-ae20-47fe-bef0-be586ad8b2c8.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d337e766-02b8-4a4b-b84a-a1c05aa9d5fd.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/11e65697-130d-477a-aa90-36652e9e9b7d.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/72f4d28b-36d8-4ee9-8999-dcfba37a6137.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5152a814-190e-464b-96ce-121b960c9d77.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bf9e669c-b119-449b-b855-cac4e522a18e.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/41e45adb-8bb5-4da8-9aa9-f2818f1eb813.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/38fce6eb-10ed-466b-8dd0-d63cac33adad.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/57d126e4-04ef-4f55-9a94-80539580bd1c.jpg']
	}, {
	  title: 'Design',
	  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/05b84a37-85b7-4f6b-b9c3-09e0d6901ec0.jpg',
	  url: '/digital-imagery',
	  previews: ['//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/fc17923c-24dd-45e5-95d0-53467ae61d80.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a0a01621-980b-4133-9404-359ad5e27336.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/67bcfc4b-b2e5-48cd-ac7b-1c45c51fdc81.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/88991a75-a216-43d2-9690-315a98208d3c.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/83e8a3b5-59c9-4cba-b7d3-f78adde05d28.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/89cf28d8-571f-4887-a226-472e04b06feb.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/732ab831-7184-4782-8c4a-e3074c178f4b.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/37018538-adff-4aa2-b7d2-6145804f3db9.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/946147ba-2a33-4ec6-b298-173494efcd56.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/b5c4b678-025d-49f1-8d0d-f2f5ac8a0d14.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/1c9daac4-2f94-4b60-8dec-4167d78520e1.jpg', '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d939fe1d-131f-41c8-b96d-ee3fd0697d9d.jpg']
	}];

	var AboutZinesSection = React.createClass({
	  displayName: 'AboutZinesSection',

	  mixins: [ClassNameMixin, ScreenSizeMixin, PureRenderMixin],

	  propTypes: {
	    layout: PropTypes.any.isRequired,
	    active: PropTypes.bool.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      activeZineTabIndex: 0
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      inactive: !this.props.active
	    };
	  },

	  render: function render() {
	    var isMobile = this.state.isMobile;

	    return React.createElement(
	      AboutSection,
	      { layout: this.props.layout,
	        active: this.props.active,
	        title: 'Use collections to make connections.',
	        subtitle: 'Add your creation to relevant collections curated by people like you and get your work instantly noticed. Or start a collection of your own and use it however you like.',
	        backgroundColor: '#1B39A8',
	        color: 'white' },
	      React.createElement(
	        'div',
	        { className: this.getClassName() },
	        isMobile ? this.renderMobileCarousel() : this.renderDesktopCarousel()
	      )
	    );
	  },

	  renderMobileCarousel: function renderMobileCarousel() {
	    var active = this.props.active;

	    return React.createElement(
	      AboutSectionCarousel,
	      { type: 'zines',
	        active: active,
	        hideScrollbars: true },
	      zineTabs.map(function (zineTab, index) {
	        return React.createElement(AboutSectionCarousel.Image, { imageUrl: zineTab.cover,
	          imageSize: { width: 320, height: 430 },
	          key: index });
	      })
	    );
	  },

	  renderDesktopCarousel: function renderDesktopCarousel() {
	    var _this = this;

	    var active = this.props.active;
	    var activeZineTabIndex = this.state.activeZineTabIndex;

	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'AboutZinesSection-tabs' },
	        React.createElement(
	          TabBar,
	          { context: 'AboutPage' },
	          zineTabs.map(function (zineTab, index) {
	            return React.createElement(
	              TabLink,
	              { key: index,
	                onClick: _this.handleZineTabClick.bind(_this, index),
	                active: index === activeZineTabIndex },
	              zineTab.title
	            );
	          })
	        )
	      ),
	      zineTabs.map(function (zineTab, index) {
	        return React.createElement(
	          AboutSectionCarousel,
	          { type: 'zines',
	            hidden: activeZineTabIndex !== index,
	            key: index,
	            active: active },
	          React.createElement(AboutSectionGrid, { imageUrls: zineTab.previews.slice(0, 4),
	            imageSize: { width: 132, height: 178 },
	            type: 'zinesLeft',
	            active: active }),
	          React.createElement(
	            'a',
	            { href: zineTab.url, target: '_blank' },
	            React.createElement(AboutSectionCarousel.Image, { imageUrl: zineTab.cover,
	              imageSize: { width: 320, height: 430 } })
	          ),
	          React.createElement(AboutSectionGrid, { imageUrls: zineTab.previews.slice(4, 8),
	            imageSize: { width: 132, height: 178 },
	            type: 'zinesRight',
	            active: active })
	        );
	      })
	    );
	  },

	  handleZineTabClick: function handleZineTabClick(index) {
	    this.setState({
	      activeZineTabIndex: index
	    });
	  }
	});

	module.exports = AboutZinesSection;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    UserInfo = __webpack_require__(132),
	    PureRenderMixin = __webpack_require__(2),
	    Icon = __webpack_require__(10),
	    ServiceTypes = __webpack_require__(35);

	__webpack_require__(959);

	var ContactList = React.createClass({
	  displayName: 'ContactList',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    contacts: React.PropTypes.array.isRequired,
	    onSelect: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    var contacts = _.map(this.props.contacts, this.renderContact);
	    return React.createElement(
	      'ul',
	      { className: 'ContactList' },
	      contacts
	    );
	  },

	  renderContact: function renderContact(contact) {
	    return React.createElement(
	      'li',
	      { className: 'ContactList-item',
	        onMouseDown: this.props.onSelect.bind(this, contact),
	        key: contact.id },
	      React.createElement(
	        UserInfo,
	        { user: contact,
	          size: 'xsmall',
	          noLink: true },
	        React.createElement(
	          'div',
	          { className: 'ContactList-description' },
	          this.renderDescription(contact)
	        )
	      )
	    );
	  },

	  renderDescription: function renderDescription(friend) {
	    var serviceType = friend.serviceType,
	        description,
	        icon,
	        mode;

	    switch (serviceType) {
	      case ServiceTypes.GOOGLE:
	        description = friend.email;
	        icon = 'email';
	        mode = 'stroke';
	        break;
	      case ServiceTypes.FACEBOOK:
	        description = 'Facebook Message';
	        icon = 'facebook';
	        mode = 'fill';
	        break;
	    }

	    return {
	      icon: React.createElement(Icon, { name: icon,
	        size: 'xsmall',
	        mode: mode }),
	      description: description && React.createElement(
	        'span',
	        null,
	        description
	      )
	    };
	  }
	});

	module.exports = ContactList;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Link = __webpack_require__(21),
	    ModalActionCreators = __webpack_require__(77),
	    ModalTypes = __webpack_require__(58),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(961);

	var Footer = React.createClass({
	  displayName: 'Footer',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'ul',
	        { className: 'Footer-list' },
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { to: 'about',
	              underline: 'never' },
	            'About Stampsy'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { to: 'terms',
	              underline: 'never' },
	            'Terms of Service'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { to: 'privacy',
	              underline: 'never' },
	            'Privacy Policy'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { onClick: this.handleContactClick,
	              underline: 'never' },
	            'Contact Us'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { href: 'https://www.facebook.com/HelloStampsy',
	              target: '_blank',
	              underline: 'never' },
	            'Facebook'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { href: 'https://twitter.com/HelloStampsy',
	              target: '_blank',
	              underline: 'never' },
	            'Twitter'
	          )
	        ),
	        React.createElement(
	          'li',
	          { className: 'Footer-item' },
	          React.createElement(
	            Link,
	            { href: 'https://www.pinterest.com/HelloStampsy/',
	              target: '_blank',
	              underline: 'never' },
	            'Pinterest'
	          )
	        )
	      )
	    );
	  },

	  handleContactClick: function handleContactClick() {
	    ModalActionCreators.showModal(ModalTypes.CONTACT_US);
	  }
	});

	module.exports = Footer;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    Link = __webpack_require__(21),
	    UserLink = __webpack_require__(69),
	    Icon = __webpack_require__(10),
	    PureRenderMixin = __webpack_require__(2),
	    ServiceTypes = __webpack_require__(35),
	    formatDate = __webpack_require__(135),
	    UserStore = __webpack_require__(5);

	__webpack_require__(964);

	var InviteList = React.createClass({
	  displayName: 'InviteList',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    invites: React.PropTypes.arrayOf(React.PropTypes.shape({
	      id: React.PropTypes.number.isRequired,
	      serviceType: React.PropTypes.oneOf([ServiceTypes.FACEBOOK, ServiceTypes.EMAIL]).isRequired,
	      serviceId: React.PropTypes.string.isRequired,
	      created: React.PropTypes.string.isRequired,
	      joined: React.PropTypes.string,
	      user: React.PropTypes.number.isRequired }).isRequired).isRequired,
	    reInvited: React.PropTypes.object.isRequired,
	    onResendClick: React.PropTypes.func.isRequired
	  },

	  render: function render() {
	    var invites = _.map(this.props.invites, this.renderInvite);

	    return React.createElement(
	      'ul',
	      { className: 'InviteList' },
	      invites
	    );
	  },

	  renderInvite: function renderInvite(invite) {
	    var serviceType = invite.serviceType,
	        user = UserStore.get(invite.user),
	        description;

	    if (serviceType === ServiceTypes.EMAIL) {
	      description = invite.serviceId;
	    } else {
	      description = user.name;
	    }

	    return React.createElement(
	      'li',
	      { className: 'InviteList-item',
	        key: invite.id },
	      React.createElement(
	        'div',
	        { className: 'InviteList-user' },
	        React.createElement(
	          'div',
	          { className: 'InviteList-name' },
	          React.createElement(Icon, { name: serviceType.toLowerCase(), size: 'xsmall', mode: serviceType === ServiceTypes.EMAIL ? 'stroke' : 'fill' }),
	          description
	        ),
	        React.createElement(
	          'div',
	          { className: 'InviteList-date' },
	          'Invited ',
	          formatDate(invite.created)
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'InviteList-status' },
	        invite.joined !== null && React.createElement(
	          'div',
	          { className: 'InviteList-user' },
	          React.createElement(
	            'div',
	            { className: 'InviteList-name' },
	            React.createElement(UserLink, { user: user,
	              target: '_blank' })
	          ),
	          React.createElement(
	            'div',
	            { className: 'InviteList-date' },
	            'Joined ',
	            formatDate(invite.joined)
	          )
	        ),
	        invite.joined === null && React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'b',
	            { className: 'InviteList-pending' },
	            'Pending'
	          ),
	          this.props.reInvited[invite.id] !== true && React.createElement(
	            Link,
	            { className: 'InviteList-resend', onClick: this.handleResendClick.bind(this, invite) },
	            '(Resend)'
	          )
	        )
	      )
	    );
	  },

	  handleResendClick: function handleResendClick(invite) {
	    this.props.onResendClick(invite);
	  }
	});

	module.exports = InviteList;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _reactAddons = __webpack_require__(362);

	var _reactAddons2 = _interopRequireDefault(_reactAddons);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesLightboxStore = __webpack_require__(147);

	var _storesLightboxStore2 = _interopRequireDefault(_storesLightboxStore);

	var _storesNavigationStore = __webpack_require__(422);

	var _storesNavigationStore2 = _interopRequireDefault(_storesNavigationStore);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _mixinsScreenSizeMixin = __webpack_require__(71);

	var _mixinsScreenSizeMixin2 = _interopRequireDefault(_mixinsScreenSizeMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _moleculesStampNavHeader = __webpack_require__(705);

	var _moleculesStampNavHeader2 = _interopRequireDefault(_moleculesStampNavHeader);

	var _moleculesDraftPreviewNavHeader = __webpack_require__(696);

	var _moleculesDraftPreviewNavHeader2 = _interopRequireDefault(_moleculesDraftPreviewNavHeader);

	var _moleculesHomeNavHeader = __webpack_require__(697);

	var _moleculesHomeNavHeader2 = _interopRequireDefault(_moleculesHomeNavHeader);

	var _moleculesZineNavHeader = __webpack_require__(710);

	var _moleculesZineNavHeader2 = _interopRequireDefault(_moleculesZineNavHeader);

	var _moleculesUserNavHeader = __webpack_require__(709);

	var _moleculesUserNavHeader2 = _interopRequireDefault(_moleculesUserNavHeader);

	var _moleculesSearchNavHeader = __webpack_require__(702);

	var _moleculesSearchNavHeader2 = _interopRequireDefault(_moleculesSearchNavHeader);

	var _atomsLink = __webpack_require__(21);

	var _atomsLink2 = _interopRequireDefault(_atomsLink);

	var _atomsCounter = __webpack_require__(165);

	var _atomsCounter2 = _interopRequireDefault(_atomsCounter);

	var _atomsUserImage = __webpack_require__(143);

	var _atomsUserImage2 = _interopRequireDefault(_atomsUserImage);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _actionsContextMenuActionCreators = __webpack_require__(111);

	var _actionsContextMenuActionCreators2 = _interopRequireDefault(_actionsContextMenuActionCreators);

	var _constantsContextMenuTypes = __webpack_require__(112);

	var _constantsContextMenuTypes2 = _interopRequireDefault(_constantsContextMenuTypes);

	var _constantsModalTypes = __webpack_require__(58);

	var _constantsModalTypes2 = _interopRequireDefault(_constantsModalTypes);

	var _actionsModalActionCreators = __webpack_require__(77);

	var _actionsModalActionCreators2 = _interopRequireDefault(_actionsModalActionCreators);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _moleculesBtnGroup = __webpack_require__(44);

	var _moleculesBtnGroup2 = _interopRequireDefault(_moleculesBtnGroup);

	var _mixinsSmoothScrollMixin = __webpack_require__(259);

	var _mixinsSmoothScrollMixin2 = _interopRequireDefault(_mixinsSmoothScrollMixin);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _actionsActivityActionCreators = __webpack_require__(247);

	var _actionsActivityActionCreators2 = _interopRequireDefault(_actionsActivityActionCreators);

	var _storesActivityListStore = __webpack_require__(287);

	var _storesActivityListStore2 = _interopRequireDefault(_storesActivityListStore);

	var _mixinsRouterStateMixin = __webpack_require__(166);

	var _mixinsRouterStateMixin2 = _interopRequireDefault(_mixinsRouterStateMixin);

	var _constantsColors = __webpack_require__(397);

	var _constantsColors2 = _interopRequireDefault(_constantsColors);

	var _moleculesZinesNavHeader = __webpack_require__(711);

	var _moleculesZinesNavHeader2 = _interopRequireDefault(_moleculesZinesNavHeader);

	var _config = __webpack_require__(66);

	var _config2 = _interopRequireDefault(_config);

	'use strict';

	__webpack_require__(965);

	var UNSEEN_ACTIVITY_POLL_INTERVAL = 5000 * 9;

	if (false) {
	  UNSEEN_ACTIVITY_POLL_INTERVAL *= 10;
	}

	function rgba(color, alpha) {
	  var rgb = _mixinsBackColorMixin2['default'].parseColor(color);
	  return 'rgba(' + rgb.concat([alpha]).join(', ') + ')';
	}

	var Separator = _reactAddons2['default'].createClass({
	  displayName: 'Separator',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    hidden: _reactAddons.PropTypes.bool
	  },

	  statics: {
	    IS_SEPARATOR: true
	  },

	  render: function render() {
	    var style = undefined;
	    if (this.props.hidden) {
	      style = { opacity: 0 };
	    }

	    return _reactAddons2['default'].createElement('div', { className: 'NavBar-separator',
	      style: style });
	  }
	});

	var NavBar = _reactAddons2['default'].createClass({
	  displayName: 'NavBar',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsBackColorMixin2['default'], _mixinsSmoothScrollMixin2['default'], _mixinsRouterStateMixin2['default'], _mixinsPureRenderMixin2['default'], _mixinsScreenSizeMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesNavigationStore2['default'], _storesUserStore2['default'], _storesZineStore2['default'], _storesLightboxStore2['default'], _storesActivityListStore2['default'])],

	  contextTypes: {
	    router: _reactAddons.PropTypes.func
	  },

	  getStateFromStores: function getStateFromStores() {
	    var navContext = _storesNavigationStore2['default'].getContext();
	    var state = {
	      me: _storesUserStore2['default'].getMe(),
	      navContext: navContext,
	      isLightboxActive: _storesLightboxStore2['default'].isActive(),
	      unseenCount: _storesActivityListStore2['default'].getUnseenCount()
	    };

	    if (navContext && navContext.zineSlug) {
	      state.zine = _storesZineStore2['default'].get(navContext.zineSlug);
	    }

	    return state;
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _state = this.state;
	    var navContext = _state.navContext;
	    var isLightboxActive = _state.isLightboxActive;

	    if (!navContext) {
	      return [];
	    }

	    var modifiers = [];

	    if (navContext.isScrolled) {
	      modifiers.push('scrolled');
	    }

	    if (navContext.isAboutCover) {
	      modifiers.push('aboutCover');
	    }

	    if (isLightboxActive || navContext.isAboutCoverVideo || _storesUserStore2['default'].isAuthenticated() && navContext.isScrollingDown && !navContext.hasScrolledToInfo) {

	      modifiers.push('hidden');
	    }

	    switch (navContext.id) {
	      case _constantsNavigationContextTypes2['default'].ABOUT:
	        modifiers.push('about');
	        break;
	      case _constantsNavigationContextTypes2['default'].STAMP:
	        modifiers.push('stamp');
	        break;
	      case _constantsNavigationContextTypes2['default'].ZINE:
	        modifiers.push('zine');
	        break;
	      case _constantsNavigationContextTypes2['default'].USER:
	        modifiers.push('user');
	        break;
	      case _constantsNavigationContextTypes2['default'].HOME:
	        modifiers.push('home');
	        break;
	      case _constantsNavigationContextTypes2['default'].DRAFT_COMPOSE:
	        modifiers.push('draftCompose');
	        break;
	      case _constantsNavigationContextTypes2['default'].DRAFT_PREVIEW:
	        modifiers.push('draftPreview');
	        break;
	      case _constantsNavigationContextTypes2['default'].SEARCH:
	        modifiers.push('search');
	        break;
	      case _constantsNavigationContextTypes2['default'].ZINES:
	        modifiers.push('zines');
	        break;
	    }

	    return modifiers;
	  },

	  componentDidMount: function componentDidMount() {
	    if (_storesUserStore2['default'].isAuthenticated()) {
	      _actionsActivityActionCreators2['default'].requestUnseenCount();

	      this.unseenInterval = setInterval(function () {
	        _actionsActivityActionCreators2['default'].requestUnseenCount();
	      }, UNSEEN_ACTIVITY_POLL_INTERVAL);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    clearInterval(this.unseenInterval);
	  },

	  getColorsFromContext: function getColorsFromContext(navContext) {
	    var isMobile = this.state.isMobile;
	    var isTablet = this.state.isTablet;

	    if (!navContext) {
	      return {
	        backColor: _constantsColors2['default'].GRAY_LIGHT,
	        isTextDark: true
	      };
	    }

	    switch (navContext.id) {
	      case _constantsNavigationContextTypes2['default'].DRAFT_COMPOSE:
	        if (isMobile) {
	          return {
	            backColor: _constantsColors2['default'].WHITE,
	            isTextDark: true
	          };
	        }

	        return {
	          backColor: 'transparent',
	          isTextDark: false
	        };

	      case _constantsNavigationContextTypes2['default'].ZINE:
	        if (this.state.zine && (navContext.isScrolled || isMobile)) {
	          return this.getColorsFromZine(this.state.zine);
	        }

	        return {
	          backColor: 'transparent',
	          isTextDark: false
	        };

	      case _constantsNavigationContextTypes2['default'].ABOUT:
	        if (isMobile || isTablet) {
	          return {
	            backColor: _constantsColors2['default'].WHITE,
	            isTextDark: true
	          };
	        }

	        return {
	          backColor: 'transparent',
	          isTextDark: false
	        };

	      default:
	        return {
	          backColor: rgba(_constantsColors2['default'].WHITE, 0.97),
	          isTextDark: true
	        };
	    }
	  },

	  getColorsFromZine: function getColorsFromZine(zine) {
	    var backColor = zine.backColor;
	    var color = this.getTextColor(backColor);

	    return {
	      backColor: rgba(backColor, 0.95),
	      isTextDark: color === 'dark'
	    };
	  },

	  render: function render() {
	    var _state2 = this.state;
	    var me = _state2.me;
	    var navContext = _state2.navContext;

	    var header = this.renderHeader(navContext);
	    var colors = this.getColorsFromContext(navContext);
	    var childColor = colors.isTextDark ? 'dark' : 'light';
	    var isInHome = navContext && navContext.id === _constantsNavigationContextTypes2['default'].HOME;
	    var isInDraftCompose = navContext && navContext.id === _constantsNavigationContextTypes2['default'].DRAFT_COMPOSE;
	    var isHeaderContentHidden = this.isHeaderContentHidden(navContext);
	    var isMobile = this.state.isMobile;
	    var isTablet = this.state.isTablet;
	    var makeHref = this.context.router.makeHref;

	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: this.getClassName(),
	        style: {
	          backgroundColor: colors.backColor,
	          color: colors.isTextDark ? _constantsColors2['default'].DARK : _constantsColors2['default'].LIGHT
	        } },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'NavBar-row' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'NavBar-container NavBar-container--fillParent' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'NavBar-logo' },
	            _reactAddons2['default'].createElement(
	              _atomsLink2['default'],
	              { to: 'home',
	                className: 'NavBar-logoLink',
	                title: 'Stampsy',
	                context: 'Logo',
	                underline: 'never',
	                href: makeHref('home'),
	                onClick: this.handleHomeClick,
	                displayBlock: true },
	              _reactAddons2['default'].createElement(_atomsIcon2['default'], { name: 'logo',
	                size: 'medium' }),
	              _reactAddons2['default'].createElement(
	                'span',
	                { className: 'NavBar-logoHome' },
	                'Home'
	              )
	            )
	          ),
	          header && !isMobile && _reactAddons2['default'].createElement(NavBar.Separator, { hidden: isHeaderContentHidden }),
	          header && !isMobile && _reactAddons2['default'].createElement(
	            'div',
	            { className: 'NavBar-header' },
	            header
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'NavBar-container NavBar-container--inflexible' },
	          !isInDraftCompose && this.renderSearchButton(childColor),
	          !isInDraftCompose && _reactAddons2['default'].createElement(NavBar.Separator, null),
	          !isInDraftCompose && _reactAddons2['default'].createElement(
	            _moleculesBtnGroup2['default'],
	            null,
	            !isTablet && !isMobile && me && _reactAddons2['default'].createElement(
	              _atomsButton2['default'],
	              { size: 'small',
	                color: isInHome ? 'green' : childColor,
	                fill: isInHome,
	                onClick: this.handleCreateClick },
	              'Create'
	            ),
	            me ? this.renderActivityButton(childColor) : this.renderLogin(childColor),
	            me && _reactAddons2['default'].createElement(
	              _atomsButton2['default'],
	              { size: 'small',
	                color: childColor,
	                onClick: this.handleUserClick,
	                round: true },
	              _reactAddons2['default'].createElement(_atomsUserImage2['default'], { user: me,
	                size: 'small',
	                context: 'NavBar' })
	            )
	          )
	        )
	      ),
	      header && isMobile && !isHeaderContentHidden && _reactAddons2['default'].createElement(
	        'div',
	        { className: 'NavBar-row' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'NavBar-container' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'NavBar-header' },
	            header
	          )
	        )
	      )
	    );
	  },

	  renderActivityButton: function renderActivityButton(buttonColor) {
	    var unseenCount = this.state.unseenCount;

	    return _reactAddons2['default'].createElement(
	      _atomsButton2['default'],
	      { className: 'NavBar-activities',
	        context: 'NavBar',
	        size: 'small',
	        color: unseenCount > 0 ? 'red' : buttonColor,
	        onClick: this.handleActivitiesClick,
	        fill: !!unseenCount,
	        round: true },
	      unseenCount > 0 && _reactAddons2['default'].createElement(_atomsCounter2['default'], { context: 'NavBar',
	        count: unseenCount }),
	      unseenCount === 0 && _reactAddons2['default'].createElement(_atomsIcon2['default'], { name: 'notification',
	        mode: 'stroke',
	        size: 'small' })
	    );
	  },

	  renderSearchButton: function renderSearchButton(buttonColor) {
	    return _reactAddons2['default'].createElement(
	      _atomsButton2['default'],
	      { context: 'NavBar',
	        size: 'small',
	        color: buttonColor,
	        onClick: this.handleSearchClick,
	        round: true },
	      _reactAddons2['default'].createElement(_atomsIcon2['default'], { name: 'search',
	        mode: 'stroke',
	        size: 'small' })
	    );
	  },

	  renderLogin: function renderLogin(buttonColor) {
	    var navContext = this.state.navContext;

	    var showSignup = (!navContext || !navContext.isAboutCover) && _config2['default'].signUpEnabled;

	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'NavBar-login' },
	      _reactAddons2['default'].createElement(
	        _moleculesBtnGroup2['default'],
	        null,
	        !showSignup && _reactAddons2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'small',
	            color: buttonColor,
	            onClick: this.handleLoginClick },
	          'Log In'
	        ),
	        showSignup && _reactAddons2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'small',
	            color: 'green',
	            onClick: this.handleSignupClick,
	            fill: true },
	          'Sign Up'
	        )
	      )
	    );
	  },

	  isHeaderContentHidden: function isHeaderContentHidden(navContext) {

	    // Special cases: hide separator while nav header has no visible text.
	    // We could return null from renderHeader(), but we want to keep the animation.

	    switch (navContext && navContext.id) {
	      case _constantsNavigationContextTypes2['default'].USER:
	        return !navContext.hasScrolledPastPublished;
	      case _constantsNavigationContextTypes2['default'].SEARCH:
	        return !navContext.hasScrolledPastZines;
	      default:
	        return false;
	    }
	  },

	  renderHeader: function renderHeader(navContext) {
	    switch (navContext && navContext.id) {
	      case _constantsNavigationContextTypes2['default'].STAMP:
	        return _reactAddons2['default'].createElement(_moleculesStampNavHeader2['default'], { stampId: navContext.stampId,
	          primaryZineSlug: navContext.primaryZineSlug,
	          scrolledPastNextUp: navContext.hasScrolledPastNextUp,
	          nextUpTitle: navContext.nextUpTitle });

	      case _constantsNavigationContextTypes2['default'].DRAFT_PREVIEW:
	        return _reactAddons2['default'].createElement(_moleculesDraftPreviewNavHeader2['default'], null);

	      case _constantsNavigationContextTypes2['default'].ZINE:
	        return _reactAddons2['default'].createElement(_moleculesZineNavHeader2['default'], { zineSlug: navContext.zineSlug,
	          isEditing: navContext.isEditing });

	      case _constantsNavigationContextTypes2['default'].USER:
	        return _reactAddons2['default'].createElement(_moleculesUserNavHeader2['default'], { userId: navContext.userId,
	          scrolledPastPublished: navContext.hasScrolledPastPublished,
	          scrolledPastCurated: navContext.hasScrolledPastCurated,
	          scrolledPastLiked: navContext.hasScrolledPastLiked });

	      case _constantsNavigationContextTypes2['default'].SEARCH:
	        return _reactAddons2['default'].createElement(_moleculesSearchNavHeader2['default'], { scrolledPastZines: navContext.hasScrolledPastZines,
	          scrolledPastUsers: navContext.hasScrolledPastUsers,
	          scrolledPastStamps: navContext.hasScrolledPastStamps });

	      case _constantsNavigationContextTypes2['default'].HOME:
	        return _reactAddons2['default'].createElement(_moleculesHomeNavHeader2['default'], { scrolled: navContext && navContext.isScrolled });

	      case _constantsNavigationContextTypes2['default'].ZINES:
	        return _reactAddons2['default'].createElement(_moleculesZinesNavHeader2['default'], { scrolled: navContext && navContext.isScrolled,
	          scrolledSectionId: navContext.scrolledSectionId });

	      default:
	        return null;
	    }
	  },

	  handleUserClick: function handleUserClick(e) {
	    var el = e.target;
	    var user = _storesUserStore2['default'].getMe();

	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].USER_PROFILE, el, {
	      userId: user.id
	    });
	  },

	  handleCreateClick: function handleCreateClick(e) {
	    var el = e.target;
	    var user = _storesUserStore2['default'].getMe();

	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].CREATE, el, {
	      userId: user.id
	    });
	  },

	  handleSearchClick: function handleSearchClick() {
	    var _context$router = this.context.router;
	    var transitionTo = _context$router.transitionTo;
	    var isActive = _context$router.isActive;

	    if (!isActive('search')) {
	      transitionTo('search');
	    }
	  },

	  handleLoginClick: function handleLoginClick() {
	    _actionsModalActionCreators2['default'].showModal(_constantsModalTypes2['default'].LOGIN, {
	      source: _constantsAnalyticsSources2['default'].NAV_BAR
	    });
	  },

	  handleSignupClick: function handleSignupClick() {
	    _actionsModalActionCreators2['default'].showModal(_constantsModalTypes2['default'].ABOUT, {
	      source: _constantsAnalyticsSources2['default'].NAV_BAR
	    });
	  },

	  handleHomeClick: function handleHomeClick() {
	    var _context$router2 = this.context.router;
	    var transitionTo = _context$router2.transitionTo;
	    var isActive = _context$router2.isActive;

	    if (isActive('feed')) {
	      this.animateScroll(0, 200);
	      _actionsStampActionCreators2['default'].requestFeedWithTrendingPage(true, true);
	      return;
	    }

	    transitionTo('feed');
	  },

	  handleActivitiesClick: function handleActivitiesClick() {
	    _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].ACTIVITIES);
	  }
	});

	NavBar.Separator = Separator;

	exports['default'] = NavBar;
	module.exports = exports['default'];

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Icon = __webpack_require__(10);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(966);

	var Notification = React.createClass({
	  displayName: 'Notification',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    content: PropTypes.node.isRequired,
	    action: PropTypes.node,
	    onCloseClick: PropTypes.func.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      showCloseButton: true
	    };
	  },

	  render: function render() {
	    var content = this.props.content,
	        action = this.props.action,
	        handleCloseClick = this.props.onCloseClick;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'Notification-container' },
	        React.createElement(
	          'div',
	          { className: 'Notification-body' },
	          React.createElement(
	            'div',
	            { className: 'Notification-message' },
	            content
	          ),
	          action && React.createElement(
	            'div',
	            { className: 'Notification-action' },
	            action
	          )
	        ),
	        React.createElement(
	          'span',
	          { className: 'Notification-close', onTouchTap: handleCloseClick },
	          React.createElement(Icon, { name: 'cross',
	            size: 'xsmall',
	            mode: 'stroke' })
	        )
	      )
	    );
	  }
	});

	module.exports = Notification;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Recaptcha = __webpack_require__(1074),
	    FormLink = __webpack_require__(148),
	    ClassNameMixin = __webpack_require__(3),
	    ApiKeys = __webpack_require__(396),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(476);

	var RecaptchaFormRow = React.createClass({
	  displayName: 'RecaptchaFormRow',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    onVerify: React.PropTypes.func.isRequired },

	  className: 'FormInputRow',

	  handleVerify: function handleVerify(response) {
	    this.props.formLink.requestChange(response);
	  },

	  render: function render() {
	    var formLink = this.props.formLink;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(Recaptcha, {
	        sitekey: ApiKeys.RE_CAPTCHA_SITEKEY,
	        render: 'explicit',
	        onloadCallback: function () {},
	        verifyCallback: this.handleVerify
	      }),
	      this.renderMessage()
	    );
	  },

	  renderMessage: function renderMessage() {
	    var formLink = this.props.formLink,
	        fieldMessage = formLink.fieldMessage;

	    if (!fieldMessage) {
	      return;
	    }

	    if (!fieldMessage.isError) {
	      return React.createElement(
	        'div',
	        { className: 'FormInputRow-help' },
	        fieldMessage.message
	      );
	    }

	    // hasFormError will get reset on next tick,
	    // so we use it to trigger the animation

	    var animateShake = !formLink.hasFormError;
	    return React.createElement(
	      'div',
	      { className: 'FormInputRow-error',
	        'data-animate': animateShake },
	      fieldMessage.message
	    );
	  }
	});

	module.exports = RecaptchaFormRow;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defineProperty = __webpack_require__(181)['default'];

	var _Object$assign = __webpack_require__(180)['default'];

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var getSupportedTransformProperty = __webpack_require__(298);
	var Easings = __webpack_require__(253);var PropTypes = React.PropTypes;
	var Children = React.Children;

	var transformProperty = getSupportedTransformProperty();
	var styles = {
	  root: {
	    width: '100%',
	    height: '100%'
	  },

	  child: function child(index, props) {
	    var translateY = index > props.activeIndex - 1 ? '0' : '-100%';

	    return _Object$assign({
	      width: '100%'
	    }, !props.disabled && _defineProperty({
	      position: 'fixed',
	      transition: '' + transformProperty.css + ' ' + props.transitionDuration + 'ms ' + Easings.BEZIER,
	      willChange: '' + transformProperty.css }, transformProperty.js, 'translate3d(0, ' + translateY + ', 0)'));
	  }
	};

	var Scrolljack = React.createClass({
	  displayName: 'Scrolljack',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    disabled: PropTypes.bool,
	    activeIndex: PropTypes.number.isRequired,
	    requestActiveIndexChange: PropTypes.func.isRequired,
	    navigation: PropTypes.element,
	    transitionDuration: PropTypes.number,
	    extraDisableScrollDuration: PropTypes.number
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },

	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var navigation = _props.navigation;

	    return React.createElement(
	      'div',
	      { style: styles.root,
	        onWheel: this.handleWheel },
	      this.renderChildren(),
	      !disabled && navigation
	    );
	  },

	  renderChildren: function renderChildren() {
	    var _this = this;

	    var wrappers = [];

	    Children.forEach(this.props.children, function (child, index) {
	      return wrappers.push(React.createElement(
	        'div',
	        { key: index, style: styles.child(index, _this.props) },
	        child
	      ));
	    });

	    if (!this.props.disabled) {
	      // To avoid calculating z-index, just stack them
	      wrappers.reverse();
	    }

	    return wrappers;
	  },

	  handleWheel: function handleWheel(e) {
	    if (this.props.disabled) {
	      return;
	    }

	    e.preventDefault();

	    var activeIndex = this.props.activeIndex;
	    var deltaY = e.deltaY;

	    if (deltaY < 0 && activeIndex > 0) {
	      this.requestChangeAfterCurrentTransition(activeIndex - 1);
	    } else if (deltaY > 0) {
	      this.requestChangeAfterCurrentTransition(activeIndex + 1);
	    }
	  },

	  requestChangeAfterCurrentTransition: function requestChangeAfterCurrentTransition(index) {
	    var _this2 = this;

	    if (this.isAnimating) {
	      return;
	    }

	    var _props2 = this.props;
	    var transitionDuration = _props2.transitionDuration;
	    var extraDisableScrollDuration = _props2.extraDisableScrollDuration;

	    var disableScrollDuration = transitionDuration + extraDisableScrollDuration;

	    this.isAnimating = true;

	    this.timeout = setTimeout(function () {
	      _this2.isAnimating = false;
	    }, disableScrollDuration);

	    this.props.requestActiveIndexChange(index);
	  }
	});

	module.exports = Scrolljack;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ShareAddButtons = __webpack_require__(411);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var UserStore = __webpack_require__(5);
	var SidebarActionCreators = __webpack_require__(29);
	var SidebarTypes = __webpack_require__(39);
	var ContextMenuActionCreators = __webpack_require__(111);
	var ContextMenuTypes = __webpack_require__(112);
	var PureRenderMixin = __webpack_require__(2);
	var isBestOf2014Special = __webpack_require__(83);var PropTypes = React.PropTypes;

	var ShareAddZine = React.createClass({
	  displayName: 'ShareAddZine',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    zine: PropTypes.object.isRequired,
	    split: PropTypes.bool
	  },

	  contextTypes: {
	    source: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    var zine = this.props.zine;
	    if (isBestOf2014Special(zine) && !UserStore.isMe(zine.curator)) {
	      return this.renderStandaloneShareButton();
	    }

	    return React.createElement(ShareAddButtons, { size: this.props.size,
	      onShareClick: this.handleShareClick,
	      onAddClick: this.handleAddClick,
	      onMoreClick: this.handleMoreClick,
	      context: this.props.context,
	      showMore: this.shouldShowMore(),
	      showShare: true,
	      split: this.props.split,
	      round: this.props.round,
	      color: this.props.color,
	      overlay: this.props.overlay });
	  },

	  renderStandaloneShareButton: function renderStandaloneShareButton() {
	    return React.createElement(
	      Button,
	      { size: this.props.size,
	        color: this.props.color,
	        fill: this.props.fill,
	        overlay: this.props.overlay,
	        onClick: this.handleShareClick,
	        round: true },
	      React.createElement(Icon, { name: 'share',
	        mode: 'stroke',
	        size: 'small' })
	    );
	  },

	  shouldShowMore: function shouldShowMore() {
	    var zine = this.props.zine;
	    return UserStore.isMe(zine.curator) || zine.isSubscribed;
	  },

	  handleAddClick: function handleAddClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMPS_TO_ZINE, {
	      zineSlug: this.props.zine.slug
	    });
	  },

	  handleShareClick: function handleShareClick(e) {
	    var el = e.target;
	    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_SHARE, el, {
	      zineSlug: this.props.zine.slug,
	      source: this.context.source
	    });
	  },

	  handleMoreClick: function handleMoreClick(e) {
	    var el = e.target,
	        zine = this.props.zine;

	    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_MORE, el, {
	      zineSlug: zine.slug,
	      isMeCurator: UserStore.isMe(zine.curator)
	    });
	  }
	});

	module.exports = ShareAddZine;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);
	var IdleScrollMixin = __webpack_require__(405);
	var TransitionEventsMixin = __webpack_require__(167);
	var forceUpdateBodyOverflow = __webpack_require__(791);var PropTypes = React.PropTypes;

	__webpack_require__(968);

	var Sidebar = React.createClass({
	  displayName: 'Sidebar',

	  mixins: [ClassNameMixin, IdleScrollMixin, TransitionEventsMixin, PureRenderMixin],

	  propTypes: {
	    active: PropTypes.bool
	  },

	  getInitialState: function getInitialState() {
	    return this.getStateFromProps(this.props);
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      active: this.state.active
	    };
	  },

	  getStateFromProps: function getStateFromProps(props) {
	    return {
	      active: props.active,
	      children: props.children
	    };
	  },

	  /**
	   * We maintain `active` and `children` in `state`
	   * in order to perform UI optimizations such as:
	   *
	   * - on open, first draw children and then trigger transition
	   * - on close, leave children until transition is over
	   */
	  reconcileStateWithProps: function reconcileStateWithProps(props) {
	    this.setState(this.getStateFromProps(props));
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.active === this.props.active) {
	      // Children changed, active has not. Reconcile now.
	      this.reconcileStateWithProps(nextProps);
	      return;
	    }

	    if (!this.props.active && nextProps.active) {
	      // Becoming active. Reconcile after children are rendered.
	      this._needsReconcileStateAfterDOMFlush = true;
	      this.setState({ active: false, children: nextProps.children });
	      return;
	    }

	    if (this.props.active && !nextProps.active) {
	      // Becoming inactive. Will reconcile when CSS transition ends.
	      this.setState({ active: false });
	      return;
	    }
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    if (this._needsReconcileStateAfterDOMFlush) {
	      this._needsReconcileStateAfterDOMFlush = false;
	      this.reconcileStateWithProps(this.props);
	    }
	  },

	  render: function render() {
	    var className = this.getClassName();
	    if (this.isScrolling()) {
	      className += ' utils--scrolling';
	    }

	    return React.createElement(
	      'div',
	      { className: className,
	        onScroll: this.handleScroll,
	        onTransitionEnd: this.handleTransitionEnd },
	      this.state.children
	    );
	  },

	  handleTransitionEnd: function handleTransitionEnd() {
	    this.reconcileStateWithProps(this.props);
	    forceUpdateBodyOverflow();
	  }
	});

	module.exports = Sidebar;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _atomsStampLink = __webpack_require__(197);

	var _atomsStampLink2 = _interopRequireDefault(_atomsStampLink);

	var _atomsUserLink = __webpack_require__(69);

	var _atomsUserLink2 = _interopRequireDefault(_atomsUserLink);

	var _atomsUserImage = __webpack_require__(143);

	var _atomsUserImage2 = _interopRequireDefault(_atomsUserImage);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _moleculesSubmitStampControl = __webpack_require__(412);

	var _moleculesSubmitStampControl2 = _interopRequireDefault(_moleculesSubmitStampControl);

	var _atomsZineLink = __webpack_require__(93);

	var _atomsZineLink2 = _interopRequireDefault(_atomsZineLink);

	var _atomsFontTest = __webpack_require__(92);

	var _atomsFontTest2 = _interopRequireDefault(_atomsFontTest);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _utilsGetZineThumbnail = __webpack_require__(178);

	var _utilsGetZineThumbnail2 = _interopRequireDefault(_utilsGetZineThumbnail);

	var _utilsGetThumbnailUrl = __webpack_require__(37);

	var _utilsGetThumbnailUrl2 = _interopRequireDefault(_utilsGetThumbnailUrl);

	var _utilsDangerouslyStripHTML = __webpack_require__(296);

	var _utilsDangerouslyStripHTML2 = _interopRequireDefault(_utilsDangerouslyStripHTML);

	var _utilsIsEmptyishHTML = __webpack_require__(445);

	var _utilsIsEmptyishHTML2 = _interopRequireDefault(_utilsIsEmptyishHTML);

	var _moleculesStampRichThumbnail = __webpack_require__(706);

	var _moleculesStampRichThumbnail2 = _interopRequireDefault(_moleculesStampRichThumbnail);

	var _moleculesStampThumbnail = __webpack_require__(707);

	var _moleculesStampThumbnail2 = _interopRequireDefault(_moleculesStampThumbnail);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	__webpack_require__(970);

	var StampItem = _react2['default'].createClass({
	  displayName: 'StampItem',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesUserStore2['default']), _mixinsBackColorMixin2['default'], _mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stamp: _react.PropTypes.object.isRequired,
	    targetZine: _react.PropTypes.object,
	    size: _react.PropTypes.oneOf(['small', 'medium']).isRequired,
	    showSubmit: _react.PropTypes.bool,
	    showLikes: _react.PropTypes.bool,
	    isTrending: _react.PropTypes.bool.isRequired,
	    primaryZine: _react.PropTypes.object,
	    routeName: _react.PropTypes.string,
	    routeParams: _react.PropTypes.object,
	    allowEmptyThumbnail: _react.PropTypes.bool
	  },

	  className: 'StampItem',

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      type: 'stamp',
	      isTrending: false,
	      showLikes: true
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: _storesUserStore2['default'].get(props.stamp.user)
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size, this.hasDescription() && 'hasDescription', this.props.showSubmit && 'showSubmit', this.props.primaryZine && 'hasZine', this.props.stamp.thumbnail && 'hasThumbnail', this.props.stamp.isLiked && 'isLiked'];
	  },

	  getZineThumbnailStyle: function getZineThumbnailStyle(zine) {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    var image = (0, _utilsGetZineThumbnail2['default'])(zine),
	        size = 3 * 16 * Math.round(devicePixelRatio),
	        thumbnailUrl;

	    thumbnailUrl = (0, _utilsGetThumbnailUrl2['default'])(image, {
	      mode: 'scale_crop',
	      width: size,
	      height: size
	    });

	    return {
	      backgroundImage: 'url(' + thumbnailUrl + ')'
	    };
	  },

	  hasDescription: function hasDescription() {
	    return !(0, _utilsIsEmptyishHTML2['default'])(this.props.stamp.description);
	  },

	  render: function render() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var size = _props.size;
	    var showSubmit = _props.showSubmit;
	    var primaryZine = _props.primaryZine;
	    var isTrending = _props.isTrending;
	    var user = this.state.user;

	    var isSmall = size === 'small';
	    var isUnlisted = stamp.status === _constantsStampStatus2['default'].UNLISTED;

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName() },
	      isTrending && _react2['default'].createElement(
	        'span',
	        { className: 'StampItem-badge StampItem-trending', title: 'Trending Stamp' },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'trending',
	          mode: 'stroke',
	          size: 'xxsmall',
	          margin: 'right' }),
	        'Trending'
	      ),
	      isUnlisted && _react2['default'].createElement(
	        'span',
	        { className: 'StampItem-badge StampItem-secret',
	          title: 'This Stamp is only visible to those who have the direct link to it.' },
	        _react2['default'].createElement(_atomsIcon2['default'], { name: 'eyeCrossed',
	          mode: 'fill',
	          size: 'xsmall',
	          margin: 'right' }),
	        'Secret'
	      ),
	      _react2['default'].createElement(
	        _atomsStampLink2['default'],
	        { stamp: stamp,
	          className: 'StampItem-body',
	          routeName: this.props.routeName,
	          routeParams: this.props.routeParams,
	          underline: 'never' },
	        _react2['default'].createElement(_moleculesStampThumbnail2['default'], { thumbnail: stamp.thumbnail,
	          allowEmpty: this.props.allowEmptyThumbnail }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'StampItem-info' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'StampItem-titleAndDescription' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'StampItem-title' },
	              stamp.title
	            ),
	            this.hasDescription() && _react2['default'].createElement(
	              _atomsFontTest2['default'],
	              { family: 'minion-pro-condensed',
	                test: stamp.description },
	              _react2['default'].createElement(
	                'div',
	                { className: 'StampItem-subtitle' },
	                (0, _utilsDangerouslyStripHTML2['default'])(stamp.description)
	              )
	            )
	          ),
	          stamp.richThumbnail && _react2['default'].createElement(_moleculesStampRichThumbnail2['default'], _extends({}, stamp.richThumbnail, {
	            iconSize: isSmall ? 'xsmall' : 'xsmall' }))
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'StampItem-footer' },
	        !showSubmit && _react2['default'].createElement(
	          'div',
	          { className: 'StampItem-meta' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'StampItem-avatars' },
	            !isSmall && primaryZine && _react2['default'].createElement(
	              _atomsZineLink2['default'],
	              { zine: primaryZine },
	              _react2['default'].createElement('div', { className: 'StampItem-zineAvatar',
	                style: this.getZineThumbnailStyle(primaryZine) })
	            ),
	            !isSmall && primaryZine && _react2['default'].createElement(
	              _atomsUserLink2['default'],
	              { user: user },
	              _react2['default'].createElement(_atomsUserImage2['default'], { className: 'StampItem-userAvatar',
	                user: user,
	                size: 'xsmall' })
	            ),
	            !isSmall && !primaryZine && _react2['default'].createElement(
	              _atomsUserLink2['default'],
	              { user: user },
	              _react2['default'].createElement(_atomsUserImage2['default'], { className: 'StampItem-userAvatar',
	                user: user,
	                size: 'small' })
	            ),
	            isSmall && !showSubmit && _react2['default'].createElement(
	              _atomsUserLink2['default'],
	              { user: user },
	              _react2['default'].createElement(_atomsUserImage2['default'], { className: 'StampItem-userAvatar',
	                user: user,
	                size: 'xsmall' })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'StampItem-zineAndUser' },
	            !isSmall && primaryZine && _react2['default'].createElement(
	              'div',
	              { className: 'StampItem-zine' },
	              'in ',
	              _react2['default'].createElement(_atomsZineLink2['default'], { className: 'StampItem-zineTitle',
	                zine: primaryZine,
	                underline: 'hover',
	                bold: true })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'StampItem-user' },
	              'by ',
	              _react2['default'].createElement(_atomsUserLink2['default'], { className: 'StampItem-userName',
	                user: user,
	                underline: 'hover' })
	            )
	          )
	        ),
	        this.renderFooterContent()
	      )
	    );
	  },

	  renderFooterContent: function renderFooterContent() {
	    var _props2 = this.props;
	    var stamp = _props2.stamp;
	    var showSubmit = _props2.showSubmit;
	    var showLikes = _props2.showLikes;
	    var targetZine = _props2.targetZine;

	    if (showSubmit && targetZine) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'StampItem-footerAction' },
	        _react2['default'].createElement(_moleculesSubmitStampControl2['default'], { stamp: stamp,
	          zine: targetZine,
	          color: 'gray' })
	      );
	    }

	    if (showLikes) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'StampItem-counters' },
	        _react2['default'].createElement(_atomsIcon2['default'], { className: 'StampItem-likeIcon',
	          name: 'like',
	          size: 'xsmall' }),
	        _react2['default'].createElement(
	          'span',
	          null,
	          stamp.likeCount
	        )
	      );
	    }
	  }
	});

	exports['default'] = StampItem;
	module.exports = exports['default'];

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var AudioCover = __webpack_require__(170);
	var PlayerTitle = __webpack_require__(251);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var PlayerActionCreators = __webpack_require__(84);
	var StampLink = __webpack_require__(197);var PropTypes = React.PropTypes;

	__webpack_require__(971);

	var StickyPlayer = React.createClass({
	  displayName: 'StickyPlayer',

	  mixins: [PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    track: PropTypes.shape({
	      url: PropTypes.string.isRequired,
	      duration: PropTypes.number.isRequired
	    }).isRequired,
	    artwork: PropTypes.object.isRequired,
	    colors: PropTypes.object.isRequired,
	    sourceStamp: PropTypes.object,
	    currentTime: PropTypes.number.isRequired,
	    isPlaying: PropTypes.bool.isRequired,
	    isPaused: PropTypes.bool.isRequired,
	    onPlay: PropTypes.func.isRequired,
	    onPause: PropTypes.func.isRequired,
	    onBackward: PropTypes.func.isRequired,
	    onForward: PropTypes.func.isRequired
	  },

	  render: function render() {
	    var _props = this.props;
	    var track = _props.track;
	    var sourceStamp = _props.sourceStamp;
	    var artwork = _props.artwork;
	    var colors = _props.colors;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        AudioCover,
	        _extends({ context: 'StickyPlayer',
	          size: 'small',
	          linkUrl: track.url,
	          colors: colors,
	          artwork: artwork,
	          duration: track.duration
	        }, this.props),
	        React.createElement(
	          Button,
	          { className: 'StickyPlayer-close',
	            onClick: this.handleCloseClick,
	            size: 'xsmall',
	            color: 'dark',
	            round: true,
	            fill: true },
	          React.createElement(Icon, { name: 'cross',
	            mode: 'stroke',
	            size: 'xxsmall' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'StickyPlayer-meta' },
	        React.createElement(PlayerTitle, { title: track.title,
	          username: track.username,
	          linkUrl: track.url,
	          context: 'StickyPlayer' }),
	        sourceStamp && React.createElement(
	          'div',
	          { className: 'StickyPlayer-stampLink' },
	          'from ',
	          React.createElement(StampLink, { className: 'StickyPlayer-title',
	            bold: true,
	            stamp: sourceStamp })
	        )
	      )
	    );
	  },

	  handleCloseClick: function handleCloseClick() {
	    PlayerActionCreators.pause(this.props.uuid);
	    PlayerActionCreators.considerRemoveStickyMedia(true);
	  }
	});

	module.exports = StickyPlayer;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var TimeAgoFormatter = __webpack_require__(787);
	var PureRenderMixin = __webpack_require__(2);
	var formatDate = __webpack_require__(135);var PropTypes = React.PropTypes;

	var TimeAgo = React.createClass({
	  displayName: 'TimeAgo',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
	    className: PropTypes.string
	  },

	  getInitialState: function getInitialState() {
	    return {
	      text: this.getText()
	    };
	  },

	  getText: function getText() {
	    return this.isAbsolute() ? formatDate(this.props.date) : TimeAgoFormatter.format(this.props.date);
	  },

	  isAbsolute: function isAbsolute() {
	    return TimeAgoFormatter.isAbsolute(this.props.date, { maxWeeks: 2 });
	  },

	  componentDidMount: function componentDidMount() {
	    this.startCheckDate();
	  },

	  componentDidUpdate: function componentDidUpdate(prevState, prevProps) {
	    if (prevProps.date !== this.props.date) {
	      this.startCheckDate();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this.stopCheckDate();
	  },

	  startCheckDate: function startCheckDate() {
	    this.stopCheckDate();
	    this.checkDateInterval = setInterval(this.checkDate, 3000);
	    this.checkDate();
	  },

	  stopCheckDate: function stopCheckDate() {
	    clearInterval(this.checkDateInterval);
	    this.checkDateInterval = null;
	  },

	  checkDate: function checkDate() {
	    if (this.isAbsolute() || !this.isMounted()) {
	      this.stopCheckDate();
	    }

	    this.setState({
	      text: this.getText()
	    });
	  },

	  render: function render() {
	    return React.createElement(
	      'time',
	      { className: this.props.className },
	      this.state.text
	    );
	  }
	});

	module.exports = TimeAgo;

/***/ },
/* 728 */,
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ZineLink = __webpack_require__(93),
	    ZineImage = __webpack_require__(590),
	    ClassNameMixin = __webpack_require__(3),
	    PureRenderMixin = __webpack_require__(2),
	    PropTypes = React.PropTypes;

	__webpack_require__(974);

	var ZineInfo = React.createClass({
	  displayName: 'ZineInfo',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    zine: React.PropTypes.object.isRequired,
	    noLink: PropTypes.bool,
	    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
	    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']) },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium' };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.size];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.renderImage(),
	      this.renderBody()
	    );
	  },

	  renderImage: function renderImage() {
	    var image = React.createElement(ZineImage, { zine: this.props.zine,
	      size: this.props.imageSize || this.props.size });

	    if (this.props.noLink) {
	      return image;
	    }

	    return React.createElement(
	      ZineLink,
	      { zine: this.props.zine,
	        className: 'ZineInfo-avatar',
	        showTitle: true },
	      image
	    );
	  },

	  renderBody: function renderBody() {
	    var title = this.renderTitle(),
	        isInNavBar = this.props.context === 'NavBar';

	    if (!title) {
	      return;
	    }

	    return React.createElement(
	      'div',
	      { className: 'ZineInfo-body' },
	      isInNavBar && 'in ',
	      title
	    );
	  },

	  renderTitle: function renderTitle() {
	    if (this.props.noLink) {
	      return React.createElement(
	        'span',
	        { className: 'ZineInfo-title' },
	        this.props.zine.title
	      );
	    }

	    return React.createElement(ZineLink, { zine: this.props.zine,
	      className: 'ZineInfo-title', bold: true });
	  } });

	module.exports = ZineInfo;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _storesZineSectionStore = __webpack_require__(434);

	var _storesZineSectionStore2 = _interopRequireDefault(_storesZineSectionStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _moleculesEmptyState = __webpack_require__(59);

	var _moleculesEmptyState2 = _interopRequireDefault(_moleculesEmptyState);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _organismsContainer = __webpack_require__(81);

	var _organismsContainer2 = _interopRequireDefault(_organismsContainer);

	var _storesScreenSizeStore = __webpack_require__(121);

	var _storesScreenSizeStore2 = _interopRequireDefault(_storesScreenSizeStore);

	var _utilsGetStampCountPerRow = __webpack_require__(149);

	var _utilsGetStampCountPerRow2 = _interopRequireDefault(_utilsGetStampCountPerRow);

	'use strict';

	var DEFAULT_ROW_COUNT = 2;
	var ZINE_COLUMNS = 3;

	var ZineSection = _react2['default'].createClass({
	  displayName: 'ZineSection',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesZineSectionStore2['default'], _storesZineStore2['default'], _storesScreenSizeStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    section: _react.PropTypes.shape({
	      id: _react.PropTypes.number.isRequired,
	      name: _react.PropTypes.string.isRequired
	    }).isRequired,
	    onParsePage: _react.PropTypes.func.isRequired,
	    onPageChange: _react.PropTypes.func.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var screenSize = _storesScreenSizeStore2['default'].getScreenSize();

	    return {
	      zines: _storesZineSectionStore2['default'].getZines(this.props.section.id),
	      zinesPerRow: (0, _utilsGetStampCountPerRow2['default'])(screenSize, ZINE_COLUMNS)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    _actionsZineActionCreators2['default'].requestZinesInSection(this.props.section.id, true);
	  },

	  render: function render() {
	    var section = this.props.section;
	    var _state = this.state;
	    var zines = _state.zines;
	    var zinesPerRow = _state.zinesPerRow;

	    return _react2['default'].createElement(
	      _organismsContainer2['default'],
	      { context: 'page' },
	      _react2['default'].createElement(
	        _organismsGroup2['default'],
	        { items: zines,
	          title: section.name,
	          key: 'zine-section-' + section.id,
	          itemProps: {
	            size: 'large'
	          },
	          type: 'zines',
	          mode: 'grid',
	          columns: 3,
	          context: 'page',
	          isExpectingPage: _storesZineSectionStore2['default'].isExpectingPage(section.id),
	          isLastPage: _storesZineSectionStore2['default'].isLastPage(section.id),
	          isInvalidated: _storesZineSectionStore2['default'].isInvalidated(section.id),
	          defaultPage: this.props.onParsePage(),
	          onPageChange: this.props.onPageChange,
	          loadNextPage: this.requestNextPage,
	          perFirstPage: zinesPerRow * DEFAULT_ROW_COUNT,
	          perPage: zinesPerRow * DEFAULT_ROW_COUNT },
	        _react2['default'].createElement(_moleculesEmptyState2['default'], { label: 'Something went wrong. Please refresh the page or try again later.',
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    _actionsZineActionCreators2['default'].requestZinesInSection(this.props.section.id);
	  }
	});

	exports['default'] = ZineSection;
	module.exports = exports['default'];

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var StampDraftStore = __webpack_require__(64);
	var createStoreMixin = __webpack_require__(8);
	var DraftActionCreators = __webpack_require__(33);
	var Button = __webpack_require__(13);
	var PureRenderMixin = __webpack_require__(2);
	var DraftPageControls = __webpack_require__(418);var PropTypes = React.PropTypes;

	var DraftComposePageControls = React.createClass({
	  displayName: 'DraftComposePageControls',

	  mixins: [createStoreMixin(StampDraftStore), PureRenderMixin],

	  propTypes: {
	    stampSegment: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      isUnlisted: StampDraftStore.isUnlisted(),
	      isPublishing: StampDraftStore.isPublishing(),
	      canPublish: StampDraftStore.canPublish()
	    };
	  },

	  render: function render() {
	    var stampSegment = this.props.stampSegment;
	    var _state = this.state;
	    var isPublishing = _state.isPublishing;
	    var canPublish = _state.canPublish;
	    var isUnlisted = _state.isUnlisted;

	    return React.createElement(
	      DraftPageControls,
	      _extends({ showOptions: true
	      }, { isPublishing: isPublishing, canPublish: canPublish, stampSegment: stampSegment, isUnlisted: isUnlisted }),
	      React.createElement(
	        Button,
	        { onClick: this.handlePreviewClick,
	          context: 'PageControls',
	          size: 'medium',
	          overlay: true,
	          color: 'black' },
	        'Preview'
	      )
	    );
	  },

	  handlePreviewClick: function handlePreviewClick() {
	    DraftActionCreators.switchToPreview();
	  }
	});

	module.exports = DraftComposePageControls;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesPageControls = __webpack_require__(116);

	var _moleculesPageControls2 = _interopRequireDefault(_moleculesPageControls);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	'use strict';

	var DraftFeedbackControls = _react2['default'].createClass({
	  displayName: 'DraftFeedbackControls',

	  mixins: [_mixinsPureRenderMixin2['default']],

	  propTypes: {
	    draftUuid: _react.PropTypes.string.isRequired
	  },

	  render: function render() {
	    return _react2['default'].createElement(
	      _moleculesPageControls2['default'],
	      null,
	      _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { color: 'green',
	            fill: true,
	            onClick: this.handleLeaveFeedbackClick,
	            context: 'PageControls',
	            size: 'large' },
	          'Leave Feedback'
	        )
	      )
	    );
	  },

	  handleLeaveFeedbackClick: function handleLeaveFeedbackClick() {
	    _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].LEAVE_DRAFT_FEEDBACK, {
	      draftUuid: this.props.draftUuid
	    });
	  }
	});

	exports['default'] = DraftFeedbackControls;
	module.exports = exports['default'];

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var StampDraftStore = __webpack_require__(64);
	var createStoreMixin = __webpack_require__(8);
	var DraftActionCreators = __webpack_require__(33);
	var Button = __webpack_require__(13);
	var Icon = __webpack_require__(10);
	var PureRenderMixin = __webpack_require__(2);
	var DraftPageControls = __webpack_require__(418);var PropTypes = React.PropTypes;

	var DraftPreviewPageControls = React.createClass({
	  displayName: 'DraftPreviewPageControls',

	  mixins: [createStoreMixin(StampDraftStore), PureRenderMixin],

	  propTypes: {
	    stampSegment: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      isUnlisted: StampDraftStore.isUnlisted(),
	      isPublishing: StampDraftStore.isPublishing(),
	      canPublish: StampDraftStore.canPublish()
	    };
	  },

	  render: function render() {
	    var stampSegment = this.props.stampSegment;
	    var _state = this.state;
	    var isPublishing = _state.isPublishing;
	    var canPublish = _state.canPublish;
	    var isUnlisted = _state.isUnlisted;

	    return React.createElement(
	      DraftPageControls,
	      { isPublishing: isPublishing, canPublish: canPublish, stampSegment: stampSegment, isUnlisted: isUnlisted },
	      React.createElement(
	        Button,
	        { onClick: this.handleEditClick,
	          context: 'PageControls',
	          overlay: true,
	          color: 'black',
	          size: 'medium' },
	        React.createElement(Icon, { name: 'arrowLeft',
	          mode: 'stroke',
	          size: 'small',
	          context: 'DraftPreviewPageControls' }),
	        'Edit'
	      )
	    );
	  },

	  handleEditClick: function handleEditClick() {
	    DraftActionCreators.switchToCompose();
	  }
	});

	module.exports = DraftPreviewPageControls;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _require = __webpack_require__(4);

	var values = _require.values;
	var PageControls = __webpack_require__(116);
	var Button = __webpack_require__(13);
	var Link = __webpack_require__(21);
	var AlertActionCreators = __webpack_require__(32);
	var AlertTypes = __webpack_require__(48);
	var ClassNameMixin = __webpack_require__(3);
	var createAnalyticsContextMixin = __webpack_require__(169);
	var createStoreMixin = __webpack_require__(8);
	var AnalyticsSources = __webpack_require__(34);
	var PureRenderMixin = __webpack_require__(2);
	var Icon = __webpack_require__(10);
	var ServiceTypes = __webpack_require__(35);
	var Share = __webpack_require__(206);
	var ImageActionCreators = __webpack_require__(248);
	var ShareActionCreators = __webpack_require__(91);
	var ImageStore = __webpack_require__(146);
	var StampStore = __webpack_require__(17);
	var UserStore = __webpack_require__(5);
	var ImageAttribution = __webpack_require__(263);
	var BackColorMixin = __webpack_require__(56);
	var SectionTypes = __webpack_require__(40);
	var shallowEqual = __webpack_require__(46);var PropTypes = React.PropTypes;

	var ImagePageControls = React.createClass({
	  displayName: 'ImagePageControls',

	  mixins: [ClassNameMixin, PureRenderMixin, BackColorMixin, createAnalyticsContextMixin(AnalyticsSources.STAMP_PAGE_CONTROLS), createStoreMixin(StampStore, ImageStore, UserStore)],

	  propTypes: {
	    stampId: PropTypes.number,
	    imageUuid: PropTypes.string.isRequired,
	    sectionType: PropTypes.oneOf(values(SectionTypes)).isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var image = ImageStore.getInStamp(props.imageUuid, props.stampId),
	        sourceImage,
	        sourceStamp,
	        sourceUser,
	        stamp;

	    if (image) {
	      sourceImage = ImageStore.getSourceImage(image) || image;
	      sourceStamp = ImageStore.getSourceStamp(image, props.stampId);
	      sourceUser = UserStore.get(sourceStamp.user);
	      stamp = StampStore.get(props.stampId);
	    }

	    return { image: image, sourceImage: sourceImage, sourceStamp: sourceStamp, sourceUser: sourceUser, stamp: stamp };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  canRenderCollectButton: function canRenderCollectButton() {
	    var _state = this.state;
	    var sourceImage = _state.sourceImage;
	    var sourceStamp = _state.sourceStamp;
	    var stamp = _state.stamp;

	    if (!sourceImage || !sourceStamp || !stamp) {
	      return false;
	    }

	    return true;
	  },

	  canRenderAttribution: function canRenderAttribution() {
	    var _state2 = this.state;
	    var sourceStamp = _state2.sourceStamp;
	    var sourceImage = _state2.sourceImage;
	    var stamp = _state2.stamp;

	    if (!sourceImage || !sourceStamp || !stamp) {
	      return false;
	    }

	    return true;
	  },

	  render: function render() {
	    var canRenderCollectButton = this.canRenderCollectButton(),
	        canRenderAttribution = this.canRenderAttribution(),
	        color;

	    if (this.state.image) {
	      switch (this.props.sectionType) {
	        case SectionTypes.COVER:
	        case SectionTypes.POSTER:
	          color = this.getTextColor(this.state.image.colors.bottom);
	          break;
	        default:
	          color = 'light';
	      }
	    }

	    return React.createElement(
	      PageControls,
	      { color: color },
	      canRenderCollectButton && React.createElement(
	        PageControls.Container,
	        null,
	        this.renderCollectButton()
	      ),
	      canRenderCollectButton && canRenderAttribution && React.createElement(PageControls.Separator, null),
	      React.createElement(
	        PageControls.Container,
	        { fill: true },
	        canRenderAttribution && this.renderAttribution()
	      ),
	      React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(Share, { services: [ServiceTypes.PINTEREST, ServiceTypes.TUMBLR],
	          context: 'PageControls',
	          onShareClick: this.handleShareClick,
	          color: 'black',
	          size: 'medium',
	          iconSize: 'small',
	          overlay: true })
	      )
	    );
	  },

	  renderCollectButton: function renderCollectButton() {
	    return [React.createElement(
	      Button,
	      { key: 'save',
	        color: 'green',
	        context: 'PageControls',
	        onClick: this.handleSaveClick,
	        size: 'medium',
	        fill: true,
	        round: true },
	      React.createElement(Icon, { size: 'small',
	        name: 'collect',
	        mode: 'stroke' })
	    ), React.createElement(
	      'div',
	      { key: 'what',
	        className: 'PageControls-info PageControls-info--toRight' },
	      React.createElement(
	        Link,
	        { onClick: this.handleWhatsThisClick,
	          opaque: true },
	        'What’s this?'
	      )
	    )];
	  },

	  renderAttribution: function renderAttribution() {
	    if (!this.canRenderAttribution()) {
	      return;
	    }

	    var _state3 = this.state;
	    var sourceStamp = _state3.sourceStamp;
	    var sourceImage = _state3.sourceImage;
	    var sourceUser = _state3.sourceUser;
	    var stamp = _state3.stamp;

	    return React.createElement(ImageAttribution, { sourceStamp: sourceStamp,
	      sourceImage: sourceImage,
	      sourceUser: sourceUser,
	      stamp: stamp,
	      context: 'PageControls' });
	  },

	  handleSaveClick: function handleSaveClick() {
	    var _state4 = this.state;
	    var sourceImage = _state4.sourceImage;
	    var sourceStamp = _state4.sourceStamp;

	    ImageActionCreators.addToGrabbag(sourceImage.uuid, sourceStamp.id);
	  },

	  handleShareClick: function handleShareClick(service) {
	    var stampId = this.props.stampId;var image = this.state.image;

	    if (!stampId || !image) {
	      return;
	    }

	    ShareActionCreators.shareStamp({
	      stampId: stampId,
	      imageUrl: image.url,
	      service: service,
	      source: AnalyticsSources.LIGHTBOX
	    });
	  },

	  handleWhatsThisClick: function handleWhatsThisClick() {
	    AlertActionCreators.showAlert(AlertTypes.STAMP_SAVE_IMAGE_HELP);
	  }
	});

	module.exports = ImagePageControls;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesPageControls = __webpack_require__(116);

	var _moleculesPageControls2 = _interopRequireDefault(_moleculesPageControls);

	var _organismsShareAddStamp = __webpack_require__(271);

	var _organismsShareAddStamp2 = _interopRequireDefault(_organismsShareAddStamp);

	var _moleculesLikeButton = __webpack_require__(265);

	var _moleculesLikeButton2 = _interopRequireDefault(_moleculesLikeButton);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _mixinsCreateAnalyticsContextMixin = __webpack_require__(169);

	var _mixinsCreateAnalyticsContextMixin2 = _interopRequireDefault(_mixinsCreateAnalyticsContextMixin);

	var _constantsAnalyticsSources = __webpack_require__(34);

	var _constantsAnalyticsSources2 = _interopRequireDefault(_constantsAnalyticsSources);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	'use strict';

	var StampPageControls = _react2['default'].createClass({
	  displayName: 'StampPageControls',

	  mixins: [_mixinsClassNameMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default'], _storesUserStore2['default']), _mixinsPureRenderMixin2['default'], (0, _mixinsCreateAnalyticsContextMixin2['default'])(_constantsAnalyticsSources2['default'].STAMP_PAGE_CONTROLS)],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = _storesStampStore2['default'].get(props.stampId);
	    var isAuthor = _storesUserStore2['default'].isMe(stamp.user);
	    return { stamp: stamp, isAuthor: isAuthor };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.stampId !== this.props.stampId) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var stamp = _state.stamp;
	    var isAuthor = _state.isAuthor;

	    var isUnlisted = stamp.status === _constantsStampStatus2['default'].UNLISTED;

	    return _react2['default'].createElement(
	      _moleculesPageControls2['default'],
	      null,
	      stamp && _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(_moleculesLikeButton2['default'], { stamp: stamp,
	          showCounter: true,
	          context: 'PageControls',
	          color: 'black',
	          overlay: true,
	          size: 'large' })
	      ),
	      stamp && _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(_organismsShareAddStamp2['default'], { size: 'large',
	          color: 'black',
	          overlay: true,
	          context: 'PageControls',
	          stamp: stamp,
	          split: true })
	      )
	    );
	  }
	});

	exports['default'] = StampPageControls;
	module.exports = exports['default'];

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Button = __webpack_require__(13);
	var BtnGroup = __webpack_require__(44);
	var Icon = __webpack_require__(10);
	var PageControls = __webpack_require__(116);
	var createStoreMixin = __webpack_require__(8);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var ZineLink = __webpack_require__(93);
	var SidebarActionCreators = __webpack_require__(29);
	var SidebarTypes = __webpack_require__(39);
	var shallowEqual = __webpack_require__(46);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var StampReviewPageControls = React.createClass({
	  displayName: 'StampReviewPageControls',

	  mixins: [createStoreMixin(StampStore), PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      stamp: StampStore.get(props.stampId),
	      zine: ZineStore.get(props.zineSlug)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (!shallowEqual(newProps, this.props)) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var zine = this.state.zine;

	    return React.createElement(
	      PageControls,
	      null,
	      React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(
	          PageControls.Message,
	          null,
	          React.createElement(
	            'div',
	            null,
	            'Submitted to ',
	            React.createElement(ZineLink, { bold: true, zine: zine }),
	            '.'
	          ),
	          React.createElement(
	            'div',
	            { className: 'utils--hideOnMobile' },
	            'Accept or decline?'
	          )
	        )
	      ),
	      React.createElement(PageControls.Separator, null),
	      React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(
	          BtnGroup,
	          null,
	          React.createElement(
	            Button,
	            { onClick: this.handleApproveClick,
	              context: 'PageControls',
	              round: true,
	              fill: true,
	              size: 'large',
	              color: 'green' },
	            React.createElement(Icon, { name: 'check',
	              mode: 'stroke' })
	          ),
	          React.createElement(
	            Button,
	            { onClick: this.handleRejectClick,
	              context: 'PageControls',
	              round: true,
	              fill: true,
	              size: 'large',
	              color: 'red' },
	            React.createElement(Icon, { name: 'cross',
	              mode: 'stroke' })
	          )
	        )
	      )
	    );
	  },

	  handleApproveClick: function handleApproveClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.APPROVE_PENDING_STAMP, {
	      stampId: this.props.stampId,
	      zineSlug: this.props.zineSlug
	    });
	  },

	  handleRejectClick: function handleRejectClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.REJECT_PENDING_STAMP, {
	      stampId: this.props.stampId,
	      zineSlug: this.props.zineSlug
	    });
	  }
	});

	module.exports = StampReviewPageControls;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PageControls = __webpack_require__(116);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var FollowUserButton = __webpack_require__(262);
	var createStoreMixin = __webpack_require__(8);
	var UserStore = __webpack_require__(5);
	var BackColorMixin = __webpack_require__(56);
	var AnalyticsSources = __webpack_require__(34);
	var PureRenderMixin = __webpack_require__(2);
	var ContextMenuActionCreators = __webpack_require__(111);
	var ContextMenuTypes = __webpack_require__(112);var PropTypes = React.PropTypes;

	var UserPageControls = React.createClass({
	  displayName: 'UserPageControls',

	  mixins: [createStoreMixin(UserStore), BackColorMixin, PureRenderMixin],

	  propTypes: {
	    userId: PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: UserStore.get(props.userId),
	      isMe: UserStore.isMe(props.userId)
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.userId !== this.props.userId) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  render: function render() {
	    var _state = this.state;
	    var user = _state.user;
	    var isMe = _state.isMe;

	    return React.createElement(
	      PageControls,
	      null,
	      user && !isMe && React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(FollowUserButton, { user: user,
	          context: 'PageControls',
	          size: 'large' })
	      ),
	      user && React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(
	          Button,
	          { context: 'PageControls',
	            size: 'large',
	            color: 'black',
	            overlay: true,
	            round: true,
	            fill: true,
	            onClick: this.handleShareClick },
	          React.createElement(Icon, { name: 'share',
	            mode: 'stroke',
	            size: 'small' })
	        )
	      )
	    );
	  },

	  handleShareClick: function handleShareClick(e) {
	    var el = e.target;
	    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.USER_SHARE, el, {
	      userId: this.props.userId,
	      source: AnalyticsSources.USER_PAGE_CONTROLS
	    });
	  }
	});

	module.exports = UserPageControls;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _moleculesPageControls = __webpack_require__(116);

	var _moleculesPageControls2 = _interopRequireDefault(_moleculesPageControls);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _moleculesBtnGroup = __webpack_require__(44);

	var _moleculesBtnGroup2 = _interopRequireDefault(_moleculesBtnGroup);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesZineDraftStore = __webpack_require__(215);

	var _storesZineDraftStore2 = _interopRequireDefault(_storesZineDraftStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _constantsContextMenuTypes = __webpack_require__(112);

	var _constantsContextMenuTypes2 = _interopRequireDefault(_constantsContextMenuTypes);

	var _actionsContextMenuActionCreators = __webpack_require__(111);

	var _actionsContextMenuActionCreators2 = _interopRequireDefault(_actionsContextMenuActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	'use strict';

	var ZineEditPageControls = _react2['default'].createClass({
	  displayName: 'ZineEditPageControls',

	  mixins: [_mixinsBackColorMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesZineDraftStore2['default']), _mixinsPureRenderMixin2['default']],

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  getStateFromStores: function getStateFromStores() {
	    var previouslyVisibleZine = this.state && this.state.zine || null;
	    return {
	      zine: _storesZineDraftStore2['default'].getActiveDraft() || previouslyVisibleZine
	    };
	  },

	  render: function render() {
	    var zine = this.state.zine;

	    if (!zine) {
	      return _react2['default'].createElement(_moleculesPageControls2['default'], null);
	    }

	    var isProAccount = _storesUserStore2['default'].isAuthenticated() && _storesUserStore2['default'].getMe().isProAccount;
	    var isUnlisted = zine.status === _constantsZineStatus2['default'].UNLISTED;
	    var textColor = zine.backColor;
	    var backColor = this.getTextColor(zine.backColor) === 'dark' ? '2e2f33' : 'ffffff';

	    return _react2['default'].createElement(
	      _moleculesPageControls2['default'],
	      { textColor: textColor,
	        backColor: backColor },
	      _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'large',
	            color: 'black',
	            overlay: true,
	            context: 'PageControls',
	            onClick: this.handleColorClick },
	          'Color',
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'arrowUp',
	            mode: 'stroke',
	            size: 'xsmall',
	            margin: 'left' })
	        )
	      ),
	      isProAccount && zine.isNew && _react2['default'].createElement(_moleculesPageControls2['default'].Separator, null),
	      isProAccount && zine.isNew && _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'large',
	            color: 'black',
	            overlay: true,
	            context: 'PageControls',
	            onClick: this.handleStatusClick },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: isUnlisted ? 'eyeCrossed' : 'eye',
	            mode: isUnlisted ? 'fill' : 'stroke',
	            size: 'small' }),
	          isUnlisted ? 'Secret' : 'Public',
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'arrowUp',
	            mode: 'stroke',
	            size: 'xsmall',
	            margin: 'left' })
	        )
	      ),
	      _react2['default'].createElement(_moleculesPageControls2['default'].Separator, null),
	      _react2['default'].createElement(
	        _moleculesPageControls2['default'].Container,
	        null,
	        _react2['default'].createElement(
	          _moleculesBtnGroup2['default'],
	          null,
	          !zine.isNew && _react2['default'].createElement(
	            _atomsButton2['default'],
	            { size: 'large',
	              color: 'black',
	              overlay: true,
	              split: true,
	              context: 'PageControls',
	              onClick: this.handleCancelClick },
	            'Cancel'
	          ),
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { size: 'large',
	              color: 'green',
	              fill: true,
	              split: !zine.isNew,
	              context: 'PageControls',
	              onClick: this.handleSaveClick },
	            zine.isNew ? 'Create' : 'Save'
	          )
	        )
	      )
	    );
	  },

	  handleColorClick: function handleColorClick(e) {
	    var el = e.target;
	    var color = this.state.zine.backColor;

	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].ZINE_COLOR_PICKER, el, {
	      previousColor: color
	    });
	  },

	  handleStatusClick: function handleStatusClick(e) {
	    var el = e.target;
	    _actionsContextMenuActionCreators2['default'].showContextMenu(_constantsContextMenuTypes2['default'].ZINE_STATUS_PICKER, el);
	  },

	  handleCancelClick: function handleCancelClick() {
	    var goBack = this.context.router.goBack;

	    _actionsZineActionCreators2['default'].destroyZineDraft();

	    if (this.state.zine.isNew) {
	      goBack();
	    }
	  },

	  handleSaveClick: function handleSaveClick() {
	    var zine = this.state.zine;

	    if (zine.isNew) {
	      _actionsZineActionCreators2['default'].createZine(this.state.zine);
	    } else {
	      _actionsZineActionCreators2['default'].updateZine(this.state.zine);
	    }
	  }
	});

	exports['default'] = ZineEditPageControls;
	module.exports = exports['default'];

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var PageControls = __webpack_require__(116);
	var ShareAddZine = __webpack_require__(723);
	var FollowZineButton = __webpack_require__(409);
	var PendingZineButton = __webpack_require__(700);
	var createStoreMixin = __webpack_require__(8);
	var ZineStore = __webpack_require__(22);
	var UserStore = __webpack_require__(5);
	var StampStore = __webpack_require__(17);
	var StampActionCreators = __webpack_require__(54);
	var ZinePendingStampStore = __webpack_require__(216);
	var BackColorMixin = __webpack_require__(56);
	var createAnalyticsContextMixin = __webpack_require__(169);
	var AnalyticsSources = __webpack_require__(34);
	var PureRenderMixin = __webpack_require__(2);
	var isBestOf2014Special = __webpack_require__(83);
	var ZineStatus = __webpack_require__(114);var PropTypes = React.PropTypes;

	var ZinePageControls = React.createClass({
	  displayName: 'ZinePageControls',

	  mixins: [createStoreMixin(ZineStore, ZinePendingStampStore, StampStore), createAnalyticsContextMixin(AnalyticsSources.ZINE_PAGE_CONTROLS), BackColorMixin, PureRenderMixin],

	  propTypes: {
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var zine = ZineStore.get(props.zineSlug),
	        isMeCurator = zine && UserStore.isMe(zine.curator),
	        pendingStamps = ZinePendingStampStore.getStamps(props.zineSlug),
	        pendingStampUsers = _.uniq(pendingStamps.map(function (s) {
	      return UserStore.get(s.user);
	    }));

	    return {
	      zine: zine,
	      isMeCurator: isMeCurator,
	      pendingStampUsers: pendingStampUsers
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    if (this.state.zine) {
	      this.zineDidChange(this.state);
	    }
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.zineSlug !== this.props.zineSlug) {
	      this.setState(this.getStateFromStores(newProps));
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.zine !== this.state.zine) {
	      this.zineDidChange();
	    }
	  },

	  zineDidChange: function zineDidChange() {
	    var _state = this.state;
	    var zine = _state.zine;
	    var isMeCurator = _state.isMeCurator;

	    if (isMeCurator) {
	      StampActionCreators.requestZinePendingPage(zine.slug, true);
	    }
	  },

	  render: function render() {
	    var _state2 = this.state;
	    var zine = _state2.zine;
	    var isMeCurator = _state2.isMeCurator;
	    var pendingStampUsers = _state2.pendingStampUsers;
	    var isSpecial = isBestOf2014Special(zine);
	    var isUnlisted;
	    var backColor;
	    var textColor;

	    if (zine) {
	      isUnlisted = zine.status === ZineStatus.UNLISTED;
	      textColor = zine.backColor;
	      backColor = this.getTextColor(zine.backColor) === 'dark' ? '2e2f33' : 'ffffff';
	    }

	    return React.createElement(
	      PageControls,
	      { textColor: textColor,
	        backColor: backColor },
	      zine && !zine.isSubscribed && !isMeCurator && !isSpecial && !isUnlisted && React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(FollowZineButton, { zine: zine,
	          context: 'PageControls',
	          size: 'large' })
	      ),
	      zine && isMeCurator && zine.pendingCount > 0 && React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(PendingZineButton, { zine: zine,
	          context: 'PageControls',
	          size: 'large',
	          pendingStampUsers: pendingStampUsers })
	      ),
	      zine && React.createElement(
	        PageControls.Container,
	        null,
	        React.createElement(ShareAddZine, { zine: zine,
	          context: 'PageControls',
	          size: 'large',
	          color: 'black',
	          overlay: true,
	          split: true })
	      )
	    );
	  }
	});

	module.exports = ZinePageControls;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$assign = __webpack_require__(180)['default'];

	var React = __webpack_require__(1);
	var AboutSocialProofSection = __webpack_require__(713);
	var AboutCoverSection = __webpack_require__(414);
	var AboutFeedSection = __webpack_require__(712);
	var AboutStampsSection = __webpack_require__(714);
	var AboutZinesSection = __webpack_require__(715);
	var AboutSectionTypes = __webpack_require__(642);
	var NavigationContextTypes = __webpack_require__(51);
	var OverlayStore = __webpack_require__(118);
	var Page = __webpack_require__(97);
	var Dots = __webpack_require__(695);
	var Icon = __webpack_require__(10);
	var Scrolljack = __webpack_require__(722);
	var PureRenderMixin = __webpack_require__(2);
	var ScreenSizeMixin = __webpack_require__(71);
	var Easings = __webpack_require__(253);
	var KeyCodes = __webpack_require__(145);
	var getSupportedTransformProperty = __webpack_require__(298);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var aboutSections = [AboutSectionTypes.COVER, AboutSectionTypes.STAMPS, AboutSectionTypes.ZINES, AboutSectionTypes.FEED, AboutSectionTypes.SOCIAL_PROOF];

	var transitionDuration = 1000;
	// const transformProperty = getSupportedTransformProperty();

	var styles = {
	  dots: {
	    position: 'absolute',
	    right: 0,
	    top: 0,
	    bottom: 0,
	    margin: 'auto' },

	  learnMore: {
	    normal: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      width: '100%',
	      height: '100%',
	      padding: '.75rem',
	      fontWeight: 'bold',
	      cursor: 'pointer',
	      backgroundColor: AboutStampsSection.backgroundColor },

	    active: {
	      // [transformProperty.js]: `translate3d(0, 0, 0)`,
	      transitionDelay: '1s'
	    }
	  }
	};

	var AboutPage = React.createClass({
	  displayName: 'AboutPage',

	  mixins: [PureRenderMixin, ScreenSizeMixin],

	  getInitialState: function getInitialState() {
	    return {
	      showVideo: false,
	      activeSectionIndex: 0
	    };
	  },

	  getNavigationContext: function getNavigationContext() {
	    var _state = this.state;
	    var activeSectionIndex = _state.activeSectionIndex;
	    var showVideo = _state.showVideo;

	    var isAboutCover = activeSectionIndex === 0;

	    return [NavigationContextTypes.ABOUT, {
	      isAboutCover: isAboutCover,
	      isAboutCoverVideo: isAboutCover && showVideo
	    }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  canScrolljack: function canScrolljack() {
	    return this.state.isDesktop && !isMobile();
	  },

	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    window.addEventListener('keydown', this.handleWindowKeyDown);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('keydown', this.handleWindowKeyDown);
	  },

	  render: function render() {
	    var _state2 = this.state;
	    var activeSectionIndex = _state2.activeSectionIndex;
	    var showVideo = _state2.showVideo;

	    var navigation = null;
	    if (!showVideo) {
	      navigation = React.createElement(Dots, { activeIndex: activeSectionIndex,
	        requestActiveIndexChange: this.handleRequestActiveSectionIndexChange,
	        count: aboutSections.length,
	        style: styles.dots });
	    }

	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        Page,
	        null,
	        React.createElement(
	          Scrolljack,
	          { disabled: !this.canScrolljack(),
	            activeIndex: activeSectionIndex,
	            requestActiveIndexChange: this.handleRequestActiveSectionIndexChange,
	            transitionDuration: transitionDuration,
	            extraDisableScrollDuration: 250,
	            navigation: navigation },
	          aboutSections.map(this.renderAboutSection)
	        )
	      )
	    );
	  },

	  renderAboutSection: function renderAboutSection(type, index) {
	    var _state3 = this.state;
	    var activeSectionIndex = _state3.activeSectionIndex;
	    var showVideo = _state3.showVideo;

	    var Section = undefined;
	    var props = {
	      key: type,
	      layout: 'section',
	      active: index === activeSectionIndex || !this.canScrolljack()
	    };

	    switch (type) {
	      case AboutSectionTypes.COVER:
	        Section = AboutCoverSection;
	        _Object$assign(props, {
	          showVideo: showVideo,
	          showLogo: true,
	          layout: showVideo ? 'full' : 'section',
	          footer: this.renderLearnMore(),
	          onRequestShowVideoChange: this.handleRequestShowVideoChange
	        });
	        break;

	      case AboutSectionTypes.STAMPS:
	        Section = AboutStampsSection;
	        break;

	      case AboutSectionTypes.ZINES:
	        Section = AboutZinesSection;
	        break;

	      case AboutSectionTypes.FEED:
	        Section = AboutFeedSection;
	        break;

	      case AboutSectionTypes.SOCIAL_PROOF:
	        Section = AboutSocialProofSection;
	        break;
	    }

	    return React.createElement(Section, props);
	  },

	  renderLearnMore: function renderLearnMore() {
	    var activeSectionIndex = this.state.activeSectionIndex;

	    var isActive = activeSectionIndex === 0;

	    if (this.canScrolljack()) {
	      return React.createElement(
	        'div',
	        { onClick: this.handleLearnMoreClick,
	          style: _Object$assign({}, styles.learnMore.normal, isActive && styles.learnMore.active) },
	        'Learn More',
	        '   ',
	        React.createElement(Icon, { context: 'AboutPage',
	          name: 'arrowDown',
	          mode: 'stroke',
	          size: 'xsmall' })
	      );
	    }
	  },

	  handleRequestShowVideoChange: function handleRequestShowVideoChange(showVideo) {
	    this.setState({ showVideo: showVideo });
	  },

	  handleRequestActiveSectionIndexChange: function handleRequestActiveSectionIndexChange(index) {
	    if (this.state.showVideo) {
	      return;
	    }

	    this.setActiveSection(index);
	  },

	  handleLearnMoreClick: function handleLearnMoreClick() {
	    this.setActiveSection(1);
	  },

	  handleWindowKeyDown: function handleWindowKeyDown(e) {
	    if (!this.canScrolljack() || OverlayStore.hasAny() || this.state.showVideo) {
	      return;
	    }

	    var activeSectionIndex = this.state.activeSectionIndex;

	    switch (e.keyCode) {
	      case KeyCodes.HOME:
	        this.setActiveSection(0);
	        break;
	      case KeyCodes.END:
	        this.setActiveSection(Infinity);
	        break;
	      case KeyCodes.UP:
	      case KeyCodes.PAGE_UP:
	        this.setActiveSection(e.metaKey ? 0 : activeSectionIndex - 1);
	        break;
	      case KeyCodes.DOWN:
	      case KeyCodes.PAGE_DOWN:
	        this.setActiveSection(e.metaKey ? Infinity : activeSectionIndex + 1);
	        break;
	      case KeyCodes.SPACE:
	        this.setActiveSection(activeSectionIndex + (e.shiftKey ? -1 : 1));
	        break;
	    }
	  },

	  setActiveSection: function setActiveSection(index) {
	    index = Math.max(0, index);
	    index = Math.min(index, aboutSections.length - 1);

	    this.setState({
	      activeSectionIndex: index
	    });
	  }
	});

	module.exports = AboutPage;

	// [transformProperty.js]: `translate3d(0, 200%, 0)`,
	// transition: `${transformProperty.css} ${transitionDuration}ms ${Easings.BEZIER}`,

/***/ },
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Analytics = __webpack_require__(52);
	var AnalyticsEvents = __webpack_require__(55);
	var StampActionCreators = __webpack_require__(54);
	var FeedWithTrendingStore = __webpack_require__(288);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var createStoreMixin = __webpack_require__(8);
	var Group = __webpack_require__(45);
	var EmptyState = __webpack_require__(59);
	var DocumentTitle = __webpack_require__(68);
	var PureRenderMixin = __webpack_require__(2);
	var PageQueryMixin = __webpack_require__(129);
	var _require = __webpack_require__(50);

	var isInitialPath = _require.isInitialPath;
	var _require2 = __webpack_require__(4);

	var pluck = _require2.pluck;var PropTypes = React.PropTypes;

	var FeedPage = React.createClass({
	  displayName: 'FeedPage',

	  mixins: [createStoreMixin(FeedWithTrendingStore, StampStore, ZineStore), PageQueryMixin, PureRenderMixin],

	  propTypes: {
	    isScrolled: PropTypes.bool.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      keyedStamps: FeedWithTrendingStore.getKeyedStamps(),
	      isInvalidated: FeedWithTrendingStore.isInvalidated(),
	      isLastPage: FeedWithTrendingStore.isLastPage(),
	      isExpectingPage: FeedWithTrendingStore.isExpectingPage()
	    };
	  },

	  getStampItemProps: function getStampItemProps(stamp, index) {
	    var keyedStamps = this.state.keyedStamps;
	    var isTrending = keyedStamps[index].isTrending;
	    var primaryZine = StampStore.getPrimaryZine(stamp.id);

	    return {
	      isTrending: isTrending,
	      primaryZine: primaryZine
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    StampActionCreators.requestFeedWithTrendingPage(true, !isInitialPath());
	    Analytics.trackEvent(AnalyticsEvents.FEED_VIEW);
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var didInvalidate = this.state.isInvalidated && !prevState.isInvalidated;
	    if (didInvalidate && !this.state.isExpectingPage) {
	      StampActionCreators.requestFeedWithTrendingPage(true, true);
	    }
	  },

	  render: function render() {
	    var isScrolled = this.props.isScrolled;var _state = this.state;
	    var keyedStamps = _state.keyedStamps;
	    var isInvalidated = _state.isInvalidated;
	    var isExpectingPage = _state.isExpectingPage;
	    var isLastPage = _state.isLastPage;

	    return React.createElement(
	      DocumentTitle,
	      { title: 'My Feed' },
	      React.createElement(
	        Group,
	        { type: 'stamps',
	          mode: 'grid',
	          columns: 3,
	          context: 'page',
	          keys: pluck(keyedStamps, 'key'),
	          items: pluck(keyedStamps, 'item'),
	          getItemProps: this.getStampItemProps,
	          isExpectingPage: isExpectingPage,
	          isLastPage: isLastPage,
	          isInvalidated: isInvalidated,
	          showInvalidationFeedback: !isScrolled,
	          defaultPage: this.parsePage(),
	          onPageChange: this.replacePage,
	          loadNextPage: this.requestNextPage },
	        React.createElement(EmptyState, { label: 'Something went wrong. Please refresh the page or try again later.',
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    StampActionCreators.requestFeedWithTrendingPage();
	  }
	});

	module.exports = FeedPage;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _slicedToArray = __webpack_require__(61)['default'];

	var React = __webpack_require__(1);
	var Page = __webpack_require__(97);
	var Container = __webpack_require__(81);
	var ScrollStateMixin = __webpack_require__(115);
	var NavigationContextTypes = __webpack_require__(51);
	var UserStore = __webpack_require__(5);
	var PureRenderMixin = __webpack_require__(2);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(154);

	var RouteHandler = _require.RouteHandler;

	var HomePage = React.createClass({
	  displayName: 'HomePage',

	  mixins: [ScrollStateMixin, PureRenderMixin],

	  statics: {
	    willTransitionTo: function willTransitionTo(transition) {
	      if (!UserStore.isAuthenticated()) {
	        transition.redirect('about');
	      }
	    }
	  },

	  getScrollState: function getScrollState(scrollY) {
	    return {
	      isScrolled: scrollY > 96
	    };
	  },

	  getNavigationContext: function getNavigationContext() {
	    var isScrolled = this.state.isScrolled;

	    return [NavigationContextTypes.HOME, { isScrolled: isScrolled }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        Page,
	        { showFooter: true },
	        React.createElement(
	          Container,
	          { context: 'Page' },
	          React.createElement(RouteHandler, _extends({ isScrolled: this.state.isScrolled
	          }, this.props))
	        )
	      )
	    );
	  }
	});

	module.exports = HomePage;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _utilsAnalytics = __webpack_require__(52);

	var _utilsAnalytics2 = _interopRequireDefault(_utilsAnalytics);

	var _constantsAnalyticsEvents = __webpack_require__(55);

	var _constantsAnalyticsEvents2 = _interopRequireDefault(_constantsAnalyticsEvents);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _storesZineSectionsStore = __webpack_require__(293);

	var _storesZineSectionsStore2 = _interopRequireDefault(_storesZineSectionsStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsPageQueryMixin = __webpack_require__(129);

	var _mixinsPageQueryMixin2 = _interopRequireDefault(_mixinsPageQueryMixin);

	var _organismsZineSection = __webpack_require__(730);

	var _organismsZineSection2 = _interopRequireDefault(_organismsZineSection);

	var _AppContext = __webpack_require__(67);

	var _AppContext2 = _interopRequireDefault(_AppContext);

	var _organismsPage = __webpack_require__(97);

	var _organismsPage2 = _interopRequireDefault(_organismsPage);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _atomsOffsetMonitor = __webpack_require__(128);

	var _atomsOffsetMonitor2 = _interopRequireDefault(_atomsOffsetMonitor);

	var _lodashCollectionFindLast = __webpack_require__(998);

	var _lodashCollectionFindLast2 = _interopRequireDefault(_lodashCollectionFindLast);

	var _mixinsScrollStateMixin = __webpack_require__(115);

	var _mixinsScrollStateMixin2 = _interopRequireDefault(_mixinsScrollStateMixin);

	'use strict';

	var ListedZinesPage = _react2['default'].createClass({
	  displayName: 'ListedZinesPage',

	  mixins: [_mixinsScrollStateMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesZineSectionsStore2['default']), _mixinsPageQueryMixin2['default'], _mixinsPureRenderMixin2['default']],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      sections: _storesZineSectionsStore2['default'].getSections()
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    this._offsets = {};
	  },

	  componentDidMount: function componentDidMount() {
	    _actionsZineActionCreators2['default'].requestZineSections(true);
	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].ZINES_VIEW);
	  },

	  getNavigationContext: function getNavigationContext() {
	    var _state = this.state;
	    var isScrolled = _state.isScrolled;
	    var scrolledSectionId = _state.scrolledSectionId;

	    return [_constantsNavigationContextTypes2['default'].ZINES, { isScrolled: isScrolled, scrolledSectionId: scrolledSectionId }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  getScrollState: function getScrollState(scrollY) {
	    var _this = this;

	    var _ref = this.state || {};

	    var sections = _ref.sections;

	    var lastScrolledSection = (0, _lodashCollectionFindLast2['default'])(sections, function (section) {
	      return _this.hasScrolledPastOffset(_this._offsets[section.id]);
	    });

	    return {
	      isScrolled: scrollY > 52,
	      scrolledSectionId: lastScrolledSection && lastScrolledSection.id
	    };
	  },

	  render: function render() {
	    var sections = this.state.sections;

	    return _react2['default'].createElement(
	      _atomsDocumentTitle2['default'],
	      { title: 'Collections' },
	      _react2['default'].createElement(
	        _AppContext2['default'],
	        this.getAppContext(),
	        _react2['default'].createElement(
	          _organismsPage2['default'],
	          { showFooter: true },
	          sections.map(this.renderZineSection)
	        )
	      )
	    );
	  },

	  renderZineSection: function renderZineSection(section, index) {
	    return _react2['default'].createElement(
	      _atomsOffsetMonitor2['default'],
	      { onOffsetTopChange: this.handleOffsetTopChange.bind(this, section.id),
	        key: 'zineSection-' + section.id },
	      _react2['default'].createElement(_organismsZineSection2['default'], { section: section,
	        onParsePage: this.handleParsePage.bind(this, index),
	        onPageChange: this.handlePageChange.bind(this, index) })
	    );
	  },

	  handleParsePage: function handleParsePage(index) {
	    return this.parsePage(index);
	  },

	  handlePageChange: function handlePageChange(index, page) {
	    return this.replacePage(index, page);
	  },

	  handleOffsetTopChange: function handleOffsetTopChange(sectionId, offsetTop) {
	    this._offsets[sectionId] = offsetTop;
	    this.updateScrollState();
	  }
	});

	exports['default'] = ListedZinesPage;
	module.exports = exports['default'];

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _moleculesZineCover = __webpack_require__(413);

	var _moleculesZineCover2 = _interopRequireDefault(_moleculesZineCover);

	var _storesZineDraftStore = __webpack_require__(215);

	var _storesZineDraftStore2 = _interopRequireDefault(_storesZineDraftStore);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _constantsPageControlsTypes = __webpack_require__(94);

	var _constantsPageControlsTypes2 = _interopRequireDefault(_constantsPageControlsTypes);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _organismsColorPicker = __webpack_require__(207);

	var _organismsColorPicker2 = _interopRequireDefault(_organismsColorPicker);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _AppContext = __webpack_require__(67);

	var _AppContext2 = _interopRequireDefault(_AppContext);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	'use strict';

	var NewZinePage = _react2['default'].createClass({
	  displayName: 'NewZinePage',

	  mixins: [_mixinsClassNameMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesZineDraftStore2['default']), _mixinsPureRenderMixin2['default']],

	  statics: {
	    willTransitionTo: function willTransitionTo(transition) {
	      if (!_storesUserStore2['default'].isAuthenticated()) {
	        transition.redirect('about');
	      }

	      _actionsZineActionCreators2['default'].destroyZineDraft();
	    },

	    willTransitionFrom: function willTransitionFrom() {
	      _actionsZineActionCreators2['default'].destroyZineDraft();
	    }
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      zine: _storesZineDraftStore2['default'].getActiveDraft()
	    };
	  },

	  getNavigationContext: function getNavigationContext() {
	    return [_constantsNavigationContextTypes2['default'].ZINE, {
	      isEditing: true
	    }];
	  },

	  getPageControls: function getPageControls() {
	    return [_constantsPageControlsTypes2['default'].ZINE_EDIT];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    var _getPageControls = this.getPageControls();

	    var _getPageControls2 = _slicedToArray(_getPageControls, 2);

	    var pageControlsType = _getPageControls2[0];
	    var pageControlsOptions = _getPageControls2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions,
	      pageControlsType: pageControlsType,
	      pageControlsOptions: pageControlsOptions
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    _actionsZineActionCreators2['default'].createNewZineDraft({
	      backColor: _organismsColorPicker2['default'].getRandomColor(),
	      curator: _storesUserStore2['default'].getMe().id,
	      title: '',
	      description: '',
	      coverUrl: null,
	      thumbnailUrl: null,
	      status: _constantsZineStatus2['default'].PUBLIC
	    });
	  },

	  render: function render() {
	    var zine = this.state.zine;

	    return _react2['default'].createElement(
	      _AppContext2['default'],
	      this.getAppContext(),
	      _react2['default'].createElement(
	        _atomsDocumentTitle2['default'],
	        { title: zine && zine.title || 'New Collection' },
	        _react2['default'].createElement(
	          'div',
	          { className: this.getClassName() },
	          zine && _react2['default'].createElement(_moleculesZineCover2['default'], { zine: zine,
	            isEditing: true })
	        )
	      )
	    );
	  }
	});

	exports['default'] = NewZinePage;
	module.exports = exports['default'];

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var React = __webpack_require__(1),
	    NavigationContextTypes = __webpack_require__(51),
	    ScreenSizeStore = __webpack_require__(121),
	    DocumentTitle = __webpack_require__(68),
	    Page = __webpack_require__(97),
	    Container = __webpack_require__(81),
	    PureRenderMixin = __webpack_require__(2),
	    PageQueryMixin = __webpack_require__(129),
	    AppContext = __webpack_require__(67);

	var COLUMNS = 4;

	var PrivacyPage = React.createClass({
	  displayName: 'PrivacyPage',

	  mixins: [PageQueryMixin, PureRenderMixin],

	  getNavigationContext: function getNavigationContext() {
	    var _state = this.state;
	    var hasScrolledPastUsers = _state.hasScrolledPastUsers;
	    var hasScrolledPastZines = _state.hasScrolledPastZines;
	    var hasScrolledPastStamps = _state.hasScrolledPastStamps;

	    return [NavigationContextTypes.SEARCH, {
	      hasScrolledPastUsers: hasScrolledPastUsers,
	      hasScrolledPastZines: hasScrolledPastZines,
	      hasScrolledPastStamps: hasScrolledPastStamps
	    }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        DocumentTitle,
	        { title: 'Privacy Policy' },
	        React.createElement(
	          Page,
	          { showFooter: true, background: 'fff' },
	          React.createElement(
	            Container,
	            { context: 'Page', className: 'Terms-page' },
	            React.createElement(
	              'div',
	              null,
	              React.createElement(
	                'h1',
	                { style: { marginBottom: '1.5rem' } },
	                'Privacy Policy'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                React.createElement(
	                  'em',
	                  null,
	                  'Effective date: November 26, 2017'
	                )
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'We only collect the minimum amount of personal information that is necessary to fulfill the purpose of your interaction with Stampsy website. We use this information to provide you with personalized and efficient experience. We don\'t sell your information to third parties, and we only use it as this Privacy Policy describes.'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Our Policy applies to all visitors and registered users of Stampsy website. Please read this Policy carefully before accessing the website. By accessing or using any part of the website, you agree to become bound by the conditions of this Policy.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '1. Information We Collect'
	              ),
	              React.createElement(
	                'h3',
	                { className: 'Terms-subtitle' },
	                'Information You Provide to Us'
	              ),
	              React.createElement(
	                'ol',
	                { className: 'Terms-paragraph' },
	                React.createElement(
	                  'li',
	                  null,
	                  'Your e-mail address and password when you register for a Stampsy account with your email address.'
	                ),
	                React.createElement(
	                  'li',
	                  null,
	                  'Your social media account names when you register for a Stampsy account with your social media account.'
	                ),
	                React.createElement(
	                  'li',
	                  null,
	                  'The information you provide for your user profile (e.g., your name, picture, short bio, location, social media accounts and website address).'
	                ),
	                React.createElement(
	                  'li',
	                  null,
	                  'User Content (e.g., photos, text content, and other materials) that you post to the website.'
	                ),
	                React.createElement(
	                  'li',
	                  null,
	                  'E-mail communications: Stampsy may send you e-mails with Stampsy news, product updates or surveys. You may also receive service-related notification e-mails from Stampsy (e.g. notifications of your actions or other users actions related to your content on Stampsy). If you do not want to receive e-mail from Stampsy, please visit the Notifications tab of your Settings.'
	                )
	              ),
	              React.createElement(
	                'h3',
	                { className: 'Terms-subtitle' },
	                'Analytics Information'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'We use third-party analytics tools like Google Analytics to help us measure traffic and analyze how our website is used. These tools collect information sent by your browser in an anonymous form that does not include personal information. This information helps us in improving our website.'
	              ),
	              React.createElement(
	                'h3',
	                { className: 'Terms-subtitle' },
	                'Cookies and Similar Technologies'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Cookies are small pieces of text that our web server sends to your browser. Your browser stores cookies on your computer or mobile device and sends to us when you return to our site. We use cookies to let you navigate between the website pages efficiently and to let you log in and out of your Stampsy account. The cookies we use do not contain personal information.'
	              ),
	              React.createElement(
	                'h3',
	                { className: 'Terms-subtitle' },
	                'Log File Information'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'When you visit our website, our servers automatically record certain log file information, including your web request, Internet Protocol ("IP") address, browser type, referring / exit pages and URLs and other such information. We may also collect similar information from emails sent to our Users which then help us track which emails are opened and which links are clicked by recipients.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '2. Sharing Your Information'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'We neither rent nor sell your personal information to anyone. We do not share your personal information with organizations, companies, or individuals outside of Stampsy unless one of the following circumstances apply:'
	              ),
	              React.createElement(
	                'ul',
	                { className: 'Terms-paragraph', style: { listStyle: 'disc', paddingLeft: '1.15rem' } },
	                React.createElement(
	                  'li',
	                  null,
	                  'With your consent. We will share information with organizations, companies, or individuals outside of Stampsy when we have your permission to do so.'
	                ),
	                React.createElement(
	                  'li',
	                  null,
	                  'For legal reasons. We will share information with organizations, companies, or individuals outside of Stampsy if necessary to:',
	                  React.createElement(
	                    'ul',
	                    { style: { listStyle: 'disc', paddingLeft: '1.15rem' } },
	                    React.createElement(
	                      'li',
	                      null,
	                      'Meet any applicable law, regulation, legal process, or government request.'
	                    ),
	                    React.createElement(
	                      'li',
	                      null,
	                      'Enforce applicable Terms of Service.'
	                    ),
	                    React.createElement(
	                      'li',
	                      null,
	                      'Detect, prevent, or address fraud, abuse, security, or technical issues.'
	                    )
	                  )
	                )
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '3. Keeping Information Secure'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Stampsy uses commercially reasonable safeguards to help keep the information collected through the website secure and take reasonable steps (such as requesting a unique password) to verify your identity before granting you access to your account. However, no method of transmission, or method of electronic storage, is 100% secure. Therefore, we cannot ensure the absolute security of any information you transmit to Stampsy or guarantee that information on the Service may not be accessed, disclosed, altered, or destroyed.'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Please do your part to help us. You are responsible for maintaining the secrecy of your unique password and account information, and for controlling access to emails between you and Stampsy, at all times. Your privacy settings may also be affected by changes the social media services you connect to Stampsy make to their services. We are not responsible for the functionality, privacy, or security measures of any other organization.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '4. Children Under 18 Years of Age'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'You must be 13 years and older to register to use Stampsy website. Stampsy does not specifically collect information about children. If we learn that our service has collected information from a child under the age of 13, we will delete that information as quickly as possible. We recommend that minors between the ages of 14 and 18 ask and receive their parents\' permission before using the service or sending information about themselves or anyone else over the Internet.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '5. Changes to This Privacy Policy'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Although most changes are likely to be minor, Stampsy may change our Privacy Policy from time to time. We will provide notification to Users of material changes to this Privacy Policy through our website by posting a notice on our home page or sending email to the email address specified in your account. For changes to this Privacy Policy that do not affect your rights, we encourage visitors to check this page frequently.'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = PrivacyPage;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$create = __webpack_require__(303)['default'];

	var React = __webpack_require__(1);
	var StampActionCreators = __webpack_require__(54);
	var UserActionCreators = __webpack_require__(47);
	var ZineActionCreators = __webpack_require__(41);
	var NavigationContextTypes = __webpack_require__(51);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var UserStore = __webpack_require__(5);
	var SearchStampStore = __webpack_require__(210);
	var SearchZineStore = __webpack_require__(212);
	var SearchUserStore = __webpack_require__(211);
	var SearchStore = __webpack_require__(424);
	var RouterStore = __webpack_require__(120);
	var ScreenSizeStore = __webpack_require__(121);
	var createStoreMixin = __webpack_require__(8);
	var Group = __webpack_require__(45);
	var EmptyState = __webpack_require__(59);
	var DocumentTitle = __webpack_require__(68);
	var Page = __webpack_require__(97);
	var Loader = __webpack_require__(43);
	var Container = __webpack_require__(81);
	var PureRenderMixin = __webpack_require__(2);
	var PageQueryMixin = __webpack_require__(129);
	var OffsetMonitor = __webpack_require__(128);
	var ScrollStateMixin = __webpack_require__(115);
	var getStampCountPerRow = __webpack_require__(149);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(50);

	var replaceWith = _require.replaceWith;
	var _require2 = __webpack_require__(4);

	var debounce = _require2.debounce;

	__webpack_require__(474);

	var COLUMNS = 4,
	    STAMP_ROW_COUNT = 2,
	    ZINE_ROW_COUNT = 1,
	    USER_ROW_COUNT = 1;

	var SearchPage = React.createClass({
	  displayName: 'SearchPage',

	  mixins: [createStoreMixin(StampStore, ZineStore, UserStore, SearchStampStore, SearchZineStore, SearchUserStore, SearchStore, ScreenSizeStore), PageQueryMixin, PureRenderMixin, ScrollStateMixin],

	  getStateFromStores: function getStateFromStores() {
	    var currentTerms = SearchStore.getTermsFromRoute(),
	        readyTerms = SearchStore.getLastTermsWithData(),
	        screenSize = ScreenSizeStore.getScreenSize(),
	        itemsPerRow = getStampCountPerRow(screenSize, COLUMNS);

	    return {
	      currentTerms: currentTerms,
	      readyTerms: readyTerms,

	      isExpectingCurrentTermsPage: SearchStampStore.isExpectingPage(currentTerms) || SearchUserStore.isExpectingPage(currentTerms) || SearchZineStore.isExpectingPage(currentTerms),

	      itemsPerRow: itemsPerRow,

	      stamps: SearchStampStore.getStamps(readyTerms),
	      isExpectingStampPage: SearchStampStore.isExpectingPage(readyTerms),
	      isLastStampPage: SearchStampStore.isLastPage(readyTerms),

	      users: SearchUserStore.getUsers(readyTerms),
	      isExpectingUserPage: SearchUserStore.isExpectingPage(readyTerms),
	      isLastUserPage: SearchUserStore.isLastPage(readyTerms),

	      zines: SearchZineStore.getZines(readyTerms),
	      isExpectingZinePage: SearchZineStore.isExpectingPage(readyTerms),
	      isLastZinePage: SearchZineStore.isLastPage(readyTerms)
	    };
	  },

	  getScrollState: function getScrollState() {
	    return {
	      hasScrolledPastZines: this.hasScrolledPastOffset(this._zinesOffsetTop),
	      hasScrolledPastUsers: this.hasScrolledPastOffset(this._usersOffsetTop),
	      hasScrolledPastStamps: this.hasScrolledPastOffset(this._stampsOffsetTop)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    this._zinesOffsetTop = 0;
	    this._usersOffsetTop = 0;
	    this._stampsOffsetTop = 0;
	  },

	  componentDidMount: function componentDidMount() {
	    this.debounceRequestSearchPage = debounce(this.requestSearchPage, 700);
	    this.requestSearchPage();
	  },

	  getNavigationContext: function getNavigationContext() {
	    var _state = this.state;
	    var hasScrolledPastUsers = _state.hasScrolledPastUsers;
	    var hasScrolledPastZines = _state.hasScrolledPastZines;
	    var hasScrolledPastStamps = _state.hasScrolledPastStamps;

	    return [NavigationContextTypes.SEARCH, {
	      hasScrolledPastUsers: hasScrolledPastUsers,
	      hasScrolledPastZines: hasScrolledPastZines,
	      hasScrolledPastStamps: hasScrolledPastStamps
	    }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  render: function render() {
	    var _this = this;

	    var _state2 = this.state;
	    var stamps = _state2.stamps;
	    var isExpectingStampPage = _state2.isExpectingStampPage;
	    var isLastStampPage = _state2.isLastStampPage;
	    var users = _state2.users;
	    var isExpectingUserPage = _state2.isExpectingUserPage;
	    var isLastUserPage = _state2.isLastUserPage;
	    var zines = _state2.zines;
	    var isExpectingZinePage = _state2.isExpectingZinePage;
	    var isLastZinePage = _state2.isLastZinePage;
	    var itemsPerRow = _state2.itemsPerRow;
	    var currentTerms = _state2.currentTerms;
	    var readyTerms = _state2.readyTerms;

	    var perStampsFirstPage = itemsPerRow * STAMP_ROW_COUNT,
	        perUsersFirstPage = itemsPerRow * USER_ROW_COUNT,
	        perZinesFirstPage = itemsPerRow * ZINE_ROW_COUNT,
	        isEmpty;

	    isEmpty = currentTerms === readyTerms && currentTerms.length > 0 && stamps.length === 0 && users.length === 0 && zines.length === 0 && isLastStampPage && isLastUserPage && isLastZinePage && !isExpectingStampPage && !isExpectingUserPage && !isExpectingZinePage;

	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        DocumentTitle,
	        { title: 'Search' },
	        React.createElement(
	          Page,
	          null,
	          this.renderInput(),
	          zines.length > 0 && React.createElement(
	            OffsetMonitor,
	            { onOffsetTopChange: this.handleZinesOffsetTopChange },
	            React.createElement(
	              Container,
	              { context: 'Page' },
	              React.createElement(Group, { type: 'zines',
	                title: 'Matching Collections',
	                mode: 'grid',
	                columns: COLUMNS,
	                perFirstPage: perZinesFirstPage,
	                context: 'page',
	                items: zines,
	                itemProps: { size: 'small' },
	                isExpectingPage: isExpectingZinePage,
	                isLastPage: isLastZinePage,
	                defaultPage: this.parsePage(2),
	                onPageChange: function (page) {
	                  return _this.replacePage(2, page);
	                },
	                loadNextPage: this.requestNextZinePage })
	            )
	          ),
	          users.length > 0 && React.createElement(
	            OffsetMonitor,
	            { onOffsetTopChange: this.handleUsersOffsetTopChange },
	            React.createElement(
	              Container,
	              { context: 'Page' },
	              React.createElement(Group, { type: 'users',
	                title: 'Matching Users',
	                mode: 'grid',
	                columns: COLUMNS,
	                perFirstPage: perUsersFirstPage,
	                context: 'page',
	                items: users,
	                itemProps: {
	                  vertical: true,
	                  size: 'small',
	                  imageSize: 'large',
	                  showLocation: true,
	                  showAbout: true,
	                  showFollow: true
	                },
	                isExpectingPage: isExpectingUserPage,
	                isLastPage: isLastUserPage,
	                defaultPage: this.parsePage(1),
	                onPageChange: function (page) {
	                  return _this.replacePage(1, page);
	                },
	                loadNextPage: this.requestNextUserPage })
	            )
	          ),
	          stamps.length > 0 && React.createElement(
	            OffsetMonitor,
	            { onOffsetTopChange: this.handleStampsOffsetTopChange },
	            React.createElement(
	              Container,
	              { context: 'Page' },
	              React.createElement(Group, { type: 'stamps',
	                mode: 'grid',
	                title: 'Matching Stamps',
	                columns: COLUMNS,
	                perFirstPage: perStampsFirstPage,
	                context: 'page',
	                items: stamps,
	                itemProps: { size: 'small' },
	                isExpectingPage: isExpectingStampPage,
	                isLastPage: isLastStampPage,
	                defaultPage: this.parsePage(0),
	                onPageChange: function (page) {
	                  return _this.replacePage(0, page);
	                },
	                loadNextPage: this.requestNextStampPage })
	            )
	          ),
	          isEmpty && this.renderEmptyState()
	        )
	      )
	    );
	  },

	  renderInput: function renderInput() {
	    var isExpectingCurrentTermsPage = this.state.isExpectingCurrentTermsPage;

	    return React.createElement(
	      Container,
	      { context: 'Page' },
	      React.createElement(
	        'div',
	        { className: 'utils--displayFlex',
	          style: { width: '100%' } },
	        React.createElement('input', { type: 'text',
	          className: 'SearchInput',
	          placeholder: 'Type to search',
	          autoFocus: true,
	          defaultValue: SearchStore.getTermsFromRoute(),
	          onChange: this.handleQueryChange }),
	        isExpectingCurrentTermsPage && React.createElement(Loader, { withPadding: false,
	          context: 'Search' })
	      )
	    );
	  },

	  renderEmptyState: function renderEmptyState() {
	    return React.createElement(
	      Container,
	      { context: 'Page' },
	      React.createElement(EmptyState, { label: 'Nothing found.',
	        absoluteCenter: true })
	    );
	  },

	  handleZinesOffsetTopChange: function handleZinesOffsetTopChange(zinesOffsetTop) {
	    this._zinesOffsetTop = zinesOffsetTop;
	    this.updateScrollState();
	  },

	  handleUsersOffsetTopChange: function handleUsersOffsetTopChange(usersOffsetTop) {
	    this._usersOffsetTop = usersOffsetTop;
	    this.updateScrollState();
	  },

	  handleStampsOffsetTopChange: function handleStampsOffsetTopChange(stampsOffsetTop) {
	    this._stampsOffsetTop = stampsOffsetTop;
	    this.updateScrollState();
	  },

	  handleQueryChange: function handleQueryChange(e) {
	    var _RouterStore$getRouterState = RouterStore.getRouterState();

	    var params = _RouterStore$getRouterState.params;
	    var query = _RouterStore$getRouterState.query;
	    var terms = e.target.value;

	    query = _Object$create(query);

	    if (terms.length > 0) {
	      query.q = terms;
	    } else {
	      delete query.q;
	    }

	    replaceWith('search', params, query);
	    this.debounceRequestSearchPage();
	  },

	  requestSearchPage: function requestSearchPage() {
	    var terms = SearchStore.getTermsFromRoute();
	    if (!terms.length) {
	      return;
	    }

	    StampActionCreators.requestSearchPage(terms, true);
	    UserActionCreators.requestSearchPage(terms, true);
	    ZineActionCreators.requestSearchPage(terms, true);
	  },

	  requestNextStampPage: function requestNextStampPage() {
	    var terms = SearchStore.getTermsFromRoute();
	    StampActionCreators.requestSearchPage(terms);
	  },

	  requestNextUserPage: function requestNextUserPage() {
	    var terms = SearchStore.getTermsFromRoute();
	    UserActionCreators.requestSearchPage(terms);
	  },

	  requestNextZinePage: function requestNextZinePage() {
	    var terms = SearchStore.getTermsFromRoute();
	    ZineActionCreators.requestSearchPage(terms);
	  }
	});

	module.exports = SearchPage;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var React = __webpack_require__(1);
	var StampActionCreators = __webpack_require__(54);
	var UserActionCreators = __webpack_require__(47);
	var ZineActionCreators = __webpack_require__(41);
	var NavigationContextTypes = __webpack_require__(51);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var UserStore = __webpack_require__(5);
	var SearchStampStore = __webpack_require__(210);
	var SearchZineStore = __webpack_require__(212);
	var SearchUserStore = __webpack_require__(211);
	var SearchStore = __webpack_require__(424);
	var RouterStore = __webpack_require__(120);
	var ScreenSizeStore = __webpack_require__(121);
	var createStoreMixin = __webpack_require__(8);
	var Group = __webpack_require__(45);
	var EmptyState = __webpack_require__(59);
	var DocumentTitle = __webpack_require__(68);
	var Page = __webpack_require__(97);
	var Loader = __webpack_require__(43);
	var Container = __webpack_require__(81);
	var PureRenderMixin = __webpack_require__(2);
	var PageQueryMixin = __webpack_require__(129);
	var OffsetMonitor = __webpack_require__(128);
	var ScrollStateMixin = __webpack_require__(115);
	var getStampCountPerRow = __webpack_require__(149);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(50);

	var replaceWith = _require.replaceWith;
	var _require2 = __webpack_require__(4);

	var debounce = _require2.debounce;

	__webpack_require__(474);

	var COLUMNS = 4;

	var SearchPage = React.createClass({
	  displayName: 'SearchPage',

	  mixins: [createStoreMixin(StampStore, ZineStore, UserStore, SearchStampStore, SearchZineStore, SearchUserStore, SearchStore, ScreenSizeStore), PageQueryMixin, PureRenderMixin, ScrollStateMixin],

	  getStateFromStores: function getStateFromStores() {
	    var currentTerms = SearchStore.getTermsFromRoute(),
	        readyTerms = SearchStore.getLastTermsWithData(),
	        screenSize = ScreenSizeStore.getScreenSize(),
	        itemsPerRow = getStampCountPerRow(screenSize, COLUMNS);

	    return {
	      currentTerms: currentTerms,
	      readyTerms: readyTerms,

	      isExpectingCurrentTermsPage: SearchStampStore.isExpectingPage(currentTerms) || SearchUserStore.isExpectingPage(currentTerms) || SearchZineStore.isExpectingPage(currentTerms),

	      itemsPerRow: itemsPerRow,

	      stamps: SearchStampStore.getStamps(readyTerms),
	      isExpectingStampPage: SearchStampStore.isExpectingPage(readyTerms),
	      isLastStampPage: SearchStampStore.isLastPage(readyTerms),

	      users: SearchUserStore.getUsers(readyTerms),
	      isExpectingUserPage: SearchUserStore.isExpectingPage(readyTerms),
	      isLastUserPage: SearchUserStore.isLastPage(readyTerms),

	      zines: SearchZineStore.getZines(readyTerms),
	      isExpectingZinePage: SearchZineStore.isExpectingPage(readyTerms),
	      isLastZinePage: SearchZineStore.isLastPage(readyTerms)
	    };
	  },

	  getScrollState: function getScrollState() {
	    return {
	      hasScrolledPastZines: this.hasScrolledPastOffset(this._zinesOffsetTop),
	      hasScrolledPastUsers: this.hasScrolledPastOffset(this._usersOffsetTop),
	      hasScrolledPastStamps: this.hasScrolledPastOffset(this._stampsOffsetTop)
	    };
	  },

	  getNavigationContext: function getNavigationContext() {
	    var _state = this.state;
	    var hasScrolledPastUsers = _state.hasScrolledPastUsers;
	    var hasScrolledPastZines = _state.hasScrolledPastZines;
	    var hasScrolledPastStamps = _state.hasScrolledPastStamps;

	    return [NavigationContextTypes.SEARCH, {
	      hasScrolledPastUsers: hasScrolledPastUsers,
	      hasScrolledPastZines: hasScrolledPastZines,
	      hasScrolledPastStamps: hasScrolledPastStamps
	    }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        DocumentTitle,
	        { title: 'Terms of Service' },
	        React.createElement(
	          Page,
	          { showFooter: true, background: 'fff' },
	          React.createElement(
	            Container,
	            { context: 'Page', className: 'Terms-page' },
	            React.createElement(
	              'div',
	              null,
	              React.createElement(
	                'h1',
	                { style: { marginBottom: '1.5rem' } },
	                'Terms of Service'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'The following terms and conditions govern all use of the Stampsy Application and all content, services and products available at or through the application. The Application is owned and operated by Stampsy Limited (“Stampsy”), whose principal place of business is at 1306B Asian House, 1 Hennessy Road, Wanchai, Hong Kong. The Application offered subject to your acceptance without modification of all of the terms and conditions contained herein and all other operating rules, policies (including, without limitation, Stampsy\'s Privacy Policy) and procedures that may be published from time to time by Stampsy (collectively, the “Agreement”).'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Please read this Agreement carefully before accessing the Application. By accessing or using any part of the Application, you agree to become bound by the terms and conditions of this agreement. If you do not agree to all the terms and conditions of this agreement, then you may not access the Application or use any other services provided by Stampsy. If these terms and conditions are considered an offer by Stampsy, acceptance is expressly limited to these terms. The Application is available only to individuals who are at least 13 years old.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '1. Your Stampsy Account'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'If you create account using the Application, you are responsible for maintaining the security of your account, and you are fully responsible for all activities that occur under the account and any other actions taken in connection with the account. You must not describe or assign keywords to your Content in a misleading or unlawful manner, including in a manner intended to trade on the name or reputation of others, and Stampsy may change or remove any description or keyword that it considers inappropriate or unlawful, or otherwise likely to cause Stampsy liability. You must immediately notify Stampsy of any unauthorized uses of your account or any other breaches of security. Stampsy will not be liable for any acts or omissions by You, including any damages of any kind incurred as a result of such acts or omissions.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '2. Responsibility of Contributors'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'If you operate an account, comment on a stamp, publish material using the Application, post links within a stamp, or otherwise make (or allow any third party to make) material available by means of the Application (any such material, “Content”), You are entirely responsible for the content of, and any harm resulting from, that Content. That is the case regardless of whether the Content in question constitutes text, graphics, an audio file, or a video file. By making Content available, you represent and warrant that:'
	              ),
	              React.createElement(
	                'ul',
	                null,
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'the downloading, copying and use of the Content will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark or trade secret rights, of any third party;'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'if your employer has rights to intellectual property you create, you have either (i) received permission from your employer to post or make available the Content, or (ii) secured from your employer a waiver as to all rights in or to the Content;'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'you have fully complied with any third-party licenses relating to the Content, and have done all things necessary to successfully pass through to end users any required terms;'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'the Content does not contain or install any viruses, worms, malware, Trojan horses or other harmful or destructive content;'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'the Content is not spam, is not machine- or randomly-generated, and does not contain unethical or unwanted commercial content designed to drive traffic to third party sites or boost the search engine rankings of third party sites, or to further unlawful acts (such as phishing) or mislead recipients as to the source of the material (such as spoofing);'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'the Content is not pornographic, does not contain sexual themes or nudity, does not contain threats, incite or demonstrate violence, and does not violate the privacy or publicity rights of any third party;'
	                ),
	                React.createElement(
	                  'li',
	                  { className: 'Terms-paragraph' },
	                  'your account or your stamp is not named in a manner that misleads your readers into thinking that you are another person or company. For example, your account’s URL or name is not the name of a person other than yourself or company other than your own; and'
	                )
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'By submitting Content to Stampsy for inclusion to your account, you grant Stampsy a world-wide, royalty-free, and non-exclusive license to reproduce, modify, adapt and publish the Content solely for the purpose of displaying, distributing and promoting your account. If you delete Content, Stampsy will use reasonable efforts to remove it, but you acknowledge that caching or references to the Content may not be made immediately unavailable.'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Without limiting any of those representations or warranties, Stampsy has the right (though not the obligation) to, in Stampsy’s sole discretion (i) refuse or remove any content that, in Stampsy’s reasonable opinion, violates any Stampsy policy or is in any way harmful or objectionable, or (ii) terminate or deny access to and use of the Application to any individual or entity for any reason, in Stampsy’s sole discretion.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '3. Restricted Use'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'You may not use the Stampsy Application to substantially replicate products or services offered by Stampsy. If Stampsy believes, in its sole discretion, that you have violated or attempted to violate these conditions or the spirit of these terms, your ability to use and access the Stampsy Application may be temporarily or permanently revoked, with or without notice.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '4. Responsibility of Application users'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Stampsy has not reviewed, and cannot review, all of the material posted using the Application, and cannot therefore be responsible for that material’s content, use or effects. By operating the Application, Stampsy does not represent or imply that it endorses the material there posted, or that it believes such material to be accurate, useful or non-harmful. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. The Application may contain content that is offensive, indecent, or otherwise objectionable, as well as content containing technical inaccuracies, typographical mistakes, and other errors. The Application may also contain material that violates the privacy or publicity rights, or infringes the intellectual property and other proprietary rights, of third parties, or the downloading, copying or use of which is subject to additional terms and conditions, stated or unstated. Stampsy disclaims any responsibility for any harm resulting from the use by visitors of the Application, or from any downloading by those visitors of content there posted.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '5. Content Posted on Other Websites'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'We have not reviewed, and cannot review, all of the material, made available through the websites and webpages to which Stampsy links, and that link to Stampsy. Stampsy does not have any control over those non-Stampsy websites, webpages or posted stamps on those websites, and is not responsible for their contents or their use. By linking to a non-Stampsy website or webpage, Stampsy does not represent or imply that it endorses such website or webpage. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. Stampsy disclaims any responsibility for any harm resulting from your use of non-Stampsy websites and webpages.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '6. Copyright Infringement and DMCA Policy'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'As Stampsy asks others to respect its intellectual property rights, it respects the intellectual property rights of others. If you believe that material in the Application violates your copyright, you are encouraged to notify Stampsy in accordance with Stampsy’s Digital Millennium Copyright Act (“DMCA”) Policy. Stampsy will respond to all such notices, including as required or appropriate by removing the infringing material or disabling all links to the infringing material. Stampsy will terminate a visitor’s access to and use of the Application if, under appropriate circumstances, the visitor is determined to be a repeat infringer of the copyrights or other intellectual property rights of Stampsy or others. In the case of such termination, Stampsy will have no obligation to provide a refund of any amounts previously paid to Stampsy.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '7. Intellectual Property'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'This Agreement does not transfer from Stampsy to you any Stampsy or third party intellectual property, and all right, title and interest in and to such property will remain (as between the parties) solely with Stampsy. Stampsy, Stampsy.com, Stampsy Application, the Stampsy logo, and all other trademarks, service marks, graphics and logos used in connection with the Application are trademarks or registered trademarks of Stampsy or Stampsy’s licensors. Other trademarks, service marks, graphics and logos used in connection with the Application may be the trademarks of other third parties. Your use of the Application grants you no right or license to reproduce or otherwise use any Stampsy or third-party trademarks.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '8. Attribution'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Stampsy reserves the right to display attribution links such as ‘Stampsy’ theme author, and font attribution in your blog footer or toolbar. Footer credits and the Stampsy toolbar may not be removed.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '9. Changes'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Stampsy reserves the right, at its sole discretion, to modify or replace any part of this Agreement. It is your responsibility to check this Agreement periodically for changes. Your continued use of or access to the Application following the posting of any changes to this Agreement constitutes acceptance of those changes. Stampsy may also, in the future, offer new services and/or features through the Application (including, the release of new tools and resources). Such new features and/or services shall be subject to the terms and conditions of this Agreement.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '10. Termination'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'Stampsy may terminate your access to all or any part of the Application at any time, with or without cause, with or without notice, effective immediately. If you wish to terminate this Agreement or your Stampsy account (if you have one), you may simply discontinue using the Application. All provisions of this Agreement which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '11. Disclaimer of Warranties'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'The Application is provided “as is”. Stampsy and its suppliers and licensors hereby disclaim all warranties of any kind, express or implied, including, without limitation, the warranties of merchantability, fitness for a particular purpose and non-infringement. Neither Stampsy nor its suppliers and licensors, makes any warranty that the Application will be error free or that access thereto will be continuous or uninterrupted. You understand that you download from, or otherwise obtain content or services through, the Application at your own discretion and risk.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '12. Limitation of Liability'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'In no event will Stampsy, or its suppliers or licensors, be liable with respect to any subject matter of this agreement under any contract, negligence, strict liability or other legal or equitable theory for: (i) any special, incidental or consequential damages; (ii) the cost of procurement for substitute products or services; (iii) for interruption of use or loss or corruption of data. Stampsy shall have no liability for any failure or delay due to matters beyond their reasonable control. The foregoing shall not apply to the extent prohibited by applicable law.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '13. General Representation and Warranty'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'You represent and warrant that (i) your use of the Application will be in strict accordance with the Stampsy Privacy Policy, with this Agreement and with all applicable laws and regulations (including without limitation any local laws or regulations in your country, state, city, or other governmental area, regarding online conduct and acceptable content, and including all applicable laws regarding the transmission of technical data exported from the United States or the country in which you reside) and (ii) your use of the Application will not infringe or misappropriate the intellectual property rights of any third party.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '14. Indemnification'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'You agree to indemnify and hold harmless Stampsy, its contractors, and its licensors, and their respective directors, officers, employees and agents from and against any and all claims and expenses, including attorneys’ fees, arising out of your use of the Application, including but not limited to your violation of this Agreement.'
	              ),
	              React.createElement(
	                'h2',
	                { className: 'Terms-subtitle' },
	                '15. Miscellaneous'
	              ),
	              React.createElement(
	                'p',
	                { className: 'Terms-paragraph' },
	                'This Agreement constitutes the entire agreement between Stampsy and you concerning the subject matter hereof, and they may only be modified by a written amendment signed by an authorized executive of Stampsy, or by the posting by Stampsy of a revised version. Except to the extent applicable law, if any, provides otherwise, this Agreement, any access to or use of the Application will be governed by the English law. You and Stampsy agree to submit to the exclusive jurisdiction of the courts of England to resolve any legal matter arising from the Terms. Notwithstanding this, you agree that Stampsy shall still be allowed to apply for injunctive remedies (or other equivalent types of urgent legal remedy) in any jurisdiction. The prevailing party in any action or proceeding to enforce this Agreement shall be entitled to costs and attorneys’ fees. If any part of this Agreement is held invalid or unenforceable, that part will be construed to reflect the parties’ original intent, and the remaining portions will remain in full force and effect. A waiver by either party of any term or condition of this Agreement or any breach thereof, in any one instance, will not waive such term or condition or any subsequent breach thereof. You may assign your rights under this Agreement to any party that consents to, and agrees to be bound by, its terms and conditions; Stampsy may assign its rights under this Agreement without condition. This Agreement will be binding upon and will inure to the benefit of the parties, their successors and permitted assigns.'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = SearchPage;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var React = __webpack_require__(1);
	var Analytics = __webpack_require__(52);
	var AnalyticsEvents = __webpack_require__(55);
	var Group = __webpack_require__(45);
	var Page = __webpack_require__(97);
	var Container = __webpack_require__(81);
	var EmptyState = __webpack_require__(59);
	var UserInfo = __webpack_require__(132);
	var UserActionCreators = __webpack_require__(47);
	var StampActionCreators = __webpack_require__(54);
	var ZineActionCreators = __webpack_require__(41);
	var NavigationContextTypes = __webpack_require__(51);
	var UserStore = __webpack_require__(5);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var UserLatestStampStore = __webpack_require__(213);
	var UserLikedStampStore = __webpack_require__(214);
	var UserCuratedZineStore = __webpack_require__(291);
	var ScreenSizeStore = __webpack_require__(121);
	var createStoreMixin = __webpack_require__(8);
	var ScrollStateMixin = __webpack_require__(115);
	var Loader = __webpack_require__(43);
	var DocumentTitle = __webpack_require__(68);
	var OffsetMonitor = __webpack_require__(128);
	var PureRenderMixin = __webpack_require__(2);
	var PageQueryMixin = __webpack_require__(129);
	var Button = __webpack_require__(13);
	var getStampCountPerRow = __webpack_require__(149);
	var PageControlsTypes = __webpack_require__(94);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(50);

	var isInitialPath = _require.isInitialPath;

	var transitionTo = _require.transitionTo;var PropTypes = React.PropTypes;

	var LATEST_OR_CURATED_COLUMNS = 3,
	    LIKED_COLUMNS = 4,
	    DEFAULT_ROW_COUNT = 2,
	    MIN_ITEM_COUNT = 6;

	var UserPage = React.createClass({
	  displayName: 'UserPage',

	  mixins: [ScrollStateMixin, PageQueryMixin, PureRenderMixin, createStoreMixin(UserStore, UserLatestStampStore, UserLikedStampStore, UserCuratedZineStore, StampStore, ZineStore, ScreenSizeStore)],

	  propTypes: {
	    params: PropTypes.shape({
	      userId: PropTypes.string.isRequired
	    }).isRequired
	  },

	  parseUserId: function parseUserId(props) {
	    props = props || this.props;
	    return parseInt(props.params.userId, 10);
	  },

	  getScrollState: function getScrollState(scrollY) {
	    return {
	      isScrolled: scrollY > 52,
	      hasScrolledPastPublished: this.hasScrolledPastOffset(this._publishedOffsetTop),
	      hasScrolledPastCurated: this.hasScrolledPastOffset(this._curatedOffsetTop),
	      hasScrolledPastLiked: this.hasScrolledPastOffset(this._likedOffsetTop)
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var userId = this.parseUserId(props),
	        screenSize = ScreenSizeStore.getScreenSize(),
	        latestOrCuratedPerRow = getStampCountPerRow(screenSize, LATEST_OR_CURATED_COLUMNS),
	        likedPerRow = getStampCountPerRow(screenSize, LIKED_COLUMNS),
	        isContentReady;

	    isContentReady = UserLatestStampStore.getPageCount(userId) > 0 && UserLikedStampStore.getPageCount(userId) > 0 && UserCuratedZineStore.getPageCount(userId) > 0;

	    return {
	      user: UserStore.get(userId),
	      isMe: UserStore.isMe(userId),
	      isContentReady: isContentReady,
	      latestStamps: UserLatestStampStore.getStamps(userId),
	      likedStamps: UserLikedStampStore.getStamps(userId),
	      curatedZines: UserCuratedZineStore.getZines(userId),
	      latestOrCuratedPerRow: latestOrCuratedPerRow,
	      likedPerRow: likedPerRow
	    };
	  },

	  getStampItemProps: function getStampItemProps(stamp) {
	    return {
	      primaryZine: StampStore.getPrimaryZine(stamp.id)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    this.resetRecordedOffsets();
	  },

	  componentDidMount: function componentDidMount() {
	    this.handleUserChange(this.props);
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.parseUserId() !== this.parseUserId(nextProps)) {
	      this.handleUserChange(nextProps);
	      this.setState(this.getStateFromStores(nextProps));
	      this.resetRecordedOffsets();
	    }
	  },

	  resetRecordedOffsets: function resetRecordedOffsets() {
	    this._publishedOffsetTop = 0;
	    this._curatedOffsetTop = 0;
	    this._likedOffsetTop = 0;
	  },

	  handleUserChange: function handleUserChange(props) {
	    var userId = this.parseUserId(props);

	    UserActionCreators.requestUser(userId, ['services']);
	    StampActionCreators.requestUserLatestPage(userId, true, !isInitialPath());
	    StampActionCreators.requestUserLikedPage(userId, true);
	    ZineActionCreators.requestUserCuratedPage(userId, true);

	    Analytics.trackEvent(AnalyticsEvents.USER_VIEW, {
	      userId: userId
	    });
	  },

	  getPageControls: function getPageControls() {
	    var userId = this.parseUserId(this.props);
	    return [PageControlsTypes.USER, { userId: userId }];
	  },

	  getNavigationContext: function getNavigationContext() {
	    var userId = this.parseUserId(this.props);
	    var _state = this.state;
	    var isScrolled = _state.isScrolled;
	    var hasScrolledPastPublished = _state.hasScrolledPastPublished;
	    var hasScrolledPastCurated = _state.hasScrolledPastCurated;
	    var hasScrolledPastLiked = _state.hasScrolledPastLiked;

	    return [NavigationContextTypes.USER, {
	      userId: userId,
	      isScrolled: isScrolled,
	      hasScrolledPastPublished: hasScrolledPastPublished,
	      hasScrolledPastCurated: hasScrolledPastCurated,
	      hasScrolledPastLiked: hasScrolledPastLiked
	    }];
	  },

	  getAppContext: function getAppContext() {
	    var _getPageControls = this.getPageControls();

	    var _getPageControls2 = _slicedToArray(_getPageControls, 2);

	    var pageControlsType = _getPageControls2[0];
	    var pageControlsOptions = _getPageControls2[1];

	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    return {
	      pageControlsType: pageControlsType,
	      pageControlsOptions: pageControlsOptions,
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions
	    };
	  },

	  render: function render() {
	    var user = this.state.user;

	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        DocumentTitle,
	        { title: user && user.name },
	        React.createElement(
	          Page,
	          null,
	          !user && this.renderLoader(),
	          user && this.renderInfo(user),
	          user && this.renderContent()
	        )
	      )
	    );
	  },

	  renderLoader: function renderLoader() {
	    return React.createElement(
	      Container,
	      { context: 'Page' },
	      React.createElement(Loader, { absoluteCenter: true })
	    );
	  },

	  renderInfo: function renderInfo(user) {
	    return React.createElement(
	      Container,
	      { context: 'Page',
	        fillParent: false },
	      React.createElement(UserInfo, { user: user,
	        context: 'Page',
	        size: 'large',
	        imageSize: 'xlarge',
	        vertical: true,
	        noLink: true,
	        showAbout: true,
	        showLocation: true,
	        showWebsite: true,
	        showAccounts: true,
	        showSubscribers: true,
	        showSubscriptions: true })
	    );
	  },

	  renderContent: function renderContent() {
	    var userId = this.parseUserId();

	    var _state2 = this.state;
	    var isContentReady = _state2.isContentReady;
	    var latestStamps = _state2.latestStamps;
	    var likedStamps = _state2.likedStamps;
	    var curatedZines = _state2.curatedZines;
	    var latestOrCuratedPerRow = _state2.latestOrCuratedPerRow;
	    var likedPerRow = _state2.likedPerRow;

	    if (!isContentReady) {
	      return React.createElement(
	        Container,
	        { context: 'Page' },
	        React.createElement(Loader, { absoluteCenter: true })
	      );
	    }

	    var hasLatest = latestStamps.length > 0,
	        hasCurated = curatedZines.length > 0,
	        hasLiked = likedStamps.length > 0,
	        perLatestOrCuratedFirstPage = latestOrCuratedPerRow * DEFAULT_ROW_COUNT,
	        perLikedFirstPage = likedPerRow * DEFAULT_ROW_COUNT;

	    if (perLatestOrCuratedFirstPage < MIN_ITEM_COUNT) {
	      perLatestOrCuratedFirstPage += latestOrCuratedPerRow;
	    }

	    if (perLikedFirstPage < MIN_ITEM_COUNT) {
	      perLikedFirstPage += likedPerRow;
	    }

	    if (!hasLatest && !hasCurated && !hasLiked) {
	      return this.renderEmptyState();
	    }

	    return [hasLatest && React.createElement(
	      OffsetMonitor,
	      { onOffsetTopChange: this.handlePublishedOffsetTopChange,
	        key: 'published' },
	      React.createElement(
	        Container,
	        { context: 'Page' },
	        React.createElement(Group, { title: 'Published Stamps',
	          type: 'stamps',
	          mode: 'grid',
	          context: 'page',
	          columns: LATEST_OR_CURATED_COLUMNS,
	          perFirstPage: perLatestOrCuratedFirstPage,
	          items: latestStamps,
	          itemProps: {
	            routeName: 'userLatestStamp',
	            routeParams: { userId: userId }
	          },
	          getItemProps: this.getStampItemProps,
	          isExpectingPage: UserLatestStampStore.isExpectingPage(userId),
	          isLastPage: UserLatestStampStore.isLastPage(userId),
	          isInvalidated: UserLatestStampStore.isInvalidated(userId),
	          loadNextPage: this.requestNextLatestPage,
	          defaultPage: this.parsePage(0),
	          onPageChange: this.replacePage.bind(this, 0) })
	      )
	    ), hasCurated && React.createElement(
	      OffsetMonitor,
	      { onOffsetTopChange: this.handleCuratedOffsetTopChange,
	        key: 'curated' },
	      React.createElement(
	        Container,
	        { context: 'Page' },
	        React.createElement(Group, { title: 'Collections',
	          type: 'zines',
	          mode: 'grid',
	          context: 'page',
	          columns: LATEST_OR_CURATED_COLUMNS,
	          perFirstPage: perLatestOrCuratedFirstPage,
	          items: curatedZines,
	          isExpectingPage: UserCuratedZineStore.isExpectingPage(userId),
	          isLastPage: UserCuratedZineStore.isLastPage(userId),
	          isInvalidated: UserCuratedZineStore.isInvalidated(userId),
	          loadNextPage: this.requestNextCuratedPage,
	          defaultPage: this.parsePage(1),
	          onPageChange: this.replacePage.bind(this, 1) })
	      )
	    ), hasLiked && React.createElement(
	      OffsetMonitor,
	      { onOffsetTopChange: this.handleLikedOffsetTopChange,
	        key: 'liked' },
	      React.createElement(
	        Container,
	        { context: 'Page' },
	        React.createElement(Group, { title: 'Liked Stamps',
	          type: 'stamps',
	          mode: 'grid',
	          context: 'page',
	          columns: LIKED_COLUMNS,
	          perFirstPage: perLikedFirstPage,

	          perPage: perLikedFirstPage % 5 === 0 ? 20 : 24,
	          items: likedStamps,
	          itemProps: {
	            size: 'small',
	            routeName: 'userLikedStamp',
	            routeParams: { userId: userId }
	          },
	          getItemProps: this.getStampItemProps,
	          isExpectingPage: UserLikedStampStore.isExpectingPage(userId),
	          isLastPage: UserLikedStampStore.isLastPage(userId),
	          isInvalidated: UserLikedStampStore.isInvalidated(userId),
	          loadNextPage: this.requestNextLikedPage,
	          defaultPage: this.parsePage(2),
	          onPageChange: this.replacePage.bind(this, 2) })
	      )
	    )];
	  },

	  renderEmptyState: function renderEmptyState() {
	    var _state3 = this.state;
	    var user = _state3.user;
	    var isMe = _state3.isMe;
	    var actions;

	    var label = isMe ? 'Your liked, posted stamps and created collections will be shown here.' : '' + user.name + ' has not liked, posted any stamps or created collections yet.';

	    if (isMe) {
	      actions = React.createElement(
	        'div',
	        { className: 'utils--hideOnTablet' },
	        React.createElement(
	          Button,
	          { onClick: this.handleCreateStampClick },
	          'Create a Stamp'
	        ),
	        React.createElement(
	          EmptyState.Separator,
	          null,
	          'or'
	        ),
	        React.createElement(
	          Button,
	          { onClick: this.handleCreateCollectionClick },
	          'Create a Collection'
	        )
	      );
	    }

	    return React.createElement(
	      Container,
	      { context: 'Page' },
	      React.createElement(
	        EmptyState,
	        { label: label,
	          absoluteCenter: true },
	        actions
	      )
	    );
	  },

	  handlePublishedOffsetTopChange: function handlePublishedOffsetTopChange(publishedOffsetTop) {
	    this._publishedOffsetTop = publishedOffsetTop;
	    this.updateScrollState();
	  },

	  handleCuratedOffsetTopChange: function handleCuratedOffsetTopChange(curatedOffsetTop) {
	    this._curatedOffsetTop = curatedOffsetTop;
	    this.updateScrollState();
	  },

	  handleLikedOffsetTopChange: function handleLikedOffsetTopChange(likedOffsetTop) {
	    this._likedOffsetTop = likedOffsetTop;
	    this.updateScrollState();
	  },

	  handleCreateStampClick: function handleCreateStampClick() {
	    transitionTo('draftCompose', { stampSegment: 'new' });
	  },

	  handleCreateCollectionClick: function handleCreateCollectionClick() {
	    transitionTo('zineNew');
	  },

	  requestNextLatestPage: function requestNextLatestPage() {
	    var userId = this.parseUserId();
	    StampActionCreators.requestUserLatestPage(userId);
	  },

	  requestNextLikedPage: function requestNextLikedPage() {
	    var userId = this.parseUserId();
	    StampActionCreators.requestUserLikedPage(userId);
	  },

	  requestNextCuratedPage: function requestNextCuratedPage() {
	    var userId = this.parseUserId();
	    ZineActionCreators.requestUserCuratedPage(userId);
	  }
	});

	module.exports = UserPage;
	// Avoid holes when on xl screens 4-column grid has 5 columns:

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _utilsAnalytics = __webpack_require__(52);

	var _utilsAnalytics2 = _interopRequireDefault(_utilsAnalytics);

	var _constantsAnalyticsEvents = __webpack_require__(55);

	var _constantsAnalyticsEvents2 = _interopRequireDefault(_constantsAnalyticsEvents);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _constantsPageControlsTypes = __webpack_require__(94);

	var _constantsPageControlsTypes2 = _interopRequireDefault(_constantsPageControlsTypes);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesZineDraftStore = __webpack_require__(215);

	var _storesZineDraftStore2 = _interopRequireDefault(_storesZineDraftStore);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesZineLatestStampStore = __webpack_require__(292);

	var _storesZineLatestStampStore2 = _interopRequireDefault(_storesZineLatestStampStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _organismsContainer = __webpack_require__(81);

	var _organismsContainer2 = _interopRequireDefault(_organismsContainer);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _moleculesEmptyState = __webpack_require__(59);

	var _moleculesEmptyState2 = _interopRequireDefault(_moleculesEmptyState);

	var _moleculesZineCover = __webpack_require__(413);

	var _moleculesZineCover2 = _interopRequireDefault(_moleculesZineCover);

	var _atomsLoader = __webpack_require__(43);

	var _atomsLoader2 = _interopRequireDefault(_atomsLoader);

	var _mixinsScrollStateMixin = __webpack_require__(115);

	var _mixinsScrollStateMixin2 = _interopRequireDefault(_mixinsScrollStateMixin);

	var _mixinsBackColorMixin = __webpack_require__(56);

	var _mixinsBackColorMixin2 = _interopRequireDefault(_mixinsBackColorMixin);

	var _organismsPage = __webpack_require__(97);

	var _organismsPage2 = _interopRequireDefault(_organismsPage);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsPageQueryMixin = __webpack_require__(129);

	var _mixinsPageQueryMixin2 = _interopRequireDefault(_mixinsPageQueryMixin);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _constantsZineStatus = __webpack_require__(114);

	var _constantsZineStatus2 = _interopRequireDefault(_constantsZineStatus);

	var _AppContext = __webpack_require__(67);

	var _AppContext2 = _interopRequireDefault(_AppContext);

	var _router = __webpack_require__(50);

	'use strict';

	var ZinePage = _react2['default'].createClass({
	  displayName: 'ZinePage',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesZineStore2['default'], _storesZineDraftStore2['default'], _storesZineLatestStampStore2['default'], _storesStampStore2['default']), _mixinsScrollStateMixin2['default'], _mixinsBackColorMixin2['default'], _mixinsPageQueryMixin2['default'], _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    params: _react.PropTypes.shape({
	      zineSlug: _react.PropTypes.string.isRequired
	    }).isRequired
	  },

	  statics: {
	    getHandlerKey: function getHandlerKey(params) {
	      return params.zineSlug;
	    },

	    willTransitionTo: function willTransitionTo() {
	      _actionsZineActionCreators2['default'].destroyZineDraft();
	    },

	    willTransitionFrom: function willTransitionFrom(transition) {
	      if (_storesZineDraftStore2['default'].isEditing()) {
	        _actionsZineActionCreators2['default'].destroyZineDraft();
	      }
	    }
	  },

	  parseSlug: function parseSlug(props) {
	    props = props || this.props;
	    return props.params.zineSlug;
	  },

	  getScrollState: function getScrollState(scrollY) {
	    return {
	      isScrolled: scrollY > 52
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var slug = this.parseSlug(props),
	        zine = _storesZineDraftStore2['default'].getActiveDraft() || _storesZineStore2['default'].get(slug);

	    return {
	      zine: zine,
	      isEditing: _storesZineDraftStore2['default'].isEditing(),
	      latestStamps: _storesZineLatestStampStore2['default'].getStamps(slug)
	    };
	  },

	  getNavigationContext: function getNavigationContext() {
	    var zineSlug = this.parseSlug(this.props);
	    var _state = this.state;
	    var isScrolled = _state.isScrolled;
	    var isEditing = _state.isEditing;

	    return [_constantsNavigationContextTypes2['default'].ZINE, {
	      zineSlug: zineSlug,
	      isScrolled: isScrolled,
	      isEditing: isEditing
	    }];
	  },

	  getPageControls: function getPageControls() {
	    var zineSlug = this.parseSlug(this.props);
	    var isEditing = this.state.isEditing;

	    var type = isEditing ? _constantsPageControlsTypes2['default'].ZINE_EDIT : _constantsPageControlsTypes2['default'].ZINE;

	    return [type, { zineSlug: zineSlug }];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    var _getPageControls = this.getPageControls();

	    var _getPageControls2 = _slicedToArray(_getPageControls, 2);

	    var pageControlsType = _getPageControls2[0];
	    var pageControlsOptions = _getPageControls2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions,
	      pageControlsType: pageControlsType,
	      pageControlsOptions: pageControlsOptions
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var zineSlug = this.parseSlug(this.props);

	    _actionsZineActionCreators2['default'].requestZine(zineSlug, ['contributorCount']);
	    _actionsStampActionCreators2['default'].requestZineLatestPage(zineSlug, true, !(0, _router.isInitialPath)());

	    _utilsAnalytics2['default'].trackEvent(_constantsAnalyticsEvents2['default'].ZINE_VIEW, {
	      zineSlug: zineSlug
	    });
	  },

	  render: function render() {
	    var zine = this.state.zine;

	    return _react2['default'].createElement(
	      _AppContext2['default'],
	      this.getAppContext(),
	      _react2['default'].createElement(
	        _atomsDocumentTitle2['default'],
	        { title: zine && zine.title },
	        _react2['default'].createElement(
	          _organismsPage2['default'],
	          { background: zine && zine.backColor },
	          !zine && _react2['default'].createElement(_atomsLoader2['default'], { absoluteCenter: true }),
	          zine && this.renderCover(),
	          zine && this.renderLatest()
	        )
	      )
	    );
	  },

	  renderCover: function renderCover() {
	    return _react2['default'].createElement(_moleculesZineCover2['default'], { zine: this.state.zine,
	      isEditing: this.state.isEditing,
	      fullWidth: true });
	  },

	  renderLatest: function renderLatest() {
	    if (this.state.isEditing) {
	      return;
	    }

	    var slug = this.parseSlug();
	    var zine = this.state.zine;
	    var textColor = this.getTextColor(zine.backColor);

	    var itemProps = undefined;
	    if (zine.status === _constantsZineStatus2['default'].PUBLIC) {
	      itemProps = {
	        routeName: 'zineLatestStamp',
	        routeParams: { zineSlug: slug }
	      };
	    } else {
	      itemProps = {
	        routeName: 'feedStamp'
	      };
	    }

	    return _react2['default'].createElement(
	      _organismsContainer2['default'],
	      { context: 'ZinePage',
	        color: textColor },
	      _react2['default'].createElement(
	        _organismsGroup2['default'],
	        { color: textColor,
	          type: 'stamps',
	          mode: 'grid',
	          columns: 3,
	          context: 'Page',
	          isExpectingPage: _storesZineLatestStampStore2['default'].isExpectingPage(slug),
	          isLastPage: _storesZineLatestStampStore2['default'].isLastPage(slug),
	          isInvalidated: _storesZineLatestStampStore2['default'].isInvalidated(slug),
	          defaultPage: this.parsePage(),
	          onPageChange: this.replacePage,
	          loadNextPage: this.requestNextLatestPage,
	          items: this.state.latestStamps,
	          itemProps: itemProps },
	        _react2['default'].createElement(
	          _moleculesEmptyState2['default'],
	          { label: 'This collection does not have any stamps yet.' },
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { color: textColor, onClick: this.handleSubmitStampClick },
	            zine.canEdit ? 'Add a Stamp' : 'Submit a Stamp'
	          )
	        )
	      )
	    );
	  },

	  handleSubmitStampClick: function handleSubmitStampClick() {
	    _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].ADD_STAMPS_TO_ZINE, {
	      zineSlug: this.parseSlug()
	    });
	  },

	  requestNextLatestPage: function requestNextLatestPage() {
	    var slug = this.parseSlug();
	    _actionsStampActionCreators2['default'].requestZineLatestPage(slug);
	  }
	});

	exports['default'] = ZinePage;
	module.exports = exports['default'];

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var React = __webpack_require__(1),
	    Page = __webpack_require__(97),
	    Loader = __webpack_require__(43),
	    PureRenderMixin = __webpack_require__(2);

	function createAsyncPage(handlerPromiseFactory, displayName) {
	  var AsyncPage = React.createClass({
	    displayName: 'Async' + displayName,

	    mixins: [PureRenderMixin],

	    statics: {
	      willTransitionTo: function willTransitionTo(transition, params, query, callback) {
	        AsyncPage.handlerPromiseFactory().then(function (handler) {
	          if (handler.willTransitionTo) {
	            handler.willTransitionTo(transition, params, query, callback);

	            if (handler.willTransitionTo.length < 4) {
	              callback();
	            }
	          } else {
	            callback();
	          }
	        });
	      },

	      willTransitionFrom: function willTransitionFrom(transition, component, callback) {
	        var handler = AsyncPage.cachedHandler;
	        if (handler && handler.willTransitionFrom) {
	          handler.willTransitionFrom(transition, component, callback);

	          if (handler.willTransitionFrom.length < 3) {
	            callback();
	          }
	        } else {
	          callback();
	        }
	      }
	    },

	    getInitialState: function getInitialState() {
	      return {
	        handler: AsyncPage.cachedHandler
	      };
	    },

	    componentWillMount: function componentWillMount() {
	      var _this = this;

	      if (this.state.handler) {
	        return;
	      }

	      AsyncPage.handlerPromiseFactory().then(function (handler) {
	        AsyncPage.cachedHandler = handler;

	        if (_this.isMounted()) {
	          _this.setState({ handler: handler });
	        }
	      });
	    },

	    render: function render() {
	      var Handler = this.state.handler;
	      if (Handler) {
	        return React.createElement(Handler, this.props);
	      }

	      return React.createElement(
	        Page,
	        null,
	        React.createElement(Loader, { absoluteCenter: true })
	      );
	    }
	  });

	  if (module.makeHot) {
	    AsyncPage = module.makeHot(AsyncPage, displayName);
	  }

	  AsyncPage.handlerPromiseFactory = handlerPromiseFactory;

	  return AsyncPage;
	}

	module.exports = createAsyncPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(386)(module)))

/***/ },
/* 754 */,
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Export a few requires we might need
	// from devtools and iframes.

	function requireProxy(module) {
	  switch (module) {
	    case 'react':
	      return __webpack_require__(362);
	    case 'ExternalActionCreators':
	      return __webpack_require__(554);
	    case 'AppDispatcher':
	      return __webpack_require__(6);
	    default:
	      console.warn('Module "' + module + '" not defined for external require in requireProxy');
	  }
	}

	module.exports = requireProxy;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _require = __webpack_require__(154);

	var Route = _require.Route;
	var DefaultRoute = _require.DefaultRoute;

	var Redirect = _require.Redirect;
	var AboutPage = __webpack_require__(740);
	var TermsPage = __webpack_require__(750);
	var PrivacyPage = __webpack_require__(748);
	var loadEditorChunk = __webpack_require__(1048);
	var loadStampChunk = __webpack_require__(1050);
	var HomePage = __webpack_require__(745);
	var FeedPage = __webpack_require__(744);
	var SearchPage = __webpack_require__(749);
	var UserPage = __webpack_require__(751);
	var ZinePage = __webpack_require__(752);
	var NewZinePage = __webpack_require__(747);
	var ListedZinesPage = __webpack_require__(746);
	var StampPageMixins = __webpack_require__(260);
	var createAsyncPage = __webpack_require__(753);
	var App = __webpack_require__(550);

	function makeAsyncEditorHandler(key) {
	  return createAsyncPage(function () {
	    return loadEditorChunk().then(function (chunk) {
	      return chunk[key];
	    });
	  }, key);
	}

	function makeAsyncStampHandler(routeName, stampPageMixin) {
	  return createAsyncPage(function () {
	    return loadStampChunk().then(function (stampChunk) {
	      return stampChunk.createStampPage({
	        routeName: routeName,
	        stampPageMixin: stampPageMixin
	      });
	    });
	  }, routeName);
	}

	function makeStampRoute(routeName, stampPageMixin, path) {
	  return React.createElement(Route, { name: routeName,
	    path: path,
	    handler: makeAsyncStampHandler(routeName, stampPageMixin) });
	}

	module.exports = React.createElement(
	  Route,
	  { handler: App, fillHeight: true },
	  React.createElement(
	    Route,
	    { name: 'home', path: '/', handler: HomePage },
	    React.createElement(Route, { name: 'feed', path: '/', handler: FeedPage })
	  ),
	  React.createElement(Route, { name: 'zines', path: '/collections', handler: ListedZinesPage }),
	  React.createElement(Route, { name: 'search', path: '/search', handler: SearchPage }),
	  React.createElement(Route, { name: 'about', path: '/about', handler: AboutPage }),
	  React.createElement(Route, { name: 'terms', path: '/terms', handler: TermsPage }),
	  React.createElement(Route, { name: 'privacy', path: '/privacy', handler: PrivacyPage }),
	  React.createElement(
	    Route,
	    { path: '/draft/:stampSegment', handler: makeAsyncEditorHandler('DraftPage') },
	    React.createElement(Route, { name: 'draftCompose', path: 'edit', handler: makeAsyncEditorHandler('DraftComposePage') }),
	    React.createElement(DefaultRoute, { name: 'draftPreview', handler: makeAsyncEditorHandler('DraftPreviewPage') })
	  ),
	  React.createElement(Redirect, { from: '/editor/new', to: '/draft/new/edit' }),
	  React.createElement(Redirect, { from: '/editor', to: '/draft/new/edit' }),
	  React.createElement(
	    Route,
	    { path: '/stamp/:stampSegment/edit', handler: makeAsyncEditorHandler('DraftPage') },
	    React.createElement(DefaultRoute, { name: 'stampEditCompose', handler: makeAsyncEditorHandler('DraftComposePage') }),
	    React.createElement(Route, { name: 'stampEditPreview', path: 'preview', handler: makeAsyncEditorHandler('DraftPreviewPage') })
	  ),
	  React.createElement(Route, { name: 'user', path: '/user/:userId', handler: UserPage }),
	  React.createElement(Redirect, { from: '/user/:userId/latest', to: 'user' }),
	  React.createElement(Redirect, { from: '/user/:userId/likes', to: 'user' }),
	  React.createElement(Redirect, { from: '/user/:userId/curated', to: 'user' }),
	  makeStampRoute('feedStamp', StampPageMixins.Feed, '/stamp/:stampSegment'),
	  makeStampRoute('userLatestStamp', StampPageMixins.UserLatest, '/user/:userId/latest/:stampSegment'),
	  makeStampRoute('userLikedStamp', StampPageMixins.UserLiked, '/user/:userId/likes/:stampSegment'),
	  makeStampRoute('zineLatestStamp', StampPageMixins.ZineLatest, '/:zineSlug/latest/:stampSegment'),
	  makeStampRoute('zinePendingStamp', StampPageMixins.ZinePending, '/:zineSlug/pending/:stampSegment'),
	  React.createElement(Redirect, { from: '/feed/:stampSegment', to: 'feedStamp' }),
	  React.createElement(Redirect, { from: '/feed/:zineSlug/:stampSegment', to: 'feedStamp' }),
	  React.createElement(Redirect, { from: '/top/:stampSegment', to: 'feedStamp' }),
	  React.createElement(Redirect, { from: '/trending/:stampSegment', to: 'feedStamp' }),
	  React.createElement(Redirect, { from: '/:zineSlug/trending/:stampSegment', to: 'zineLatestStamp' }),
	  React.createElement(Route, { name: 'zine', path: '/:zineSlug', handler: ZinePage }),
	  React.createElement(Route, { name: 'zineNew', path: '/collections/new', handler: NewZinePage }),
	  React.createElement(Redirect, { from: '/:zineSlug/trending', to: 'zine' }),
	  React.createElement(Redirect, { from: '/:zineSlug/latest', to: 'zine' }),
	  React.createElement(Redirect, { from: '/:zineSlug/pending', to: 'zine' })
	);

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Group = __webpack_require__(45),
	    SidebarBody = __webpack_require__(57),
	    createStoreMixin = __webpack_require__(8),
	    ActivityListStore = __webpack_require__(287),
	    UserStore = __webpack_require__(5),
	    ActivityActionCreators = __webpack_require__(247),
	    PureRenderMixin = __webpack_require__(2);

	var ACTIVITY_PAGE_POLL_INTERVAL = 3000;

	if (false) {
	  ACTIVITY_PAGE_POLL_INTERVAL *= 10;
	}

	var Activities = React.createClass({
	  displayName: 'Activities',

	  mixins: [createStoreMixin(ActivityListStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    var activities = ActivityListStore.getActivities();

	    return {
	      activities: activities
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    ActivityActionCreators.requestActivityPage(true);

	    this.activitiesInterval = setInterval(function () {
	      ActivityActionCreators.requestActivityPage(true);
	    }, ACTIVITY_PAGE_POLL_INTERVAL);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    ActivityActionCreators.markAll();

	    clearInterval(this.activitiesInterval);
	  },

	  render: function render() {
	    var userId = UserStore.getMe().id;

	    return React.createElement(
	      SidebarBody,
	      { title: 'Notifications' },
	      React.createElement(Group, { type: 'activities',
	        items: this.state.activities,
	        context: 'sidebar',
	        mode: 'list',
	        isExpectingPage: ActivityListStore.isExpectingPage(userId),
	        isLastPage: ActivityListStore.isLastPage(userId),
	        isInvalidated: ActivityListStore.isInvalidated(userId),
	        loadNextPage: this.requestNextPage })
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    ActivityActionCreators.requestActivityPage();
	  }
	});

	module.exports = Activities;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesZineStore = __webpack_require__(22);

	var _storesZineStore2 = _interopRequireDefault(_storesZineStore);

	var _storesUserCuratedZineStore = __webpack_require__(291);

	var _storesUserCuratedZineStore2 = _interopRequireDefault(_storesUserCuratedZineStore);

	var _storesUserCuratedUnlistedZineStore = __webpack_require__(431);

	var _storesUserCuratedUnlistedZineStore2 = _interopRequireDefault(_storesUserCuratedUnlistedZineStore);

	var _storesUserContributedZineStore = __webpack_require__(430);

	var _storesUserContributedZineStore2 = _interopRequireDefault(_storesUserContributedZineStore);

	var _storesUserContributedUnlistedZineStore = __webpack_require__(429);

	var _storesUserContributedUnlistedZineStore2 = _interopRequireDefault(_storesUserContributedUnlistedZineStore);

	var _storesSuggestedZineStore = __webpack_require__(427);

	var _storesSuggestedZineStore2 = _interopRequireDefault(_storesSuggestedZineStore);

	var _actionsZineActionCreators = __webpack_require__(41);

	var _actionsZineActionCreators2 = _interopRequireDefault(_actionsZineActionCreators);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _organismsSidebarBody = __webpack_require__(57);

	var _organismsSidebarBody2 = _interopRequireDefault(_organismsSidebarBody);

	var _moleculesEmptyState = __webpack_require__(59);

	var _moleculesEmptyState2 = _interopRequireDefault(_moleculesEmptyState);

	var _atomsLoader = __webpack_require__(43);

	var _atomsLoader2 = _interopRequireDefault(_atomsLoader);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _router = __webpack_require__(50);

	var _constantsStampStatus = __webpack_require__(95);

	var _constantsStampStatus2 = _interopRequireDefault(_constantsStampStatus);

	'use strict';

	var AddStampToZines = _react2['default'].createClass({
	  displayName: 'AddStampToZines',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesUserContributedZineStore2['default'], _storesUserContributedUnlistedZineStore2['default'], _storesUserCuratedZineStore2['default'], _storesUserCuratedUnlistedZineStore2['default'], _storesSuggestedZineStore2['default'], _storesStampStore2['default'], _storesZineStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = _storesStampStore2['default'].get(props.stampId);
	    var me = _storesUserStore2['default'].getMe();
	    var isMyStamp = _storesUserStore2['default'].isMe(stamp.user);
	    var isPublicStamp = stamp.status === _constantsStampStatus2['default'].PUBLIC;

	    var curatedStore = this.getCuratedStore(stamp);
	    var curatedZines = curatedStore.getZines(me.id);

	    var isReady = curatedStore.getPageCount(me.id) > 0;
	    var contributedZines = [];
	    var suggestedZines = [];

	    var contributedStore = this.getContributedStore(stamp);
	    if (isMyStamp) {
	      contributedZines = contributedStore.getZines(me.id);
	      isReady = isReady && contributedStore.getPageCount(me.id) > 0;

	      if (isPublicStamp) {
	        suggestedZines = _storesSuggestedZineStore2['default'].getZines();
	        isReady = isReady && _storesSuggestedZineStore2['default'].getPageCount() > 0;
	      }
	    }

	    return {
	      isPublicStamp: isPublicStamp,
	      stamp: stamp,
	      isMyStamp: isMyStamp,
	      isReady: isReady,
	      curatedZines: curatedZines,
	      contributedZines: contributedZines,
	      suggestedZines: suggestedZines
	    };
	  },

	  getCuratedStore: function getCuratedStore(stamp) {
	    var isPublic = stamp.status === _constantsStampStatus2['default'].PUBLIC;
	    return isPublic ? _storesUserCuratedZineStore2['default'] : _storesUserCuratedUnlistedZineStore2['default'];
	  },

	  getContributedStore: function getContributedStore(stamp) {
	    var isPublic = stamp.status === _constantsStampStatus2['default'].PUBLIC;
	    return isPublic ? _storesUserContributedZineStore2['default'] : _storesUserContributedUnlistedZineStore2['default'];
	  },

	  componentDidMount: function componentDidMount() {
	    var me = _storesUserStore2['default'].getMe();

	    if (this.state.isPublicStamp) {
	      _actionsZineActionCreators2['default'].requestUserCuratedPage(me.id, true);
	    } else {
	      _actionsZineActionCreators2['default'].requestUserCuratedUnlistedPage(me.id, true);
	    }

	    if (this.state.isMyStamp) {
	      if (this.state.isPublicStamp) {
	        _actionsZineActionCreators2['default'].requestUserContributedPage(me.id, true);
	      } else {
	        _actionsZineActionCreators2['default'].requestUserContributedUnlistedPage(me.id, true);
	      }
	      _actionsZineActionCreators2['default'].requestSuggestedPage(true);
	    }
	  },

	  render: function render() {
	    var isMyStamp = this.state.isMyStamp;
	    var title;
	    var subtitle;

	    if (isMyStamp) {
	      title = 'Submit to Collections';
	      subtitle = _react2['default'].createElement(
	        'span',
	        null,
	        'Submit your Stamp to one or more relevant collections.',
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'span',
	          null,
	          'You may have to wait for approval to collections curated by other users.'
	        )
	      );
	    } else {
	      title = 'Add to Collections';
	      subtitle = 'Add this Stamp to one or more relevant collections.';
	    }

	    return _react2['default'].createElement(
	      _organismsSidebarBody2['default'],
	      { title: title,
	        subtitle: subtitle },
	      this.renderGroups()
	    );
	  },

	  renderGroups: function renderGroups() {
	    if (!this.state.isReady) {
	      return _react2['default'].createElement(_atomsLoader2['default'], { absoluteCenter: true });
	    }

	    var userId = _storesUserStore2['default'].getMe().id;
	    var _state = this.state;
	    var stamp = _state.stamp;
	    var suggestedZines = _state.suggestedZines;
	    var contributedZines = _state.contributedZines;
	    var curatedZines = _state.curatedZines;
	    var isPublicStamp = _state.isPublicStamp;

	    var hasCurated = curatedZines.length > 0;
	    var hasContributed = contributedZines.length > 0;
	    var hasSuggested = suggestedZines.length > 0;
	    var curatedStore = this.getCuratedStore(stamp);
	    var contributedStore = this.getContributedStore(stamp);
	    var emptyLabel = isPublicStamp ? 'Currently you are not curating any collections.' : 'Currently you are not curating any secret collections.';

	    if (!hasCurated && !hasContributed && !hasSuggested) {
	      return _react2['default'].createElement(
	        _moleculesEmptyState2['default'],
	        { label: emptyLabel,
	          absoluteCenter: true },
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { onClick: this.handleCreateCollectionClick,
	            hideOnMobile: true },
	          'Create a Collection'
	        )
	      );
	    }

	    return {
	      curatedZines: hasCurated && _react2['default'].createElement(_organismsGroup2['default'], { title: 'My Collections',
	        type: 'zines',
	        items: curatedZines,
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: { size: 'small', showSubmit: true, stamp: stamp },
	        isExpectingPage: curatedStore.isExpectingPage(userId),
	        isLastPage: curatedStore.isLastPage(userId),
	        isInvalidated: curatedStore.isInvalidated(userId),
	        loadNextPage: this.requestNextCuratedPage }),

	      contributedZines: hasContributed && _react2['default'].createElement(_organismsGroup2['default'], { title: 'Recent Collections',
	        type: 'zines',
	        items: contributedZines,
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: { size: 'small', showSubmit: true, stamp: stamp },
	        isExpectingPage: contributedStore.isExpectingPage(userId),
	        isLastPage: contributedStore.isLastPage(userId),
	        isInvalidated: contributedStore.isInvalidated(userId),
	        loadNextPage: this.requestNextContributedPage }),

	      suggestedZines: hasSuggested && _react2['default'].createElement(_organismsGroup2['default'], { title: 'Trending Collections',
	        type: 'zines',
	        items: suggestedZines,
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: { size: 'small', showSubmit: true, stamp: stamp },
	        isExpectingPage: _storesSuggestedZineStore2['default'].isExpectingPage(),
	        isLastPage: _storesSuggestedZineStore2['default'].isLastPage(),
	        isInvalidated: _storesSuggestedZineStore2['default'].isInvalidated(),
	        loadNextPage: this.requestNextSuggestedPage })
	    };
	  },

	  handleCreateCollectionClick: function handleCreateCollectionClick() {
	    (0, _router.transitionTo)('zineNew');
	  },

	  requestNextCuratedPage: function requestNextCuratedPage() {
	    var userId = _storesUserStore2['default'].getMe().id;
	    if (this.state.isPublicStamp) {
	      _actionsZineActionCreators2['default'].requestUserCuratedPage(userId);
	    } else {
	      _actionsZineActionCreators2['default'].requestUserCuratedUnlistedPage(userId);
	    }
	  },

	  requestNextContributedPage: function requestNextContributedPage() {
	    var userId = _storesUserStore2['default'].getMe().id;
	    if (this.state.isPublicStamp) {
	      _actionsZineActionCreators2['default'].requestUserContributedPage(userId);
	    } else {
	      _actionsZineActionCreators2['default'].requestUserContributedUnlistedPage(userId);
	    }
	  },

	  requestNextSuggestedPage: function requestNextSuggestedPage() {
	    _actionsZineActionCreators2['default'].requestSuggestedPage();
	  }
	});

	module.exports = AddStampToZines;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var UserStore = __webpack_require__(5);
	var ZineStore = __webpack_require__(22);
	var StampStore = __webpack_require__(17);
	var UserLatestStampStore = __webpack_require__(213);
	var UserLikedStampStore = __webpack_require__(214);
	var StampActionCreators = __webpack_require__(54);
	var Group = __webpack_require__(45);
	var Loader = __webpack_require__(43);
	var SidebarBody = __webpack_require__(57);
	var EmptyState = __webpack_require__(59);
	var PureRenderMixin = __webpack_require__(2);
	var Button = __webpack_require__(13);
	var _require = __webpack_require__(50);

	var transitionTo = _require.transitionTo;var PropTypes = React.PropTypes;

	var AddStampsToZine = React.createClass({
	  displayName: 'AddStampsToZine',

	  mixins: [createStoreMixin(UserLatestStampStore, UserLikedStampStore, StampStore, ZineStore), PureRenderMixin],

	  propTypes: {
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var zine = ZineStore.get(props.zineSlug),
	        me = UserStore.getMe(),
	        isMyZine = UserStore.isMe(zine.curator),
	        latestStamps = UserLatestStampStore.getStamps(me.id),
	        isReady = UserLatestStampStore.getPageCount(me.id) > 0,
	        likedStamps = [];

	    if (isMyZine) {
	      likedStamps = UserLikedStampStore.getStamps(me.id);
	      isReady = isReady && UserLikedStampStore.getPageCount(me.id) > 0;
	    }

	    return {
	      zine: zine,
	      isReady: isReady,
	      isMyZine: isMyZine,
	      latestStamps: latestStamps,
	      likedStamps: likedStamps
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var me = UserStore.getMe();
	    StampActionCreators.requestUserLatestPage(me.id, true);

	    if (this.state.isMyZine) {
	      StampActionCreators.requestUserLikedPage(me.id, true);
	    }
	  },

	  render: function render() {
	    var isMyZine = this.state.isMyZine;
	    var title;
	    var subtitle;

	    if (isMyZine) {
	      title = 'Add Stamps';
	      subtitle = 'Pick relevant stamps for this collection.';
	    } else {
	      title = 'Submit Your Stamps';
	      subtitle = React.createElement(
	        'span',
	        null,
	        'We will notify you once the curator',
	        React.createElement('br', null),
	        'has accepted or declined your submissions.'
	      );
	    }

	    return React.createElement(
	      SidebarBody,
	      { title: title,
	        subtitle: subtitle },
	      this.renderGroups()
	    );
	  },

	  renderGroups: function renderGroups() {
	    if (!this.state.isReady) {
	      return React.createElement(Loader, { absoluteCenter: true });
	    }

	    var userId = UserStore.getMe().id;

	    var _state = this.state;
	    var zine = _state.zine;
	    var latestStamps = _state.latestStamps;
	    var likedStamps = _state.likedStamps;
	    var isMyZine = _state.isMyZine;

	    var hasLatest = latestStamps.length > 0,
	        hasLiked = likedStamps.length > 0;

	    if (!hasLatest && !hasLiked) {
	      var label = isMyZine ? 'You do not have any published or liked stamps.' : 'You do not have any published stamps.';

	      return React.createElement(
	        EmptyState,
	        { label: label,
	          absoluteCenter: true },
	        React.createElement(
	          Button,
	          { onClick: this.handleCreateStampClick },
	          'Create a Stamp'
	        )
	      );
	    }

	    return {
	      latestStamps: hasLatest && React.createElement(Group, { type: 'stamps',
	        title: 'Published Stamps',
	        items: latestStamps,
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: {
	          size: 'small',
	          showSubmit: true,
	          targetZine: zine
	        },
	        isExpectingPage: UserLatestStampStore.isExpectingPage(userId),
	        isLastPage: UserLatestStampStore.isLastPage(userId),
	        isInvalidated: UserLatestStampStore.isInvalidated(userId),
	        loadNextPage: this.requestNextLatestPage }),

	      likedStamps: hasLiked && React.createElement(Group, { type: 'stamps',
	        title: 'Liked Stamps',
	        items: likedStamps,
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: {
	          size: 'small',
	          showSubmit: true,
	          targetZine: zine
	        },
	        isExpectingPage: UserLikedStampStore.isExpectingPage(userId),
	        isLastPage: UserLikedStampStore.isLastPage(userId),
	        isInvalidated: UserLikedStampStore.isInvalidated(userId),
	        loadNextPage: this.requestNextLikedPage }) };
	  },

	  handleCreateStampClick: function handleCreateStampClick() {
	    transitionTo('draftCompose', { stampSegment: 'new' });
	  },

	  requestNextLatestPage: function requestNextLatestPage() {
	    var userId = UserStore.getMe().id;
	    StampActionCreators.requestUserLatestPage(userId);
	  },

	  requestNextLikedPage: function requestNextLikedPage() {
	    var userId = UserStore.getMe().id;
	    StampActionCreators.requestUserLikedPage(userId);
	  }
	});

	module.exports = AddStampsToZine;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var FormMixin = __webpack_require__(79);
	var StampStore = __webpack_require__(17);
	var UserStore = __webpack_require__(5);
	var ZineStore = __webpack_require__(22);
	var SidebarBody = __webpack_require__(57);
	var FormInput = __webpack_require__(196);
	var Button = __webpack_require__(13);
	var Textarea = __webpack_require__(142);
	var ZineActionCreators = __webpack_require__(41);
	var PendingStampMessageMixin = __webpack_require__(407);
	var PureRenderMixin = __webpack_require__(2);
	var getStampSegment = __webpack_require__(60);var PropTypes = React.PropTypes;

	var ApprovePendingStamp = React.createClass({
	  displayName: 'ApprovePendingStamp',

	  mixins: [FormMixin, PendingStampMessageMixin, createStoreMixin(StampStore, ZineStore), PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = StampStore.get(props.stampId),
	        zine = ZineStore.get(props.zineSlug),
	        author = UserStore.get(stamp.user);

	    return {
	      stamp: stamp,
	      zine: zine,
	      author: author
	    };
	  },

	  render: function render() {
	    var _state = this.state;
	    var zine = _state.zine;
	    var author = _state.author;

	    return React.createElement(
	      SidebarBody,
	      { title: 'Accept Submission to “' + zine.title + '”',
	        subtitle: 'You can add an optional message for the author.' },
	      React.createElement(
	        'div',
	        { className: 'utils--fullWidth' },
	        React.createElement(FormInput, { component: Textarea,
	          size: 'small',
	          placeholder: 'Message for ' + author.name,
	          formLink: this.linkState('message'),
	          readOnly: !this.isFormEditable(),
	          hasMinHeight: true }),
	        React.createElement(
	          Button,
	          { size: 'large',
	            color: 'green',
	            fill: true,
	            onClick: this.handleConfirmClick,
	            disabled: !this.isFormEditable(),
	            fullWidth: true },
	          'Accept'
	        )
	      )
	    );
	  },

	  handleConfirmClick: function handleConfirmClick() {
	    this.removeStoredPendingMessage();

	    var zineSlug = this.props.zineSlug;var _state2 = this.state;
	    var message = _state2.message;
	    var stamp = _state2.stamp;

	    var stampFragment = getStampSegment(stamp);
	    ZineActionCreators.approveStampToZine(zineSlug, stampFragment, message);
	  }
	});

	module.exports = ApprovePendingStamp;
	/* TODO: add and use FormGroup */

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _organismsSidebarBody = __webpack_require__(57);

	var _organismsSidebarBody2 = _interopRequireDefault(_organismsSidebarBody);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesDraftFeedbackStore = __webpack_require__(419);

	var _storesDraftFeedbackStore2 = _interopRequireDefault(_storesDraftFeedbackStore);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _moleculesEmptyState = __webpack_require__(59);

	var _moleculesEmptyState2 = _interopRequireDefault(_moleculesEmptyState);

	'use strict';

	var DraftFeedbacks = _react2['default'].createClass({
	  displayName: 'DraftFeedbacks',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesDraftFeedbackStore2['default'], _storesUserStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    draftUuid: _react.PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      messages: _storesDraftFeedbackStore2['default'].getDraftFeedbacks(this.props.draftUuid)
	    };
	  },

	  render: function render() {
	    var draftUuid = this.props.draftUuid;

	    return _react2['default'].createElement(
	      _organismsSidebarBody2['default'],
	      { title: 'Feedback' },
	      _react2['default'].createElement(
	        _organismsGroup2['default'],
	        { type: 'messages',
	          items: this.state.messages,
	          context: 'sidebar',
	          mode: 'grid',
	          columns: 1,
	          isExpectingPage: _storesDraftFeedbackStore2['default'].isExpectingPage(draftUuid),
	          isLastPage: _storesDraftFeedbackStore2['default'].isLastPage(draftUuid),
	          isInvalidated: _storesDraftFeedbackStore2['default'].isInvalidated(draftUuid),
	          loadNextPage: this.requestNextPage },
	        _react2['default'].createElement(_moleculesEmptyState2['default'], { label: 'There is no any feedbacks so far',
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    _actionsDraftActionCreators2['default'].requestDraftFeedbackPage(this.props.draftUuid);
	  }
	});

	module.exports = DraftFeedbacks;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var createStoreMixin = __webpack_require__(8);
	var StampDraftStore = __webpack_require__(64);
	var DraftActionCreators = __webpack_require__(33);
	var PureRenderMixin = __webpack_require__(2);
	var UserStore = __webpack_require__(5);
	var EmptyState = __webpack_require__(59);
	var Button = __webpack_require__(13);
	var _require = __webpack_require__(50);

	var transitionTo = _require.transitionTo;
	var SidebarActionCreators = __webpack_require__(29);

	var Drafts = React.createClass({
	  displayName: 'Drafts',

	  mixins: [createStoreMixin(StampDraftStore, UserStore), PureRenderMixin],

	  getStateFromStores: function getStateFromStores() {
	    return {
	      drafts: StampDraftStore.getDrafts()
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    DraftActionCreators.requestDraftPage(true);
	  },

	  render: function render() {
	    var stampId = this.props.stampId;
	    var getItemProps;

	    getItemProps = function (item) {
	      return {
	        routeParams: { stampId: item.uuid }
	      };
	    };

	    return React.createElement(
	      SidebarBody,
	      { title: 'My Drafts' },
	      React.createElement(
	        Group,
	        { type: 'stamps',
	          items: this.state.drafts,
	          itemProps: {
	            size: 'small',
	            showLikes: false,
	            allowEmptyThumbnail: true,
	            routeName: 'draftCompose'
	          },
	          getItemProps: getItemProps,
	          context: 'sidebar',
	          mode: 'grid',
	          columns: 2,
	          isExpectingPage: StampDraftStore.isExpectingPage(stampId),
	          isLastPage: StampDraftStore.isLastPage(stampId),
	          isInvalidated: StampDraftStore.isInvalidated(stampId),
	          loadNextPage: this.requestNextPage },
	        React.createElement(
	          EmptyState,
	          { label: 'You have no saved drafts.',
	            absoluteCenter: true },
	          React.createElement(
	            Button,
	            { onClick: this.handleCreateStampClick },
	            'Create a Stamp'
	          )
	        )
	      )
	    );
	  },

	  handleCreateStampClick: function handleCreateStampClick() {
	    SidebarActionCreators.hideSidebar();
	    transitionTo('draftCompose', { stampSegment: 'new' });
	  },

	  requestNextPage: function requestNextPage() {
	    DraftActionCreators.requestDraftPage();
	  }
	});

	module.exports = Drafts;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _require = __webpack_require__(4);

	var reject = _require.reject;
	var createStoreMixin = __webpack_require__(8);
	var StampStore = __webpack_require__(17);
	var ImageStore = __webpack_require__(146);
	var ImageActionCreators = __webpack_require__(248);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var EmptyState = __webpack_require__(59);
	var PureRenderMixin = __webpack_require__(2);
	var ImageUsedInStampStore = __webpack_require__(421);var PropTypes = React.PropTypes;

	var ImageUsedInStamps = React.createClass({
	  displayName: 'ImageUsedInStamps',

	  mixins: [createStoreMixin(ImageUsedInStampStore, ImageStore, StampStore), PureRenderMixin],

	  propTypes: {
	    imageUuid: PropTypes.string.isRequired,
	    excludeStampId: PropTypes.number
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var image = ImageStore.get(props.imageUuid),
	        usedInStamps = ImageUsedInStampStore.getStamps(props.imageUuid);

	    return {
	      image: image,
	      usedInStamps: reject(usedInStamps, function (s) {
	        return s.id === props.excludeStampId;
	      })
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var imageUuid = this.props.imageUuid;

	    ImageActionCreators.requestImageUsedInStampsPage(imageUuid, true);
	  },

	  render: function render() {
	    var imageUuid = this.props.imageUuid;var usedInStamps = this.state.usedInStamps;

	    return React.createElement(
	      SidebarBody,
	      { title: 'More Stamps with This Image',
	        subtitle: '' },
	      React.createElement(
	        Group,
	        { type: 'stamps',
	          context: 'Sidebar',
	          mode: 'grid',
	          columns: 2,
	          isExpectingPage: ImageUsedInStampStore.isExpectingPage(imageUuid),
	          isLastPage: ImageUsedInStampStore.isLastPage(imageUuid),
	          isInvalidated: ImageUsedInStampStore.isInvalidated(imageUuid),
	          loadNextPage: this.requestNextPendingPage,
	          items: usedInStamps,
	          itemProps: {
	            size: 'small',
	            routeName: 'feedStamp',
	            showZine: false,
	            routeParams: {
	              imageUuid: imageUuid
	            }
	          } },
	        React.createElement(EmptyState, { label: 'There are no other stamps with this image.',
	          context: 'Sidebar',
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextLatestPage: function requestNextLatestPage() {
	    var imageUuid = this.props.imageUuid;

	    ImageActionCreators.requestImageUsedInStampsPage(imageUuid);
	  }
	});

	module.exports = ImageUsedInStamps;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _mixinsFormMixin = __webpack_require__(79);

	var _mixinsFormMixin2 = _interopRequireDefault(_mixinsFormMixin);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _organismsSidebarBody = __webpack_require__(57);

	var _organismsSidebarBody2 = _interopRequireDefault(_organismsSidebarBody);

	var _atomsFormInput = __webpack_require__(196);

	var _atomsFormInput2 = _interopRequireDefault(_atomsFormInput);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _atomsTextarea = __webpack_require__(142);

	var _atomsTextarea2 = _interopRequireDefault(_atomsTextarea);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	'use strict';

	var LeaveDraftFeedback = _react2['default'].createClass({
	  displayName: 'LeaveDraftFeedback',

	  mixins: [_mixinsFormMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesStampStore2['default'], _storesUserStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    draftUuid: _react.PropTypes.string.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return {
	      message: ''
	    };
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = _storesStampStore2['default'].get(props.draftUuid);
	    var author = _storesUserStore2['default'].get(stamp.user);

	    return {
	      stamp: stamp,
	      author: author
	    };
	  },

	  render: function render() {
	    var author = this.state.author;

	    return _react2['default'].createElement(
	      _organismsSidebarBody2['default'],
	      { title: 'Leave Feedback' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'utils--fullWidth' },
	        _react2['default'].createElement(_atomsFormInput2['default'], { component: _atomsTextarea2['default'],
	          size: 'small',
	          placeholder: 'Message for ' + author.name,
	          formLink: this.linkState('message'),
	          readOnly: !this.isFormEditable(),
	          hasMinHeight: true }),
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { size: 'large',
	            color: 'green',
	            fill: true,
	            onClick: this.handleSendClick,
	            disabled: !this.isFormEditable(),
	            fullWidth: true },
	          'Send'
	        )
	      )
	    );
	  },

	  handleSendClick: function handleSendClick() {
	    var draftUuid = this.props.draftUuid;
	    var message = this.state.message;

	    if (!message.trim().length) {
	      return;
	    }

	    _actionsDraftActionCreators2['default'].sendFeedback(draftUuid, message);
	  }
	});

	exports['default'] = LeaveDraftFeedback;
	module.exports = exports['default'];
	/* TODO: add and use FormGroup */

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Collection = __webpack_require__(417);
	var createStoreMixin = __webpack_require__(8);
	var PureRenderMixin = __webpack_require__(2);
	var StampStore = __webpack_require__(17);
	var getUniqueStampImages = __webpack_require__(443);
	var SidebarBody = __webpack_require__(57);var PropTypes = React.PropTypes;

	var PinterestPicker = React.createClass({
	  displayName: 'PinterestPicker',

	  mixins: [PureRenderMixin, createStoreMixin(StampStore)],

	  propTypes: {
	    stampId: PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = StampStore.get(props.stampId),
	        images = getUniqueStampImages(stamp);

	    return {
	      images: images
	    };
	  },

	  render: function render() {
	    var stampId = this.props.stampId;

	    return React.createElement(
	      SidebarBody,
	      { title: 'Choose an image to pin' },
	      React.createElement(Collection, { type: 'pinterestImages',
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        itemProps: { stampId: stampId },
	        items: this.state.images })
	    );
	  }
	});

	module.exports = PinterestPicker;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var FormMixin = __webpack_require__(79);
	var StampStore = __webpack_require__(17);
	var UserStore = __webpack_require__(5);
	var ZineStore = __webpack_require__(22);
	var SidebarBody = __webpack_require__(57);
	var FormInput = __webpack_require__(196);
	var Button = __webpack_require__(13);
	var Textarea = __webpack_require__(142);
	var ZineActionCreators = __webpack_require__(41);
	var PendingStampMessageMixin = __webpack_require__(407);
	var PureRenderMixin = __webpack_require__(2);
	var getStampSegment = __webpack_require__(60);var PropTypes = React.PropTypes;

	var RejectPendingStamp = React.createClass({
	  displayName: 'RejectPendingStamp',

	  mixins: [FormMixin, PendingStampMessageMixin, createStoreMixin(StampStore, ZineStore), PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = StampStore.get(props.stampId),
	        zine = ZineStore.get(props.zineSlug),
	        author = UserStore.get(stamp.user);

	    return {
	      stamp: stamp,
	      zine: zine,
	      author: author
	    };
	  },

	  render: function render() {
	    var _state = this.state;
	    var zine = _state.zine;
	    var author = _state.author;

	    return React.createElement(
	      SidebarBody,
	      { title: 'Decline Submission to “' + zine.title + '”',
	        subtitle: 'You can add an optional message for the author.' },
	      React.createElement(
	        'div',
	        { className: 'utils--fullWidth' },
	        React.createElement(FormInput, { component: Textarea,
	          size: 'small',
	          placeholder: 'Message for ' + author.name,
	          formLink: this.linkState('message'),
	          readOnly: !this.isFormEditable(),
	          hasMinHeight: true }),
	        React.createElement(
	          Button,
	          { size: 'large',
	            color: 'red',
	            fill: true,
	            onClick: this.handleConfirmClick,
	            disabled: !this.isFormEditable(),
	            fullWidth: true },
	          'Decline'
	        )
	      )
	    );
	  },

	  handleConfirmClick: function handleConfirmClick() {
	    this.removeStoredPendingMessage();

	    var zineSlug = this.props.zineSlug;var _state2 = this.state;
	    var message = _state2.message;
	    var stamp = _state2.stamp;

	    var stampFragment = getStampSegment(stamp);
	    ZineActionCreators.rejectStampFromZine(zineSlug, stampFragment, message);
	  }
	});

	module.exports = RejectPendingStamp;
	/* TODO: add and use FormGroup */

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _organismsSidebarBody = __webpack_require__(57);

	var _organismsSidebarBody2 = _interopRequireDefault(_organismsSidebarBody);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesStampLikesStore = __webpack_require__(426);

	var _storesStampLikesStore2 = _interopRequireDefault(_storesStampLikesStore);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _utilsGetStampSegment = __webpack_require__(60);

	var _utilsGetStampSegment2 = _interopRequireDefault(_utilsGetStampSegment);

	'use strict';

	var StampLikes = _react2['default'].createClass({
	  displayName: 'StampLikes',

	  mixins: [(0, _mixinsCreateStoreMixin2['default'])(_storesStampLikesStore2['default'], _storesUserStore2['default'], _storesStampStore2['default']), _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    stampId: _react.PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var stampId = this.props.stampId;

	    var stampLikes = _storesStampLikesStore2['default'].getStampLikes(stampId);

	    return {
	      stampLikes: stampLikes,
	      stamp: _storesStampStore2['default'].get(stampId)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(this.state.stamp);
	    _actionsStampActionCreators2['default'].requestStampLikePage(stampSegment, true);
	  },

	  render: function render() {
	    var stampId = this.props.stampId;

	    return _react2['default'].createElement(
	      _organismsSidebarBody2['default'],
	      { title: 'Liked By' },
	      _react2['default'].createElement(_organismsGroup2['default'], { type: 'users',
	        items: this.state.stampLikes,
	        itemProps: {
	          vertical: true,
	          size: 'small',
	          imageSize: 'large',
	          showLocation: true,
	          showAbout: true,
	          context: 'StampLikes',
	          showFollow: true
	        },
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        isExpectingPage: _storesStampLikesStore2['default'].isExpectingPage(stampId),
	        isLastPage: _storesStampLikesStore2['default'].isLastPage(stampId),
	        isInvalidated: _storesStampLikesStore2['default'].isInvalidated(stampId),
	        loadNextPage: this.requestNextPage })
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    var stampSegment = (0, _utilsGetStampSegment2['default'])(this.state.stamp);
	    _actionsStampActionCreators2['default'].requestStampLikePage(stampSegment);
	  }
	});

	module.exports = StampLikes;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var ZineStore = __webpack_require__(22);
	var StampStore = __webpack_require__(17);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var pluralize = __webpack_require__(98);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var StampOtherZines = React.createClass({
	  displayName: 'StampOtherZines',

	  mixins: [createStoreMixin(StampStore, ZineStore), PureRenderMixin],

	  propTypes: {
	    stampId: PropTypes.number.isRequired,
	    zineSlugs: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      stamp: StampStore.get(props.stampId),
	      zines: props.zineSlugs.map(ZineStore.get)
	    };
	  },

	  render: function render() {
	    var title = 'This Stamp in Other Collections',
	        subtitle = '“' + this.state.stamp.title + '” is also in ',
	        zineCount = this.state.zines.length;

	    subtitle += zineCount;
	    subtitle += pluralize(zineCount, ' collection.', ' collections.');

	    return React.createElement(
	      SidebarBody,
	      { title: title,
	        subtitle: subtitle },
	      React.createElement(Group, { type: 'zines',
	        context: 'sidebar',
	        mode: 'grid',
	        columns: 2,
	        items: this.state.zines,
	        itemProps: { size: 'small' } })
	    );
	  }
	});

	module.exports = StampOtherZines;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var createStoreMixin = __webpack_require__(8);
	var UserSubscribersStore = __webpack_require__(432);
	var UserActionCreators = __webpack_require__(47);
	var PureRenderMixin = __webpack_require__(2);
	var UserStore = __webpack_require__(5);
	var EmptyState = __webpack_require__(59);
	var FollowUserButton = __webpack_require__(262);var PropTypes = React.PropTypes;

	var UserSubscribers = React.createClass({
	  displayName: 'UserSubscribers',

	  mixins: [createStoreMixin(UserSubscribersStore, UserStore), PureRenderMixin],

	  propTypes: {
	    userId: PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: UserStore.get(props.userId),
	      userSubscribers: UserSubscribersStore.getUserSubscribers(props.userId),
	      isMe: UserStore.isMe(props.userId)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    UserActionCreators.requestUserSubscriberPage(this.props.userId, true, true);
	  },

	  render: function render() {
	    var userId = this.props.userId;var _state = this.state;
	    var user = _state.user;
	    var userSubscribers = _state.userSubscribers;

	    var isMe = _state.isMe;
	    var firstName = user.name.split(' ')[0];
	    var title = isMe ? 'You Are Followed By' : '' + firstName + ' Is Followed By';
	    var emptyLabel = isMe ? 'You have no followers.' : '' + firstName + ' has no followers.';

	    return React.createElement(
	      SidebarBody,
	      { title: title },
	      React.createElement(
	        Group,
	        { type: 'users',
	          items: userSubscribers,
	          itemProps: {
	            size: 'small',
	            imageSize: 'large',
	            showLocation: true,
	            showAbout: true,
	            showFollow: true
	          },
	          context: 'sidebar',
	          mode: 'grid',
	          columns: 2,
	          isExpectingPage: UserSubscribersStore.isExpectingPage(userId),
	          isLastPage: UserSubscribersStore.isLastPage(userId),
	          isInvalidated: UserSubscribersStore.isInvalidated(userId),
	          loadNextPage: this.requestNextPage },
	        React.createElement(
	          EmptyState,
	          { label: emptyLabel,
	            absoluteCenter: true },
	          !isMe && React.createElement(FollowUserButton, { user: user })
	        )
	      )
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    UserActionCreators.requestUserSubscriberPage(this.props.userId);
	  }
	});

	module.exports = UserSubscribers;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var createStoreMixin = __webpack_require__(8);
	var UserSubscriptionsStore = __webpack_require__(433);
	var UserActionCreators = __webpack_require__(47);
	var PureRenderMixin = __webpack_require__(2);
	var UserStore = __webpack_require__(5);
	var EmptyState = __webpack_require__(59);var PropTypes = React.PropTypes;

	var UserSubscriptions = React.createClass({
	  displayName: 'UserSubscriptions',

	  mixins: [createStoreMixin(UserSubscriptionsStore, UserStore), PureRenderMixin],

	  propTypes: {
	    userId: PropTypes.number.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    return {
	      user: UserStore.get(props.userId),
	      userSubscriptions: UserSubscriptionsStore.getUserSubscriptions(props.userId),
	      isMe: UserStore.isMe(props.userId)
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    UserActionCreators.requestUserSubscriptionPage(this.props.userId, true, true);
	  },

	  render: function render() {
	    var userId = this.props.userId;var _state = this.state;
	    var user = _state.user;
	    var userSubscriptions = _state.userSubscriptions;

	    var isMe = _state.isMe;
	    var firstName = user.name.split(' ')[0];
	    var title = isMe ? 'You Follow' : '' + firstName + ' Follows';
	    var emptyLabel = isMe ? 'You don’t follow anyone.' : '' + firstName + ' doesn’t follow anyone.';

	    return React.createElement(
	      SidebarBody,
	      { title: title },
	      React.createElement(
	        Group,
	        { type: 'users',
	          items: userSubscriptions,
	          itemProps: {
	            size: 'small',
	            imageSize: 'large',
	            showLocation: true,
	            showAbout: true,
	            showFollow: true
	          },
	          context: 'sidebar',
	          mode: 'grid',
	          columns: 2,
	          isExpectingPage: UserSubscriptionsStore.isExpectingPage(userId),
	          isLastPage: UserSubscriptionsStore.isLastPage(userId),
	          isInvalidated: UserSubscriptionsStore.isInvalidated(userId),
	          loadNextPage: this.requestNextPage },
	        React.createElement(EmptyState, { label: emptyLabel,
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextPage: function requestNextPage() {
	    UserActionCreators.requestUserSubscriptionPage(this.props.userId);
	  }
	});

	module.exports = UserSubscriptions;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);
	var ZinePendingStampStore = __webpack_require__(216);
	var StampActionCreators = __webpack_require__(54);
	var Group = __webpack_require__(45);
	var SidebarBody = __webpack_require__(57);
	var EmptyState = __webpack_require__(59);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	var ZinePendingStamps = React.createClass({
	  displayName: 'ZinePendingStamps',

	  mixins: [createStoreMixin(ZinePendingStampStore, StampStore), PureRenderMixin],

	  propTypes: {
	    zineSlug: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var zine = ZineStore.get(props.zineSlug),
	        pendingStamps = ZinePendingStampStore.getStamps(props.zineSlug);

	    return {
	      zine: zine,
	      pendingStamps: pendingStamps
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    var zineSlug = this.props.zineSlug;
	    StampActionCreators.requestZinePendingPage(zineSlug, true);
	  },

	  render: function render() {
	    var zineSlug = this.props.zineSlug,
	        pendingStamps = this.state.pendingStamps;

	    return React.createElement(
	      SidebarBody,
	      { title: 'Pending Submissions',
	        subtitle: 'Accept or decline stamps submitted by other users.' },
	      React.createElement(
	        Group,
	        { type: 'stamps',
	          context: 'Sidebar',
	          mode: 'grid',
	          columns: 2,
	          isExpectingPage: ZinePendingStampStore.isExpectingPage(zineSlug),
	          isLastPage: ZinePendingStampStore.isLastPage(zineSlug),
	          isInvalidated: ZinePendingStampStore.isInvalidated(zineSlug),
	          loadNextPage: this.requestNextPendingPage,
	          items: pendingStamps,
	          itemProps: {
	            size: 'small',
	            routeName: 'zinePendingStamp',
	            showZine: false,
	            routeParams: {
	              zineSlug: zineSlug
	            }
	          } },
	        React.createElement(EmptyState, { label: 'You have no pending submissions.',
	          context: 'Sidebar',
	          absoluteCenter: true })
	      )
	    );
	  },

	  requestNextLatestPage: function requestNextLatestPage() {
	    var zineSlug = this.props.zineSlug;
	    StampActionCreators.requestZinePendingPage(zineSlug);
	  }
	});

	module.exports = ZinePendingStamps;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var StoreUtils = __webpack_require__(30);
	var UserStore = __webpack_require__(5);
	var StampStore = __webpack_require__(17);
	var ZineStore = __webpack_require__(22);var createStore = StoreUtils.createStore;
	var mergeIntoBag = StoreUtils.mergeIntoBag;

	var _activities = {};

	var ActivityStore = createStore({
	  get: function get(id) {
	    return _activities[id];
	  }
	});

	ActivityStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken, StampStore.dispatchToken, ZineStore.dispatchToken]);

	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      receivedActivities = entities && entities.activities;

	  if (receivedActivities) {
	    mergeIntoBag(_activities, receivedActivities);
	    ActivityStore.emitChange();
	  }
	});

	module.exports = ActivityStore;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var UserStore = __webpack_require__(5);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var mergeIntoBag = _require.mergeIntoBag;
	var isInBag = _require.isInBag;

	var _messages = {};

	var MessageStore = createStore({
	  contains: function contains(uuid, fields) {
	    return isInBag(_messages, uuid, fields);
	  },

	  get: function get(id) {
	    return _messages[id];
	  }
	});

	MessageStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      messages = entities && entities.messages;

	  if (messages) {
	    mergeIntoBag(_messages, messages);
	    MessageStore.emitChange();
	  }
	});

	module.exports = MessageStore;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9),
	    StoreUtils = __webpack_require__(30),
	    createStore = StoreUtils.createStore;

	var _pageControls = null;

	var PageControlsStore = createStore({
	  getPageControls: function getPageControls() {
	    return _pageControls;
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action;

	  switch (action.type) {
	    case ActionTypes.SHOW_PAGE_CONTROLS:
	      _pageControls = action.pageControls;
	      PageControlsStore.emitChange();
	      break;
	    case ActionTypes.HIDE_PAGE_CONTROLS:
	      _pageControls = null;
	      PageControlsStore.emitChange();
	      break;
	  }
	});

	module.exports = PageControlsStore;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _AppDispatcher = __webpack_require__(6);

	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

	var _utilsStoreUtils = __webpack_require__(30);

	'use strict';

	var _sections = {};

	var SectionStore = (0, _utilsStoreUtils.createStore)({
	  get: function get(id) {
	    return _sections[id];
	  }
	});

	SectionStore._objects = _sections;

	SectionStore.dispatchToken = _AppDispatcher2['default'].register(function (payload) {
	  var action = payload.action;
	  var response = action.response;
	  var entities = response && response.entities;
	  var sections = entities && entities.sections;

	  if (sections) {
	    (0, _utilsStoreUtils.mergeIntoBag)(_sections, sections);
	    SectionStore.emitChange();
	  }
	});

	exports['default'] = SectionStore;
	module.exports = exports['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);
	var AppDispatcher = __webpack_require__(6);
	var ActionTypes = __webpack_require__(9);
	var ServiceTypes = __webpack_require__(35);
	var SocialFriendListStore = __webpack_require__(290);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var update = __webpack_require__(49);

	var _recepient = null,
	    _suggested = null,
	    resentInvites = {},
	    _isSending = false,
	    _isFormHidden = false,
	    _message = null;

	var NON_LETTERS_RE = /[\s\.,-\/#!$%\^&\*;:{}=\-_`~()'"“”]/g;

	function getDefaultRecipient() {
	  return {
	    text: '',
	    tags: [],
	    isEmpty: function isEmpty() {
	      return !this.text;
	    }
	  };
	}

	function updateSuggestions(query) {
	  var facebookFriends = SocialFriendListStore.getFriends(ServiceTypes.FACEBOOK),
	      googleFriends = SocialFriendListStore.getFriends(ServiceTypes.GOOGLE),
	      friends = (facebookFriends || []).concat(googleFriends || []),
	      queryWords = _.compact(query.toLowerCase().split(NON_LETTERS_RE));

	  if (!query) {
	    _suggested = [];
	    return;
	  }

	  _suggested = _.filter(friends, function isMatch(friend) {
	    return _.every(queryWords, function (queryWord) {
	      return _.any(friend.keywords, function (keyword) {
	        return keyword.indexOf(queryWord) === 0;
	      });
	    });
	  });
	}

	function pushTag(tag) {
	  _recepient = update(_recepient || getDefaultRecipient(), {
	    text: { $set: '' },
	    tags: { $push: [tag] }
	  });

	  _suggested = [];
	}

	var SendInvitationFormStore = createStore({
	  getFormState: function getFormState() {
	    return {
	      resentInvites: resentInvites,
	      isSending: _isSending,
	      isFormHidden: _isFormHidden,
	      recipient: _recepient || getDefaultRecipient(),
	      suggested: _suggested || [],
	      message: _message || ''
	    };
	  }
	});

	AppDispatcher.register(function (payload) {
	  var action = payload.action,
	      response = action.response;

	  switch (action.type) {
	    case ActionTypes.SEND_INVITE:
	    case ActionTypes.RESEND_INVITE:
	    case ActionTypes.UPDATE_INVITE:
	      _isSending = true;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.SEND_INVITE_ERROR:
	    case ActionTypes.RESEND_INVITE_ERROR:
	    case ActionTypes.UPDATE_INVITE_ERROR:
	      _isSending = false;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.SEND_INVITE_SUCCESS:
	    case ActionTypes.UPDATE_INVITE_SUCCESS:
	      _isSending = false;
	      _recepient = getDefaultRecipient();
	      _message = null;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.SEND_FB_INVITE:
	      _isFormHidden = true;
	      _isSending = true;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.SEND_FB_INVITE_SUCCESS:
	      _isSending = false;
	      _isFormHidden = false;
	      _recepient = getDefaultRecipient();
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.SEND_FB_INVITE_ERROR:
	      _isSending = false;
	      _isFormHidden = false;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.RESEND_INVITE_SUCCESS:
	      _isSending = false;
	      resentInvites[response.result] = true;
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.HIDE_MODAL:
	      resentInvites = {};
	      break;

	    case ActionTypes.FORM_VALUE_CHANGED:
	      if (action.key === 'recipient') {
	        _recepient = action.value;
	        updateSuggestions(_recepient.text);
	        SendInvitationFormStore.emitChange();
	      } else if (action.key === 'message') {
	        _message = action.value;
	        SendInvitationFormStore.emitChange();
	      }
	      break;

	    case ActionTypes.INVITATION_FORM_PUSH_TAG:
	      pushTag(action.tag);
	      SendInvitationFormStore.emitChange();
	      break;

	    case ActionTypes.INVITATION_FORM_CLEAR_SUGGESTED:
	      _suggested = [];
	      SendInvitationFormStore.emitChange();
	      break;
	  }
	});

	module.exports = SendInvitationFormStore;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6);
	var _ = __webpack_require__(4);
	var UserStore = __webpack_require__(5);
	var _require = __webpack_require__(30);

	var createStore = _require.createStore;
	var mergeIntoBag = _require.mergeIntoBag;
	var isInBag = _require.isInBag;

	var socialFriends = {};

	var NON_LETTERS_RE = /[\s\.,-\/#!$%\^&\*;:{}=\-_`~()'"“”]/g;

	function getKeywords(friend) {
	  var nameWords = (friend.name || '').split('@')[0].split(NON_LETTERS_RE),
	      emailWords = (friend.email || '').split('@')[0].split(NON_LETTERS_RE);

	  return _.compact(nameWords.concat(emailWords)).map(function (word) {
	    return word.toLowerCase();
	  });
	}

	var SocialFriendStore = createStore({
	  contains: function contains(slug, fields) {
	    return isInBag(socialFriends, slug, fields);
	  },

	  get: function get(id) {
	    return socialFriends[id];
	  }
	});

	SocialFriendStore._objects = socialFriends;

	SocialFriendStore.dispatchToken = AppDispatcher.register(function (payload) {
	  AppDispatcher.waitFor([UserStore.dispatchToken]);

	  var action = payload.action,
	      response = action.response,
	      entities = response && response.entities,
	      receivedFriends = entities && entities.socialFriends;

	  switch (action.type) {
	    default:
	      if (receivedFriends) {
	        _.each(receivedFriends, function (friend) {
	          friend.keywords = getKeywords(friend);
	          return friend;
	        });

	        mergeIntoBag(socialFriends, receivedFriends);
	        SocialFriendStore.emitChange();
	      }
	      break;
	  }
	});

	module.exports = SocialFriendStore;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    SafeLocalStorage = __webpack_require__(134),
	    request = __webpack_require__(385);

	function randomHex() {
	  return '' + Math.floor(Math.random() * 10000000000).toString(16);
	}

	function getFingerprint(storageKey) {
	  if (!storageKey) {
	    throw new Error('Fingerprint key not specified.');
	  }

	  var result = SafeLocalStorage.getItem(storageKey);
	  if (!result) {
	    result = randomHex() + randomHex() + randomHex() + randomHex();
	    SafeLocalStorage.setItem(storageKey, result);
	  }

	  return result;
	}

	function getSession(storageKey) {
	  if (!storageKey) {
	    throw new Error('Session key not specified.');
	  }

	  var result;
	  try {
	    result = sessionStorage.getItem(storageKey);
	  } catch (error) {}

	  if (!result) {
	    result = randomHex() + randomHex() + randomHex() + randomHex();
	    try {
	      sessionStorage.setItem(storageKey, result);
	    } catch (error) {}
	  }

	  return result;
	}

	module.exports = {
	  initialize: function initialize(options) {
	    this.backendUrl = options.backendUrl;
	    this.sessionData = {
	      'user_id': options.userId,
	      'user_fingerprint': getFingerprint(options.fingerprintKey),
	      'session': getSession(options.sessionKey),
	      'timezone': new Date().getTimezoneOffset() / -60
	    };
	  },

	  trackEvent: function trackEvent(name, params) {
	    if (!this.backendUrl) {
	      throw new Error('Call initialize() before tracking events.');
	    }

	    var eventData = _.extend({
	      'location': document.location.href,
	      'event': name,
	      'data': params
	    }, this.sessionData);

	    request.post(this.backendUrl).send(eventData).end();
	  }
	};

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	var PromiseUtils = __webpack_require__(785),
	    noop = __webpack_require__(220);

	function FileUploader(options) {
	  this.uploadUrl = options.uploadUrl;
	  this.data = options.data;
	  this.key = options.key || 'file';
	  this.transform = options.transform || function (x) {
	    return x;
	  };

	  var maxSimultaneousUploads = options.maxSimultaneousUploads;
	  if (maxSimultaneousUploads) {
	    this.uploadFile = PromiseUtils.limitConcurrency(this.uploadFile, maxSimultaneousUploads);
	  }
	}

	FileUploader.prototype = {
	  uploadFiles: function uploadFiles(files) {
	    files = Array.prototype.slice.call(files, 0);
	    return files.map(this.uploadFile, this);
	  },

	  uploadFile: function uploadFile(file, onProgress, cancellationToken) {
	    var _this = this;

	    var xhr,
	        formData,
	        prop,
	        data = this.data,
	        key = this.key,
	        transform = this.transform;

	    return new _Promise(function (resolve, reject) {
	      if (!file.size) {
	        return reject(new Error('Empty file size.'));
	      }

	      xhr = new window.XMLHttpRequest();
	      formData = new window.FormData();

	      if (cancellationToken) {
	        cancellationToken.onCancelled(function (reason) {
	          reject(reason);
	          onProgress = noop;
	          xhr.abort();
	        });
	      }

	      xhr.open('POST', _this.uploadUrl);

	      xhr.upload.onloadstart = function () {
	        onProgress(0);
	      };

	      xhr.upload.onprogress = function (e) {
	        if (e.lengthComputable) {
	          onProgress(e.loaded / e.total);
	        }
	      };

	      xhr.onload = function (e) {
	        try {
	          resolve(transform(JSON.parse(e.target.responseText)));
	        } catch (err) {
	          reject(err);
	        }
	      };

	      xhr.onerror = function (err) {
	        reject(err);
	      };

	      if (data) {
	        for (prop in data) {
	          if (data.hasOwnProperty(prop)) {
	            formData.append(prop, data[prop]);
	          }
	        }
	      }

	      formData.append(key, file);
	      xhr.send(formData);
	    });
	  }
	};

	module.exports = FileUploader;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var once = _require.once;

	var FAMILIES = {
	  'minion-pro-condensed': {
	    /**
	     * Which characters are missing from the Default set?
	     *
	     * Minion Pro character map: http://www.linotype.com/172077/MinionProCondensedRegular-product.html
	     * Type Tester on Typekit shows characters missing from Default set: https://typekit.com/
	     * Useful tool for building Unicode regexes: http://kourge.net/projects/regexp-unicode-block
	     */
	    trigger: /[\u0100-\u017F\u0180-\u024F\u02B0-\u02FF\u0370-\u03FF\u0400-\u04FF\u1E00-\u1EFF\u1F00-\u1FFF\u2010\u2012\u201a\u2020\u2021\u2022\u2024\u2025\u2030\u2044\u2070-\u209F\u20a1\u20a3\u20a4\u20a7\u20ab\u20b9\u2113\u2116\u2126\u212e\u2150-\u218F\u2190\u2192\u25a0-\u25c9\u2610\u2611\u2713-\u27a2\ue000-\uf7ff\ufb00-\ufb06]/g,
	    load: once(window.loadMinionProCondensedFullKit)
	  },
	  'playfair-display': {
	    /**
	     * Which characters are missing from the Default set?
	     *
	     * Minion Pro character map: http://www.linotype.com/172077/MinionProCondensedRegular-product.html
	     * Type Tester on Typekit shows characters missing from Default set: https://typekit.com/
	     * Useful tool for building Unicode regexes: http://kourge.net/projects/regexp-unicode-block
	     */
	    trigger: /.*/g,
	    load: once(window.loadPlayfairDisplay)
	  }
	};

	var FontLoader = {
	  ensureCanRenderString: function ensureCanRenderString(str, family) {
	    if (str.match(FAMILIES[family].trigger)) {
	      FAMILIES[family].load();
	    }
	  }
	};

	module.exports = FontLoader;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = __webpack_require__(224)['default'];

	var _classCallCheck = __webpack_require__(223)['default'];

	var ImagePlaceholderCache = (function () {
	  function ImagePlaceholderCache() {
	    _classCallCheck(this, ImagePlaceholderCache);

	    this.cache = {};
	    this.canvas = document.createElement('canvas');
	  }

	  _createClass(ImagePlaceholderCache, [{
	    key: 'getDataURLForSize',
	    value: function getDataURLForSize(_ref) {
	      var width = _ref.width;
	      var height = _ref.height;

	      var key = '' + width + ':' + height;
	      if (!this.cache[key]) {
	        this.canvas.width = width;
	        this.canvas.height = height;
	        this.cache[key] = this.canvas.toDataURL();
	      }

	      return this.cache[key];
	    }
	  }]);

	  return ImagePlaceholderCache;
	})();

	module.exports = ImagePlaceholderCache;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var SafeLocalStorage = __webpack_require__(134);

	var Legacy = {
	  loadDraftFromStorage: function loadDraftFromStorage() {
	    var json = SafeLocalStorage.getItem('draft');
	    if (json) {
	      SafeLocalStorage.removeItem('draft');
	      return JSON.parse(json);
	    }
	  }
	};

	module.exports = Legacy;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var SafeLocalStorage = __webpack_require__(134),
	    guid = __webpack_require__(246);

	var Migrations = {
	  migrateDraftFromOldEditor: function migrateDraftFromOldEditor() {
	    var prefix = 'editor/collections/draft_collection',
	        draftId = (SafeLocalStorage.getItem(prefix) || '').split(',')[0];

	    if (!draftId) {
	      return;
	    }

	    var stamp = JSON.parse(SafeLocalStorage.getItem(prefix + '-' + draftId));
	    delete stamp.id;

	    SafeLocalStorage.removeItem(prefix);
	    SafeLocalStorage.removeItem(prefix + '-' + draftId);

	    SafeLocalStorage.setItem('draft', JSON.stringify(stamp));
	  },

	  migrateGrabbagFromOldEditor: function migrateGrabbagFromOldEditor() {
	    var prefix = 'editor/collections/grabbox_collection',
	        grabboxIds = (SafeLocalStorage.getItem(prefix) || '').split(',');

	    if (grabboxIds.length === 1 && grabboxIds[0] === '') {
	      return;
	    }

	    SafeLocalStorage.removeItem(prefix);

	    var grabbox = grabboxIds.map(function (imageId) {
	      var key = prefix + '-' + imageId,
	          image = JSON.parse(SafeLocalStorage.getItem(key));

	      SafeLocalStorage.removeItem(key);
	      image.media.uuid = guid();

	      return {
	        uuid: guid(),
	        image: image.media
	      };
	    });

	    SafeLocalStorage.setItem('grabbag', JSON.stringify(grabbox));
	  }
	};

	module.exports = Migrations;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = __webpack_require__(224)['default'];

	var _classCallCheck = __webpack_require__(223)['default'];

	var _require = __webpack_require__(4);

	var union = _require.union;
	var _find = _require.find;
	var without = _require.without;
	var clone = _require.clone;
	var invariant = __webpack_require__(11);
	var PaginatedList = (function () {
	  function PaginatedList(ids) {
	    _classCallCheck(this, PaginatedList);

	    this._ids = ids || [];
	    this._pageCount = 0;
	    this._nextPageUrl = null;
	    this._isExpectingPage = false;
	    this._isInvalidated = false;
	  }

	  _createClass(PaginatedList, [{
	    key: 'getIds',
	    value: function getIds() {
	      return this._ids;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this._pageCount;
	    }
	  }, {
	    key: 'isExpectingPage',
	    value: function isExpectingPage() {
	      return this._isExpectingPage;
	    }
	  }, {
	    key: 'getNextPageUrl',
	    value: function getNextPageUrl() {
	      return this._nextPageUrl;
	    }
	  }, {
	    key: 'isLastPage',
	    value: function isLastPage() {
	      return this._nextPageUrl === null;
	    }
	  }, {
	    key: 'isInvalidated',
	    value: function isInvalidated() {
	      return this._isInvalidated;
	    }
	  }, {
	    key: 'find',
	    value: function find(predicate) {
	      return _find(this._ids, predicate);
	    }
	  }, {
	    key: 'prepend',
	    value: function prepend(id) {
	      this._ids = union([id], this._ids);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	      this._ids = without(this._ids, id);
	    }
	  }, {
	    key: 'contains',
	    value: function contains(id) {
	      return this._ids.indexOf(id) !== -1;
	    }
	  }, {
	    key: 'invalidate',
	    value: function invalidate() {
	      // Empty is as good as invalidated
	      if (this._pageCount === 0) {
	        return;
	      }

	      // TODO: We'd like to support invalidating in-flight but in order to do that
	      // `receivePage` needs to be sure whether specific response is next or invalidated page
	      // and the whole chunk of consuming code will have to be refactored. Leave it for now.

	      if (this._isExpectingPage) {
	        console.warn('Cannot invalidate while fetching page. Invalidation ignored.');
	        return;
	      }

	      this._isInvalidated = true;
	    }
	  }, {
	    key: 'expectPage',
	    value: function expectPage() {
	      invariant(!this._isExpectingPage, 'Cannot call expectPage twice without prior cancelPage or receivePage call.');
	      this._isExpectingPage = true;
	    }
	  }, {
	    key: 'cancelPage',
	    value: function cancelPage() {
	      invariant(this._isExpectingPage, 'Cannot call cancelPage without prior expectPage call.');
	      this._isExpectingPage = false;
	      this._isInvalidated = false;
	    }
	  }, {
	    key: 'receivePage',
	    value: function receivePage(newIds, nextPageUrl) {
	      invariant(this._isExpectingPage, 'Cannot call receivePage without prior expectPage call.');
	      nextPageUrl = nextPageUrl || null;

	      if (this._isInvalidated) {
	        this.receiveInvalidatedFirstPage(newIds, nextPageUrl);
	      } else {
	        this.receiveNextPage(newIds, nextPageUrl);
	      }

	      this._isExpectingPage = false;
	      this._isInvalidated = false;
	    }
	  }, {
	    key: 'receiveNextPage',
	    value: function receiveNextPage(newIds, nextPageUrl) {
	      this._ids = union(this._ids, newIds);
	      this._pageCount++;
	      this._nextPageUrl = nextPageUrl;
	    }
	  }, {
	    key: 'receiveInvalidatedFirstPage',
	    value: function receiveInvalidatedFirstPage(firstPageIds, nextPageUrl) {
	      var _this = this;

	      var isCommonId = function isCommonId(id) {
	        return _this._ids.indexOf(id) > -1;
	      },
	          firstPageIdsBackwards = clone(firstPageIds).reverse(),
	          lastCommonId = _find(firstPageIdsBackwards, isCommonId),
	          lastCommonIdIndex = this._ids.indexOf(lastCommonId);

	      // Only attempt to merge if there is a common item
	      if (lastCommonIdIndex > -1) {
	        this._ids = union(firstPageIds, this._ids.slice(lastCommonIdIndex + 1));
	      } else {
	        this._ids = firstPageIds;
	        this._pageCount = 1;
	        this._nextPageUrl = nextPageUrl;
	      }
	    }
	  }]);

	  return PaginatedList;
	})();

	module.exports = PaginatedList;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	/**
	 * Constructs a function that proxies to promiseFactory
	 * limiting the count of promises that can run simultaneously.
	 * @param promiseFactory function that returns promises.
	 * @param limit how many promises are allowed to be running at the same time.
	 * @returns function that returns a promise that eventually proxies to promiseFactory.
	 */
	function limitConcurrency(promiseFactory, limit) {
	  var running = 0,
	      semaphore = null,
	      resolveSemaphore = null;

	  function scheduleNextJob() {
	    if (running < limit) {
	      running++;
	      return _Promise.resolve();
	    }

	    if (!semaphore) {
	      semaphore = new _Promise(function (resolve) {
	        resolveSemaphore = resolve;
	      });
	    }

	    return semaphore['finally'](scheduleNextJob);
	  }

	  function processScheduledJobs() {
	    running--;

	    if (semaphore && running < limit) {
	      resolveSemaphore();

	      semaphore = null;
	      resolveSemaphore = null;
	    }
	  }

	  return function () {
	    var _this = this,
	        args = arguments;

	    function runJob() {
	      return promiseFactory.apply(_this, args);
	    }

	    return scheduleNextJob().then(runJob)['finally'](processScheduledJobs);
	  };
	}

	module.exports = {
	  limitConcurrency: limitConcurrency
	};

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// Based on https://github.com/petehunt/react-raf-batching
	// but also triggers `tick` regularly if tab is inactive.

	'use strict';

	var ReactUpdates = __webpack_require__(63),
	    now = __webpack_require__(1171),
	    CrashReporter = __webpack_require__(294);

	var FORCE_TICK_INTERVAL = 1000,
	    FORCE_TICK_THRESHOLD = 100,
	    lastTick;

	var tick = CrashReporter.wrap(function tickImpl() {
	  window.requestAnimationFrame(tick);

	  ReactUpdates.flushBatchedUpdates();
	  lastTick = now();
	});

	function forceTick() {
	  if (now() - lastTick > FORCE_TICK_THRESHOLD) {
	    tick();
	  }
	}

	var ReactRAFBatchingStrategy = {
	  isBatchingUpdates: true,

	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function batchedUpdates(callback, a, b, c, d) {
	    callback(a, b, c, d);
	  }
	};

	tick();
	setInterval(forceTick, FORCE_TICK_INTERVAL);

	module.exports = ReactRAFBatchingStrategy;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var MIN_DATE = new Date(0);

	function getTimeString(count, singular, plural) {
	  return count === 1 ? singular : plural.replace(/%s/, count);
	}

	function getDiff(date) {
	  var now = new Date(),
	      diff = new Date(now - (typeof date === 'string' ? new Date(date) : date)),
	      years = diff.getUTCFullYear() - MIN_DATE.getUTCFullYear(),
	      months = years === 0 && diff.getUTCMonth() - MIN_DATE.getUTCMonth(),
	      days = months === 0 && diff.getUTCDate() - MIN_DATE.getUTCDate(),
	      weeks = (days - days % 7) / 7,
	      hours = days === 0 && diff.getUTCHours() - MIN_DATE.getUTCHours(),
	      minutes = hours === 0 && diff.getUTCMinutes() - MIN_DATE.getUTCMinutes();

	  return { years: years, months: months, days: days, weeks: weeks, hours: hours, minutes: minutes };
	}

	function format(date) {
	  var diff = getDiff(date);

	  if (diff.years) {
	    return getTimeString(diff.years, 'a year ago', '%s years ago');
	  } else if (diff.months) {
	    return getTimeString(diff.months, 'a month ago', '%s months ago');
	  } else if (diff.weeks) {
	    return getTimeString(diff.weeks, 'a week ago', '%s weeks ago');
	  } else if (diff.days) {
	    return getTimeString(diff.days, 'a day ago', '%s days ago');
	  } else if (diff.hours) {
	    return getTimeString(diff.hours, 'an hour ago', '%s hours ago');
	  } else if (diff.minutes) {
	    return getTimeString(diff.minutes, 'a minute ago', '%s minutes ago');
	  } else {
	    return 'just now';
	  }
	}

	function normalizeOptions(options) {
	  var maxMinutes = options.maxMinutes || null,
	      maxHours = maxMinutes !== null ? 0 : options.maxHours || null,
	      maxDays = maxHours !== null ? 0 : options.maxDays || null,
	      maxWeeks = maxDays !== null ? 0 : options.maxWeeks || null,
	      maxMonths = maxWeeks !== null ? 0 : options.maxMonths || null,
	      maxYears = maxMonths !== null ? 0 : options.maxYears || null;

	  return { maxYears: maxYears, maxMonths: maxMonths, maxWeeks: maxWeeks, maxDays: maxDays, maxHours: maxHours, maxMinutes: maxMinutes };
	}

	function isAbsolute(date, options) {
	  var diff = getDiff(date);

	  options = normalizeOptions(options);

	  if (options.maxYears !== null && diff.years > options.maxYears) {
	    return true;
	  } else if (options.maxMonths !== null && diff.months > options.maxMonths) {
	    return true;
	  } else if (options.maxWeeks !== null && diff.weeks > options.maxWeeks) {
	    return true;
	  } else if (options.maxDays !== null && diff.days > options.maxDays) {
	    return true;
	  } else if (options.maxHours !== null && diff.hours > options.maxHours) {
	    return true;
	  } else if (options.maxMinutes !== null && diff.minutes > options.maxMinutes) {
	    return true;
	  }
	}

	module.exports = {
	  format: format,
	  isAbsolute: isAbsolute
	};

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _humps = __webpack_require__(186);

	var _mapKeys = __webpack_require__(448);

	var _mapKeys2 = _interopRequireDefault(_mapKeys);

	var _lodashObjectMapValues = __webpack_require__(1043);

	var _lodashObjectMapValues2 = _interopRequireDefault(_lodashObjectMapValues);

	'use strict';

	function camelizeAction(action) {
	  var camelized = (0, _humps.camelizeKeys)(action);

	  // Don't camelize entity keys, but camelize everything inside:
	  // action.response.entities.humptyDumpties['vorpal-jabberwock'].snarkCount

	  if (action.response && action.response.entities) {
	    camelized.response.entities = (0, _lodashObjectMapValues2['default'])((0, _mapKeys2['default'])(action.response.entities, _humps.camelize), function (entityBag) {
	      return (0, _lodashObjectMapValues2['default'])(entityBag, _humps.camelizeKeys);
	    });
	  }

	  return camelized;
	}

	exports['default'] = camelizeAction;
	module.exports = exports['default'];

/***/ },
/* 789 */,
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var SOUNDCLOUD_USER_RE = /http(s)?:\/\/soundcloud.com\/([^\/]+).*/i,
	    SOUNDCLOUD_USER_URL = 'http$1://soundcloud.com/$2';

	/**
	 * Parse track(list) url to extract user URL
	 * because we don't save it (at least we don't yet).
	 */
	function extractSoundCloudUserUrl(trackOrPlaylistUrl) {
	  return trackOrPlaylistUrl.replace(SOUNDCLOUD_USER_RE, SOUNDCLOUD_USER_URL);
	}

	module.exports = extractSoundCloudUserUrl;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function forceUpdateBodyOverflow() {
	  if (!window.safari) {
	    return;
	  }

	  // If you move cursor over sidebar while it's still animating
	  // and try to scroll, it will get stuck in desktop Safari.

	  // Temporarily setting it to 'scroll' and back
	  // seems to fix the problem, at least in Safari 8.

	  var prevOverflow = document.body.style.overflow;
	  document.body.style.overflow = 'scroll';

	  setTimeout(function () {
	    if (document.body.style.overflow === 'scroll') {
	      document.body.style.overflow = prevOverflow;
	    }
	  });
	}

	module.exports = forceUpdateBodyOverflow;

/***/ },
/* 792 */,
/* 793 */,
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var find = _require.find;
	var SectionTypes = __webpack_require__(40);
	var MediaTypes = __webpack_require__(70);

	function getFirstAudioSection(stamp) {
	  if (!stamp || !stamp.content) {
	    return null;
	  }

	  return find(stamp.content.sections, function (s) {
	    return s.type === SectionTypes.MEDIA && (s.mediaType === MediaTypes.AUDIO_TRACK || s.mediaType === MediaTypes.AUDIO_PLAYLIST);
	  });
	}

	module.exports = getFirstAudioSection;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function getInnerText(el) {
	  return el.textContent || el.innerText || '';
	}

	module.exports = getInnerText;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function getStreamUrl(track) {
	  var sourceId = track.sourceId;

	  // We can't use track.streamUrl directly because it might be 404.
	  // Instead, let our server decide where to stream from.

	  // In future, we might want to return an array of sources here
	  // and switch to our server only if track.streamUrl actually fails.

	  return '/api/media/redirect_to_stream?track_id=' + sourceId;
	}

	module.exports = getStreamUrl;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function limitThumbnailSize(size, maxSize, mode) {
	  size = {
	    width: size.width,
	    height: size.height
	  };

	  var scale;

	  switch (mode) {
	    case 'preview':
	      if (size.width && size.width > maxSize.width) {
	        scale = maxSize.width / size.width;

	        size.width *= scale;
	        if (size.height) {
	          size.height *= scale;
	        }
	      }

	      if (size.height && size.height > maxSize.height) {
	        scale = maxSize.height / size.height;

	        size.height *= scale;
	        if (size.width) {
	          size.width *= scale;
	        }
	      }
	      break;

	    case 'scale_crop':
	      // Empty height or width make no sense for scale_crop, assume square
	      size.width = size.width || size.height;
	      size.height = size.height || size.width;

	      if (size.width > maxSize.width && size.height > maxSize.height) {
	        scale = Math.max(maxSize.width / size.width, maxSize.height / size.height);

	        size.width *= scale;
	        size.height *= scale;
	      }
	      break;

	    default:
	      throw new Error('Unknown image mode');
	  }

	  if (size.width) {
	    size.width = Math.round(size.width);
	  }

	  if (size.height) {
	    size.height = Math.round(size.height);
	  }

	  return size;
	}

	module.exports = limitThumbnailSize;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _constantsDebugActionTypes = __webpack_require__(644);

	var _constantsDebugActionTypes2 = _interopRequireDefault(_constantsDebugActionTypes);

	var _lodashObjectOmit = __webpack_require__(1044);

	var _lodashObjectOmit2 = _interopRequireDefault(_lodashObjectOmit);

	'use strict';

	var lastLogTime = undefined;

	function logAction(prefix, action) {
	  if (true) {
	    return;
	  }

	  var breakLine = Date.now() - lastLogTime > 1000;
	  lastLogTime = Date.now();

	  var method = 'log';
	  if (action.type && action.type.substr(-6) === '_ERROR') {
	    method = 'error';
	  } else if (action.type && _constantsDebugActionTypes2['default'].indexOf(action.type) !== -1) {
	    method = 'debug';
	  }

	  if (breakLine) {
	    console[method].call(console, '\n');
	  }

	  console[method].call(console, prefix, action.type, (0, _lodashObjectOmit2['default'])(action, 'type'));
	}

	exports['default'] = logAction;
	module.exports = exports['default'];

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// Based on:
	// http://jsbin.com/oxaxuc/13/edit?js

	if (!Element.prototype.scrollIntoViewIfNeeded) {
	  Element.prototype.scrollIntoViewIfNeeded = function (centered) {
	    centered = centered === undefined ? true : !!centered;

	    // The following are always from the {top, bottom, left, right}
	    // of the viewport, to the {top, …} of the box.
	    // Think of them as geometrical vectors, it helps.
	    // The axes are directed downwards and towards the right.

	    var topToBottom = this.offsetTop + this.offsetHeight - window.scrollY,
	        bottomToTop = -window.innerHeight + topToBottom - this.offsetHeight,
	        leftToRight = this.offsetLeft + this.offsetWidth,
	        rightToLeft = -window.innerWidth + leftToRight - this.offsetWidth,
	        xAllowed = true,
	        // We allow one translation on the x axis,
	    yAllowed = true; // and one on the y axis.

	    // Whatever `centered` is, the behavior is the same if the box is
	    // (even partially) visible.

	    if ((topToBottom > 0 || !centered) && topToBottom <= this.offsetHeight) {
	      if (yAllowed) {
	        scrollBy(0, topToBottom - this.offsetHeight);
	        yAllowed = false;
	      }
	    } else if ((bottomToTop < 0 || !centered) && bottomToTop >= -this.offsetHeight) {
	      if (yAllowed) {
	        scrollBy(0, bottomToTop + this.offsetHeight);
	        yAllowed = false;
	      }
	    }

	    if ((leftToRight > 0 || !centered) && leftToRight <= this.offsetWidth) {
	      if (xAllowed) {
	        scrollBy(leftToRight - this.offsetWidth, 0);
	        xAllowed = false;
	      }
	    } else if ((rightToLeft < 0 || !centered) && rightToLeft >= -this.offsetWidth) {
	      if (xAllowed) {
	        scrollBy(rightToLeft + this.offsetWidth, 0);
	        xAllowed = false;
	      }
	    }

	    // If we want it centered, and the box is completely hidden,
	    // then we center it explicitly.

	    if (centered) {
	      if (yAllowed && (topToBottom <= 0 || bottomToTop >= 0)) {
	        scroll(window.scrollX, this.offsetTop + this.offsetHeight / 2 - window.innerHeight / 2);
	      }

	      if (xAllowed && (leftToRight <= 0 || rightToLeft <= 0)) {
	        scroll(this.offsetLeft + this.offsetWidth / 2 - window.innerWidth / 2, window.scrollY);
	      }
	    }
	  };
	}

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var viewportUnitsBuggyfill = __webpack_require__(1181);
	var _require = __webpack_require__(4);

	var any = _require.any;

	// Polyfill calls are wrapped in try-catch to avoid potential issues in IE:
	// https://github.com/rodneyrehm/viewport-units-buggyfill/issues/38

	try {
	  viewportUnitsBuggyfill.init();
	} catch (err) {}

	var patchedViewportStyleNode = document.getElementById('patched-viewport');

	function isAppStyleNode(node) {
	  return node.tagName === 'STYLE' && node !== patchedViewportStyleNode;
	}

	function refreshViewportBuggyfill() {
	  try {
	    viewportUnitsBuggyfill.refresh();
	    patchedViewportStyleNode.parentNode.appendChild(patchedViewportStyleNode);
	  } catch (err) {}
	}

	function handleHeadMutation(mutationRecords) {
	  if (any(mutationRecords, function (record) {
	    return any(record.addedNodes, isAppStyleNode);
	  })) {
	    refreshViewportBuggyfill();
	  }
	}

	if (patchedViewportStyleNode) {
	  if (typeof MutationObserver !== 'undefined') {
	    new MutationObserver(handleHeadMutation).observe(document.head, {
	      childList: true
	    });
	  } else {
	    setInterval(refreshViewportBuggyfill, 1500);
	  }
	}

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	try {
	  window.devicePixelRatio = (function () {
	    var ratio = 1;

	    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
	      ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
	    } else if (window.devicePixelRatio !== undefined) {
	      ratio = window.devicePixelRatio;
	    }

	    return ratio;
	  })();
	} catch (err) {}

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(808), __esModule: true };

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(812), __esModule: true };

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _Object$create = __webpack_require__(303)["default"];

	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) subClass.__proto__ = superClass;
	};

	exports.__esModule = true;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */

	module.exports = Emitter;

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};

	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }

	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];

	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @preserve console-shim 1.0.3
	 * https://github.com/kayahr/console-shim
	 * Copyright (C) 2011 Klaus Reimer <k@ailis.de>
	 * Licensed under the MIT license
	 * (See http://www.opensource.org/licenses/mit-license)
	 */
	 
	 
	(function(){
	"use strict";

	/**
	 * Returns a function which calls the specified function in the specified
	 * scope.
	 *
	 * @param {Function} func
	 *            The function to call.
	 * @param {Object} scope
	 *            The scope to call the function in.
	 * @param {...*} args
	 *            Additional arguments to pass to the bound function.
	 * @returns {function(...[*]): undefined}
	 *            The bound function.
	 */
	var bind = function(func, scope, args)
	{
	    var fixedArgs = Array.prototype.slice.call(arguments, 2);
	    return function()
	    {
	        var args = fixedArgs.concat(Array.prototype.slice.call(arguments, 0));
	        (/** @type {Function} */ func).apply(scope, args);
	    };
	};

	// Create console if not present
	if (!window["console"]) window.console = /** @type {Console} */ ({});
	var console = (/** @type {Object} */ window.console);

	// Implement console log if needed
	if (!console["log"])
	{
	    // Use log4javascript if present
	    if (window["log4javascript"])
	    {
	        var log = log4javascript.getDefaultLogger();
	        console.log = bind(log.info, log);
	        console.debug = bind(log.debug, log);
	        console.info = bind(log.info, log);
	        console.warn = bind(log.warn, log);
	        console.error = bind(log.error, log);
	    }
	    
	    // Use empty dummy implementation to ignore logging
	    else
	    {
	        console.log = (/** @param {...*} args */ function(args) {});
	    }
	}

	// Implement other log levels to console.log if missing
	if (!console["debug"]) console.debug = console.log;
	if (!console["info"]) console.info = console.log;
	if (!console["warn"]) console.warn = console.log;
	if (!console["error"]) console.error = console.log;

	// Wrap the log methods in IE (<=9) because their argument handling is wrong
	// This wrapping is also done if the __consoleShimTest__ symbol is set. This
	// is needed for unit testing.
	if (window["__consoleShimTest__"] != null || 
	    eval("/*@cc_on @_jscript_version <= 9@*/"))
	{
	    /**
	     * Wraps the call to a real IE logging method. Modifies the arguments so
	     * parameters which are not represented by a placeholder are properly
	     * printed with a space character as separator.
	     *
	     * @param {...*} args
	     *            The function arguments. First argument is the log function
	     *            to call, the other arguments are the log arguments.
	     */
	    var wrap = function(args)
	    {
	        var i, max, match, log;
	        
	        // Convert argument list to real array
	        args = Array.prototype.slice.call(arguments, 0);
	        
	        // First argument is the log method to call
	        log = args.shift();
	        
	        max = args.length;
	        if (max > 1 && window["__consoleShimTest__"] !== false)
	        {
	            // When first parameter is not a string then add a format string to
	            // the argument list so we are able to modify it in the next stop
	            if (typeof(args[0]) != "string")
	            {
	                args.unshift("%o");
	                max += 1;
	            }
	            
	            // For each additional parameter which has no placeholder in the
	            // format string we add another placeholder separated with a
	            // space character.
	            match = args[0].match(/%[a-z]/g);
	            for (i = match ? match.length + 1 : 1; i < max; i += 1)
	            {
	                args[0] += " %o";
	            }
	        }
	        Function.apply.call(log, console, args);
	    };
	    
	    // Wrap the native log methods of IE to fix argument output problems
	    console.log = bind(wrap, window, console.log);
	    console.debug = bind(wrap, window, console.debug);
	    console.info = bind(wrap, window, console.info);
	    console.warn = bind(wrap, window, console.warn);
	    console.error = bind(wrap, window, console.error);
	}

	// Implement console.assert if missing
	if (!console["assert"])
	{
	    console["assert"] = function()
	    {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var expr = args.shift();
	        if (!expr)
	        {
	            args[0] = "Assertion failed: " + args[0];
	            console.error.apply(console, args);
	        }
	    };
	}

	// Linking console.dir and console.dirxml to the console.log method if
	// missing. Hopefully the browser already logs objects and DOM nodes as a
	// tree.
	if (!console["dir"]) console["dir"] = console.log;
	if (!console["dirxml"]) console["dirxml"] = console.log;

	// Linking console.exception to console.error. This is not the same but
	// at least some error message is displayed.
	if (!console["exception"]) console["exception"] = console.error;

	// Implement console.time and console.timeEnd if one of them is missing
	if (!console["time"] || !console["timeEnd"])
	{
	    var timers = {};
	    console["time"] = function(id)
	    {
	        timers[id] = new Date().getTime();
	    };
	    console["timeEnd"] = function(id)
	    {
	        var start = timers[id];
	        if (start)
	        {
	            console.log(id + ": " + (new Date().getTime() - start) + "ms");
	            delete timers[id];
	        }
	    };
	}

	// Implement console.table if missing
	if (!console["table"])
	{
	    console["table"] = function(data, columns)
	    {
	        var i, iMax, row, j, jMax, k;
	        
	        // Do nothing if data has wrong type or no data was specified
	        if (!data || !(data instanceof Array) || !data.length) return;
	        
	        // Auto-calculate columns array if not set
	        if (!columns || !(columns instanceof Array))
	        {
	            columns = [];
	            for (k in data[0])
	            {
	                if (!data[0].hasOwnProperty(k)) continue;
	                columns.push(k);
	            }
	        }
	        
	        for (i = 0, iMax = data.length; i < iMax; i += 1)
	        {
	            row = [];
	            for (j = 0, jMax = columns.length; j < jMax; j += 1)
	            {
	                row.push(data[i][columns[j]]);
	            }
	            
	            Function.apply.call(console.log, console, row);
	        }
	    };
	}

	// Dummy implementations of other console features to prevent error messages
	// in browsers not supporting it.
	if (!console["clear"]) console["clear"] = function() {};
	if (!console["trace"]) console["trace"] = function() {};
	if (!console["group"]) console["group"] = function() {};
	if (!console["groupCollapsed"]) console["groupCollapsed"] = function() {};
	if (!console["groupEnd"]) console["groupEnd"] = function() {};
	if (!console["timeStamp"]) console["timeStamp"] = function() {};
	if (!console["profile"]) console["profile"] = function() {};
	if (!console["profileEnd"]) console["profileEnd"] = function() {};
	if (!console["count"]) console["count"] = function() {};

	})();


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(307);
	__webpack_require__(306);
	__webpack_require__(458);
	module.exports = __webpack_require__(25).core.getIterator;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(307);
	__webpack_require__(306);
	__webpack_require__(458);
	module.exports = __webpack_require__(25).core.isIterable;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(832);
	module.exports = __webpack_require__(25).core.Object.assign;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(25);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(25);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(836);
	module.exports = __webpack_require__(25).core.Object.entries;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(833);
	module.exports = __webpack_require__(25).core.Object.keys;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(834);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(835);
	module.exports = __webpack_require__(25).core.Promise;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(25)
	  , enumKeys = __webpack_require__(817);
	// 19.1.2.1 Object.assign(target, source, ...)
	/* eslint-disable no-unused-vars */
	module.exports = Object.assign || function assign(target, source){
	/* eslint-enable no-unused-vars */
	  var T = Object($.assertDefined(target))
	    , l = arguments.length
	    , i = 1;
	  while(l > i){
	    var S      = $.ES5Object(arguments[i++])
	      , keys   = enumKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)T[key = keys[j++]] = S[key];
	  }
	  return T;
	};

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(25)
	  , document = $.g.document
	  , isObject = $.isObject
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(25);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getDesc    = $.getDesc
	    , getSymbols = $.getSymbols;
	  if(getSymbols)$.each.call(getSymbols(it), function(key){
	    if(getDesc(it, key).enumerable)keys.push(key);
	  });
	  return keys;
	};

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var ctx  = __webpack_require__(225)
	  , get  = __webpack_require__(150).get
	  , call = __webpack_require__(822);
	module.exports = function(iterable, entries, fn, that){
	  var iterator = get(iterable)
	    , f        = ctx(fn, that, entries ? 2 : 1)
	    , step;
	  while(!(step = iterator.next()).done){
	    if(call(iterator, f, step.value, entries) === false){
	      return call.close(iterator);
	    }
	  }
	};

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function($){
	  $.FW   = false;
	  $.path = $.core;
	  return $;
	};

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var $ = __webpack_require__(25)
	  , toString = {}.toString
	  , getNames = $.getNames;

	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	function getWindowNames(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	}

	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames($.toObject(it));
	};

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	// Fast apply
	// http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	    case 5: return un ? fn(args[0], args[1], args[2], args[3], args[4])
	                      : fn.call(that, args[0], args[1], args[2], args[3], args[4]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var assertObject = __webpack_require__(182).obj;
	function close(iterator){
	  var ret = iterator['return'];
	  if(ret !== undefined)assertObject(ret.call(iterator));
	}
	function call(iterator, fn, value, entries){
	  try {
	    return entries ? fn(assertObject(value)[0], value[1]) : fn(value);
	  } catch(e){
	    close(iterator);
	    throw e;
	  }
	}
	call.close = close;
	module.exports = call;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var SYMBOL_ITERATOR = __webpack_require__(124)('iterator')
	  , SAFE_CLOSING    = false;
	try {
	  var riter = [7][SYMBOL_ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	module.exports = function(exec){
	  if(!SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[SYMBOL_ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[SYMBOL_ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var $redef = __webpack_require__(305);
	module.exports = function(target, src){
	  for(var key in src)$redef(target, key, src[key]);
	  return target;
	};

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var $      = __webpack_require__(25)
	  , assert = __webpack_require__(182);
	function check(O, proto){
	  assert.obj(O);
	  assert(proto === null || $.isObject(proto), proto, ": can't set as prototype!");
	}
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} // eslint-disable-line
	    ? function(buggy, set){
	        try {
	          set = __webpack_require__(225)(Function.call, $.getDesc(Object.prototype, '__proto__').set, 2);
	          set({}, []);
	        } catch(e){ buggy = true; }
	        return function setPrototypeOf(O, proto){
	          check(O, proto);
	          if(buggy)O.__proto__ = proto;
	          else set(O, proto);
	          return O;
	        };
	      }()
	    : undefined),
	  check: check
	};

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(25)
	  , SPECIES = __webpack_require__(124)('species');
	module.exports = function(C){
	  if($.DESC && !(SPECIES in C))$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: $.that
	  });
	};

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	// true  -> String#at
	// false -> String#codePointAt
	var $ = __webpack_require__(25);
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String($.assertDefined(that))
	      , i = $.toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l
	      || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	        ? TO_STRING ? s.charAt(i) : a
	        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $      = __webpack_require__(25)
	  , ctx    = __webpack_require__(225)
	  , cof    = __webpack_require__(183)
	  , invoke = __webpack_require__(821)
	  , cel    = __webpack_require__(816)
	  , global             = $.g
	  , isFunction         = $.isFunction
	  , html               = $.html
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	function run(){
	  var id = +this;
	  if($.has(queue, id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	}
	function listner(event){
	  run.call(event.data);
	}
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!isFunction(setTask) || !isFunction(clearTask)){
	  setTask = function(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(isFunction(fn) ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(cof(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Modern browsers, skip implementation for WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is object
	  } else if(global.addEventListener && isFunction(global.postMessage) && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id, '*');
	    };
	    global.addEventListener('message', listner, false);
	  // WebWorkers
	  } else if(isFunction(MessageChannel)){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(25)
	  , setUnscope = __webpack_require__(830)
	  , ITER       = __webpack_require__(226).safe('iter')
	  , $iter      = __webpack_require__(150)
	  , step       = $iter.step
	  , Iterators  = $iter.Iterators;

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	__webpack_require__(456)(Array, 'Array', function(iterated, kind){
	  $.set(this, ITER, {o: $.toObject(iterated), i: 0, k: kind});
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var iter  = this[ITER]
	    , O     = iter.o
	    , kind  = iter.k
	    , index = iter.i++;
	  if(!O || index >= O.length){
	    iter.o = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	setUnscope('keys');
	setUnscope('values');
	setUnscope('entries');

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $def = __webpack_require__(184);
	$def($def.S, 'Object', {assign: __webpack_require__(815)});

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(25)
	  , $def     = __webpack_require__(184)
	  , isObject = $.isObject
	  , toObject = $.toObject;
	$.each.call(('freeze,seal,preventExtensions,isFrozen,isSealed,isExtensible,' +
	  'getOwnPropertyDescriptor,getPrototypeOf,keys,getOwnPropertyNames').split(',')
	, function(KEY, ID){
	  var fn     = ($.core.Object || {})[KEY] || Object[KEY]
	    , forced = 0
	    , method = {};
	  method[KEY] = ID == 0 ? function freeze(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 1 ? function seal(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 2 ? function preventExtensions(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 3 ? function isFrozen(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 4 ? function isSealed(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 5 ? function isExtensible(it){
	    return isObject(it) ? fn(it) : false;
	  } : ID == 6 ? function getOwnPropertyDescriptor(it, key){
	    return fn(toObject(it), key);
	  } : ID == 7 ? function getPrototypeOf(it){
	    return fn(Object($.assertDefined(it)));
	  } : ID == 8 ? function keys(it){
	    return fn(toObject(it));
	  } : __webpack_require__(820).get;
	  try {
	    fn('z');
	  } catch(e){
	    forced = 1;
	  }
	  $def($def.S + $def.F * forced, 'Object', method);
	});

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(183)
	  , tmp = {};
	tmp[__webpack_require__(124)('toStringTag')] = 'z';
	if(__webpack_require__(25).FW && cof(tmp) != 'z'){
	  __webpack_require__(305)(Object.prototype, 'toString', function toString(){
	    return '[object ' + cof.classof(this) + ']';
	  }, true);
	}

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $        = __webpack_require__(25)
	  , ctx      = __webpack_require__(225)
	  , cof      = __webpack_require__(183)
	  , $def     = __webpack_require__(184)
	  , assert   = __webpack_require__(182)
	  , forOf    = __webpack_require__(818)
	  , setProto = __webpack_require__(826).set
	  , same     = __webpack_require__(825)
	  , species  = __webpack_require__(827)
	  , SPECIES  = __webpack_require__(124)('species')
	  , RECORD   = __webpack_require__(226).safe('record')
	  , PROMISE  = 'Promise'
	  , global   = $.g
	  , process  = global.process
	  , isNode   = cof(process) == 'process'
	  , asap     = process && process.nextTick || __webpack_require__(829).set
	  , P        = global[PROMISE]
	  , isFunction     = $.isFunction
	  , isObject       = $.isObject
	  , assertFunction = assert.fn
	  , assertObject   = assert.obj
	  , Wrapper;

	function testResolve(sub){
	  var test = new P(function(){});
	  if(sub)test.constructor = Object;
	  return P.resolve(test) === test;
	}

	var useNative = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = isFunction(P) && isFunction(P.resolve) && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && $.DESC){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();

	// helpers
	function isPromise(it){
	  return isObject(it) && (useNative ? cof.classof(it) == 'Promise' : RECORD in it);
	}
	function sameConstructor(a, b){
	  // library wrapper special case
	  if(!$.FW && a === P && b === Wrapper)return true;
	  return same(a, b);
	}
	function getConstructor(C){
	  var S = assertObject(C)[SPECIES];
	  return S != undefined ? S : C;
	}
	function isThenable(it){
	  var then;
	  if(isObject(it))then = it.then;
	  return isFunction(then) ? then : false;
	}
	function notify(record){
	  var chain = record.c;
	  // strange IE + webpack dev server bug - use .call(global)
	  if(chain.length)asap.call(global, function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    function run(react){
	      var cb = ok ? react.ok : react.fail
	        , ret, then;
	      try {
	        if(cb){
	          if(!ok)record.h = true;
	          ret = cb === true ? value : cb(value);
	          if(ret === react.P){
	            react.rej(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(ret)){
	            then.call(ret, react.res, react.rej);
	          } else react.res(ret);
	        } else react.rej(value);
	      } catch(err){
	        react.rej(err);
	      }
	    }
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	  });
	}
	function isUnhandled(promise){
	  var record = promise[RECORD]
	    , chain  = record.a || record.c
	    , i      = 0
	    , react;
	  if(record.h)return false;
	  while(chain.length > i){
	    react = chain[i++];
	    if(react.fail || !isUnhandled(react.P))return false;
	  } return true;
	}
	function $reject(value){
	  var record = this
	    , promise;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  setTimeout(function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    asap.call(global, function(){
	      if(isUnhandled(promise = record.p)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(global.console && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      }
	      record.a = undefined;
	    });
	  }, 1);
	  notify(record);
	}
	function $resolve(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(then = isThenable(value)){
	      // strange IE + webpack dev server bug - use .call(global)
	      asap.call(global, function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	}

	// constructor polyfill
	if(!useNative){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    assertFunction(executor);
	    var record = {
	      p: assert.inst(this, P, PROMISE),       // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false                                // <- handled rejection
	    };
	    $.hide(this, RECORD, record);
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(824)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var S = assertObject(assertObject(this).constructor)[SPECIES];
	      var react = {
	        ok:   isFunction(onFulfilled) ? onFulfilled : true,
	        fail: isFunction(onRejected)  ? onRejected  : false
	      };
	      var promise = react.P = new (S != undefined ? S : P)(function(res, rej){
	        react.res = assertFunction(res);
	        react.rej = assertFunction(rej);
	      });
	      var record = this[RECORD];
	      record.c.push(react);
	      if(record.a)record.a.push(react);
	      if(record.s)notify(record);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}

	// export
	$def($def.G + $def.W + $def.F * !useNative, {Promise: P});
	cof.set(P, PROMISE);
	species(P);
	species(Wrapper = $.core[PROMISE]);

	// statics
	$def($def.S + $def.F * !useNative, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    return new (getConstructor(this))(function(res, rej){ rej(r); });
	  }
	});
	$def($def.S + $def.F * (!useNative || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    return isPromise(x) && sameConstructor(x.constructor, this)
	      ? x : new this(function(res){ res(x); });
	  }
	});
	$def($def.S + $def.F * !(useNative && __webpack_require__(823)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C      = getConstructor(this)
	      , values = [];
	    return new C(function(res, rej){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        C.resolve(promise).then(function(value){
	          results[index] = value;
	          --remaining || res(results);
	        }, rej);
	      });
	      else res(results);
	    });
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C = getConstructor(this);
	    return new C(function(res, rej){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(res, rej);
	      });
	    });
	  }
	});

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $    = __webpack_require__(25)
	  , $def = __webpack_require__(184);
	function createObjectToArray(isEntries){
	  return function(object){
	    var O      = $.toObject(object)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = Array(length)
	      , key;
	    if(isEntries)while(length > i)result[i] = [key = keys[i++], O[key]];
	    else while(length > i)result[i] = O[keys[i++]];
	    return result;
	  };
	}
	$def($def.S, 'Object', {
	  values:  createObjectToArray(false),
	  entries: createObjectToArray(true)
	});

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(14)
	  , enumKeys = __webpack_require__(464);
	// 19.1.2.1 Object.assign(target, source, ...)
	/* eslint-disable no-unused-vars */
	module.exports = Object.assign || function assign(target, source){
	/* eslint-enable no-unused-vars */
	  var T = Object($.assertDefined(target))
	    , l = arguments.length
	    , i = 1;
	  while(l > i){
	    var S      = $.ES5Object(arguments[i++])
	      , keys   = enumKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)T[key = keys[j++]] = S[key];
	  }
	  return T;
	};

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function($){
	  $.FW   = true;
	  $.path = $.g;
	  return $;
	};

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(14);
	module.exports = function(object, el){
	  var O      = $.toObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $      = __webpack_require__(14)
	  , invoke = __webpack_require__(229)
	  , assertFunction = __webpack_require__(65).fn;
	module.exports = function(/* ...pargs */){
	  var fn     = assertFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = $.path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that    = this
	      , _length = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !_length)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(_length > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var $                = __webpack_require__(14)
	  , cel              = __webpack_require__(463)
	  , cof              = __webpack_require__(72)
	  , $def             = __webpack_require__(23)
	  , invoke           = __webpack_require__(229)
	  , arrayMethod      = __webpack_require__(227)
	  , IE_PROTO         = __webpack_require__(87).safe('__proto__')
	  , assert           = __webpack_require__(65)
	  , assertObject     = assert.obj
	  , ObjectProto      = Object.prototype
	  , html             = $.html
	  , A                = []
	  , _slice           = A.slice
	  , _join            = A.join
	  , classof          = cof.classof
	  , has              = $.has
	  , defineProperty   = $.setDesc
	  , getOwnDescriptor = $.getDesc
	  , defineProperties = $.setDescs
	  , isFunction       = $.isFunction
	  , isObject         = $.isObject
	  , toObject         = $.toObject
	  , toLength         = $.toLength
	  , toIndex          = $.toIndex
	  , IE8_DOM_DEFINE   = false
	  , $indexOf         = __webpack_require__(459)(false)
	  , $forEach         = arrayMethod(0)
	  , $map             = arrayMethod(1)
	  , $filter          = arrayMethod(2)
	  , $some            = arrayMethod(3)
	  , $every           = arrayMethod(4);

	if(!$.DESC){
	  try {
	    IE8_DOM_DEFINE = defineProperty(cel('div'), 'x',
	      {get: function(){ return 8; }}
	    ).x == 8;
	  } catch(e){ /* empty */ }
	  $.setDesc = function(O, P, Attributes){
	    if(IE8_DOM_DEFINE)try {
	      return defineProperty(O, P, Attributes);
	    } catch(e){ /* empty */ }
	    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	    if('value' in Attributes)assertObject(O)[P] = Attributes.value;
	    return O;
	  };
	  $.getDesc = function(O, P){
	    if(IE8_DOM_DEFINE)try {
	      return getOwnDescriptor(O, P);
	    } catch(e){ /* empty */ }
	    if(has(O, P))return $.desc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
	  };
	  $.setDescs = defineProperties = function(O, Properties){
	    assertObject(O);
	    var keys   = $.getKeys(Properties)
	      , length = keys.length
	      , i = 0
	      , P;
	    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
	    return O;
	  };
	}
	$def($def.S + $def.F * !$.DESC, 'Object', {
	  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $.getDesc,
	  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	  defineProperty: $.setDesc,
	  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties
	});

	  // IE 8- don't enum bug keys
	var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
	            'toLocaleString,toString,valueOf').split(',')
	  // Additional keys for getOwnPropertyNames
	  , keys2 = keys1.concat('length', 'prototype')
	  , keysLen1 = keys1.length;

	// Create object with `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = cel('iframe')
	    , i      = keysLen1
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict.prototype[keys1[i]];
	  return createDict();
	};
	function createGetKeys(names, length){
	  return function(object){
	    var O      = toObject(object)
	      , i      = 0
	      , result = []
	      , key;
	    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	    // Don't enum bug & hidden keys
	    while(length > i)if(has(O, key = names[i++])){
	      ~$indexOf(result, key) || result.push(key);
	    }
	    return result;
	  };
	}
	function Empty(){}
	$def($def.S, 'Object', {
	  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	  getPrototypeOf: $.getProto = $.getProto || function(O){
	    O = Object(assert.def(O));
	    if(has(O, IE_PROTO))return O[IE_PROTO];
	    if(isFunction(O.constructor) && O instanceof O.constructor){
	      return O.constructor.prototype;
	    } return O instanceof Object ? ObjectProto : null;
	  },
	  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
	  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	  create: $.create = $.create || function(O, /*?*/Properties){
	    var result;
	    if(O !== null){
	      Empty.prototype = assertObject(O);
	      result = new Empty();
	      Empty.prototype = null;
	      // add "__proto__" for Object.getPrototypeOf shim
	      result[IE_PROTO] = O;
	    } else result = createDict();
	    return Properties === undefined ? result : defineProperties(result, Properties);
	  },
	  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false),
	  // 19.1.2.17 / 15.2.3.8 Object.seal(O)
	  seal: function seal(it){
	    return it; // <- cap
	  },
	  // 19.1.2.5 / 15.2.3.9 Object.freeze(O)
	  freeze: function freeze(it){
	    return it; // <- cap
	  },
	  // 19.1.2.15 / 15.2.3.10 Object.preventExtensions(O)
	  preventExtensions: function preventExtensions(it){
	    return it; // <- cap
	  },
	  // 19.1.2.13 / 15.2.3.11 Object.isSealed(O)
	  isSealed: function isSealed(it){
	    return !isObject(it); // <- cap
	  },
	  // 19.1.2.12 / 15.2.3.12 Object.isFrozen(O)
	  isFrozen: function isFrozen(it){
	    return !isObject(it); // <- cap
	  },
	  // 19.1.2.11 / 15.2.3.13 Object.isExtensible(O)
	  isExtensible: function isExtensible(it){
	    return isObject(it); // <- cap
	  }
	});

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	$def($def.P, 'Function', {
	  bind: function(that /*, args... */){
	    var fn       = assert.fn(this)
	      , partArgs = _slice.call(arguments, 1);
	    function bound(/* args... */){
	      var args   = partArgs.concat(_slice.call(arguments))
	        , constr = this instanceof bound
	        , ctx    = constr ? $.create(fn.prototype) : that
	        , result = invoke(fn, args, ctx);
	      return constr ? ctx : result;
	    }
	    if(fn.prototype)bound.prototype = fn.prototype;
	    return bound;
	  }
	});

	// Fix for not array-like ES3 string and DOM objects
	if(!(0 in Object('z') && 'z'[0] == 'z')){
	  $.ES5Object = function(it){
	    return cof(it) == 'String' ? it.split('') : Object(it);
	  };
	}

	var buggySlice = true;
	try {
	  if(html)_slice.call(html);
	  buggySlice = false;
	} catch(e){ /* empty */ }

	$def($def.P + $def.F * buggySlice, 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return _slice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

	$def($def.P + $def.F * ($.ES5Object != Object), 'Array', {
	  join: function join(){
	    return _join.apply($.ES5Object(this), arguments);
	  }
	});

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	$def($def.S, 'Array', {
	  isArray: function(arg){
	    return cof(arg) == 'Array';
	  }
	});
	function createArrayReduce(isRight){
	  return function(callbackfn, memo){
	    assert.fn(callbackfn);
	    var O      = toObject(this)
	      , length = toLength(O.length)
	      , index  = isRight ? length - 1 : 0
	      , i      = isRight ? -1 : 1;
	    if(arguments.length < 2)for(;;){
	      if(index in O){
	        memo = O[index];
	        index += i;
	        break;
	      }
	      index += i;
	      assert(isRight ? index >= 0 : length > index, 'Reduce of empty array with no initial value');
	    }
	    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
	      memo = callbackfn(memo, O[index], index, this);
	    }
	    return memo;
	  };
	}
	$def($def.P, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: $.each = $.each || function forEach(callbackfn/*, that = undefined */){
	    return $forEach(this, callbackfn, arguments[1]);
	  },
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn/*, that = undefined */){
	    return $map(this, callbackfn, arguments[1]);
	  },
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn/*, that = undefined */){
	    return $filter(this, callbackfn, arguments[1]);
	  },
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn/*, that = undefined */){
	    return $some(this, callbackfn, arguments[1]);
	  },
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn/*, that = undefined */){
	    return $every(this, callbackfn, arguments[1]);
	  },
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: createArrayReduce(false),
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: createArrayReduce(true),
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(el /*, fromIndex = 0 */){
	    return $indexOf(this, el, arguments[1]);
	  },
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
	    var O      = toObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, $.toInteger(fromIndex));
	    if(index < 0)index = toLength(length + index);
	    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
	    return -1;
	  }
	});

	// 21.1.3.25 / 15.5.4.20 String.prototype.trim()
	$def($def.P, 'String', {trim: __webpack_require__(310)(/^\s*([\s\S]*\S)?\s*$/, '$1')});

	// 20.3.3.1 / 15.9.4.4 Date.now()
	$def($def.S, 'Date', {now: function(){
	  return +new Date;
	}});

	function lz(num){
	  return num > 9 ? num : '0' + num;
	}

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	// PhantomJS and old webkit had a broken Date implementation.
	var date       = new Date(-5e13 - 1)
	  , brokenDate = !(date.toISOString && date.toISOString() == '0385-07-25T07:06:39.999Z'
	      && __webpack_require__(314)(function(){ new Date(NaN).toISOString(); }));
	$def($def.P + $def.F * brokenDate, 'Date', {toISOString: function(){
	  if(!isFinite(this))throw RangeError('Invalid time value');
	  var d = this
	    , y = d.getUTCFullYear()
	    , m = d.getUTCMilliseconds()
	    , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	}});

	if(classof(function(){ return arguments; }()) == 'Object')cof.classof = function(it){
	  var tag = classof(it);
	  return tag == 'Object' && isFunction(it.callee) ? 'Arguments' : tag;
	};

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $       = __webpack_require__(14)
	  , $def    = __webpack_require__(23)
	  , toIndex = $.toIndex;
	$def($def.P, 'Array', {
	  // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	  copyWithin: function copyWithin(target/* = 0 */, start /* = 0, end = @length */){
	    var O     = Object($.assertDefined(this))
	      , len   = $.toLength(O.length)
	      , to    = toIndex(target, len)
	      , from  = toIndex(start, len)
	      , end   = arguments[2]
	      , fin   = end === undefined ? len : toIndex(end, len)
	      , count = Math.min(fin - from, len - to)
	      , inc   = 1;
	    if(from < to && to < from + count){
	      inc  = -1;
	      from = from + count - 1;
	      to   = to   + count - 1;
	    }
	    while(count-- > 0){
	      if(from in O)O[to] = O[from];
	      else delete O[to];
	      to   += inc;
	      from += inc;
	    } return O;
	  }
	});
	__webpack_require__(151)('copyWithin');

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $       = __webpack_require__(14)
	  , $def    = __webpack_require__(23)
	  , toIndex = $.toIndex;
	$def($def.P, 'Array', {
	  // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	  fill: function fill(value /*, start = 0, end = @length */){
	    var O      = Object($.assertDefined(this))
	      , length = $.toLength(O.length)
	      , index  = toIndex(arguments[1], length)
	      , end    = arguments[2]
	      , endPos = end === undefined ? length : toIndex(end, length);
	    while(endPos > index)O[index++] = value;
	    return O;
	  }
	});
	__webpack_require__(151)('fill');

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var KEY    = 'findIndex'
	  , $def   = __webpack_require__(23)
	  , forced = true
	  , $find  = __webpack_require__(227)(6);
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$def($def.P + $def.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments[1]);
	  }
	});
	__webpack_require__(151)(KEY);

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var KEY    = 'find'
	  , $def   = __webpack_require__(23)
	  , forced = true
	  , $find  = __webpack_require__(227)(5);
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$def($def.P + $def.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments[1]);
	  }
	});
	__webpack_require__(151)(KEY);

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var $     = __webpack_require__(14)
	  , ctx   = __webpack_require__(125)
	  , $def  = __webpack_require__(23)
	  , $iter = __webpack_require__(100)
	  , call  = __webpack_require__(466);
	$def($def.S + $def.F * !__webpack_require__(309)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = Object($.assertDefined(arrayLike))
	      , mapfn   = arguments[1]
	      , mapping = mapfn !== undefined
	      , f       = mapping ? ctx(mapfn, arguments[2], 2) : undefined
	      , index   = 0
	      , length, result, step, iterator;
	    if($iter.is(O)){
	      iterator = $iter.get(O);
	      // strange IE quirks mode bug -> use typeof instead of isFunction
	      result   = new (typeof this == 'function' ? this : Array);
	      for(; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, f, [step.value, index], true) : step.value;
	      }
	    } else {
	      // strange IE quirks mode bug -> use typeof instead of isFunction
	      result = new (typeof this == 'function' ? this : Array)(length = $.toLength(O.length));
	      for(; length > index; index++){
	        result[index] = mapping ? f(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var $def = __webpack_require__(23);
	$def($def.S, 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , length = arguments.length
	      // strange IE quirks mode bug -> use typeof instead of isFunction
	      , result = new (typeof this == 'function' ? this : Array)(length);
	    while(length > index)result[index] = arguments[index++];
	    result.length = length;
	    return result;
	  }
	});

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(231)(Array);

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var $             = __webpack_require__(14)
	  , HAS_INSTANCE  = __webpack_require__(73)('hasInstance')
	  , FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(!$.isFunction(this) || !$.isObject(O))return false;
	  if(!$.isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = $.getProto(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $    = __webpack_require__(14)
	  , NAME = 'name'
	  , setDesc = $.setDesc
	  , FunctionProto = Function.prototype;
	// 19.2.4.2 name
	NAME in FunctionProto || $.FW && $.DESC && setDesc(FunctionProto, NAME, {
	  configurable: true,
	  get: function(){
	    var match = String(this).match(/^\s*function ([^ (]*)/)
	      , name  = match ? match[1] : '';
	    $.has(this, NAME) || setDesc(this, NAME, $.desc(5, name));
	    return name;
	  },
	  set: function(value){
	    $.has(this, NAME) || setDesc(this, NAME, $.desc(0, value));
	  }
	});

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(460);

	// 23.1 Map Objects
	__webpack_require__(228)('Map', function(get){
	  return function Map(){ return get(this, arguments[0]); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var Infinity = 1 / 0
	  , $def  = __webpack_require__(23)
	  , E     = Math.E
	  , pow   = Math.pow
	  , abs   = Math.abs
	  , exp   = Math.exp
	  , log   = Math.log
	  , sqrt  = Math.sqrt
	  , ceil  = Math.ceil
	  , floor = Math.floor
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	function roundTiesToEven(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	}

	// 20.2.2.28 Math.sign(x)
	function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	}
	// 20.2.2.5 Math.asinh(x)
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : log(x + sqrt(x * x + 1));
	}
	// 20.2.2.14 Math.expm1(x)
	function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : exp(x) - 1;
	}

	$def($def.S, 'Math', {
	  // 20.2.2.3 Math.acosh(x)
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : isFinite(x) ? log(x / E + sqrt(x + 1) * sqrt(x - 1) / E) + 1 : x;
	  },
	  // 20.2.2.5 Math.asinh(x)
	  asinh: asinh,
	  // 20.2.2.7 Math.atanh(x)
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : log((1 + x) / (1 - x)) / 2;
	  },
	  // 20.2.2.9 Math.cbrt(x)
	  cbrt: function cbrt(x){
	    return sign(x = +x) * pow(abs(x), 1 / 3);
	  },
	  // 20.2.2.11 Math.clz32(x)
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - floor(log(x + 0.5) * Math.LOG2E) : 32;
	  },
	  // 20.2.2.12 Math.cosh(x)
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  },
	  // 20.2.2.14 Math.expm1(x)
	  expm1: expm1,
	  // 20.2.2.16 Math.fround(x)
	  fround: function fround(x){
	    var $abs  = abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  },
	  // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , len  = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < len){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * sqrt(sum);
	  },
	  // 20.2.2.18 Math.imul(x, y)
	  imul: function imul(x, y){
	    var UInt16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UInt16 & xn
	      , yl = UInt16 & yn;
	    return 0 | xl * yl + ((UInt16 & xn >>> 16) * yl + xl * (UInt16 & yn >>> 16) << 16 >>> 0);
	  },
	  // 20.2.2.20 Math.log1p(x)
	  log1p: function log1p(x){
	    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log(1 + x);
	  },
	  // 20.2.2.21 Math.log10(x)
	  log10: function log10(x){
	    return log(x) / Math.LN10;
	  },
	  // 20.2.2.22 Math.log2(x)
	  log2: function log2(x){
	    return log(x) / Math.LN2;
	  },
	  // 20.2.2.28 Math.sign(x)
	  sign: sign,
	  // 20.2.2.30 Math.sinh(x)
	  sinh: function sinh(x){
	    return abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (E / 2);
	  },
	  // 20.2.2.33 Math.tanh(x)
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  },
	  // 20.2.2.34 Math.trunc(x)
	  trunc: function trunc(it){
	    return (it > 0 ? floor : ceil)(it);
	  }
	});

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(14)
	  , isObject   = $.isObject
	  , isFunction = $.isFunction
	  , NUMBER     = 'Number'
	  , $Number    = $.g[NUMBER]
	  , Base       = $Number
	  , proto      = $Number.prototype;
	function toPrimitive(it){
	  var fn, val;
	  if(isFunction(fn = it.valueOf) && !isObject(val = fn.call(it)))return val;
	  if(isFunction(fn = it.toString) && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to number");
	}
	function toNumber(it){
	  if(isObject(it))it = toPrimitive(it);
	  if(typeof it == 'string' && it.length > 2 && it.charCodeAt(0) == 48){
	    var binary = false;
	    switch(it.charCodeAt(1)){
	      case 66 : case 98  : binary = true;
	      case 79 : case 111 : return parseInt(it.slice(2), binary ? 2 : 8);
	    }
	  } return +it;
	}
	if($.FW && !($Number('0o1') && $Number('0b1'))){
	  $Number = function Number(it){
	    return this instanceof $Number ? new Base(toNumber(it)) : toNumber(it);
	  };
	  $.each.call($.DESC ? $.getNames(Base) : (
	      // ES3:
	      'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	      // ES6 (in case, if modules with ES6 Number statics required before):
	      'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	      'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	    ).split(','), function(key){
	      if($.has(Base, key) && !$.has($Number, key)){
	        $.setDesc($Number, key, $.getDesc(Base, key));
	      }
	    }
	  );
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(101)($.g, NUMBER, $Number);
	}

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var $     = __webpack_require__(14)
	  , $def  = __webpack_require__(23)
	  , abs   = Math.abs
	  , floor = Math.floor
	  , _isFinite = $.g.isFinite
	  , MAX_SAFE_INTEGER = 0x1fffffffffffff; // pow(2, 53) - 1 == 9007199254740991;
	function isInteger(it){
	  return !$.isObject(it) && _isFinite(it) && floor(it) === it;
	}
	$def($def.S, 'Number', {
	  // 20.1.2.1 Number.EPSILON
	  EPSILON: Math.pow(2, -52),
	  // 20.1.2.2 Number.isFinite(number)
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  },
	  // 20.1.2.3 Number.isInteger(number)
	  isInteger: isInteger,
	  // 20.1.2.4 Number.isNaN(number)
	  isNaN: function isNaN(number){
	    return number != number;
	  },
	  // 20.1.2.5 Number.isSafeInteger(number)
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= MAX_SAFE_INTEGER;
	  },
	  // 20.1.2.6 Number.MAX_SAFE_INTEGER
	  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
	  // 20.1.2.10 Number.MIN_SAFE_INTEGER
	  MIN_SAFE_INTEGER: -MAX_SAFE_INTEGER,
	  // 20.1.2.12 Number.parseFloat(string)
	  parseFloat: parseFloat,
	  // 20.1.2.13 Number.parseInt(string, radix)
	  parseInt: parseInt
	});

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $def = __webpack_require__(23);
	$def($def.S, 'Object', {assign: __webpack_require__(837)});

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $def = __webpack_require__(23);
	$def($def.S, 'Object', {
	  is: __webpack_require__(468)
	});

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $def = __webpack_require__(23);
	$def($def.S, 'Object', {setPrototypeOf: __webpack_require__(311).set});

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(14)
	  , $def     = __webpack_require__(23)
	  , isObject = $.isObject
	  , toObject = $.toObject;
	$.each.call(('freeze,seal,preventExtensions,isFrozen,isSealed,isExtensible,' +
	  'getOwnPropertyDescriptor,getPrototypeOf,keys,getOwnPropertyNames').split(',')
	, function(KEY, ID){
	  var fn     = ($.core.Object || {})[KEY] || Object[KEY]
	    , forced = 0
	    , method = {};
	  method[KEY] = ID == 0 ? function freeze(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 1 ? function seal(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 2 ? function preventExtensions(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 3 ? function isFrozen(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 4 ? function isSealed(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 5 ? function isExtensible(it){
	    return isObject(it) ? fn(it) : false;
	  } : ID == 6 ? function getOwnPropertyDescriptor(it, key){
	    return fn(toObject(it), key);
	  } : ID == 7 ? function getPrototypeOf(it){
	    return fn(Object($.assertDefined(it)));
	  } : ID == 8 ? function keys(it){
	    return fn(toObject(it));
	  } : __webpack_require__(465).get;
	  try {
	    fn('z');
	  } catch(e){
	    forced = 1;
	  }
	  $def($def.S + $def.F * forced, 'Object', method);
	});

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(72)
	  , tmp = {};
	tmp[__webpack_require__(73)('toStringTag')] = 'z';
	if(__webpack_require__(14).FW && cof(tmp) != 'z'){
	  __webpack_require__(101)(Object.prototype, 'toString', function toString(){
	    return '[object ' + cof.classof(this) + ']';
	  }, true);
	}

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $        = __webpack_require__(14)
	  , ctx      = __webpack_require__(125)
	  , cof      = __webpack_require__(72)
	  , $def     = __webpack_require__(23)
	  , assert   = __webpack_require__(65)
	  , forOf    = __webpack_require__(185)
	  , setProto = __webpack_require__(311).set
	  , same     = __webpack_require__(468)
	  , species  = __webpack_require__(231)
	  , SPECIES  = __webpack_require__(73)('species')
	  , RECORD   = __webpack_require__(87).safe('record')
	  , PROMISE  = 'Promise'
	  , global   = $.g
	  , process  = global.process
	  , isNode   = cof(process) == 'process'
	  , asap     = process && process.nextTick || __webpack_require__(471).set
	  , P        = global[PROMISE]
	  , isFunction     = $.isFunction
	  , isObject       = $.isObject
	  , assertFunction = assert.fn
	  , assertObject   = assert.obj
	  , Wrapper;

	function testResolve(sub){
	  var test = new P(function(){});
	  if(sub)test.constructor = Object;
	  return P.resolve(test) === test;
	}

	var useNative = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = isFunction(P) && isFunction(P.resolve) && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && $.DESC){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();

	// helpers
	function isPromise(it){
	  return isObject(it) && (useNative ? cof.classof(it) == 'Promise' : RECORD in it);
	}
	function sameConstructor(a, b){
	  // library wrapper special case
	  if(!$.FW && a === P && b === Wrapper)return true;
	  return same(a, b);
	}
	function getConstructor(C){
	  var S = assertObject(C)[SPECIES];
	  return S != undefined ? S : C;
	}
	function isThenable(it){
	  var then;
	  if(isObject(it))then = it.then;
	  return isFunction(then) ? then : false;
	}
	function notify(record){
	  var chain = record.c;
	  // strange IE + webpack dev server bug - use .call(global)
	  if(chain.length)asap.call(global, function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    function run(react){
	      var cb = ok ? react.ok : react.fail
	        , ret, then;
	      try {
	        if(cb){
	          if(!ok)record.h = true;
	          ret = cb === true ? value : cb(value);
	          if(ret === react.P){
	            react.rej(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(ret)){
	            then.call(ret, react.res, react.rej);
	          } else react.res(ret);
	        } else react.rej(value);
	      } catch(err){
	        react.rej(err);
	      }
	    }
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	  });
	}
	function isUnhandled(promise){
	  var record = promise[RECORD]
	    , chain  = record.a || record.c
	    , i      = 0
	    , react;
	  if(record.h)return false;
	  while(chain.length > i){
	    react = chain[i++];
	    if(react.fail || !isUnhandled(react.P))return false;
	  } return true;
	}
	function $reject(value){
	  var record = this
	    , promise;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  setTimeout(function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    asap.call(global, function(){
	      if(isUnhandled(promise = record.p)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(global.console && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      }
	      record.a = undefined;
	    });
	  }, 1);
	  notify(record);
	}
	function $resolve(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(then = isThenable(value)){
	      // strange IE + webpack dev server bug - use .call(global)
	      asap.call(global, function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	}

	// constructor polyfill
	if(!useNative){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    assertFunction(executor);
	    var record = {
	      p: assert.inst(this, P, PROMISE),       // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false                                // <- handled rejection
	    };
	    $.hide(this, RECORD, record);
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(230)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var S = assertObject(assertObject(this).constructor)[SPECIES];
	      var react = {
	        ok:   isFunction(onFulfilled) ? onFulfilled : true,
	        fail: isFunction(onRejected)  ? onRejected  : false
	      };
	      var promise = react.P = new (S != undefined ? S : P)(function(res, rej){
	        react.res = assertFunction(res);
	        react.rej = assertFunction(rej);
	      });
	      var record = this[RECORD];
	      record.c.push(react);
	      if(record.a)record.a.push(react);
	      if(record.s)notify(record);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}

	// export
	$def($def.G + $def.W + $def.F * !useNative, {Promise: P});
	cof.set(P, PROMISE);
	species(P);
	species(Wrapper = $.core[PROMISE]);

	// statics
	$def($def.S + $def.F * !useNative, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    return new (getConstructor(this))(function(res, rej){ rej(r); });
	  }
	});
	$def($def.S + $def.F * (!useNative || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    return isPromise(x) && sameConstructor(x.constructor, this)
	      ? x : new this(function(res){ res(x); });
	  }
	});
	$def($def.S + $def.F * !(useNative && __webpack_require__(309)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C      = getConstructor(this)
	      , values = [];
	    return new C(function(res, rej){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        C.resolve(promise).then(function(value){
	          results[index] = value;
	          --remaining || res(results);
	        }, rej);
	      });
	      else res(results);
	    });
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C = getConstructor(this);
	    return new C(function(res, rej){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(res, rej);
	      });
	    });
	  }
	});

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(14)
	  , $def      = __webpack_require__(23)
	  , setProto  = __webpack_require__(311)
	  , $iter     = __webpack_require__(100)
	  , ITERATOR  = __webpack_require__(73)('iterator')
	  , ITER      = __webpack_require__(87).safe('iter')
	  , step      = $iter.step
	  , assert    = __webpack_require__(65)
	  , isObject  = $.isObject
	  , getProto  = $.getProto
	  , $Reflect  = $.g.Reflect
	  , _apply    = Function.apply
	  , assertObject = assert.obj
	  , _isExtensible = Object.isExtensible || isObject
	  , _preventExtensions = Object.preventExtensions
	  // IE TP has broken Reflect.enumerate
	  , buggyEnumerate = !($Reflect && $Reflect.enumerate && ITERATOR in $Reflect.enumerate({}));

	function Enumerate(iterated){
	  $.set(this, ITER, {o: iterated, k: undefined, i: 0});
	}
	$iter.create(Enumerate, 'Object', function(){
	  var iter = this[ITER]
	    , keys = iter.k
	    , key;
	  if(keys == undefined){
	    iter.k = keys = [];
	    for(key in iter.o)keys.push(key);
	  }
	  do {
	    if(iter.i >= keys.length)return step(1);
	  } while(!((key = keys[iter.i++]) in iter.o));
	  return step(0, key);
	});

	var reflect = {
	  // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(target, thisArgument, argumentsList);
	  },
	  // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	  construct: function construct(target, argumentsList /*, newTarget*/){
	    var proto    = assert.fn(arguments.length < 3 ? target : arguments[2]).prototype
	      , instance = $.create(isObject(proto) ? proto : Object.prototype)
	      , result   = _apply.call(target, instance, argumentsList);
	    return isObject(result) ? result : instance;
	  },
	  // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    assertObject(target);
	    try {
	      $.setDesc(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  },
	  // 26.1.4 Reflect.deleteProperty(target, propertyKey)
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = $.getDesc(assertObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  },
	  // 26.1.6 Reflect.get(target, propertyKey [, receiver])
	  get: function get(target, propertyKey/*, receiver*/){
	    var receiver = arguments.length < 3 ? target : arguments[2]
	      , desc = $.getDesc(assertObject(target), propertyKey), proto;
	    if(desc)return $.has(desc, 'value')
	      ? desc.value
	      : desc.get === undefined
	        ? undefined
	        : desc.get.call(receiver);
	    return isObject(proto = getProto(target))
	      ? get(proto, propertyKey, receiver)
	      : undefined;
	  },
	  // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return $.getDesc(assertObject(target), propertyKey);
	  },
	  // 26.1.8 Reflect.getPrototypeOf(target)
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(assertObject(target));
	  },
	  // 26.1.9 Reflect.has(target, propertyKey)
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  },
	  // 26.1.10 Reflect.isExtensible(target)
	  isExtensible: function isExtensible(target){
	    return _isExtensible(assertObject(target));
	  },
	  // 26.1.11 Reflect.ownKeys(target)
	  ownKeys: __webpack_require__(467),
	  // 26.1.12 Reflect.preventExtensions(target)
	  preventExtensions: function preventExtensions(target){
	    assertObject(target);
	    try {
	      if(_preventExtensions)_preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  },
	  // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	  set: function set(target, propertyKey, V/*, receiver*/){
	    var receiver = arguments.length < 4 ? target : arguments[3]
	      , ownDesc  = $.getDesc(assertObject(target), propertyKey)
	      , existingDescriptor, proto;
	    if(!ownDesc){
	      if(isObject(proto = getProto(target))){
	        return set(proto, propertyKey, V, receiver);
	      }
	      ownDesc = $.desc(0);
	    }
	    if($.has(ownDesc, 'value')){
	      if(ownDesc.writable === false || !isObject(receiver))return false;
	      existingDescriptor = $.getDesc(receiver, propertyKey) || $.desc(0);
	      existingDescriptor.value = V;
	      $.setDesc(receiver, propertyKey, existingDescriptor);
	      return true;
	    }
	    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	  }
	};
	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	if(setProto)reflect.setPrototypeOf = function setPrototypeOf(target, proto){
	  setProto.check(target, proto);
	  try {
	    setProto.set(target, proto);
	    return true;
	  } catch(e){
	    return false;
	  }
	};

	$def($def.G, {Reflect: {}});

	$def($def.S + $def.F * buggyEnumerate, 'Reflect', {
	  // 26.1.5 Reflect.enumerate(target)
	  enumerate: function enumerate(target){
	    return new Enumerate(assertObject(target));
	  }
	});

	$def($def.S, 'Reflect', reflect);

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(14)
	  , cof     = __webpack_require__(72)
	  , $RegExp = $.g.RegExp
	  , Base    = $RegExp
	  , proto   = $RegExp.prototype
	  , re      = /a/g
	  // "new" creates a new object
	  , CORRECT_NEW = new $RegExp(re) !== re
	  // RegExp allows a regex with flags as the pattern
	  , ALLOWS_RE_WITH_FLAGS = function(){
	    try {
	      return $RegExp(re, 'i') == '/a/i';
	    } catch(e){ /* empty */ }
	  }();
	if($.FW && $.DESC){
	  if(!CORRECT_NEW || !ALLOWS_RE_WITH_FLAGS){
	    $RegExp = function RegExp(pattern, flags){
	      var patternIsRegExp  = cof(pattern) == 'RegExp'
	        , flagsIsUndefined = flags === undefined;
	      if(!(this instanceof $RegExp) && patternIsRegExp && flagsIsUndefined)return pattern;
	      return CORRECT_NEW
	        ? new Base(patternIsRegExp && !flagsIsUndefined ? pattern.source : pattern, flags)
	        : new Base(patternIsRegExp ? pattern.source : pattern
	          , patternIsRegExp && flagsIsUndefined ? pattern.flags : flags);
	    };
	    $.each.call($.getNames(Base), function(key){
	      key in $RegExp || $.setDesc($RegExp, key, {
	        configurable: true,
	        get: function(){ return Base[key]; },
	        set: function(it){ Base[key] = it; }
	      });
	    });
	    proto.constructor = $RegExp;
	    $RegExp.prototype = proto;
	    __webpack_require__(101)($.g, 'RegExp', $RegExp);
	  }
	  // 21.2.5.3 get RegExp.prototype.flags()
	  if(/./g.flags != 'g')$.setDesc(proto, 'flags', {
	    configurable: true,
	    get: __webpack_require__(310)(/^.*\/(\w*)$/, '$1')
	  });
	}
	__webpack_require__(231)($RegExp);

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(460);

	// 23.2 Set Objects
	__webpack_require__(228)('Set', function(get){
	  return function Set(){ return get(this, arguments[0]); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $def = __webpack_require__(23)
	  , $at  = __webpack_require__(313)(false);
	$def($def.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $    = __webpack_require__(14)
	  , cof  = __webpack_require__(72)
	  , $def = __webpack_require__(23)
	  , toLength = $.toLength;

	// should throw error on regex
	$def($def.P + $def.F * !__webpack_require__(314)(function(){ 'q'.endsWith(/./); }), 'String', {
	  // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    if(cof(searchString) == 'RegExp')throw TypeError();
	    var that = String($.assertDefined(this))
	      , endPosition = arguments[1]
	      , len = toLength(that.length)
	      , end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    searchString += '';
	    return that.slice(end - searchString.length, end) === searchString;
	  }
	});

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var $def    = __webpack_require__(23)
	  , toIndex = __webpack_require__(14).toIndex
	  , fromCharCode = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	$def($def.S + $def.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res = []
	      , len = arguments.length
	      , i   = 0
	      , code;
	    while(len > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $    = __webpack_require__(14)
	  , cof  = __webpack_require__(72)
	  , $def = __webpack_require__(23);

	$def($def.P, 'String', {
	  // 21.1.3.7 String.prototype.includes(searchString, position = 0)
	  includes: function includes(searchString /*, position = 0 */){
	    if(cof(searchString) == 'RegExp')throw TypeError();
	    return !!~String($.assertDefined(this)).indexOf(searchString, arguments[1]);
	  }
	});

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var set   = __webpack_require__(14).set
	  , $at   = __webpack_require__(313)(true)
	  , ITER  = __webpack_require__(87).safe('iter')
	  , $iter = __webpack_require__(100)
	  , step  = $iter.step;

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(308)(String, 'String', function(iterated){
	  set(this, ITER, {o: String(iterated), i: 0});
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var iter  = this[ITER]
	    , O     = iter.o
	    , index = iter.i
	    , point;
	  if(index >= O.length)return step(1);
	  point = $at(O, index);
	  iter.i += point.length;
	  return step(0, point);
	});

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var $    = __webpack_require__(14)
	  , $def = __webpack_require__(23);

	$def($def.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl = $.toObject(callSite.raw)
	      , len = $.toLength(tpl.length)
	      , sln = arguments.length
	      , res = []
	      , i   = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < sln)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var $def = __webpack_require__(23);

	$def($def.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(470)
	});

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $    = __webpack_require__(14)
	  , cof  = __webpack_require__(72)
	  , $def = __webpack_require__(23);

	// should throw error on regex
	$def($def.P + $def.F * !__webpack_require__(314)(function(){ 'q'.startsWith(/./); }), 'String', {
	  // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    if(cof(searchString) == 'RegExp')throw TypeError();
	    var that  = String($.assertDefined(this))
	      , index = $.toLength(Math.min(arguments[1], that.length));
	    searchString += '';
	    return that.slice(index, index + searchString.length) === searchString;
	  }
	});

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $        = __webpack_require__(14)
	  , setTag   = __webpack_require__(72).set
	  , uid      = __webpack_require__(87)
	  , shared   = __webpack_require__(312)
	  , $def     = __webpack_require__(23)
	  , $redef   = __webpack_require__(101)
	  , keyOf    = __webpack_require__(839)
	  , enumKeys = __webpack_require__(464)
	  , assertObject = __webpack_require__(65).obj
	  , ObjectProto = Object.prototype
	  , DESC     = $.DESC
	  , has      = $.has
	  , $create  = $.create
	  , getDesc  = $.getDesc
	  , setDesc  = $.setDesc
	  , desc     = $.desc
	  , $names   = __webpack_require__(465)
	  , getNames = $names.get
	  , toObject = $.toObject
	  , $Symbol  = $.g.Symbol
	  , setter   = false
	  , TAG      = uid('tag')
	  , HIDDEN   = uid('hidden')
	  , _propertyIsEnumerable = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols = shared('symbols')
	  , useNative = $.isFunction($Symbol);

	var setSymbolDesc = DESC ? function(){ // fallback for old Android
	  try {
	    return $create(setDesc({}, HIDDEN, {
	      get: function(){
	        return setDesc(this, HIDDEN, {value: false})[HIDDEN];
	      }
	    }))[HIDDEN] || setDesc;
	  } catch(e){
	    return function(it, key, D){
	      var protoDesc = getDesc(ObjectProto, key);
	      if(protoDesc)delete ObjectProto[key];
	      setDesc(it, key, D);
	      if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	    };
	  }
	}() : setDesc;

	function wrap(tag){
	  var sym = AllSymbols[tag] = $.set($create($Symbol.prototype), TAG, tag);
	  DESC && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, desc(1, value));
	    }
	  });
	  return sym;
	}

	function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, desc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = $create(D, {enumerable: desc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	}
	function defineProperties(it, P){
	  assertObject(it);
	  var keys = enumKeys(P = toObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)defineProperty(it, key = keys[i++], P[key]);
	  return it;
	}
	function create(it, P){
	  return P === undefined ? $create(it) : defineProperties($create(it), P);
	}
	function propertyIsEnumerable(key){
	  var E = _propertyIsEnumerable.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	}
	function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	}
	function getOwnPropertyNames(it){
	  var names  = getNames(toObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	}
	function getOwnPropertySymbols(it){
	  var names  = getNames(toObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	}

	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments[0]));
	  };
	  $redef($Symbol.prototype, 'toString', function(){
	    return this[TAG];
	  });

	  $.create     = create;
	  $.setDesc    = defineProperty;
	  $.getDesc    = getOwnPropertyDescriptor;
	  $.setDescs   = defineProperties;
	  $.getNames   = $names.get = getOwnPropertyNames;
	  $.getSymbols = getOwnPropertySymbols;

	  if($.DESC && $.FW)$redef(ObjectProto, 'propertyIsEnumerable', propertyIsEnumerable, true);
	}

	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	    'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	    'species,split,toPrimitive,toStringTag,unscopables'
	  ).split(','), function(it){
	    var sym = __webpack_require__(73)(it);
	    symbolStatics[it] = useNative ? sym : wrap(sym);
	  }
	);

	setter = true;

	$def($def.G + $def.W, {Symbol: $Symbol});

	$def($def.S, 'Symbol', symbolStatics);

	$def($def.S + $def.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: getOwnPropertySymbols
	});

	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setTag($.g.JSON, 'JSON', true);

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $         = __webpack_require__(14)
	  , weak      = __webpack_require__(462)
	  , leakStore = weak.leakStore
	  , ID        = weak.ID
	  , WEAK      = weak.WEAK
	  , has       = $.has
	  , isObject  = $.isObject
	  , isExtensible = Object.isExtensible || isObject
	  , tmp       = {};

	// 23.3 WeakMap Objects
	var $WeakMap = __webpack_require__(228)('WeakMap', function(get){
	  return function WeakMap(){ return get(this, arguments[0]); };
	}, {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      if(!isExtensible(key))return leakStore(this).get(key);
	      if(has(key, WEAK))return key[WEAK][this[ID]];
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	}, weak, true, true);

	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  $.each.call(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    __webpack_require__(101)(proto, key, function(a, b){
	      // store frozen objects on leaky map
	      if(isObject(a) && !isExtensible(a)){
	        var result = leakStore(this)[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(462);

	// 23.4 WeakSet Objects
	__webpack_require__(228)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments[0]); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $def      = __webpack_require__(23)
	  , $includes = __webpack_require__(459)(true);
	$def($def.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments[1]);
	  }
	});
	__webpack_require__(151)('includes');

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	__webpack_require__(461)('Map');

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/WebReflection/9353781
	var $       = __webpack_require__(14)
	  , $def    = __webpack_require__(23)
	  , ownKeys = __webpack_require__(467);

	$def($def.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O      = $.toObject(object)
	      , result = {};
	    $.each.call(ownKeys(O), function(key){
	      $.setDesc(result, key, $.desc(0, $.getDesc(O, key)));
	    });
	    return result;
	  }
	});

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $    = __webpack_require__(14)
	  , $def = __webpack_require__(23);
	function createObjectToArray(isEntries){
	  return function(object){
	    var O      = $.toObject(object)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = Array(length)
	      , key;
	    if(isEntries)while(length > i)result[i] = [key = keys[i++], O[key]];
	    else while(length > i)result[i] = O[keys[i++]];
	    return result;
	  };
	}
	$def($def.S, 'Object', {
	  values:  createObjectToArray(false),
	  entries: createObjectToArray(true)
	});

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $def = __webpack_require__(23);
	$def($def.S, 'RegExp', {
	  escape: __webpack_require__(310)(/[\\^$*+?.()|[\]{}]/g, '\\$&', true)
	});


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	__webpack_require__(461)('Set');

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/mathiasbynens/String.prototype.at
	'use strict';
	var $def = __webpack_require__(23)
	  , $at  = __webpack_require__(313)(true);
	$def($def.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $def = __webpack_require__(23)
	  , $pad = __webpack_require__(469);
	$def($def.P, 'String', {
	  lpad: function lpad(n){
	    return $pad(this, n, arguments[1], true);
	  }
	});

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $def = __webpack_require__(23)
	  , $pad = __webpack_require__(469);
	$def($def.P, 'String', {
	  rpad: function rpad(n){
	    return $pad(this, n, arguments[1], false);
	  }
	});

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	// JavaScript 1.6 / Strawman array statics shim
	var $       = __webpack_require__(14)
	  , $def    = __webpack_require__(23)
	  , $Array  = $.core.Array || Array
	  , statics = {};
	function setStatics(keys, length){
	  $.each.call(keys.split(','), function(key){
	    if(length == undefined && key in $Array)statics[key] = $Array[key];
	    else if(key in [])statics[key] = __webpack_require__(125)(Function.call, [][key], length);
	  });
	}
	setStatics('pop,reverse,shift,keys,values,entries', 1);
	setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	           'reduce,reduceRight,copyWithin,fill,turn');
	$def($def.S, 'Array', statics);

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(472);
	var $           = __webpack_require__(14)
	  , Iterators   = __webpack_require__(100).Iterators
	  , ITERATOR    = __webpack_require__(73)('iterator')
	  , ArrayValues = Iterators.Array
	  , NL          = $.g.NodeList
	  , HTC         = $.g.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype;
	if($.FW){
	  if(NL && !(ITERATOR in NLProto))$.hide(NLProto, ITERATOR, ArrayValues);
	  if(HTC && !(ITERATOR in HTCProto))$.hide(HTCProto, ITERATOR, ArrayValues);
	}
	Iterators.NodeList = Iterators.HTMLCollection = ArrayValues;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var $def  = __webpack_require__(23)
	  , $task = __webpack_require__(471);
	$def($def.G + $def.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var $         = __webpack_require__(14)
	  , $def      = __webpack_require__(23)
	  , invoke    = __webpack_require__(229)
	  , partial   = __webpack_require__(840)
	  , navigator = $.g.navigator
	  , MSIE      = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	function wrap(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      $.isFunction(fn) ? fn : Function(fn)
	    ), time);
	  } : set;
	}
	$def($def.G + $def.B + $def.F * MSIE, {
	  setTimeout:  wrap($.g.setTimeout),
	  setInterval: wrap($.g.setInterval)
	});

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(841);
	__webpack_require__(872);
	__webpack_require__(855);
	__webpack_require__(856);
	__webpack_require__(857);
	__webpack_require__(859);
	__webpack_require__(858);
	__webpack_require__(850);
	__webpack_require__(849);
	__webpack_require__(853);
	__webpack_require__(854);
	__webpack_require__(852);
	__webpack_require__(866);
	__webpack_require__(869);
	__webpack_require__(868);
	__webpack_require__(864);
	__webpack_require__(865);
	__webpack_require__(867);
	__webpack_require__(870);
	__webpack_require__(871);
	__webpack_require__(846);
	__webpack_require__(847);
	__webpack_require__(472);
	__webpack_require__(848);
	__webpack_require__(842);
	__webpack_require__(843);
	__webpack_require__(845);
	__webpack_require__(844);
	__webpack_require__(862);
	__webpack_require__(860);
	__webpack_require__(851);
	__webpack_require__(863);
	__webpack_require__(873);
	__webpack_require__(874);
	__webpack_require__(861);
	__webpack_require__(875);
	__webpack_require__(881);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(879);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(876);
	__webpack_require__(880);
	__webpack_require__(884);
	__webpack_require__(887);
	__webpack_require__(886);
	__webpack_require__(885);
	module.exports = __webpack_require__(14).core;


/***/ },
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * @typechecks
	 */

	"use strict";

	var invariant = __webpack_require__(991);

	var _lastID = 1;
	var _prefix = 'ID_';

	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *    CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *
	 *         case 'city-update':
	 *           FlightPriceStore.price =
	 *             FlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */

	  function Dispatcher() {
	    this.$Dispatcher_callbacks = {};
	    this.$Dispatcher_isPending = {};
	    this.$Dispatcher_isHandled = {};
	    this.$Dispatcher_isDispatching = false;
	    this.$Dispatcher_pendingPayload = null;
	  }

	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   *
	   * @param {function} callback
	   * @return {string}
	   */
	  Dispatcher.prototype.register=function(callback) {
	    var id = _prefix + _lastID++;
	    this.$Dispatcher_callbacks[id] = callback;
	    return id;
	  };

	  /**
	   * Removes a callback based on its token.
	   *
	   * @param {string} id
	   */
	  Dispatcher.prototype.unregister=function(id) {
	    invariant(
	      this.$Dispatcher_callbacks[id],
	      'Dispatcher.unregister(...): `%s` does not map to a registered callback.',
	      id
	    );
	    delete this.$Dispatcher_callbacks[id];
	  };

	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   *
	   * @param {array<string>} ids
	   */
	  Dispatcher.prototype.waitFor=function(ids) {
	    invariant(
	      this.$Dispatcher_isDispatching,
	      'Dispatcher.waitFor(...): Must be invoked while dispatching.'
	    );
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this.$Dispatcher_isPending[id]) {
	        invariant(
	          this.$Dispatcher_isHandled[id],
	          'Dispatcher.waitFor(...): Circular dependency detected while ' +
	          'waiting for `%s`.',
	          id
	        );
	        continue;
	      }
	      invariant(
	        this.$Dispatcher_callbacks[id],
	        'Dispatcher.waitFor(...): `%s` does not map to a registered callback.',
	        id
	      );
	      this.$Dispatcher_invokeCallback(id);
	    }
	  };

	  /**
	   * Dispatches a payload to all registered callbacks.
	   *
	   * @param {object} payload
	   */
	  Dispatcher.prototype.dispatch=function(payload) {
	    invariant(
	      !this.$Dispatcher_isDispatching,
	      'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.'
	    );
	    this.$Dispatcher_startDispatching(payload);
	    try {
	      for (var id in this.$Dispatcher_callbacks) {
	        if (this.$Dispatcher_isPending[id]) {
	          continue;
	        }
	        this.$Dispatcher_invokeCallback(id);
	      }
	    } finally {
	      this.$Dispatcher_stopDispatching();
	    }
	  };

	  /**
	   * Is this Dispatcher currently dispatching.
	   *
	   * @return {boolean}
	   */
	  Dispatcher.prototype.isDispatching=function() {
	    return this.$Dispatcher_isDispatching;
	  };

	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @param {string} id
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_invokeCallback=function(id) {
	    this.$Dispatcher_isPending[id] = true;
	    this.$Dispatcher_callbacks[id](this.$Dispatcher_pendingPayload);
	    this.$Dispatcher_isHandled[id] = true;
	  };

	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @param {object} payload
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_startDispatching=function(payload) {
	    for (var id in this.$Dispatcher_callbacks) {
	      this.$Dispatcher_isPending[id] = false;
	      this.$Dispatcher_isHandled[id] = false;
	    }
	    this.$Dispatcher_pendingPayload = payload;
	    this.$Dispatcher_isDispatching = true;
	  };

	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_stopDispatching=function() {
	    this.$Dispatcher_pendingPayload = null;
	    this.$Dispatcher_isDispatching = false;
	  };


	module.exports = Dispatcher;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */

	"use strict";

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	module.exports = invariant;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	(function() {

	/*! Raven.js 1.1.16 (463f68f) | github.com/getsentry/raven-js */

	/*
	 * Includes TraceKit
	 * https://github.com/getsentry/TraceKit
	 *
	 * Copyright 2014 Matt Robenolt and other contributors
	 * Released under the BSD license
	 * https://github.com/getsentry/raven-js/blob/master/LICENSE
	 *
	 */
	;(function(window, undefined){
	'use strict';

	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	 MIT license
	*/

	var TraceKit = {
	    remoteFetching: false,
	    collectWindowErrors: true,
	    // 3 lines before, the offending line, 3 lines after
	    linesOfContext: 7
	};

	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';


	/**
	 * TraceKit.wrap: Wrap any function in a TraceKit reporter
	 * Example: func = TraceKit.wrap(func);
	 *
	 * @param {Function} func Function to be wrapped
	 * @return {Function} The wrapped func
	 */
	TraceKit.wrap = function traceKitWrapper(func) {
	    function wrapped() {
	        try {
	            return func.apply(this, arguments);
	        } catch (e) {
	            TraceKit.report(e);
	            throw e;
	        }
	    }
	    return wrapped;
	};

	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;

	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }

	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }

	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }

	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (hasKey(handlers, i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }

	        if (exception) {
	            throw exception;
	        }
	    }

	    var _oldOnerrorHandler, _onErrorHandlerInstalled;

	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;

	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	            location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
	            location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
	            stack = {
	                'message': message,
	                'url': document.location.href,
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }

	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }

	        return false;
	    }

	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = window.onerror;
	        window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }

	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }

	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }

	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }

	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;

	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        window.setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));

	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }

	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());

	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace.ofCaller([depth])
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 * Tracing example:
	 *     function trace(message) {
	 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
	 *         var data = message + "\n";
	 *         for(var i in stackInfo.stack) {
	 *             var item = stackInfo.stack[i];
	 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
	 *         }
	 *         if (window.console)
	 *             console.info(data);
	 *         else
	 *             alert(data);
	 *     }
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    var debug = false,
	        sourceCache = {};

	    /**
	     * Attempts to retrieve source code via XMLHttpRequest, which is used
	     * to look up anonymous function names.
	     * @param {string} url URL of source code.
	     * @return {string} Source contents.
	     */
	    function loadSource(url) {
	        if (!TraceKit.remoteFetching) { //Only attempt request if remoteFetching is on.
	            return '';
	        }
	        try {
	            var getXHR = function() {
	                try {
	                    return new window.XMLHttpRequest();
	                } catch (e) {
	                    // explicitly bubble up the exception if not found
	                    return new window.ActiveXObject('Microsoft.XMLHTTP');
	                }
	            };

	            var request = getXHR();
	            request.open('GET', url, false);
	            request.send('');
	            return request.responseText;
	        } catch (e) {
	            return '';
	        }
	    }

	    /**
	     * Retrieves source code from the source code cache.
	     * @param {string} url URL of source code.
	     * @return {Array.<string>} Source contents.
	     */
	    function getSource(url) {
	        if (!isString(url)) return [];
	        if (!hasKey(sourceCache, url)) {
	            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
	            // cross-domain errors will be triggered.
	            var source = '';
	            if (url.indexOf(document.domain) !== -1) {
	                source = loadSource(url);
	            }
	            sourceCache[url] = source ? source.split('\n') : [];
	        }

	        return sourceCache[url];
	    }

	    /**
	     * Tries to use an externally loaded copy of source code to determine
	     * the name of a function by looking at the name of the variable it was
	     * assigned to, if any.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} lineNo Line number in source code.
	     * @return {string} The function name, if discoverable.
	     */
	    function guessFunctionName(url, lineNo) {
	        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
	            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
	            line = '',
	            maxLines = 10,
	            source = getSource(url),
	            m;

	        if (!source.length) {
	            return UNKNOWN_FUNCTION;
	        }

	        // Walk backwards from the first line in the function until we find the line which
	        // matches the pattern above, which is the function definition
	        for (var i = 0; i < maxLines; ++i) {
	            line = source[lineNo - i] + line;

	            if (!isUndefined(line)) {
	                if ((m = reGuessFunction.exec(line))) {
	                    return m[1];
	                } else if ((m = reFunctionArgNames.exec(line))) {
	                    return m[1];
	                }
	            }
	        }

	        return UNKNOWN_FUNCTION;
	    }

	    /**
	     * Retrieves the surrounding lines from where an exception occurred.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} line Line number in source code to centre
	     * around for context.
	     * @return {?Array.<string>} Lines of source code.
	     */
	    function gatherContext(url, line) {
	        var source = getSource(url);

	        if (!source.length) {
	            return null;
	        }

	        var context = [],
	            // linesBefore & linesAfter are inclusive with the offending line.
	            // if linesOfContext is even, there will be one extra line
	            //   *before* the offending line.
	            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
	            // Add one extra line if linesOfContext is odd
	            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
	            start = Math.max(0, line - linesBefore - 1),
	            end = Math.min(source.length, line + linesAfter - 1);

	        line -= 1; // convert to 0-based index

	        for (var i = start; i < end; ++i) {
	            if (!isUndefined(source[i])) {
	                context.push(source[i]);
	            }
	        }

	        return context.length > 0 ? context : null;
	    }

	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }

	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }

	    /**
	     * Determines where a code fragment occurs in the source code.
	     * @param {RegExp} re The function definition.
	     * @param {Array.<string>} urls A list of URLs to search.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceInUrls(re, urls) {
	        var source, m;
	        for (var i = 0, j = urls.length; i < j; ++i) {
	            // console.log('searching', urls[i]);
	            if ((source = getSource(urls[i])).length) {
	                source = source.join('\n');
	                if ((m = re.exec(source))) {
	                    // console.log('Found function in ' + urls[i]);

	                    return {
	                        'url': urls[i],
	                        'line': source.substring(0, m.index).split('\n').length,
	                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
	                    };
	                }
	            }
	        }

	        // console.log('no match');

	        return null;
	    }

	    /**
	     * Determines at which column a code fragment occurs on a line of the
	     * source code.
	     * @param {string} fragment The code fragment.
	     * @param {string} url The URL to search.
	     * @param {(string|number)} line The line number to examine.
	     * @return {?number} The column number.
	     */
	    function findSourceInLine(fragment, url, line) {
	        var source = getSource(url),
	            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
	            m;

	        line -= 1;

	        if (source && source.length > line && (m = re.exec(source[line]))) {
	            return m.index;
	        }

	        return null;
	    }

	    /**
	     * Determines where a function was defined within the source code.
	     * @param {(Function|string)} func A function reference or serialized
	     * function definition.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceByFunctionBody(func) {
	        var urls = [window.location.href],
	            scripts = document.getElementsByTagName('script'),
	            body,
	            code = '' + func,
	            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            re,
	            parts,
	            result;

	        for (var i = 0; i < scripts.length; ++i) {
	            var script = scripts[i];
	            if (script.src) {
	                urls.push(script.src);
	            }
	        }

	        if (!(parts = codeRE.exec(code))) {
	            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
	        }

	        // not sure if this is really necessary, but I don’t have a test
	        // corpus large enough to confirm that and it was in the original.
	        else {
	            var name = parts[1] ? '\\s+' + parts[1] : '',
	                args = parts[2].split(',').join('\\s*,\\s*');

	            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
	            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
	        }

	        // look for a normal function definition
	        if ((result = findSourceInUrls(re, urls))) {
	            return result;
	        }

	        // look for an old-school event handler function
	        if ((parts = eventRE.exec(code))) {
	            var event = parts[1];
	            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);

	            // look for a function defined in HTML as an onXXX handler
	            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');

	            if ((result = findSourceInUrls(re, urls[0]))) {
	                return result;
	            }

	            // look for ???
	            re = new RegExp(body);

	            if ((result = findSourceInUrls(re, urls))) {
	                return result;
	            }
	        }

	        return null;
	    }

	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (!ex.stack) {
	            return null;
	        }

	        var chrome = /^\s*at (?:((?:\[object object\])?\S+(?: \[as \S+\])?) )?\(?((?:file|https?|chrome-extension):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(\S*)(?:\((.*?)\))?@((?:file|https?|chrome).*?):(\d+)(?::(\d+))?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);

	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : '',
	                    'line': +parts[4],
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else if ((parts = chrome.exec(lines[i]))) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else {
	                continue;
	            }

	            if (!element.func && element.line) {
	                element.func = guessFunctionName(element.url, element.line);
	            }

	            if (element.line) {
	                element.context = gatherContext(element.url, element.line);
	            }

	            stack.push(element);
	        }

	        if (!stack.length) {
	            return null;
	        }

	        if (stack[0].line && !stack[0].column && reference) {
	            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
	        } else if (!stack[0].column && !isUndefined(ex.columnNumber)) {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }

	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack
	        };
	    }

	    /**
	     * Computes stack trace information from the stacktrace property.
	     * Opera 10 uses this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStacktraceProp(ex) {
	        // Access and store the stacktrace property before doing ANYTHING
	        // else to it because Opera is not very good at providing it
	        // reliably in other circumstances.
	        var stacktrace = ex.stacktrace;

	        var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
	            lines = stacktrace.split('\n'),
	            stack = [],
	            parts;

	        for (var i = 0, j = lines.length; i < j; i += 2) {
	            if ((parts = testRE.exec(lines[i]))) {
	                var element = {
	                    'line': +parts[1],
	                    'column': +parts[2],
	                    'func': parts[3] || parts[4],
	                    'args': parts[5] ? parts[5].split(',') : [],
	                    'url': parts[6]
	                };

	                if (!element.func && element.line) {
	                    element.func = guessFunctionName(element.url, element.line);
	                }
	                if (element.line) {
	                    try {
	                        element.context = gatherContext(element.url, element.line);
	                    } catch (exc) {}
	                }

	                if (!element.context) {
	                    element.context = [lines[i + 1]];
	                }

	                stack.push(element);
	            }
	        }

	        if (!stack.length) {
	            return null;
	        }

	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack
	        };
	    }

	    /**
	     * NOT TESTED.
	     * Computes stack trace information from an error message that includes
	     * the stack trace.
	     * Opera 9 and earlier use this method if the option to show stack
	     * traces is turned on in opera:config.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack information.
	     */
	    function computeStackTraceFromOperaMultiLineMessage(ex) {
	        // Opera includes a stack trace into the exception message. An example is:
	        //
	        // Statement on line 3: Undefined variable: undefinedFunc
	        // Backtrace:
	        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
	        //         undefinedFunc(a);
	        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
	        //           zzz(x, y, z);
	        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
	        //           yyy(a, a, a);
	        //   Line 1 of function script
	        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
	        //   ...

	        var lines = ex.message.split('\n');
	        if (lines.length < 4) {
	            return null;
	        }

	        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
	            stack = [],
	            scripts = document.getElementsByTagName('script'),
	            inlineScriptBlocks = [],
	            parts,
	            i,
	            len,
	            source;

	        for (i in scripts) {
	            if (hasKey(scripts, i) && !scripts[i].src) {
	                inlineScriptBlocks.push(scripts[i]);
	            }
	        }

	        for (i = 2, len = lines.length; i < len; i += 2) {
	            var item = null;
	            if ((parts = lineRE1.exec(lines[i]))) {
	                item = {
	                    'url': parts[2],
	                    'func': parts[3],
	                    'line': +parts[1]
	                };
	            } else if ((parts = lineRE2.exec(lines[i]))) {
	                item = {
	                    'url': parts[3],
	                    'func': parts[4]
	                };
	                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
	                var script = inlineScriptBlocks[parts[2] - 1];
	                if (script) {
	                    source = getSource(item.url);
	                    if (source) {
	                        source = source.join('\n');
	                        var pos = source.indexOf(script.innerText);
	                        if (pos >= 0) {
	                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
	                        }
	                    }
	                }
	            } else if ((parts = lineRE3.exec(lines[i]))) {
	                var url = window.location.href.replace(/#.*$/, ''),
	                    line = parts[1];
	                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
	                source = findSourceInUrls(re, [url]);
	                item = {
	                    'url': url,
	                    'line': source ? source.line : line,
	                    'func': ''
	                };
	            }

	            if (item) {
	                if (!item.func) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	                var context = gatherContext(item.url, item.line);
	                var midline = (context ? context[Math.floor(context.length / 2)] : null);
	                if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
	                    item.context = context;
	                } else {
	                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
	                    item.context = [lines[i + 1]];
	                }
	                stack.push(item);
	            }
	        }
	        if (!stack.length) {
	            return null; // could not parse multiline exception message as Opera stack trace
	        }

	        return {
	            'name': ex.name,
	            'message': lines[0],
	            'url': document.location.href,
	            'stack': stack
	        };
	    }

	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };

	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;

	            if (!initial.func) {
	                initial.func = guessFunctionName(initial.url, initial.line);
	            }

	            if (!initial.context) {
	                initial.context = gatherContext(initial.url, initial.line);
	            }

	            var reference = / '([^']+)' /.exec(message);
	            if (reference) {
	                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
	            }

	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        stackInfo.stack[0].context = initial.context;
	                        return false;
	                    }
	                }
	            }

	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }

	        return false;
	    }

	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;

	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }

	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };

	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }

	            if ((source = findSourceByFunctionBody(curr))) {
	                item.url = source.url;
	                item.line = source.line;

	                if (item.func === UNKNOWN_FUNCTION) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }

	                var reference = / '([^']+)' /.exec(ex.message || ex.description);
	                if (reference) {
	                    item.column = findSourceInLine(reference[1], source.url, source.line);
	                }
	            }

	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }

	            stack.push(item);
	        }

	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }

	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }

	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);

	        try {
	            // This must be tried first because Opera 10 *destroys*
	            // its stacktrace property if you try to access the stack
	            // property first!!
	            stack = computeStackTraceFromStacktraceProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }

	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }

	        try {
	            stack = computeStackTraceFromOperaMultiLineMessage(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }

	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }

	        return {};
	    }

	    /**
	     * Logs a stacktrace starting from the previous call and working down.
	     * @param {(number|string)=} depth How many frames deep to trace.
	     * @return {Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceOfCaller(depth) {
	        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
	        try {
	            throw new Error();
	        } catch (ex) {
	            return computeStackTrace(ex, depth + 1);
	        }
	    }

	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.guessFunctionName = guessFunctionName;
	    computeStackTrace.gatherContext = gatherContext;
	    computeStackTrace.ofCaller = computeStackTraceOfCaller;

	    return computeStackTrace;
	}());

	'use strict';

	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	var _Raven = window.Raven,
	    hasJSON = !!(window.JSON && window.JSON.stringify),
	    lastCapturedException,
	    lastEventId,
	    globalServer,
	    globalUser,
	    globalKey,
	    globalProject,
	    globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        collectWindowErrors: true,
	        tags: {},
	        extra: {}
	    },
	    authQueryString,
	    isRavenInstalled = false;

	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	var Raven = {
	    VERSION: '1.1.16',

	    debug: true,

	    /*
	     * Allow multiple versions of Raven to be installed.
	     * Strip Raven from the global context and returns the instance.
	     *
	     * @return {Raven}
	     */
	    noConflict: function() {
	        window.Raven = _Raven;
	        return Raven;
	    },

	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        if (globalServer) {
	            logDebug('error', 'Error: Raven has already been configured');
	            return Raven;
	        }
	        if (!dsn) return Raven;

	        var uri = parseDSN(dsn),
	            lastSlash = uri.path.lastIndexOf('/'),
	            path = uri.path.substr(1, lastSlash);

	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                globalOptions[key] = value;
	            });
	        }

	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        globalOptions.ignoreErrors.push('Script error.');
	        globalOptions.ignoreErrors.push('Script error');

	        // Other variants of external script errors:
	        globalOptions.ignoreErrors.push('Javascript error: Script error on line 0');
	        globalOptions.ignoreErrors.push('Javascript error: Script error. on line 0');

	        // join regexp rules into one big rule
	        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
	        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
	        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);

	        globalKey = uri.user;
	        globalProject = uri.path.substr(lastSlash + 1);

	        // assemble the endpoint from the uri pieces
	        globalServer = '//' + uri.host +
	                      (uri.port ? ':' + uri.port : '') +
	                      '/' + path + 'api/' + globalProject + '/store/';

	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }

	        if (globalOptions.fetchContext) {
	            TraceKit.remoteFetching = true;
	        }

	        if (globalOptions.linesOfContext) {
	            TraceKit.linesOfContext = globalOptions.linesOfContext;
	        }

	        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

	        setAuthQueryString();

	        // return for chaining
	        return Raven;
	    },

	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        if (isSetup() && !isRavenInstalled) {
	            TraceKit.report.subscribe(handleStackInfo);
	            isRavenInstalled = true;
	        }

	        return Raven;
	    },

	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }

	        return Raven.wrap(options, func).apply(this, args);
	    },

	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func) {
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }

	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }

	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }

	        // We don't wanna wrap it twice!
	        if (func.__raven__) {
	            return func;
	        }

	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.

	            while(i--) args[i] = deep ? Raven.wrap(options, arguments[i]) : arguments[i];

	            try {
	                /*jshint -W040*/
	                return func.apply(this, args);
	            } catch(e) {
	                Raven.captureException(e, options);
	                throw e;
	            }
	        }

	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }

	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;

	        return wrapped;
	    },

	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	        isRavenInstalled = false;

	        return Raven;
	    },

	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!(ex instanceof Error)) return Raven.captureMessage(ex, options);

	        // Store the raw exception object for potential debugging and introspection
	        lastCapturedException = ex;

	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            TraceKit.report(ex, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }

	        return Raven;
	    },

	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // Fire away!
	        send(
	            objectMerge({
	                message: msg + ''  // Make sure it's actually a string
	            }, options)
	        );

	        return Raven;
	    },

	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	       globalUser = user;

	       return Raven;
	    },

	    /*
	     * Set extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	       globalOptions.extra = extra || {};

	       return Raven;
	    },

	    /*
	     * Set tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	       globalOptions.tags = tags || {};

	       return Raven;
	    },

	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return lastCapturedException;
	    },

	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return lastEventId;
	    }
	};

	Raven.setUser = Raven.setUserContext; // To be deprecated

	function triggerEvent(eventType, options) {
	    var event, key;

	    options = options || {};

	    eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);

	    if (document.createEvent) {
	        event = document.createEvent('HTMLEvents');
	        event.initEvent(eventType, true, true);
	    } else {
	        event = document.createEventObject();
	        event.eventType = eventType;
	    }

	    for (key in options) if (hasKey(options, key)) {
	        event[key] = options[key];
	    }

	    if (document.createEvent) {
	        // IE9 if standards
	        document.dispatchEvent(event);
	    } else {
	        // IE8 regardless of Quirks or Standards
	        // IE9 if quirks
	        try {
	            document.fireEvent('on' + event.eventType.toLowerCase(), event);
	        } catch(e) {}
	    }
	}

	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(\w+)(:\w+)?@([\w\.-]+)(?::(\d+))?(\/.*)/;

	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;

	/**** Private functions ****/
	function parseDSN(str) {
	    var m = dsnPattern.exec(str),
	        dsn = {},
	        i = 7;

	    try {
	        while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch(e) {
	        throw new RavenConfigError('Invalid DSN: ' + str);
	    }

	    if (dsn.pass)
	        throw new RavenConfigError('Do not specify your private key in the DSN!');

	    return dsn;
	}

	function isUndefined(what) {
	    return typeof what === 'undefined';
	}

	function isFunction(what) {
	    return typeof what === 'function';
	}

	function isString(what) {
	    return typeof what === 'string';
	}

	function isEmptyObject(what) {
	    for (var k in what) return false;
	    return true;
	}

	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return Object.prototype.hasOwnProperty.call(object, key);
	}

	function each(obj, callback) {
	    var i, j;

	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}


	function setAuthQueryString() {
	    authQueryString =
	        '?sentry_version=4' +
	        '&sentry_client=raven-js/' + Raven.VERSION +
	        '&sentry_key=' + globalKey;
	}


	function handleStackInfo(stackInfo, options) {
	    var frames = [];

	    if (stackInfo.stack && stackInfo.stack.length) {
	        each(stackInfo.stack, function(i, stack) {
	            var frame = normalizeFrame(stack);
	            if (frame) {
	                frames.push(frame);
	            }
	        });
	    }

	    triggerEvent('handle', {
	        stackInfo: stackInfo,
	        options: options
	    });

	    processException(
	        stackInfo.name,
	        stackInfo.message,
	        stackInfo.url,
	        stackInfo.lineno,
	        frames,
	        options
	    );
	}

	function normalizeFrame(frame) {
	    if (!frame.url) return;

	    // normalize the frames data
	    var normalized = {
	        filename:   frame.url,
	        lineno:     frame.line,
	        colno:      frame.column,
	        'function': frame.func || '?'
	    }, context = extractContextFromFrame(frame), i;

	    if (context) {
	        var keys = ['pre_context', 'context_line', 'post_context'];
	        i = 3;
	        while (i--) normalized[keys[i]] = context[i];
	    }

	    normalized.in_app = !( // determine if an exception came from outside of our app
	        // first we check the global includePaths list.
	        !globalOptions.includePaths.test(normalized.filename) ||
	        // Now we check for fun, if the function name is Raven or TraceKit
	        /(Raven|TraceKit)\./.test(normalized['function']) ||
	        // finally, we do a last ditch effort and check for raven.min.js
	        /raven\.(min\.)?js$/.test(normalized.filename)
	    );

	    return normalized;
	}

	function extractContextFromFrame(frame) {
	    // immediately check if we should even attempt to parse a context
	    if (!frame.context || !globalOptions.fetchContext) return;

	    var context = frame.context,
	        pivot = ~~(context.length / 2),
	        i = context.length, isMinified = false;

	    while (i--) {
	        // We're making a guess to see if the source is minified or not.
	        // To do that, we make the assumption if *any* of the lines passed
	        // in are greater than 300 characters long, we bail.
	        // Sentry will see that there isn't a context
	        if (context[i].length > 300) {
	            isMinified = true;
	            break;
	        }
	    }

	    if (isMinified) {
	        // The source is minified and we don't know which column. Fuck it.
	        if (isUndefined(frame.column)) return;

	        // If the source is minified and has a frame column
	        // we take a chunk of the offending line to hopefully shed some light
	        return [
	            [],  // no pre_context
	            context[pivot].substr(frame.column, 50), // grab 50 characters, starting at the offending column
	            []   // no post_context
	        ];
	    }

	    return [
	        context.slice(0, pivot),    // pre_context
	        context[pivot],             // context_line
	        context.slice(pivot + 1)    // post_context
	    ];
	}

	function processException(type, message, fileurl, lineno, frames, options) {
	    var stacktrace, label, i;

	    // In some instances message is not actually a string, no idea why,
	    // so we want to always coerce it to one.
	    message += '';

	    // Sometimes an exception is getting logged in Sentry as
	    // <no message value>
	    // This can only mean that the message was falsey since this value
	    // is hardcoded into Sentry itself.
	    // At this point, if the message is falsey, we bail since it's useless
	    if (type === 'Error' && !message) return;

	    if (globalOptions.ignoreErrors.test(message)) return;

	    if (frames && frames.length) {
	        fileurl = frames[0].filename || fileurl;
	        // Sentry expects frames oldest to newest
	        // and JS sends them as newest to oldest
	        frames.reverse();
	        stacktrace = {frames: frames};
	    } else if (fileurl) {
	        stacktrace = {
	            frames: [{
	                filename: fileurl,
	                lineno: lineno,
	                in_app: true
	            }]
	        };
	    }

	    // Truncate the message to a max of characters
	    message = truncate(message, 100);

	    if (globalOptions.ignoreUrls && globalOptions.ignoreUrls.test(fileurl)) return;
	    if (globalOptions.whitelistUrls && !globalOptions.whitelistUrls.test(fileurl)) return;

	    label = lineno ? message + ' at ' + lineno : message;

	    // Fire away!
	    send(
	        objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                type: type,
	                value: message
	            },
	            // sentry.interfaces.Stacktrace
	            stacktrace: stacktrace,
	            culprit: fileurl,
	            message: label
	        }, options)
	    );
	}

	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}

	function truncate(str, max) {
	    return str.length <= max ? str : str.substr(0, max) + '\u2026';
	}

	function getHttpData() {
	    var http = {
	        url: document.location.href,
	        headers: {
	            'User-Agent': navigator.userAgent
	        }
	    };

	    if (document.referrer) {
	        http.headers.Referer = document.referrer;
	    }

	    return http;
	}

	function send(data) {
	    if (!isSetup()) return;

	    data = objectMerge({
	        project: globalProject,
	        logger: globalOptions.logger,
	        site: globalOptions.site,
	        platform: 'javascript',
	        // sentry.interfaces.Http
	        request: getHttpData()
	    }, data);

	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(globalOptions.tags, data.tags);
	    data.extra = objectMerge(globalOptions.extra, data.extra);

	    // If there are no tags/extra, strip the key from the payload alltogther.
	    if (isEmptyObject(data.tags)) delete data.tags;
	    if (isEmptyObject(data.extra)) delete data.extra;

	    if (globalUser) {
	        // sentry.interfaces.User
	        data.user = globalUser;
	    }

	    if (isFunction(globalOptions.dataCallback)) {
	        data = globalOptions.dataCallback(data);
	    }

	    // Check if the request should be filtered or not
	    if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	        return;
	    }

	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    lastEventId = data.event_id || (data.event_id = uuid4());

	    makeRequest(data);
	}


	function makeRequest(data) {
	    var img = new Image(),
	        src = globalServer + authQueryString + '&sentry_data=' + encodeURIComponent(JSON.stringify(data));

	    img.onload = function success() {
	        triggerEvent('success', {
	            data: data,
	            src: src
	        });
	    };
	    img.onerror = img.onabort = function failure() {
	        triggerEvent('failure', {
	            data: data,
	            src: src
	        });
	    };
	    img.src = src;
	}

	function isSetup() {
	    if (!hasJSON) return false;  // needs JSON support
	    if (!globalServer) {
	        logDebug('error', 'Error: Raven has not been configured.');
	        return false;
	    }
	    return true;
	}

	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;

	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}

	// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	function uuid4() {
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	        var r = Math.random()*16|0,
	            v = c == 'x' ? r : (r&0x3|0x8);
	        return v.toString(16);
	    });
	}

	function logDebug(level, message) {
	    if (window.console && console[level] && Raven.debug) {
	        console[level](message);
	    }
	}

	function afterLoad() {
	    // Attempt to initialize Raven on load
	    var RavenConfig = window.RavenConfig;
	    if (RavenConfig) {
	        Raven.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	}
	afterLoad();

	// Expose Raven to the world
	window.Raven = Raven;

	// AMD
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return Raven; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	})(this);
	}.call(window));

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')

	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }

	  opts = opts || {}
	  cb = cb || function() {}

	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src

	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }

	  if (opts.text) {
	    script.text = '' + opts.text
	  }

	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)

	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }

	  head.appendChild(script)
	}

	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}

	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}

	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(152);

	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for, instead of the element itself.
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(chr) {
	 *   return chr.user == 'barney';
	 * });
	 * // => 0
	 *
	 * // using the `_.matches` callback shorthand
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.findIndex(users, 'active', false);
	 * // => 0
	 *
	 * // using the `_.property` callback shorthand
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, thisArg) {
	  var index = -1,
	      length = array ? array.length : 0;

	  predicate = baseCallback(predicate, thisArg, 3);
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}

	module.exports = findIndex;


/***/ },
/* 995 */,
/* 996 */,
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(102);

	/**
	 * Creates an object composed from arrays of property names and values. Provide
	 * either a single two dimensional array, e.g. `[[key1, value1], [key2, value2]]`
	 * or two arrays, one of property names and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @alias object
	 * @category Array
	 * @param {Array} props The property names.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject(['fred', 'barney'], [30, 40]);
	 * // => { 'fred': 30, 'barney': 40 }
	 */
	function zipObject(props, values) {
	  var index = -1,
	      length = props ? props.length : 0,
	      result = {};

	  if (length && !values && !isArray(props[0])) {
	    values = [];
	  }
	  while (++index < length) {
	    var key = props[index];
	    if (values) {
	      result[key] = values[index];
	    } else if (key) {
	      result[key[0]] = key[1];
	    }
	  }
	  return result;
	}

	module.exports = zipObject;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(152),
	    baseEachRight = __webpack_require__(1007),
	    baseFind = __webpack_require__(1009);

	/**
	 * This method is like `_.find` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * _.findLast([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 1;
	 * });
	 * // => 3
	 */
	function findLast(collection, predicate, thisArg) {
	  predicate = baseCallback(predicate, thisArg, 3);
	  return baseFind(collection, predicate, baseEachRight);
	}

	module.exports = findLast;


/***/ },
/* 999 */,
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1003),
	    baseCallback = __webpack_require__(152),
	    baseFilter = __webpack_require__(1008),
	    isArray = __webpack_require__(102);

	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.reject([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [1, 3]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.reject(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.reject(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function reject(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}

	module.exports = reject;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(1024),
	    isNative = __webpack_require__(103);

	/** Native method references. */
	var Set = isNative(Set = global.Set) && Set;

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;

	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;

	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}

	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;

	module.exports = SetCache;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	module.exports = arrayEach;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A specialized version of `_.filter` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}

	module.exports = arrayFilter;


/***/ },
/* 1004 */,
/* 1005 */,
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(482),
	    arrayEach = __webpack_require__(1002),
	    baseCopy = __webpack_require__(484),
	    baseForOwn = __webpack_require__(349),
	    initCloneArray = __webpack_require__(1030),
	    initCloneByTag = __webpack_require__(1031),
	    initCloneObject = __webpack_require__(1032),
	    isArray = __webpack_require__(102),
	    isObject = __webpack_require__(104),
	    keys = __webpack_require__(126);

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (typeof result != 'undefined') {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;

	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseCopy(value, result, keys(value));
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);

	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);

	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}

	module.exports = baseClone;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(1011),
	    isLength = __webpack_require__(88),
	    toObject = __webpack_require__(189);

	/**
	 * The base implementation of `_.forEachRight` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	function baseEachRight(collection, iteratee) {
	  var length = collection ? collection.length : 0;
	  if (!isLength(length)) {
	    return baseForOwnRight(collection, iteratee);
	  }
	  var iterable = toObject(collection);
	  while (length--) {
	    if (iteratee(iterable[length], length, iterable) === false) {
	      break;
	    }
	  }
	  return collection;
	}

	module.exports = baseEachRight;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(486);

	/**
	 * The base implementation of `_.filter` without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}

	module.exports = baseFilter;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}

	module.exports = baseFind;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(348),
	    keysIn = __webpack_require__(233);

	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}

	module.exports = baseForIn;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(1012),
	    keys = __webpack_require__(126);

	/**
	 * The base implementation of `_.forOwnRight` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwnRight(object, iteratee) {
	  return baseForRight(object, iteratee, keys);
	}

	module.exports = baseForOwnRight;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(189);

	/**
	 * This function is like `baseFor` except that it iterates over properties
	 * in the opposite order.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	function baseForRight(object, iteratee, keysFunc) {
	  var iterable = toObject(object),
	      props = keysFunc(object),
	      length = props.length;

	  while (length--) {
	    var key = props[length];
	    if (iteratee(iterable[key], key, iterable) === false) {
	      break;
	    }
	  }
	  return object;
	}

	module.exports = baseForRight;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(1026),
	    equalByTag = __webpack_require__(1027),
	    equalObjects = __webpack_require__(1028),
	    isArray = __webpack_require__(102),
	    isTypedArray = __webpack_require__(1039);

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;

	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;

	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  var valWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	      othWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	  if (valWrapped || othWrapped) {
	    return equalFunc(valWrapped ? object.value() : object, othWrapped ? other.value() : other, customizer, isWhere, stackA, stackB);
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);

	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);

	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isWhere, stackA, stackB);

	  stackA.pop();
	  stackB.pop();

	  return result;
	}

	module.exports = baseIsEqualDeep;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The base implementation of `_.isFunction` without support for environments
	 * with incorrect `typeof` results.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 */
	function baseIsFunction(value) {
	  // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	  // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	  return typeof value == 'function' || false;
	}

	module.exports = baseIsFunction;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(489);

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The source property names to match.
	 * @param {Array} values The source values to match.
	 * @param {Array} strictCompareFlags Strict comparison flags for source values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, props, values, strictCompareFlags, customizer) {
	  var length = props.length;
	  if (object == null) {
	    return !length;
	  }
	  var index = -1,
	      noCustomizer = !customizer;

	  while (++index < length) {
	    if ((noCustomizer && strictCompareFlags[index])
	          ? values[index] !== object[props[index]]
	          : !hasOwnProperty.call(object, props[index])
	        ) {
	      return false;
	    }
	  }
	  index = -1;
	  while (++index < length) {
	    var key = props[index];
	    if (noCustomizer && strictCompareFlags[index]) {
	      var result = hasOwnProperty.call(object, key);
	    } else {
	      var objValue = object[key],
	          srcValue = values[index];

	      result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (typeof result == 'undefined') {
	        result = baseIsEqual(srcValue, objValue, customizer, true);
	      }
	    }
	    if (!result) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = baseIsMatch;


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(486);

	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * or `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var result = [];
	  baseEach(collection, function(value, key, collection) {
	    result.push(iteratee(value, key, collection));
	  });
	  return result;
	}

	module.exports = baseMap;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1015),
	    isStrictComparable = __webpack_require__(495),
	    keys = __webpack_require__(126);

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var props = keys(source),
	      length = props.length;

	  if (length == 1) {
	    var key = props[0],
	        value = source[key];

	    if (isStrictComparable(value)) {
	      return function(object) {
	        return object != null && object[key] === value && hasOwnProperty.call(object, key);
	      };
	    }
	  }
	  var values = Array(length),
	      strictCompareFlags = Array(length);

	  while (length--) {
	    value = source[props[length]];
	    values[length] = value;
	    strictCompareFlags[length] = isStrictComparable(value);
	  }
	  return function(object) {
	    return baseIsMatch(object, props, values, strictCompareFlags);
	  };
	}

	module.exports = baseMatches;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(489),
	    isStrictComparable = __webpack_require__(495);

	/**
	 * The base implementation of `_.matchesProperty` which does not coerce `key`
	 * to a string.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} value The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(key, value) {
	  if (isStrictComparable(value)) {
	    return function(object) {
	      return object != null && object[key] === value;
	    };
	  }
	  return function(object) {
	    return object != null && baseIsEqual(value, object[key], null, true);
	  };
	}

	module.exports = baseMatchesProperty;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(353),
	    metaMap = __webpack_require__(1034);

	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};

	module.exports = baseSetData;


/***/ },
/* 1020 */,
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Converts `value` to a string if it is not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  if (typeof value == 'string') {
	    return value;
	  }
	  return value == null ? '' : (value + '');
	}

	module.exports = baseToString;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * returned by `keysFunc`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}

	module.exports = baseValues;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var constant = __webpack_require__(499),
	    isNative = __webpack_require__(103);

	/** Native method references. */
	var ArrayBuffer = isNative(ArrayBuffer = global.ArrayBuffer) && ArrayBuffer,
	    bufferSlice = isNative(bufferSlice = ArrayBuffer && new ArrayBuffer(0).slice) && bufferSlice,
	    floor = Math.floor,
	    Uint8Array = isNative(Uint8Array = global.Uint8Array) && Uint8Array;

	/** Used to clone array buffers. */
	var Float64Array = (function() {
	  // Safari 5 errors when using an array buffer to initialize a typed array
	  // where the array buffer's `byteLength` is not a multiple of the typed
	  // array's `BYTES_PER_ELEMENT`.
	  try {
	    var func = isNative(func = global.Float64Array) && func,
	        result = new func(new ArrayBuffer(10), 0, 1) && func;
	  } catch(e) {}
	  return result;
	}());

	/** Used as the size, in bytes, of each `Float64Array` element. */
	var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;

	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  return bufferSlice.call(buffer, 0);
	}
	if (!bufferSlice) {
	  // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
	  bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
	    var byteLength = buffer.byteLength,
	        floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
	        offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
	        result = new ArrayBuffer(byteLength);

	    if (floatLength) {
	      var view = new Float64Array(result, 0, floatLength);
	      view.set(new Float64Array(buffer, 0, floatLength));
	    }
	    if (byteLength != offset) {
	      view = new Uint8Array(result, offset);
	      view.set(new Uint8Array(buffer, offset));
	    }
	    return result;
	  };
	}

	module.exports = bufferClone;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);

	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}

	module.exports = cachePush;


/***/ },
/* 1025 */,
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length,
	      result = true;

	  if (arrLength != othLength && !(isWhere && othLength > arrLength)) {
	    return false;
	  }
	  // Deep compare the contents, ignoring non-numeric properties.
	  while (result && ++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    result = undefined;
	    if (customizer) {
	      result = isWhere
	        ? customizer(othValue, arrValue, index)
	        : customizer(arrValue, othValue, index);
	    }
	    if (typeof result == 'undefined') {
	      // Recursively compare arrays (susceptible to call stack limits).
	      if (isWhere) {
	        var othIndex = othLength;
	        while (othIndex--) {
	          othValue = other[othIndex];
	          result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	          if (result) {
	            break;
	          }
	        }
	      } else {
	        result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	      }
	    }
	  }
	  return !!result;
	}

	module.exports = equalArrays;


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} value The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        // But, treat `-0` vs. `+0` as not equal.
	        : (object == 0 ? ((1 / object) == (1 / other)) : object == +other);

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}

	module.exports = equalByTag;


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(126);

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isWhere) {
	    return false;
	  }
	  var hasCtor,
	      index = -1;

	  while (++index < objLength) {
	    var key = objProps[index],
	        result = hasOwnProperty.call(other, key);

	    if (result) {
	      var objValue = object[key],
	          othValue = other[key];

	      result = undefined;
	      if (customizer) {
	        result = isWhere
	          ? customizer(othValue, objValue, key)
	          : customizer(objValue, othValue, key);
	      }
	      if (typeof result == 'undefined') {
	        // Recursively compare objects (susceptible to call stack limits).
	        result = (objValue && objValue === othValue) || equalFunc(objValue, othValue, customizer, isWhere, stackA, stackB);
	      }
	    }
	    if (!result) {
	      return false;
	    }
	    hasCtor || (hasCtor = key == 'constructor');
	  }
	  if (!hasCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor && ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = equalObjects;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 * If `fromRight` is provided elements of `array` are iterated from right to left.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} [fromIndex] The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromRight ? (fromIndex || length) : ((fromIndex || 0) - 1);

	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}

	module.exports = indexOfNaN;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);

	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	module.exports = initCloneArray;


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(1023);

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);

	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);

	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

	    case numberTag:
	    case stringTag:
	      return new Ctor(object);

	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}

	module.exports = initCloneByTag;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}

	module.exports = initCloneObject;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(1019),
	    isNative = __webpack_require__(103),
	    support = __webpack_require__(352);

	/** Used to detect named functions. */
	var reFuncName = /^\s*function[ \n\r\t]+\w/;

	/** Used to detect functions containing a `this` reference. */
	var reThis = /\bthis\b/;

	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;

	/**
	 * Checks if `func` is eligible for `this` binding.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is eligible, else `false`.
	 */
	function isBindable(func) {
	  var result = !(support.funcNames ? func.name : support.funcDecomp);

	  if (!result) {
	    var source = fnToString.call(func);
	    if (!support.funcNames) {
	      result = !reFuncName.test(source);
	    }
	    if (!result) {
	      // Check if `func` references the `this` keyword and store the result.
	      result = reThis.test(source) || isNative(func);
	      baseSetData(func, result);
	    }
	  }
	  return result;
	}

	module.exports = isBindable;


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var isNative = __webpack_require__(103);

	/** Native method references. */
	var WeakMap = isNative(WeakMap = global.WeakMap) && WeakMap;

	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;

	module.exports = metaMap;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(189);

	/**
	 * A specialized version of `_.pick` that picks `object` properties specified
	 * by the `props` array.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);

	  var index = -1,
	      length = props.length,
	      result = {};

	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}

	module.exports = pickByArray;


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(1010);

	/**
	 * A specialized version of `_.pick` that picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}

	module.exports = pickByCallback;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(351),
	    isArray = __webpack_require__(102),
	    isIndex = __webpack_require__(350),
	    isLength = __webpack_require__(88),
	    keysIn = __webpack_require__(233),
	    support = __webpack_require__(352);

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;

	  var allowIndexes = length && isLength(length) &&
	    (isArray(object) || (support.nonEnumArgs && isArguments(object)));

	  var index = -1,
	      result = [];

	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	module.exports = shimKeys;


/***/ },
/* 1038 */,
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(88),
	    isObjectLike = __webpack_require__(188);

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return (isObjectLike(value) && isLength(value.length) && typedArrayTags[objToString.call(value)]) || false;
	}

	module.exports = isTypedArray;


/***/ },
/* 1040 */,
/* 1041 */,
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(348),
	    bindCallback = __webpack_require__(187),
	    keysIn = __webpack_require__(233);

	/**
	 * Iterates over own and inherited enumerable properties of an object invoking
	 * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	 * with three arguments; (value, key, object). Iterator functions may exit
	 * iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	 */
	function forIn(object, iteratee, thisArg) {
	  if (typeof iteratee != 'function' || typeof thisArg != 'undefined') {
	    iteratee = bindCallback(iteratee, thisArg, 3);
	  }
	  return baseFor(object, iteratee, keysIn);
	}

	module.exports = forIn;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(152),
	    baseForOwn = __webpack_require__(349);

	/**
	 * Creates an object with the same keys as `object` and values generated by
	 * running each own enumerable property of `object` through `iteratee`. The
	 * iteratee function is bound to `thisArg` and invoked with three arguments;
	 * (value, key, object).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns the new mapped object.
	 * @example
	 *
	 * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	 *   return n * 3;
	 * });
	 * // => { 'a': 3, 'b': 6 }
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * // using the `_.property` callback shorthand
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee, thisArg) {
	  var result = {};
	  iteratee = baseCallback(iteratee, thisArg, 3);

	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}

	module.exports = mapValues;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(483),
	    baseDifference = __webpack_require__(485),
	    baseFlatten = __webpack_require__(487),
	    bindCallback = __webpack_require__(187),
	    keysIn = __webpack_require__(233),
	    pickByArray = __webpack_require__(1035),
	    pickByCallback = __webpack_require__(1036);

	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 * Property names may be specified as individual arguments or as arrays of
	 * property names. If `predicate` is provided it is invoked for each property
	 * of `object` omitting the properties `predicate` returns truthy for. The
	 * predicate is bound to `thisArg` and invoked with three arguments;
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	function omit(object, predicate, thisArg) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof predicate != 'function') {
	    var props = arrayMap(baseFlatten(arguments, false, false, 1), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  predicate = bindCallback(predicate, thisArg, 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	}

	module.exports = omit;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1021);

	/**
	 * Used to match `RegExp` special characters.
	 * See this [article on `RegExp` characters](http://www.regular-expressions.info/characters.html#special)
	 * for more details.
	 */
	var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
	    reHasRegExpChars = RegExp(reRegExpChars.source);

	/**
	 * Escapes the `RegExp` special characters "\", "^", "$", ".", "|", "?", "*",
	 * "+", "(", ")", "[", "]", "{" and "}" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = baseToString(string);
	  return (string && reHasRegExpChars.test(string))
	    ? string.replace(reRegExpChars, '\\$&')
	    : string;
	}

	module.exports = escapeRegExp;


/***/ },
/* 1046 */,
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	// shim for using process in browser

	var process = module.exports = {};
	var queue = [];
	var draining = false;

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    draining = true;
	    var currentQueue;
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        var i = -1;
	        while (++i < len) {
	            currentQueue[i]();
	        }
	        len = queue.length;
	    }
	    draining = false;
	}
	process.nextTick = function (fun) {
	    queue.push(fun);
	    if (!draining) {
	        setTimeout(drainQueue, 0);
	    }
	};

	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	// TODO(shtylman)
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(639));
	    });
	  });
	}

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(3, function (require) {
	      resolve(__webpack_require__(640));
	    });
	  });
	}

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(2, function (require) {
	      resolve(__webpack_require__(641));
	    });
	  });
	}

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Promise.prototype.finally
	 *
	 * Pulled from https://github.com/domenic/promises-unwrapping/issues/18#issuecomment-57801572
	 * @author @stefanpenner, @matthew-andrews
	 */

	// Get a handle on the global object
	var local;
	if (typeof global !== 'undefined') local = global;
	else if (typeof window !== 'undefined' && window.document) local = window;
	else local = self;

	// Polyfill (verb)
	var finallySupport = "finally" in local.Promise.prototype;
	if (!finallySupport) local.Promise.prototype['finally'] = finallyPolyfill;

	// Polyfill (noun)
	function finallyPolyfill(callback) {
		var constructor = this.constructor;

		return this.then(function(value) {
				return constructor.resolve(callback()).then(function() {
					return value;
				});
			}, function(reason) {
				return constructor.resolve(callback()).then(function() {
					throw reason;
				});
			});
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = PubSub;

	function PubSub(mix){

	  var proxy = mix || function pubsubProxy(){
	    arguments.length && sub.apply(undefined, arguments);
	  };

	  function sub(callback){
	    subscribe(proxy, callback);
	  }

	  function subOnce(callback){
	    once(proxy, callback);
	  }

	  function unsubOnce(callback){
	    unsubscribeOnce(proxy, callback);
	  }

	  function unsub(callback){
	    unsubscribe(proxy, callback);
	  }

	  function pub(){
	    var args = [proxy];
	    Array.prototype.push.apply(args, arguments);
	    publish.apply(undefined, args);
	  }

	  proxy.subscribers        = [];
	  proxy.subscribersForOnce = [];

	  proxy.subscribe          = sub;
	  proxy.subscribe.once     = subOnce;
	  proxy.unsubscribe        = unsub;
	  proxy.unsubscribe.once   = unsubOnce;
	  proxy.publish            = pub;

	  return proxy;
	}

	/**
	 * Publish "from" by applying given args
	 *
	 * @param {Function} from
	 * @param {...Any} args
	 */
	function publish(from){

	  var args = Array.prototype.slice.call(arguments, 1);

	  if (from && from.subscribers && from.subscribers.length > 0) {
	    from.subscribers.forEach(function(cb, i){
	      if(!cb) return;

	      try {
	        cb.apply(undefined, args);
	      } catch(exc) {
	        setTimeout(function(){ throw exc; }, 0);
	      }
	    });
	  }

	  if (from && from.subscribersForOnce && from.subscribersForOnce.length > 0) {
	    from.subscribersForOnce.forEach(function(cb, i){
	      if(!cb) return;

	      try {
	        cb.apply(undefined, args);
	      } catch(exc) {
	        setTimeout(function(){ throw exc; }, 0);
	      }
	    });

	    from.subscribersForOnce = [];

	  }

	}

	/**
	 * Subscribe callback to given pubsub object.
	 *
	 * @param {Pubsub} to
	 * @param {Function} callback
	 */
	function subscribe(to, callback){
	  if(!callback) return false;
	  return to.subscribers.push(callback);
	}


	/**
	 * Subscribe callback to given pubsub object for only one publish.
	 *
	 * @param {Pubsub} to
	 * @param {Function} callback
	 */
	function once(to, callback){
	  if(!callback) return false;

	  return to.subscribersForOnce.push(callback);
	}

	/**
	 * Unsubscribe callback to given pubsub object.
	 *
	 * @param {Pubsub} to
	 * @param {Function} callback
	 */
	function unsubscribe(to, callback){
	  var i = to.subscribers.length;

	  while(i--){
	    if(to.subscribers[i] && to.subscribers[i] == callback){
	      to.subscribers[i] = undefined;

	      return i;
	    }
	  }

	  return false;
	}


	/**
	 * Unsubscribe callback subscribed for once to specified pubsub.
	 *
	 * @param {Pubsub} to
	 * @param {Function} callback
	 * @return {Boolean or Number}
	 */
	function unsubscribeOnce(to, callback){
	  var i = to.subscribersForOnce.length;

	  while(i--){
	    if(to.subscribersForOnce[i] && to.subscribersForOnce[i] == callback){
	      to.subscribersForOnce[i] = undefined;

	      return i;
	    }
	  }

	  return false;
	}


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.decode = exports.parse = __webpack_require__(1053);
	exports.encode = exports.stringify = __webpack_require__(1054);


/***/ },
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    createSideEffect = __webpack_require__(519);

	var _serverTitle = null;

	function getTitleFromPropsList(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}

	var DocumentTitle = createSideEffect(function handleChange(propsList) {
	  var title = getTitleFromPropsList(propsList);

	  if (typeof document !== 'undefined') {
	    document.title = title || '';
	  } else {
	    _serverTitle = title || null;
	  }
	}, {
	  displayName: 'DocumentTitle',

	  propTypes: {
	    title: React.PropTypes.string.isRequired
	  },

	  statics: {
	    peek: function () {
	      return _serverTitle;
	    },

	    rewind: function () {
	      var title = _serverTitle;
	      this.dispose();
	      return title;
	    }
	  }
	});

	module.exports = DocumentTitle;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),s=a(1),l=r(s),c={className:s.PropTypes.string,onloadCallbackName:s.PropTypes.string,elementID:s.PropTypes.string,onloadCallback:s.PropTypes.func,verifyCallback:s.PropTypes.func,expiredCallback:s.PropTypes.func,render:s.PropTypes.string,sitekey:s.PropTypes.string,theme:s.PropTypes.string,type:s.PropTypes.string,verifyCallbackName:s.PropTypes.string,expiredCallbackName:s.PropTypes.string,size:s.PropTypes.string,tabindex:s.PropTypes.string},d={elementID:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0"},u=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha},f=void 0,y=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:u(),widget:null},a.state.ready||(f=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),p(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(f)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"_updateReadyState",value:function(){u()&&(this.setState({ready:!0}),clearInterval(f))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?l["default"].createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):l["default"].createElement("div",{className:"g-recaptcha","data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-tabindex":this.props.tabindex})}}]),t}(s.Component);t["default"]=y,y.propTypes=c,y.defaultProps=d,e.exports=t["default"]},function(t,a){t.exports=e}])});

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	/* jshint -W084 */
	var PathUtils = __webpack_require__(360);

	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];

	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.

	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }

	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, defaultRoute]);
	  } // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, notFoundRoute]);
	  } // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) {
	    return new Match(pathname, params, query, [route]);
	  }return null;
	}

	var Match = (function () {
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);

	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }

	  _createClass(Match, null, {
	    findMatch: {

	      /**
	       * Attempts to match depth-first a route in the given route's
	       * subtree against the given path and returns the match if it
	       * succeeds, null if no match can be made.
	       */

	      value: function findMatch(routes, path) {
	        var pathname = PathUtils.withoutQuery(path);
	        var query = PathUtils.extractQuery(path);
	        var match = null;

	        for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);

	        return match;
	      }
	    }
	  });

	  return Match;
	})();

	module.exports = Match;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var warning = __webpack_require__(26);
	var PropTypes = __webpack_require__(105);

	function deprecatedMethod(routerMethodName, fn) {
	  return function () {
	    warning(false, "Router.Navigation is deprecated. Please use this.context.router." + routerMethodName + "() instead");

	    return fn.apply(this, arguments);
	  };
	}

	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {

	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },

	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: deprecatedMethod("makePath", function (to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  }),

	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: deprecatedMethod("makeHref", function (to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  }),

	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: deprecatedMethod("transitionTo", function (to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  }),

	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: deprecatedMethod("replaceWith", function (to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  }),

	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: deprecatedMethod("goBack", function () {
	    return this.context.router.goBack();
	  })

	};

	module.exports = Navigation;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var invariant = __webpack_require__(11);
	var canUseDOM = __webpack_require__(42).canUseDOM;
	var getWindowScrollPosition = __webpack_require__(1083);

	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) {
	    return true;
	  } // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) {
	    return false;
	  }var routes = state.routes;
	  var prevRoutes = prevState.routes;

	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });

	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}

	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {

	  statics: {

	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};

	      this.scrollHistory[path] = getWindowScrollPosition();
	    },

	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};

	      return this.scrollHistory[path] || null;
	    }

	  },

	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, "Cannot use scroll behavior without a DOM");
	  },

	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },

	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) {
	      return;
	    }var scrollBehavior = this.constructor.getScrollBehavior();

	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }

	};

	module.exports = ScrollHistory;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var warning = __webpack_require__(26);
	var PropTypes = __webpack_require__(105);

	function deprecatedMethod(routerMethodName, fn) {
	  return function () {
	    warning(false, "Router.State is deprecated. Please use this.context.router." + routerMethodName + "() instead");

	    return fn.apply(this, arguments);
	  };
	}

	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *   
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *   
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {

	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },

	  /**
	   * Returns the current URL path.
	   */
	  getPath: deprecatedMethod("getCurrentPath", function () {
	    return this.context.router.getCurrentPath();
	  }),

	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: deprecatedMethod("getCurrentPathname", function () {
	    return this.context.router.getCurrentPathname();
	  }),

	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: deprecatedMethod("getCurrentParams", function () {
	    return this.context.router.getCurrentParams();
	  }),

	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: deprecatedMethod("getCurrentQuery", function () {
	    return this.context.router.getCurrentQuery();
	  }),

	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: deprecatedMethod("getCurrentRoutes", function () {
	    return this.context.router.getCurrentRoutes();
	  }),

	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: deprecatedMethod("isActive", function (to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  })

	};

	module.exports = State;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/* jshint -W058 */

	var Cancellation = __webpack_require__(507);
	var Redirect = __webpack_require__(508);

	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}

	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || "ABORT";
	};

	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};

	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};

	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);

	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};

	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);

	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};

	module.exports = Transition;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	var ScrollToTopBehavior = {

	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }

	};

	module.exports = ScrollToTopBehavior;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */

	var React = __webpack_require__(1);

	var ContextWrapper = (function (_React$Component) {
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);

	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }

	  _inherits(ContextWrapper, _React$Component);

	  _createClass(ContextWrapper, {
	    render: {
	      value: function render() {
	        return this.props.children;
	      }
	    }
	  });

	  return ContextWrapper;
	})(React.Component);

	module.exports = ContextWrapper;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var React = __webpack_require__(1);
	var assign = __webpack_require__(15);
	var PropTypes = __webpack_require__(105);

	function isLeftClickEvent(event) {
	  return event.button === 0;
	}

	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}

	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */

	var Link = (function (_React$Component) {
	  function Link() {
	    _classCallCheck(this, Link);

	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }

	  _inherits(Link, _React$Component);

	  _createClass(Link, {
	    handleClick: {
	      value: function handleClick(event) {
	        var allowTransition = true;
	        var clickResult;

	        if (this.props.onClick) clickResult = this.props.onClick(event);

	        if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
	          return;
	        }if (clickResult === false || event.defaultPrevented === true) allowTransition = false;

	        event.preventDefault();

	        if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    getHref: {

	      /**
	       * Returns the value of the "href" attribute to use on the DOM element.
	       */

	      value: function getHref() {
	        return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    getClassName: {

	      /**
	       * Returns the value of the "class" attribute to use on the DOM element, which contains
	       * the value of the activeClassName property when this <Link> is active.
	       */

	      value: function getClassName() {
	        var className = this.props.className;

	        if (this.getActiveState()) className += " " + this.props.activeClassName;

	        return className;
	      }
	    },
	    getActiveState: {
	      value: function getActiveState() {
	        return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    render: {
	      value: function render() {
	        var props = assign({}, this.props, {
	          href: this.getHref(),
	          className: this.getClassName(),
	          onClick: this.handleClick.bind(this)
	        });

	        if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;

	        return React.DOM.a(props, this.props.children);
	      }
	    }
	  });

	  return Link;
	})(React.Component);

	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619

	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};

	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};

	Link.defaultProps = {
	  activeClassName: "active",
	  className: ""
	};

	module.exports = Link;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var invariant = __webpack_require__(11);
	var canUseDOM = __webpack_require__(42).canUseDOM;

	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, "Cannot get current scroll position without a DOM");

	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}

	module.exports = getWindowScrollPosition;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var React = __webpack_require__(1);

	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}

	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}

	module.exports = isReactChildren;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var invariant = __webpack_require__(11);
	var LocationActions = __webpack_require__(190);
	var History = __webpack_require__(153);

	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */

	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);

	    this.history = history || [];
	    this.listeners = [];
	    this._updateHistoryLength();
	  }

	  _createClass(TestLocation, {
	    needsDOM: {
	      get: function () {
	        return false;
	      }
	    },
	    _updateHistoryLength: {
	      value: function _updateHistoryLength() {
	        History.length = this.history.length;
	      }
	    },
	    _notifyChange: {
	      value: function _notifyChange(type) {
	        var change = {
	          path: this.getCurrentPath(),
	          type: type
	        };

	        for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	      }
	    },
	    addChangeListener: {
	      value: function addChangeListener(listener) {
	        this.listeners.push(listener);
	      }
	    },
	    removeChangeListener: {
	      value: function removeChangeListener(listener) {
	        this.listeners = this.listeners.filter(function (l) {
	          return l !== listener;
	        });
	      }
	    },
	    push: {
	      value: function push(path) {
	        this.history.push(path);
	        this._updateHistoryLength();
	        this._notifyChange(LocationActions.PUSH);
	      }
	    },
	    replace: {
	      value: function replace(path) {
	        invariant(this.history.length, "You cannot replace the current path with no history");

	        this.history[this.history.length - 1] = path;

	        this._notifyChange(LocationActions.REPLACE);
	      }
	    },
	    pop: {
	      value: function pop() {
	        this.history.pop();
	        this._updateHistoryLength();
	        this._notifyChange(LocationActions.POP);
	      }
	    },
	    getCurrentPath: {
	      value: function getCurrentPath() {
	        return this.history[this.history.length - 1];
	      }
	    },
	    toString: {
	      value: function toString() {
	        return "<TestLocation>";
	      }
	    }
	  });

	  return TestLocation;
	})();

	module.exports = TestLocation;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var createRouter = __webpack_require__(513);

	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === "function") {
	    callback = location;
	    location = null;
	  }

	  var router = createRouter({
	    routes: routes,
	    location: location
	  });

	  router.run(callback);

	  return router;
	}

	module.exports = runRouter;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) {
	    return false;
	  }
	  return window.history && "pushState" in window.history;
	}

	module.exports = supportsHistory;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);

		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));

			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}

		return to;
	};


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1090);


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules

	var Stringify = __webpack_require__(1092);
	var Parse = __webpack_require__(1091);


	// Declare internals

	var internals = {};


	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules

	var Utils = __webpack_require__(518);


	// Declare internals

	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};


	internals.parseValues = function (str, options) {

	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));

	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }

	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }

	    return obj;
	};


	internals.parseObject = function (chain, val, options) {

	    if (!chain.length) {
	        return val;
	    }

	    var root = chain.shift();

	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {

	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }

	    return obj;
	};


	internals.parseKeys = function (key, val, options) {

	    if (!key) {
	        return;
	    }

	    // The regex chunks

	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;

	    // Get the parent

	    var segment = parent.exec(key);

	    // Don't allow them to overwrite object prototype properties

	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }

	    // Stash the parent if it exists

	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }

	    // Loop through children appending to the array until we hit depth

	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {

	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }

	    // If there's a remainder, just add whatever is left

	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }

	    return internals.parseObject(keys, val, options);
	};


	module.exports = function (str, options) {

	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {

	        return {};
	    }

	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;

	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};

	    // Iterate over the keys and setup the new object

	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }

	    return Utils.compact(obj);
	};


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules

	var Utils = __webpack_require__(518);


	// Declare internals

	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};


	internals.stringify = function (obj, prefix, generateArrayPrefix) {

	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }

	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {

	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }

	    var values = [];

	    if (typeof obj === 'undefined') {
	        return values;
	    }

	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }

	    return values;
	};


	module.exports = function (obj, options) {

	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;

	    var keys = [];

	    if (typeof obj !== 'object' ||
	        obj === null) {

	        return '';
	    }

	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }

	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }

	    return keys.join(delimiter);
	};


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ResponderEventPlugin
	 */

	"use strict";

	var EventConstants = __webpack_require__(62);
	var EventPluginUtils = __webpack_require__(192);
	var EventPropagators = __webpack_require__(139);
	var SyntheticEvent = __webpack_require__(110);

	var accumulateInto = __webpack_require__(243);
	var keyOf = __webpack_require__(76);

	var isStartish = EventPluginUtils.isStartish;
	var isMoveish = EventPluginUtils.isMoveish;
	var isEndish = EventPluginUtils.isEndish;
	var executeDirectDispatch = EventPluginUtils.executeDirectDispatch;
	var hasDispatches = EventPluginUtils.hasDispatches;
	var executeDispatchesInOrderStopAtTrue =
	  EventPluginUtils.executeDispatchesInOrderStopAtTrue;

	/**
	 * ID of element that should respond to touch/move types of interactions, as
	 * indicated explicitly by relevant callbacks.
	 */
	var responderID = null;
	var isPressing = false;

	var eventTypes = {
	  /**
	   * On a `touchStart`/`mouseDown`, is it desired that this element become the
	   * responder?
	   */
	  startShouldSetResponder: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onStartShouldSetResponder: null}),
	      captured: keyOf({onStartShouldSetResponderCapture: null})
	    }
	  },

	  /**
	   * On a `scroll`, is it desired that this element become the responder? This
	   * is usually not needed, but should be used to retroactively infer that a
	   * `touchStart` had occured during momentum scroll. During a momentum scroll,
	   * a touch start will be immediately followed by a scroll event if the view is
	   * currently scrolling.
	   */
	  scrollShouldSetResponder: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScrollShouldSetResponder: null}),
	      captured: keyOf({onScrollShouldSetResponderCapture: null})
	    }
	  },

	  /**
	   * On a `touchMove`/`mouseMove`, is it desired that this element become the
	   * responder?
	   */
	  moveShouldSetResponder: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMoveShouldSetResponder: null}),
	      captured: keyOf({onMoveShouldSetResponderCapture: null})
	    }
	  },

	  /**
	   * Direct responder events dispatched directly to responder. Do not bubble.
	   */
	  responderMove: {registrationName: keyOf({onResponderMove: null})},
	  responderRelease: {registrationName: keyOf({onResponderRelease: null})},
	  responderTerminationRequest: {
	    registrationName: keyOf({onResponderTerminationRequest: null})
	  },
	  responderGrant: {registrationName: keyOf({onResponderGrant: null})},
	  responderReject: {registrationName: keyOf({onResponderReject: null})},
	  responderTerminate: {registrationName: keyOf({onResponderTerminate: null})}
	};

	/**
	 * Performs negotiation between any existing/current responder, checks to see if
	 * any new entity is interested in becoming responder, performs that handshake
	 * and returns any events that must be emitted to notify the relevant parties.
	 *
	 * A note about event ordering in the `EventPluginHub`.
	 *
	 * Suppose plugins are injected in the following order:
	 *
	 * `[R, S, C]`
	 *
	 * To help illustrate the example, assume `S` is `SimpleEventPlugin` (for
	 * `onClick` etc) and `R` is `ResponderEventPlugin`.
	 *
	 * "Deferred-Dispatched Events":
	 *
	 * - The current event plugin system will traverse the list of injected plugins,
	 *   in order, and extract events by collecting the plugin's return value of
	 *   `extractEvents()`.
	 * - These events that are returned from `extractEvents` are "deferred
	 *   dispatched events".
	 * - When returned from `extractEvents`, deferred-dispatched events contain an
	 *   "accumulation" of deferred dispatches.
	 * - These deferred dispatches are accumulated/collected before they are
	 *   returned, but processed at a later time by the `EventPluginHub` (hence the
	 *   name deferred).
	 *
	 * In the process of returning their deferred-dispatched events, event plugins
	 * themselves can dispatch events on-demand without returning them from
	 * `extractEvents`. Plugins might want to do this, so that they can use event
	 * dispatching as a tool that helps them decide which events should be extracted
	 * in the first place.
	 *
	 * "On-Demand-Dispatched Events":
	 *
	 * - On-demand-dispatched events are not returned from `extractEvents`.
	 * - On-demand-dispatched events are dispatched during the process of returning
	 *   the deferred-dispatched events.
	 * - They should not have side effects.
	 * - They should be avoided, and/or eventually be replaced with another
	 *   abstraction that allows event plugins to perform multiple "rounds" of event
	 *   extraction.
	 *
	 * Therefore, the sequence of event dispatches becomes:
	 *
	 * - `R`s on-demand events (if any)   (dispatched by `R` on-demand)
	 * - `S`s on-demand events (if any)   (dispatched by `S` on-demand)
	 * - `C`s on-demand events (if any)   (dispatched by `C` on-demand)
	 * - `R`s extracted events (if any)   (dispatched by `EventPluginHub`)
	 * - `S`s extracted events (if any)   (dispatched by `EventPluginHub`)
	 * - `C`s extracted events (if any)   (dispatched by `EventPluginHub`)
	 *
	 * In the case of `ResponderEventPlugin`: If the `startShouldSetResponder`
	 * on-demand dispatch returns `true` (and some other details are satisfied) the
	 * `onResponderGrant` deferred dispatched event is returned from
	 * `extractEvents`. The sequence of dispatch executions in this case
	 * will appear as follows:
	 *
	 * - `startShouldSetResponder` (`ResponderEventPlugin` dispatches on-demand)
	 * - `touchStartCapture`       (`EventPluginHub` dispatches as usual)
	 * - `touchStart`              (`EventPluginHub` dispatches as usual)
	 * - `responderGrant/Reject`   (`EventPluginHub` dispatches as usual)
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {string} topLevelTargetID ID of deepest React rendered element.
	 * @param {object} nativeEvent Native browser event.
	 * @return {*} An accumulation of synthetic events.
	 */
	function setResponderAndExtractTransfer(
	    topLevelType,
	    topLevelTargetID,
	    nativeEvent) {
	  var shouldSetEventType =
	    isStartish(topLevelType) ? eventTypes.startShouldSetResponder :
	    isMoveish(topLevelType) ? eventTypes.moveShouldSetResponder :
	    eventTypes.scrollShouldSetResponder;

	  var bubbleShouldSetFrom = responderID || topLevelTargetID;
	  var shouldSetEvent = SyntheticEvent.getPooled(
	    shouldSetEventType,
	    bubbleShouldSetFrom,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(shouldSetEvent);
	  var wantsResponderID = executeDispatchesInOrderStopAtTrue(shouldSetEvent);
	  if (!shouldSetEvent.isPersistent()) {
	    shouldSetEvent.constructor.release(shouldSetEvent);
	  }

	  if (!wantsResponderID || wantsResponderID === responderID) {
	    return null;
	  }
	  var extracted;
	  var grantEvent = SyntheticEvent.getPooled(
	    eventTypes.responderGrant,
	    wantsResponderID,
	    nativeEvent
	  );

	  EventPropagators.accumulateDirectDispatches(grantEvent);
	  if (responderID) {
	    var terminationRequestEvent = SyntheticEvent.getPooled(
	      eventTypes.responderTerminationRequest,
	      responderID,
	      nativeEvent
	    );
	    EventPropagators.accumulateDirectDispatches(terminationRequestEvent);
	    var shouldSwitch = !hasDispatches(terminationRequestEvent) ||
	      executeDirectDispatch(terminationRequestEvent);
	    if (!terminationRequestEvent.isPersistent()) {
	      terminationRequestEvent.constructor.release(terminationRequestEvent);
	    }

	    if (shouldSwitch) {
	      var terminateType = eventTypes.responderTerminate;
	      var terminateEvent = SyntheticEvent.getPooled(
	        terminateType,
	        responderID,
	        nativeEvent
	      );
	      EventPropagators.accumulateDirectDispatches(terminateEvent);
	      extracted = accumulateInto(extracted, [grantEvent, terminateEvent]);
	      responderID = wantsResponderID;
	    } else {
	      var rejectEvent = SyntheticEvent.getPooled(
	        eventTypes.responderReject,
	        wantsResponderID,
	        nativeEvent
	      );
	      EventPropagators.accumulateDirectDispatches(rejectEvent);
	      extracted = accumulateInto(extracted, rejectEvent);
	    }
	  } else {
	    extracted = accumulateInto(extracted, grantEvent);
	    responderID = wantsResponderID;
	  }
	  return extracted;
	}

	/**
	 * A transfer is a negotiation between a currently set responder and the next
	 * element to claim responder status. Any start event could trigger a transfer
	 * of responderID. Any move event could trigger a transfer, so long as there is
	 * currently a responder set (in other words as long as the user is pressing
	 * down).
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @return {boolean} True if a transfer of responder could possibly occur.
	 */
	function canTriggerTransfer(topLevelType) {
	  return topLevelType === EventConstants.topLevelTypes.topScroll ||
	         isStartish(topLevelType) ||
	         (isPressing && isMoveish(topLevelType));
	}

	/**
	 * Event plugin for formalizing the negotiation between claiming locks on
	 * receiving touches.
	 */
	var ResponderEventPlugin = {

	  getResponderID: function() {
	    return responderID;
	  },

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var extracted;
	    // Must have missed an end event - reset the state here.
	    if (responderID && isStartish(topLevelType)) {
	      responderID = null;
	    }
	    if (isStartish(topLevelType)) {
	      isPressing = true;
	    } else if (isEndish(topLevelType)) {
	      isPressing = false;
	    }
	    if (canTriggerTransfer(topLevelType)) {
	      var transfer = setResponderAndExtractTransfer(
	        topLevelType,
	        topLevelTargetID,
	        nativeEvent
	      );
	      if (transfer) {
	        extracted = accumulateInto(extracted, transfer);
	      }
	    }
	    // Now that we know the responder is set correctly, we can dispatch
	    // responder type events (directly to the responder).
	    var type = isMoveish(topLevelType) ? eventTypes.responderMove :
	      isEndish(topLevelType) ? eventTypes.responderRelease :
	      isStartish(topLevelType) ? eventTypes.responderStart : null;
	    if (type) {
	      var gesture = SyntheticEvent.getPooled(
	        type,
	        responderID || '',
	        nativeEvent
	      );
	      EventPropagators.accumulateDirectDispatches(gesture);
	      extracted = accumulateInto(extracted, gesture);
	    }
	    if (type === eventTypes.responderRelease) {
	      responderID = null;
	    }
	    return extracted;
	  }

	};

	module.exports = ResponderEventPlugin;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = __webpack_require__(62);
	var EventPluginUtils = __webpack_require__(192);
	var EventPropagators = __webpack_require__(139);
	var SyntheticUIEvent = __webpack_require__(162);
	var TouchEventUtils = __webpack_require__(1095);
	var ViewportMetrics = __webpack_require__(242);

	var keyOf = __webpack_require__(76);
	var topLevelTypes = EventConstants.topLevelTypes;

	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;

	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    topLevelTypes.topTouchCancel,
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}

	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;

	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};

	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}

	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}

	var dependencies = [
	  topLevelTypes.topMouseDown,
	  topLevelTypes.topMouseMove,
	  topLevelTypes.topMouseUp
	];

	if (EventPluginUtils.useTouchEvents) {
	  dependencies.push(
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  );
	}

	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};

	var TapEventPlugin = {

	  tapMoveThreshold: tapMoveThreshold,

	  ignoreMouseThreshold: ignoreMouseThreshold,

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    if (isTouch(topLevelType)) {
	      lastTouchEvent = nativeEvent.timeStamp;
	    } else {
	      if (lastTouchEvent && (nativeEvent.timeStamp - lastTouchEvent) < ignoreMouseThreshold) {
	        return null;
	      }
	    }

	    if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	      return null;
	    }
	    var event = null;
	    var distance = getDistance(startCoords, nativeEvent);
	    if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	      event = SyntheticUIEvent.getPooled(
	        eventTypes.touchTap,
	        topLevelTargetID,
	        nativeEvent
	      );
	    }
	    if (isStartish(topLevelType)) {
	      startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	      startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	    } else if (isEndish(topLevelType)) {
	      startCoords.x = 0;
	      startCoords.y = 0;
	    }
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }

	};

	module.exports = TapEventPlugin;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */

	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;

	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};

	module.exports = TouchEventUtils;


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function injectTapEventPlugin () {
	  var React = __webpack_require__(1);
	  React.initializeTouchEvents(true);

	  __webpack_require__(156).injection.injectEventPluginsByName({
	    "ResponderEventPlugin": __webpack_require__(1093),
	    "TapEventPlugin":       __webpack_require__(1094)
	  });
	};


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPropagators = __webpack_require__(139);
	var ExecutionEnvironment = __webpack_require__(42);
	var FallbackCompositionState = __webpack_require__(1105);
	var SyntheticCompositionEvent = __webpack_require__(1146);
	var SyntheticInputEvent = __webpack_require__(1149);

	var keyOf = __webpack_require__(76);

	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;

	var canUseCompositionEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'CompositionEvent' in window
	);

	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}

	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'TextEvent' in window &&
	  !documentMode &&
	  !isPresto()
	);

	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = (
	  ExecutionEnvironment.canUseDOM &&
	  (
	    (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11)
	  )
	);

	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (
	    typeof opera === 'object' &&
	    typeof opera.version === 'function' &&
	    parseInt(opera.version(), 10) <= 12
	  );
	}

	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

	var topLevelTypes = EventConstants.topLevelTypes;

	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBeforeInput: null}),
	      captured: keyOf({onBeforeInputCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topTextInput,
	      topLevelTypes.topPaste
	    ]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionEnd: null}),
	      captured: keyOf({onCompositionEndCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionStart: null}),
	      captured: keyOf({onCompositionStartCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionStart,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionUpdate: null}),
	      captured: keyOf({onCompositionUpdateCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionUpdate,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  }
	};

	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;

	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (
	    (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	    // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	    !(nativeEvent.ctrlKey && nativeEvent.altKey)
	  );
	}


	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}

	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return (
	    topLevelType === topLevelTypes.topKeyDown &&
	    nativeEvent.keyCode === START_KEYCODE
	  );
	}

	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return (END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1);
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return (nativeEvent.keyCode !== START_KEYCODE);
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}

	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}

	// Track the current IME composition fallback object, if any.
	var currentComposition = null;

	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var eventType;
	  var fallbackData;

	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }

	  if (!eventType) {
	    return null;
	  }

	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }

	  var event = SyntheticCompositionEvent.getPooled(
	    eventType,
	    topLevelTargetID,
	    nativeEvent
	  );

	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }

	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}

	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }

	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;

	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;

	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }

	      return chars;

	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}

	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (
	      topLevelType === topLevelTypes.topCompositionEnd ||
	      isFallbackCompositionEnd(topLevelType, nativeEvent)
	    ) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }

	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}

	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var chars;

	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }

	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }

	  var event = SyntheticInputEvent.getPooled(
	    eventTypes.beforeInput,
	    topLevelTargetID,
	    nativeEvent
	  );

	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}

	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID,
	    nativeEvent
	  ) {
	    return [
	      extractCompositionEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      ),
	      extractBeforeInputEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      )
	    ];
	  }
	};

	module.exports = BeforeInputEventPlugin;


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPluginHub = __webpack_require__(156);
	var EventPropagators = __webpack_require__(139);
	var ExecutionEnvironment = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(63);
	var SyntheticEvent = __webpack_require__(110);

	var isEventSupported = __webpack_require__(382);
	var isTextInputElement = __webpack_require__(543);
	var keyOf = __webpack_require__(76);

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onChange: null}),
	      captured: keyOf({onChangeCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topChange,
	      topLevelTypes.topClick,
	      topLevelTypes.topFocus,
	      topLevelTypes.topInput,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};

	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;

	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  return (
	    elem.nodeName === 'SELECT' ||
	    (elem.nodeName === 'INPUT' && elem.type === 'file')
	  );
	}

	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (
	    (!('documentMode' in document) || document.documentMode > 8)
	  );
	}

	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(
	    eventTypes.change,
	    activeElementID,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(event);

	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}

	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue();
	}

	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}

	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}

	function getTargetIDForChangeEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}


	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (
	    (!('documentMode' in document) || document.documentMode > 9)
	  );
	}

	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp =  {
	  get: function() {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function(val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};

	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(
	    target.constructor.prototype,
	    'value'
	  );

	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}

	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }

	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);

	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}

	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;

	  manualDispatchChangeEvent(nativeEvent);
	}

	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}

	// For IE8 and IE9.
	function handleEventsForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}

	// For IE8 and IE9.
	function getTargetIDForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange ||
	      topLevelType === topLevelTypes.topKeyUp ||
	      topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}


	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return (
	    elem.nodeName === 'INPUT' &&
	    (elem.type === 'checkbox' || elem.type === 'radio')
	  );
	}

	function getTargetIDForClickEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}

	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }

	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(
	          eventTypes.change,
	          targetID,
	          nativeEvent
	        );
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }

	    if (handleEventFunc) {
	      handleEventFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	    }
	  }

	};

	module.exports = ChangeEventPlugin;


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */

	'use strict';

	var nextReactRootIndex = 0;

	var ClientReactRootIndex = {
	  createReactRootIndex: function() {
	    return nextReactRootIndex++;
	  }
	};

	module.exports = ClientReactRootIndex;


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */

	'use strict';

	var Danger = __webpack_require__(1101);
	var ReactMultiChildUpdateTypes = __webpack_require__(530);

	var setTextContent = __webpack_require__(1173);
	var invariant = __webpack_require__(11);

	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	  parentNode.insertBefore(
	    childNode,
	    parentNode.childNodes[index] || null
	  );
	}

	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {

	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,

	  updateTextContent: setTextContent,

	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function(updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;

	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING ||
	          update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;

	        (false ? invariant(
	          updatedChild,
	          'processUpdates(): Unable to find child %s of element. This ' +
	          'probably means the DOM was unexpectedly mutated (e.g., by the ' +
	          'browser), usually due to forgetting a <tbody> when using tables, ' +
	          'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' +
	          'in an <svg> parent. Try inspecting the child nodes of the element ' +
	          'with React ID `%s`.',
	          updatedIndex,
	          parentID
	        ) : invariant(updatedChild));

	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;

	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }

	    var renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);

	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }

	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(
	            update.parentNode,
	            renderedMarkup[update.markupIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(
	            update.parentNode,
	            initialChildren[update.parentID][update.fromIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(
	            update.parentNode,
	            update.textContent
	          );
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }

	};

	module.exports = DOMChildrenOperations;


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */

	/*jslint evil: true, sub: true */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	var createNodesFromMarkup = __webpack_require__(1158);
	var emptyFunction = __webpack_require__(89);
	var getMarkupWrap = __webpack_require__(539);
	var invariant = __webpack_require__(11);

	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';

	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}

	var Danger = {

	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function(markupList) {
	    (false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' +
	      'thread. Make sure `window` and `document` are available globally ' +
	      'before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      (false ? invariant(
	        markupList[i],
	        'dangerouslyRenderMarkup(...): Missing markup.'
	      ) : invariant(markupList[i]));
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];

	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];

	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(
	            OPEN_TAG_NAME_EXP,
	            // This index will be parsed back out below.
	            '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" '
	          );
	        }
	      }

	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(
	        markupListByNodeName.join(''),
	        emptyFunction // Do nothing special with <script> tags.
	      );

	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute &&
	            renderNode.hasAttribute(RESULT_INDEX_ATTR)) {

	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);

	          (false ? invariant(
	            !resultList.hasOwnProperty(resultIndex),
	            'Danger: Assigning to an already-occupied result index.'
	          ) : invariant(!resultList.hasOwnProperty(resultIndex)));

	          resultList[resultIndex] = renderNode;

	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;

	        } else if (false) {
	          console.error(
	            'Danger: Discarding unexpected node:',
	            renderNode
	          );
	        }
	      }
	    }

	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    (false ? invariant(
	      resultListAssignmentCount === resultList.length,
	      'Danger: Did not assign to every index of resultList.'
	    ) : invariant(resultListAssignmentCount === resultList.length));

	    (false ? invariant(
	      resultList.length === markupList.length,
	      'Danger: Expected markup to render %s nodes, but rendered %s.',
	      markupList.length,
	      resultList.length
	    ) : invariant(resultList.length === markupList.length));

	    return resultList;
	  },

	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
	    (false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' +
	      'worker thread. Make sure `window` and `document` are available ' +
	      'globally before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    (false ? invariant(markup, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(markup));
	    (false ? invariant(
	      oldChild.tagName.toLowerCase() !== 'html',
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' +
	      '<html> node. This is because browser quirks make this unreliable ' +
	      'and/or slow. If you want to render to the root you must use ' +
	      'server rendering. See React.renderToString().'
	    ) : invariant(oldChild.tagName.toLowerCase() !== 'html'));

	    var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }

	};

	module.exports = Danger;


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */

	'use strict';

	var keyOf = __webpack_require__(76);

	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [
	  keyOf({ResponderEventPlugin: null}),
	  keyOf({SimpleEventPlugin: null}),
	  keyOf({TapEventPlugin: null}),
	  keyOf({EnterLeaveEventPlugin: null}),
	  keyOf({ChangeEventPlugin: null}),
	  keyOf({SelectEventPlugin: null}),
	  keyOf({BeforeInputEventPlugin: null}),
	  keyOf({AnalyticsEventPlugin: null}),
	  keyOf({MobileSafariClickEventPlugin: null})
	];

	module.exports = DefaultEventPluginOrder;


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPropagators = __webpack_require__(139);
	var SyntheticMouseEvent = __webpack_require__(240);

	var ReactMount = __webpack_require__(109);
	var keyOf = __webpack_require__(76);

	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;

	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({onMouseEnter: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  },
	  mouseLeave: {
	    registrationName: keyOf({onMouseLeave: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  }
	};

	var extractedEvents = [null, null];

	var EnterLeaveEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topMouseOver &&
	        (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut &&
	        topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }

	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }

	    var from, to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      to =
	        getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement) ||
	        win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	    }

	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }

	    var fromID = from ? ReactMount.getID(from) : '';
	    var toID = to ? ReactMount.getID(to) : '';

	    var leave = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseLeave,
	      fromID,
	      nativeEvent
	    );
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;

	    var enter = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseEnter,
	      toID,
	      nativeEvent
	    );
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;

	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);

	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;

	    return extractedEvents;
	  }

	};

	module.exports = EnterLeaveEventPlugin;


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */

	var emptyFunction = __webpack_require__(89);

	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },

	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function(target, eventType, callback) {
	    if (!target.addEventListener) {
	      if (false) {
	        console.error(
	          'Attempted to listen to events during the capture phase on a ' +
	          'browser that does not support the capture phase. Your application ' +
	          'will not receive some events.'
	        );
	      }
	      return {
	        remove: emptyFunction
	      };
	    } else {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    }
	  },

	  registerDefault: function() {}
	};

	module.exports = EventListener;


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);

	var assign = __webpack_require__(15);
	var getTextContentAccessor = __webpack_require__(540);

	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}

	assign(FallbackCompositionState.prototype, {
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },

	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }

	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;

	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }

	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }

	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});

	PooledClass.addPoolingTo(FallbackCompositionState);

	module.exports = FallbackCompositionState;


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */

	/*jslint bitwise: true*/

	'use strict';

	var DOMProperty = __webpack_require__(155);
	var ExecutionEnvironment = __webpack_require__(42);

	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE =
	  DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE =
	  DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = (
	    implementation &&
	    implementation.hasFeature &&
	    implementation.hasFeature(
	      'http://www.w3.org/TR/SVG11/feature#BasicStructure',
	      '1.1'
	    )
	  );
	}


	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(
	    /^(data|aria)-[a-z_][a-z\d_.\-]*$/
	  ),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusMixin
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,

	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // property is supported for OpenGraph in meta tags.
	    property: null,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};

	module.exports = HTMLDOMPropertyConfig;


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedStateMixin
	 * @typechecks static-only
	 */

	'use strict';

	var ReactLink = __webpack_require__(1129);
	var ReactStateSetters = __webpack_require__(1137);

	/**
	 * A simple mixin around ReactLink.forState().
	 */
	var LinkedStateMixin = {
	  /**
	   * Create a ReactLink that's linked to part of this component's state. The
	   * ReactLink will have the current value of this.state[key] and will call
	   * setState() when a change is requested.
	   *
	   * @param {string} key state key to update. Note: you may want to use keyOf()
	   * if you're using Google Closure Compiler advanced mode.
	   * @return {ReactLink} ReactLink instance linking to the state.
	   */
	  linkState: function(key) {
	    return new ReactLink(
	      this.state[key],
	      ReactStateSetters.createStateKeySetter(this, key)
	    );
	  }
	};

	module.exports = LinkedStateMixin;


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule MobileSafariClickEventPlugin
	 * @typechecks static-only
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);

	var emptyFunction = __webpack_require__(89);

	var topLevelTypes = EventConstants.topLevelTypes;

	/**
	 * Mobile Safari does not fire properly bubble click events on non-interactive
	 * elements, which means delegated click listeners do not fire. The workaround
	 * for this bug involves attaching an empty click listener on the target node.
	 *
	 * This particular plugin works around the bug by attaching an empty click
	 * listener on `touchstart` (which does fire on every element).
	 */
	var MobileSafariClickEventPlugin = {

	  eventTypes: null,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topTouchStart) {
	      var target = nativeEvent.target;
	      if (target && !target.onclick) {
	        target.onclick = emptyFunction;
	      }
	    }
	  }

	};

	module.exports = MobileSafariClickEventPlugin;


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */

	'use strict';

	var React = __webpack_require__(157);

	var assign = __webpack_require__(15);

	var ReactTransitionGroup = React.createFactory(
	  __webpack_require__(374)
	);
	var ReactCSSTransitionGroupChild = React.createFactory(
	  __webpack_require__(1110)
	);

	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',

	  propTypes: {
	    transitionName: React.PropTypes.string.isRequired,
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool
	  },

	  getDefaultProps: function() {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },

	  _wrapChild: function(child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return ReactCSSTransitionGroupChild(
	      {
	        name: this.props.transitionName,
	        appear: this.props.transitionAppear,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave
	      },
	      child
	    );
	  },

	  render: function() {
	    return (
	      ReactTransitionGroup(
	        assign({}, this.props, {childFactory: this._wrapChild})
	      )
	    );
	  }
	});

	module.exports = ReactCSSTransitionGroup;


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */

	'use strict';

	var React = __webpack_require__(157);

	var CSSCore = __webpack_require__(520);
	var ReactTransitionEvents = __webpack_require__(1139);

	var onlyChild = __webpack_require__(245);
	var warning = __webpack_require__(26);

	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	var NO_EVENT_TIMEOUT = 5000;

	var noEventListener = null;


	if (false) {
	  noEventListener = function() {
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'transition(): tried to perform an animation without ' +
	      'an animationend or transitionend event after timeout (' +
	      '%sms). You should either disable this ' +
	      'transition in JS or add a CSS animation/transition.',
	      NO_EVENT_TIMEOUT
	    ) : null);
	  };
	}

	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',

	  transition: function(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '-' + animationType;
	    var activeClassName = className + '-active';
	    var noEventTimeout = null;

	    var endListener = function(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	      if (false) {
	        clearTimeout(noEventTimeout);
	      }

	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);

	      ReactTransitionEvents.removeEndEventListener(node, endListener);

	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };

	    ReactTransitionEvents.addEndEventListener(node, endListener);

	    CSSCore.addClass(node, className);

	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);

	    if (false) {
	      noEventTimeout = setTimeout(noEventListener, NO_EVENT_TIMEOUT);
	    }
	  },

	  queueClass: function(className) {
	    this.classNameQueue.push(className);

	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },

	  flushClassNameQueue: function() {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(
	        CSSCore.addClass.bind(CSSCore, this.getDOMNode())
	      );
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },

	  componentWillMount: function() {
	    this.classNameQueue = [];
	  },

	  componentWillUnmount: function() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },

	  componentWillAppear: function(done) {
	    if (this.props.appear) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },

	  componentWillEnter: function(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },

	  componentWillLeave: function(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },

	  render: function() {
	    return onlyChild(this.props.children);
	  }
	});

	module.exports = ReactCSSTransitionGroupChild;


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */

	'use strict';

	var ReactReconciler = __webpack_require__(161);

	var flattenChildren = __webpack_require__(1160);
	var instantiateReactComponent = __webpack_require__(381);
	var shouldUpdateReactComponent = __webpack_require__(384);

	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {

	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function(nestedChildNodes, transaction, context) {
	    var children = flattenChildren(nestedChildNodes);
	    for (var name in children) {
	      if (children.hasOwnProperty(name)) {
	        var child = children[name];
	        // The rendered children must be turned into instances as they're
	        // mounted.
	        var childInstance = instantiateReactComponent(child, null);
	        children[name] = childInstance;
	      }
	    }
	    return children;
	  },

	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextNestedChildNodes Nested child maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function(
	    prevChildren,
	    nextNestedChildNodes,
	    transaction,
	    context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    var nextChildren = flattenChildren(nextNestedChildNodes);
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(
	          prevChild, nextElement, transaction, context
	        );
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(
	          nextElement,
	          null
	        );
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) &&
	          !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },

	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function(renderedChildren) {
	    for (var name in renderedChildren) {
	      var renderedChild = renderedChildren[name];
	      ReactReconciler.unmountComponent(renderedChild);
	    }
	  }

	};

	module.exports = ReactChildReconciler;


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */

	'use strict';

	var ReactComponentEnvironment = __webpack_require__(368);
	var ReactContext = __webpack_require__(369);
	var ReactCurrentOwner = __webpack_require__(108);
	var ReactElement = __webpack_require__(31);
	var ReactElementValidator = __webpack_require__(193);
	var ReactInstanceMap = __webpack_require__(160);
	var ReactLifeCycle = __webpack_require__(372);
	var ReactNativeComponent = __webpack_require__(238);
	var ReactPerf = __webpack_require__(141);
	var ReactPropTypeLocations = __webpack_require__(373);
	var ReactPropTypeLocationNames = __webpack_require__(239);
	var ReactReconciler = __webpack_require__(161);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);
	var emptyObject = __webpack_require__(244);
	var invariant = __webpack_require__(11);
	var shouldUpdateReactComponent = __webpack_require__(384);
	var warning = __webpack_require__(26);

	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}

	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */

	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;

	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {

	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function(element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;

	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;

	    this._renderedComponent = null;

	    this._context = null;
	    this._mountOrder = 0;
	    this._isTopLevel = false;

	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },

	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;

	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(this._currentElement._context);

	    var Component = ReactNativeComponent.getComponentClassForElement(
	      this._currentElement
	    );

	    // Initialize the public class
	    var inst = new Component(publicProps, publicContext);

	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      ("production" !== process.env.NODE_ENV ? warning(
	        inst.render != null,
	        '%s(...): No `render` method found on the returned component ' +
	        'instance: you may have forgotten to define `render` in your ' +
	        'component or you may have accidentally tried to render an element ' +
	        'whose type is a function that isn\'t a React component.',
	        Component.displayName || Component.name || 'Component'
	      ) : null);
	    }

	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;

	    this._instance = inst;

	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);

	    if (false) {
	      this._warnIfContextsDiffer(this._currentElement._context, context);
	    }

	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getInitialState ||
	        inst.getInitialState.isReactClassApproved,
	        'getInitialState was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Did you mean to define a state property instead?',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getDefaultProps ||
	        inst.getDefaultProps.isReactClassApproved,
	        'getDefaultProps was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Use a static property to define defaultProps instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.propTypes,
	        'propTypes was defined as an instance property on %s. Use a static ' +
	        'property to define propTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.contextTypes,
	        'contextTypes was defined as an instance property on %s. Use a ' +
	        'static property to define contextTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof inst.componentShouldUpdate !== 'function',
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        (this.getName() || 'A component')
	      ) : null);
	    }

	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    (false ? invariant(
	      typeof initialState === 'object' && !Array.isArray(initialState),
	      '%s.state: must be set to an object or null',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));

	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;

	    var renderedElement;

	    var previouslyMounting = ReactLifeCycle.currentlyMountingInstance;
	    ReactLifeCycle.currentlyMountingInstance = this;
	    try {
	      if (inst.componentWillMount) {
	        inst.componentWillMount();
	        // When mounting, calls to `setState` by `componentWillMount` will set
	        // `this._pendingStateQueue` without triggering a re-render.
	        if (this._pendingStateQueue) {
	          inst.state = this._processPendingState(inst.props, inst.context);
	        }
	      }

	      renderedElement = this._renderValidatedComponent();
	    } finally {
	      ReactLifeCycle.currentlyMountingInstance = previouslyMounting;
	    }

	    this._renderedComponent = this._instantiateReactComponent(
	      renderedElement,
	      this._currentElement.type // The wrapping type
	    );

	    var markup = ReactReconciler.mountComponent(
	      this._renderedComponent,
	      rootID,
	      transaction,
	      this._processChildContext(context)
	    );
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }

	    return markup;
	  },

	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function() {
	    var inst = this._instance;

	    if (inst.componentWillUnmount) {
	      var previouslyUnmounting = ReactLifeCycle.currentlyUnmountingInstance;
	      ReactLifeCycle.currentlyUnmountingInstance = this;
	      try {
	        inst.componentWillUnmount();
	      } finally {
	        ReactLifeCycle.currentlyUnmountingInstance = previouslyUnmounting;
	      }
	    }

	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;

	    // Reset pending fields
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;

	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;

	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);

	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },

	  /**
	   * Schedule a partial update to the props. Only used for internal testing.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @internal
	   */
	  _setPropsInternal: function(partialProps, callback) {
	    // This is a deoptimized path. We optimize for always having an element.
	    // This creates an extra internal element.
	    var element = this._pendingElement || this._currentElement;
	    this._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      assign({}, element.props, partialProps)
	    );
	    ReactUpdates.enqueueUpdate(this, callback);
	  },

	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function(context) {
	    var maskedContext = null;
	    // This really should be getting the component class for the element,
	    // but we know that we're not going to need it for built-ins.
	    if (typeof this._currentElement.type === 'string') {
	      return emptyObject;
	    }
	    var contextTypes = this._currentElement.type.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },

	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function(context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.contextTypes) {
	        this._checkPropTypes(
	          Component.contextTypes,
	          maskedContext,
	          ReactPropTypeLocations.context
	        );
	      }
	    }
	    return maskedContext;
	  },

	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function(currentContext) {
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      (false ? invariant(
	        typeof inst.constructor.childContextTypes === 'object',
	        '%s.getChildContext(): childContextTypes must be defined in order to ' +
	        'use getChildContext().',
	        this.getName() || 'ReactCompositeComponent'
	      ) : invariant(typeof inst.constructor.childContextTypes === 'object'));
	      if (false) {
	        this._checkPropTypes(
	          inst.constructor.childContextTypes,
	          childContext,
	          ReactPropTypeLocations.childContext
	        );
	      }
	      for (var name in childContext) {
	        (false ? invariant(
	          name in inst.constructor.childContextTypes,
	          '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
	          this.getName() || 'ReactCompositeComponent',
	          name
	        ) : invariant(name in inst.constructor.childContextTypes));
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },

	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function(newProps) {
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.propTypes) {
	        this._checkPropTypes(
	          Component.propTypes,
	          newProps,
	          ReactPropTypeLocations.prop
	        );
	      }
	    }
	    return newProps;
	  },

	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function(propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          (false ? invariant(
	            typeof propTypes[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually ' +
	            'from React.PropTypes.',
	            componentName || 'React class',
	            ReactPropTypeLocationNames[location],
	            propName
	          ) : invariant(typeof propTypes[propName] === 'function'));
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // React.render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);

	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            (false ? warning(
	              false,
	              'Failed Composite propType: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          } else {
	            (false ? warning(
	              false,
	              'Failed Context Types: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          }
	        }
	      }
	    }
	  },

	  receiveComponent: function(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;

	    this._pendingElement = null;

	    this.updateComponent(
	      transaction,
	      prevElement,
	      nextElement,
	      prevContext,
	      nextContext
	    );
	  },

	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(
	        this,
	        this._pendingElement || this._currentElement,
	        transaction,
	        this._context
	      );
	    }

	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      if (false) {
	        ReactElementValidator.checkAndWarnForMutatedProps(
	          this._currentElement
	        );
	      }

	      this.updateComponent(
	        transaction,
	        this._currentElement,
	        this._currentElement,
	        this._context,
	        this._context
	      );
	    }
	  },

	  /**
	   * Compare two contexts, warning if they are different
	   * TODO: Remove this check when owner-context is removed
	   */
	   _warnIfContextsDiffer: function(ownerBasedContext, parentBasedContext) {
	    ownerBasedContext = this._maskContext(ownerBasedContext);
	    parentBasedContext = this._maskContext(parentBasedContext);
	    var parentKeys = Object.keys(parentBasedContext).sort();
	    var displayName = this.getName() || 'ReactCompositeComponent';
	    for (var i = 0; i < parentKeys.length; i++) {
	      var key = parentKeys[i];
	      (false ? warning(
	        ownerBasedContext[key] === parentBasedContext[key],
	        'owner-based and parent-based contexts differ '  +
	        '(values: `%s` vs `%s`) for key (%s) while mounting %s ' +
	        '(see: http://fb.me/react-context-by-parent)',
	        ownerBasedContext[key],
	        parentBasedContext[key],
	        key,
	        displayName
	      ) : null);
	    }
	  },

	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(
	    transaction,
	    prevParentElement,
	    nextParentElement,
	    prevUnmaskedContext,
	    nextUnmaskedContext
	  ) {
	    var inst = this._instance;

	    var nextContext = inst.context;
	    var nextProps = inst.props;

	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement !== nextParentElement) {
	      nextContext = this._processContext(nextParentElement._context);
	      nextProps = this._processProps(nextParentElement.props);

	      if (false) {
	        if (nextUnmaskedContext != null) {
	          this._warnIfContextsDiffer(
	            nextParentElement._context,
	            nextUnmaskedContext
	          );
	        }
	      }

	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.

	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }

	    var nextState = this._processPendingState(nextProps, nextContext);

	    var shouldUpdate =
	      this._pendingForceUpdate ||
	      !inst.shouldComponentUpdate ||
	      inst.shouldComponentUpdate(nextProps, nextState, nextContext);

	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof shouldUpdate !== 'undefined',
	        '%s.shouldComponentUpdate(): Returned undefined instead of a ' +
	        'boolean value. Make sure to return true or false.',
	        this.getName() || 'ReactCompositeComponent'
	      ) : null);
	    }

	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(
	        nextParentElement,
	        nextProps,
	        nextState,
	        nextContext,
	        transaction,
	        nextUnmaskedContext
	      );
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },

	  _processPendingState: function(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;

	    if (!queue) {
	      return inst.state;
	    }

	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(
	        nextState,
	        typeof partial === 'function' ?
	          partial.call(inst, nextState, props, context) :
	          partial
	      );
	    }

	    return nextState;
	  },

	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function(
	    nextElement,
	    nextProps,
	    nextState,
	    nextContext,
	    transaction,
	    unmaskedContext
	  ) {
	    var inst = this._instance;

	    var prevProps = inst.props;
	    var prevState = inst.state;
	    var prevContext = inst.context;

	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }

	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;

	    this._updateRenderedComponent(transaction, unmaskedContext);

	    if (inst.componentDidUpdate) {
	      transaction.getReactMountReady().enqueue(
	        inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext),
	        inst
	      );
	    }
	  },

	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(
	        prevComponentInstance,
	        nextRenderedElement,
	        transaction,
	        this._processChildContext(context)
	      );
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);

	      this._renderedComponent = this._instantiateReactComponent(
	        nextRenderedElement,
	        this._currentElement.type
	      );
	      var nextMarkup = ReactReconciler.mountComponent(
	        this._renderedComponent,
	        thisID,
	        transaction,
	        this._processChildContext(context)
	      );
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },

	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function(prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(
	      prevComponentID,
	      nextMarkup
	    );
	  },

	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function() {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' &&
	          inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }

	    return renderedComponent;
	  },

	  /**
	   * @private
	   */
	  _renderValidatedComponent: function() {
	    var renderedComponent;
	    var previousContext = ReactContext.current;
	    ReactContext.current = this._processChildContext(
	      this._currentElement._context
	    );
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent =
	        this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactContext.current = previousContext;
	      ReactCurrentOwner.current = null;
	    }
	    (false ? invariant(
	      // TODO: An `isValidNode` function would probably be more appropriate
	      renderedComponent === null || renderedComponent === false ||
	      ReactElement.isValidElement(renderedComponent),
	      '%s.render(): A valid ReactComponent must be returned. You may have ' +
	        'returned undefined, an array or some other invalid object.',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(// TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false ||
	    ReactElement.isValidElement(renderedComponent)));
	    return renderedComponent;
	  },

	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function(ref, component) {
	    var inst = this.getPublicInstance();
	    var refs = inst.refs === emptyObject ? (inst.refs = {}) : inst.refs;
	    refs[ref] = component.getPublicInstance();
	  },

	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },

	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return (
	      type.displayName || (constructor && constructor.displayName) ||
	      type.name || (constructor && constructor.name) ||
	      null
	    );
	  },

	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by React.render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function() {
	    return this._instance;
	  },

	  // Stub
	  _instantiateReactComponent: null

	};

	ReactPerf.measureMethods(
	  ReactCompositeComponentMixin,
	  'ReactCompositeComponent',
	  {
	    mountComponent: 'mountComponent',
	    updateComponent: 'updateComponent',
	    _renderValidatedComponent: '_renderValidatedComponent'
	  }
	);

	var ReactCompositeComponent = {

	  Mixin: ReactCompositeComponentMixin

	};

	module.exports = ReactCompositeComponent;


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 * @typechecks static-only
	 */

	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactElementValidator = __webpack_require__(193);

	var mapObject = __webpack_require__(1168);

	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}

	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOM = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',

	  // SVG
	  circle: 'circle',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'

	}, createDOMFactory);

	module.exports = ReactDOM;


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */

	'use strict';

	var AutoFocusMixin = __webpack_require__(237);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var keyMirror = __webpack_require__(24);

	var button = ReactElement.createFactory('button');

	var mouseListenerNames = keyMirror({
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	});

	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = ReactClass.createClass({
	  displayName: 'ReactDOMButton',
	  tagName: 'BUTTON',

	  mixins: [AutoFocusMixin, ReactBrowserComponentMixin],

	  render: function() {
	    var props = {};

	    // Copy the props; except the mouse listeners if we're disabled
	    for (var key in this.props) {
	      if (this.props.hasOwnProperty(key) &&
	          (!this.props.disabled || !mouseListenerNames[key])) {
	        props[key] = this.props[key];
	      }
	    }

	    return button(props, this.props.children);
	  }

	});

	module.exports = ReactDOMButton;


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMForm
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var LocalEventTrapMixin = __webpack_require__(365);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var form = ReactElement.createFactory('form');

	/**
	 * Since onSubmit doesn't bubble OR capture on the top level in IE8, we need
	 * to capture it on the <form> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <form> a
	 * composite component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMForm = ReactClass.createClass({
	  displayName: 'ReactDOMForm',
	  tagName: 'FORM',

	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],

	  render: function() {
	    // TODO: Instead of using `ReactDOM` directly, we should use JSX. However,
	    // `jshint` fails to parse JSX so in order for linting to work in the open
	    // source repo, we need to just use `ReactDOM.form`.
	    return form(this.props);
	  },

	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit');
	  }
	});

	module.exports = ReactDOMForm;


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIframe
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var LocalEventTrapMixin = __webpack_require__(365);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var iframe = ReactElement.createFactory('iframe');

	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <iframe> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <iframe> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMIframe = ReactClass.createClass({
	  displayName: 'ReactDOMIframe',
	  tagName: 'IFRAME',

	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],

	  render: function() {
	    return iframe(this.props);
	  },

	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	  }
	});

	module.exports = ReactDOMIframe;


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMImg
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var LocalEventTrapMixin = __webpack_require__(365);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var img = ReactElement.createFactory('img');

	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <img> element itself. There are lots of hacks we could do
	 * to accomplish this, but the most reliable is to make <img> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMImg = ReactClass.createClass({
	  displayName: 'ReactDOMImg',
	  tagName: 'IMG',

	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],

	  render: function() {
	    return img(this.props);
	  },

	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error');
	  }
	});

	module.exports = ReactDOMImg;


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */

	'use strict';

	var AutoFocusMixin = __webpack_require__(237);
	var DOMPropertyOperations = __webpack_require__(191);
	var LinkedValueUtils = __webpack_require__(364);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);
	var ReactMount = __webpack_require__(109);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);

	var input = ReactElement.createFactory('input');

	var instancesByReactID = {};

	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}

	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = ReactClass.createClass({
	  displayName: 'ReactDOMInput',
	  tagName: 'INPUT',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    return {
	      initialChecked: this.props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null
	    };
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);

	    props.defaultChecked = null;
	    props.defaultValue = null;

	    var value = LinkedValueUtils.getValue(this);
	    props.value = value != null ? value : this.state.initialValue;

	    var checked = LinkedValueUtils.getChecked(this);
	    props.checked = checked != null ? checked : this.state.initialChecked;

	    props.onChange = this._handleChange;

	    return input(props, this.props.children);
	  },

	  componentDidMount: function() {
	    var id = ReactMount.getID(this.getDOMNode());
	    instancesByReactID[id] = this;
	  },

	  componentWillUnmount: function() {
	    var rootNode = this.getDOMNode();
	    var id = ReactMount.getID(rootNode);
	    delete instancesByReactID[id];
	  },

	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var rootNode = this.getDOMNode();
	    if (this.props.checked != null) {
	      DOMPropertyOperations.setValueForProperty(
	        rootNode,
	        'checked',
	        this.props.checked || false
	      );
	    }

	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    // Here we use asap to wait until all updates have propagated, which
	    // is important when using controlled components within layers:
	    // https://github.com/facebook/react/issues/1698
	    ReactUpdates.asap(forceUpdateIfMounted, this);

	    var name = this.props.name;
	    if (this.props.type === 'radio' && name != null) {
	      var rootNode = this.getDOMNode();
	      var queryRoot = rootNode;

	      while (queryRoot.parentNode) {
	        queryRoot = queryRoot.parentNode;
	      }

	      // If `rootNode.form` was non-null, then we could try `form.elements`,
	      // but that sometimes behaves strangely in IE8. We could also try using
	      // `form.getElementsByName`, but that will only return direct children
	      // and won't include inputs that use the HTML5 `form=` attribute. Since
	      // the input might not even be in a form, let's just use the global
	      // `querySelectorAll` to ensure we don't miss anything.
	      var group = queryRoot.querySelectorAll(
	        'input[name=' + JSON.stringify('' + name) + '][type="radio"]');

	      for (var i = 0, groupLen = group.length; i < groupLen; i++) {
	        var otherNode = group[i];
	        if (otherNode === rootNode ||
	            otherNode.form !== rootNode.form) {
	          continue;
	        }
	        var otherID = ReactMount.getID(otherNode);
	        (false ? invariant(
	          otherID,
	          'ReactDOMInput: Mixing React and non-React radio inputs with the ' +
	          'same `name` is not supported.'
	        ) : invariant(otherID));
	        var otherInstance = instancesByReactID[otherID];
	        (false ? invariant(
	          otherInstance,
	          'ReactDOMInput: Unknown radio button ID %s.',
	          otherID
	        ) : invariant(otherInstance));
	        // If this is a controlled radio button group, forcing the input that
	        // was previously checked to update will cause it to be come re-checked
	        // as appropriate.
	        ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	      }
	    }

	    return returnValue;
	  }

	});

	module.exports = ReactDOMInput;


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */

	'use strict';

	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var warning = __webpack_require__(26);

	var option = ReactElement.createFactory('option');

	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = ReactClass.createClass({
	  displayName: 'ReactDOMOption',
	  tagName: 'OPTION',

	  mixins: [ReactBrowserComponentMixin],

	  componentWillMount: function() {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        this.props.selected == null,
	        'Use the `defaultValue` or `value` props on <select> instead of ' +
	        'setting `selected` on <option>.'
	      ) : null);
	    }
	  },

	  render: function() {
	    return option(this.props, this.props.children);
	  }

	});

	module.exports = ReactDOMOption;


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */

	'use strict';

	var AutoFocusMixin = __webpack_require__(237);
	var LinkedValueUtils = __webpack_require__(364);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);

	var select = ReactElement.createFactory('select');

	function updateOptionsIfPendingUpdateAndMounted() {
	  /*jshint validthis:true */
	  if (this._pendingUpdate) {
	    this._pendingUpdate = false;
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null && this.isMounted()) {
	      updateOptions(this, value);
	    }
	  }
	}

	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function selectValueType(props, propName, componentName) {
	  if (props[propName] == null) {
	    return null;
	  }
	  if (props.multiple) {
	    if (!Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be an array if ") +
	        ("`multiple` is true.")
	      );
	    }
	  } else {
	    if (Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be a scalar ") +
	        ("value if `multiple` is false.")
	      );
	    }
	  }
	}

	/**
	 * @param {ReactComponent} component Instance of ReactDOMSelect
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(component, propValue) {
	  var selectedValue, i, l;
	  var options = component.getDOMNode().options;

	  if (component.props.multiple) {
	    selectedValue = {};
	    for (i = 0, l = propValue.length; i < l; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0, l = options.length; i < l; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0, l = options.length; i < l; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}

	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = ReactClass.createClass({
	  displayName: 'ReactDOMSelect',
	  tagName: 'SELECT',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  propTypes: {
	    defaultValue: selectValueType,
	    value: selectValueType
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);

	    props.onChange = this._handleChange;
	    props.value = null;

	    return select(props, this.props.children);
	  },

	  componentWillMount: function() {
	    this._pendingUpdate = false;
	  },

	  componentDidMount: function() {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      updateOptions(this, value);
	    } else if (this.props.defaultValue != null) {
	      updateOptions(this, this.props.defaultValue);
	    }
	  },

	  componentDidUpdate: function(prevProps) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      this._pendingUpdate = false;
	      updateOptions(this, value);
	    } else if (!prevProps.multiple !== !this.props.multiple) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (this.props.defaultValue != null) {
	        updateOptions(this, this.props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(this, this.props.multiple ? [] : '');
	      }
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }

	    this._pendingUpdate = true;
	    ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	    return returnValue;
	  }

	});

	module.exports = ReactDOMSelect;


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	var getNodeForCharacterOffset = __webpack_require__(1162);
	var getTextContentAccessor = __webpack_require__(540);

	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}

	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;

	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);

	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;

	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}

	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();

	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }

	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;

	  var currentRange = selection.getRangeAt(0);

	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(
	    selection.anchorNode,
	    selection.anchorOffset,
	    selection.focusNode,
	    selection.focusOffset
	  );

	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

	  var isTempRangeCollapsed = isCollapsed(
	    tempRange.startContainer,
	    tempRange.startOffset,
	    tempRange.endContainer,
	    tempRange.endOffset
	  );

	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;

	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;

	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}

	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;

	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }

	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}

	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }

	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ?
	            start : Math.min(offsets.end, length);

	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }

	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);

	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();

	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}

	var useIEOffsets = (
	  ExecutionEnvironment.canUseDOM &&
	  'selection' in document &&
	  !('getSelection' in window)
	);

	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};

	module.exports = ReactDOMSelection;


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */

	'use strict';

	var AutoFocusMixin = __webpack_require__(237);
	var DOMPropertyOperations = __webpack_require__(191);
	var LinkedValueUtils = __webpack_require__(364);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);
	var invariant = __webpack_require__(11);

	var warning = __webpack_require__(26);

	var textarea = ReactElement.createFactory('textarea');

	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}

	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = ReactClass.createClass({
	  displayName: 'ReactDOMTextarea',
	  tagName: 'TEXTAREA',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = this.props.children;
	    if (children != null) {
	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'Use the `defaultValue` or `value` props instead of setting ' +
	          'children on <textarea>.'
	        ) : null);
	      }
	      (false ? invariant(
	        defaultValue == null,
	        'If you supply `defaultValue` on a <textarea>, do not pass children.'
	      ) : invariant(defaultValue == null));
	      if (Array.isArray(children)) {
	        (false ? invariant(
	          children.length <= 1,
	          '<textarea> can only have at most one child.'
	        ) : invariant(children.length <= 1));
	        children = children[0];
	      }

	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(this);
	    return {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue)
	    };
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);

	    (false ? invariant(
	      props.dangerouslySetInnerHTML == null,
	      '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
	    ) : invariant(props.dangerouslySetInnerHTML == null));

	    props.defaultValue = null;
	    props.value = null;
	    props.onChange = this._handleChange;

	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    return textarea(props, this.state.initialValue);
	  },

	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      var rootNode = this.getDOMNode();
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	    return returnValue;
	  }

	});

	module.exports = ReactDOMTextarea;


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */

	'use strict';

	var ReactUpdates = __webpack_require__(63);
	var Transaction = __webpack_require__(241);

	var assign = __webpack_require__(15);
	var emptyFunction = __webpack_require__(89);

	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};

	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};

	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}

	assign(
	  ReactDefaultBatchingStrategyTransaction.prototype,
	  Transaction.Mixin,
	  {
	    getTransactionWrappers: function() {
	      return TRANSACTION_WRAPPERS;
	    }
	  }
	);

	var transaction = new ReactDefaultBatchingStrategyTransaction();

	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,

	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function(callback, a, b, c, d) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d);
	    } else {
	      transaction.perform(callback, null, a, b, c, d);
	    }
	  }
	};

	module.exports = ReactDefaultBatchingStrategy;


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */

	'use strict';

	var BeforeInputEventPlugin = __webpack_require__(1097);
	var ChangeEventPlugin = __webpack_require__(1098);
	var ClientReactRootIndex = __webpack_require__(1099);
	var DefaultEventPluginOrder = __webpack_require__(1102);
	var EnterLeaveEventPlugin = __webpack_require__(1103);
	var ExecutionEnvironment = __webpack_require__(42);
	var HTMLDOMPropertyConfig = __webpack_require__(1106);
	var MobileSafariClickEventPlugin = __webpack_require__(1108);
	var ReactBrowserComponentMixin = __webpack_require__(107);
	var ReactClass = __webpack_require__(75);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(367);
	var ReactDefaultBatchingStrategy = __webpack_require__(1123);
	var ReactDOMComponent = __webpack_require__(370);
	var ReactDOMButton = __webpack_require__(1114);
	var ReactDOMForm = __webpack_require__(1115);
	var ReactDOMImg = __webpack_require__(1117);
	var ReactDOMIDOperations = __webpack_require__(526);
	var ReactDOMIframe = __webpack_require__(1116);
	var ReactDOMInput = __webpack_require__(1118);
	var ReactDOMOption = __webpack_require__(1119);
	var ReactDOMSelect = __webpack_require__(1120);
	var ReactDOMTextarea = __webpack_require__(1122);
	var ReactDOMTextComponent = __webpack_require__(527);
	var ReactElement = __webpack_require__(31);
	var ReactEventListener = __webpack_require__(1127);
	var ReactInjection = __webpack_require__(1128);
	var ReactInstanceHandles = __webpack_require__(159);
	var ReactMount = __webpack_require__(109);
	var ReactReconcileTransaction = __webpack_require__(1133);
	var SelectEventPlugin = __webpack_require__(1142);
	var ServerReactRootIndex = __webpack_require__(1143);
	var SimpleEventPlugin = __webpack_require__(1144);
	var SVGDOMPropertyConfig = __webpack_require__(1141);

	var createFullPageComponent = __webpack_require__(1157);

	function autoGenerateWrapperClass(type) {
	  return ReactClass.createClass({
	    tagName: type.toUpperCase(),
	    render: function() {
	      return new ReactElement(
	        type,
	        null,
	        null,
	        null,
	        null,
	        this.props
	      );
	    }
	  });
	}

	function inject() {
	  ReactInjection.EventEmitter.injectReactEventListener(
	    ReactEventListener
	  );

	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);

	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    MobileSafariClickEventPlugin: MobileSafariClickEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });

	  ReactInjection.NativeComponent.injectGenericComponentClass(
	    ReactDOMComponent
	  );

	  ReactInjection.NativeComponent.injectTextComponentClass(
	    ReactDOMTextComponent
	  );

	  ReactInjection.NativeComponent.injectAutoWrapper(
	    autoGenerateWrapperClass
	  );

	  // This needs to happen before createFullPageComponent() otherwise the mixin
	  // won't be included.
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);

	  ReactInjection.NativeComponent.injectComponentClasses({
	    'button': ReactDOMButton,
	    'form': ReactDOMForm,
	    'iframe': ReactDOMIframe,
	    'img': ReactDOMImg,
	    'input': ReactDOMInput,
	    'option': ReactDOMOption,
	    'select': ReactDOMSelect,
	    'textarea': ReactDOMTextarea,

	    'html': createFullPageComponent('html'),
	    'head': createFullPageComponent('head'),
	    'body': createFullPageComponent('body')
	  });

	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');

	  ReactInjection.Updates.injectReconcileTransaction(
	    ReactReconcileTransaction
	  );
	  ReactInjection.Updates.injectBatchingStrategy(
	    ReactDefaultBatchingStrategy
	  );

	  ReactInjection.RootIndex.injectCreateReactRootIndex(
	    ExecutionEnvironment.canUseDOM ?
	      ClientReactRootIndex.createReactRootIndex :
	      ServerReactRootIndex.createReactRootIndex
	  );

	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	  ReactInjection.DOMComponent.injectIDOperations(ReactDOMIDOperations);

	  if (false) {
	    var url = (ExecutionEnvironment.canUseDOM && window.location.href) || '';
	    if ((/[?&]react_perf\b/).test(url)) {
	      var ReactDefaultPerf = require("./ReactDefaultPerf");
	      ReactDefaultPerf.start();
	    }
	  }
	}

	module.exports = {
	  inject: inject
	};


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */

	"use strict";

	var ReactErrorUtils = {
	  /**
	   * Creates a guarded version of a function. This is supposed to make debugging
	   * of event handlers easier. To aid debugging with the browser's debugger,
	   * this currently simply returns the original function.
	   *
	   * @param {function} func Function to be executed
	   * @param {string} name The name of the guard
	   * @return {function}
	   */
	  guard: function(func, name) {
	    return func;
	  }
	};

	module.exports = ReactErrorUtils;


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */

	'use strict';

	var EventPluginHub = __webpack_require__(156);

	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue();
	}

	var ReactEventEmitterMixin = {

	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events = EventPluginHub.extractEvents(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent
	    );

	    runEventQueueInBatch(events);
	  }
	};

	module.exports = ReactEventEmitterMixin;


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */

	'use strict';

	var EventListener = __webpack_require__(1104);
	var ExecutionEnvironment = __webpack_require__(42);
	var PooledClass = __webpack_require__(106);
	var ReactInstanceHandles = __webpack_require__(159);
	var ReactMount = __webpack_require__(109);
	var ReactUpdates = __webpack_require__(63);

	var assign = __webpack_require__(15);
	var getEventTarget = __webpack_require__(380);
	var getUnboundedScrollPosition = __webpack_require__(541);

	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}

	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(
	  TopLevelCallbackBookKeeping,
	  PooledClass.twoArgumentPooler
	);

	function handleTopLevelImpl(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(
	    getEventTarget(bookKeeping.nativeEvent)
	  ) || window;

	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }

	  for (var i = 0, l = bookKeeping.ancestors.length; i < l; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(
	      bookKeeping.topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      bookKeeping.nativeEvent
	    );
	  }
	}

	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}

	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,

	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

	  setHandleTopLevel: function(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },

	  setEnabled: function(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },

	  isEnabled: function() {
	    return ReactEventListener._enabled;
	  },


	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },

	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },

	  monitorScrollValue: function(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },

	  dispatchEvent: function(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }

	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
	      topLevelType,
	      nativeEvent
	    );
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};

	module.exports = ReactEventListener;


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */

	'use strict';

	var DOMProperty = __webpack_require__(155);
	var EventPluginHub = __webpack_require__(156);
	var ReactComponentEnvironment = __webpack_require__(368);
	var ReactClass = __webpack_require__(75);
	var ReactEmptyComponent = __webpack_require__(371);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactNativeComponent = __webpack_require__(238);
	var ReactDOMComponent = __webpack_require__(370);
	var ReactPerf = __webpack_require__(141);
	var ReactRootIndex = __webpack_require__(533);
	var ReactUpdates = __webpack_require__(63);

	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMComponent: ReactDOMComponent.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};

	module.exports = ReactInjection;


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLink
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * ReactLink encapsulates a common pattern in which a component wants to modify
	 * a prop received from its parent. ReactLink allows the parent to pass down a
	 * value coupled with a callback that, when invoked, expresses an intent to
	 * modify that value. For example:
	 *
	 * React.createClass({
	 *   getInitialState: function() {
	 *     return {value: ''};
	 *   },
	 *   render: function() {
	 *     var valueLink = new ReactLink(this.state.value, this._handleValueChange);
	 *     return <input valueLink={valueLink} />;
	 *   },
	 *   this._handleValueChange: function(newValue) {
	 *     this.setState({value: newValue});
	 *   }
	 * });
	 *
	 * We have provided some sugary mixins to make the creation and
	 * consumption of ReactLink easier; see LinkedValueUtils and LinkedStateMixin.
	 */

	var React = __webpack_require__(157);

	/**
	 * @param {*} value current value of the link
	 * @param {function} requestChange callback to request a change
	 */
	function ReactLink(value, requestChange) {
	  this.value = value;
	  this.requestChange = requestChange;
	}

	/**
	 * Creates a PropType that enforces the ReactLink API and optionally checks the
	 * type of the value being passed inside the link. Example:
	 *
	 * MyComponent.propTypes = {
	 *   tabIndexLink: ReactLink.PropTypes.link(React.PropTypes.number)
	 * }
	 */
	function createLinkTypeChecker(linkType) {
	  var shapes = {
	    value: typeof linkType === 'undefined' ?
	      React.PropTypes.any.isRequired :
	      linkType.isRequired,
	    requestChange: React.PropTypes.func.isRequired
	  };
	  return React.PropTypes.shape(shapes);
	}

	ReactLink.PropTypes = {
	  link: createLinkTypeChecker
	};

	module.exports = ReactLink;


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */

	'use strict';

	var ReactComponentEnvironment = __webpack_require__(368);
	var ReactMultiChildUpdateTypes = __webpack_require__(530);

	var ReactReconciler = __webpack_require__(161);
	var ReactChildReconciler = __webpack_require__(1111);

	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;

	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];

	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];

	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    textContent: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}

	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}

	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}

	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    textContent: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}

	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(
	      updateQueue,
	      markupQueue
	    );
	    clearQueue();
	  }
	}

	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}

	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {

	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {

	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function(nestedChildren, transaction, context) {
	      var children = ReactChildReconciler.instantiateChildren(
	        nestedChildren, transaction, context
	      );
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(
	            child,
	            rootID,
	            transaction,
	            context
	          );
	          child._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	      return mountImages;
	    },

	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function(nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },

	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function(nextNestedChildren, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildren, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }

	      }
	    },

	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function(nextNestedChildren, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = ReactChildReconciler.updateChildren(
	        prevChildren, nextNestedChildren, transaction, context
	      );
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChildByName(prevChild, name);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(
	            nextChild, name, nextIndex, transaction, context
	          );
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) &&
	            !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChildByName(prevChildren[name], name);
	        }
	      }
	    },

	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function() {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },

	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function(child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },

	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function(child, mountImage) {
	      enqueueMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },

	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function(child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },

	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function(textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },

	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function(
	      child,
	      name,
	      index,
	      transaction,
	      context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(
	        child,
	        rootID,
	        transaction,
	        context
	      );
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },

	    /**
	     * Unmounts a rendered child by name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @param {string} name Name of the child in `this._renderedChildren`.
	     * @private
	     */
	    _unmountChildByName: function(child, name) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }

	  }

	};

	module.exports = ReactMultiChild;


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */

	'use strict';

	var invariant = __webpack_require__(11);

	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {

	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function(object) {
	    return !!(
	      (object &&
	      typeof object.attachRef === 'function' && typeof object.detachRef === 'function')
	    );
	  },

	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function(component, ref, owner) {
	    (false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'addComponentAsRefTo(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to add a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    owner.attachRef(ref, component);
	  },

	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function(component, ref, owner) {
	    (false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to remove a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }

	};

	module.exports = ReactOwner;


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTransferer
	 */

	'use strict';

	var assign = __webpack_require__(15);
	var emptyFunction = __webpack_require__(89);
	var joinClasses = __webpack_require__(1167);

	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}

	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return assign({}, b, a);
	});

	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};

	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }

	    var transferStrategy = TransferStrategies[thisKey];

	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}

	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {

	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(assign({}, oldProps), newProps);
	  }

	};

	module.exports = ReactPropTransferer;


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */

	'use strict';

	var CallbackQueue = __webpack_require__(363);
	var PooledClass = __webpack_require__(106);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactInputSelection = __webpack_require__(528);
	var ReactPutListenerQueue = __webpack_require__(532);
	var Transaction = __webpack_require__(241);

	var assign = __webpack_require__(15);

	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};

	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },

	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occured. `close`
	   *   restores the previous value.
	   */
	  close: function(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};

	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },

	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function() {
	    this.reactMountReady.notifyAll();
	  }
	};

	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },

	  close: function() {
	    this.putListenerQueue.putListeners();
	  }
	};

	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  SELECTION_RESTORATION,
	  EVENT_SUPPRESSION,
	  ON_DOM_READY_QUEUEING
	];

	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction() {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}

	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap proceedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },

	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },

	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;

	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};


	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

	PooledClass.addPoolingTo(ReactReconcileTransaction);

	module.exports = ReactReconcileTransaction;


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */

	'use strict';

	var ReactOwner = __webpack_require__(1131);

	var ReactRef = {};

	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}

	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}

	ReactRef.attachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};

	ReactRef.shouldUpdateRefs = function(prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.

	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.

	  return (
	    nextElement._owner !== prevElement._owner ||
	    nextElement.ref !== prevElement.ref
	  );
	};

	ReactRef.detachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};

	module.exports = ReactRef;


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';

	var ReactElement = __webpack_require__(31);
	var ReactInstanceHandles = __webpack_require__(159);
	var ReactMarkupChecksum = __webpack_require__(529);
	var ReactServerRenderingTransaction =
	  __webpack_require__(1136);

	var emptyObject = __webpack_require__(244);
	var instantiateReactComponent = __webpack_require__(381);
	var invariant = __webpack_require__(11);

	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  (false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToString(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));

	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);

	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup =
	        componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}

	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  (false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToStaticMarkup(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));

	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);

	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}

	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */

	'use strict';

	var PooledClass = __webpack_require__(106);
	var CallbackQueue = __webpack_require__(363);
	var ReactPutListenerQueue = __webpack_require__(532);
	var Transaction = __webpack_require__(241);

	var assign = __webpack_require__(15);
	var emptyFunction = __webpack_require__(89);

	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },

	  close: emptyFunction
	};

	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },

	  close: emptyFunction
	};

	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  ON_DOM_READY_QUEUEING
	];

	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}

	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap proceedures.
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },

	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },

	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;

	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};


	assign(
	  ReactServerRenderingTransaction.prototype,
	  Transaction.Mixin,
	  Mixin
	);

	PooledClass.addPoolingTo(ReactServerRenderingTransaction);

	module.exports = ReactServerRenderingTransaction;


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactStateSetters
	 */

	'use strict';

	var ReactStateSetters = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(component, funcReturningState) {
	    return function(a, b, c, d, e, f) {
	      var partialState = funcReturningState.call(component, a, b, c, d, e, f);
	      if (partialState) {
	        component.setState(partialState);
	      }
	    };
	  },

	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(component, key) {
	    // Memoize the setters.
	    var cache = component.__keySetters || (component.__keySetters = {});
	    return cache[key] || (cache[key] = createStateKeySetter(component, key));
	  }
	};

	function createStateKeySetter(component, key) {
	  // Partial state is allocated outside of the function closure so it can be
	  // reused with every call, avoiding memory allocation when this function
	  // is called.
	  var partialState = {};
	  return function stateKeySetter(value) {
	    partialState[key] = value;
	    component.setState(partialState);
	  };
	}

	ReactStateSetters.Mixin = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateSetter(function(xValue) {
	   *     return {x: xValue};
	   *   })(1);
	   *
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(funcReturningState) {
	    return ReactStateSetters.createStateSetter(this, funcReturningState);
	  },

	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateKeySetter('x')(1);
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(key) {
	    return ReactStateSetters.createStateKeySetter(this, key);
	  }
	};

	module.exports = ReactStateSetters;


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */

	'use strict';

	var ReactChildren = __webpack_require__(366);
	var ReactFragment = __webpack_require__(158);

	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around ReactChildren.map().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function(children) {
	    if (!children) {
	      return children;
	    }
	    return ReactFragment.extract(ReactChildren.map(children, function(child) {
	      return child;
	    }));
	  },

	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function(prev, next) {
	    prev = prev || {};
	    next = next || {};

	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }

	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};

	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }

	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(
	            pendingNextKey
	          );
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }

	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }

	    return childMapping;
	  }
	};

	module.exports = ReactTransitionChildMapping;


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);

	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },

	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};

	var endEvents = [];

	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;

	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }

	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }

	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}

	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}

	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.

	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}

	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}

	var ReactTransitionEvents = {
	  addEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },

	  removeEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};

	module.exports = ReactTransitionEvents;


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactWithAddons
	 */

	/**
	 * This module exists purely in the open source project, and is meant as a way
	 * to create a separate standalone build of React. This build has "addons", or
	 * functionality we've built and think might be useful but doesn't have a good
	 * place to live inside React core.
	 */

	'use strict';

	var LinkedStateMixin = __webpack_require__(1107);
	var React = __webpack_require__(157);
	var ReactComponentWithPureRenderMixin =
	  __webpack_require__(525);
	var ReactCSSTransitionGroup = __webpack_require__(1109);
	var ReactFragment = __webpack_require__(158);
	var ReactTransitionGroup = __webpack_require__(374);
	var ReactUpdates = __webpack_require__(63);

	var cx = __webpack_require__(163);
	var cloneWithProps = __webpack_require__(376);
	var update = __webpack_require__(49);

	React.addons = {
	  CSSTransitionGroup: ReactCSSTransitionGroup,
	  LinkedStateMixin: LinkedStateMixin,
	  PureRenderMixin: ReactComponentWithPureRenderMixin,
	  TransitionGroup: ReactTransitionGroup,

	  batchedUpdates: ReactUpdates.batchedUpdates,
	  classSet: cx,
	  cloneWithProps: cloneWithProps,
	  createFragment: ReactFragment.create,
	  update: update
	};

	if (false) {
	  React.addons.Perf = require("./ReactDefaultPerf");
	  React.addons.TestUtils = require("./ReactTestUtils");
	}

	module.exports = React;


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */

	/*jslint bitwise: true*/

	'use strict';

	var DOMProperty = __webpack_require__(155);

	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;

	var SVGDOMPropertyConfig = {
	  Properties: {
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox'
	  }
	};

	module.exports = SVGDOMPropertyConfig;


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPropagators = __webpack_require__(139);
	var ReactInputSelection = __webpack_require__(528);
	var SyntheticEvent = __webpack_require__(110);

	var getActiveElement = __webpack_require__(537);
	var isTextInputElement = __webpack_require__(543);
	var keyOf = __webpack_require__(76);
	var shallowEqual = __webpack_require__(46);

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSelect: null}),
	      captured: keyOf({onSelectCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topContextMenu,
	      topLevelTypes.topFocus,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topMouseDown,
	      topLevelTypes.topMouseUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};

	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;

	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @param {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node &&
	      ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}

	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown ||
	      activeElement == null ||
	      activeElement !== getActiveElement()) {
	    return null;
	  }

	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;

	    var syntheticEvent = SyntheticEvent.getPooled(
	      eventTypes.select,
	      activeElementID,
	      nativeEvent
	    );

	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;

	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

	    return syntheticEvent;
	  }
	}

	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) ||
	            topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;

	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent);

	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't).
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      case topLevelTypes.topSelectionChange:
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent);
	    }
	  }
	};

	module.exports = SelectEventPlugin;


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */

	'use strict';

	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);

	var ServerReactRootIndex = {
	  createReactRootIndex: function() {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};

	module.exports = ServerReactRootIndex;


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */

	'use strict';

	var EventConstants = __webpack_require__(62);
	var EventPluginUtils = __webpack_require__(192);
	var EventPropagators = __webpack_require__(139);
	var SyntheticClipboardEvent = __webpack_require__(1145);
	var SyntheticEvent = __webpack_require__(110);
	var SyntheticFocusEvent = __webpack_require__(1148);
	var SyntheticKeyboardEvent = __webpack_require__(1150);
	var SyntheticMouseEvent = __webpack_require__(240);
	var SyntheticDragEvent = __webpack_require__(1147);
	var SyntheticTouchEvent = __webpack_require__(1151);
	var SyntheticUIEvent = __webpack_require__(162);
	var SyntheticWheelEvent = __webpack_require__(1152);

	var getEventCharCode = __webpack_require__(378);

	var invariant = __webpack_require__(11);
	var keyOf = __webpack_require__(76);
	var warning = __webpack_require__(26);

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBlur: true}),
	      captured: keyOf({onBlurCapture: true})
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onClick: true}),
	      captured: keyOf({onClickCapture: true})
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onContextMenu: true}),
	      captured: keyOf({onContextMenuCapture: true})
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCopy: true}),
	      captured: keyOf({onCopyCapture: true})
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCut: true}),
	      captured: keyOf({onCutCapture: true})
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDoubleClick: true}),
	      captured: keyOf({onDoubleClickCapture: true})
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrag: true}),
	      captured: keyOf({onDragCapture: true})
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnd: true}),
	      captured: keyOf({onDragEndCapture: true})
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnter: true}),
	      captured: keyOf({onDragEnterCapture: true})
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragExit: true}),
	      captured: keyOf({onDragExitCapture: true})
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragLeave: true}),
	      captured: keyOf({onDragLeaveCapture: true})
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragOver: true}),
	      captured: keyOf({onDragOverCapture: true})
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragStart: true}),
	      captured: keyOf({onDragStartCapture: true})
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrop: true}),
	      captured: keyOf({onDropCapture: true})
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onFocus: true}),
	      captured: keyOf({onFocusCapture: true})
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onInput: true}),
	      captured: keyOf({onInputCapture: true})
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyDown: true}),
	      captured: keyOf({onKeyDownCapture: true})
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyPress: true}),
	      captured: keyOf({onKeyPressCapture: true})
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyUp: true}),
	      captured: keyOf({onKeyUpCapture: true})
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onLoad: true}),
	      captured: keyOf({onLoadCapture: true})
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onError: true}),
	      captured: keyOf({onErrorCapture: true})
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseDown: true}),
	      captured: keyOf({onMouseDownCapture: true})
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseMove: true}),
	      captured: keyOf({onMouseMoveCapture: true})
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOut: true}),
	      captured: keyOf({onMouseOutCapture: true})
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOver: true}),
	      captured: keyOf({onMouseOverCapture: true})
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseUp: true}),
	      captured: keyOf({onMouseUpCapture: true})
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onPaste: true}),
	      captured: keyOf({onPasteCapture: true})
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onReset: true}),
	      captured: keyOf({onResetCapture: true})
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScroll: true}),
	      captured: keyOf({onScrollCapture: true})
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSubmit: true}),
	      captured: keyOf({onSubmitCapture: true})
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchCancel: true}),
	      captured: keyOf({onTouchCancelCapture: true})
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchEnd: true}),
	      captured: keyOf({onTouchEndCapture: true})
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchMove: true}),
	      captured: keyOf({onTouchMoveCapture: true})
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchStart: true}),
	      captured: keyOf({onTouchStartCapture: true})
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onWheel: true}),
	      captured: keyOf({onWheelCapture: true})
	    }
	  }
	};

	var topLevelEventsToDispatchConfig = {
	  topBlur:        eventTypes.blur,
	  topClick:       eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy:        eventTypes.copy,
	  topCut:         eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag:        eventTypes.drag,
	  topDragEnd:     eventTypes.dragEnd,
	  topDragEnter:   eventTypes.dragEnter,
	  topDragExit:    eventTypes.dragExit,
	  topDragLeave:   eventTypes.dragLeave,
	  topDragOver:    eventTypes.dragOver,
	  topDragStart:   eventTypes.dragStart,
	  topDrop:        eventTypes.drop,
	  topError:       eventTypes.error,
	  topFocus:       eventTypes.focus,
	  topInput:       eventTypes.input,
	  topKeyDown:     eventTypes.keyDown,
	  topKeyPress:    eventTypes.keyPress,
	  topKeyUp:       eventTypes.keyUp,
	  topLoad:        eventTypes.load,
	  topMouseDown:   eventTypes.mouseDown,
	  topMouseMove:   eventTypes.mouseMove,
	  topMouseOut:    eventTypes.mouseOut,
	  topMouseOver:   eventTypes.mouseOver,
	  topMouseUp:     eventTypes.mouseUp,
	  topPaste:       eventTypes.paste,
	  topReset:       eventTypes.reset,
	  topScroll:      eventTypes.scroll,
	  topSubmit:      eventTypes.submit,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd:    eventTypes.touchEnd,
	  topTouchMove:   eventTypes.touchMove,
	  topTouchStart:  eventTypes.touchStart,
	  topWheel:       eventTypes.wheel
	};

	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}

	var SimpleEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * Same as the default implementation, except cancels the event when return
	   * value is false. This behavior will be disabled in a future release.
	   *
	   * @param {object} Event to be dispatched.
	   * @param {function} Application-level callback.
	   * @param {string} domID DOM ID to pass to the callback.
	   */
	  executeDispatch: function(event, listener, domID) {
	    var returnValue = EventPluginUtils.executeDispatch(event, listener, domID);

	    (false ? warning(
	      typeof returnValue !== 'boolean',
	      'Returning `false` from an event handler is deprecated and will be ' +
	      'ignored in a future release. Instead, manually call ' +
	      'e.stopPropagation() or e.preventDefault(), as appropriate.'
	    ) : null);

	    if (returnValue === false) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  },

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topError:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSubmit:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    (false ? invariant(
	      EventConstructor,
	      'SimpleEventPlugin: Unhandled event type, `%s`.',
	      topLevelType
	    ) : invariant(EventConstructor));
	    var event = EventConstructor.getPooled(
	      dispatchConfig,
	      topLevelTargetID,
	      nativeEvent
	    );
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }

	};

	module.exports = SimpleEventPlugin;


/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticEvent = __webpack_require__(110);

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function(event) {
	    return (
	      'clipboardData' in event ?
	        event.clipboardData :
	        window.clipboardData
	    );
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

	module.exports = SyntheticClipboardEvent;


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticEvent = __webpack_require__(110);

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(
	  SyntheticCompositionEvent,
	  CompositionEventInterface
	);

	module.exports = SyntheticCompositionEvent;


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticMouseEvent = __webpack_require__(240);

	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

	module.exports = SyntheticDragEvent;


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticUIEvent = __webpack_require__(162);

	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

	module.exports = SyntheticFocusEvent;


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticEvent = __webpack_require__(110);

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(
	  SyntheticInputEvent,
	  InputEventInterface
	);

	module.exports = SyntheticInputEvent;


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticUIEvent = __webpack_require__(162);

	var getEventCharCode = __webpack_require__(378);
	var getEventKey = __webpack_require__(1161);
	var getEventModifierState = __webpack_require__(379);

	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.

	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.

	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

	module.exports = SyntheticKeyboardEvent;


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticUIEvent = __webpack_require__(162);

	var getEventModifierState = __webpack_require__(379);

	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

	module.exports = SyntheticTouchEvent;


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */

	'use strict';

	var SyntheticMouseEvent = __webpack_require__(240);

	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function(event) {
	    return (
	      'deltaX' in event ? event.deltaX :
	      // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	      'wheelDeltaX' in event ? -event.wheelDeltaX : 0
	    );
	  },
	  deltaY: function(event) {
	    return (
	      'deltaY' in event ? event.deltaY :
	      // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	      'wheelDeltaY' in event ? -event.wheelDeltaY :
	      // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	      'wheelDelta' in event ? -event.wheelDelta : 0
	    );
	  },
	  deltaZ: null,

	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

	module.exports = SyntheticWheelEvent;


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */

	/* jslint bitwise:true */

	'use strict';

	var MOD = 65521;

	// This is a clean-room implementation of adler32 designed for detecting
	// if markup is not what we expect it to be. It does not need to be
	// cryptographically strong, only reasonably good at detecting if markup
	// generated on the server is different than that on the client.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  for (var i = 0; i < data.length; i++) {
	    a = (a + data.charCodeAt(i)) % MOD;
	    b = (b + a) % MOD;
	  }
	  return a | (b << 16);
	}

	module.exports = adler32;


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */

	var _hyphenPattern = /-(.)/g;

	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function(_, character) {
	    return character.toUpperCase();
	  });
	}

	module.exports = camelize;


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */

	"use strict";

	var camelize = __webpack_require__(1154);

	var msPattern = /^-ms-/;

	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}

	module.exports = camelizeStyleName;


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */

	var toArray = __webpack_require__(1174);

	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj &&
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    ('length' in obj) &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    (typeof obj.nodeType != 'number') &&
	    (
	      // a real array
	      (// HTMLCollection/NodeList
	      (Array.isArray(obj) ||
	      // arguments
	      ('callee' in obj) || 'item' in obj))
	    )
	  );
	}

	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}

	module.exports = createArrayFromMixed;


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createFullPageComponent
	 * @typechecks
	 */

	'use strict';

	// Defeat circular references by requiring this directly.
	var ReactClass = __webpack_require__(75);
	var ReactElement = __webpack_require__(31);

	var invariant = __webpack_require__(11);

	/**
	 * Create a component that will throw an exception when unmounted.
	 *
	 * Components like <html> <head> and <body> can't be removed or added
	 * easily in a cross-browser way, however it's valuable to be able to
	 * take advantage of React's reconciliation for styling and <title>
	 * management. So we just document it and throw in dangerous cases.
	 *
	 * @param {string} tag The tag to wrap
	 * @return {function} convenience constructor of new component
	 */
	function createFullPageComponent(tag) {
	  var elementFactory = ReactElement.createFactory(tag);

	  var FullPageComponent = ReactClass.createClass({
	    tagName: tag.toUpperCase(),
	    displayName: 'ReactFullPageComponent' + tag,

	    componentWillUnmount: function() {
	      (false ? invariant(
	        false,
	        '%s tried to unmount. Because of cross-browser quirks it is ' +
	        'impossible to unmount some top-level components (eg <html>, <head>, ' +
	        'and <body>) reliably and efficiently. To fix this, have a single ' +
	        'top-level component that never unmounts render these elements.',
	        this.constructor.displayName
	      ) : invariant(false));
	    },

	    render: function() {
	      return elementFactory(this.props);
	    }
	  });

	  return FullPageComponent;
	}

	module.exports = createFullPageComponent;


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */

	/*jslint evil: true, sub: true */

	var ExecutionEnvironment = __webpack_require__(42);

	var createArrayFromMixed = __webpack_require__(1156);
	var getMarkupWrap = __webpack_require__(539);
	var invariant = __webpack_require__(11);

	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;

	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}

	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  (false ? invariant(!!dummyNode, 'createNodesFromMarkup dummy not initialized') : invariant(!!dummyNode));
	  var nodeName = getNodeName(markup);

	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];

	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }

	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    (false ? invariant(
	      handleScript,
	      'createNodesFromMarkup(...): Unexpected <script> element rendered.'
	    ) : invariant(handleScript));
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }

	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}

	module.exports = createNodesFromMarkup;


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */

	'use strict';

	var CSSProperty = __webpack_require__(521);

	var isUnitlessNumber = CSSProperty.isUnitlessNumber;

	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901

	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }

	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 ||
	      isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }

	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}

	module.exports = dangerousStyleValue;


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */

	'use strict';

	var traverseAllChildren = __webpack_require__(544);
	var warning = __webpack_require__(26);

	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = !result.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'flattenChildren(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}

	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}

	module.exports = flattenChildren;


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */

	'use strict';

	var getEventCharCode = __webpack_require__(378);

	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};

	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};

	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.

	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }

	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);

	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}

	module.exports = getEventKey;


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */

	'use strict';

	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}

	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}

	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;

	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;

	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }

	      nodeStart = nodeEnd;
	    }

	    node = getLeafNode(getSiblingNode(node));
	  }
	}

	module.exports = getNodeForCharacterOffset;


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getReactRootElementInContainer
	 */

	'use strict';

	var DOC_NODE_TYPE = 9;

	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 *                                           a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }

	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}

	module.exports = getReactRootElementInContainer;


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */

	var _uppercasePattern = /([A-Z])/g;

	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}

	module.exports = hyphenate;


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */

	"use strict";

	var hyphenate = __webpack_require__(1164);

	var msPattern = /^ms-/;

	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}

	module.exports = hyphenateStyleName;


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */

	var isNode = __webpack_require__(542);

	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}

	module.exports = isTextNode;


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}

	module.exports = joinClasses;


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */

	'use strict';

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}

	module.exports = mapObject;


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */

	'use strict';

	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function(string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}

	module.exports = memoizeStringOnly;


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */

	"use strict";

	var ExecutionEnvironment = __webpack_require__(42);

	var performance;

	if (ExecutionEnvironment.canUseDOM) {
	  performance =
	    window.performance ||
	    window.msPerformance ||
	    window.webkitPerformance;
	}

	module.exports = performance || {};


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */

	var performance = __webpack_require__(1170);

	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (!performance || !performance.now) {
	  performance = Date;
	}

	var performanceNow = performance.now.bind(performance);

	module.exports = performanceNow;


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */

	'use strict';

	var escapeTextContentForBrowser = __webpack_require__(194);

	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}

	module.exports = quoteAttributeValueForBrowser;


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */

	'use strict';

	var ExecutionEnvironment = __webpack_require__(42);
	var escapeTextContentForBrowser = __webpack_require__(194);
	var setInnerHTML = __webpack_require__(383);

	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function(node, text) {
	  node.textContent = text;
	};

	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function(node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}

	module.exports = setTextContent;


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */

	var invariant = __webpack_require__(11);

	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;

	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  (false ? invariant(
	    !Array.isArray(obj) &&
	    (typeof obj === 'object' || typeof obj === 'function'),
	    'toArray: Array-like object expected'
	  ) : invariant(!Array.isArray(obj) &&
	  (typeof obj === 'object' || typeof obj === 'function')));

	  (false ? invariant(
	    typeof length === 'number',
	    'toArray: Object needs a length property'
	  ) : invariant(typeof length === 'number'));

	  (false ? invariant(
	    length === 0 ||
	    (length - 1) in obj,
	    'toArray: Object should have keys for indices'
	  ) : invariant(length === 0 ||
	  (length - 1) in obj));

	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }

	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}

	module.exports = toArray;


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */

	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];

	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */

	!(function(global) {
	  "use strict";

	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };

	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;

	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }

	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }

	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );

	          if (record.type === "throw") {
	            context.delegate = null;

	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }

	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;

	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }

	          context.delegate = null;
	        }

	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;

	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }

	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }

	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          var info = {
	            value: record.arg,
	            done: context.done
	          };

	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp[toStringTagSymbol] = "Generator";

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }

	      return ContinueSentinel;
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1047)))

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	console.warn(
	  "The regenerator/runtime module is deprecated; " +
	    "please import regenerator-runtime/runtime instead."
	);

	module.exports = __webpack_require__(1176);


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	var pubsub = __webpack_require__(1052);
	var loadScript = __webpack_require__(993);

	module.exports = requireSDK;

	function requireSDK (url, global) {
	  var onReady = pubsub();

	  var hasManualTrigger;
	  var isLoading;
	  var isLoaded;

	  load.trigger = setManualTrigger;

	  return load;

	  function isAlreadyLoaded () {
	    return window[global];
	  }

	  function load (callback) {
	    if (isAlreadyLoaded() || isLoaded) {
	      return callback && callback(undefined, window[global]);
	    }

	    callback && onReady.subscribe(callback);

	    if (isLoading) return;

	    isLoading = true;

	    if (!url) return;

	    loadScript(url, function (error) {
	      if (hasManualTrigger) return;

	      if (error) {
	        isLoaded = true;
	        return onReady.publish(error);
	      }

	      trigger();
	    });

	  };

	  function trigger () {
	    isLoaded = true;
	    onReady.publish(undefined, global ? window[global] : undefined);
	  }

	  function setManualTrigger () {
	    hasManualTrigger = true;
	    return trigger;
	  }


	}


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {

		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}

		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,

		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'

		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},

		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,

		/** Temporary variable */
		key;

		/*--------------------------------------------------------------------------*/

		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}

		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}

		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}

		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}

		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}

		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}

		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}

		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}

		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;

			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.

			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}

			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}

			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.

			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

					if (index >= inputLength) {
						error('invalid-input');
					}

					digit = basicToDigit(input.charCodeAt(index++));

					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}

					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

					if (digit < t) {
						break;
					}

					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}

					w *= baseMinusT;

				}

				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);

				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}

				n += floor(i / out);
				i %= out;

				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);

			}

			return ucs2encode(output);
		}

		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;

			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);

			// Cache the length
			inputLength = input.length;

			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;

			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}

			handledCPCount = basicLength = output.length;

			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.

			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}

			// Main encoding loop:
			while (handledCPCount < inputLength) {

				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}

				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}

				delta += (m - n) * handledCPCountPlusOne;
				n = m;

				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];

					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}

					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}

						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}

				++delta;
				++n;

			}
			return output.join('');
		}

		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}

		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}

		/*--------------------------------------------------------------------------*/

		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};

		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}

	}(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(386)(module), (function() { return this; }())))

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var punycode = __webpack_require__(1179);

	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;

	exports.Url = Url;

	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,

	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1055);

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}

	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }

	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;

	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    this.parseHost();

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }

	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }

	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}

	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';

	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }

	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }

	  var search = this.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }

	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];

	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }

	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};

	function isString(arg) {
	  return typeof arg === "string";
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * viewport-units-buggyfill v0.5.0
	 * @web: https://github.com/rodneyrehm/viewport-units-buggyfill/
	 * @author: Rodney Rehm - http://rodneyrehm.de/en/
	 */

	(function (root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like enviroments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.viewportUnitsBuggyfill = factory();
	  }
	}(this, function () {
	  'use strict';
	  /*global document, window, navigator, location, XMLHttpRequest, XDomainRequest*/

	  var initialized = false;
	  var options;
	  var userAgent = window.navigator.userAgent;
	  var viewportUnitExpression = /([+-]?[0-9.]+)(vh|vw|vmin|vmax)/g;
	  var forEach = [].forEach;
	  var dimensions;
	  var declarations;
	  var styleNode;
	  var isOldInternetExplorer = false;
	  var isOperaMini = userAgent.indexOf('Opera Mini') > -1;

	  var isMobileSafari = /(iPhone|iPod|iPad).+AppleWebKit/i.test(userAgent) && (function() {
	    // Regexp for iOS-version tested against the following userAgent strings:
	    // Example WebView UserAgents:
	    // * iOS Chrome on iOS8: "Mozilla/5.0 (iPad; CPU OS 8_1 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) CriOS/39.0.2171.50 Mobile/12B410 Safari/600.1.4"
	    // * iOS Facebook on iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 [FBAN/FBIOS;FBAV/12.1.0.24.20; FBBV/3214247; FBDV/iPhone6,1;FBMD/iPhone; FBSN/iPhone OS;FBSV/7.1.1; FBSS/2; FBCR/AT&T;FBID/phone;FBLC/en_US;FBOP/5]"
	    // Example Safari UserAgents:
	    // * Safari iOS8: "Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4"
	    // * Safari iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A4449d Safari/9537.53"
	    var iOSversion = userAgent.match(/OS (\d)/);
	    // viewport units work fine in mobile Safari and webView on iOS 8+
	    return iOSversion && iOSversion.length>1 && parseInt(iOSversion[1]) < 8;
	  })();

	  var isBadStockAndroid = (function() {
	    // Android stock browser test derived from
	    // http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
	    var isAndroid = userAgent.indexOf(' Android ') > -1;
	    if (!isAndroid) {
	      return false;
	    }

	    var isStockAndroid = userAgent.indexOf('Version/') > -1;
	    if (!isStockAndroid) {
	      return false;
	    }

	    var versionNumber = parseFloat((userAgent.match('Android ([0-9.]+)') || [])[1]);
	    // anything below 4.4 uses WebKit without *any* viewport support,
	    // 4.4 has issues with viewport units within calc()
	    return versionNumber <= 4.4;
	  })();

	  // Do not remove the following comment!
	  // It is a conditional comment used to
	  // identify old Internet Explorer versions

	  /*@cc_on

	  @if (@_jscript_version <= 10)
	    isOldInternetExplorer = true;
	  @end

	  @*/

	  // added check for IE11, since it *still* doesn't understand vmax!!!
	  if (!isOldInternetExplorer) {
	    isOldInternetExplorer = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
	  }
	  function debounce(func, wait) {
	    var timeout;
	    return function() {
	      var context = this;
	      var args = arguments;
	      var callback = function() {
	        func.apply(context, args);
	      };

	      clearTimeout(timeout);
	      timeout = setTimeout(callback, wait);
	    };
	  }

	  // from http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
	  function inIframe() {
	    try {
	      return window.self !== window.top;
	    } catch (e) {
	      return true;
	    }
	  }

	  function initialize(initOptions) {
	    if (initialized) {
	      return;
	    }

	    if (initOptions === true) {
	      initOptions = {
	        force: true
	      };
	    }

	    options = initOptions || {};
	    options.isMobileSafari = isMobileSafari;
	    options.isBadStockAndroid = isBadStockAndroid;

	    if (!options.force && !isMobileSafari && !isOldInternetExplorer && !isBadStockAndroid && !isOperaMini && (!options.hacks || !options.hacks.required(options))) {
	      // this buggyfill only applies to mobile safari, IE9-10 and the Stock Android Browser.
	      return;
	    }

	    options.hacks && options.hacks.initialize(options);

	    initialized = true;
	    styleNode = document.createElement('style');
	    styleNode.id = 'patched-viewport';
	    document.head.appendChild(styleNode);

	    // Issue #6: Cross Origin Stylesheets are not accessible through CSSOM,
	    // therefore download and inject them as <style> to circumvent SOP.
	    importCrossOriginLinks(function() {
	      var _refresh = debounce(refresh, options.refreshDebounceWait || 100);
	      // doing a full refresh rather than updateStyles because an orientationchange
	      // could activate different stylesheets
	      window.addEventListener('orientationchange', _refresh, true);
	      // orientationchange might have happened while in a different window
	      window.addEventListener('pageshow', _refresh, true);

	      if (options.force || isOldInternetExplorer || inIframe()) {
	        window.addEventListener('resize', _refresh, true);
	        options._listeningToResize = true;
	      }

	      options.hacks && options.hacks.initializeEvents(options, refresh, _refresh);

	      refresh();
	    });
	  }

	  function updateStyles() {
	    styleNode.textContent = getReplacedViewportUnits();
	  }

	  function refresh() {
	    if (!initialized) {
	      return;
	    }

	    findProperties();

	    // iOS Safari will report window.innerWidth and .innerHeight as 0 unless a timeout is used here.
	    // TODO: figure out WHY innerWidth === 0
	    setTimeout(function() {
	      updateStyles();
	    }, 1);
	  }

	  function findProperties() {
	    declarations = [];
	    forEach.call(document.styleSheets, function(sheet) {
	      if (sheet.ownerNode.id === 'patched-viewport' || !sheet.cssRules || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	        // skip entire sheet because no rules are present, it's supposed to be ignored or it's the target-element of the buggyfill
	        return;
	      }

	      if (sheet.media && sheet.media.mediaText && window.matchMedia && !window.matchMedia(sheet.media.mediaText).matches) {
	        // skip entire sheet because media attribute doesn't match
	        return;
	      }

	      forEach.call(sheet.cssRules, findDeclarations);
	    });

	    return declarations;
	  }

	  function findDeclarations(rule) {
	    if (rule.type === 7) {
	      var value;

	      // there may be a case where accessing cssText throws an error.
	      // I could not reproduce this issue, but the worst that can happen
	      // this way is an animation not running properly.
	      // not awesome, but probably better than a script error
	      // see https://github.com/rodneyrehm/viewport-units-buggyfill/issues/21
	      try {
	        value = rule.cssText;
	      } catch(e) {
	        return;
	      }

	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        // KeyframesRule does not have a CSS-PropertyName
	        declarations.push([rule, null, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, null, value);
	      }

	      return;
	    }

	    if (!rule.style) {
	      if (!rule.cssRules) {
	        return;
	      }

	      forEach.call(rule.cssRules, function(_rule) {
	        findDeclarations(_rule);
	      });

	      return;
	    }

	    forEach.call(rule.style, function(name) {
	      var value = rule.style.getPropertyValue(name);
	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        declarations.push([rule, name, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, name, value);
	      }
	    });
	  }

	  function getReplacedViewportUnits() {
	    dimensions = getViewport();

	    var css = [];
	    var buffer = [];
	    var open;
	    var close;

	    declarations.forEach(function(item) {
	      var _item = overwriteDeclaration.apply(null, item);
	      var _open = _item.selector.length ? (_item.selector.join(' {\n') + ' {\n') : '';
	      var _close = new Array(_item.selector.length + 1).join('\n}');

	      if (!_open || _open !== open) {
	        if (buffer.length) {
	          css.push(open + buffer.join('\n') + close);
	          buffer.length = 0;
	        }

	        if (_open) {
	          open = _open;
	          close = _close;
	          buffer.push(_item.content);
	        } else {
	          css.push(_item.content);
	          open = null;
	          close = null;
	        }

	        return;
	      }

	      if (_open && !open) {
	        open = _open;
	        close = _close;
	      }

	      buffer.push(_item.content);
	    });

	    if (buffer.length) {
	      css.push(open + buffer.join('\n') + close);
	    }

	    // Opera Mini messes up on the content hack (it replaces the DOM node's innerHTML with the value).
	    // This fixes it. We test for Opera Mini only since it is the most expensive CSS selector
	    // see https://developer.mozilla.org/en-US/docs/Web/CSS/Universal_selectors
	    if (isOperaMini) {
	      css.push('* { content: normal !important; }');
	    }

	    return css.join('\n\n');
	  }

	  function overwriteDeclaration(rule, name, value) {
	    var _value;
	    var _selectors = [];

	    _value = value.replace(viewportUnitExpression, replaceValues);

	    if (options.hacks) {
	      _value = options.hacks.overwriteDeclaration(rule, name, _value);
	    }

	    if (name) {
	      // skipping KeyframesRule
	      _selectors.push(rule.selectorText);
	      _value = name + ': ' + _value + ';';
	    }

	    var _rule = rule.parentRule;
	    while (_rule) {
	      _selectors.unshift('@media ' + _rule.media.mediaText);
	      _rule = _rule.parentRule;
	    }

	    return {
	      selector: _selectors,
	      content: _value
	    };
	  }

	  function replaceValues(match, number, unit) {
	    var _base = dimensions[unit];
	    var _number = parseFloat(number) / 100;
	    return (_number * _base) + 'px';
	  }

	  function getViewport() {
	    var vh = window.innerHeight;
	    var vw = window.innerWidth;

	    return {
	      vh: vh,
	      vw: vw,
	      vmax: Math.max(vw, vh),
	      vmin: Math.min(vw, vh)
	    };
	  }

	  function importCrossOriginLinks(next) {
	    var _waiting = 0;
	    var decrease = function() {
	      _waiting--;
	      if (!_waiting) {
	        next();
	      }
	    };

	    forEach.call(document.styleSheets, function(sheet) {
	      if (!sheet.href || origin(sheet.href) === origin(location.href)) {
	        // skip <style> and <link> from same origin
	        return;
	      }

	      _waiting++;
	      convertLinkToStyle(sheet.ownerNode, decrease);
	    });

	    if (!_waiting) {
	      next();
	    }
	  }

	  function origin(url) {
	    return url.slice(0, url.indexOf('/', url.indexOf('://') + 3));
	  }

	  function convertLinkToStyle(link, next) {
	    getCors(link.href, function() {
	      var style = document.createElement('style');
	      style.media = link.media;
	      style.setAttribute('data-href', link.href);
	      style.textContent = this.responseText;
	      link.parentNode.replaceChild(style, link);
	      next();
	    }, next);
	  }

	  function getCors(url, success, error) {
	    var xhr = new XMLHttpRequest();
	    if ('withCredentials' in xhr) {
	      // XHR for Chrome/Firefox/Opera/Safari.
	      xhr.open('GET', url, true);
	    } else if (typeof XDomainRequest !== 'undefined') {
	      // XDomainRequest for IE.
	      xhr = new XDomainRequest();
	      xhr.open('GET', url);
	    } else {
	      throw new Error('cross-domain XHR not supported');
	    }

	    xhr.onload = success;
	    xhr.onerror = error;
	    xhr.send();
	    return xhr;
	  }

	  return {
	    version: '0.5.0',
	    findProperties: findProperties,
	    getCss: getReplacedViewportUnits,
	    init: initialize,
	    refresh: refresh
	  };

	}));


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	(function() { module.exports = this["ga"]; }());

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.75bbd7d4621f3fc54856.js
 **/